!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("roundTheWorldGame", [], e) : "object" == typeof exports ? exports.roundTheWorldGame = e() : t.roundTheWorldGame = e();
}(window, function () {
  return function (t) {
    var e = {};

    function i(s) {
      if (e[s]) return e[s].exports;
      var n = e[s] = {
        i: s,
        l: !1,
        exports: {}
      };
      return t[s].call(n.exports, n, n.exports, i), n.l = !0, n.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, s) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: s
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var s = Object.create(null);
      if (i.r(s), Object.defineProperty(s, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var n in t) {
        i.d(s, n, function (e) {
          return t[e];
        }.bind(null, n));
      }
      return s;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 1);
  }([function (t, e) {
    var i;

    i = function () {
      return this;
    }();

    try {
      i = i || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (i = window);
    }

    t.exports = i;
  }, function (t, e, i) {
    i(2), i(4);
    var s = i(6),
        n = i(9);

    t.exports.createGameInDiv = function (t) {
      var e = new s.Game("100", "100", s.CANVAS, t);
      s.Device.whenReady(function () {
        e.plugins.add(n.Plugin);
      }), e.getScaledWidth = function (t) {
        return t * (this.width / 1600);
      }, e.getScaledHeight = function (t) {
        return t * (this.height / 1200);
      }, e.global = {
        score: 0,
        highscore: [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 0, 0, 0, 0]],
        continentIndex: 0,
        modeIndex: 0,
        modeButton: ["btCapital", "btFlag", "btPopulation", "btCurrency"],
        fullArray: [["dz", "ao", "bj", "bw", "bf", "bi", "cm", "cv", "cf", "td", "km", "cg", "cd", "ci", "dj", "eg", "gq", "er", "et", "ga", "gm", "gh", "gn", "gw", "ke", "ls", "lr", "ly", "mg", "mw", "ml", "mr", "mu", "yt", "ma", "mz", "na", "ne", "ng", "re", "rw", "sh", "st", "sn", "sc", "sl", "so", "za", "ss", "sd", "sz", "tz", "tg", "tn", "ug", "eh", "zm", "zw"], ["ai", "ag", "ar", "aw", "bs", "bb", "bz", "bm", "bo", "bq", "br", "ca", "ky", "cl", "co", "cr", "cu", "cw", "dm", "do", "ec", "sv", "fk", "gf", "gl", "gd", "gp", "gt", "gy", "ht", "hn", "jm", "mq", "mx", "ms", "ni", "pa", "py", "pe", "pr", "bl", "kn", "lc", "mf", "pm", "vc", "sx", "sr", "tt", "tc", "us", "uy", "ve", "vg", "vi"], ["af", "am", "az", "bh", "bd", "bt", "bn", "kh", "cn", "cy", "ge", "hk", "in", "id", "ir", "iq", "il", "jp", "jo", "kz", "kp", "kr", "kw", "kg", "la", "lb", "mo", "my", "mv", "mn", "mm", "np", "om", "pk", "ps", "ph", "qa", "sa", "sg", "lk", "sy", "tw", "tj", "th", "tl", "tr", "tm", "ae", "uz", "vn", "ye"], ["as", "au", "ck", "fj", "pf", "gu", "ki", "mh", "fm", "nr", "nc", "nz", "nu", "nf", "mp", "pw", "pg", "pn", "ws", "sb", "tk", "to", "tv", "vu", "wf"], ["ax", "al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk", "ee", "fo", "fi", "fr", "de", "gi", "gr", "gg", "va", "hu", "is", "ie", "im", "it", "je", "lv", "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro", "ru", "sm", "rs", "sk", "si", "es", "sj", "se", "ch", "ua", "gb"]]
      };
      var o = i(10),
          r = i(11),
          a = i(12),
          h = i(13),
          l = i(14),
          c = i(15),
          u = i(16),
          d = i(17),
          p = i(284),
          f = i(285);
      e.state.add("capitalState", o), e.state.add("populationState", r), e.state.add("currencyState", a), e.state.add("flagState", h), e.state.add("gameOver", l), e.state.add("winState", c), e.state.add("menuState", u), e.state.add("preloadState", d), e.state.add("learnState", p), e.state.add("bootState", f), e.state.start("bootState");
    };
  }, function (t, e, i) {
    (function (e) {
      t.exports = e.PIXI = i(3);
    }).call(this, i(0));
  }, function (t, e, i) {
    /**
    * @author       Richard Davey <rich@photonstorm.com>
    * @copyright    2016 Photon Storm Ltd.
    * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
    *
    * @overview
    *
    * Phaser - http://phaser.io
    *
    * v2.10.6 "2018-06-01" - Built: Fri Jun 01 2018 17:45:01
    *
    * By Richard Davey http://www.photonstorm.com @photonstorm
    *
    * Phaser is a fun, free and fast 2D game framework for making HTML5 games
    * for desktop and mobile web browsers, supporting Canvas and WebGL rendering.
    *
    * Phaser uses Pixi.js for rendering, created by Mat Groves http://matgroves.com @Doormat23
    * Phaser uses p2.js for full-body physics, created by Stefan Hedman https://github.com/schteppe/p2.js @schteppe
    * Phaser contains a port of N+ Physics, converted by Richard Davey, original by http://www.metanetsoftware.com
    *
    * Many thanks to Adam Saltsman (@ADAMATOMIC) for releasing Flixel, from which both Phaser and my love of framework development originate.
    *
    * Follow development at http://phaser.io and on our forum
    *
    * "If you want your children to be intelligent,  read them fairy tales."
    * "If you want them to be more intelligent, read them more fairy tales."
    *                                                     -- Albert Einstein
    */
    (function () {
      var i = i || {};
      /**
      * @author       Mat Groves http://matgroves.com @Doormat23
      * @author       Richard Davey <rich@photonstorm.com>
      * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
      */

      i.DisplayObject = function () {
        this.position = new i.Point(0, 0), this.scale = new i.Point(1, 1), this.pivot = new i.Point(0, 0), this.rotation = 0, this.alpha = 1, this.visible = !0, this.hitArea = null, this.renderable = !1, this.parent = null, this.worldAlpha = 1, this.worldTransform = new Phaser.Matrix(), this.worldPosition = new i.Point(0, 0), this.worldScale = new i.Point(1, 1), this.worldRotation = 0, this.filterArea = null, this._sr = 0, this._cr = 1, this._bounds = new i.Rectangle(0, 0, 0, 0), this._currentBounds = null, this._mask = null, this._cacheAsBitmap = !1, this._cacheIsDirty = !1;
      }, i.DisplayObject.prototype = {
        constructor: i.DisplayObject,
        destroy: function destroy() {
          if (this.children) {
            for (var t = this.children.length; t--;) {
              this.children[t].destroy();
            }

            this.children = [];
          }

          this.hitArea = null, this.parent = null, this.worldTransform = null, this.filterArea = null, this.renderable = !1, this._bounds = null, this._currentBounds = null, this._mask = null, this._destroyCachedSprite();
        },
        updateTransform: function updateTransform(t) {
          if (!t && !this.parent && !this.game) return this;
          var e = this.parent;
          t ? e = t : this.parent || (e = this.game.world);
          var i,
              s,
              n,
              o,
              r,
              a,
              h = e.worldTransform,
              l = this.worldTransform;
          this.rotation % Phaser.Math.PI2 ? (this.rotation !== this.rotationCache && (this.rotationCache = this.rotation, this._sr = Math.sin(this.rotation), this._cr = Math.cos(this.rotation)), i = this._cr * this.scale.x, s = this._sr * this.scale.x, n = -this._sr * this.scale.y, o = this._cr * this.scale.y, r = this.position.x, a = this.position.y, (this.pivot.x || this.pivot.y) && (r -= this.pivot.x * i + this.pivot.y * n, a -= this.pivot.x * s + this.pivot.y * o), l.a = i * h.a + s * h.c, l.b = i * h.b + s * h.d, l.c = n * h.a + o * h.c, l.d = n * h.b + o * h.d, l.tx = r * h.a + a * h.c + h.tx, l.ty = r * h.b + a * h.d + h.ty) : (i = this.scale.x, s = 0, n = 0, o = this.scale.y, r = this.position.x - this.pivot.x * i, a = this.position.y - this.pivot.y * o, l.a = i * h.a, l.b = i * h.b, l.c = o * h.c, l.d = o * h.d, l.tx = r * h.a + a * h.c + h.tx, l.ty = r * h.b + a * h.d + h.ty), i = l.a, s = l.b, n = l.c;
          var c = i * (o = l.d) - s * n;

          if (i || s) {
            var u = Math.sqrt(i * i + s * s);
            this.worldRotation = s > 0 ? Math.acos(i / u) : -Math.acos(i / u), this.worldScale.x = u, this.worldScale.y = c / u;
          } else if (n || o) {
            var d = Math.sqrt(n * n + o * o);
            this.worldRotation = Phaser.Math.HALF_PI - (o > 0 ? Math.acos(-n / d) : -Math.acos(n / d)), this.worldScale.x = c / d, this.worldScale.y = d;
          } else this.worldScale.x = 0, this.worldScale.y = 0;

          return this.worldAlpha = this.alpha * e.worldAlpha, this.worldPosition.x = l.tx, this.worldPosition.y = l.ty, this._currentBounds = null, this.transformCallback && this.transformCallback.call(this.transformCallbackContext, l, h), this;
        },
        preUpdate: function preUpdate() {},
        generateTexture: function generateTexture(t, e, s) {
          var n = this.getLocalBounds(),
              o = new Phaser.RenderTexture(this.game, 0 | n.width, 0 | n.height, s, e, t);
          return i.DisplayObject._tempMatrix.tx = -n.x, i.DisplayObject._tempMatrix.ty = -n.y, o.render(this, i.DisplayObject._tempMatrix), o;
        },
        updateCache: function updateCache() {
          return this._generateCachedSprite(), this;
        },
        toGlobal: function toGlobal(t) {
          return this.updateTransform(), this.worldTransform.apply(t);
        },
        toLocal: function toLocal(t, e) {
          return e && (t = e.toGlobal(t)), this.updateTransform(), this.worldTransform.applyInverse(t);
        },
        _renderCachedSprite: function _renderCachedSprite(t) {
          this._cachedSprite.worldAlpha = this.worldAlpha, t.gl ? i.Sprite.prototype._renderWebGL.call(this._cachedSprite, t) : i.Sprite.prototype._renderCanvas.call(this._cachedSprite, t);
        },
        _generateCachedSprite: function _generateCachedSprite() {
          this._cacheAsBitmap = !1;
          var t = this.getLocalBounds();
          if (t.width = Math.max(1, Math.ceil(t.width)), t.height = Math.max(1, Math.ceil(t.height)), this.updateTransform(), this._cachedSprite) this._cachedSprite.texture.resize(t.width, t.height);else {
            var e = 0;
            this.texture && this.texture.baseTexture && i._enableMultiTextureToggle && (e = this.texture.baseTexture.textureIndex);
            var s = new Phaser.RenderTexture(this.game, t.width, t.height, void 0, void 0, void 0, void 0, e);
            this._cachedSprite = new i.Sprite(s), this._cachedSprite.worldTransform = this.worldTransform;
          }
          var n = this._filters;
          this._filters = null, this._cachedSprite.filters = n, i.DisplayObject._tempMatrix.tx = -t.x, i.DisplayObject._tempMatrix.ty = -t.y, this._cachedSprite.texture.render(this, i.DisplayObject._tempMatrix, !0), this._cachedSprite.anchor.x = -t.x / t.width, this._cachedSprite.anchor.y = -t.y / t.height, this._filters = n, this._cacheAsBitmap = !0;
        },
        _destroyCachedSprite: function _destroyCachedSprite() {
          this._cachedSprite && (this._cachedSprite.texture.destroy(!0), this._cachedSprite = null);
        }
      }, i.DisplayObject.prototype.displayObjectUpdateTransform = i.DisplayObject.prototype.updateTransform, Object.defineProperties(i.DisplayObject.prototype, {
        x: {
          get: function get() {
            return this.position.x;
          },
          set: function set(t) {
            this.position.x = t;
          }
        },
        y: {
          get: function get() {
            return this.position.y;
          },
          set: function set(t) {
            this.position.y = t;
          }
        },
        worldVisible: {
          get: function get() {
            if (this.visible) {
              var t = this.parent;
              if (!t) return this.visible;

              do {
                if (!t.visible) return !1;
                t = t.parent;
              } while (t);

              return !0;
            }

            return !1;
          }
        },
        mask: {
          get: function get() {
            return this._mask;
          },
          set: function set(t) {
            this._mask && (this._mask.isMask = !1), this._mask = t, t && (this._mask.isMask = !0);
          }
        },
        filters: {
          get: function get() {
            return this._filters;
          },
          set: function set(t) {
            if (Array.isArray(t)) {
              for (var e = [], s = 0; s < t.length; s++) {
                for (var n = t[s].passes, o = 0; o < n.length; o++) {
                  e.push(n[o]);
                }
              }

              this._filterBlock = {
                target: this,
                filterPasses: e
              };
            }

            this._filters = t, this.blendMode && this.blendMode === i.blendModes.MULTIPLY && (this.blendMode = i.blendModes.NORMAL);
          }
        },
        cacheAsBitmap: {
          get: function get() {
            return this._cacheAsBitmap;
          },
          set: function set(t) {
            this._cacheAsBitmap !== t && (t ? this._generateCachedSprite() : this._destroyCachedSprite(), this._cacheAsBitmap = t);
          }
        }
      }), i.DisplayObjectContainer = function () {
        i.DisplayObject.call(this), this.children = [], this.ignoreChildInput = !1;
      }, i.DisplayObjectContainer.prototype = Object.create(i.DisplayObject.prototype), i.DisplayObjectContainer.prototype.constructor = i.DisplayObjectContainer, i.DisplayObjectContainer.prototype.addChild = function (t) {
        return this.addChildAt(t, this.children.length);
      }, i.DisplayObjectContainer.prototype.addChildAt = function (t, e) {
        if (e >= 0 && e <= this.children.length) return t.parent && t.parent.removeChild(t), t.parent = this, this.children.splice(e, 0, t), t;
        throw new Error(t + "addChildAt: The index " + e + " supplied is out of bounds " + this.children.length);
      }, i.DisplayObjectContainer.prototype.swapChildren = function (t, e) {
        if (t !== e) {
          var i = this.getChildIndex(t),
              s = this.getChildIndex(e);
          if (i < 0 || s < 0) throw new Error("swapChildren: Both the supplied DisplayObjects must be a child of the caller.");
          this.children[i] = e, this.children[s] = t;
        }
      }, i.DisplayObjectContainer.prototype.getChildIndex = function (t) {
        var e = this.children.indexOf(t);
        if (-1 === e) throw new Error("The supplied DisplayObject must be a child of the caller");
        return e;
      }, i.DisplayObjectContainer.prototype.setChildIndex = function (t, e) {
        if (e < 0 || e >= this.children.length) throw new Error("The supplied index is out of bounds");
        var i = this.getChildIndex(t);
        this.children.splice(i, 1), this.children.splice(e, 0, t);
      }, i.DisplayObjectContainer.prototype.getChildAt = function (t) {
        if (t < 0 || t >= this.children.length) throw new Error("getChildAt: Supplied index " + t + " does not exist in the child list, or the supplied DisplayObject must be a child of the caller");
        return this.children[t];
      }, i.DisplayObjectContainer.prototype.removeChild = function (t) {
        var e = this.children.indexOf(t);
        if (-1 !== e) return this.removeChildAt(e);
      }, i.DisplayObjectContainer.prototype.removeChildAt = function (t) {
        var e = this.getChildAt(t);
        return e && (e.parent = void 0, this.children.splice(t, 1)), e;
      }, i.DisplayObjectContainer.prototype.removeChildren = function (t, e) {
        void 0 === t && (t = 0), void 0 === e && (e = this.children.length);
        var i = e - t;

        if (i > 0 && i <= e) {
          for (var s = this.children.splice(t, i), n = 0; n < s.length; n++) {
            s[n].parent = void 0;
          }

          return s;
        }

        if (0 === i && 0 === this.children.length) return [];
        throw new Error("removeChildren: Range Error, numeric values are outside the acceptable range");
      }, i.DisplayObjectContainer.prototype.updateTransform = function () {
        if (this.visible && (this.displayObjectUpdateTransform(), !this._cacheAsBitmap)) for (var t = 0; t < this.children.length; t++) {
          this.children[t].updateTransform();
        }
      }, i.DisplayObjectContainer.prototype.displayObjectContainerUpdateTransform = i.DisplayObjectContainer.prototype.updateTransform, i.DisplayObjectContainer.prototype.getBounds = function (t) {
        var e,
            s = t && t instanceof i.DisplayObject,
            n = !0;

        if (s ? n = t instanceof i.DisplayObjectContainer && t.contains(this) : t = this, s) {
          var o = t.worldTransform;

          for (t.worldTransform = Phaser.identityMatrix, e = 0; e < t.children.length; e++) {
            t.children[e].updateTransform();
          }
        }

        var r,
            a,
            h,
            l = 1 / 0,
            c = 1 / 0,
            u = -1 / 0,
            d = -1 / 0,
            p = !1;

        for (e = 0; e < this.children.length; e++) {
          this.children[e].visible && (p = !0, l = l < (r = this.children[e].getBounds()).x ? l : r.x, c = c < r.y ? c : r.y, a = r.width + r.x, h = r.height + r.y, u = u > a ? u : a, d = d > h ? d : h);
        }

        var f = this._bounds;

        if (!p) {
          var g = (f = new i.Rectangle()).x,
              m = f.width + f.x,
              y = f.y,
              v = f.height + f.y,
              b = this.worldTransform,
              x = b.a,
              w = b.b,
              _ = b.c,
              T = b.d,
              P = b.tx,
              S = b.ty,
              C = x * m + _ * v + P,
              A = T * v + w * m + S,
              E = x * g + _ * v + P,
              M = T * v + w * g + S,
              R = x * g + _ * y + P,
              L = T * y + w * g + S,
              I = x * m + _ * y + P,
              k = T * y + w * m + S;
          u = C, d = A, c = A, l = I < (l = R < (l = E < (l = C) ? E : l) ? R : l) ? I : l, c = k < (c = L < (c = M < c ? M : c) ? L : c) ? k : c, u = I > (u = R > (u = E > u ? E : u) ? R : u) ? I : u, d = k > (d = L > (d = M > d ? M : d) ? L : d) ? k : d;
        }

        if (f.x = l, f.y = c, f.width = u - l, f.height = d - c, s) for (t.worldTransform = o, e = 0; e < t.children.length; e++) {
          t.children[e].updateTransform();
        }

        if (!n) {
          var O = t.getBounds();
          f.x -= O.x, f.y -= O.y;
        }

        return f;
      }, i.DisplayObjectContainer.prototype.getLocalBounds = function () {
        return this.getBounds(this);
      }, i.DisplayObjectContainer.prototype.contains = function (t) {
        return !!t && (t === this || this.contains(t.parent));
      }, i.DisplayObjectContainer.prototype._renderWebGL = function (t) {
        var e;
        if (this.visible && !(this.alpha <= 0)) if (this._cacheAsBitmap) this._renderCachedSprite(t);else if (this._mask || this._filters) {
          for (this._filters && (t.spriteBatch.flush(), t.filterManager.pushFilter(this._filterBlock)), this._mask && (t.spriteBatch.stop(), t.maskManager.pushMask(this.mask, t), t.spriteBatch.start()), e = 0; e < this.children.length; e++) {
            this.children[e]._renderWebGL(t);
          }

          t.spriteBatch.stop(), this._mask && t.maskManager.popMask(this._mask, t), this._filters && t.filterManager.popFilter(), t.spriteBatch.start();
        } else for (e = 0; e < this.children.length; e++) {
          this.children[e]._renderWebGL(t);
        }
      }, i.DisplayObjectContainer.prototype._renderCanvas = function (t) {
        if (!1 !== this.visible && 0 !== this.alpha) if (this._cacheAsBitmap) this._renderCachedSprite(t);else {
          this._mask && t.maskManager.pushMask(this._mask, t);

          for (var e = 0; e < this.children.length; e++) {
            this.children[e]._renderCanvas(t);
          }

          this._mask && t.maskManager.popMask(t);
        }
      }, Object.defineProperty(i.DisplayObjectContainer.prototype, "width", {
        get: function get() {
          return this.getLocalBounds().width * this.scale.x;
        },
        set: function set(t) {
          var e = this.getLocalBounds().width;
          this.scale.x = 0 !== e ? t / e : 1, this._width = t;
        }
      }), Object.defineProperty(i.DisplayObjectContainer.prototype, "height", {
        get: function get() {
          return this.getLocalBounds().height * this.scale.y;
        },
        set: function set(t) {
          var e = this.getLocalBounds().height;
          this.scale.y = 0 !== e ? t / e : 1, this._height = t;
        }
      }), i.Sprite = function (t) {
        i.DisplayObjectContainer.call(this), this.anchor = new i.Point(i.Sprite.defaultAnchor.x, i.Sprite.defaultAnchor.y), this.texture = t || i.Texture.emptyTexture, this._width = 0, this._height = 0, this.tint = 16777215, this.cachedTint = -1, this.tintedTexture = null, this.blendMode = i.blendModes.NORMAL, this.shader = null, this.exists = !0, this.texture.baseTexture.hasLoaded && this.onTextureUpdate(), this.renderable = !0;
      }, i.Sprite.defaultAnchor = {
        x: 0,
        y: 0
      }, i.Sprite.prototype = Object.create(i.DisplayObjectContainer.prototype), i.Sprite.prototype.constructor = i.Sprite, Object.defineProperty(i.Sprite.prototype, "width", {
        get: function get() {
          return this.scale.x * this.texture.frame.width;
        },
        set: function set(t) {
          this.scale.x = t / this.texture.frame.width, this._width = t;
        }
      }), Object.defineProperty(i.Sprite.prototype, "height", {
        get: function get() {
          return this.scale.y * this.texture.frame.height;
        },
        set: function set(t) {
          this.scale.y = t / this.texture.frame.height, this._height = t;
        }
      }), i.Sprite.prototype.setTexture = function (t, e) {
        e && this.texture.baseTexture.destroy(), this.texture.baseTexture.skipRender = !1, this.texture = t, this.texture.valid = !0, this.cachedTint = -1;
      }, i.Sprite.prototype.onTextureUpdate = function () {
        this._width && (this.scale.x = this._width / this.texture.frame.width), this._height && (this.scale.y = this._height / this.texture.frame.height);
      }, i.Sprite.prototype.getBounds = function (t) {
        var e = this.texture.frame.width,
            i = this.texture.frame.height,
            s = e * (1 - this.anchor.x),
            n = e * -this.anchor.x,
            o = i * (1 - this.anchor.y),
            r = i * -this.anchor.y,
            a = t || this.worldTransform,
            h = a.a,
            l = a.b,
            c = a.c,
            u = a.d,
            d = a.tx,
            p = a.ty,
            f = -1 / 0,
            g = -1 / 0,
            m = 1 / 0,
            y = 1 / 0;

        if (0 === l && 0 === c) {
          if (h < 0) {
            h *= -1;
            var v = s;
            s = -n, n = -v;
          }

          if (u < 0) {
            u *= -1;
            v = o;
            o = -r, r = -v;
          }

          m = h * n + d, f = h * s + d, y = u * r + p, g = u * o + p;
        } else {
          var b = h * n + c * r + d,
              x = u * r + l * n + p,
              w = h * s + c * r + d,
              _ = u * r + l * s + p,
              T = h * s + c * o + d,
              P = u * o + l * s + p,
              S = h * n + c * o + d,
              C = u * o + l * n + p;

          m = S < (m = T < (m = w < (m = b < m ? b : m) ? w : m) ? T : m) ? S : m, y = C < (y = P < (y = _ < (y = x < y ? x : y) ? _ : y) ? P : y) ? C : y, f = S > (f = T > (f = w > (f = b > f ? b : f) ? w : f) ? T : f) ? S : f, g = C > (g = P > (g = _ > (g = x > g ? x : g) ? _ : g) ? P : g) ? C : g;
        }

        var A = this._bounds;
        return A.x = m, A.width = f - m, A.y = y, A.height = g - y, this._currentBounds = A, A;
      }, i.Sprite.prototype.getLocalBounds = function () {
        var t = this.worldTransform;
        this.worldTransform = Phaser.identityMatrix;

        for (var e = 0; e < this.children.length; e++) {
          this.children[e].updateTransform();
        }

        var i = this.getBounds();

        for (this.worldTransform = t, e = 0; e < this.children.length; e++) {
          this.children[e].updateTransform();
        }

        return i;
      }, i.Sprite.prototype._renderWebGL = function (t, e) {
        if (this.visible && !(this.alpha <= 0) && this.renderable) {
          var i = this.worldTransform;

          if (e && (i = e), this._mask || this._filters) {
            var s = t.spriteBatch;
            this._filters && (s.flush(), t.filterManager.pushFilter(this._filterBlock)), this._mask && (s.stop(), t.maskManager.pushMask(this.mask, t), s.start()), s.render(this);

            for (var n = 0; n < this.children.length; n++) {
              this.children[n]._renderWebGL(t);
            }

            s.stop(), this._mask && t.maskManager.popMask(this._mask, t), this._filters && t.filterManager.popFilter(), s.start();
          } else {
            t.spriteBatch.render(this);

            for (n = 0; n < this.children.length; n++) {
              this.children[n]._renderWebGL(t, i);
            }
          }
        }
      }, i.Sprite.prototype._renderCanvas = function (t, e) {
        if (!(!this.visible || 0 === this.alpha || !this.renderable || this.texture.crop.width < 1 || this.texture.crop.height < 1)) {
          var s = this.worldTransform;

          if (e && (s = e), this.blendMode !== t.currentBlendMode && (t.currentBlendMode = this.blendMode, t.context.globalCompositeOperation = i.blendModesCanvas[t.currentBlendMode]), this._mask && t.maskManager.pushMask(this._mask, t), this.texture.valid) {
            var n = this.texture.baseTexture.resolution / t.resolution;
            t.context.globalAlpha = this.worldAlpha, t.smoothProperty && t.scaleMode !== this.texture.baseTexture.scaleMode && (t.scaleMode = this.texture.baseTexture.scaleMode, t.context[t.smoothProperty] = t.scaleMode === i.scaleModes.LINEAR);
            var o = this.texture.trim ? this.texture.trim.x - this.anchor.x * this.texture.trim.width : this.anchor.x * -this.texture.frame.width,
                r = this.texture.trim ? this.texture.trim.y - this.anchor.y * this.texture.trim.height : this.anchor.y * -this.texture.frame.height,
                a = s.tx * t.resolution + t.shakeX,
                h = s.ty * t.resolution + t.shakeY,
                l = this.texture.crop.width,
                c = this.texture.crop.height;

            if (this.texture.rotated) {
              var u = s.a,
                  d = s.b,
                  p = s.c,
                  f = s.d,
                  g = l;
              a = s.c * c + a, h = s.d * c + h, s.a = 6.123233995736766e-17 * u - p, s.b = 6.123233995736766e-17 * d - f, s.c = u + 6.123233995736766e-17 * p, s.d = d + 6.123233995736766e-17 * f, l = c, c = g;
            }

            if (t.roundPixels ? (t.context.setTransform(s.a, s.b, s.c, s.d, 0 | a, 0 | h), o |= 0, r |= 0) : t.context.setTransform(s.a, s.b, s.c, s.d, a, h), o /= n, r /= n, c |= 0, (l |= 0) && c) {
              if (16777215 !== this.tint) (this.texture.requiresReTint || this.cachedTint !== this.tint) && (this.tintedTexture = i.CanvasTinter.getTintedTexture(this, this.tint), this.cachedTint = this.tint, this.texture.requiresReTint = !1), t.context.drawImage(this.tintedTexture, 0, 0, l, c, o, r, l / n, c / n);else {
                var m = this.texture.crop.x,
                    y = this.texture.crop.y;
                t.context.drawImage(this.texture.baseTexture.source, m, y, l, c, o, r, l / n, c / n);
              }

              for (v = 0; v < this.children.length; v++) {
                this.children[v]._renderCanvas(t);
              }

              this._mask && t.maskManager.popMask(t);
            }
          } else {
            for (var v = 0; v < this.children.length; v++) {
              this.children[v]._renderCanvas(t);
            }

            this._mask && t.maskManager.popMask(t);
          }
        }
      }, i.initDefaultShaders = function () {}, i.CompileVertexShader = function (t, e) {
        return i._CompileShader(t, e, t.VERTEX_SHADER);
      }, i.CompileFragmentShader = function (t, e) {
        return i._CompileShader(t, e, t.FRAGMENT_SHADER);
      }, i._CompileShader = function (t, e, i) {
        var s = e;
        Array.isArray(e) && (s = e.join("\n"));
        var n = t.createShader(i);
        return t.shaderSource(n, s), t.compileShader(n), t.getShaderParameter(n, t.COMPILE_STATUS) ? n : (window.console.log(t.getShaderInfoLog(n)), null);
      }, i.compileProgram = function (t, e, s) {
        var n = i.CompileFragmentShader(t, s),
            o = i.CompileVertexShader(t, e),
            r = t.createProgram();
        return t.attachShader(r, o), t.attachShader(r, n), t.linkProgram(r), t.getProgramParameter(r, t.LINK_STATUS) || (window.console.log(t.getProgramInfoLog(r)), window.console.log("Could not initialise shaders")), r;
      }, i.PixiShader = function (t) {
        this._UID = Phaser._UID++, this.gl = t, this.program = null, this.fragmentSrc = null, this.textureCount = 0, this.firstRun = !0, this.dirty = !0, this.attributes = [], this.init();
      }, i.PixiShader.prototype.constructor = i.PixiShader, i.PixiShader.prototype.initMultitexShader = function () {
        var t = this.gl;
        this.MAX_TEXTURES = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);

        for (var e = "\tif (vTextureIndex == 0.0) { gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;return;}\n", s = 1; s < this.MAX_TEXTURES; ++s) {
          e += "\tif (vTextureIndex == " + s + ".0) {gl_FragColor = texture2D(uSamplerArray[" + s + "], vTextureCoord) * vColor;return;}\n";
        }

        this.fragmentSrc = ["// PixiShader Fragment Shader.", "precision lowp float;", "bool isnan( float val ) {  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true; }", "varying vec2 vTextureCoord;", "varying vec4 vColor;", "varying float vTextureIndex;", "uniform sampler2D uSamplerArray[" + this.MAX_TEXTURES + "];", "const vec4 BLUE = vec4(1.0, 0.0, 1.0, 1.0);", "const vec4 RED = vec4(1.0, 0.0, 0.0, 1.0);", "void main(void) {", e, "   if(vTextureIndex >= " + this.MAX_TEXTURES + ".0) { gl_FragColor = BLUE;return;}", "   if(isnan(vTextureIndex)) { gl_FragColor = RED;return;}", "}"];
        var n = i.compileProgram(t, this.vertexSrc || i.PixiShader.defaultVertexSrc, this.fragmentSrc);
        t.useProgram(n), this.uSamplerArray = t.getUniformLocation(n, "uSamplerArray[0]"), this.projectionVector = t.getUniformLocation(n, "projectionVector"), this.offsetVector = t.getUniformLocation(n, "offsetVector"), this.dimensions = t.getUniformLocation(n, "dimensions"), this.aVertexPosition = t.getAttribLocation(n, "aVertexPosition"), this.aTextureCoord = t.getAttribLocation(n, "aTextureCoord"), this.colorAttribute = t.getAttribLocation(n, "aColor"), this.aTextureIndex = t.getAttribLocation(n, "aTextureIndex");
        var o = [],
            r = t.createTexture();
        t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, r), t.texImage2D(t.TEXTURE_2D, 0, t.RGB, 1, 1, 0, t.RGB, t.UNSIGNED_BYTE, null);

        for (var a = 0; a < this.MAX_TEXTURES; ++a) {
          t.activeTexture(t.TEXTURE0 + a), t.bindTexture(t.TEXTURE_2D, r), o.push(a);
        }

        for (var h in t.activeTexture(t.TEXTURE0), t.uniform1iv(this.uSamplerArray, o), -1 === this.colorAttribute && (this.colorAttribute = 2), this.attributes = [this.aVertexPosition, this.aTextureCoord, this.colorAttribute, this.aTextureIndex], this.uniforms) {
          this.uniforms[h].uniformLocation = t.getUniformLocation(n, h);
        }

        this.initUniforms(), this.program = n;
      }, i.PixiShader.prototype.initDefaultShader = function () {
        null === this.fragmentSrc && (this.fragmentSrc = ["precision lowp float;", "varying vec2 vTextureCoord;", "varying vec4 vColor;", "varying float vTextureIndex;", "uniform sampler2D uSampler;", "void main(void) {", "   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor ;", "}"]);
        var t = this.gl,
            e = i.compileProgram(t, this.vertexSrc || i.PixiShader.defaultVertexSrc, this.fragmentSrc);

        for (var s in t.useProgram(e), this.uSampler = t.getUniformLocation(e, "uSampler"), this.projectionVector = t.getUniformLocation(e, "projectionVector"), this.offsetVector = t.getUniformLocation(e, "offsetVector"), this.dimensions = t.getUniformLocation(e, "dimensions"), this.aVertexPosition = t.getAttribLocation(e, "aVertexPosition"), this.aTextureCoord = t.getAttribLocation(e, "aTextureCoord"), this.colorAttribute = t.getAttribLocation(e, "aColor"), this.aTextureIndex = t.getAttribLocation(e, "aTextureIndex"), -1 === this.colorAttribute && (this.colorAttribute = 2), this.attributes = [this.aVertexPosition, this.aTextureCoord, this.colorAttribute, this.aTextureIndex], this.uniforms) {
          this.uniforms[s].uniformLocation = t.getUniformLocation(e, s);
        }

        this.initUniforms(), this.program = e;
      }, i.PixiShader.prototype.init = function (t) {
        i._enableMultiTextureToggle && !t ? this.initMultitexShader() : this.initDefaultShader();
      }, i.PixiShader.prototype.initUniforms = function () {
        this.textureCount = 1;
        var t,
            e = this.gl;

        for (var i in this.uniforms) {
          var s = (t = this.uniforms[i]).type;
          "sampler2D" === s ? (t._init = !1, null !== t.value && this.initSampler2D(t)) : "mat2" === s || "mat3" === s || "mat4" === s ? (t.glMatrix = !0, t.glValueLength = 1, "mat2" === s ? t.glFunc = e.uniformMatrix2fv : "mat3" === s ? t.glFunc = e.uniformMatrix3fv : "mat4" === s && (t.glFunc = e.uniformMatrix4fv)) : (t.glFunc = e["uniform" + s], t.glValueLength = "2f" === s || "2i" === s ? 2 : "3f" === s || "3i" === s ? 3 : "4f" === s || "4i" === s ? 4 : 1);
        }
      }, i.PixiShader.prototype.initSampler2D = function (t) {
        if (t.value && t.value.baseTexture && t.value.baseTexture.hasLoaded) {
          var e = this.gl;

          if (e.activeTexture(e.TEXTURE0 + this.textureCount), e.bindTexture(e.TEXTURE_2D, t.value.baseTexture._glTextures[e.id]), t.textureData) {
            var i = t.textureData,
                s = i.magFilter ? i.magFilter : e.LINEAR,
                n = i.minFilter ? i.minFilter : e.LINEAR,
                o = i.wrapS ? i.wrapS : e.CLAMP_TO_EDGE,
                r = i.wrapT ? i.wrapT : e.CLAMP_TO_EDGE,
                a = i.luminance ? e.LUMINANCE : e.RGBA;

            if (i.repeat && (o = e.REPEAT, r = e.REPEAT), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, !!i.flipY), i.width) {
              var h = i.width ? i.width : 512,
                  l = i.height ? i.height : 2,
                  c = i.border ? i.border : 0;
              e.texImage2D(e.TEXTURE_2D, 0, a, h, l, c, a, e.UNSIGNED_BYTE, null);
            } else e.texImage2D(e.TEXTURE_2D, 0, a, e.RGBA, e.UNSIGNED_BYTE, t.value.baseTexture.source);

            e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, s), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, n), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, o), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, r);
          }

          e.uniform1i(t.uniformLocation, this.textureCount), t._init = !0, this.textureCount++;
        }
      }, i.PixiShader.prototype.syncUniforms = function () {
        var t;
        this.textureCount = 1;
        var e = this.gl;

        for (var s in this.uniforms) {
          1 === (t = this.uniforms[s]).glValueLength ? !0 === t.glMatrix ? t.glFunc.call(e, t.uniformLocation, t.transpose, t.value) : t.glFunc.call(e, t.uniformLocation, t.value) : 2 === t.glValueLength ? t.glFunc.call(e, t.uniformLocation, t.value.x, t.value.y) : 3 === t.glValueLength ? t.glFunc.call(e, t.uniformLocation, t.value.x, t.value.y, t.value.z) : 4 === t.glValueLength ? t.glFunc.call(e, t.uniformLocation, t.value.x, t.value.y, t.value.z, t.value.w) : "sampler2D" === t.type && (t._init ? (e.activeTexture(e["TEXTURE" + this.textureCount]), t.value.baseTexture._dirty[e.id] ? i.instances[e.id].updateTexture(t.value.baseTexture) : e.bindTexture(e.TEXTURE_2D, t.value.baseTexture._glTextures[e.id]), e.uniform1i(t.uniformLocation, this.textureCount), this.textureCount++) : this.initSampler2D(t));
        }
      }, i.PixiShader.prototype.destroy = function () {
        this.gl.deleteProgram(this.program), this.uniforms = null, this.gl = null, this.attributes = null;
      }, i.PixiShader.defaultVertexSrc = ["// PixiShader Vertex Shader", "// With multi-texture rendering", "attribute vec2 aVertexPosition;", "attribute vec2 aTextureCoord;", "attribute vec4 aColor;", "attribute float aTextureIndex;", "uniform vec2 projectionVector;", "uniform vec2 offsetVector;", "varying vec2 vTextureCoord;", "varying vec4 vColor;", "varying float vTextureIndex;", "const vec2 center = vec2(-1.0, 1.0);", "void main(void) {", "   if (aTextureIndex > 0.0) gl_Position = vec4(0.0);", "   gl_Position = vec4( ((aVertexPosition + offsetVector) / projectionVector) + center , 0.0, 1.0);", "   vTextureCoord = aTextureCoord;", "   vColor = vec4(aColor.rgb * aColor.a, aColor.a);", "   vTextureIndex = aTextureIndex;", "}"], i.PixiFastShader = function (t) {
        if (this._UID = Phaser._UID++, this.gl = t, this.program = null, i._enableMultiTextureToggle) {
          t = this.gl;
          this.MAX_TEXTURES = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);

          for (var e = "\tif (vTextureIndex == 0.0) { gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;return;}\n", s = 1; s < this.MAX_TEXTURES; ++s) {
            e += "\tif (vTextureIndex == " + s + ".0) { gl_FragColor = texture2D(uSamplerArray[" + s + "], vTextureCoord) * vColor;return;}\n";
          }

          this.fragmentSrc = ["// PixiFastShader Fragment Shader.", "precision lowp float;", "bool isnan( float val ) {  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true; }", "varying vec2 vTextureCoord;", "varying float vColor;", "varying float vTextureIndex;", "uniform sampler2D uSamplerArray[" + this.MAX_TEXTURES + "];", "const vec4 BLUE = vec4(1.0, 0.0, 1.0, 1.0);", "const vec4 RED = vec4(1.0, 0.0, 0.0, 1.0);", "void main(void) {", e, "   if(vTextureIndex >= " + this.MAX_TEXTURES + ".0) { gl_FragColor = BLUE;return;}", "   if(isnan(vTextureIndex)) {gl_FragColor = RED;return;}", "}"];
        } else this.fragmentSrc = ["// PixiFastShader Fragment Shader.", "precision lowp float;", "varying vec2 vTextureCoord;", "varying float vColor;", "varying float vTextureIndex;", "uniform sampler2D uSampler;", "void main(void) {", "   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;", "}"];

        this.vertexSrc = ["// PixiFastShader Vertex Shader.", "attribute vec2 aVertexPosition;", "attribute vec2 aPositionCoord;", "attribute vec2 aScale;", "attribute float aRotation;", "attribute vec2 aTextureCoord;", "attribute float aColor;", "attribute float aTextureIndex;", "uniform vec2 projectionVector;", "uniform vec2 offsetVector;", "uniform mat3 uMatrix;", "varying vec2 vTextureCoord;", "varying float vColor;", "varying float vTextureIndex;", "const vec2 center = vec2(-1.0, 1.0);", "void main(void) {", "   vec2 v;", "   vec2 sv = aVertexPosition * aScale;", "   v.x = (sv.x) * cos(aRotation) - (sv.y) * sin(aRotation);", "   v.y = (sv.x) * sin(aRotation) + (sv.y) * cos(aRotation);", "   v = ( uMatrix * vec3(v + aPositionCoord , 1.0) ).xy ;", "   gl_Position = vec4( ( v / projectionVector) + center , 0.0, 1.0);", "   vTextureCoord = aTextureCoord;", "   vTextureIndex = aTextureIndex;", "   vColor = aColor;", "}"], this.textureCount = 0, this.init();
      }, i.PixiFastShader.prototype.constructor = i.PixiFastShader, i.PixiFastShader.prototype.init = function () {
        var t = this.gl,
            e = i.compileProgram(t, this.vertexSrc, this.fragmentSrc);

        if (t.useProgram(e), this.uSampler = i._enableMultiTextureToggle ? t.getUniformLocation(e, "uSamplerArray[0]") : t.getUniformLocation(e, "uSampler"), i._enableMultiTextureToggle) {
          var s = [],
              n = t.createTexture();
          t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, n), t.texImage2D(t.TEXTURE_2D, 0, t.RGB, 1, 1, 0, t.RGB, t.UNSIGNED_BYTE, null);

          for (var o = 0; o < this.MAX_TEXTURES; ++o) {
            t.activeTexture(t.TEXTURE0 + o), t.bindTexture(t.TEXTURE_2D, n), s.push(o);
          }

          t.activeTexture(t.TEXTURE0), t.uniform1iv(this.uSampler, s);
        }

        this.projectionVector = t.getUniformLocation(e, "projectionVector"), this.offsetVector = t.getUniformLocation(e, "offsetVector"), this.dimensions = t.getUniformLocation(e, "dimensions"), this.uMatrix = t.getUniformLocation(e, "uMatrix"), this.aVertexPosition = t.getAttribLocation(e, "aVertexPosition"), this.aPositionCoord = t.getAttribLocation(e, "aPositionCoord"), this.aScale = t.getAttribLocation(e, "aScale"), this.aRotation = t.getAttribLocation(e, "aRotation"), this.aTextureCoord = t.getAttribLocation(e, "aTextureCoord"), this.colorAttribute = t.getAttribLocation(e, "aColor"), this.aTextureIndex = t.getAttribLocation(e, "aTextureIndex"), -1 === this.colorAttribute && (this.colorAttribute = 2), this.attributes = [this.aVertexPosition, this.aPositionCoord, this.aScale, this.aRotation, this.aTextureCoord, this.colorAttribute, this.aTextureIndex], this.program = e;
      }, i.PixiFastShader.prototype.destroy = function () {
        this.gl.deleteProgram(this.program), this.uniforms = null, this.gl = null, this.attributes = null;
      }, i.StripShader = function (t) {
        if (this._UID = Phaser._UID++, this.gl = t, this.program = null, i._enableMultiTextureToggle) {
          t = this.gl;
          this.MAX_TEXTURES = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);

          for (var e = "\tif (vTextureIndex == 0.0) { gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord);return;}\n", s = 1; s < this.MAX_TEXTURES; ++s) {
            e += "\tif (vTextureIndex == " + s + ".0) { gl_FragColor = texture2D(uSamplerArray[" + s + "], vTextureCoord) ;return;}\n";
          }

          this.fragmentSrc = ["//StripShader Fragment Shader.", "precision mediump float;", "bool isnan( float val ) {  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true; }", "varying vec2 vTextureCoord;", "varying float vTextureIndex;", "uniform float alpha;", "uniform sampler2D uSamplerArray[" + this.MAX_TEXTURES + "];", "const vec4 BLUE = vec4(1.0, 0.0, 1.0, 1.0);", "const vec4 RED = vec4(1.0, 0.0, 0.0, 1.0);", "void main(void) {", e, "   if(vTextureIndex >= " + this.MAX_TEXTURES + ".0) { gl_FragColor = BLUE;return;}", "   if(isnan(vTextureIndex)) {gl_FragColor = RED;return;}", "}"];
        } else this.fragmentSrc = ["//StripShader Fragment Shader.", "precision mediump float;", "varying vec2 vTextureCoord;", "varying float vTextureIndex;", "uniform float alpha;", "uniform sampler2D uSampler;", "void main(void) {", "   gl_FragColor = texture2D(uSampler, vTextureCoord);", "}"];

        this.vertexSrc = ["//StripShader Vertex Shader.", "attribute vec2 aVertexPosition;", "attribute vec2 aTextureCoord;", "attribute float aTextureIndex;", "uniform mat3 translationMatrix;", "uniform vec2 projectionVector;", "uniform vec2 offsetVector;", "varying vec2 vTextureCoord;", "varying float vTextureIndex;", "void main(void) {", "   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);", "   v -= offsetVector.xyx;", "   gl_Position = vec4( v.x / projectionVector.x -1.0, v.y / -projectionVector.y + 1.0 , 0.0, 1.0);", "   vTextureCoord = aTextureCoord;", "   vTextureIndex = aTextureIndex;", "}"], this.init();
      }, i.StripShader.prototype.constructor = i.StripShader, i.StripShader.prototype.init = function () {
        var t = this.gl,
            e = i.compileProgram(t, this.vertexSrc, this.fragmentSrc);

        if (t.useProgram(e), this.uSampler = i._enableMultiTextureToggle ? t.getUniformLocation(e, "uSamplerArray[0]") : t.getUniformLocation(e, "uSampler"), i._enableMultiTextureToggle) {
          var s = [],
              n = t.createTexture();
          t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, n), t.texImage2D(t.TEXTURE_2D, 0, t.RGB, 1, 1, 0, t.RGB, t.UNSIGNED_BYTE, null);

          for (var o = 0; o < this.MAX_TEXTURES; ++o) {
            t.activeTexture(t.TEXTURE0 + o), t.bindTexture(t.TEXTURE_2D, n), s.push(o);
          }

          t.activeTexture(t.TEXTURE0), t.uniform1iv(this.uSampler, s);
        }

        this.projectionVector = t.getUniformLocation(e, "projectionVector"), this.offsetVector = t.getUniformLocation(e, "offsetVector"), this.colorAttribute = t.getAttribLocation(e, "aColor"), this.aTextureIndex = t.getAttribLocation(e, "aTextureIndex"), this.aVertexPosition = t.getAttribLocation(e, "aVertexPosition"), this.aTextureCoord = t.getAttribLocation(e, "aTextureCoord"), this.attributes = [this.aVertexPosition, this.aTextureCoord, this.aTextureIndex], this.translationMatrix = t.getUniformLocation(e, "translationMatrix"), this.alpha = t.getUniformLocation(e, "alpha"), this.program = e;
      }, i.StripShader.prototype.destroy = function () {
        this.gl.deleteProgram(this.program), this.uniforms = null, this.gl = null, this.attribute = null;
      }, i.PrimitiveShader = function (t) {
        this._UID = Phaser._UID++, this.gl = t, this.program = null, this.fragmentSrc = ["precision mediump float;", "varying vec4 vColor;", "void main(void) {", "   gl_FragColor = vColor;", "}"], this.vertexSrc = ["attribute vec2 aVertexPosition;", "attribute vec4 aColor;", "uniform mat3 translationMatrix;", "uniform vec2 projectionVector;", "uniform vec2 offsetVector;", "uniform float alpha;", "uniform float flipY;", "uniform vec3 tint;", "varying vec4 vColor;", "void main(void) {", "   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);", "   v -= offsetVector.xyx;", "   gl_Position = vec4( v.x / projectionVector.x -1.0, (v.y / projectionVector.y * -flipY) + flipY , 0.0, 1.0);", "   vColor = aColor * vec4(tint * alpha, alpha);", "}"], this.init();
      }, i.PrimitiveShader.prototype.constructor = i.PrimitiveShader, i.PrimitiveShader.prototype.init = function () {
        var t = this.gl,
            e = i.compileProgram(t, this.vertexSrc, this.fragmentSrc);
        t.useProgram(e), this.projectionVector = t.getUniformLocation(e, "projectionVector"), this.offsetVector = t.getUniformLocation(e, "offsetVector"), this.tintColor = t.getUniformLocation(e, "tint"), this.flipY = t.getUniformLocation(e, "flipY"), this.aVertexPosition = t.getAttribLocation(e, "aVertexPosition"), this.colorAttribute = t.getAttribLocation(e, "aColor"), this.attributes = [this.aVertexPosition, this.colorAttribute], this.translationMatrix = t.getUniformLocation(e, "translationMatrix"), this.alpha = t.getUniformLocation(e, "alpha"), this.program = e;
      }, i.PrimitiveShader.prototype.destroy = function () {
        this.gl.deleteProgram(this.program), this.uniforms = null, this.gl = null, this.attributes = null;
      }, i.ComplexPrimitiveShader = function (t) {
        this._UID = Phaser._UID++, this.gl = t, this.program = null, this.fragmentSrc = ["precision mediump float;", "varying vec4 vColor;", "void main(void) {", "   gl_FragColor = vColor;", "}"], this.vertexSrc = ["attribute vec2 aVertexPosition;", "uniform mat3 translationMatrix;", "uniform vec2 projectionVector;", "uniform vec2 offsetVector;", "uniform vec3 tint;", "uniform float alpha;", "uniform vec3 color;", "uniform float flipY;", "varying vec4 vColor;", "void main(void) {", "   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);", "   v -= offsetVector.xyx;", "   gl_Position = vec4( v.x / projectionVector.x -1.0, (v.y / projectionVector.y * -flipY) + flipY , 0.0, 1.0);", "   vColor = vec4(color * alpha * tint, alpha);", "}"], this.init();
      }, i.ComplexPrimitiveShader.prototype.constructor = i.ComplexPrimitiveShader, i.ComplexPrimitiveShader.prototype.init = function () {
        var t = this.gl,
            e = i.compileProgram(t, this.vertexSrc, this.fragmentSrc);
        t.useProgram(e), this.projectionVector = t.getUniformLocation(e, "projectionVector"), this.offsetVector = t.getUniformLocation(e, "offsetVector"), this.tintColor = t.getUniformLocation(e, "tint"), this.color = t.getUniformLocation(e, "color"), this.flipY = t.getUniformLocation(e, "flipY"), this.aVertexPosition = t.getAttribLocation(e, "aVertexPosition"), this.attributes = [this.aVertexPosition, this.colorAttribute], this.translationMatrix = t.getUniformLocation(e, "translationMatrix"), this.alpha = t.getUniformLocation(e, "alpha"), this.program = e;
      }, i.ComplexPrimitiveShader.prototype.destroy = function () {
        this.gl.deleteProgram(this.program), this.uniforms = null, this.gl = null, this.attribute = null;
      }, i.glContexts = [], i.instances = [], i._enableMultiTextureToggle = !1, i.WebGLRenderer = function (t, e) {
        this.game = t, i.defaultRenderer || (i.defaultRenderer = this), this.extensions = {}, this.type = Phaser.WEBGL, this.resolution = t.resolution, this.transparent = t.transparent, this.autoResize = !1, this.preserveDrawingBuffer = t.preserveDrawingBuffer, this.clearBeforeRender = t.clearBeforeRender, this.width = t.width, this.height = t.height, this.view = t.canvas, this._contextOptions = {
          alpha: this.transparent,
          antialias: t.antialias,
          failIfMajorPerformanceCaveat: e.failIfMajorPerformanceCaveat,
          premultipliedAlpha: this.transparent && "notMultiplied" !== this.transparent,
          stencil: !0,
          preserveDrawingBuffer: this.preserveDrawingBuffer
        }, this.projection = new i.Point(), this.offset = new i.Point(), this.shaderManager = new i.WebGLShaderManager(), this.spriteBatch = new i.WebGLSpriteBatch(t), this.maskManager = new i.WebGLMaskManager(), this.filterManager = new i.WebGLFilterManager(), this.stencilManager = new i.WebGLStencilManager(), this.blendModeManager = new i.WebGLBlendModeManager(), this.renderSession = {}, this.currentBatchedTextures = [], this.renderSession.game = this.game, this.renderSession.gl = this.gl, this.renderSession.drawCount = 0, this.renderSession.shaderManager = this.shaderManager, this.renderSession.maskManager = this.maskManager, this.renderSession.filterManager = this.filterManager, this.renderSession.blendModeManager = this.blendModeManager, this.renderSession.spriteBatch = this.spriteBatch, this.renderSession.stencilManager = this.stencilManager, this.renderSession.renderer = this, this.renderSession.resolution = this.resolution, this.renderSession.roundPixels = e.roundPixels || !1, this.renderSession.maxTextureAvailableSpace = null, this.initContext(), this.mapBlendModes();
      }, i.WebGLRenderer.prototype.constructor = i.WebGLRenderer, i.WebGLRenderer.prototype.initContext = function () {
        var t = this.view.getContext("webgl", this._contextOptions) || this.view.getContext("experimental-webgl", this._contextOptions);
        if (this.gl = t, !t) throw new Error("This browser does not support webGL. Try using the canvas renderer");
        this.maxTextures = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS), this.maxTextureSize = this.gl.getParameter(t.MAX_TEXTURE_SIZE), this.glContextId = t.id = i.WebGLRenderer.glContextId++, i.glContexts[this.glContextId] = t, i.instances[this.glContextId] = this, t.disable(t.DEPTH_TEST), t.disable(t.CULL_FACE), t.enable(t.BLEND), this.shaderManager.setContext(t), this.spriteBatch.setContext(t), this.maskManager.setContext(t), this.filterManager.setContext(t), this.blendModeManager.setContext(t), this.stencilManager.setContext(t), this.renderSession.gl = this.gl, this.resize(this.width, this.height), this.extensions.compression = {};
        var e = t.getExtension("WEBGL_compressed_texture_etc1") || t.getExtension("WEBKIT_WEBGL_compressed_texture_etc1"),
            s = t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            n = t.getExtension("WEBGL_compressed_texture_s3tc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        e && (this.extensions.compression.ETC1 = e), s && (this.extensions.compression.PVRTC = s), n && (this.extensions.compression.S3TC = n);
      }, i.WebGLRenderer.prototype.setTexturePriority = function (t) {
        if (i._enableMultiTextureToggle) {
          for (var e = function e(t) {
            return --t, t |= t >> 1, t |= t >> 2, t |= t >> 4, t |= t >> 8, t |= t >> 16, ++t;
          }, s = this.gl, n = s.getParameter(s.MAX_TEXTURE_IMAGE_UNITS), o = s.getParameter(s.MAX_TEXTURE_SIZE), r = this.game.cache._cache.image, a = null, h = 0; h < this.currentBatchedTextures.length; h++) {
            (a = this.currentBatchedTextures[h]) in r ? r[a].base.textureIndex = 0 : console.warn('setTexturePriority: There is no image "%s" in the image cache.', a);
          }

          var l = o - e(Math.max(this.width, this.height));
          this.currentBatchedTextures.length = 0;

          for (var c = 0; c < t.length; ++c) {
            if ((a = t[c]) in r) {
              var u = r[a].base;
              (l -= e(Math.max(u.width, u.height))) <= 0 ? (u.textureIndex = 0, console.warn('setTexturePriority: Image "%s" was given textureIndex=0 because there is no available texture space (%s).', a, l)) : u.textureIndex = 1 + c % (n - 1), this.currentBatchedTextures.push(a);
            } else console.warn('setTexturePriority: There is no image "%s" in the image cache.', a);
          }

          return this.renderSession.maxTextureAvailableSpace = l, this.currentBatchedTextures;
        }

        console.warn("setTexturePriority error: Multi Texture support hasn't been enabled in the Phaser Game Config.");
      }, i.WebGLRenderer.prototype.render = function (t) {
        if (!this.contextLost) {
          var e = this.gl;
          e.viewport(0, 0, this.width, this.height), e.bindFramebuffer(e.FRAMEBUFFER, null), this.game.clearBeforeRender && (e.clearColor(t._bgColor.r, t._bgColor.g, t._bgColor.b, t._bgColor.a), e.clear(e.COLOR_BUFFER_BIT)), this.offset.x = this.game.camera._shake.x, this.offset.y = this.game.camera._shake.y, this.renderDisplayObject(t, this.projection);
        }
      }, i.WebGLRenderer.prototype.renderDisplayObject = function (t, e, s, n) {
        this.renderSession.blendModeManager.setBlendMode(i.blendModes.NORMAL), this.renderSession.drawCount = 0, this.renderSession.flipY = s ? -1 : 1, this.renderSession.projection = e, this.renderSession.offset = this.offset, this.spriteBatch.begin(this.renderSession), this.filterManager.begin(this.renderSession, s), t._renderWebGL(this.renderSession, n), this.spriteBatch.end();
      }, i.WebGLRenderer.prototype.resize = function (t, e) {
        this.width = t * this.resolution, this.height = e * this.resolution, this.view.width = this.width, this.view.height = this.height, this.autoResize && (this.view.style.width = this.width / this.resolution + "px", this.view.style.height = this.height / this.resolution + "px"), this.gl.viewport(0, 0, this.width, this.height), this.projection.x = this.width / 2 / this.resolution, this.projection.y = -this.height / 2 / this.resolution;
      }, i.WebGLRenderer.prototype.updateCompressedTexture = function (t) {
        if (!t.hasLoaded) return !1;
        var e = this.gl,
            s = t.source;
        return t._glTextures[e.id] || (t._glTextures[e.id] = e.createTexture()), e.activeTexture(e.TEXTURE0 + t.textureIndex), e.bindTexture(e.TEXTURE_2D, t._glTextures[e.id]), e.compressedTexImage2D(e.TEXTURE_2D, 0, s.glExtensionFormat, s.width, s.height, 0, s.textureData), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, t.scaleMode === i.scaleModes.LINEAR ? e.LINEAR : e.NEAREST), t.mipmap && Phaser.Math.isPowerOfTwo(t.width, t.height) ? (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, t.scaleMode === i.scaleModes.LINEAR ? e.LINEAR_MIPMAP_LINEAR : e.NEAREST_MIPMAP_NEAREST), e.generateMipmap(e.TEXTURE_2D)) : e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, t.scaleMode === i.scaleModes.LINEAR ? e.LINEAR : e.NEAREST), t._powerOf2 ? (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT)) : (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE)), t._dirty[e.id] = !1, !0;
      }, i.WebGLRenderer.prototype.updateTexture = function (t) {
        if (!t.hasLoaded) return !1;
        if (t.source.compressionAlgorithm) return this.updateCompressedTexture(t);
        var e = this.gl;
        return t._glTextures[e.id] || (t._glTextures[e.id] = e.createTexture()), e.activeTexture(e.TEXTURE0 + t.textureIndex), e.bindTexture(e.TEXTURE_2D, t._glTextures[e.id]), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultipliedAlpha), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, t.source), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, t.scaleMode === i.scaleModes.LINEAR ? e.LINEAR : e.NEAREST), t.mipmap && Phaser.Math.isPowerOfTwo(t.width, t.height) ? (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, t.scaleMode === i.scaleModes.LINEAR ? e.LINEAR_MIPMAP_LINEAR : e.NEAREST_MIPMAP_NEAREST), e.generateMipmap(e.TEXTURE_2D)) : e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, t.scaleMode === i.scaleModes.LINEAR ? e.LINEAR : e.NEAREST), t._powerOf2 ? (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.REPEAT), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.REPEAT)) : (e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE)), t._dirty[e.id] = !1, !0;
      }, i.WebGLRenderer.prototype.destroy = function () {
        i.glContexts[this.glContextId] = null, this.projection = null, this.offset = null, this.shaderManager.destroy(), this.spriteBatch.destroy(), this.maskManager.destroy(), this.filterManager.destroy(), this.shaderManager = null, this.spriteBatch = null, this.maskManager = null, this.filterManager = null, this.gl = null, this.renderSession = null, Phaser.CanvasPool.remove(this), i.instances[this.glContextId] = null, i.WebGLRenderer.glContextId--;
      }, i.WebGLRenderer.prototype.mapBlendModes = function () {
        var t = this.gl;

        if (!i.blendModesWebGL) {
          var e = [],
              s = i.blendModes;
          e[s.NORMAL] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.ADD] = [t.SRC_ALPHA, t.DST_ALPHA], e[s.MULTIPLY] = [t.DST_COLOR, t.ONE_MINUS_SRC_ALPHA], e[s.SCREEN] = [t.SRC_ALPHA, t.ONE], e[s.OVERLAY] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.DARKEN] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.LIGHTEN] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.COLOR_DODGE] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.COLOR_BURN] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.HARD_LIGHT] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.SOFT_LIGHT] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.DIFFERENCE] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.EXCLUSION] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.HUE] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.SATURATION] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.COLOR] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], e[s.LUMINOSITY] = [t.ONE, t.ONE_MINUS_SRC_ALPHA], i.blendModesWebGL = e;
        }
      }, i.WebGLRenderer.prototype.getMaxTextureUnit = function () {
        var t = this.gl;
        return t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);
      }, i.enableMultiTexture = function () {
        i._enableMultiTextureToggle = !0;
      }, i.WebGLRenderer.glContextId = 0, i.WebGLRenderer.textureArray = [], i.WebGLBlendModeManager = function () {
        this.currentBlendMode = 99999;
      }, i.WebGLBlendModeManager.prototype.constructor = i.WebGLBlendModeManager, i.WebGLBlendModeManager.prototype.setContext = function (t) {
        this.gl = t;
      }, i.WebGLBlendModeManager.prototype.setBlendMode = function (t) {
        if (this.currentBlendMode === t) return !1;
        this.currentBlendMode = t;
        var e = i.blendModesWebGL[this.currentBlendMode];
        return e && this.gl.blendFunc(e[0], e[1]), !0;
      }, i.WebGLBlendModeManager.prototype.destroy = function () {
        this.gl = null;
      }, i.WebGLMaskManager = function () {}, i.WebGLMaskManager.prototype.constructor = i.WebGLMaskManager, i.WebGLMaskManager.prototype.setContext = function (t) {
        this.gl = t;
      }, i.WebGLMaskManager.prototype.pushMask = function (t, e) {
        var s = e.gl;
        t.dirty && i.WebGLGraphics.updateGraphics(t, s), void 0 !== t._webGL[s.id] && void 0 !== t._webGL[s.id].data && 0 !== t._webGL[s.id].data.length && e.stencilManager.pushStencil(t, t._webGL[s.id].data[0], e);
      }, i.WebGLMaskManager.prototype.popMask = function (t, e) {
        var i = this.gl;
        void 0 !== t._webGL[i.id] && void 0 !== t._webGL[i.id].data && 0 !== t._webGL[i.id].data.length && e.stencilManager.popStencil(t, t._webGL[i.id].data[0], e);
      }, i.WebGLMaskManager.prototype.destroy = function () {
        this.gl = null;
      }, i.WebGLStencilManager = function () {
        this.stencilStack = [], this.reverse = !0, this.count = 0;
      }, i.WebGLStencilManager.prototype.setContext = function (t) {
        this.gl = t;
      }, i.WebGLStencilManager.prototype.pushStencil = function (t, e, i) {
        var s = this.gl;
        this.bindGraphics(t, e, i), 0 === this.stencilStack.length && (s.enable(s.STENCIL_TEST), s.clear(s.STENCIL_BUFFER_BIT), this.reverse = !0, this.count = 0), this.stencilStack.push(e);
        var n = this.count;
        s.colorMask(!1, !1, !1, !1), s.stencilFunc(s.ALWAYS, 0, 255), s.stencilOp(s.KEEP, s.KEEP, s.INVERT), 1 === e.mode ? (s.drawElements(s.TRIANGLE_FAN, e.indices.length - 4, s.UNSIGNED_SHORT, 0), this.reverse ? (s.stencilFunc(s.EQUAL, 255 - n, 255), s.stencilOp(s.KEEP, s.KEEP, s.DECR)) : (s.stencilFunc(s.EQUAL, n, 255), s.stencilOp(s.KEEP, s.KEEP, s.INCR)), s.drawElements(s.TRIANGLE_FAN, 4, s.UNSIGNED_SHORT, 2 * (e.indices.length - 4)), this.reverse ? s.stencilFunc(s.EQUAL, 255 - (n + 1), 255) : s.stencilFunc(s.EQUAL, n + 1, 255), this.reverse = !this.reverse) : (this.reverse ? (s.stencilFunc(s.EQUAL, n, 255), s.stencilOp(s.KEEP, s.KEEP, s.INCR)) : (s.stencilFunc(s.EQUAL, 255 - n, 255), s.stencilOp(s.KEEP, s.KEEP, s.DECR)), s.drawElements(s.TRIANGLE_STRIP, e.indices.length, s.UNSIGNED_SHORT, 0), this.reverse ? s.stencilFunc(s.EQUAL, n + 1, 255) : s.stencilFunc(s.EQUAL, 255 - (n + 1), 255)), s.colorMask(!0, !0, !0, !0), s.stencilOp(s.KEEP, s.KEEP, s.KEEP), this.count++;
      }, i.WebGLStencilManager.prototype.bindGraphics = function (t, e, i) {
        this._currentGraphics = t;
        var s,
            n = this.gl,
            o = i.projection,
            r = i.offset;
        1 === e.mode ? (s = i.shaderManager.complexPrimitiveShader, i.shaderManager.setShader(s), n.uniform1f(s.flipY, i.flipY), n.uniformMatrix3fv(s.translationMatrix, !1, t.worldTransform.toArray(!0)), n.uniform2f(s.projectionVector, o.x, -o.y), n.uniform2f(s.offsetVector, -r.x, -r.y), n.uniform3fv(s.tintColor, Phaser.Color.hexToRGBArray(t.tint)), n.uniform3fv(s.color, e.color), n.uniform1f(s.alpha, t.worldAlpha * e.alpha), n.bindBuffer(n.ARRAY_BUFFER, e.buffer), n.vertexAttribPointer(s.aVertexPosition, 2, n.FLOAT, !1, 8, 0), n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, e.indexBuffer)) : (s = i.shaderManager.primitiveShader, i.shaderManager.setShader(s), n.uniformMatrix3fv(s.translationMatrix, !1, t.worldTransform.toArray(!0)), n.uniform1f(s.flipY, i.flipY), n.uniform2f(s.projectionVector, o.x, -o.y), n.uniform2f(s.offsetVector, -r.x, -r.y), n.uniform3fv(s.tintColor, Phaser.Color.hexToRGBArray(t.tint)), n.uniform1f(s.alpha, t.worldAlpha), n.bindBuffer(n.ARRAY_BUFFER, e.buffer), n.vertexAttribPointer(s.aVertexPosition, 2, n.FLOAT, !1, 24, 0), n.vertexAttribPointer(s.colorAttribute, 4, n.FLOAT, !1, 24, 8), n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, e.indexBuffer));
      }, i.WebGLStencilManager.prototype.popStencil = function (t, e, i) {
        var s = this.gl;
        if (this.stencilStack.pop(), this.count--, 0 === this.stencilStack.length) s.disable(s.STENCIL_TEST);else {
          var n = this.count;
          this.bindGraphics(t, e, i), s.colorMask(!1, !1, !1, !1), 1 === e.mode ? (this.reverse = !this.reverse, this.reverse ? (s.stencilFunc(s.EQUAL, 255 - (n + 1), 255), s.stencilOp(s.KEEP, s.KEEP, s.INCR)) : (s.stencilFunc(s.EQUAL, n + 1, 255), s.stencilOp(s.KEEP, s.KEEP, s.DECR)), s.drawElements(s.TRIANGLE_FAN, 4, s.UNSIGNED_SHORT, 2 * (e.indices.length - 4)), s.stencilFunc(s.ALWAYS, 0, 255), s.stencilOp(s.KEEP, s.KEEP, s.INVERT), s.drawElements(s.TRIANGLE_FAN, e.indices.length - 4, s.UNSIGNED_SHORT, 0), this.reverse ? s.stencilFunc(s.EQUAL, n, 255) : s.stencilFunc(s.EQUAL, 255 - n, 255)) : (this.reverse ? (s.stencilFunc(s.EQUAL, n + 1, 255), s.stencilOp(s.KEEP, s.KEEP, s.DECR)) : (s.stencilFunc(s.EQUAL, 255 - (n + 1), 255), s.stencilOp(s.KEEP, s.KEEP, s.INCR)), s.drawElements(s.TRIANGLE_STRIP, e.indices.length, s.UNSIGNED_SHORT, 0), this.reverse ? s.stencilFunc(s.EQUAL, n, 255) : s.stencilFunc(s.EQUAL, 255 - n, 255)), s.colorMask(!0, !0, !0, !0), s.stencilOp(s.KEEP, s.KEEP, s.KEEP);
        }
      }, i.WebGLStencilManager.prototype.destroy = function () {
        this.stencilStack = null, this.gl = null;
      }, i.WebGLShaderManager = function () {
        this.maxAttibs = 10, this.attribState = [], this.tempAttribState = [];

        for (var t = 0; t < this.maxAttibs; t++) {
          this.attribState[t] = !1;
        }

        this.stack = [];
      }, i.WebGLShaderManager.prototype.constructor = i.WebGLShaderManager, i.WebGLShaderManager.prototype.setContext = function (t) {
        this.gl = t, this.primitiveShader = new i.PrimitiveShader(t), this.complexPrimitiveShader = new i.ComplexPrimitiveShader(t), this.defaultShader = new i.PixiShader(t), this.fastShader = new i.PixiFastShader(t), this.stripShader = new i.StripShader(t), this.creatureShader = i.CreatureShader ? new i.CreatureShader(t) : null, this.setShader(this.defaultShader);
      }, i.WebGLShaderManager.prototype.setAttribs = function (t) {
        var e;

        for (e = 0; e < this.tempAttribState.length; e++) {
          this.tempAttribState[e] = !1;
        }

        for (e = 0; e < t.length; e++) {
          var i = t[e];
          this.tempAttribState[i] = !0;
        }

        var s = this.gl;

        for (e = 0; e < this.attribState.length; e++) {
          this.attribState[e] !== this.tempAttribState[e] && (this.attribState[e] = this.tempAttribState[e], this.tempAttribState[e] ? s.enableVertexAttribArray(e) : s.disableVertexAttribArray(e));
        }
      }, i.WebGLShaderManager.prototype.setShader = function (t) {
        return this._currentId !== t._UID && (this._currentId = t._UID, this.currentShader = t, this.gl.useProgram(t.program), this.setAttribs(t.attributes), !0);
      }, i.WebGLShaderManager.prototype.destroy = function () {
        this.attribState = null, this.tempAttribState = null, this.primitiveShader.destroy(), this.complexPrimitiveShader.destroy(), this.defaultShader.destroy(), this.fastShader.destroy(), this.stripShader.destroy(), this.creatureShader && this.creatureShader.destroy(), this.gl = null;
      }, i.WebGLSpriteBatch = function (t) {
        this.game = t, this.vertSize = 5, this.size = 2e3, this.vertexSize = 24;
        var e = this.vertexSize * this.size * 4,
            i = 6 * this.size;
        this.vertices = new ArrayBuffer(e), this.positions = new Float32Array(this.vertices), this.colors = new Uint32Array(this.vertices), this.indices = new Uint16Array(i), this.lastIndexCount = 0;

        for (var s = 0, n = 0; s < i; s += 6, n += 4) {
          this.indices[s + 0] = n + 0, this.indices[s + 1] = n + 1, this.indices[s + 2] = n + 2, this.indices[s + 3] = n + 0, this.indices[s + 4] = n + 2, this.indices[s + 5] = n + 3;
        }

        this.drawing = !1, this.currentBatchSize = 0, this.currentBaseTexture = null, this.dirty = !0, this.textures = [], this.blendModes = [], this.shaders = [], this.sprites = [], this.defaultShader = null;
      }, i.WebGLSpriteBatch.prototype.setContext = function (t) {
        if (this.MAX_TEXTURES = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS), this.gl = t, i._enableMultiTextureToggle) {
          for (var e = "\tif (vTextureIndex == 0.0) {gl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;return;}\n", s = 1; s < this.MAX_TEXTURES; ++s) {
            e += "\tif (vTextureIndex == " + s + ".0) {gl_FragColor = texture2D(uSamplerArray[" + s + "], vTextureCoord) * vColor;return;}\n";
          }

          this.defaultShader = new Phaser.Filter(this.game, void 0, ["//WebGLSpriteBatch Fragment Shader.", "precision lowp float;", "varying vec2 vTextureCoord;", "varying vec4 vColor;", "varying float vTextureIndex;", "uniform sampler2D uSamplerArray[" + this.MAX_TEXTURES + "];", "void main(void) {", e, "\tgl_FragColor = texture2D(uSamplerArray[0], vTextureCoord) * vColor;", "}"]);
        } else this.defaultShader = new Phaser.Filter(this.game, void 0, ["//WebGLSpriteBatch Fragment Shader.", "precision lowp float;", "varying vec2 vTextureCoord;", "varying vec4 vColor;", "varying float vTextureIndex;", "uniform sampler2D uSampler;", "void main(void) {", "   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;", "}"]);

        this.vertexBuffer = t.createBuffer(), this.indexBuffer = t.createBuffer(), t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, this.indexBuffer), t.bufferData(t.ELEMENT_ARRAY_BUFFER, this.indices, t.STATIC_DRAW), t.bindBuffer(t.ARRAY_BUFFER, this.vertexBuffer), t.bufferData(t.ARRAY_BUFFER, this.vertices, t.DYNAMIC_DRAW), this.currentBlendMode = 99999;
        var n = new i.PixiShader(t);
        n.fragmentSrc = this.defaultShader.fragmentSrc, n.uniforms = {}, n.init(), this.defaultShader.shaders[t.id] = n;
      }, i.WebGLSpriteBatch.prototype.begin = function (t) {
        this.renderSession = t, this.shader = this.renderSession.shaderManager.defaultShader, this.start();
      }, i.WebGLSpriteBatch.prototype.end = function () {
        this.flush();
      }, i.WebGLSpriteBatch.prototype.render = function (t, e) {
        var s = t.texture,
            n = s.baseTexture,
            o = this.gl;
        i.WebGLRenderer.textureArray[n.textureIndex] != n && (this.flush(), o.activeTexture(o.TEXTURE0 + n.textureIndex), o.bindTexture(o.TEXTURE_2D, n._glTextures[o.id]), i.WebGLRenderer.textureArray[n.textureIndex] = n);
        var r = t.worldTransform;
        e && (r = e), this.currentBatchSize >= this.size && (this.flush(), this.currentBaseTexture = s.baseTexture);
        var a = s._uvs;

        if (a) {
          var h,
              l,
              c,
              u,
              d = t.anchor.x,
              p = t.anchor.y;

          if (s.trim) {
            var f = s.trim;
            h = (l = f.x - d * f.width) + s.crop.width, c = (u = f.y - p * f.height) + s.crop.height;
          } else h = s.frame.width * (1 - d), l = s.frame.width * -d, c = s.frame.height * (1 - p), u = s.frame.height * -p;

          var g = this.currentBatchSize * this.vertexSize,
              m = (this.currentBatchSize, s.baseTexture.resolution),
              y = s.baseTexture.textureIndex,
              v = r.a / m,
              b = r.b / m,
              x = r.c / m,
              w = r.d / m,
              _ = r.tx,
              T = r.ty,
              P = (s.crop.width, s.crop.height);

          if (s.rotated) {
            var S = r.a,
                C = r.b,
                A = r.c,
                E = r.d,
                M = l,
                R = h;
            _ = r.c * P + _, T = r.d * P + T, v = 6.123233995736766e-17 * S - A, b = 6.123233995736766e-17 * C - E, x = S + 6.123233995736766e-17 * A, w = C + 6.123233995736766e-17 * E, s._updateUvsInverted(), h = c, l = u, c = R, u = M;
          }

          var L = this.colors,
              I = this.positions,
              k = t.tint,
              O = (k >> 16) + (65280 & k) + ((255 & k) << 16) + (255 * t.worldAlpha << 24);
          this.renderSession.roundPixels ? (I[g++] = v * l + x * u + _ | 0, I[g++] = w * u + b * l + T | 0, I[g++] = a.x0, I[g++] = a.y0, L[g++] = O, I[g++] = y, I[g++] = v * h + x * u + _ | 0, I[g++] = w * u + b * h + T | 0, I[g++] = a.x1, I[g++] = a.y1, L[g++] = O, I[g++] = y, I[g++] = v * h + x * c + _ | 0, I[g++] = w * c + b * h + T | 0, I[g++] = a.x2, I[g++] = a.y2, L[g++] = O, I[g++] = y, I[g++] = v * l + x * c + _ | 0, I[g++] = w * c + b * l + T | 0, I[g++] = a.x3, I[g++] = a.y3, L[g++] = O, I[g++] = y) : (I[g++] = v * l + x * u + _, I[g++] = w * u + b * l + T, I[g++] = a.x0, I[g++] = a.y0, L[g++] = O, I[g++] = y, I[g++] = v * h + x * u + _, I[g++] = w * u + b * h + T, I[g++] = a.x1, I[g++] = a.y1, L[g++] = O, I[g++] = y, I[g++] = v * h + x * c + _, I[g++] = w * c + b * h + T, I[g++] = a.x2, I[g++] = a.y2, L[g++] = O, I[g++] = y, I[g++] = v * l + x * c + _, I[g++] = w * c + b * l + T, I[g++] = a.x3, I[g++] = a.y3, L[g++] = O, I[g++] = y), this.sprites[this.currentBatchSize++] = t;
        }
      }, i.WebGLSpriteBatch.prototype.renderTilingSprite = function (t) {
        var e = t.tilingTexture,
            s = e.baseTexture,
            n = this.gl,
            o = t.texture.baseTexture.textureIndex;
        i.WebGLRenderer.textureArray[o] != s && (this.flush(), n.activeTexture(n.TEXTURE0 + o), n.bindTexture(n.TEXTURE_2D, s._glTextures[n.id]), i.WebGLRenderer.textureArray[o] = s), this.currentBatchSize >= this.size && (this.flush(), this.currentBaseTexture = e.baseTexture), t._uvs || (t._uvs = new i.TextureUvs());
        var r = t._uvs,
            a = e.baseTexture.width,
            h = e.baseTexture.height;
        t.tilePosition.x %= a * t.tileScaleOffset.x, t.tilePosition.y %= h * t.tileScaleOffset.y;
        var l = t.tilePosition.x / (a * t.tileScaleOffset.x),
            c = t.tilePosition.y / (h * t.tileScaleOffset.y),
            u = t.width / a / (t.tileScale.x * t.tileScaleOffset.x),
            d = t.height / h / (t.tileScale.y * t.tileScaleOffset.y);
        r.x0 = 0 - l, r.y0 = 0 - c, r.x1 = 1 * u - l, r.y1 = 0 - c, r.x2 = 1 * u - l, r.y2 = 1 * d - c, r.x3 = 0 - l, r.y3 = 1 * d - c;

        var p = t.tint,
            f = (p >> 16) + (65280 & p) + ((255 & p) << 16) + (255 * t.worldAlpha << 24),
            g = this.positions,
            m = this.colors,
            y = t.width,
            v = t.height,
            b = t.anchor.x,
            x = t.anchor.y,
            w = y * (1 - b),
            _ = y * -b,
            T = v * (1 - x),
            P = v * -x,
            S = this.currentBatchSize * this.vertexSize,
            C = e.baseTexture.resolution,
            A = t.worldTransform,
            E = A.a / C,
            M = A.b / C,
            R = A.c / C,
            L = A.d / C,
            I = A.tx,
            k = A.ty;

        g[S++] = E * _ + R * P + I, g[S++] = L * P + M * _ + k, g[S++] = r.x0, g[S++] = r.y0, m[S++] = f, g[S++] = o, g[S++] = E * w + R * P + I, g[S++] = L * P + M * w + k, g[S++] = r.x1, g[S++] = r.y1, m[S++] = f, g[S++] = o, g[S++] = E * w + R * T + I, g[S++] = L * T + M * w + k, g[S++] = r.x2, g[S++] = r.y2, m[S++] = f, g[S++] = o, g[S++] = E * _ + R * T + I, g[S++] = L * T + M * _ + k, g[S++] = r.x3, g[S++] = r.y3, m[S++] = f, g[S++] = o, this.sprites[this.currentBatchSize++] = t;
      }, i.WebGLSpriteBatch.prototype.flush = function () {
        if (0 !== this.currentBatchSize) {
          var t,
              e,
              s,
              n,
              o = this.gl;

          if (this.dirty) {
            this.dirty = !1, t = this.defaultShader.shaders[o.id], o.activeTexture(o.TEXTURE0), o.bindBuffer(o.ARRAY_BUFFER, this.vertexBuffer), o.bindBuffer(o.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
            var r = this.vertexSize;
            o.vertexAttribPointer(t.aVertexPosition, 2, o.FLOAT, !1, r, 0), o.vertexAttribPointer(t.aTextureCoord, 2, o.FLOAT, !1, r, 8), o.vertexAttribPointer(t.colorAttribute, 4, o.UNSIGNED_BYTE, !0, r, 16), o.vertexAttribPointer(t.aTextureIndex, 1, o.FLOAT, !1, r, 20);
          }

          if (this.currentBatchSize > .5 * this.size) o.bufferSubData(o.ARRAY_BUFFER, 0, this.vertices);else {
            o.bindBuffer(o.ARRAY_BUFFER, this.vertexBuffer);
            var a = this.positions.subarray(0, this.currentBatchSize * this.vertexSize);
            o.bufferSubData(o.ARRAY_BUFFER, 0, a);
          }

          for (var h, l = 0, c = 0, u = null, d = this.renderSession.blendModeManager.currentBlendMode, p = null, f = !1, g = !1, m = 0, y = this.currentBatchSize; m < y; m++) {
            e = (h = this.sprites[m]).tilingTexture ? h.tilingTexture.baseTexture : h.texture.baseTexture, f = d !== (s = h.blendMode), g = p !== (n = h.shader || this.defaultShader);
            var v = e.skipRender;

            if (v && h.children.length > 0 && (v = !1), (f || g) && (this.renderBatch(u, l, c), c = m, l = 0, u = e, f && (d = s, this.renderSession.blendModeManager.setBlendMode(d)), g)) {
              (t = (p = n).shaders[o.id]) || ((t = new i.PixiShader(o)).fragmentSrc = p.fragmentSrc, t.uniforms = p.uniforms, t.init(), p.shaders[o.id] = t), this.renderSession.shaderManager.setShader(t), t.dirty && t.syncUniforms();
              var b = this.renderSession.projection;
              o.uniform2f(t.projectionVector, b.x, b.y);
              var x = this.renderSession.offset;
              o.uniform2f(t.offsetVector, x.x, x.y);
            }

            l++;
          }

          this.renderBatch(u, l, c), this.currentBatchSize = 0;
        }
      }, i.WebGLSpriteBatch.prototype.renderBatch = function (t, e, i) {
        if (0 !== e) {
          var s = this.gl;

          if (t._dirty[s.id]) {
            if (!this.renderSession.renderer.updateTexture(t)) return;
          } else s.bindTexture(s.TEXTURE_2D, t._glTextures[s.id]);

          s.drawElements(s.TRIANGLES, 6 * e, s.UNSIGNED_SHORT, 6 * i * 2), this.renderSession.drawCount++;
        }
      }, i.WebGLSpriteBatch.prototype.stop = function () {
        this.flush(), this.dirty = !0;
      }, i.WebGLSpriteBatch.prototype.start = function () {
        this.dirty = !0;
      }, i.WebGLSpriteBatch.prototype.destroy = function () {
        this.vertices = null, this.indices = null, this.gl.deleteBuffer(this.vertexBuffer), this.gl.deleteBuffer(this.indexBuffer), this.currentBaseTexture = null, this.gl = null;
      }, i.WebGLFastSpriteBatch = function (t) {
        this.vertSize = 11, this.maxSize = 6e3, this.size = this.maxSize;
        var e = 4 * this.size * this.vertSize,
            i = 6 * this.maxSize;
        this.vertices = new Float32Array(e), this.indices = new Uint16Array(i), this.vertexBuffer = null, this.indexBuffer = null, this.lastIndexCount = 0;

        for (var s = 0, n = 0; s < i; s += 6, n += 4) {
          this.indices[s + 0] = n + 0, this.indices[s + 1] = n + 1, this.indices[s + 2] = n + 2, this.indices[s + 3] = n + 0, this.indices[s + 4] = n + 2, this.indices[s + 5] = n + 3;
        }

        this.drawing = !1, this.currentBatchSize = 0, this.currentBaseTexture = null, this.currentBlendMode = 0, this.renderSession = null, this.shader = null, this.matrix = null, this.setContext(t);
      }, i.WebGLFastSpriteBatch.prototype.constructor = i.WebGLFastSpriteBatch, i.WebGLFastSpriteBatch.prototype.setContext = function (t) {
        this.gl = t, this.vertexBuffer = t.createBuffer(), this.indexBuffer = t.createBuffer(), t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, this.indexBuffer), t.bufferData(t.ELEMENT_ARRAY_BUFFER, this.indices, t.STATIC_DRAW), t.bindBuffer(t.ARRAY_BUFFER, this.vertexBuffer), t.bufferData(t.ARRAY_BUFFER, this.vertices, t.DYNAMIC_DRAW);
      }, i.WebGLFastSpriteBatch.prototype.begin = function (t, e) {
        this.renderSession = e, this.shader = this.renderSession.shaderManager.fastShader, this.matrix = t.worldTransform.toArray(!0), this.start();
      }, i.WebGLFastSpriteBatch.prototype.end = function () {
        this.flush();
      }, i.WebGLFastSpriteBatch.prototype.render = function (t) {
        var e = t.children,
            i = e[0];

        if (i.texture._uvs) {
          this.currentBaseTexture = i.texture.baseTexture, i.blendMode !== this.renderSession.blendModeManager.currentBlendMode && (this.flush(), this.renderSession.blendModeManager.setBlendMode(i.blendMode));

          for (var s = 0, n = e.length; s < n; s++) {
            this.renderSprite(e[s]);
          }

          this.flush();
        }
      }, i.WebGLFastSpriteBatch.prototype.renderSprite = function (t) {
        var e = t.texture.baseTexture,
            s = this.gl,
            n = t.texture.baseTexture.textureIndex;

        if ((i.WebGLRenderer.textureArray[n] == e || !e._glTextures[s.id] || t.texture.baseTexture.skipRender || (this.flush(), s.activeTexture(s.TEXTURE0 + n), s.bindTexture(s.TEXTURE_2D, e._glTextures[s.id]), i.WebGLRenderer.textureArray[n] = e, t.texture._uvs)) && t.visible) {
          var o,
              r,
              a,
              h,
              l,
              c,
              u = this.vertices;

          if (o = t.texture._uvs, t.texture.frame.width, t.texture.frame.height, t.texture.trim) {
            var d = t.texture.trim;
            r = (a = d.x - t.anchor.x * d.width) + t.texture.crop.width, h = (l = d.y - t.anchor.y * d.height) + t.texture.crop.height;
          } else r = t.texture.frame.width * (1 - t.anchor.x), a = t.texture.frame.width * -t.anchor.x, h = t.texture.frame.height * (1 - t.anchor.y), l = t.texture.frame.height * -t.anchor.y;

          c = 4 * this.currentBatchSize * this.vertSize, u[c++] = a, u[c++] = l, u[c++] = t.position.x, u[c++] = t.position.y, u[c++] = t.scale.x, u[c++] = t.scale.y, u[c++] = t.rotation, u[c++] = o.x0, u[c++] = o.y1, u[c++] = t.alpha, u[c++] = n, u[c++] = r, u[c++] = l, u[c++] = t.position.x, u[c++] = t.position.y, u[c++] = t.scale.x, u[c++] = t.scale.y, u[c++] = t.rotation, u[c++] = o.x1, u[c++] = o.y1, u[c++] = t.alpha, u[c++] = n, u[c++] = r, u[c++] = h, u[c++] = t.position.x, u[c++] = t.position.y, u[c++] = t.scale.x, u[c++] = t.scale.y, u[c++] = t.rotation, u[c++] = o.x2, u[c++] = o.y2, u[c++] = t.alpha, u[c++] = n, u[c++] = a, u[c++] = h, u[c++] = t.position.x, u[c++] = t.position.y, u[c++] = t.scale.x, u[c++] = t.scale.y, u[c++] = t.rotation, u[c++] = o.x3, u[c++] = o.y3, u[c++] = t.alpha, u[c++] = n, this.currentBatchSize++, this.currentBatchSize >= this.size && this.flush();
        }
      }, i.WebGLFastSpriteBatch.prototype.flush = function () {
        if (0 !== this.currentBatchSize) {
          var t = this.gl;

          if (this.currentBaseTexture._glTextures[t.id]) {
            if (this.currentBatchSize > .5 * this.size) t.bufferSubData(t.ARRAY_BUFFER, 0, this.vertices);else {
              var e = this.vertices.subarray(0, 4 * this.currentBatchSize * this.vertSize);
              t.bufferSubData(t.ARRAY_BUFFER, 0, e);
            }
            t.drawElements(t.TRIANGLES, 6 * this.currentBatchSize, t.UNSIGNED_SHORT, 0), this.currentBatchSize = 0, this.renderSession.drawCount++;
          } else this.renderSession.renderer.updateTexture(this.currentBaseTexture, t);
        }
      }, i.WebGLFastSpriteBatch.prototype.stop = function () {
        this.flush();
      }, i.WebGLFastSpriteBatch.prototype.start = function () {
        var t = this.gl;
        t.activeTexture(t.TEXTURE0), t.bindBuffer(t.ARRAY_BUFFER, this.vertexBuffer), t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
        var e = this.renderSession.projection;
        t.uniform2f(this.shader.projectionVector, e.x, e.y), t.uniformMatrix3fv(this.shader.uMatrix, !1, this.matrix);
        var i = 4 * this.vertSize;
        t.vertexAttribPointer(this.shader.aVertexPosition, 2, t.FLOAT, !1, i, 0), t.vertexAttribPointer(this.shader.aPositionCoord, 2, t.FLOAT, !1, i, 8), t.vertexAttribPointer(this.shader.aScale, 2, t.FLOAT, !1, i, 16), t.vertexAttribPointer(this.shader.aRotation, 1, t.FLOAT, !1, i, 24), t.vertexAttribPointer(this.shader.aTextureCoord, 2, t.FLOAT, !1, i, 28), t.vertexAttribPointer(this.shader.colorAttribute, 1, t.FLOAT, !1, i, 36), t.vertexAttribPointer(this.shader.aTextureIndex, 1, t.FLOAT, !1, i, 40);
      }, i.WebGLFilterManager = function () {
        this.filterStack = [], this.offsetX = 0, this.offsetY = 0;
      }, i.WebGLFilterManager.prototype.constructor = i.WebGLFilterManager, i.WebGLFilterManager.prototype.setContext = function (t) {
        this.gl = t, this.texturePool = [], this.initShaderBuffers();
      }, i.WebGLFilterManager.prototype.begin = function (t, e) {
        this.renderSession = t, this.defaultShader = t.shaderManager.defaultShader;
        var i = this.renderSession.projection;
        this.width = 2 * i.x, this.height = 2 * -i.y, this.buffer = e;
      }, i.WebGLFilterManager.prototype.pushFilter = function (t) {
        var e = this.gl,
            s = this.renderSession.projection,
            n = this.renderSession.offset;
        t._filterArea = t.target.filterArea || t.target.getBounds(), t._previous_stencil_mgr = this.renderSession.stencilManager, this.renderSession.stencilManager = new i.WebGLStencilManager(), this.renderSession.stencilManager.setContext(e), e.disable(e.STENCIL_TEST), this.filterStack.push(t);
        var o = t.filterPasses[0];
        this.offsetX += t._filterArea.x, this.offsetY += t._filterArea.y;
        var r = this.texturePool.pop();
        r ? r.resize(this.width * this.renderSession.resolution, this.height * this.renderSession.resolution) : r = new i.FilterTexture(this.gl, this.width * this.renderSession.resolution, this.height * this.renderSession.resolution), e.bindTexture(e.TEXTURE_2D, r.texture);
        var a = t._filterArea,
            h = o.padding;
        a.x -= h, a.y -= h, a.width += 2 * h, a.height += 2 * h, a.x < 0 && (a.x = 0), a.width > this.width && (a.width = this.width), a.y < 0 && (a.y = 0), a.height > this.height && (a.height = this.height), e.bindFramebuffer(e.FRAMEBUFFER, r.frameBuffer), e.viewport(0, 0, a.width * this.renderSession.resolution, a.height * this.renderSession.resolution), s.x = a.width / 2, s.y = -a.height / 2, n.x = -a.x, n.y = -a.y, e.colorMask(!0, !0, !0, !0), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT), t._glFilterTexture = r;
      }, i.WebGLFilterManager.prototype.popFilter = function () {
        var t = this.gl,
            e = this.filterStack.pop(),
            s = e._filterArea,
            n = e._glFilterTexture,
            o = this.renderSession.projection,
            r = this.renderSession.offset;

        if (e.filterPasses.length > 1) {
          t.viewport(0, 0, s.width * this.renderSession.resolution, s.height * this.renderSession.resolution), t.bindBuffer(t.ARRAY_BUFFER, this.vertexBuffer), this.vertexArray[0] = 0, this.vertexArray[1] = s.height, this.vertexArray[2] = s.width, this.vertexArray[3] = s.height, this.vertexArray[4] = 0, this.vertexArray[5] = 0, this.vertexArray[6] = s.width, this.vertexArray[7] = 0, t.bufferSubData(t.ARRAY_BUFFER, 0, this.vertexArray), t.bindBuffer(t.ARRAY_BUFFER, this.uvBuffer), this.uvArray[2] = s.width / this.width, this.uvArray[5] = s.height / this.height, this.uvArray[6] = s.width / this.width, this.uvArray[7] = s.height / this.height, t.bufferSubData(t.ARRAY_BUFFER, 0, this.uvArray);
          var a = n,
              h = this.texturePool.pop();
          h || (h = new i.FilterTexture(this.gl, this.width * this.renderSession.resolution, this.height * this.renderSession.resolution)), h.resize(this.width * this.renderSession.resolution, this.height * this.renderSession.resolution), t.bindFramebuffer(t.FRAMEBUFFER, h.frameBuffer), t.clear(t.COLOR_BUFFER_BIT), t.disable(t.BLEND);

          for (var l = 0; l < e.filterPasses.length - 1; l++) {
            var c = e.filterPasses[l];
            t.bindFramebuffer(t.FRAMEBUFFER, h.frameBuffer), t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, a.texture), this.applyFilterPass(c, s, s.width, s.height);
            var u = a;
            a = h, h = u;
          }

          t.enable(t.BLEND), n = a, this.texturePool.push(h);
        }

        var d = e.filterPasses[e.filterPasses.length - 1];
        this.offsetX -= s.x, this.offsetY -= s.y;
        var p = this.width,
            f = this.height,
            g = 0,
            m = 0,
            y = this.buffer;
        if (0 === this.filterStack.length) t.colorMask(!0, !0, !0, !0);else {
          var v = this.filterStack[this.filterStack.length - 1];
          p = (s = v._filterArea).width, f = s.height, g = s.x, m = s.y, y = v._glFilterTexture.frameBuffer;
        }
        o.x = p / 2, o.y = -f / 2, r.x = g, r.y = m;
        var b = (s = e._filterArea).x - g,
            x = s.y - m;
        t.bindBuffer(t.ARRAY_BUFFER, this.vertexBuffer), this.vertexArray[0] = b, this.vertexArray[1] = x + s.height, this.vertexArray[2] = b + s.width, this.vertexArray[3] = x + s.height, this.vertexArray[4] = b, this.vertexArray[5] = x, this.vertexArray[6] = b + s.width, this.vertexArray[7] = x, t.bufferSubData(t.ARRAY_BUFFER, 0, this.vertexArray), t.bindBuffer(t.ARRAY_BUFFER, this.uvBuffer), this.uvArray[2] = s.width / this.width, this.uvArray[5] = s.height / this.height, this.uvArray[6] = s.width / this.width, this.uvArray[7] = s.height / this.height, t.bufferSubData(t.ARRAY_BUFFER, 0, this.uvArray), t.viewport(0, 0, p * this.renderSession.resolution, f * this.renderSession.resolution), t.bindFramebuffer(t.FRAMEBUFFER, y), t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, n.texture), this.renderSession.stencilManager && this.renderSession.stencilManager.destroy(), this.renderSession.stencilManager = e._previous_stencil_mgr, e._previous_stencil_mgr = null, this.renderSession.stencilManager.count > 0 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.applyFilterPass(d, s, p, f), this.texturePool.push(n), e._glFilterTexture = null;
      }, i.WebGLFilterManager.prototype.applyFilterPass = function (t, e, s, n) {
        var o = this.gl,
            r = t.shaders[o.id];
        r || ((r = new i.PixiShader(o)).fragmentSrc = t.fragmentSrc, r.uniforms = t.uniforms, r.init(!0), t.shaders[o.id] = r), this.renderSession.shaderManager.setShader(r), o.uniform2f(r.projectionVector, s / 2, -n / 2), o.uniform2f(r.offsetVector, 0, 0), t.uniforms.dimensions && (t.uniforms.dimensions.value[0] = this.width, t.uniforms.dimensions.value[1] = this.height, t.uniforms.dimensions.value[2] = this.vertexArray[0], t.uniforms.dimensions.value[3] = this.vertexArray[5]), r.syncUniforms(), o.bindBuffer(o.ARRAY_BUFFER, this.vertexBuffer), o.vertexAttribPointer(r.aVertexPosition, 2, o.FLOAT, !1, 0, 0), o.bindBuffer(o.ARRAY_BUFFER, this.uvBuffer), o.vertexAttribPointer(r.aTextureCoord, 2, o.FLOAT, !1, 0, 0), o.bindBuffer(o.ARRAY_BUFFER, this.colorBuffer), o.vertexAttribPointer(r.colorAttribute, 2, o.FLOAT, !1, 0, 0), o.bindBuffer(o.ELEMENT_ARRAY_BUFFER, this.indexBuffer), o.drawElements(o.TRIANGLES, 6, o.UNSIGNED_SHORT, 0), this.renderSession.drawCount++;
      }, i.WebGLFilterManager.prototype.initShaderBuffers = function () {
        var t = this.gl;
        this.vertexBuffer = t.createBuffer(), this.uvBuffer = t.createBuffer(), this.colorBuffer = t.createBuffer(), this.indexBuffer = t.createBuffer(), this.vertexArray = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]), t.bindBuffer(t.ARRAY_BUFFER, this.vertexBuffer), t.bufferData(t.ARRAY_BUFFER, this.vertexArray, t.STATIC_DRAW), this.uvArray = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]), t.bindBuffer(t.ARRAY_BUFFER, this.uvBuffer), t.bufferData(t.ARRAY_BUFFER, this.uvArray, t.STATIC_DRAW), this.colorArray = new Float32Array([1, 16777215, 1, 16777215, 1, 16777215, 1, 16777215]), t.bindBuffer(t.ARRAY_BUFFER, this.colorBuffer), t.bufferData(t.ARRAY_BUFFER, this.colorArray, t.STATIC_DRAW), t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, this.indexBuffer), t.bufferData(t.ELEMENT_ARRAY_BUFFER, new Uint16Array([0, 1, 2, 1, 3, 2]), t.STATIC_DRAW);
      }, i.WebGLFilterManager.prototype.destroy = function () {
        var t = this.gl;
        this.filterStack = null, this.offsetX = 0, this.offsetY = 0;

        for (var e = 0; e < this.texturePool.length; e++) {
          this.texturePool[e].destroy();
        }

        this.texturePool = null, t.deleteBuffer(this.vertexBuffer), t.deleteBuffer(this.uvBuffer), t.deleteBuffer(this.colorBuffer), t.deleteBuffer(this.indexBuffer);
      };
      var s = {
        36054: "Incomplete attachment",
        36055: "Missing attachment",
        36057: "Incomplete dimensions",
        36061: "Framebuffer unsupported"
      };

      function n(t, e, n, o, r) {
        var a,
            h,
            l = t.createFramebuffer(),
            c = t.createRenderbuffer();
        return t.activeTexture(t.TEXTURE0 + r), t.bindFramebuffer(t.FRAMEBUFFER, l), t.bindRenderbuffer(t.RENDERBUFFER, c), t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, this.renderBuffer), a = function (t, e, s, n) {
          var o = t.createTexture();
          return t.bindTexture(t.TEXTURE_2D, o), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, n === i.scaleModes.LINEAR ? t.LINEAR : t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, n === i.scaleModes.LINEAR ? t.LINEAR : t.NEAREST), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, e, s, 0, t.RGBA, t.UNSIGNED_BYTE, null), o;
        }(t, e, n, o), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, a, 0), (h = t.checkFramebufferStatus(t.FRAMEBUFFER)) !== t.FRAMEBUFFER_COMPLETE && console.error("Incomplete GL framebuffer. ", s[h]), l.width = e, l.height = n, l.targetTexture = a, l.renderBuffer = c, l;
      }

      return i.FilterTexture = function (t, e, s, o, r) {
        r = "number" == typeof r ? r : 0, this.gl = t, this.frameBuffer = n(t, e, s, o || i.scaleModes.DEFAULT, r), this.texture = this.frameBuffer.targetTexture, this.width = e, this.height = s, this.renderBuffer = this.frameBuffer.renderBuffer;
      }, i.FilterTexture.prototype.constructor = i.FilterTexture, i.FilterTexture.prototype.clear = function () {
        var t = this.gl;
        t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT);
      }, i.FilterTexture.prototype.resize = function (t, e) {
        if (this.width !== t || this.height !== e) {
          this.width = t, this.height = e;
          var i = this.gl;
          i.bindTexture(i.TEXTURE_2D, this.texture), i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, t, e, 0, i.RGBA, i.UNSIGNED_BYTE, null), i.bindRenderbuffer(i.RENDERBUFFER, this.renderBuffer), i.renderbufferStorage(i.RENDERBUFFER, i.DEPTH_STENCIL, t, e);
        }
      }, i.FilterTexture.prototype.destroy = function () {
        var t = this.gl;
        t.deleteFramebuffer(this.frameBuffer), t.deleteTexture(this.texture), this.frameBuffer = null, this.texture = null;
      }, i.CanvasBuffer = function (t, e) {
        this.width = t, this.height = e, this.canvas = Phaser.CanvasPool.create(this, this.width, this.height), this.context = this.canvas.getContext("2d"), this.canvas.width = t, this.canvas.height = e;
      }, i.CanvasBuffer.prototype.constructor = i.CanvasBuffer, i.CanvasBuffer.prototype.clear = function () {
        this.context.setTransform(1, 0, 0, 1, 0, 0), this.context.clearRect(0, 0, this.width, this.height);
      }, i.CanvasBuffer.prototype.resize = function (t, e) {
        this.width = this.canvas.width = t, this.height = this.canvas.height = e;
      }, i.CanvasBuffer.prototype.destroy = function () {
        Phaser.CanvasPool.remove(this);
      }, i.CanvasMaskManager = function () {}, i.CanvasMaskManager.prototype.constructor = i.CanvasMaskManager, i.CanvasMaskManager.prototype.pushMask = function (t, e) {
        var s = e.context;
        s.save();
        var n = t.alpha,
            o = t.worldTransform,
            r = e.resolution;
        s.setTransform(o.a * r, o.b * r, o.c * r, o.d * r, o.tx * r, o.ty * r), i.CanvasGraphics.renderGraphicsMask(t, s), s.clip(), t.worldAlpha = n;
      }, i.CanvasMaskManager.prototype.popMask = function (t) {
        t.context.restore();
      }, i.CanvasTinter = function () {}, i.CanvasTinter.getTintedTexture = function (t, e) {
        var s = t.tintedTexture || Phaser.CanvasPool.create(this);
        return i.CanvasTinter.tintMethod(t.texture, e, s), s;
      }, i.CanvasTinter.tintWithMultiply = function (t, e, i) {
        var s = i.getContext("2d"),
            n = t.crop,
            o = n.width,
            r = n.height;
        t.rotated && (o = r, r = n.width), i.width === o && i.height === r || (i.width = o, i.height = r), s.clearRect(0, 0, o, r), s.fillStyle = "#" + ("00000" + (0 | e).toString(16)).substr(-6), s.fillRect(0, 0, o, r), s.globalCompositeOperation = "multiply", s.drawImage(t.baseTexture.source, n.x, n.y, o, r, 0, 0, o, r), s.globalCompositeOperation = "destination-atop", s.drawImage(t.baseTexture.source, n.x, n.y, o, r, 0, 0, o, r);
      }, i.CanvasTinter.tintWithPerPixel = function (t, e, s) {
        var n = s.getContext("2d"),
            o = t.crop,
            r = o.width,
            a = o.height;
        t.rotated && (r = a, a = o.width), s.width === r && s.height === a || (s.width = r, s.height = a), n.globalCompositeOperation = "copy", n.drawImage(t.baseTexture.source, o.x, o.y, r, a, 0, 0, r, a);

        for (var h = Phaser.Color.hexToRGBArray(e), l = h[0], c = h[1], u = h[2], d = n.getImageData(0, 0, r, a), p = d.data, f = 0; f < p.length; f += 4) {
          if (p[f + 0] *= l, p[f + 1] *= c, p[f + 2] *= u, !i.CanvasTinter.canHandleAlpha) {
            var g = p[f + 3];
            p[f + 0] /= 255 / g, p[f + 1] /= 255 / g, p[f + 2] /= 255 / g;
          }
        }

        n.putImageData(d, 0, 0);
      }, i.CanvasRenderer = function (t, e) {
        if (this.game = t, i.defaultRenderer || (i.defaultRenderer = this), this.type = Phaser.CANVAS, this.resolution = t.resolution, this.clearBeforeRender = t.clearBeforeRender, this.transparent = t.transparent, this.autoResize = !1, this.width = t.width * this.resolution, this.height = t.height * this.resolution, this.view = t.canvas, this.context = this.view.getContext("2d", {
          alpha: this.transparent
        }), !this.context) throw new Error("Failed to create a Canvas 2d context.");
        this.refresh = !0, this.count = 0, this.maskManager = new i.CanvasMaskManager(), this.renderSession = {
          context: this.context,
          maskManager: this.maskManager,
          scaleMode: null,
          smoothProperty: Phaser.Canvas.getSmoothingPrefix(this.context),
          roundPixels: e.roundPixels || !1
        }, this.mapBlendModes(), this.resize(this.width, this.height);
      }, i.CanvasRenderer.prototype.constructor = i.CanvasRenderer, i.CanvasRenderer.prototype.render = function (t) {
        this.context.setTransform(1, 0, 0, 1, 0, 0), this.context.globalAlpha = 1, this.renderSession.currentBlendMode = 0, this.renderSession.shakeX = this.game.camera._shake.x, this.renderSession.shakeY = this.game.camera._shake.y, this.context.globalCompositeOperation = "source-over", navigator.isCocoonJS && this.view.screencanvas && (this.context.fillStyle = "black", this.context.clear()), this.clearBeforeRender && (this.transparent ? this.context.clearRect(0, 0, this.width, this.height) : t._bgColor && (this.context.fillStyle = t._bgColor.rgba, this.context.fillRect(0, 0, this.width, this.height))), this.renderDisplayObject(t);
      }, i.CanvasRenderer.prototype.setTexturePriority = function (t) {}, i.CanvasRenderer.prototype.destroy = function (t) {
        void 0 === t && (t = !0), t && this.view.parent && this.view.parent.removeChild(this.view), this.view = null, this.context = null, this.maskManager = null, this.renderSession = null;
      }, i.CanvasRenderer.prototype.resize = function (t, e) {
        this.width = t * this.resolution, this.height = e * this.resolution, this.view.width = this.width, this.view.height = this.height, this.autoResize && (this.view.style.width = this.width / this.resolution + "px", this.view.style.height = this.height / this.resolution + "px"), this.renderSession.smoothProperty && (this.context[this.renderSession.smoothProperty] = this.renderSession.scaleMode === i.scaleModes.LINEAR);
      }, i.CanvasRenderer.prototype.renderDisplayObject = function (t, e, i) {
        this.renderSession.context = e || this.context, this.renderSession.resolution = this.resolution, t._renderCanvas(this.renderSession, i);
      }, i.CanvasRenderer.prototype.mapBlendModes = function () {
        if (!i.blendModesCanvas) {
          var t = [],
              e = i.blendModes,
              s = this.game.device.canUseMultiply;
          t[e.NORMAL] = "source-over", t[e.ADD] = "lighter", t[e.MULTIPLY] = s ? "multiply" : "source-over", t[e.SCREEN] = s ? "screen" : "source-over", t[e.OVERLAY] = s ? "overlay" : "source-over", t[e.DARKEN] = s ? "darken" : "source-over", t[e.LIGHTEN] = s ? "lighten" : "source-over", t[e.COLOR_DODGE] = s ? "color-dodge" : "source-over", t[e.COLOR_BURN] = s ? "color-burn" : "source-over", t[e.HARD_LIGHT] = s ? "hard-light" : "source-over", t[e.SOFT_LIGHT] = s ? "soft-light" : "source-over", t[e.DIFFERENCE] = s ? "difference" : "source-over", t[e.EXCLUSION] = s ? "exclusion" : "source-over", t[e.HUE] = s ? "hue" : "source-over", t[e.SATURATION] = s ? "saturation" : "source-over", t[e.COLOR] = s ? "color" : "source-over", t[e.LUMINOSITY] = s ? "luminosity" : "source-over", i.blendModesCanvas = t;
        }
      }, i.BaseTexture = function (t, e, s) {
        this.resolution = s || 1, this.width = 100, this.height = 100, this.scaleMode = e || i.scaleModes.DEFAULT, this.hasLoaded = !1, this.source = t, this.premultipliedAlpha = !0, this._glTextures = [], this.mipmap = !1, this.textureIndex = 0, this._dirty = [!0, !0, !0, !0], t && ((this.source.complete || this.source.getContext) && this.source.width && this.source.height && (this.hasLoaded = !0, this.width = this.source.naturalWidth || this.source.width, this.height = this.source.naturalHeight || this.source.height, this.dirty()), this.skipRender = !1, this._powerOf2 = !1);
      }, i.BaseTexture.prototype.constructor = i.BaseTexture, i.BaseTexture.prototype.forceLoaded = function (t, e) {
        this.hasLoaded = !0, this.width = t, this.height = e, this.dirty();
      }, i.BaseTexture.prototype.destroy = function () {
        this.source && Phaser.CanvasPool.removeByCanvas(this.source), this.source = null, this.unloadFromGPU();
      }, i.BaseTexture.prototype.dirty = function () {
        for (var t = 0; t < this._glTextures.length; t++) {
          this._dirty[t] = !0;
        }
      }, i.BaseTexture.prototype.unloadFromGPU = function () {
        this.dirty();

        for (var t = this._glTextures.length - 1; t >= 0; t--) {
          var e = this._glTextures[t],
              s = i.glContexts[t];
          s && e && s.deleteTexture(e);
        }

        this._glTextures.length = 0, this.dirty();
      }, i.BaseTexture.fromCanvas = function (t, e, s) {
        return 0 === t.width && (t.width = 1), 0 === t.height && (t.height = 1), s = s || 1, new i.BaseTexture(t, e, s);
      }, i.TextureSilentFail = !1, i.Texture = function (t, e, s, n) {
        this.noFrame = !1, e || (this.noFrame = !0, e = new i.Rectangle(0, 0, 1, 1)), t instanceof i.Texture && (t = t.baseTexture), this.baseTexture = t, this.frame = e, this.trim = n, this.valid = !1, this.isTiling = !1, this.requiresUpdate = !1, this.requiresReTint = !1, this._uvs = null, this.width = 0, this.height = 0, this.crop = s || new i.Rectangle(0, 0, 1, 1), this.rotated = !1, t.hasLoaded && (this.noFrame && (e = new i.Rectangle(0, 0, t.width, t.height)), this.setFrame(e));
      }, i.Texture.prototype.constructor = i.Texture, i.Texture.prototype.onBaseTextureLoaded = function () {
        var t = this.baseTexture;
        this.noFrame && (this.frame = new i.Rectangle(0, 0, t.width, t.height)), this.setFrame(this.frame);
      }, i.Texture.prototype.destroy = function (t) {
        t && this.baseTexture.destroy(), this.valid = !1;
      }, i.Texture.prototype.setFrame = function (t) {
        if (this.noFrame = !1, this.frame = t, this.width = t.width, this.height = t.height, this.crop.x = t.x, this.crop.y = t.y, this.crop.width = t.width, this.crop.height = t.height, this.trim || !(t.x + t.width > this.baseTexture.width || t.y + t.height > this.baseTexture.height)) this.valid = t && t.width && t.height && this.baseTexture.source && this.baseTexture.hasLoaded, this.trim && (this.width = this.trim.width, this.height = this.trim.height, this.frame.width = this.trim.width, this.frame.height = this.trim.height), this.valid && this._updateUvs();else {
          if (!i.TextureSilentFail) throw new Error("Texture Error: frame does not fit inside the base Texture dimensions " + this);
          this.valid = !1;
        }
      }, i.Texture.prototype._updateUvs = function () {
        this._uvs || (this._uvs = new i.TextureUvs());
        var t = this.crop,
            e = this.baseTexture.width,
            s = this.baseTexture.height;
        this._uvs.x0 = t.x / e, this._uvs.y0 = t.y / s, this._uvs.x1 = (t.x + t.width) / e, this._uvs.y1 = t.y / s, this._uvs.x2 = (t.x + t.width) / e, this._uvs.y2 = (t.y + t.height) / s, this._uvs.x3 = t.x / e, this._uvs.y3 = (t.y + t.height) / s;
      }, i.Texture.prototype._updateUvsInverted = function () {
        this._uvs || (this._uvs = new i.TextureUvs());
        var t = this.crop,
            e = this.baseTexture.width,
            s = this.baseTexture.height;
        this._uvs.x0 = t.x / e, this._uvs.y0 = t.y / s, this._uvs.x1 = (t.x + t.height) / e, this._uvs.y1 = t.y / s, this._uvs.x2 = (t.x + t.height) / e, this._uvs.y2 = (t.y + t.width) / s, this._uvs.x3 = t.x / e, this._uvs.y3 = (t.y + t.width) / s;
      }, i.Texture.fromCanvas = function (t, e) {
        var s = i.BaseTexture.fromCanvas(t, e);
        return new i.Texture(s);
      }, i.TextureUvs = function () {
        this.x0 = 0, this.y0 = 0, this.x1 = 0, this.y1 = 0, this.x2 = 0, this.y2 = 0, this.x3 = 0, this.y3 = 0;
      }, void 0 !== t && t.exports && (e = t.exports = i), e.PIXI = i, i;
    }).call(this);
  }, function (t, e, i) {
    (function (e) {
      t.exports = e.p2 = i(5);
    }).call(this, i(0));
  }, function (t, e, i) {
    var s;

    t.exports = function t(e, i, n) {
      function o(a, h) {
        if (!i[a]) {
          if (!e[a]) {
            var l = "function" == typeof s && s;
            if (!h && l) return s(a, !0);
            if (r) return r(a, !0);
            throw new Error("Cannot find module '" + a + "'");
          }

          var c = i[a] = {
            exports: {}
          };
          e[a][0].call(c.exports, function (t) {
            var i = e[a][1][t];
            return o(i || t);
          }, c, c.exports, t, e, i, n);
        }

        return i[a].exports;
      }

      for (var r = "function" == typeof s && s, a = 0; a < n.length; a++) {
        o(n[a]);
      }

      return o;
    }({
      1: [function (t, e, i) {
        var s = t("./Scalar");

        function n() {}

        e.exports = n, n.lineInt = function (t, e, i) {
          i = i || 0;
          var n,
              o,
              r,
              a,
              h,
              l,
              c,
              u = [0, 0];
          return n = t[1][1] - t[0][1], o = t[0][0] - t[1][0], r = n * t[0][0] + o * t[0][1], a = e[1][1] - e[0][1], h = e[0][0] - e[1][0], l = a * e[0][0] + h * e[0][1], c = n * h - a * o, s.eq(c, 0, i) || (u[0] = (h * r - o * l) / c, u[1] = (n * l - a * r) / c), u;
        }, n.segmentsIntersect = function (t, e, i, s) {
          var n = e[0] - t[0],
              o = e[1] - t[1],
              r = s[0] - i[0],
              a = s[1] - i[1];
          if (r * o - a * n == 0) return !1;
          var h = (n * (i[1] - t[1]) + o * (t[0] - i[0])) / (r * o - a * n),
              l = (r * (t[1] - i[1]) + a * (i[0] - t[0])) / (a * n - r * o);
          return h >= 0 && h <= 1 && l >= 0 && l <= 1;
        };
      }, {
        "./Scalar": 4
      }],
      2: [function (t, e, i) {
        function s() {}

        e.exports = s, s.area = function (t, e, i) {
          return (e[0] - t[0]) * (i[1] - t[1]) - (i[0] - t[0]) * (e[1] - t[1]);
        }, s.left = function (t, e, i) {
          return s.area(t, e, i) > 0;
        }, s.leftOn = function (t, e, i) {
          return s.area(t, e, i) >= 0;
        }, s.right = function (t, e, i) {
          return s.area(t, e, i) < 0;
        }, s.rightOn = function (t, e, i) {
          return s.area(t, e, i) <= 0;
        };
        var n = [],
            o = [];
        s.collinear = function (t, e, i, r) {
          if (r) {
            var a = n,
                h = o;
            a[0] = e[0] - t[0], a[1] = e[1] - t[1], h[0] = i[0] - e[0], h[1] = i[1] - e[1];
            var l = a[0] * h[0] + a[1] * h[1],
                c = Math.sqrt(a[0] * a[0] + a[1] * a[1]),
                u = Math.sqrt(h[0] * h[0] + h[1] * h[1]),
                d = Math.acos(l / (c * u));
            return d < r;
          }

          return 0 == s.area(t, e, i);
        }, s.sqdist = function (t, e) {
          var i = e[0] - t[0],
              s = e[1] - t[1];
          return i * i + s * s;
        };
      }, {}],
      3: [function (t, e, i) {
        var s = t("./Line"),
            n = t("./Point"),
            o = t("./Scalar");

        function r() {
          this.vertices = [];
        }

        e.exports = r, r.prototype.at = function (t) {
          var e = this.vertices,
              i = e.length;
          return e[t < 0 ? t % i + i : t % i];
        }, r.prototype.first = function () {
          return this.vertices[0];
        }, r.prototype.last = function () {
          return this.vertices[this.vertices.length - 1];
        }, r.prototype.clear = function () {
          this.vertices.length = 0;
        }, r.prototype.append = function (t, e, i) {
          if (void 0 === e) throw new Error("From is not given!");
          if (void 0 === i) throw new Error("To is not given!");
          if (i - 1 < e) throw new Error("lol1");
          if (i > t.vertices.length) throw new Error("lol2");
          if (e < 0) throw new Error("lol3");

          for (var s = e; s < i; s++) {
            this.vertices.push(t.vertices[s]);
          }
        }, r.prototype.makeCCW = function () {
          for (var t = 0, e = this.vertices, i = 1; i < this.vertices.length; ++i) {
            (e[i][1] < e[t][1] || e[i][1] == e[t][1] && e[i][0] > e[t][0]) && (t = i);
          }

          n.left(this.at(t - 1), this.at(t), this.at(t + 1)) || this.reverse();
        }, r.prototype.reverse = function () {
          for (var t = [], e = 0, i = this.vertices.length; e !== i; e++) {
            t.push(this.vertices.pop());
          }

          this.vertices = t;
        }, r.prototype.isReflex = function (t) {
          return n.right(this.at(t - 1), this.at(t), this.at(t + 1));
        };
        var a = [],
            h = [];

        function l(t, e, i, s, n) {
          n = n || 0;
          var r = e[1] - t[1],
              a = t[0] - e[0],
              h = r * t[0] + a * t[1],
              l = s[1] - i[1],
              c = i[0] - s[0],
              u = l * i[0] + c * i[1],
              d = r * c - l * a;
          return o.eq(d, 0, n) ? [0, 0] : [(c * h - a * u) / d, (r * u - l * h) / d];
        }

        r.prototype.canSee = function (t, e) {
          var i,
              o,
              r = a,
              l = h;
          if (n.leftOn(this.at(t + 1), this.at(t), this.at(e)) && n.rightOn(this.at(t - 1), this.at(t), this.at(e))) return !1;
          o = n.sqdist(this.at(t), this.at(e));

          for (var c = 0; c !== this.vertices.length; ++c) {
            if ((c + 1) % this.vertices.length !== t && c !== t && n.leftOn(this.at(t), this.at(e), this.at(c + 1)) && n.rightOn(this.at(t), this.at(e), this.at(c)) && (r[0] = this.at(t), r[1] = this.at(e), l[0] = this.at(c), l[1] = this.at(c + 1), i = s.lineInt(r, l), n.sqdist(this.at(t), i) < o)) return !1;
          }

          return !0;
        }, r.prototype.copy = function (t, e, i) {
          var s = i || new r();
          if (s.clear(), t < e) for (var n = t; n <= e; n++) {
            s.vertices.push(this.vertices[n]);
          } else {
            for (var n = 0; n <= e; n++) {
              s.vertices.push(this.vertices[n]);
            }

            for (var n = t; n < this.vertices.length; n++) {
              s.vertices.push(this.vertices[n]);
            }
          }
          return s;
        }, r.prototype.getCutEdges = function () {
          for (var t = [], e = [], i = [], s = new r(), n = Number.MAX_VALUE, o = 0; o < this.vertices.length; ++o) {
            if (this.isReflex(o)) for (var a = 0; a < this.vertices.length; ++a) {
              if (this.canSee(o, a)) {
                e = this.copy(o, a, s).getCutEdges(), i = this.copy(a, o, s).getCutEdges();

                for (var h = 0; h < i.length; h++) {
                  e.push(i[h]);
                }

                e.length < n && (t = e, n = e.length, t.push([this.at(o), this.at(a)]));
              }
            }
          }

          return t;
        }, r.prototype.decomp = function () {
          var t = this.getCutEdges();
          return t.length > 0 ? this.slice(t) : [this];
        }, r.prototype.slice = function (t) {
          if (0 == t.length) return [this];

          if (t instanceof Array && t.length && t[0] instanceof Array && 2 == t[0].length && t[0][0] instanceof Array) {
            for (var e = [this], i = 0; i < t.length; i++) {
              for (var s = t[i], n = 0; n < e.length; n++) {
                var o = e[n],
                    r = o.slice(s);

                if (r) {
                  e.splice(n, 1), e.push(r[0], r[1]);
                  break;
                }
              }
            }

            return e;
          }

          var s = t,
              i = this.vertices.indexOf(s[0]),
              n = this.vertices.indexOf(s[1]);
          return -1 != i && -1 != n && [this.copy(i, n), this.copy(n, i)];
        }, r.prototype.isSimple = function () {
          for (var t = this.vertices, e = 0; e < t.length - 1; e++) {
            for (var i = 0; i < e - 1; i++) {
              if (s.segmentsIntersect(t[e], t[e + 1], t[i], t[i + 1])) return !1;
            }
          }

          for (var e = 1; e < t.length - 2; e++) {
            if (s.segmentsIntersect(t[0], t[t.length - 1], t[e], t[e + 1])) return !1;
          }

          return !0;
        }, r.prototype.quickDecomp = function (t, e, i, s, o, a) {
          o = o || 100, a = a || 0, s = s || 25, t = void 0 !== t ? t : [], e = e || [], i = i || [];
          var h = [0, 0],
              c = [0, 0],
              u = [0, 0],
              d = 0,
              p = 0,
              f = 0,
              g = 0,
              m = 0,
              y = 0,
              v = 0,
              b = new r(),
              x = new r(),
              w = this.vertices;
          if (w.length < 3) return t;
          if (++a > o) return console.warn("quickDecomp: max level (" + o + ") reached."), t;

          for (var _ = 0; _ < this.vertices.length; ++_) {
            if (this.isReflex(_)) {
              e.push(this.vertices[_]), d = p = Number.MAX_VALUE;

              for (var T = 0; T < this.vertices.length; ++T) {
                n.left(this.at(_ - 1), this.at(_), this.at(T)) && n.rightOn(this.at(_ - 1), this.at(_), this.at(T - 1)) && (u = l(this.at(_ - 1), this.at(_), this.at(T), this.at(T - 1)), n.right(this.at(_ + 1), this.at(_), u) && (f = n.sqdist(this.vertices[_], u)) < p && (p = f, c = u, y = T)), n.left(this.at(_ + 1), this.at(_), this.at(T + 1)) && n.rightOn(this.at(_ + 1), this.at(_), this.at(T)) && (u = l(this.at(_ + 1), this.at(_), this.at(T), this.at(T + 1)), n.left(this.at(_ - 1), this.at(_), u) && (f = n.sqdist(this.vertices[_], u)) < d && (d = f, h = u, m = T));
              }

              if (y == (m + 1) % this.vertices.length) u[0] = (c[0] + h[0]) / 2, u[1] = (c[1] + h[1]) / 2, i.push(u), _ < m ? (b.append(this, _, m + 1), b.vertices.push(u), x.vertices.push(u), 0 != y && x.append(this, y, this.vertices.length), x.append(this, 0, _ + 1)) : (0 != _ && b.append(this, _, this.vertices.length), b.append(this, 0, m + 1), b.vertices.push(u), x.vertices.push(u), x.append(this, y, _ + 1));else {
                if (y > m && (m += this.vertices.length), g = Number.MAX_VALUE, m < y) return t;

                for (var T = y; T <= m; ++T) {
                  n.leftOn(this.at(_ - 1), this.at(_), this.at(T)) && n.rightOn(this.at(_ + 1), this.at(_), this.at(T)) && (f = n.sqdist(this.at(_), this.at(T))) < g && (g = f, v = T % this.vertices.length);
                }

                _ < v ? (b.append(this, _, v + 1), 0 != v && x.append(this, v, w.length), x.append(this, 0, _ + 1)) : (0 != _ && b.append(this, _, w.length), b.append(this, 0, v + 1), x.append(this, v, _ + 1));
              }
              return b.vertices.length < x.vertices.length ? (b.quickDecomp(t, e, i, s, o, a), x.quickDecomp(t, e, i, s, o, a)) : (x.quickDecomp(t, e, i, s, o, a), b.quickDecomp(t, e, i, s, o, a)), t;
            }
          }

          return t.push(this), t;
        }, r.prototype.removeCollinearPoints = function (t) {
          for (var e = 0, i = this.vertices.length - 1; this.vertices.length > 3 && i >= 0; --i) {
            n.collinear(this.at(i - 1), this.at(i), this.at(i + 1), t) && (this.vertices.splice(i % this.vertices.length, 1), i--, e++);
          }

          return e;
        };
      }, {
        "./Line": 1,
        "./Point": 2,
        "./Scalar": 4
      }],
      4: [function (t, e, i) {
        function s() {}

        e.exports = s, s.eq = function (t, e, i) {
          return i = i || 0, Math.abs(t - e) < i;
        };
      }, {}],
      5: [function (t, e, i) {
        e.exports = {
          Polygon: t("./Polygon"),
          Point: t("./Point")
        };
      }, {
        "./Point": 2,
        "./Polygon": 3
      }],
      6: [function (t, e, i) {
        e.exports = {
          name: "p2",
          version: "0.7.1",
          description: "A JavaScript 2D physics engine.",
          author: "Stefan Hedman <schteppe@gmail.com> (http://steffe.se)",
          keywords: ["p2.js", "p2", "physics", "engine", "2d"],
          main: "./src/p2.js",
          engines: {
            node: "*"
          },
          repository: {
            type: "git",
            url: "https://github.com/schteppe/p2.js.git"
          },
          bugs: {
            url: "https://github.com/schteppe/p2.js/issues"
          },
          licenses: [{
            type: "MIT"
          }],
          devDependencies: {
            grunt: "^0.4.5",
            "grunt-contrib-jshint": "^0.11.2",
            "grunt-contrib-nodeunit": "^0.4.1",
            "grunt-contrib-uglify": "~0.4.0",
            "grunt-contrib-watch": "~0.5.0",
            "grunt-browserify": "~2.0.1",
            "grunt-contrib-concat": "^0.4.0"
          },
          dependencies: {
            "poly-decomp": "0.1.1"
          }
        };
      }, {}],
      7: [function (t, e, i) {
        var s = t("../math/vec2");

        function n(t) {
          this.lowerBound = s.create(), t && t.lowerBound && s.copy(this.lowerBound, t.lowerBound), this.upperBound = s.create(), t && t.upperBound && s.copy(this.upperBound, t.upperBound);
        }

        t("../utils/Utils"), e.exports = n;
        var o = s.create();
        n.prototype.setFromPoints = function (t, e, i, n) {
          var r = this.lowerBound,
              a = this.upperBound;
          "number" != typeof i && (i = 0), 0 !== i ? s.rotate(r, t[0], i) : s.copy(r, t[0]), s.copy(a, r);

          for (var h = Math.cos(i), l = Math.sin(i), c = 1; c < t.length; c++) {
            var u = t[c];

            if (0 !== i) {
              var d = u[0],
                  p = u[1];
              o[0] = h * d - l * p, o[1] = l * d + h * p, u = o;
            }

            for (var f = 0; f < 2; f++) {
              u[f] > a[f] && (a[f] = u[f]), u[f] < r[f] && (r[f] = u[f]);
            }
          }

          e && (s.add(this.lowerBound, this.lowerBound, e), s.add(this.upperBound, this.upperBound, e)), n && (this.lowerBound[0] -= n, this.lowerBound[1] -= n, this.upperBound[0] += n, this.upperBound[1] += n);
        }, n.prototype.copy = function (t) {
          s.copy(this.lowerBound, t.lowerBound), s.copy(this.upperBound, t.upperBound);
        }, n.prototype.extend = function (t) {
          for (var e = 2; e--;) {
            var i = t.lowerBound[e];
            this.lowerBound[e] > i && (this.lowerBound[e] = i);
            var s = t.upperBound[e];
            this.upperBound[e] < s && (this.upperBound[e] = s);
          }
        }, n.prototype.overlaps = function (t) {
          var e = this.lowerBound,
              i = this.upperBound,
              s = t.lowerBound,
              n = t.upperBound;
          return (s[0] <= i[0] && i[0] <= n[0] || e[0] <= n[0] && n[0] <= i[0]) && (s[1] <= i[1] && i[1] <= n[1] || e[1] <= n[1] && n[1] <= i[1]);
        }, n.prototype.containsPoint = function (t) {
          var e = this.lowerBound,
              i = this.upperBound;
          return e[0] <= t[0] && t[0] <= i[0] && e[1] <= t[1] && t[1] <= i[1];
        }, n.prototype.overlapsRay = function (t) {
          var e = 1 / t.direction[0],
              i = 1 / t.direction[1],
              s = (this.lowerBound[0] - t.from[0]) * e,
              n = (this.upperBound[0] - t.from[0]) * e,
              o = (this.lowerBound[1] - t.from[1]) * i,
              r = (this.upperBound[1] - t.from[1]) * i,
              a = Math.max(Math.max(Math.min(s, n), Math.min(o, r))),
              h = Math.min(Math.min(Math.max(s, n), Math.max(o, r)));
          return h < 0 ? -1 : a > h ? -1 : a;
        };
      }, {
        "../math/vec2": 30,
        "../utils/Utils": 57
      }],
      8: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = t("../objects/Body");

        function o(t) {
          this.type = t, this.result = [], this.world = null, this.boundingVolumeType = o.AABB;
        }

        e.exports = o, o.AABB = 1, o.BOUNDING_CIRCLE = 2, o.prototype.setWorld = function (t) {
          this.world = t;
        }, o.prototype.getCollisionPairs = function (t) {};
        var r = s.create();
        o.boundingRadiusCheck = function (t, e) {
          s.sub(r, t.position, e.position);
          var i = s.squaredLength(r),
              n = t.boundingRadius + e.boundingRadius;
          return i <= n * n;
        }, o.aabbCheck = function (t, e) {
          return t.getAABB().overlaps(e.getAABB());
        }, o.prototype.boundingVolumeCheck = function (t, e) {
          var i;

          switch (this.boundingVolumeType) {
            case o.BOUNDING_CIRCLE:
              i = o.boundingRadiusCheck(t, e);
              break;

            case o.AABB:
              i = o.aabbCheck(t, e);
              break;

            default:
              throw new Error("Bounding volume type not recognized: " + this.boundingVolumeType);
          }

          return i;
        }, o.canCollide = function (t, e) {
          var i = n.KINEMATIC,
              s = n.STATIC;
          return !(t.type === s && e.type === s || t.type === i && e.type === s || t.type === s && e.type === i || t.type === i && e.type === i || t.sleepState === n.SLEEPING && e.sleepState === n.SLEEPING || t.sleepState === n.SLEEPING && e.type === s || e.sleepState === n.SLEEPING && t.type === s);
        }, o.NAIVE = 1, o.SAP = 2;
      }, {
        "../math/vec2": 30,
        "../objects/Body": 31
      }],
      9: [function (t, e, i) {
        t("../shapes/Circle"), t("../shapes/Plane"), t("../shapes/Shape"), t("../shapes/Particle");
        var s = t("../collision/Broadphase");

        function n() {
          s.call(this, s.NAIVE);
        }

        t("../math/vec2"), e.exports = n, n.prototype = new s(), n.prototype.constructor = n, n.prototype.getCollisionPairs = function (t) {
          var e = t.bodies,
              i = this.result;
          i.length = 0;

          for (var n = 0, o = e.length; n !== o; n++) {
            for (var r = e[n], a = 0; a < n; a++) {
              var h = e[a];
              s.canCollide(r, h) && this.boundingVolumeCheck(r, h) && i.push(r, h);
            }
          }

          return i;
        }, n.prototype.aabbQuery = function (t, e, i) {
          i = i || [];

          for (var s = t.bodies, n = 0; n < s.length; n++) {
            var o = s[n];
            o.aabbNeedsUpdate && o.updateAABB(), o.aabb.overlaps(e) && i.push(o);
          }

          return i;
        };
      }, {
        "../collision/Broadphase": 8,
        "../math/vec2": 30,
        "../shapes/Circle": 39,
        "../shapes/Particle": 43,
        "../shapes/Plane": 44,
        "../shapes/Shape": 45
      }],
      10: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = s.sub,
            o = s.add,
            r = s.dot,
            a = (t("../utils/Utils"), t("../utils/ContactEquationPool")),
            h = t("../utils/FrictionEquationPool"),
            l = t("../utils/TupleDictionary"),
            c = t("../equations/Equation"),
            u = (t("../equations/ContactEquation"), t("../equations/FrictionEquation"), t("../shapes/Circle")),
            d = t("../shapes/Convex"),
            p = t("../shapes/Shape"),
            f = (t("../objects/Body"), t("../shapes/Box"));
        e.exports = B;

        var g = s.fromValues(0, 1),
            m = s.fromValues(0, 0),
            y = s.fromValues(0, 0),
            v = s.fromValues(0, 0),
            b = s.fromValues(0, 0),
            x = s.fromValues(0, 0),
            w = s.fromValues(0, 0),
            _ = s.fromValues(0, 0),
            T = s.fromValues(0, 0),
            P = s.fromValues(0, 0),
            S = s.fromValues(0, 0),
            C = s.fromValues(0, 0),
            A = s.fromValues(0, 0),
            E = s.fromValues(0, 0),
            M = s.fromValues(0, 0),
            R = s.fromValues(0, 0),
            L = s.fromValues(0, 0),
            I = s.fromValues(0, 0),
            k = s.fromValues(0, 0),
            O = [];

        function B() {
          this.contactEquations = [], this.frictionEquations = [], this.enableFriction = !0, this.enabledEquations = !0, this.slipForce = 10, this.frictionCoefficient = .3, this.surfaceVelocity = 0, this.contactEquationPool = new a({
            size: 32
          }), this.frictionEquationPool = new h({
            size: 64
          }), this.restitution = 0, this.stiffness = c.DEFAULT_STIFFNESS, this.relaxation = c.DEFAULT_RELAXATION, this.frictionStiffness = c.DEFAULT_STIFFNESS, this.frictionRelaxation = c.DEFAULT_RELAXATION, this.enableFrictionReduction = !0, this.collidingBodiesLastStep = new l(), this.contactSkinSize = .01;
        }

        var F = s.create(),
            D = s.create();

        function U(t, e) {
          s.set(t.vertices[0], .5 * -e.length, -e.radius), s.set(t.vertices[1], .5 * e.length, -e.radius), s.set(t.vertices[2], .5 * e.length, e.radius), s.set(t.vertices[3], .5 * -e.length, e.radius);
        }

        B.prototype.bodiesOverlap = function (t, e) {
          for (var i = F, s = D, n = 0, o = t.shapes.length; n !== o; n++) {
            var r = t.shapes[n];
            t.toWorldFrame(i, r.position);

            for (var a = 0, h = e.shapes.length; a !== h; a++) {
              var l = e.shapes[a];
              if (e.toWorldFrame(s, l.position), this[r.type | l.type](t, r, i, r.angle + t.angle, e, l, s, l.angle + e.angle, !0)) return !0;
            }
          }

          return !1;
        }, B.prototype.collidedLastStep = function (t, e) {
          var i = 0 | t.id,
              s = 0 | e.id;
          return !!this.collidingBodiesLastStep.get(i, s);
        }, B.prototype.reset = function () {
          this.collidingBodiesLastStep.reset();

          for (var t = this.contactEquations, e = t.length; e--;) {
            var i = t[e],
                s = i.bodyA.id,
                n = i.bodyB.id;
            this.collidingBodiesLastStep.set(s, n, !0);
          }

          for (var o = this.contactEquations, r = this.frictionEquations, a = 0; a < o.length; a++) {
            this.contactEquationPool.release(o[a]);
          }

          for (var a = 0; a < r.length; a++) {
            this.frictionEquationPool.release(r[a]);
          }

          this.contactEquations.length = this.frictionEquations.length = 0;
        }, B.prototype.createContactEquation = function (t, e, i, s) {
          var n = this.contactEquationPool.get();
          return n.bodyA = t, n.bodyB = e, n.shapeA = i, n.shapeB = s, n.restitution = this.restitution, n.firstImpact = !this.collidedLastStep(t, e), n.stiffness = this.stiffness, n.relaxation = this.relaxation, n.needsUpdate = !0, n.enabled = this.enabledEquations, n.offset = this.contactSkinSize, n;
        }, B.prototype.createFrictionEquation = function (t, e, i, s) {
          var n = this.frictionEquationPool.get();
          return n.bodyA = t, n.bodyB = e, n.shapeA = i, n.shapeB = s, n.setSlipForce(this.slipForce), n.frictionCoefficient = this.frictionCoefficient, n.relativeVelocity = this.surfaceVelocity, n.enabled = this.enabledEquations, n.needsUpdate = !0, n.stiffness = this.frictionStiffness, n.relaxation = this.frictionRelaxation, n.contactEquations.length = 0, n;
        }, B.prototype.createFrictionFromContact = function (t) {
          var e = this.createFrictionEquation(t.bodyA, t.bodyB, t.shapeA, t.shapeB);
          return s.copy(e.contactPointA, t.contactPointA), s.copy(e.contactPointB, t.contactPointB), s.rotate90cw(e.t, t.normalA), e.contactEquations.push(t), e;
        }, B.prototype.createFrictionFromAverage = function (t) {
          var e = this.contactEquations[this.contactEquations.length - 1],
              i = this.createFrictionEquation(e.bodyA, e.bodyB, e.shapeA, e.shapeB),
              n = e.bodyA;
          e.bodyB, s.set(i.contactPointA, 0, 0), s.set(i.contactPointB, 0, 0), s.set(i.t, 0, 0);

          for (var o = 0; o !== t; o++) {
            (e = this.contactEquations[this.contactEquations.length - 1 - o]).bodyA === n ? (s.add(i.t, i.t, e.normalA), s.add(i.contactPointA, i.contactPointA, e.contactPointA), s.add(i.contactPointB, i.contactPointB, e.contactPointB)) : (s.sub(i.t, i.t, e.normalA), s.add(i.contactPointA, i.contactPointA, e.contactPointB), s.add(i.contactPointB, i.contactPointB, e.contactPointA)), i.contactEquations.push(e);
          }

          var r = 1 / t;
          return s.scale(i.contactPointA, i.contactPointA, r), s.scale(i.contactPointB, i.contactPointB, r), s.normalize(i.t, i.t), s.rotate90cw(i.t, i.t), i;
        }, B.prototype[p.LINE | p.CONVEX] = B.prototype.convexLine = function (t, e, i, s, n, o, r, a, h) {
          return !h && 0;
        }, B.prototype[p.LINE | p.BOX] = B.prototype.lineBox = function (t, e, i, s, n, o, r, a, h) {
          return !h && 0;
        };
        var G = new f({
          width: 1,
          height: 1
        }),
            N = s.create();
        B.prototype[p.CAPSULE | p.CONVEX] = B.prototype[p.CAPSULE | p.BOX] = B.prototype.convexCapsule = function (t, e, i, n, o, r, a, h, l) {
          var c = N;
          s.set(c, r.length / 2, 0), s.rotate(c, c, h), s.add(c, c, a);
          var u = this.circleConvex(o, r, c, h, t, e, i, n, l, r.radius);
          s.set(c, -r.length / 2, 0), s.rotate(c, c, h), s.add(c, c, a);
          var d = this.circleConvex(o, r, c, h, t, e, i, n, l, r.radius);
          if (l && (u || d)) return !0;
          var p = G;
          U(p, r);
          var f = this.convexConvex(t, e, i, n, o, p, a, h, l);
          return f + u + d;
        }, B.prototype[p.CAPSULE | p.LINE] = B.prototype.lineCapsule = function (t, e, i, s, n, o, r, a, h) {
          return !h && 0;
        };
        var W = s.create(),
            X = s.create(),
            j = new f({
          width: 1,
          height: 1
        });
        B.prototype[p.CAPSULE | p.CAPSULE] = B.prototype.capsuleCapsule = function (t, e, i, n, o, r, a, h, l) {
          for (var c = W, u = X, d = 0, p = 0; p < 2; p++) {
            s.set(c, (0 === p ? -1 : 1) * e.length / 2, 0), s.rotate(c, c, n), s.add(c, c, i);

            for (var f = 0; f < 2; f++) {
              s.set(u, (0 === f ? -1 : 1) * r.length / 2, 0), s.rotate(u, u, h), s.add(u, u, a), this.enableFrictionReduction && (v = this.enableFriction, this.enableFriction = !1);
              var g = this.circleCircle(t, e, c, n, o, r, u, h, l, e.radius, r.radius);
              if (this.enableFrictionReduction && (this.enableFriction = v), l && g) return !0;
              d += g;
            }
          }

          this.enableFrictionReduction && (v = this.enableFriction, this.enableFriction = !1);
          var m = j;
          U(m, e);
          var y = this.convexCapsule(t, m, i, n, o, r, a, h, l);
          if (this.enableFrictionReduction && (this.enableFriction = v), l && y) return !0;

          if (d += y, this.enableFrictionReduction) {
            var v = this.enableFriction;
            this.enableFriction = !1;
          }

          U(m, r);
          var b = this.convexCapsule(o, m, a, h, t, e, i, n, l);
          return this.enableFrictionReduction && (this.enableFriction = v), !(!l || !b) || (d += b, this.enableFrictionReduction && d && this.enableFriction && this.frictionEquations.push(this.createFrictionFromAverage(d)), d);
        }, B.prototype[p.LINE | p.LINE] = B.prototype.lineLine = function (t, e, i, s, n, o, r, a, h) {
          return !h && 0;
        }, B.prototype[p.PLANE | p.LINE] = B.prototype.planeLine = function (t, e, i, a, h, l, c, u, d) {
          var p = m,
              f = y,
              S = v,
              C = b,
              A = x,
              E = w,
              M = _,
              R = T,
              L = P,
              I = O,
              k = 0;
          s.set(p, -l.length / 2, 0), s.set(f, l.length / 2, 0), s.rotate(S, p, u), s.rotate(C, f, u), o(S, S, c), o(C, C, c), s.copy(p, S), s.copy(f, C), n(A, f, p), s.normalize(E, A), s.rotate90cw(L, E), s.rotate(R, g, a), I[0] = p, I[1] = f;

          for (var B = 0; B < I.length; B++) {
            var F = I[B];
            n(M, F, i);
            var D = r(M, R);

            if (D < 0) {
              if (d) return !0;
              var U = this.createContactEquation(t, h, e, l);
              k++, s.copy(U.normalA, R), s.normalize(U.normalA, U.normalA), s.scale(M, R, D), n(U.contactPointA, F, M), n(U.contactPointA, U.contactPointA, t.position), n(U.contactPointB, F, c), o(U.contactPointB, U.contactPointB, c), n(U.contactPointB, U.contactPointB, h.position), this.contactEquations.push(U), this.enableFrictionReduction || this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(U));
            }
          }

          return !d && (this.enableFrictionReduction || k && this.enableFriction && this.frictionEquations.push(this.createFrictionFromAverage(k)), k);
        }, B.prototype[p.PARTICLE | p.CAPSULE] = B.prototype.particleCapsule = function (t, e, i, s, n, o, r, a, h) {
          return this.circleLine(t, e, i, s, n, o, r, a, h, o.radius, 0);
        }, B.prototype[p.CIRCLE | p.LINE] = B.prototype.circleLine = function (t, e, i, a, h, l, c, u, d, p, f) {
          var p = p || 0,
              f = void 0 !== f ? f : e.radius,
              g = m,
              R = y,
              L = v,
              I = b,
              k = x,
              B = w,
              F = _,
              D = T,
              U = P,
              G = S,
              N = C,
              W = A,
              X = E,
              j = M,
              H = O;
          s.set(D, -l.length / 2, 0), s.set(U, l.length / 2, 0), s.rotate(G, D, u), s.rotate(N, U, u), o(G, G, c), o(N, N, c), s.copy(D, G), s.copy(U, N), n(B, U, D), s.normalize(F, B), s.rotate90cw(k, F), n(W, i, D);
          var V = r(W, k);
          n(I, D, c), n(X, i, c);
          var q = f + p;

          if (Math.abs(V) < q) {
            s.scale(g, k, V), n(L, i, g), s.scale(R, k, r(k, X)), s.normalize(R, R), s.scale(R, R, p), o(L, L, R);
            var Y = r(F, L),
                z = r(F, D),
                K = r(F, U);

            if (Y > z && Y < K) {
              if (d) return !0;
              var J = this.createContactEquation(t, h, e, l);
              return s.scale(J.normalA, g, -1), s.normalize(J.normalA, J.normalA), s.scale(J.contactPointA, J.normalA, f), o(J.contactPointA, J.contactPointA, i), n(J.contactPointA, J.contactPointA, t.position), n(J.contactPointB, L, c), o(J.contactPointB, J.contactPointB, c), n(J.contactPointB, J.contactPointB, h.position), this.contactEquations.push(J), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(J)), 1;
            }
          }

          H[0] = D, H[1] = U;

          for (var Q = 0; Q < H.length; Q++) {
            var Z = H[Q];

            if (n(W, Z, i), s.squaredLength(W) < Math.pow(q, 2)) {
              if (d) return !0;
              var J = this.createContactEquation(t, h, e, l);
              return s.copy(J.normalA, W), s.normalize(J.normalA, J.normalA), s.scale(J.contactPointA, J.normalA, f), o(J.contactPointA, J.contactPointA, i), n(J.contactPointA, J.contactPointA, t.position), n(J.contactPointB, Z, c), s.scale(j, J.normalA, -p), o(J.contactPointB, J.contactPointB, j), o(J.contactPointB, J.contactPointB, c), n(J.contactPointB, J.contactPointB, h.position), this.contactEquations.push(J), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(J)), 1;
            }
          }

          return 0;
        }, B.prototype[p.CIRCLE | p.CAPSULE] = B.prototype.circleCapsule = function (t, e, i, s, n, o, r, a, h) {
          return this.circleLine(t, e, i, s, n, o, r, a, h, o.radius);
        }, B.prototype[p.CIRCLE | p.CONVEX] = B.prototype[p.CIRCLE | p.BOX] = B.prototype.circleConvex = function (t, e, i, r, a, h, l, c, u, d) {
          for (var d = "number" == typeof d ? d : e.radius, p = m, f = y, g = v, w = b, _ = x, T = S, P = C, A = E, I = M, k = R, O = L, B = !1, F = Number.MAX_VALUE, D = h.vertices, U = 0; U !== D.length + 1; U++) {
            var G = D[U % D.length],
                N = D[(U + 1) % D.length];

            if (s.rotate(p, G, c), s.rotate(f, N, c), o(p, p, l), o(f, f, l), n(g, f, p), s.normalize(w, g), s.rotate90cw(_, w), s.scale(I, _, -e.radius), o(I, I, i), z(I, h, l, c)) {
              s.sub(k, p, I);
              var W = Math.abs(s.dot(k, _));
              W < F && (s.copy(O, I), F = W, s.scale(A, _, W), s.add(A, A, I), B = !0);
            }
          }

          if (B) {
            if (u) return !0;
            var X = this.createContactEquation(t, a, e, h);
            return s.sub(X.normalA, O, i), s.normalize(X.normalA, X.normalA), s.scale(X.contactPointA, X.normalA, d), o(X.contactPointA, X.contactPointA, i), n(X.contactPointA, X.contactPointA, t.position), n(X.contactPointB, A, l), o(X.contactPointB, X.contactPointB, l), n(X.contactPointB, X.contactPointB, a.position), this.contactEquations.push(X), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(X)), 1;
          }

          if (d > 0) for (var U = 0; U < D.length; U++) {
            var j = D[U];

            if (s.rotate(P, j, c), o(P, P, l), n(T, P, i), s.squaredLength(T) < Math.pow(d, 2)) {
              if (u) return !0;
              var X = this.createContactEquation(t, a, e, h);
              return s.copy(X.normalA, T), s.normalize(X.normalA, X.normalA), s.scale(X.contactPointA, X.normalA, d), o(X.contactPointA, X.contactPointA, i), n(X.contactPointA, X.contactPointA, t.position), n(X.contactPointB, P, l), o(X.contactPointB, X.contactPointB, l), n(X.contactPointB, X.contactPointB, a.position), this.contactEquations.push(X), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(X)), 1;
            }
          }
          return 0;
        };
        var H = s.create(),
            V = s.create(),
            q = s.create(),
            Y = s.create();

        function z(t, e, i, r) {
          for (var a = H, h = V, l = q, c = Y, u = t, d = e.vertices, p = null, f = 0; f !== d.length + 1; f++) {
            var g = d[f % d.length],
                m = d[(f + 1) % d.length];
            s.rotate(a, g, r), s.rotate(h, m, r), o(a, a, i), o(h, h, i), n(l, a, u), n(c, h, u);
            var y = s.crossLength(l, c);
            if (null === p && (p = y), y * p <= 0) return !1;
            p = y;
          }

          return !0;
        }

        B.prototype[p.PARTICLE | p.CONVEX] = B.prototype[p.PARTICLE | p.BOX] = B.prototype.particleConvex = function (t, e, i, a, h, l, c, u, d) {
          var p = m,
              f = y,
              g = v,
              T = b,
              P = x,
              C = w,
              A = _,
              M = S,
              R = E,
              L = I,
              O = k,
              B = Number.MAX_VALUE,
              F = !1,
              D = l.vertices;
          if (!z(i, l, c, u)) return 0;
          if (d) return !0;

          for (var U = 0; U !== D.length + 1; U++) {
            var G = D[U % D.length],
                N = D[(U + 1) % D.length];
            s.rotate(p, G, u), s.rotate(f, N, u), o(p, p, c), o(f, f, c), n(g, f, p), s.normalize(T, g), s.rotate90cw(P, T), n(M, i, p), r(M, P), n(C, p, c), n(A, i, c), s.sub(L, p, i);
            var W = Math.abs(s.dot(L, P));
            W < B && (B = W, s.scale(R, P, W), s.add(R, R, i), s.copy(O, P), F = !0);
          }

          if (F) {
            var X = this.createContactEquation(t, h, e, l);
            return s.scale(X.normalA, O, -1), s.normalize(X.normalA, X.normalA), s.set(X.contactPointA, 0, 0), o(X.contactPointA, X.contactPointA, i), n(X.contactPointA, X.contactPointA, t.position), n(X.contactPointB, R, c), o(X.contactPointB, X.contactPointB, c), n(X.contactPointB, X.contactPointB, h.position), this.contactEquations.push(X), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(X)), 1;
          }

          return 0;
        }, B.prototype[p.CIRCLE] = B.prototype.circleCircle = function (t, e, i, r, a, h, l, c, u, d, p) {
          var f = m,
              d = d || e.radius,
              p = p || h.radius;
          n(f, i, l);
          var g = d + p;
          if (s.squaredLength(f) > Math.pow(g, 2)) return 0;
          if (u) return !0;
          var y = this.createContactEquation(t, a, e, h);
          return n(y.normalA, l, i), s.normalize(y.normalA, y.normalA), s.scale(y.contactPointA, y.normalA, d), s.scale(y.contactPointB, y.normalA, -p), o(y.contactPointA, y.contactPointA, i), n(y.contactPointA, y.contactPointA, t.position), o(y.contactPointB, y.contactPointB, l), n(y.contactPointB, y.contactPointB, a.position), this.contactEquations.push(y), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(y)), 1;
        }, B.prototype[p.PLANE | p.CONVEX] = B.prototype[p.PLANE | p.BOX] = B.prototype.planeConvex = function (t, e, i, a, h, l, c, u, d) {
          var p = m,
              f = y,
              b = v,
              x = 0;
          s.rotate(f, g, a);

          for (var w = 0; w !== l.vertices.length; w++) {
            var _ = l.vertices[w];

            if (s.rotate(p, _, u), o(p, p, c), n(b, p, i), r(b, f) <= 0) {
              if (d) return !0;
              x++;
              var T = this.createContactEquation(t, h, e, l);
              n(b, p, i), s.copy(T.normalA, f);
              var P = r(b, T.normalA);
              s.scale(b, T.normalA, P), n(T.contactPointB, p, h.position), n(T.contactPointA, p, b), n(T.contactPointA, T.contactPointA, t.position), this.contactEquations.push(T), this.enableFrictionReduction || this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(T));
            }
          }

          return this.enableFrictionReduction && this.enableFriction && x && this.frictionEquations.push(this.createFrictionFromAverage(x)), x;
        }, B.prototype[p.PARTICLE | p.PLANE] = B.prototype.particlePlane = function (t, e, i, o, a, h, l, c, u) {
          var d = m,
              p = y;
          c = c || 0, n(d, i, l), s.rotate(p, g, c);
          var f = r(d, p);
          if (f > 0) return 0;
          if (u) return !0;
          var v = this.createContactEquation(a, t, h, e);
          return s.copy(v.normalA, p), s.scale(d, v.normalA, f), n(v.contactPointA, i, d), n(v.contactPointA, v.contactPointA, a.position), n(v.contactPointB, i, t.position), this.contactEquations.push(v), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(v)), 1;
        }, B.prototype[p.CIRCLE | p.PARTICLE] = B.prototype.circleParticle = function (t, e, i, r, a, h, l, c, u) {
          var d = m;
          if (n(d, l, i), s.squaredLength(d) > Math.pow(e.radius, 2)) return 0;
          if (u) return !0;
          var p = this.createContactEquation(t, a, e, h);
          return s.copy(p.normalA, d), s.normalize(p.normalA, p.normalA), s.scale(p.contactPointA, p.normalA, e.radius), o(p.contactPointA, p.contactPointA, i), n(p.contactPointA, p.contactPointA, t.position), n(p.contactPointB, l, a.position), this.contactEquations.push(p), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(p)), 1;
        };
        var K = new u({
          radius: 1
        }),
            J = s.create(),
            Q = s.create();
        s.create(), B.prototype[p.PLANE | p.CAPSULE] = B.prototype.planeCapsule = function (t, e, i, n, r, a, h, l, c) {
          var u,
              d = J,
              p = Q,
              f = K;
          s.set(d, -a.length / 2, 0), s.rotate(d, d, l), o(d, d, h), s.set(p, a.length / 2, 0), s.rotate(p, p, l), o(p, p, h), f.radius = a.radius, this.enableFrictionReduction && (u = this.enableFriction, this.enableFriction = !1);
          var g = this.circlePlane(r, f, d, 0, t, e, i, n, c),
              m = this.circlePlane(r, f, p, 0, t, e, i, n, c);
          if (this.enableFrictionReduction && (this.enableFriction = u), c) return g || m;
          var y = g + m;
          return this.enableFrictionReduction && y && this.frictionEquations.push(this.createFrictionFromAverage(y)), y;
        }, B.prototype[p.CIRCLE | p.PLANE] = B.prototype.circlePlane = function (t, e, i, a, h, l, c, u, d) {
          var p = t,
              f = e,
              b = i,
              x = h,
              w = c,
              _ = u;
          _ = _ || 0;
          var T = m,
              P = y,
              S = v;
          n(T, b, w), s.rotate(P, g, _);
          var C = r(P, T);
          if (C > f.radius) return 0;
          if (d) return !0;
          var A = this.createContactEquation(x, p, l, e);
          return s.copy(A.normalA, P), s.scale(A.contactPointB, A.normalA, -f.radius), o(A.contactPointB, A.contactPointB, b), n(A.contactPointB, A.contactPointB, p.position), s.scale(S, A.normalA, C), n(A.contactPointA, T, S), o(A.contactPointA, A.contactPointA, w), n(A.contactPointA, A.contactPointA, x.position), this.contactEquations.push(A), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(A)), 1;
        }, B.prototype[p.CONVEX] = B.prototype[p.CONVEX | p.BOX] = B.prototype[p.BOX] = B.prototype.convexConvex = function (t, e, i, a, h, l, c, u, d, p) {
          var f = m,
              g = y,
              w = v,
              S = b,
              C = x,
              A = _,
              E = T,
              M = P,
              R = 0,
              p = "number" == typeof p ? p : 0,
              L = B.findSeparatingAxis(e, i, a, l, c, u, f);
          if (!L) return 0;
          n(E, c, i), r(f, E) > 0 && s.scale(f, f, -1);
          var I = B.getClosestEdge(e, a, f, !0),
              k = B.getClosestEdge(l, u, f);
          if (-1 === I || -1 === k) return 0;

          for (var O = 0; O < 2; O++) {
            var F,
                D = I,
                U = k,
                G = e,
                N = l,
                W = i,
                X = c,
                j = a,
                H = u,
                V = t,
                q = h;
            0 === O && (F = D, D = U, U = F, F = G, G = N, N = F, F = W, W = X, X = F, F = j, j = H, H = F, F = V, V = q, q = F);

            for (var Y = U; Y < U + 2; Y++) {
              var z = N.vertices[(Y + N.vertices.length) % N.vertices.length];
              s.rotate(g, z, H), o(g, g, X);

              for (var K = 0, J = D - 1; J < D + 2; J++) {
                var Q = G.vertices[(J + G.vertices.length) % G.vertices.length],
                    Z = G.vertices[(J + 1 + G.vertices.length) % G.vertices.length];
                s.rotate(w, Q, j), s.rotate(S, Z, j), o(w, w, W), o(S, S, W), n(C, S, w), s.rotate90cw(M, C), s.normalize(M, M), n(E, g, w);
                var $ = r(M, E);
                (J === D && $ <= p || J !== D && $ <= 0) && K++;
              }

              if (K >= 3) {
                if (d) return !0;
                var tt = this.createContactEquation(V, q, G, N);
                R++;
                var Q = G.vertices[D % G.vertices.length],
                    Z = G.vertices[(D + 1) % G.vertices.length];
                s.rotate(w, Q, j), s.rotate(S, Z, j), o(w, w, W), o(S, S, W), n(C, S, w), s.rotate90cw(tt.normalA, C), s.normalize(tt.normalA, tt.normalA), n(E, g, w);
                var $ = r(tt.normalA, E);
                s.scale(A, tt.normalA, $), n(tt.contactPointA, g, W), n(tt.contactPointA, tt.contactPointA, A), o(tt.contactPointA, tt.contactPointA, W), n(tt.contactPointA, tt.contactPointA, V.position), n(tt.contactPointB, g, X), o(tt.contactPointB, tt.contactPointB, X), n(tt.contactPointB, tt.contactPointB, q.position), this.contactEquations.push(tt), this.enableFrictionReduction || this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(tt));
              }
            }
          }

          return this.enableFrictionReduction && this.enableFriction && R && this.frictionEquations.push(this.createFrictionFromAverage(R)), R;
        };
        var Z = s.fromValues(0, 0);

        B.projectConvexOntoAxis = function (t, e, i, n, o) {
          var a,
              h,
              l = null,
              c = null,
              u = Z;
          s.rotate(u, n, -i);

          for (var d = 0; d < t.vertices.length; d++) {
            a = t.vertices[d], h = r(a, u), (null === l || h > l) && (l = h), (null === c || h < c) && (c = h);
          }

          if (c > l) {
            var p = c;
            c = l, l = p;
          }

          var f = r(e, n);
          s.set(o, c + f, l + f);
        };

        var $ = s.fromValues(0, 0),
            tt = s.fromValues(0, 0),
            et = s.fromValues(0, 0),
            it = s.fromValues(0, 0),
            st = s.fromValues(0, 0),
            nt = s.fromValues(0, 0);

        B.findSeparatingAxis = function (t, e, i, o, r, a, h) {
          var l = null,
              c = !1,
              u = !1,
              d = $,
              p = tt,
              g = et,
              m = it,
              y = st,
              v = nt;
          if (t instanceof f && o instanceof f) for (var b = 0; 2 !== b; b++) {
            var x = t,
                w = i;
            1 === b && (x = o, w = a);

            for (var _ = 0; 2 !== _; _++) {
              0 === _ ? s.set(m, 0, 1) : 1 === _ && s.set(m, 1, 0), 0 !== w && s.rotate(m, m, w), B.projectConvexOntoAxis(t, e, i, m, y), B.projectConvexOntoAxis(o, r, a, m, v);
              var T = y,
                  P = v;
              y[0] > v[0] && (P = y, T = v);
              var S = P[0] - T[1];
              c = S <= 0, (null === l || S > l) && (s.copy(h, m), l = S, u = c);
            }
          } else for (var b = 0; 2 !== b; b++) {
            var x = t,
                w = i;
            1 === b && (x = o, w = a);

            for (var _ = 0; _ !== x.vertices.length; _++) {
              s.rotate(p, x.vertices[_], w), s.rotate(g, x.vertices[(_ + 1) % x.vertices.length], w), n(d, g, p), s.rotate90cw(m, d), s.normalize(m, m), B.projectConvexOntoAxis(t, e, i, m, y), B.projectConvexOntoAxis(o, r, a, m, v);
              var T = y,
                  P = v;
              y[0] > v[0] && (P = y, T = v);
              var S = P[0] - T[1];
              c = S <= 0, (null === l || S > l) && (s.copy(h, m), l = S, u = c);
            }
          }
          return u;
        };

        var ot = s.fromValues(0, 0),
            rt = s.fromValues(0, 0),
            at = s.fromValues(0, 0);

        B.getClosestEdge = function (t, e, i, o) {
          var a = ot,
              h = rt,
              l = at;
          s.rotate(a, i, -e), o && s.scale(a, a, -1);

          for (var c = -1, u = t.vertices.length, d = -1, p = 0; p !== u; p++) {
            n(h, t.vertices[(p + 1) % u], t.vertices[p % u]), s.rotate90cw(l, h), s.normalize(l, l);
            var f = r(l, a);
            (-1 === c || f > d) && (c = p % u, d = f);
          }

          return c;
        };

        var ht = s.create(),
            lt = s.create(),
            ct = s.create(),
            ut = s.create(),
            dt = s.create(),
            pt = s.create(),
            ft = s.create();

        B.prototype[p.CIRCLE | p.HEIGHTFIELD] = B.prototype.circleHeightfield = function (t, e, i, r, a, h, l, c, u, d) {
          var p = h.heights,
              d = d || e.radius,
              f = h.elementWidth,
              g = lt,
              m = ht,
              y = dt,
              v = ft,
              b = pt,
              x = ct,
              w = ut,
              _ = Math.floor((i[0] - d - l[0]) / f),
              T = Math.ceil((i[0] + d - l[0]) / f);

          _ < 0 && (_ = 0), T >= p.length && (T = p.length - 1);

          for (var P = p[_], S = p[T], C = _; C < T; C++) {
            p[C] < S && (S = p[C]), p[C] > P && (P = p[C]);
          }

          if (i[1] - d > P) return !u && 0;

          for (var A = !1, C = _; C < T; C++) {
            s.set(x, C * f, p[C]), s.set(w, (C + 1) * f, p[C + 1]), s.add(x, x, l), s.add(w, w, l), s.sub(b, w, x), s.rotate(b, b, Math.PI / 2), s.normalize(b, b), s.scale(m, b, -d), s.add(m, m, i), s.sub(g, m, x);
            var E = s.dot(g, b);

            if (m[0] >= x[0] && m[0] < w[0] && E <= 0) {
              if (u) return !0;
              A = !0, s.scale(g, b, -E), s.add(y, m, g), s.copy(v, b);
              var M = this.createContactEquation(a, t, h, e);
              s.copy(M.normalA, v), s.scale(M.contactPointB, M.normalA, -d), o(M.contactPointB, M.contactPointB, i), n(M.contactPointB, M.contactPointB, t.position), s.copy(M.contactPointA, y), s.sub(M.contactPointA, M.contactPointA, a.position), this.contactEquations.push(M), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(M));
            }
          }

          if (A = !1, d > 0) for (var C = _; C <= T; C++) {
            if (s.set(x, C * f, p[C]), s.add(x, x, l), s.sub(g, i, x), s.squaredLength(g) < Math.pow(d, 2)) {
              if (u) return !0;
              A = !0;
              var M = this.createContactEquation(a, t, h, e);
              s.copy(M.normalA, g), s.normalize(M.normalA, M.normalA), s.scale(M.contactPointB, M.normalA, -d), o(M.contactPointB, M.contactPointB, i), n(M.contactPointB, M.contactPointB, t.position), n(M.contactPointA, x, l), o(M.contactPointA, M.contactPointA, l), n(M.contactPointA, M.contactPointA, a.position), this.contactEquations.push(M), this.enableFriction && this.frictionEquations.push(this.createFrictionFromContact(M));
            }
          }
          return A ? 1 : 0;
        };

        var gt = s.create(),
            mt = s.create(),
            yt = s.create(),
            vt = new d({
          vertices: [s.create(), s.create(), s.create(), s.create()]
        });

        B.prototype[p.BOX | p.HEIGHTFIELD] = B.prototype[p.CONVEX | p.HEIGHTFIELD] = B.prototype.convexHeightfield = function (t, e, i, n, o, r, a, h, l) {
          var c = r.heights,
              u = r.elementWidth,
              d = gt,
              p = mt,
              f = yt,
              g = vt,
              m = Math.floor((t.aabb.lowerBound[0] - a[0]) / u),
              y = Math.ceil((t.aabb.upperBound[0] - a[0]) / u);
          m < 0 && (m = 0), y >= c.length && (y = c.length - 1);

          for (var v = c[m], b = c[y], x = m; x < y; x++) {
            c[x] < b && (b = c[x]), c[x] > v && (v = c[x]);
          }

          if (t.aabb.lowerBound[1] > v) return !l && 0;

          for (var w = 0, x = m; x < y; x++) {
            s.set(d, x * u, c[x]), s.set(p, (x + 1) * u, c[x + 1]), s.add(d, d, a), s.add(p, p, a), s.set(f, .5 * (p[0] + d[0]), .5 * (p[1] + d[1] - 100)), s.sub(g.vertices[0], p, f), s.sub(g.vertices[1], d, f), s.copy(g.vertices[2], g.vertices[1]), s.copy(g.vertices[3], g.vertices[0]), g.vertices[2][1] -= 100, g.vertices[3][1] -= 100, w += this.convexConvex(t, e, i, n, o, g, f, 0, l);
          }

          return w;
        };
      }, {
        "../equations/ContactEquation": 21,
        "../equations/Equation": 22,
        "../equations/FrictionEquation": 23,
        "../math/vec2": 30,
        "../objects/Body": 31,
        "../shapes/Box": 37,
        "../shapes/Circle": 39,
        "../shapes/Convex": 40,
        "../shapes/Shape": 45,
        "../utils/ContactEquationPool": 48,
        "../utils/FrictionEquationPool": 49,
        "../utils/TupleDictionary": 56,
        "../utils/Utils": 57
      }],
      11: [function (t, e, i) {
        e.exports = n;
        var s = t("../math/vec2");

        function n(t) {
          t = t || {}, this.from = t.from ? s.fromValues(t.from[0], t.from[1]) : s.create(), this.to = t.to ? s.fromValues(t.to[0], t.to[1]) : s.create(), this.checkCollisionResponse = void 0 === t.checkCollisionResponse || t.checkCollisionResponse, this.skipBackfaces = !!t.skipBackfaces, this.collisionMask = void 0 !== t.collisionMask ? t.collisionMask : -1, this.collisionGroup = void 0 !== t.collisionGroup ? t.collisionGroup : -1, this.mode = void 0 !== t.mode ? t.mode : n.ANY, this.callback = t.callback || function (t) {}, this.direction = s.create(), this.length = 1, this.update();
        }

        t("../collision/RaycastResult"), t("../shapes/Shape"), t("../collision/AABB"), n.prototype.constructor = n, n.CLOSEST = 1, n.ANY = 2, n.ALL = 4, n.prototype.update = function () {
          var t = this.direction;
          s.sub(t, this.to, this.from), this.length = s.length(t), s.normalize(t, t);
        }, n.prototype.intersectBodies = function (t, e) {
          for (var i = 0, s = e.length; !t.shouldStop(this) && i < s; i++) {
            var n = e[i],
                o = n.getAABB();
            (o.overlapsRay(this) >= 0 || o.containsPoint(this.from)) && this.intersectBody(t, n);
          }
        };
        var o = s.create();
        n.prototype.intersectBody = function (t, e) {
          var i = this.checkCollisionResponse;
          if (!i || e.collisionResponse) for (var n = o, r = 0, a = e.shapes.length; r < a; r++) {
            var h = e.shapes[r];

            if ((!i || h.collisionResponse) && 0 != (this.collisionGroup & h.collisionMask) && 0 != (h.collisionGroup & this.collisionMask)) {
              s.rotate(n, h.position, e.angle), s.add(n, n, e.position);
              var l = h.angle + e.angle;
              if (this.intersectShape(t, h, l, n, e), t.shouldStop(this)) break;
            }
          }
        }, n.prototype.intersectShape = function (t, e, i, n, o) {
          var h = this.from,
              l = function (t, e, i) {
            s.sub(r, i, t);
            var n = s.dot(r, e);
            return s.scale(a, e, n), s.add(a, a, t), s.squaredDistance(i, a);
          }(h, this.direction, n);

          l > e.boundingRadius * e.boundingRadius || (this._currentBody = o, this._currentShape = e, e.raycast(t, this, n, i), this._currentBody = this._currentShape = null);
        }, n.prototype.getAABB = function (t) {
          var e = this.to,
              i = this.from;
          s.set(t.lowerBound, Math.min(e[0], i[0]), Math.min(e[1], i[1])), s.set(t.upperBound, Math.max(e[0], i[0]), Math.max(e[1], i[1]));
        }, s.create(), n.prototype.reportIntersection = function (t, e, i, o) {
          this.from, this.to;
          var r = this._currentShape,
              a = this._currentBody;
          if (!(this.skipBackfaces && s.dot(i, this.direction) > 0)) switch (this.mode) {
            case n.ALL:
              t.set(i, r, a, e, o), this.callback(t);
              break;

            case n.CLOSEST:
              (e < t.fraction || !t.hasHit()) && t.set(i, r, a, e, o);
              break;

            case n.ANY:
              t.set(i, r, a, e, o);
          }
        };
        var r = s.create(),
            a = s.create();
      }, {
        "../collision/AABB": 7,
        "../collision/RaycastResult": 12,
        "../math/vec2": 30,
        "../shapes/Shape": 45
      }],
      12: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = t("../collision/Ray");

        function o() {
          this.normal = s.create(), this.shape = null, this.body = null, this.faceIndex = -1, this.fraction = -1, this.isStopped = !1;
        }

        e.exports = o, o.prototype.reset = function () {
          s.set(this.normal, 0, 0), this.shape = null, this.body = null, this.faceIndex = -1, this.fraction = -1, this.isStopped = !1;
        }, o.prototype.getHitDistance = function (t) {
          return s.distance(t.from, t.to) * this.fraction;
        }, o.prototype.hasHit = function () {
          return -1 !== this.fraction;
        }, o.prototype.getHitPoint = function (t, e) {
          s.lerp(t, e.from, e.to, this.fraction);
        }, o.prototype.stop = function () {
          this.isStopped = !0;
        }, o.prototype.shouldStop = function (t) {
          return this.isStopped || -1 !== this.fraction && t.mode === n.ANY;
        }, o.prototype.set = function (t, e, i, n, o) {
          s.copy(this.normal, t), this.shape = e, this.body = i, this.fraction = n, this.faceIndex = o;
        };
      }, {
        "../collision/Ray": 11,
        "../math/vec2": 30
      }],
      13: [function (t, e, i) {
        var s = t("../utils/Utils"),
            n = t("../collision/Broadphase");

        function o() {
          n.call(this, n.SAP), this.axisList = [], this.axisIndex = 0;
          var t = this;
          this._addBodyHandler = function (e) {
            t.axisList.push(e.body);
          }, this._removeBodyHandler = function (e) {
            var i = t.axisList.indexOf(e.body);
            -1 !== i && t.axisList.splice(i, 1);
          };
        }

        e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.setWorld = function (t) {
          this.axisList.length = 0, s.appendArray(this.axisList, t.bodies), t.off("addBody", this._addBodyHandler).off("removeBody", this._removeBodyHandler), t.on("addBody", this._addBodyHandler).on("removeBody", this._removeBodyHandler), this.world = t;
        }, o.sortAxisList = function (t, e) {
          e |= 0;

          for (var i = 1, s = t.length; i < s; i++) {
            for (var n = t[i], o = i - 1; o >= 0 && !(t[o].aabb.lowerBound[e] <= n.aabb.lowerBound[e]); o--) {
              t[o + 1] = t[o];
            }

            t[o + 1] = n;
          }

          return t;
        }, o.prototype.sortList = function () {
          var t = this.axisList,
              e = this.axisIndex;
          o.sortAxisList(t, e);
        }, o.prototype.getCollisionPairs = function (t) {
          var e = this.axisList,
              i = this.result,
              s = this.axisIndex;
          i.length = 0;

          for (var o = e.length; o--;) {
            var r = e[o];
            r.aabbNeedsUpdate && r.updateAABB();
          }

          this.sortList();

          for (var a = 0, h = 0 | e.length; a !== h; a++) {
            for (var l = e[a], c = a + 1; c < h; c++) {
              var u = e[c],
                  d = u.aabb.lowerBound[s] <= l.aabb.upperBound[s];
              if (!d) break;
              n.canCollide(l, u) && this.boundingVolumeCheck(l, u) && i.push(l, u);
            }
          }

          return i;
        }, o.prototype.aabbQuery = function (t, e, i) {
          i = i || [], this.sortList();
          var s = this.axisIndex,
              n = "x";
          1 === s && (n = "y"), 2 === s && (n = "z");

          for (var o = this.axisList, r = (e.lowerBound[n], e.upperBound[n], 0); r < o.length; r++) {
            var a = o[r];
            a.aabbNeedsUpdate && a.updateAABB(), a.aabb.overlaps(e) && i.push(a);
          }

          return i;
        };
      }, {
        "../collision/Broadphase": 8,
        "../utils/Utils": 57
      }],
      14: [function (t, e, i) {
        e.exports = n;
        var s = t("../utils/Utils");

        function n(t, e, i, n) {
          this.type = i, n = s.defaults(n, {
            collideConnected: !0,
            wakeUpBodies: !0
          }), this.equations = [], this.bodyA = t, this.bodyB = e, this.collideConnected = n.collideConnected, n.wakeUpBodies && (t && t.wakeUp(), e && e.wakeUp());
        }

        n.prototype.update = function () {
          throw new Error("method update() not implmemented in this Constraint subclass!");
        }, n.DISTANCE = 1, n.GEAR = 2, n.LOCK = 3, n.PRISMATIC = 4, n.REVOLUTE = 5, n.prototype.setStiffness = function (t) {
          for (var e = this.equations, i = 0; i !== e.length; i++) {
            var s = e[i];
            s.stiffness = t, s.needsUpdate = !0;
          }
        }, n.prototype.setRelaxation = function (t) {
          for (var e = this.equations, i = 0; i !== e.length; i++) {
            var s = e[i];
            s.relaxation = t, s.needsUpdate = !0;
          }
        };
      }, {
        "../utils/Utils": 57
      }],
      15: [function (t, e, i) {
        var s = t("./Constraint"),
            n = t("../equations/Equation"),
            o = t("../math/vec2"),
            r = t("../utils/Utils");

        function a(t, e, i) {
          i = r.defaults(i, {
            localAnchorA: [0, 0],
            localAnchorB: [0, 0]
          }), s.call(this, t, e, s.DISTANCE, i), this.localAnchorA = o.fromValues(i.localAnchorA[0], i.localAnchorA[1]), this.localAnchorB = o.fromValues(i.localAnchorB[0], i.localAnchorB[1]);
          var a,
              h = this.localAnchorA,
              l = this.localAnchorB;
          if (this.distance = 0, "number" == typeof i.distance) this.distance = i.distance;else {
            var c = o.create(),
                u = o.create(),
                d = o.create();
            o.rotate(c, h, t.angle), o.rotate(u, l, e.angle), o.add(d, e.position, u), o.sub(d, d, c), o.sub(d, d, t.position), this.distance = o.length(d);
          }
          a = void 0 === i.maxForce ? Number.MAX_VALUE : i.maxForce;
          var p = new n(t, e, -a, a);
          this.equations = [p], this.maxForce = a;
          var d = o.create(),
              f = o.create(),
              g = o.create(),
              m = this;
          p.computeGq = function () {
            var t = this.bodyA,
                e = this.bodyB,
                i = t.position,
                s = e.position;
            return o.rotate(f, h, t.angle), o.rotate(g, l, e.angle), o.add(d, s, g), o.sub(d, d, f), o.sub(d, d, i), o.length(d) - m.distance;
          }, this.setMaxForce(a), this.upperLimitEnabled = !1, this.upperLimit = 1, this.lowerLimitEnabled = !1, this.lowerLimit = 0, this.position = 0;
        }

        e.exports = a, a.prototype = new s(), a.prototype.constructor = a;
        var h = o.create(),
            l = o.create(),
            c = o.create();
        a.prototype.update = function () {
          var t = this.equations[0],
              e = this.bodyA,
              i = this.bodyB,
              s = (this.distance, e.position),
              n = i.position,
              r = this.equations[0],
              a = t.G;
          o.rotate(l, this.localAnchorA, e.angle), o.rotate(c, this.localAnchorB, i.angle), o.add(h, n, c), o.sub(h, h, l), o.sub(h, h, s), this.position = o.length(h);
          var u = !1;

          if (this.upperLimitEnabled && this.position > this.upperLimit && (r.maxForce = 0, r.minForce = -this.maxForce, this.distance = this.upperLimit, u = !0), this.lowerLimitEnabled && this.position < this.lowerLimit && (r.maxForce = this.maxForce, r.minForce = 0, this.distance = this.lowerLimit, u = !0), !this.lowerLimitEnabled && !this.upperLimitEnabled || u) {
            r.enabled = !0, o.normalize(h, h);
            var d = o.crossLength(l, h),
                p = o.crossLength(c, h);
            a[0] = -h[0], a[1] = -h[1], a[2] = -d, a[3] = h[0], a[4] = h[1], a[5] = p;
          } else r.enabled = !1;
        }, a.prototype.setMaxForce = function (t) {
          var e = this.equations[0];
          e.minForce = -t, e.maxForce = t;
        }, a.prototype.getMaxForce = function () {
          var t = this.equations[0];
          return t.maxForce;
        };
      }, {
        "../equations/Equation": 22,
        "../math/vec2": 30,
        "../utils/Utils": 57,
        "./Constraint": 14
      }],
      16: [function (t, e, i) {
        var s = t("./Constraint"),
            n = (t("../equations/Equation"), t("../equations/AngleLockEquation"));

        function o(t, e, i) {
          i = i || {}, s.call(this, t, e, s.GEAR, i), this.ratio = void 0 !== i.ratio ? i.ratio : 1, this.angle = void 0 !== i.angle ? i.angle : e.angle - this.ratio * t.angle, i.angle = this.angle, i.ratio = this.ratio, this.equations = [new n(t, e, i)], void 0 !== i.maxTorque && this.setMaxTorque(i.maxTorque);
        }

        t("../math/vec2"), e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.update = function () {
          var t = this.equations[0];
          t.ratio !== this.ratio && t.setRatio(this.ratio), t.angle = this.angle;
        }, o.prototype.setMaxTorque = function (t) {
          this.equations[0].setMaxTorque(t);
        }, o.prototype.getMaxTorque = function (t) {
          return this.equations[0].maxForce;
        };
      }, {
        "../equations/AngleLockEquation": 20,
        "../equations/Equation": 22,
        "../math/vec2": 30,
        "./Constraint": 14
      }],
      17: [function (t, e, i) {
        var s = t("./Constraint"),
            n = t("../math/vec2"),
            o = t("../equations/Equation");

        function r(t, e, i) {
          i = i || {}, s.call(this, t, e, s.LOCK, i);
          var r = void 0 === i.maxForce ? Number.MAX_VALUE : i.maxForce,
              a = (i.localAngleB, new o(t, e, -r, r)),
              h = new o(t, e, -r, r),
              l = new o(t, e, -r, r),
              c = n.create(),
              u = n.create(),
              d = this;
          a.computeGq = function () {
            return n.rotate(c, d.localOffsetB, t.angle), n.sub(u, e.position, t.position), n.sub(u, u, c), u[0];
          }, h.computeGq = function () {
            return n.rotate(c, d.localOffsetB, t.angle), n.sub(u, e.position, t.position), n.sub(u, u, c), u[1];
          };
          var p = n.create(),
              f = n.create();
          l.computeGq = function () {
            return n.rotate(p, d.localOffsetB, e.angle - d.localAngleB), n.scale(p, p, -1), n.sub(u, t.position, e.position), n.add(u, u, p), n.rotate(f, p, -Math.PI / 2), n.normalize(f, f), n.dot(u, f);
          }, this.localOffsetB = n.create(), i.localOffsetB ? n.copy(this.localOffsetB, i.localOffsetB) : (n.sub(this.localOffsetB, e.position, t.position), n.rotate(this.localOffsetB, this.localOffsetB, -t.angle)), this.localAngleB = 0, "number" == typeof i.localAngleB ? this.localAngleB = i.localAngleB : this.localAngleB = e.angle - t.angle, this.equations.push(a, h, l), this.setMaxForce(r);
        }

        e.exports = r, r.prototype = new s(), r.prototype.constructor = r, r.prototype.setMaxForce = function (t) {
          for (var e = this.equations, i = 0; i < this.equations.length; i++) {
            e[i].maxForce = t, e[i].minForce = -t;
          }
        }, r.prototype.getMaxForce = function () {
          return this.equations[0].maxForce;
        };
        var a = n.create(),
            h = n.create(),
            l = n.create(),
            c = n.fromValues(1, 0),
            u = n.fromValues(0, 1);

        r.prototype.update = function () {
          var t = this.equations[0],
              e = this.equations[1],
              i = this.equations[2],
              s = this.bodyA,
              o = this.bodyB;
          n.rotate(a, this.localOffsetB, s.angle), n.rotate(h, this.localOffsetB, o.angle - this.localAngleB), n.scale(h, h, -1), n.rotate(l, h, Math.PI / 2), n.normalize(l, l), t.G[0] = -1, t.G[1] = 0, t.G[2] = -n.crossLength(a, c), t.G[3] = 1, e.G[0] = 0, e.G[1] = -1, e.G[2] = -n.crossLength(a, u), e.G[4] = 1, i.G[0] = -l[0], i.G[1] = -l[1], i.G[3] = l[0], i.G[4] = l[1], i.G[5] = n.crossLength(h, l);
        };
      }, {
        "../equations/Equation": 22,
        "../math/vec2": 30,
        "./Constraint": 14
      }],
      18: [function (t, e, i) {
        var s = t("./Constraint"),
            n = t("../equations/ContactEquation"),
            o = t("../equations/Equation"),
            r = t("../math/vec2"),
            a = t("../equations/RotationalLockEquation");

        function h(t, e, i) {
          i = i || {}, s.call(this, t, e, s.PRISMATIC, i);
          var h = r.fromValues(0, 0),
              l = r.fromValues(1, 0),
              c = r.fromValues(0, 0);
          i.localAnchorA && r.copy(h, i.localAnchorA), i.localAxisA && r.copy(l, i.localAxisA), i.localAnchorB && r.copy(c, i.localAnchorB), this.localAnchorA = h, this.localAnchorB = c, this.localAxisA = l;
          var u = this.maxForce = void 0 !== i.maxForce ? i.maxForce : Number.MAX_VALUE,
              d = new o(t, e, -u, u),
              p = new r.create(),
              f = new r.create(),
              g = new r.create(),
              m = new r.create();

          if (d.computeGq = function () {
            return r.dot(g, m);
          }, d.updateJacobian = function () {
            var i = this.G,
                s = t.position,
                n = e.position;
            r.rotate(p, h, t.angle), r.rotate(f, c, e.angle), r.add(g, n, f), r.sub(g, g, s), r.sub(g, g, p), r.rotate(m, l, t.angle + Math.PI / 2), i[0] = -m[0], i[1] = -m[1], i[2] = -r.crossLength(p, m) + r.crossLength(m, g), i[3] = m[0], i[4] = m[1], i[5] = r.crossLength(f, m);
          }, this.equations.push(d), !i.disableRotationalLock) {
            var y = new a(t, e, -u, u);
            this.equations.push(y);
          }

          this.position = 0, this.velocity = 0, this.lowerLimitEnabled = void 0 !== i.lowerLimit, this.upperLimitEnabled = void 0 !== i.upperLimit, this.lowerLimit = void 0 !== i.lowerLimit ? i.lowerLimit : 0, this.upperLimit = void 0 !== i.upperLimit ? i.upperLimit : 1, this.upperLimitEquation = new n(t, e), this.lowerLimitEquation = new n(t, e), this.upperLimitEquation.minForce = this.lowerLimitEquation.minForce = 0, this.upperLimitEquation.maxForce = this.lowerLimitEquation.maxForce = u, this.motorEquation = new o(t, e), this.motorEnabled = !1, this.motorSpeed = 0;
          var v = this,
              b = this.motorEquation;
          b.computeGW, b.computeGq = function () {
            return 0;
          }, b.computeGW = function () {
            var t = this.G,
                e = this.bodyA,
                i = this.bodyB,
                s = e.velocity,
                n = i.velocity,
                o = e.angularVelocity,
                r = i.angularVelocity;
            return this.gmult(t, s, o, n, r) + v.motorSpeed;
          };
        }

        e.exports = h, h.prototype = new s(), h.prototype.constructor = h;
        var l = r.create(),
            c = r.create(),
            u = r.create(),
            d = r.create(),
            p = r.create(),
            f = r.create();
        h.prototype.update = function () {
          var t = this.equations,
              e = t[0],
              i = this.upperLimit,
              s = this.lowerLimit,
              n = this.upperLimitEquation,
              o = this.lowerLimitEquation,
              a = this.bodyA,
              h = this.bodyB,
              g = this.localAxisA,
              m = this.localAnchorA,
              y = this.localAnchorB;
          e.updateJacobian(), r.rotate(l, g, a.angle), r.rotate(d, m, a.angle), r.add(c, d, a.position), r.rotate(p, y, h.angle), r.add(u, p, h.position);
          var v = this.position = r.dot(u, l) - r.dot(c, l);

          if (this.motorEnabled) {
            var b = this.motorEquation.G;
            b[0] = l[0], b[1] = l[1], b[2] = r.crossLength(l, p), b[3] = -l[0], b[4] = -l[1], b[5] = -r.crossLength(l, d);
          }

          if (this.upperLimitEnabled && v > i) r.scale(n.normalA, l, -1), r.sub(n.contactPointA, c, a.position), r.sub(n.contactPointB, u, h.position), r.scale(f, l, i), r.add(n.contactPointA, n.contactPointA, f), -1 === t.indexOf(n) && t.push(n);else {
            var x = t.indexOf(n);
            -1 !== x && t.splice(x, 1);
          }
          if (this.lowerLimitEnabled && v < s) r.scale(o.normalA, l, 1), r.sub(o.contactPointA, c, a.position), r.sub(o.contactPointB, u, h.position), r.scale(f, l, s), r.sub(o.contactPointB, o.contactPointB, f), -1 === t.indexOf(o) && t.push(o);else {
            var x = t.indexOf(o);
            -1 !== x && t.splice(x, 1);
          }
        }, h.prototype.enableMotor = function () {
          this.motorEnabled || (this.equations.push(this.motorEquation), this.motorEnabled = !0);
        }, h.prototype.disableMotor = function () {
          if (this.motorEnabled) {
            var t = this.equations.indexOf(this.motorEquation);
            this.equations.splice(t, 1), this.motorEnabled = !1;
          }
        }, h.prototype.setLimits = function (t, e) {
          "number" == typeof t ? (this.lowerLimit = t, this.lowerLimitEnabled = !0) : (this.lowerLimit = t, this.lowerLimitEnabled = !1), "number" == typeof e ? (this.upperLimit = e, this.upperLimitEnabled = !0) : (this.upperLimit = e, this.upperLimitEnabled = !1);
        };
      }, {
        "../equations/ContactEquation": 21,
        "../equations/Equation": 22,
        "../equations/RotationalLockEquation": 24,
        "../math/vec2": 30,
        "./Constraint": 14
      }],
      19: [function (t, e, i) {
        var s = t("./Constraint"),
            n = t("../equations/Equation"),
            o = t("../equations/RotationalVelocityEquation"),
            r = t("../equations/RotationalLockEquation"),
            a = t("../math/vec2");
        e.exports = p;
        var h = a.create(),
            l = a.create(),
            c = a.fromValues(1, 0),
            u = a.fromValues(0, 1),
            d = a.create();

        function p(t, e, i) {
          i = i || {}, s.call(this, t, e, s.REVOLUTE, i);
          var p = this.maxForce = void 0 !== i.maxForce ? i.maxForce : Number.MAX_VALUE;
          this.pivotA = a.create(), this.pivotB = a.create(), i.worldPivot ? (a.sub(this.pivotA, i.worldPivot, t.position), a.sub(this.pivotB, i.worldPivot, e.position), a.rotate(this.pivotA, this.pivotA, -t.angle), a.rotate(this.pivotB, this.pivotB, -e.angle)) : (a.copy(this.pivotA, i.localPivotA), a.copy(this.pivotB, i.localPivotB));
          var f = this.equations = [new n(t, e, -p, p), new n(t, e, -p, p)],
              g = f[0],
              m = f[1],
              y = this;
          g.computeGq = function () {
            return a.rotate(h, y.pivotA, t.angle), a.rotate(l, y.pivotB, e.angle), a.add(d, e.position, l), a.sub(d, d, t.position), a.sub(d, d, h), a.dot(d, c);
          }, m.computeGq = function () {
            return a.rotate(h, y.pivotA, t.angle), a.rotate(l, y.pivotB, e.angle), a.add(d, e.position, l), a.sub(d, d, t.position), a.sub(d, d, h), a.dot(d, u);
          }, m.minForce = g.minForce = -p, m.maxForce = g.maxForce = p, this.motorEquation = new o(t, e), this.motorEnabled = !1, this.angle = 0, this.lowerLimitEnabled = !1, this.upperLimitEnabled = !1, this.lowerLimit = 0, this.upperLimit = 0, this.upperLimitEquation = new r(t, e), this.lowerLimitEquation = new r(t, e), this.upperLimitEquation.minForce = 0, this.lowerLimitEquation.maxForce = 0;
        }

        p.prototype = new s(), p.prototype.constructor = p, p.prototype.setLimits = function (t, e) {
          "number" == typeof t ? (this.lowerLimit = t, this.lowerLimitEnabled = !0) : (this.lowerLimit = t, this.lowerLimitEnabled = !1), "number" == typeof e ? (this.upperLimit = e, this.upperLimitEnabled = !0) : (this.upperLimit = e, this.upperLimitEnabled = !1);
        }, p.prototype.update = function () {
          var t = this.bodyA,
              e = this.bodyB,
              i = this.pivotA,
              s = this.pivotB,
              n = this.equations,
              o = (n[0], n[1], n[0]),
              r = n[1],
              d = this.upperLimit,
              p = this.lowerLimit,
              f = this.upperLimitEquation,
              g = this.lowerLimitEquation,
              m = this.angle = e.angle - t.angle;
          if (this.upperLimitEnabled && m > d) f.angle = d, -1 === n.indexOf(f) && n.push(f);else {
            var y = n.indexOf(f);
            -1 !== y && n.splice(y, 1);
          }
          if (this.lowerLimitEnabled && m < p) g.angle = p, -1 === n.indexOf(g) && n.push(g);else {
            var y = n.indexOf(g);
            -1 !== y && n.splice(y, 1);
          }
          a.rotate(h, i, t.angle), a.rotate(l, s, e.angle), o.G[0] = -1, o.G[1] = 0, o.G[2] = -a.crossLength(h, c), o.G[3] = 1, o.G[4] = 0, o.G[5] = a.crossLength(l, c), r.G[0] = 0, r.G[1] = -1, r.G[2] = -a.crossLength(h, u), r.G[3] = 0, r.G[4] = 1, r.G[5] = a.crossLength(l, u);
        }, p.prototype.enableMotor = function () {
          this.motorEnabled || (this.equations.push(this.motorEquation), this.motorEnabled = !0);
        }, p.prototype.disableMotor = function () {
          if (this.motorEnabled) {
            var t = this.equations.indexOf(this.motorEquation);
            this.equations.splice(t, 1), this.motorEnabled = !1;
          }
        }, p.prototype.setMotorSpeed = function (t) {
          if (this.motorEnabled) {
            var e = this.equations.indexOf(this.motorEquation);
            this.equations[e].relativeVelocity = t;
          }
        }, p.prototype.getMotorSpeed = function () {
          return !!this.motorEnabled && this.motorEquation.relativeVelocity;
        };
      }, {
        "../equations/Equation": 22,
        "../equations/RotationalLockEquation": 24,
        "../equations/RotationalVelocityEquation": 25,
        "../math/vec2": 30,
        "./Constraint": 14
      }],
      20: [function (t, e, i) {
        var s = t("./Equation");

        function n(t, e, i) {
          i = i || {}, s.call(this, t, e, -Number.MAX_VALUE, Number.MAX_VALUE), this.angle = i.angle || 0, this.ratio = "number" == typeof i.ratio ? i.ratio : 1, this.setRatio(this.ratio);
        }

        t("../math/vec2"), e.exports = n, n.prototype = new s(), n.prototype.constructor = n, n.prototype.computeGq = function () {
          return this.ratio * this.bodyA.angle - this.bodyB.angle + this.angle;
        }, n.prototype.setRatio = function (t) {
          var e = this.G;
          e[2] = t, e[5] = -1, this.ratio = t;
        }, n.prototype.setMaxTorque = function (t) {
          this.maxForce = t, this.minForce = -t;
        };
      }, {
        "../math/vec2": 30,
        "./Equation": 22
      }],
      21: [function (t, e, i) {
        var s = t("./Equation"),
            n = t("../math/vec2");

        function o(t, e) {
          s.call(this, t, e, 0, Number.MAX_VALUE), this.contactPointA = n.create(), this.penetrationVec = n.create(), this.contactPointB = n.create(), this.normalA = n.create(), this.restitution = 0, this.firstImpact = !1, this.shapeA = null, this.shapeB = null;
        }

        e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.computeB = function (t, e, i) {
          var s,
              o,
              r = this.bodyA,
              a = this.bodyB,
              h = this.contactPointA,
              l = this.contactPointB,
              c = r.position,
              u = a.position,
              d = this.penetrationVec,
              p = this.normalA,
              f = this.G,
              g = n.crossLength(h, p),
              m = n.crossLength(l, p);
          f[0] = -p[0], f[1] = -p[1], f[2] = -g, f[3] = p[0], f[4] = p[1], f[5] = m, n.add(d, u, l), n.sub(d, d, c), n.sub(d, d, h), this.firstImpact && 0 !== this.restitution ? (o = 0, s = 1 / e * (1 + this.restitution) * this.computeGW()) : (o = n.dot(p, d) + this.offset, s = this.computeGW());
          var y = this.computeGiMf(),
              v = -o * t - s * e - i * y;
          return v;
        };
        var r = n.create(),
            a = n.create(),
            h = n.create();

        o.prototype.getVelocityAlongNormal = function () {
          return this.bodyA.getVelocityAtPoint(r, this.contactPointA), this.bodyB.getVelocityAtPoint(a, this.contactPointB), n.subtract(h, r, a), n.dot(this.normalA, h);
        };
      }, {
        "../math/vec2": 30,
        "./Equation": 22
      }],
      22: [function (t, e, i) {
        e.exports = o;
        var s = t("../math/vec2"),
            n = t("../utils/Utils");

        function o(t, e, i, s) {
          this.minForce = void 0 === i ? -Number.MAX_VALUE : i, this.maxForce = void 0 === s ? Number.MAX_VALUE : s, this.bodyA = t, this.bodyB = e, this.stiffness = o.DEFAULT_STIFFNESS, this.relaxation = o.DEFAULT_RELAXATION, this.G = new n.ARRAY_TYPE(6);

          for (var r = 0; r < 6; r++) {
            this.G[r] = 0;
          }

          this.offset = 0, this.a = 0, this.b = 0, this.epsilon = 0, this.timeStep = 1 / 60, this.needsUpdate = !0, this.multiplier = 0, this.relativeVelocity = 0, this.enabled = !0;
        }

        t("../objects/Body"), o.prototype.constructor = o, o.DEFAULT_STIFFNESS = 1e6, o.DEFAULT_RELAXATION = 4, o.prototype.update = function () {
          var t = this.stiffness,
              e = this.relaxation,
              i = this.timeStep;
          this.a = 4 / (i * (1 + 4 * e)), this.b = 4 * e / (1 + 4 * e), this.epsilon = 4 / (i * i * t * (1 + 4 * e)), this.needsUpdate = !1;
        }, o.prototype.gmult = function (t, e, i, s, n) {
          return t[0] * e[0] + t[1] * e[1] + t[2] * i + t[3] * s[0] + t[4] * s[1] + t[5] * n;
        }, o.prototype.computeB = function (t, e, i) {
          var s = this.computeGW(),
              n = this.computeGq(),
              o = this.computeGiMf();
          return -n * t - s * e - o * i;
        };
        var r = s.create(),
            a = s.create();
        o.prototype.computeGq = function () {
          var t = this.G,
              e = this.bodyA,
              i = this.bodyB,
              s = (e.position, i.position, e.angle),
              n = i.angle;
          return this.gmult(t, r, s, a, n) + this.offset;
        }, o.prototype.computeGW = function () {
          var t = this.G,
              e = this.bodyA,
              i = this.bodyB,
              s = e.velocity,
              n = i.velocity,
              o = e.angularVelocity,
              r = i.angularVelocity;
          return this.gmult(t, s, o, n, r) + this.relativeVelocity;
        }, o.prototype.computeGWlambda = function () {
          var t = this.G,
              e = this.bodyA,
              i = this.bodyB,
              s = e.vlambda,
              n = i.vlambda,
              o = e.wlambda,
              r = i.wlambda;
          return this.gmult(t, s, o, n, r);
        };
        var h = s.create(),
            l = s.create();
        o.prototype.computeGiMf = function () {
          var t = this.bodyA,
              e = this.bodyB,
              i = t.force,
              n = t.angularForce,
              o = e.force,
              r = e.angularForce,
              a = t.invMassSolve,
              c = e.invMassSolve,
              u = t.invInertiaSolve,
              d = e.invInertiaSolve,
              p = this.G;
          return s.scale(h, i, a), s.multiply(h, t.massMultiplier, h), s.scale(l, o, c), s.multiply(l, e.massMultiplier, l), this.gmult(p, h, n * u, l, r * d);
        }, o.prototype.computeGiMGt = function () {
          var t = this.bodyA,
              e = this.bodyB,
              i = t.invMassSolve,
              s = e.invMassSolve,
              n = t.invInertiaSolve,
              o = e.invInertiaSolve,
              r = this.G;
          return r[0] * r[0] * i * t.massMultiplier[0] + r[1] * r[1] * i * t.massMultiplier[1] + r[2] * r[2] * n + r[3] * r[3] * s * e.massMultiplier[0] + r[4] * r[4] * s * e.massMultiplier[1] + r[5] * r[5] * o;
        };
        var c = s.create(),
            u = s.create(),
            d = s.create();
        s.create(), s.create(), s.create(), o.prototype.addToWlambda = function (t) {
          var e = this.bodyA,
              i = this.bodyB,
              n = c,
              o = u,
              r = d,
              a = e.invMassSolve,
              h = i.invMassSolve,
              l = e.invInertiaSolve,
              p = i.invInertiaSolve,
              f = this.G;
          o[0] = f[0], o[1] = f[1], r[0] = f[3], r[1] = f[4], s.scale(n, o, a * t), s.multiply(n, n, e.massMultiplier), s.add(e.vlambda, e.vlambda, n), e.wlambda += l * f[2] * t, s.scale(n, r, h * t), s.multiply(n, n, i.massMultiplier), s.add(i.vlambda, i.vlambda, n), i.wlambda += p * f[5] * t;
        }, o.prototype.computeInvC = function (t) {
          return 1 / (this.computeGiMGt() + t);
        };
      }, {
        "../math/vec2": 30,
        "../objects/Body": 31,
        "../utils/Utils": 57
      }],
      23: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = t("./Equation");

        function o(t, e, i) {
          n.call(this, t, e, -i, i), this.contactPointA = s.create(), this.contactPointB = s.create(), this.t = s.create(), this.contactEquations = [], this.shapeA = null, this.shapeB = null, this.frictionCoefficient = .3;
        }

        t("../utils/Utils"), e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.setSlipForce = function (t) {
          this.maxForce = t, this.minForce = -t;
        }, o.prototype.getSlipForce = function () {
          return this.maxForce;
        }, o.prototype.computeB = function (t, e, i) {
          this.bodyA, this.bodyB;
          var n = this.contactPointA,
              o = this.contactPointB,
              r = this.t,
              a = this.G;
          a[0] = -r[0], a[1] = -r[1], a[2] = -s.crossLength(n, r), a[3] = r[0], a[4] = r[1], a[5] = s.crossLength(o, r);
          var h = this.computeGW(),
              l = this.computeGiMf(),
              c = -h * e - i * l;
          return c;
        };
      }, {
        "../math/vec2": 30,
        "../utils/Utils": 57,
        "./Equation": 22
      }],
      24: [function (t, e, i) {
        var s = t("./Equation"),
            n = t("../math/vec2");

        function o(t, e, i) {
          i = i || {}, s.call(this, t, e, -Number.MAX_VALUE, Number.MAX_VALUE), this.angle = i.angle || 0;
          var n = this.G;
          n[2] = 1, n[5] = -1;
        }

        e.exports = o, o.prototype = new s(), o.prototype.constructor = o;
        var r = n.create(),
            a = n.create(),
            h = n.fromValues(1, 0),
            l = n.fromValues(0, 1);

        o.prototype.computeGq = function () {
          return n.rotate(r, h, this.bodyA.angle + this.angle), n.rotate(a, l, this.bodyB.angle), n.dot(r, a);
        };
      }, {
        "../math/vec2": 30,
        "./Equation": 22
      }],
      25: [function (t, e, i) {
        var s = t("./Equation");

        function n(t, e) {
          s.call(this, t, e, -Number.MAX_VALUE, Number.MAX_VALUE), this.relativeVelocity = 1, this.ratio = 1;
        }

        t("../math/vec2"), e.exports = n, n.prototype = new s(), n.prototype.constructor = n, n.prototype.computeB = function (t, e, i) {
          var s = this.G;
          s[2] = -1, s[5] = this.ratio;
          var n = this.computeGiMf(),
              o = this.computeGW(),
              r = -o * e - i * n;
          return r;
        };
      }, {
        "../math/vec2": 30,
        "./Equation": 22
      }],
      26: [function (t, e, i) {
        var s = function s() {};

        e.exports = s, s.prototype = {
          constructor: s,
          on: function on(t, e, i) {
            e.context = i || this, void 0 === this._listeners && (this._listeners = {});
            var s = this._listeners;
            return void 0 === s[t] && (s[t] = []), -1 === s[t].indexOf(e) && s[t].push(e), this;
          },
          has: function has(t, e) {
            if (void 0 === this._listeners) return !1;
            var i = this._listeners;

            if (e) {
              if (void 0 !== i[t] && -1 !== i[t].indexOf(e)) return !0;
            } else if (void 0 !== i[t]) return !0;

            return !1;
          },
          off: function off(t, e) {
            if (void 0 === this._listeners) return this;
            var i = this._listeners,
                s = i[t].indexOf(e);
            return -1 !== s && i[t].splice(s, 1), this;
          },
          emit: function emit(t) {
            if (void 0 === this._listeners) return this;
            var e = this._listeners,
                i = e[t.type];

            if (void 0 !== i) {
              t.target = this;

              for (var s = 0, n = i.length; s < n; s++) {
                var o = i[s];
                o.call(o.context, t);
              }
            }

            return this;
          }
        };
      }, {}],
      27: [function (t, e, i) {
        var s = t("./Material"),
            n = t("../equations/Equation");

        function o(t, e, i) {
          if (i = i || {}, !(t instanceof s && e instanceof s)) throw new Error("First two arguments must be Material instances.");
          this.id = o.idCounter++, this.materialA = t, this.materialB = e, this.friction = void 0 !== i.friction ? Number(i.friction) : .3, this.restitution = void 0 !== i.restitution ? Number(i.restitution) : 0, this.stiffness = void 0 !== i.stiffness ? Number(i.stiffness) : n.DEFAULT_STIFFNESS, this.relaxation = void 0 !== i.relaxation ? Number(i.relaxation) : n.DEFAULT_RELAXATION, this.frictionStiffness = void 0 !== i.frictionStiffness ? Number(i.frictionStiffness) : n.DEFAULT_STIFFNESS, this.frictionRelaxation = void 0 !== i.frictionRelaxation ? Number(i.frictionRelaxation) : n.DEFAULT_RELAXATION, this.surfaceVelocity = void 0 !== i.surfaceVelocity ? Number(i.surfaceVelocity) : 0, this.contactSkinSize = .005;
        }

        e.exports = o, o.idCounter = 0;
      }, {
        "../equations/Equation": 22,
        "./Material": 28
      }],
      28: [function (t, e, i) {
        function s(t) {
          this.id = t || s.idCounter++;
        }

        e.exports = s, s.idCounter = 0;
      }, {}],
      29: [function (t, e, i) {
        var s = {
          GetArea: function GetArea(t) {
            if (t.length < 6) return 0;

            for (var e = t.length - 2, i = 0, s = 0; s < e; s += 2) {
              i += (t[s + 2] - t[s]) * (t[s + 1] + t[s + 3]);
            }

            return .5 * -(i += (t[0] - t[e]) * (t[e + 1] + t[1]));
          },
          Triangulate: function Triangulate(t) {
            var e = t.length >> 1;
            if (e < 3) return [];

            for (var i = [], n = [], o = 0; o < e; o++) {
              n.push(o);
            }

            for (var o = 0, r = e; r > 3;) {
              var a = n[(o + 0) % r],
                  h = n[(o + 1) % r],
                  l = n[(o + 2) % r],
                  c = t[2 * a],
                  u = t[2 * a + 1],
                  d = t[2 * h],
                  p = t[2 * h + 1],
                  f = t[2 * l],
                  g = t[2 * l + 1],
                  m = !1;

              if (s._convex(c, u, d, p, f, g)) {
                m = !0;

                for (var y = 0; y < r; y++) {
                  var v = n[y];

                  if (v != a && v != h && v != l && s._PointInTriangle(t[2 * v], t[2 * v + 1], c, u, d, p, f, g)) {
                    m = !1;
                    break;
                  }
                }
              }

              if (m) i.push(a, h, l), n.splice((o + 1) % r, 1), r--, o = 0;else if (o++ > 3 * r) break;
            }

            return i.push(n[0], n[1], n[2]), i;
          },
          _PointInTriangle: function _PointInTriangle(t, e, i, s, n, o, r, a) {
            var h = r - i,
                l = a - s,
                c = n - i,
                u = o - s,
                d = t - i,
                p = e - s,
                f = h * h + l * l,
                g = h * c + l * u,
                m = h * d + l * p,
                y = c * c + u * u,
                v = c * d + u * p,
                b = 1 / (f * y - g * g),
                x = (y * m - g * v) * b,
                w = (f * v - g * m) * b;
            return x >= 0 && w >= 0 && x + w < 1;
          },
          _convex: function _convex(t, e, i, s, n, o) {
            return (e - s) * (n - i) + (i - t) * (o - s) >= 0;
          }
        };
        e.exports = s;
      }, {}],
      30: [function (t, e, i) {
        var s = e.exports = {},
            n = t("../utils/Utils");
        s.crossLength = function (t, e) {
          return t[0] * e[1] - t[1] * e[0];
        }, s.crossVZ = function (t, e, i) {
          return s.rotate(t, e, -Math.PI / 2), s.scale(t, t, i), t;
        }, s.crossZV = function (t, e, i) {
          return s.rotate(t, i, Math.PI / 2), s.scale(t, t, e), t;
        }, s.rotate = function (t, e, i) {
          if (0 !== i) {
            var s = Math.cos(i),
                n = Math.sin(i),
                o = e[0],
                r = e[1];
            t[0] = s * o - n * r, t[1] = n * o + s * r;
          } else t[0] = e[0], t[1] = e[1];
        }, s.rotate90cw = function (t, e) {
          var i = e[0],
              s = e[1];
          t[0] = s, t[1] = -i;
        }, s.toLocalFrame = function (t, e, i, n) {
          s.copy(t, e), s.sub(t, t, i), s.rotate(t, t, -n);
        }, s.toGlobalFrame = function (t, e, i, n) {
          s.copy(t, e), s.rotate(t, t, n), s.add(t, t, i);
        }, s.vectorToLocalFrame = function (t, e, i) {
          s.rotate(t, e, -i);
        }, s.vectorToGlobalFrame = function (t, e, i) {
          s.rotate(t, e, i);
        }, s.centroid = function (t, e, i, n) {
          return s.add(t, e, i), s.add(t, t, n), s.scale(t, t, 1 / 3), t;
        }, s.create = function () {
          var t = new n.ARRAY_TYPE(2);
          return t[0] = 0, t[1] = 0, t;
        }, s.clone = function (t) {
          var e = new n.ARRAY_TYPE(2);
          return e[0] = t[0], e[1] = t[1], e;
        }, s.fromValues = function (t, e) {
          var i = new n.ARRAY_TYPE(2);
          return i[0] = t, i[1] = e, i;
        }, s.copy = function (t, e) {
          return t[0] = e[0], t[1] = e[1], t;
        }, s.set = function (t, e, i) {
          return t[0] = e, t[1] = i, t;
        }, s.add = function (t, e, i) {
          return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t;
        }, s.subtract = function (t, e, i) {
          return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t;
        }, s.sub = s.subtract, s.multiply = function (t, e, i) {
          return t[0] = e[0] * i[0], t[1] = e[1] * i[1], t;
        }, s.mul = s.multiply, s.divide = function (t, e, i) {
          return t[0] = e[0] / i[0], t[1] = e[1] / i[1], t;
        }, s.div = s.divide, s.scale = function (t, e, i) {
          return t[0] = e[0] * i, t[1] = e[1] * i, t;
        }, s.distance = function (t, e) {
          var i = e[0] - t[0],
              s = e[1] - t[1];
          return Math.sqrt(i * i + s * s);
        }, s.dist = s.distance, s.squaredDistance = function (t, e) {
          var i = e[0] - t[0],
              s = e[1] - t[1];
          return i * i + s * s;
        }, s.sqrDist = s.squaredDistance, s.length = function (t) {
          var e = t[0],
              i = t[1];
          return Math.sqrt(e * e + i * i);
        }, s.len = s.length, s.squaredLength = function (t) {
          var e = t[0],
              i = t[1];
          return e * e + i * i;
        }, s.sqrLen = s.squaredLength, s.negate = function (t, e) {
          return t[0] = -e[0], t[1] = -e[1], t;
        }, s.normalize = function (t, e) {
          var i = e[0],
              s = e[1],
              n = i * i + s * s;
          return n > 0 && (n = 1 / Math.sqrt(n), t[0] = e[0] * n, t[1] = e[1] * n), t;
        }, s.dot = function (t, e) {
          return t[0] * e[0] + t[1] * e[1];
        }, s.str = function (t) {
          return "vec2(" + t[0] + ", " + t[1] + ")";
        }, s.lerp = function (t, e, i, s) {
          var n = e[0],
              o = e[1];
          return t[0] = n + s * (i[0] - n), t[1] = o + s * (i[1] - o), t;
        }, s.reflect = function (t, e, i) {
          var s = e[0] * i[0] + e[1] * i[1];
          t[0] = e[0] - 2 * i[0] * s, t[1] = e[1] - 2 * i[1] * s;
        }, s.getLineSegmentsIntersection = function (t, e, i, n, o) {
          var r = s.getLineSegmentsIntersectionFraction(e, i, n, o);
          return !(r < 0 || (t[0] = e[0] + r * (i[0] - e[0]), t[1] = e[1] + r * (i[1] - e[1]), 0));
        }, s.getLineSegmentsIntersectionFraction = function (t, e, i, s) {
          var n,
              o,
              r = e[0] - t[0],
              a = e[1] - t[1],
              h = s[0] - i[0],
              l = s[1] - i[1];
          return n = (-a * (t[0] - i[0]) + r * (t[1] - i[1])) / (-h * a + r * l), o = (h * (t[1] - i[1]) - l * (t[0] - i[0])) / (-h * a + r * l), n >= 0 && n <= 1 && o >= 0 && o <= 1 ? o : -1;
        };
      }, {
        "../utils/Utils": 57
      }],
      31: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = t("poly-decomp"),
            o = t("../shapes/Convex"),
            r = t("../collision/RaycastResult"),
            a = t("../collision/Ray"),
            h = t("../collision/AABB"),
            l = t("../events/EventEmitter");

        function c(t) {
          t = t || {}, l.call(this), this.id = t.id || ++c._idCounter, this.world = null, this.shapes = [], this.mass = t.mass || 0, this.invMass = 0, this.inertia = 0, this.invInertia = 0, this.invMassSolve = 0, this.invInertiaSolve = 0, this.fixedRotation = !!t.fixedRotation, this.fixedX = !!t.fixedX, this.fixedY = !!t.fixedY, this.massMultiplier = s.create(), this.position = s.fromValues(0, 0), t.position && s.copy(this.position, t.position), this.interpolatedPosition = s.fromValues(0, 0), this.interpolatedAngle = 0, this.previousPosition = s.fromValues(0, 0), this.previousAngle = 0, this.velocity = s.fromValues(0, 0), t.velocity && s.copy(this.velocity, t.velocity), this.vlambda = s.fromValues(0, 0), this.wlambda = 0, this.angle = t.angle || 0, this.angularVelocity = t.angularVelocity || 0, this.force = s.create(), t.force && s.copy(this.force, t.force), this.angularForce = t.angularForce || 0, this.damping = "number" == typeof t.damping ? t.damping : .1, this.angularDamping = "number" == typeof t.angularDamping ? t.angularDamping : .1, this.type = c.STATIC, void 0 !== t.type ? this.type = t.type : t.mass ? this.type = c.DYNAMIC : this.type = c.STATIC, this.boundingRadius = 0, this.aabb = new h(), this.aabbNeedsUpdate = !0, this.allowSleep = void 0 === t.allowSleep || t.allowSleep, this.wantsToSleep = !1, this.sleepState = c.AWAKE, this.sleepSpeedLimit = void 0 !== t.sleepSpeedLimit ? t.sleepSpeedLimit : .2, this.sleepTimeLimit = void 0 !== t.sleepTimeLimit ? t.sleepTimeLimit : 1, this.gravityScale = void 0 !== t.gravityScale ? t.gravityScale : 1, this.collisionResponse = void 0 === t.collisionResponse || t.collisionResponse, this.idleTime = 0, this.timeLastSleepy = 0, this.ccdSpeedThreshold = void 0 !== t.ccdSpeedThreshold ? t.ccdSpeedThreshold : -1, this.ccdIterations = void 0 !== t.ccdIterations ? t.ccdIterations : 10, this.concavePath = null, this._wakeUpAfterNarrowphase = !1, this.updateMassProperties();
        }

        e.exports = c, c.prototype = new l(), c.prototype.constructor = c, c._idCounter = 0, c.prototype.updateSolveMassProperties = function () {
          this.sleepState === c.SLEEPING || this.type === c.KINEMATIC ? (this.invMassSolve = 0, this.invInertiaSolve = 0) : (this.invMassSolve = this.invMass, this.invInertiaSolve = this.invInertia);
        }, c.prototype.setDensity = function (t) {
          var e = this.getArea();
          this.mass = e * t, this.updateMassProperties();
        }, c.prototype.getArea = function () {
          for (var t = 0, e = 0; e < this.shapes.length; e++) {
            t += this.shapes[e].area;
          }

          return t;
        }, c.prototype.getAABB = function () {
          return this.aabbNeedsUpdate && this.updateAABB(), this.aabb;
        };
        var u = new h(),
            d = s.create();
        c.prototype.updateAABB = function () {
          for (var t = this.shapes, e = t.length, i = d, n = this.angle, o = 0; o !== e; o++) {
            var r = t[o],
                a = r.angle + n;
            s.rotate(i, r.position, n), s.add(i, i, this.position), r.computeAABB(u, i, a), 0 === o ? this.aabb.copy(u) : this.aabb.extend(u);
          }

          this.aabbNeedsUpdate = !1;
        }, c.prototype.updateBoundingRadius = function () {
          for (var t = this.shapes, e = t.length, i = 0, n = 0; n !== e; n++) {
            var o = t[n],
                r = s.length(o.position),
                a = o.boundingRadius;
            r + a > i && (i = r + a);
          }

          this.boundingRadius = i;
        }, c.prototype.addShape = function (t, e, i) {
          if (t.body) throw new Error("A shape can only be added to one body.");
          t.body = this, e ? s.copy(t.position, e) : s.set(t.position, 0, 0), t.angle = i || 0, this.shapes.push(t), this.updateMassProperties(), this.updateBoundingRadius(), this.aabbNeedsUpdate = !0;
        }, c.prototype.removeShape = function (t) {
          var e = this.shapes.indexOf(t);
          return -1 !== e && (this.shapes.splice(e, 1), this.aabbNeedsUpdate = !0, t.body = null, !0);
        }, c.prototype.updateMassProperties = function () {
          if (this.type === c.STATIC || this.type === c.KINEMATIC) this.mass = Number.MAX_VALUE, this.invMass = 0, this.inertia = Number.MAX_VALUE, this.invInertia = 0;else {
            var t = this.shapes,
                e = t.length,
                i = this.mass / e,
                n = 0;
            if (this.fixedRotation) this.inertia = Number.MAX_VALUE, this.invInertia = 0;else {
              for (var o = 0; o < e; o++) {
                var r = t[o],
                    a = s.squaredLength(r.position),
                    h = r.computeMomentOfInertia(i);
                n += h + i * a;
              }

              this.inertia = n, this.invInertia = n > 0 ? 1 / n : 0;
            }
            this.invMass = 1 / this.mass, s.set(this.massMultiplier, this.fixedX ? 0 : 1, this.fixedY ? 0 : 1);
          }
        }, s.create(), c.prototype.applyForce = function (t, e) {
          if (s.add(this.force, this.force, t), e) {
            var i = s.crossLength(e, t);
            this.angularForce += i;
          }
        };
        var p = s.create(),
            f = s.create(),
            g = s.create();

        c.prototype.applyForceLocal = function (t, e) {
          e = e || g;
          var i = p,
              s = f;
          this.vectorToWorldFrame(i, t), this.vectorToWorldFrame(s, e), this.applyForce(i, s);
        };

        var m = s.create();

        c.prototype.applyImpulse = function (t, e) {
          if (this.type === c.DYNAMIC) {
            var i = m;

            if (s.scale(i, t, this.invMass), s.multiply(i, this.massMultiplier, i), s.add(this.velocity, i, this.velocity), e) {
              var n = s.crossLength(e, t);
              n *= this.invInertia, this.angularVelocity += n;
            }
          }
        };

        var y = s.create(),
            v = s.create(),
            b = s.create();
        c.prototype.applyImpulseLocal = function (t, e) {
          e = e || b;
          var i = y,
              s = v;
          this.vectorToWorldFrame(i, t), this.vectorToWorldFrame(s, e), this.applyImpulse(i, s);
        }, c.prototype.toLocalFrame = function (t, e) {
          s.toLocalFrame(t, e, this.position, this.angle);
        }, c.prototype.toWorldFrame = function (t, e) {
          s.toGlobalFrame(t, e, this.position, this.angle);
        }, c.prototype.vectorToLocalFrame = function (t, e) {
          s.vectorToLocalFrame(t, e, this.angle);
        }, c.prototype.vectorToWorldFrame = function (t, e) {
          s.vectorToGlobalFrame(t, e, this.angle);
        }, c.prototype.fromPolygon = function (t, e) {
          e = e || {};

          for (var i = this.shapes.length; i >= 0; --i) {
            this.removeShape(this.shapes[i]);
          }

          var r,
              a = new n.Polygon();
          if (a.vertices = t, a.makeCCW(), "number" == typeof e.removeCollinearPoints && a.removeCollinearPoints(e.removeCollinearPoints), void 0 === e.skipSimpleCheck && !a.isSimple()) return !1;
          this.concavePath = a.vertices.slice(0);

          for (var i = 0; i < this.concavePath.length; i++) {
            var h = [0, 0];
            s.copy(h, this.concavePath[i]), this.concavePath[i] = h;
          }

          r = e.optimalDecomp ? a.decomp() : a.quickDecomp();

          for (var l = s.create(), i = 0; i !== r.length; i++) {
            for (var c = new o({
              vertices: r[i].vertices
            }), u = 0; u !== c.vertices.length; u++) {
              var h = c.vertices[u];
              s.sub(h, h, c.centerOfMass);
            }

            s.scale(l, c.centerOfMass, 1), c.updateTriangles(), c.updateCenterOfMass(), c.updateBoundingRadius(), this.addShape(c, l);
          }

          return this.adjustCenterOfMass(), this.aabbNeedsUpdate = !0, !0;
        }, s.fromValues(0, 0);

        var x = s.fromValues(0, 0),
            w = s.fromValues(0, 0),
            _ = s.fromValues(0, 0);

        c.prototype.adjustCenterOfMass = function () {
          var t = x,
              e = w,
              i = _,
              n = 0;
          s.set(e, 0, 0);

          for (var o = 0; o !== this.shapes.length; o++) {
            var r = this.shapes[o];
            s.scale(t, r.position, r.area), s.add(e, e, t), n += r.area;
          }

          s.scale(i, e, 1 / n);

          for (var o = 0; o !== this.shapes.length; o++) {
            var r = this.shapes[o];
            s.sub(r.position, r.position, i);
          }

          s.add(this.position, this.position, i);

          for (var o = 0; this.concavePath && o < this.concavePath.length; o++) {
            s.sub(this.concavePath[o], this.concavePath[o], i);
          }

          this.updateMassProperties(), this.updateBoundingRadius();
        }, c.prototype.setZeroForce = function () {
          s.set(this.force, 0, 0), this.angularForce = 0;
        }, c.prototype.resetConstraintVelocity = function () {
          var t = this.vlambda;
          s.set(t, 0, 0), this.wlambda = 0;
        }, c.prototype.addConstraintVelocity = function () {
          var t = this,
              e = t.velocity;
          s.add(e, e, t.vlambda), t.angularVelocity += t.wlambda;
        }, c.prototype.applyDamping = function (t) {
          if (this.type === c.DYNAMIC) {
            var e = this.velocity;
            s.scale(e, e, Math.pow(1 - this.damping, t)), this.angularVelocity *= Math.pow(1 - this.angularDamping, t);
          }
        }, c.prototype.wakeUp = function () {
          var t = this.sleepState;
          this.sleepState = c.AWAKE, this.idleTime = 0, t !== c.AWAKE && this.emit(c.wakeUpEvent);
        }, c.prototype.sleep = function () {
          this.sleepState = c.SLEEPING, this.angularVelocity = 0, this.angularForce = 0, s.set(this.velocity, 0, 0), s.set(this.force, 0, 0), this.emit(c.sleepEvent);
        }, c.prototype.sleepTick = function (t, e, i) {
          if (this.allowSleep && this.type !== c.SLEEPING) {
            this.wantsToSleep = !1, this.sleepState;
            var n = s.squaredLength(this.velocity) + Math.pow(this.angularVelocity, 2),
                o = Math.pow(this.sleepSpeedLimit, 2);
            n >= o ? (this.idleTime = 0, this.sleepState = c.AWAKE) : (this.idleTime += i, this.sleepState = c.SLEEPY), this.idleTime > this.sleepTimeLimit && (e ? this.wantsToSleep = !0 : this.sleep());
          }
        }, c.prototype.overlaps = function (t) {
          return this.world.overlapKeeper.bodiesAreOverlapping(this, t);
        };
        var T = s.create(),
            P = s.create();

        c.prototype.integrate = function (t) {
          var e = this.invMass,
              i = this.force,
              n = this.position,
              o = this.velocity;
          s.copy(this.previousPosition, this.position), this.previousAngle = this.angle, this.fixedRotation || (this.angularVelocity += this.angularForce * this.invInertia * t), s.scale(T, i, t * e), s.multiply(T, this.massMultiplier, T), s.add(o, T, o), this.integrateToTimeOfImpact(t) || (s.scale(P, o, t), s.add(n, n, P), this.fixedRotation || (this.angle += this.angularVelocity * t)), this.aabbNeedsUpdate = !0;
        };

        var S = new r(),
            C = new a({
          mode: a.ALL
        }),
            A = s.create(),
            E = s.create(),
            M = s.create(),
            R = s.create();
        c.prototype.integrateToTimeOfImpact = function (t) {
          if (this.ccdSpeedThreshold < 0 || s.squaredLength(this.velocity) < Math.pow(this.ccdSpeedThreshold, 2)) return !1;
          s.normalize(A, this.velocity), s.scale(E, this.velocity, t), s.add(E, E, this.position), s.sub(M, E, this.position);
          var e,
              i = this.angularVelocity * t,
              n = s.length(M),
              o = 1,
              r = this;
          if (S.reset(), C.callback = function (t) {
            t.body !== r && (e = t.body, t.getHitPoint(E, C), s.sub(M, E, r.position), o = s.length(M) / n, t.stop());
          }, s.copy(C.from, this.position), s.copy(C.to, E), C.update(), this.world.raycast(S, C), !e) return !1;
          var a = this.angle;
          s.copy(R, this.position);

          for (var h = 0, l = 0, c = 0, u = o; u >= l && h < this.ccdIterations;) {
            h++, c = (u - l) / 2, s.scale(P, M, o), s.add(this.position, R, P), this.angle = a + i * o, this.updateAABB();
            var d = this.aabb.overlaps(e.aabb) && this.world.narrowphase.bodiesOverlap(this, e);
            d ? l = c : u = c;
          }

          return o = c, s.copy(this.position, R), this.angle = a, s.scale(P, M, o), s.add(this.position, this.position, P), this.fixedRotation || (this.angle += i * o), !0;
        }, c.prototype.getVelocityAtPoint = function (t, e) {
          return s.crossVZ(t, e, this.angularVelocity), s.subtract(t, this.velocity, t), t;
        }, c.sleepyEvent = {
          type: "sleepy"
        }, c.sleepEvent = {
          type: "sleep"
        }, c.wakeUpEvent = {
          type: "wakeup"
        }, c.DYNAMIC = 1, c.STATIC = 2, c.KINEMATIC = 4, c.AWAKE = 0, c.SLEEPY = 1, c.SLEEPING = 2;
      }, {
        "../collision/AABB": 7,
        "../collision/Ray": 11,
        "../collision/RaycastResult": 12,
        "../events/EventEmitter": 26,
        "../math/vec2": 30,
        "../shapes/Convex": 40,
        "poly-decomp": 5
      }],
      32: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = t("./Spring");

        function o(t, e, i) {
          i = i || {}, n.call(this, t, e, i), this.localAnchorA = s.fromValues(0, 0), this.localAnchorB = s.fromValues(0, 0), i.localAnchorA && s.copy(this.localAnchorA, i.localAnchorA), i.localAnchorB && s.copy(this.localAnchorB, i.localAnchorB), i.worldAnchorA && this.setWorldAnchorA(i.worldAnchorA), i.worldAnchorB && this.setWorldAnchorB(i.worldAnchorB);
          var o = s.create(),
              r = s.create();
          this.getWorldAnchorA(o), this.getWorldAnchorB(r);
          var a = s.distance(o, r);
          this.restLength = "number" == typeof i.restLength ? i.restLength : a;
        }

        t("../utils/Utils"), e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.setWorldAnchorA = function (t) {
          this.bodyA.toLocalFrame(this.localAnchorA, t);
        }, o.prototype.setWorldAnchorB = function (t) {
          this.bodyB.toLocalFrame(this.localAnchorB, t);
        }, o.prototype.getWorldAnchorA = function (t) {
          this.bodyA.toWorldFrame(t, this.localAnchorA);
        }, o.prototype.getWorldAnchorB = function (t) {
          this.bodyB.toWorldFrame(t, this.localAnchorB);
        };
        var r = s.create(),
            a = s.create(),
            h = s.create(),
            l = s.create(),
            c = s.create(),
            u = s.create(),
            d = s.create(),
            p = s.create(),
            f = s.create();

        o.prototype.applyForce = function () {
          var t = this.stiffness,
              e = this.damping,
              i = this.restLength,
              n = this.bodyA,
              o = this.bodyB,
              g = r,
              m = a,
              y = h,
              v = l,
              b = f,
              x = c,
              w = u,
              _ = d,
              T = p;
          this.getWorldAnchorA(x), this.getWorldAnchorB(w), s.sub(_, x, n.position), s.sub(T, w, o.position), s.sub(g, w, x);
          var P = s.len(g);
          s.normalize(m, g), s.sub(y, o.velocity, n.velocity), s.crossZV(b, o.angularVelocity, T), s.add(y, y, b), s.crossZV(b, n.angularVelocity, _), s.sub(y, y, b), s.scale(v, m, -t * (P - i) - e * s.dot(y, m)), s.sub(n.force, n.force, v), s.add(o.force, o.force, v);
          var S = s.crossLength(_, v),
              C = s.crossLength(T, v);
          n.angularForce -= S, o.angularForce += C;
        };
      }, {
        "../math/vec2": 30,
        "../utils/Utils": 57,
        "./Spring": 34
      }],
      33: [function (t, e, i) {
        t("../math/vec2");
        var s = t("./Spring");

        function n(t, e, i) {
          i = i || {}, s.call(this, t, e, i), this.restAngle = "number" == typeof i.restAngle ? i.restAngle : e.angle - t.angle;
        }

        e.exports = n, n.prototype = new s(), n.prototype.constructor = n, n.prototype.applyForce = function () {
          var t = this.stiffness,
              e = this.damping,
              i = this.restAngle,
              s = this.bodyA,
              n = this.bodyB,
              o = n.angle - s.angle,
              r = n.angularVelocity - s.angularVelocity,
              a = -t * (o - i) - e * r * 0;
          s.angularForce -= a, n.angularForce += a;
        };
      }, {
        "../math/vec2": 30,
        "./Spring": 34
      }],
      34: [function (t, e, i) {
        t("../math/vec2");
        var s = t("../utils/Utils");

        function n(t, e, i) {
          i = s.defaults(i, {
            stiffness: 100,
            damping: 1
          }), this.stiffness = i.stiffness, this.damping = i.damping, this.bodyA = t, this.bodyB = e;
        }

        e.exports = n, n.prototype.applyForce = function () {};
      }, {
        "../math/vec2": 30,
        "../utils/Utils": 57
      }],
      35: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = (t("../utils/Utils"), t("../constraints/Constraint")),
            o = t("../equations/FrictionEquation"),
            r = t("../objects/Body");

        function a(t, e) {
          e = e || {}, this.chassisBody = t, this.wheels = [], this.groundBody = new r({
            mass: 0
          }), this.world = null;
          var i = this;

          this.preStepCallback = function () {
            i.update();
          };
        }

        function h(t, e) {
          e = e || {}, this.vehicle = t, this.forwardEquation = new o(t.chassisBody, t.groundBody), this.sideEquation = new o(t.chassisBody, t.groundBody), this.steerValue = 0, this.engineForce = 0, this.setSideFriction(void 0 !== e.sideFriction ? e.sideFriction : 5), this.localForwardVector = s.fromValues(0, 1), e.localForwardVector && s.copy(this.localForwardVector, e.localForwardVector), this.localPosition = s.fromValues(0, 0), e.localPosition && s.copy(this.localPosition, e.localPosition), n.apply(this, t.chassisBody, t.groundBody), this.equations.push(this.forwardEquation, this.sideEquation), this.setBrakeForce(0);
        }

        e.exports = a, a.prototype.addToWorld = function (t) {
          this.world = t, t.addBody(this.groundBody), t.on("preStep", this.preStepCallback);

          for (var e = 0; e < this.wheels.length; e++) {
            var i = this.wheels[e];
            t.addConstraint(i);
          }
        }, a.prototype.removeFromWorld = function () {
          var t = this.world;
          t.removeBody(this.groundBody), t.off("preStep", this.preStepCallback);

          for (var e = 0; e < this.wheels.length; e++) {
            var i = this.wheels[e];
            t.removeConstraint(i);
          }

          this.world = null;
        }, a.prototype.addWheel = function (t) {
          var e = new h(this, t);
          return this.wheels.push(e), e;
        }, a.prototype.update = function () {
          for (var t = 0; t < this.wheels.length; t++) {
            this.wheels[t].update();
          }
        }, h.prototype = new n(), h.prototype.setBrakeForce = function (t) {
          this.forwardEquation.setSlipForce(t);
        }, h.prototype.setSideFriction = function (t) {
          this.sideEquation.setSlipForce(t);
        };
        var l = s.create(),
            c = s.create();

        h.prototype.getSpeed = function () {
          return this.vehicle.chassisBody.vectorToWorldFrame(c, this.localForwardVector), this.vehicle.chassisBody.getVelocityAtPoint(l, c), s.dot(l, c);
        };

        var u = s.create();

        h.prototype.update = function () {
          this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.t, this.localForwardVector), s.rotate(this.sideEquation.t, this.localForwardVector, Math.PI / 2), this.vehicle.chassisBody.vectorToWorldFrame(this.sideEquation.t, this.sideEquation.t), s.rotate(this.forwardEquation.t, this.forwardEquation.t, this.steerValue), s.rotate(this.sideEquation.t, this.sideEquation.t, this.steerValue), this.vehicle.chassisBody.toWorldFrame(this.forwardEquation.contactPointB, this.localPosition), s.copy(this.sideEquation.contactPointB, this.forwardEquation.contactPointB), this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.contactPointA, this.localPosition), s.copy(this.sideEquation.contactPointA, this.forwardEquation.contactPointA), s.normalize(u, this.forwardEquation.t), s.scale(u, u, this.engineForce), this.vehicle.chassisBody.applyForce(u, this.forwardEquation.contactPointA);
        };
      }, {
        "../constraints/Constraint": 14,
        "../equations/FrictionEquation": 23,
        "../math/vec2": 30,
        "../objects/Body": 31,
        "../utils/Utils": 57
      }],
      36: [function (t, e, i) {
        var s = e.exports = {
          AABB: t("./collision/AABB"),
          AngleLockEquation: t("./equations/AngleLockEquation"),
          Body: t("./objects/Body"),
          Broadphase: t("./collision/Broadphase"),
          Capsule: t("./shapes/Capsule"),
          Circle: t("./shapes/Circle"),
          Constraint: t("./constraints/Constraint"),
          ContactEquation: t("./equations/ContactEquation"),
          ContactEquationPool: t("./utils/ContactEquationPool"),
          ContactMaterial: t("./material/ContactMaterial"),
          Convex: t("./shapes/Convex"),
          DistanceConstraint: t("./constraints/DistanceConstraint"),
          Equation: t("./equations/Equation"),
          EventEmitter: t("./events/EventEmitter"),
          FrictionEquation: t("./equations/FrictionEquation"),
          FrictionEquationPool: t("./utils/FrictionEquationPool"),
          GearConstraint: t("./constraints/GearConstraint"),
          GSSolver: t("./solver/GSSolver"),
          Heightfield: t("./shapes/Heightfield"),
          Line: t("./shapes/Line"),
          LockConstraint: t("./constraints/LockConstraint"),
          Material: t("./material/Material"),
          Narrowphase: t("./collision/Narrowphase"),
          NaiveBroadphase: t("./collision/NaiveBroadphase"),
          Particle: t("./shapes/Particle"),
          Plane: t("./shapes/Plane"),
          Pool: t("./utils/Pool"),
          RevoluteConstraint: t("./constraints/RevoluteConstraint"),
          PrismaticConstraint: t("./constraints/PrismaticConstraint"),
          Ray: t("./collision/Ray"),
          RaycastResult: t("./collision/RaycastResult"),
          Box: t("./shapes/Box"),
          RotationalVelocityEquation: t("./equations/RotationalVelocityEquation"),
          SAPBroadphase: t("./collision/SAPBroadphase"),
          Shape: t("./shapes/Shape"),
          Solver: t("./solver/Solver"),
          Spring: t("./objects/Spring"),
          TopDownVehicle: t("./objects/TopDownVehicle"),
          LinearSpring: t("./objects/LinearSpring"),
          RotationalSpring: t("./objects/RotationalSpring"),
          Utils: t("./utils/Utils"),
          World: t("./world/World"),
          vec2: t("./math/vec2"),
          version: t("../package.json").version
        };
        Object.defineProperty(s, "Rectangle", {
          get: function get() {
            return console.warn("The Rectangle class has been renamed to Box."), this.Box;
          }
        });
      }, {
        "../package.json": 6,
        "./collision/AABB": 7,
        "./collision/Broadphase": 8,
        "./collision/NaiveBroadphase": 9,
        "./collision/Narrowphase": 10,
        "./collision/Ray": 11,
        "./collision/RaycastResult": 12,
        "./collision/SAPBroadphase": 13,
        "./constraints/Constraint": 14,
        "./constraints/DistanceConstraint": 15,
        "./constraints/GearConstraint": 16,
        "./constraints/LockConstraint": 17,
        "./constraints/PrismaticConstraint": 18,
        "./constraints/RevoluteConstraint": 19,
        "./equations/AngleLockEquation": 20,
        "./equations/ContactEquation": 21,
        "./equations/Equation": 22,
        "./equations/FrictionEquation": 23,
        "./equations/RotationalVelocityEquation": 25,
        "./events/EventEmitter": 26,
        "./material/ContactMaterial": 27,
        "./material/Material": 28,
        "./math/vec2": 30,
        "./objects/Body": 31,
        "./objects/LinearSpring": 32,
        "./objects/RotationalSpring": 33,
        "./objects/Spring": 34,
        "./objects/TopDownVehicle": 35,
        "./shapes/Box": 37,
        "./shapes/Capsule": 38,
        "./shapes/Circle": 39,
        "./shapes/Convex": 40,
        "./shapes/Heightfield": 41,
        "./shapes/Line": 42,
        "./shapes/Particle": 43,
        "./shapes/Plane": 44,
        "./shapes/Shape": 45,
        "./solver/GSSolver": 46,
        "./solver/Solver": 47,
        "./utils/ContactEquationPool": 48,
        "./utils/FrictionEquationPool": 49,
        "./utils/Pool": 55,
        "./utils/Utils": 57,
        "./world/World": 61
      }],
      37: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = t("./Shape"),
            o = t("./Convex");

        function r(t) {
          "number" == typeof arguments[0] && "number" == typeof arguments[1] && (t = {
            width: arguments[0],
            height: arguments[1]
          }, console.warn("The Rectangle has been renamed to Box and its constructor signature has changed. Please use the following format: new Box({ width: 1, height: 1, ... })")), t = t || {};
          var e = this.width = t.width || 1,
              i = this.height = t.height || 1,
              r = [s.fromValues(-e / 2, -i / 2), s.fromValues(e / 2, -i / 2), s.fromValues(e / 2, i / 2), s.fromValues(-e / 2, i / 2)],
              a = [s.fromValues(1, 0), s.fromValues(0, 1)];
          t.vertices = r, t.axes = a, t.type = n.BOX, o.call(this, t);
        }

        e.exports = r, r.prototype = new o(), r.prototype.constructor = r, r.prototype.computeMomentOfInertia = function (t) {
          var e = this.width,
              i = this.height;
          return t * (i * i + e * e) / 12;
        }, r.prototype.updateBoundingRadius = function () {
          var t = this.width,
              e = this.height;
          this.boundingRadius = Math.sqrt(t * t + e * e) / 2;
        }, s.create(), s.create(), s.create(), s.create(), r.prototype.computeAABB = function (t, e, i) {
          t.setFromPoints(this.vertices, e, i, 0);
        }, r.prototype.updateArea = function () {
          this.area = this.width * this.height;
        };
      }, {
        "../math/vec2": 30,
        "./Convex": 40,
        "./Shape": 45
      }],
      38: [function (t, e, i) {
        var s = t("./Shape"),
            n = t("../math/vec2");

        function o(t) {
          "number" == typeof arguments[0] && "number" == typeof arguments[1] && (t = {
            length: arguments[0],
            radius: arguments[1]
          }, console.warn("The Capsule constructor signature has changed. Please use the following format: new Capsule({ radius: 1, length: 1 })")), t = t || {}, this.length = t.length || 1, this.radius = t.radius || 1, t.type = s.CAPSULE, s.call(this, t);
        }

        e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.computeMomentOfInertia = function (t) {
          var e = this.radius,
              i = this.length + e,
              s = 2 * e;
          return t * (s * s + i * i) / 12;
        }, o.prototype.updateBoundingRadius = function () {
          this.boundingRadius = this.radius + this.length / 2;
        }, o.prototype.updateArea = function () {
          this.area = Math.PI * this.radius * this.radius + 2 * this.radius * this.length;
        };
        var r = n.create();

        o.prototype.computeAABB = function (t, e, i) {
          var s = this.radius;
          n.set(r, this.length / 2, 0), 0 !== i && n.rotate(r, r, i), n.set(t.upperBound, Math.max(r[0] + s, -r[0] + s), Math.max(r[1] + s, -r[1] + s)), n.set(t.lowerBound, Math.min(r[0] - s, -r[0] - s), Math.min(r[1] - s, -r[1] - s)), n.add(t.lowerBound, t.lowerBound, e), n.add(t.upperBound, t.upperBound, e);
        };

        var a = n.create(),
            h = n.create(),
            l = n.create(),
            c = n.create(),
            u = n.fromValues(0, 1);

        o.prototype.raycast = function (t, e, i, s) {
          for (var o = e.from, r = e.to, d = (e.direction, a), p = h, f = l, g = c, m = this.length / 2, y = 0; y < 2; y++) {
            var v = this.radius * (2 * y - 1);
            n.set(f, -m, v), n.set(g, m, v), n.toGlobalFrame(f, f, i, s), n.toGlobalFrame(g, g, i, s);
            var b = n.getLineSegmentsIntersectionFraction(o, r, f, g);
            if (b >= 0 && (n.rotate(p, u, s), n.scale(p, p, 2 * y - 1), e.reportIntersection(t, b, p, -1), t.shouldStop(e))) return;
          }

          for (var x = Math.pow(this.radius, 2) + Math.pow(m, 2), y = 0; y < 2; y++) {
            n.set(f, m * (2 * y - 1), 0), n.toGlobalFrame(f, f, i, s);

            var w = Math.pow(r[0] - o[0], 2) + Math.pow(r[1] - o[1], 2),
                _ = 2 * ((r[0] - o[0]) * (o[0] - f[0]) + (r[1] - o[1]) * (o[1] - f[1])),
                T = Math.pow(o[0] - f[0], 2) + Math.pow(o[1] - f[1], 2) - Math.pow(this.radius, 2),
                b = Math.pow(_, 2) - 4 * w * T;

            if (!(b < 0)) if (0 === b) {
              if (n.lerp(d, o, r, b), n.squaredDistance(d, i) > x && (n.sub(p, d, f), n.normalize(p, p), e.reportIntersection(t, b, p, -1), t.shouldStop(e))) return;
            } else {
              var P = Math.sqrt(b),
                  S = 1 / (2 * w),
                  C = (-_ - P) * S,
                  A = (-_ + P) * S;
              if (C >= 0 && C <= 1 && (n.lerp(d, o, r, C), n.squaredDistance(d, i) > x && (n.sub(p, d, f), n.normalize(p, p), e.reportIntersection(t, C, p, -1), t.shouldStop(e)))) return;
              if (A >= 0 && A <= 1 && (n.lerp(d, o, r, A), n.squaredDistance(d, i) > x && (n.sub(p, d, f), n.normalize(p, p), e.reportIntersection(t, A, p, -1), t.shouldStop(e)))) return;
            }
          }
        };
      }, {
        "../math/vec2": 30,
        "./Shape": 45
      }],
      39: [function (t, e, i) {
        var s = t("./Shape"),
            n = t("../math/vec2");

        function o(t) {
          "number" == typeof arguments[0] && (t = {
            radius: arguments[0]
          }, console.warn("The Circle constructor signature has changed. Please use the following format: new Circle({ radius: 1 })")), t = t || {}, this.radius = t.radius || 1, t.type = s.CIRCLE, s.call(this, t);
        }

        e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.computeMomentOfInertia = function (t) {
          var e = this.radius;
          return t * e * e / 2;
        }, o.prototype.updateBoundingRadius = function () {
          this.boundingRadius = this.radius;
        }, o.prototype.updateArea = function () {
          this.area = Math.PI * this.radius * this.radius;
        }, o.prototype.computeAABB = function (t, e, i) {
          var s = this.radius;
          n.set(t.upperBound, s, s), n.set(t.lowerBound, -s, -s), e && (n.add(t.lowerBound, t.lowerBound, e), n.add(t.upperBound, t.upperBound, e));
        };
        var r = n.create(),
            a = n.create();

        o.prototype.raycast = function (t, e, i, s) {
          var o = e.from,
              h = e.to,
              l = this.radius,
              c = Math.pow(h[0] - o[0], 2) + Math.pow(h[1] - o[1], 2),
              u = 2 * ((h[0] - o[0]) * (o[0] - i[0]) + (h[1] - o[1]) * (o[1] - i[1])),
              d = Math.pow(o[0] - i[0], 2) + Math.pow(o[1] - i[1], 2) - Math.pow(l, 2),
              p = Math.pow(u, 2) - 4 * c * d,
              f = r,
              g = a;
          if (!(p < 0)) if (0 === p) n.lerp(f, o, h, p), n.sub(g, f, i), n.normalize(g, g), e.reportIntersection(t, p, g, -1);else {
            var m = Math.sqrt(p),
                y = 1 / (2 * c),
                v = (-u - m) * y,
                b = (-u + m) * y;
            if (v >= 0 && v <= 1 && (n.lerp(f, o, h, v), n.sub(g, f, i), n.normalize(g, g), e.reportIntersection(t, v, g, -1), t.shouldStop(e))) return;
            b >= 0 && b <= 1 && (n.lerp(f, o, h, b), n.sub(g, f, i), n.normalize(g, g), e.reportIntersection(t, b, g, -1));
          }
        };
      }, {
        "../math/vec2": 30,
        "./Shape": 45
      }],
      40: [function (t, e, i) {
        var s = t("./Shape"),
            n = t("../math/vec2"),
            o = t("../math/polyk");

        function r(t) {
          Array.isArray(arguments[0]) && (t = {
            vertices: arguments[0],
            axes: arguments[1]
          }, console.warn("The Convex constructor signature has changed. Please use the following format: new Convex({ vertices: [...], ... })")), t = t || {}, this.vertices = [];

          for (var e = void 0 !== t.vertices ? t.vertices : [], i = 0; i < e.length; i++) {
            var o = n.create();
            n.copy(o, e[i]), this.vertices.push(o);
          }

          if (this.axes = [], t.axes) for (var i = 0; i < t.axes.length; i++) {
            var r = n.create();
            n.copy(r, t.axes[i]), this.axes.push(r);
          } else for (var i = 0; i < this.vertices.length; i++) {
            var a = this.vertices[i],
                h = this.vertices[(i + 1) % this.vertices.length],
                l = n.create();
            n.sub(l, h, a), n.rotate90cw(l, l), n.normalize(l, l), this.axes.push(l);
          }
          if (this.centerOfMass = n.fromValues(0, 0), this.triangles = [], this.vertices.length && (this.updateTriangles(), this.updateCenterOfMass()), this.boundingRadius = 0, t.type = s.CONVEX, s.call(this, t), this.updateBoundingRadius(), this.updateArea(), this.area < 0) throw new Error("Convex vertices must be given in conter-clockwise winding.");
        }

        t("poly-decomp"), e.exports = r, r.prototype = new s(), r.prototype.constructor = r;
        var a = n.create(),
            h = n.create();
        r.prototype.projectOntoLocalAxis = function (t, e) {
          for (var i, s, o = null, r = null, t = a, h = 0; h < this.vertices.length; h++) {
            i = this.vertices[h], s = n.dot(i, t), (null === o || s > o) && (o = s), (null === r || s < r) && (r = s);
          }

          if (r > o) {
            var l = r;
            r = o, o = l;
          }

          n.set(e, r, o);
        }, r.prototype.projectOntoWorldAxis = function (t, e, i, s) {
          var o = h;
          this.projectOntoLocalAxis(t, s), 0 !== i ? n.rotate(o, t, i) : o = t;
          var r = n.dot(e, o);
          n.set(s, s[0] + r, s[1] + r);
        }, r.prototype.updateTriangles = function () {
          this.triangles.length = 0;

          for (var t = [], e = 0; e < this.vertices.length; e++) {
            var i = this.vertices[e];
            t.push(i[0], i[1]);
          }

          for (var s = o.Triangulate(t), e = 0; e < s.length; e += 3) {
            var n = s[e],
                r = s[e + 1],
                a = s[e + 2];
            this.triangles.push([n, r, a]);
          }
        };
        var l = n.create(),
            c = n.create(),
            u = n.create(),
            d = n.create(),
            p = n.create();
        n.create(), n.create(), n.create(), n.create(), r.prototype.updateCenterOfMass = function () {
          var t = this.triangles,
              e = this.vertices,
              i = this.centerOfMass,
              s = l,
              o = u,
              a = d,
              h = p,
              f = c;
          n.set(i, 0, 0);

          for (var g = 0, m = 0; m !== t.length; m++) {
            var y = t[m],
                o = e[y[0]],
                a = e[y[1]],
                h = e[y[2]];
            n.centroid(s, o, a, h);
            var v = r.triangleArea(o, a, h);
            g += v, n.scale(f, s, v), n.add(i, i, f);
          }

          n.scale(i, i, 1 / g);
        }, r.prototype.computeMomentOfInertia = function (t) {
          for (var e = 0, i = 0, s = this.vertices.length, o = s - 1, r = 0; r < s; o = r, r++) {
            var a = this.vertices[o],
                h = this.vertices[r],
                l = Math.abs(n.crossLength(a, h)),
                c = n.dot(h, h) + n.dot(h, a) + n.dot(a, a);
            e += l * c, i += l;
          }

          return t / 6 * (e / i);
        }, r.prototype.updateBoundingRadius = function () {
          for (var t = this.vertices, e = 0, i = 0; i !== t.length; i++) {
            var s = n.squaredLength(t[i]);
            s > e && (e = s);
          }

          this.boundingRadius = Math.sqrt(e);
        }, r.triangleArea = function (t, e, i) {
          return .5 * ((e[0] - t[0]) * (i[1] - t[1]) - (i[0] - t[0]) * (e[1] - t[1]));
        }, r.prototype.updateArea = function () {
          this.updateTriangles(), this.area = 0;

          for (var t = this.triangles, e = this.vertices, i = 0; i !== t.length; i++) {
            var s = t[i],
                n = e[s[0]],
                o = e[s[1]],
                a = e[s[2]],
                h = r.triangleArea(n, o, a);
            this.area += h;
          }
        }, r.prototype.computeAABB = function (t, e, i) {
          t.setFromPoints(this.vertices, e, i, 0);
        };
        var f = n.create(),
            g = n.create(),
            m = n.create();

        r.prototype.raycast = function (t, e, i, s) {
          var o = f,
              r = g,
              a = m,
              h = this.vertices;
          n.toLocalFrame(o, e.from, i, s), n.toLocalFrame(r, e.to, i, s);

          for (var l = h.length, c = 0; c < l && !t.shouldStop(e); c++) {
            var u = h[c],
                d = h[(c + 1) % l],
                p = n.getLineSegmentsIntersectionFraction(o, r, u, d);
            p >= 0 && (n.sub(a, d, u), n.rotate(a, a, -Math.PI / 2 + s), n.normalize(a, a), e.reportIntersection(t, p, a, c));
          }
        };
      }, {
        "../math/polyk": 29,
        "../math/vec2": 30,
        "./Shape": 45,
        "poly-decomp": 5
      }],
      41: [function (t, e, i) {
        var s = t("./Shape"),
            n = t("../math/vec2");

        function o(t) {
          if (Array.isArray(arguments[0])) {
            if (t = {
              heights: arguments[0]
            }, "object" == typeof arguments[1]) for (var e in arguments[1]) {
              t[e] = arguments[1][e];
            }
            console.warn("The Heightfield constructor signature has changed. Please use the following format: new Heightfield({ heights: [...], ... })");
          }

          t = t || {}, this.heights = t.heights ? t.heights.slice(0) : [], this.maxValue = t.maxValue || null, this.minValue = t.minValue || null, this.elementWidth = t.elementWidth || .1, void 0 !== t.maxValue && void 0 !== t.minValue || this.updateMaxMinValues(), t.type = s.HEIGHTFIELD, s.call(this, t);
        }

        t("../utils/Utils"), e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.updateMaxMinValues = function () {
          for (var t = this.heights, e = t[0], i = t[0], s = 0; s !== t.length; s++) {
            var n = t[s];
            n > e && (e = n), n < i && (i = n);
          }

          this.maxValue = e, this.minValue = i;
        }, o.prototype.computeMomentOfInertia = function (t) {
          return Number.MAX_VALUE;
        }, o.prototype.updateBoundingRadius = function () {
          this.boundingRadius = Number.MAX_VALUE;
        }, o.prototype.updateArea = function () {
          for (var t = this.heights, e = 0, i = 0; i < t.length - 1; i++) {
            e += (t[i] + t[i + 1]) / 2 * this.elementWidth;
          }

          this.area = e;
        };
        var r = [n.create(), n.create(), n.create(), n.create()];
        o.prototype.computeAABB = function (t, e, i) {
          n.set(r[0], 0, this.maxValue), n.set(r[1], this.elementWidth * this.heights.length, this.maxValue), n.set(r[2], this.elementWidth * this.heights.length, this.minValue), n.set(r[3], 0, this.minValue), t.setFromPoints(r, e, i);
        }, o.prototype.getLineSegment = function (t, e, i) {
          var s = this.heights,
              o = this.elementWidth;
          n.set(t, i * o, s[i]), n.set(e, (i + 1) * o, s[i + 1]);
        }, o.prototype.getSegmentIndex = function (t) {
          return Math.floor(t[0] / this.elementWidth);
        }, o.prototype.getClampedSegmentIndex = function (t) {
          var e = this.getSegmentIndex(t);
          return e = Math.min(this.heights.length, Math.max(e, 0));
        }, n.create();
        var a = n.create(),
            h = n.create(),
            l = n.create(),
            c = n.create(),
            u = n.create();
        n.fromValues(0, 1), o.prototype.raycast = function (t, e, i, s) {
          var o = e.from,
              r = e.to,
              d = (e.direction, a),
              p = h,
              f = l,
              g = c,
              m = u;
          n.toLocalFrame(g, o, i, s), n.toLocalFrame(m, r, i, s);
          var y = this.getClampedSegmentIndex(g),
              v = this.getClampedSegmentIndex(m);

          if (y > v) {
            var b = y;
            y = v, v = b;
          }

          for (var x = 0; x < this.heights.length - 1; x++) {
            this.getLineSegment(p, f, x);
            var w = n.getLineSegmentsIntersectionFraction(g, m, p, f);
            if (w >= 0 && (n.sub(d, f, p), n.rotate(d, d, s + Math.PI / 2), n.normalize(d, d), e.reportIntersection(t, w, d, -1), t.shouldStop(e))) return;
          }
        };
      }, {
        "../math/vec2": 30,
        "../utils/Utils": 57,
        "./Shape": 45
      }],
      42: [function (t, e, i) {
        var s = t("./Shape"),
            n = t("../math/vec2");

        function o(t) {
          "number" == typeof arguments[0] && (t = {
            length: arguments[0]
          }, console.warn("The Line constructor signature has changed. Please use the following format: new Line({ length: 1, ... })")), t = t || {}, this.length = t.length || 1, t.type = s.LINE, s.call(this, t);
        }

        e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.computeMomentOfInertia = function (t) {
          return t * Math.pow(this.length, 2) / 12;
        }, o.prototype.updateBoundingRadius = function () {
          this.boundingRadius = this.length / 2;
        };
        var r = [n.create(), n.create()];
        o.prototype.computeAABB = function (t, e, i) {
          var s = this.length / 2;
          n.set(r[0], -s, 0), n.set(r[1], s, 0), t.setFromPoints(r, e, i, 0);
        }, n.create();
        var a = n.create(),
            h = n.create(),
            l = n.create(),
            c = n.fromValues(0, 1);

        o.prototype.raycast = function (t, e, i, s) {
          var o = e.from,
              r = e.to,
              u = h,
              d = l,
              p = this.length / 2;
          n.set(u, -p, 0), n.set(d, p, 0), n.toGlobalFrame(u, u, i, s), n.toGlobalFrame(d, d, i, s);
          var f = n.getLineSegmentsIntersectionFraction(u, d, o, r);

          if (f >= 0) {
            var g = a;
            n.rotate(g, c, s), e.reportIntersection(t, f, g, -1);
          }
        };
      }, {
        "../math/vec2": 30,
        "./Shape": 45
      }],
      43: [function (t, e, i) {
        var s = t("./Shape"),
            n = t("../math/vec2");

        function o(t) {
          (t = t || {}).type = s.PARTICLE, s.call(this, t);
        }

        e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.computeMomentOfInertia = function (t) {
          return 0;
        }, o.prototype.updateBoundingRadius = function () {
          this.boundingRadius = 0;
        }, o.prototype.computeAABB = function (t, e, i) {
          n.copy(t.lowerBound, e), n.copy(t.upperBound, e);
        };
      }, {
        "../math/vec2": 30,
        "./Shape": 45
      }],
      44: [function (t, e, i) {
        var s = t("./Shape"),
            n = t("../math/vec2");

        function o(t) {
          (t = t || {}).type = s.PLANE, s.call(this, t);
        }

        t("../utils/Utils"), e.exports = o, o.prototype = new s(), o.prototype.constructor = o, o.prototype.computeMomentOfInertia = function (t) {
          return 0;
        }, o.prototype.updateBoundingRadius = function () {
          this.boundingRadius = Number.MAX_VALUE;
        }, o.prototype.computeAABB = function (t, e, i) {
          var s = i % (2 * Math.PI),
              o = n.set,
              r = t.lowerBound,
              a = t.upperBound;
          o(r, -1e7, -1e7), o(a, 1e7, 1e7), 0 === s ? a[1] = 0 : s === Math.PI / 2 ? r[0] = 0 : s === Math.PI ? r[1] = 0 : s === 3 * Math.PI / 2 && (a[0] = 0);
        }, o.prototype.updateArea = function () {
          this.area = Number.MAX_VALUE;
        };
        var r = n.create(),
            a = (n.create(), n.create(), n.create()),
            h = n.create();

        o.prototype.raycast = function (t, e, i, s) {
          var o = e.from,
              l = e.to,
              c = e.direction,
              u = r,
              d = a,
              p = h;
          n.set(d, 0, 1), n.rotate(d, d, s), n.sub(p, o, i);
          var f = n.dot(p, d);
          n.sub(p, l, i);
          var g = n.dot(p, d);

          if (!(f * g > 0 || n.squaredDistance(o, l) < f * f)) {
            var m = n.dot(d, c);
            n.sub(u, o, i);
            var y = -n.dot(d, u) / m / e.length;
            e.reportIntersection(t, y, d, -1);
          }
        };
      }, {
        "../math/vec2": 30,
        "../utils/Utils": 57,
        "./Shape": 45
      }],
      45: [function (t, e, i) {
        e.exports = n;
        var s = t("../math/vec2");

        function n(t) {
          t = t || {}, this.body = null, this.position = s.fromValues(0, 0), t.position && s.copy(this.position, t.position), this.angle = t.angle || 0, this.type = t.type || 0, this.id = n.idCounter++, this.boundingRadius = 0, this.collisionGroup = void 0 !== t.collisionGroup ? t.collisionGroup : 1, this.collisionResponse = void 0 === t.collisionResponse || t.collisionResponse, this.collisionMask = void 0 !== t.collisionMask ? t.collisionMask : 1, this.material = t.material || null, this.area = 0, this.sensor = void 0 !== t.sensor && t.sensor, this.type && this.updateBoundingRadius(), this.updateArea();
        }

        n.idCounter = 0, n.CIRCLE = 1, n.PARTICLE = 2, n.PLANE = 4, n.CONVEX = 8, n.LINE = 16, n.BOX = 32, n.CAPSULE = 64, n.HEIGHTFIELD = 128, n.prototype.computeMomentOfInertia = function (t) {}, n.prototype.updateBoundingRadius = function () {}, n.prototype.updateArea = function () {}, n.prototype.computeAABB = function (t, e, i) {}, n.prototype.raycast = function (t, e, i, s) {};
      }, {
        "../math/vec2": 30
      }],
      46: [function (t, e, i) {
        var s = t("../math/vec2"),
            n = t("./Solver"),
            o = t("../utils/Utils"),
            r = t("../equations/FrictionEquation");

        function a(t) {
          n.call(this, t, n.GS), t = t || {}, this.iterations = t.iterations || 10, this.tolerance = t.tolerance || 1e-7, this.arrayStep = 30, this.lambda = new o.ARRAY_TYPE(this.arrayStep), this.Bs = new o.ARRAY_TYPE(this.arrayStep), this.invCs = new o.ARRAY_TYPE(this.arrayStep), this.useZeroRHS = !1, this.frictionIterations = void 0 !== t.frictionIterations ? 0 : t.frictionIterations, this.usedIterations = 0;
        }

        e.exports = a, a.prototype = new n(), a.prototype.constructor = a, a.prototype.solve = function (t, e) {
          this.sortEquations();
          var i = 0,
              n = this.iterations,
              h = this.frictionIterations,
              l = this.equations,
              c = l.length,
              u = Math.pow(this.tolerance * c, 2),
              d = e.bodies,
              p = e.bodies.length,
              f = (s.add, s.set, this.useZeroRHS),
              g = this.lambda;
          if (this.usedIterations = 0, c) for (var m = 0; m !== p; m++) {
            var y = d[m];
            y.updateSolveMassProperties();
          }
          g.length < c && (g = this.lambda = new o.ARRAY_TYPE(c + this.arrayStep), this.Bs = new o.ARRAY_TYPE(c + this.arrayStep), this.invCs = new o.ARRAY_TYPE(c + this.arrayStep)), function (t) {
            for (var e = t.length; e--;) {
              t[e] = 0;
            }
          }(g);

          for (var v, b, x = this.invCs, w = this.Bs, g = this.lambda, m = 0; m !== l.length; m++) {
            var _ = l[m];
            (_.timeStep !== t || _.needsUpdate) && (_.timeStep = t, _.update()), w[m] = _.computeB(_.a, _.b, t), x[m] = _.computeInvC(_.epsilon);
          }

          if (0 !== c) {
            for (m = 0; m !== p; m++) {
              var y = d[m];
              y.resetConstraintVelocity();
            }

            if (h) {
              for (i = 0; i !== h; i++) {
                for (v = 0, b = 0; b !== c; b++) {
                  _ = l[b];
                  var T = a.iterateEquation(b, _, _.epsilon, w, x, g, f, t, i);
                  v += Math.abs(T);
                }

                if (this.usedIterations++, v * v <= u) break;
              }

              for (a.updateMultipliers(l, g, 1 / t), b = 0; b !== c; b++) {
                var P = l[b];

                if (P instanceof r) {
                  for (var S = 0, C = 0; C !== P.contactEquations.length; C++) {
                    S += P.contactEquations[C].multiplier;
                  }

                  S *= P.frictionCoefficient / P.contactEquations.length, P.maxForce = S, P.minForce = -S;
                }
              }
            }

            for (i = 0; i !== n; i++) {
              for (v = 0, b = 0; b !== c; b++) {
                _ = l[b];
                var T = a.iterateEquation(b, _, _.epsilon, w, x, g, f, t, i);
                v += Math.abs(T);
              }

              if (this.usedIterations++, v * v <= u) break;
            }

            for (m = 0; m !== p; m++) {
              d[m].addConstraintVelocity();
            }

            a.updateMultipliers(l, g, 1 / t);
          }
        }, a.updateMultipliers = function (t, e, i) {
          for (var s = t.length; s--;) {
            t[s].multiplier = e[s] * i;
          }
        }, a.iterateEquation = function (t, e, i, s, n, o, r, a, h) {
          var l = s[t],
              c = n[t],
              u = o[t],
              d = e.computeGWlambda(),
              p = e.maxForce,
              f = e.minForce;
          r && (l = 0);
          var g = c * (l - d - i * u),
              m = u + g;
          return m < f * a ? g = f * a - u : m > p * a && (g = p * a - u), o[t] += g, e.addToWlambda(g), g;
        };
      }, {
        "../equations/FrictionEquation": 23,
        "../math/vec2": 30,
        "../utils/Utils": 57,
        "./Solver": 47
      }],
      47: [function (t, e, i) {
        t("../utils/Utils");
        var s = t("../events/EventEmitter");

        function n(t, e) {
          t = t || {}, s.call(this), this.type = e, this.equations = [], this.equationSortFunction = t.equationSortFunction || !1;
        }

        e.exports = n, n.prototype = new s(), n.prototype.constructor = n, n.prototype.solve = function (t, e) {
          throw new Error("Solver.solve should be implemented by subclasses!");
        };
        var o = {
          bodies: []
        };
        n.prototype.solveIsland = function (t, e) {
          this.removeAllEquations(), e.equations.length && (this.addEquations(e.equations), o.bodies.length = 0, e.getBodies(o.bodies), o.bodies.length && this.solve(t, o));
        }, n.prototype.sortEquations = function () {
          this.equationSortFunction && this.equations.sort(this.equationSortFunction);
        }, n.prototype.addEquation = function (t) {
          t.enabled && this.equations.push(t);
        }, n.prototype.addEquations = function (t) {
          for (var e = 0, i = t.length; e !== i; e++) {
            var s = t[e];
            s.enabled && this.equations.push(s);
          }
        }, n.prototype.removeEquation = function (t) {
          var e = this.equations.indexOf(t);
          -1 !== e && this.equations.splice(e, 1);
        }, n.prototype.removeAllEquations = function () {
          this.equations.length = 0;
        }, n.GS = 1, n.ISLAND = 2;
      }, {
        "../events/EventEmitter": 26,
        "../utils/Utils": 57
      }],
      48: [function (t, e, i) {
        var s = t("../equations/ContactEquation"),
            n = t("./Pool");

        function o() {
          n.apply(this, arguments);
        }

        e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.create = function () {
          return new s();
        }, o.prototype.destroy = function (t) {
          return t.bodyA = t.bodyB = null, this;
        };
      }, {
        "../equations/ContactEquation": 21,
        "./Pool": 55
      }],
      49: [function (t, e, i) {
        var s = t("../equations/FrictionEquation"),
            n = t("./Pool");

        function o() {
          n.apply(this, arguments);
        }

        e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.create = function () {
          return new s();
        }, o.prototype.destroy = function (t) {
          return t.bodyA = t.bodyB = null, this;
        };
      }, {
        "../equations/FrictionEquation": 23,
        "./Pool": 55
      }],
      50: [function (t, e, i) {
        var s = t("../world/IslandNode"),
            n = t("./Pool");

        function o() {
          n.apply(this, arguments);
        }

        e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.create = function () {
          return new s();
        }, o.prototype.destroy = function (t) {
          return t.reset(), this;
        };
      }, {
        "../world/IslandNode": 60,
        "./Pool": 55
      }],
      51: [function (t, e, i) {
        var s = t("../world/Island"),
            n = t("./Pool");

        function o() {
          n.apply(this, arguments);
        }

        e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.create = function () {
          return new s();
        }, o.prototype.destroy = function (t) {
          return t.reset(), this;
        };
      }, {
        "../world/Island": 58,
        "./Pool": 55
      }],
      52: [function (t, e, i) {
        var s = t("./TupleDictionary"),
            n = (t("./OverlapKeeperRecord"), t("./OverlapKeeperRecordPool"));

        function o() {
          this.overlappingShapesLastState = new s(), this.overlappingShapesCurrentState = new s(), this.recordPool = new n({
            size: 16
          }), this.tmpDict = new s(), this.tmpArray1 = [];
        }

        t("./Utils"), e.exports = o, o.prototype.tick = function () {
          for (var t = this.overlappingShapesLastState, e = this.overlappingShapesCurrentState, i = t.keys.length; i--;) {
            var s = t.keys[i],
                n = t.getByKey(s);
            e.getByKey(s), n && this.recordPool.release(n);
          }

          t.reset(), t.copy(e), e.reset();
        }, o.prototype.setOverlapping = function (t, e, i, s) {
          this.overlappingShapesLastState;
          var n = this.overlappingShapesCurrentState;

          if (!n.get(e.id, s.id)) {
            var o = this.recordPool.get();
            o.set(t, e, i, s), n.set(e.id, s.id, o);
          }
        }, o.prototype.getNewOverlaps = function (t) {
          return this.getDiff(this.overlappingShapesLastState, this.overlappingShapesCurrentState, t);
        }, o.prototype.getEndOverlaps = function (t) {
          return this.getDiff(this.overlappingShapesCurrentState, this.overlappingShapesLastState, t);
        }, o.prototype.bodiesAreOverlapping = function (t, e) {
          for (var i = this.overlappingShapesCurrentState, s = i.keys.length; s--;) {
            var n = i.keys[s],
                o = i.data[n];
            if (o.bodyA === t && o.bodyB === e || o.bodyA === e && o.bodyB === t) return !0;
          }

          return !1;
        }, o.prototype.getDiff = function (t, e, i) {
          var i = i || [],
              s = t,
              n = e;
          i.length = 0;

          for (var o = n.keys.length; o--;) {
            var r = n.keys[o],
                a = n.data[r];
            if (!a) throw new Error("Key " + r + " had no data!");
            var h = s.data[r];
            h || i.push(a);
          }

          return i;
        }, o.prototype.isNewOverlap = function (t, e) {
          var i = 0 | t.id,
              s = 0 | e.id,
              n = this.overlappingShapesLastState,
              o = this.overlappingShapesCurrentState;
          return !n.get(i, s) && !!o.get(i, s);
        }, o.prototype.getNewBodyOverlaps = function (t) {
          this.tmpArray1.length = 0;
          var e = this.getNewOverlaps(this.tmpArray1);
          return this.getBodyDiff(e, t);
        }, o.prototype.getEndBodyOverlaps = function (t) {
          this.tmpArray1.length = 0;
          var e = this.getEndOverlaps(this.tmpArray1);
          return this.getBodyDiff(e, t);
        }, o.prototype.getBodyDiff = function (t, e) {
          e = e || [];

          for (var i = this.tmpDict, s = t.length; s--;) {
            var n = t[s];
            i.set(0 | n.bodyA.id, 0 | n.bodyB.id, n);
          }

          for (s = i.keys.length; s--;) {
            var n = i.getByKey(i.keys[s]);
            n && e.push(n.bodyA, n.bodyB);
          }

          return i.reset(), e;
        };
      }, {
        "./OverlapKeeperRecord": 53,
        "./OverlapKeeperRecordPool": 54,
        "./TupleDictionary": 56,
        "./Utils": 57
      }],
      53: [function (t, e, i) {
        function s(t, e, i, s) {
          this.shapeA = e, this.shapeB = s, this.bodyA = t, this.bodyB = i;
        }

        e.exports = s, s.prototype.set = function (t, e, i, n) {
          s.call(this, t, e, i, n);
        };
      }, {}],
      54: [function (t, e, i) {
        var s = t("./OverlapKeeperRecord"),
            n = t("./Pool");

        function o() {
          n.apply(this, arguments);
        }

        e.exports = o, o.prototype = new n(), o.prototype.constructor = o, o.prototype.create = function () {
          return new s();
        }, o.prototype.destroy = function (t) {
          return t.bodyA = t.bodyB = t.shapeA = t.shapeB = null, this;
        };
      }, {
        "./OverlapKeeperRecord": 53,
        "./Pool": 55
      }],
      55: [function (t, e, i) {
        function s(t) {
          t = t || {}, this.objects = [], void 0 !== t.size && this.resize(t.size);
        }

        e.exports = s, s.prototype.resize = function (t) {
          for (var e = this.objects; e.length > t;) {
            e.pop();
          }

          for (; e.length < t;) {
            e.push(this.create());
          }

          return this;
        }, s.prototype.get = function () {
          var t = this.objects;
          return t.length ? t.pop() : this.create();
        }, s.prototype.release = function (t) {
          return this.destroy(t), this.objects.push(t), this;
        };
      }, {}],
      56: [function (t, e, i) {
        var s = t("./Utils");

        function n() {
          this.data = {}, this.keys = [];
        }

        e.exports = n, n.prototype.getKey = function (t, e) {
          return (0 | (t |= 0)) == (0 | (e |= 0)) ? -1 : 0 | ((0 | t) > (0 | e) ? t << 16 | 65535 & e : e << 16 | 65535 & t);
        }, n.prototype.getByKey = function (t) {
          return t |= 0, this.data[t];
        }, n.prototype.get = function (t, e) {
          return this.data[this.getKey(t, e)];
        }, n.prototype.set = function (t, e, i) {
          if (!i) throw new Error("No data!");
          var s = this.getKey(t, e);
          return this.data[s] || this.keys.push(s), this.data[s] = i, s;
        }, n.prototype.reset = function () {
          for (var t = this.data, e = this.keys, i = e.length; i--;) {
            delete t[e[i]];
          }

          e.length = 0;
        }, n.prototype.copy = function (t) {
          this.reset(), s.appendArray(this.keys, t.keys);

          for (var e = t.keys.length; e--;) {
            var i = t.keys[e];
            this.data[i] = t.data[i];
          }
        };
      }, {
        "./Utils": 57
      }],
      57: [function (t, e, i) {
        function s() {}

        e.exports = s, s.appendArray = function (t, e) {
          if (e.length < 15e4) t.push.apply(t, e);else for (var i = 0, s = e.length; i !== s; ++i) {
            t.push(e[i]);
          }
        }, s.splice = function (t, e, i) {
          i = i || 1;

          for (var s = e, n = t.length - i; s < n; s++) {
            t[s] = t[s + i];
          }

          t.length = n;
        }, "undefined" != typeof P2_ARRAY_TYPE ? s.ARRAY_TYPE = P2_ARRAY_TYPE : "undefined" != typeof Float32Array ? s.ARRAY_TYPE = Float32Array : s.ARRAY_TYPE = Array, s.extend = function (t, e) {
          for (var i in e) {
            t[i] = e[i];
          }
        }, s.defaults = function (t, e) {
          for (var i in t = t || {}, e) {
            i in t || (t[i] = e[i]);
          }

          return t;
        };
      }, {}],
      58: [function (t, e, i) {
        var s = t("../objects/Body");

        function n() {
          this.equations = [], this.bodies = [];
        }

        e.exports = n, n.prototype.reset = function () {
          this.equations.length = this.bodies.length = 0;
        };
        var o = [];
        n.prototype.getBodies = function (t) {
          var e = t || [],
              i = this.equations;
          o.length = 0;

          for (var s = 0; s !== i.length; s++) {
            var n = i[s];
            -1 === o.indexOf(n.bodyA.id) && (e.push(n.bodyA), o.push(n.bodyA.id)), -1 === o.indexOf(n.bodyB.id) && (e.push(n.bodyB), o.push(n.bodyB.id));
          }

          return e;
        }, n.prototype.wantsToSleep = function () {
          for (var t = 0; t < this.bodies.length; t++) {
            var e = this.bodies[t];
            if (e.type === s.DYNAMIC && !e.wantsToSleep) return !1;
          }

          return !0;
        }, n.prototype.sleep = function () {
          for (var t = 0; t < this.bodies.length; t++) {
            var e = this.bodies[t];
            e.sleep();
          }

          return !0;
        };
      }, {
        "../objects/Body": 31
      }],
      59: [function (t, e, i) {
        t("../math/vec2"), t("./Island"), t("./IslandNode");
        var s = t("./../utils/IslandNodePool"),
            n = t("./../utils/IslandPool"),
            o = t("../objects/Body");

        function r(t) {
          this.nodePool = new s({
            size: 16
          }), this.islandPool = new n({
            size: 8
          }), this.equations = [], this.islands = [], this.nodes = [], this.queue = [];
        }

        e.exports = r, r.getUnvisitedNode = function (t) {
          for (var e = t.length, i = 0; i !== e; i++) {
            var s = t[i];
            if (!s.visited && s.body.type === o.DYNAMIC) return s;
          }

          return !1;
        }, r.prototype.visit = function (t, e, i) {
          e.push(t.body);

          for (var s = t.equations.length, n = 0; n !== s; n++) {
            var o = t.equations[n];
            -1 === i.indexOf(o) && i.push(o);
          }
        }, r.prototype.bfs = function (t, e, i) {
          var s = this.queue;

          for (s.length = 0, s.push(t), t.visited = !0, this.visit(t, e, i); s.length;) {
            for (var n, a = s.pop(); n = r.getUnvisitedNode(a.neighbors);) {
              n.visited = !0, this.visit(n, e, i), n.body.type === o.DYNAMIC && s.push(n);
            }
          }
        }, r.prototype.split = function (t) {
          for (var e = t.bodies, i = this.nodes, s = this.equations; i.length;) {
            this.nodePool.release(i.pop());
          }

          for (var n = 0; n !== e.length; n++) {
            var o = this.nodePool.get();
            o.body = e[n], i.push(o);
          }

          for (var a = 0; a !== s.length; a++) {
            var h = s[a],
                n = e.indexOf(h.bodyA),
                l = e.indexOf(h.bodyB),
                c = i[n],
                u = i[l];
            c.neighbors.push(u), u.neighbors.push(c), c.equations.push(h), u.equations.push(h);
          }

          for (var d, p = this.islands, n = 0; n < p.length; n++) {
            this.islandPool.release(p[n]);
          }

          for (p.length = 0; d = r.getUnvisitedNode(i);) {
            var f = this.islandPool.get();
            this.bfs(d, f.bodies, f.equations), p.push(f);
          }

          return p;
        };
      }, {
        "../math/vec2": 30,
        "../objects/Body": 31,
        "./../utils/IslandNodePool": 50,
        "./../utils/IslandPool": 51,
        "./Island": 58,
        "./IslandNode": 60
      }],
      60: [function (t, e, i) {
        function s(t) {
          this.body = t, this.neighbors = [], this.equations = [], this.visited = !1;
        }

        e.exports = s, s.prototype.reset = function () {
          this.equations.length = 0, this.neighbors.length = 0, this.visited = !1, this.body = null;
        };
      }, {}],
      61: [function (t, e, i) {
        var s = t("../solver/GSSolver"),
            n = (t("../solver/Solver"), t("../collision/Ray"), t("../math/vec2")),
            o = t("../shapes/Circle"),
            r = t("../shapes/Convex"),
            a = (t("../shapes/Line"), t("../shapes/Plane")),
            h = t("../shapes/Capsule"),
            l = t("../shapes/Particle"),
            c = t("../events/EventEmitter"),
            u = t("../objects/Body"),
            d = (t("../shapes/Shape"), t("../objects/LinearSpring"), t("../material/Material")),
            p = t("../material/ContactMaterial"),
            f = (t("../constraints/DistanceConstraint"), t("../constraints/Constraint"), t("../constraints/LockConstraint"), t("../constraints/RevoluteConstraint"), t("../constraints/PrismaticConstraint"), t("../constraints/GearConstraint"), t("../../package.json"), t("../collision/Broadphase"), t("../collision/AABB")),
            g = t("../collision/SAPBroadphase"),
            m = t("../collision/Narrowphase"),
            y = t("../utils/Utils"),
            v = t("../utils/OverlapKeeper"),
            b = t("./IslandManager");

        function x(t) {
          c.apply(this), t = t || {}, this.springs = [], this.bodies = [], this.disabledBodyCollisionPairs = [], this.solver = t.solver || new s(), this.narrowphase = new m(this), this.islandManager = new b(), this.gravity = n.fromValues(0, -9.78), t.gravity && n.copy(this.gravity, t.gravity), this.frictionGravity = n.length(this.gravity) || 10, this.useWorldGravityAsFrictionGravity = !0, this.useFrictionGravityOnZeroGravity = !0, this.broadphase = t.broadphase || new g(), this.broadphase.setWorld(this), this.constraints = [], this.defaultMaterial = new d(), this.defaultContactMaterial = new p(this.defaultMaterial, this.defaultMaterial), this.lastTimeStep = 1 / 60, this.applySpringForces = !0, this.applyDamping = !0, this.applyGravity = !0, this.solveConstraints = !0, this.contactMaterials = [], this.time = 0, this.accumulator = 0, this.stepping = !1, this.bodiesToBeRemoved = [], this.islandSplit = void 0 === t.islandSplit || !!t.islandSplit, this.emitImpactEvent = !0, this._constraintIdCounter = 0, this._bodyIdCounter = 0, this.postStepEvent = {
            type: "postStep"
          }, this.addBodyEvent = {
            type: "addBody",
            body: null
          }, this.removeBodyEvent = {
            type: "removeBody",
            body: null
          }, this.addSpringEvent = {
            type: "addSpring",
            spring: null
          }, this.impactEvent = {
            type: "impact",
            bodyA: null,
            bodyB: null,
            shapeA: null,
            shapeB: null,
            contactEquation: null
          }, this.postBroadphaseEvent = {
            type: "postBroadphase",
            pairs: null
          }, this.sleepMode = x.NO_SLEEPING, this.beginContactEvent = {
            type: "beginContact",
            shapeA: null,
            shapeB: null,
            bodyA: null,
            bodyB: null,
            contactEquations: []
          }, this.endContactEvent = {
            type: "endContact",
            shapeA: null,
            shapeB: null,
            bodyA: null,
            bodyB: null
          }, this.preSolveEvent = {
            type: "preSolve",
            contactEquations: null,
            frictionEquations: null
          }, this.overlappingShapesLastState = {
            keys: []
          }, this.overlappingShapesCurrentState = {
            keys: []
          }, this.overlapKeeper = new v();
        }

        t("../objects/RotationalSpring"), e.exports = x, x.prototype = new Object(c.prototype), x.prototype.constructor = x, x.NO_SLEEPING = 1, x.BODY_SLEEPING = 2, x.ISLAND_SLEEPING = 4, x.prototype.addConstraint = function (t) {
          this.constraints.push(t);
        }, x.prototype.addContactMaterial = function (t) {
          this.contactMaterials.push(t);
        }, x.prototype.removeContactMaterial = function (t) {
          var e = this.contactMaterials.indexOf(t);
          -1 !== e && y.splice(this.contactMaterials, e, 1);
        }, x.prototype.getContactMaterial = function (t, e) {
          for (var i = this.contactMaterials, s = 0, n = i.length; s !== n; s++) {
            var o = i[s];
            if (o.materialA.id === t.id && o.materialB.id === e.id || o.materialA.id === e.id && o.materialB.id === t.id) return o;
          }

          return !1;
        }, x.prototype.removeConstraint = function (t) {
          var e = this.constraints.indexOf(t);
          -1 !== e && y.splice(this.constraints, e, 1);
        }, n.create(), n.create(), n.create(), n.create(), n.create(), n.create();

        var w = n.create(),
            _ = n.fromValues(0, 0),
            T = n.fromValues(0, 0);

        n.fromValues(0, 0), n.fromValues(0, 0), x.prototype.step = function (t, e, i) {
          if (i = i || 10, 0 === (e = e || 0)) this.internalStep(t), this.time += t;else {
            this.accumulator += e;

            for (var s = 0; this.accumulator >= t && s < i;) {
              this.internalStep(t), this.time += t, this.accumulator -= t, s++;
            }

            for (var o = this.accumulator % t / t, r = 0; r !== this.bodies.length; r++) {
              var a = this.bodies[r];
              n.lerp(a.interpolatedPosition, a.previousPosition, a.position, o), a.interpolatedAngle = a.previousAngle + o * (a.angle - a.previousAngle);
            }
          }
        };
        var P = [];
        x.prototype.internalStep = function (t) {
          this.stepping = !0;
          var e = this.springs.length,
              i = this.springs,
              s = this.bodies,
              o = this.gravity,
              r = this.solver,
              a = this.bodies.length,
              h = this.broadphase,
              l = this.narrowphase,
              c = this.constraints,
              d = w,
              p = (n.scale, n.add),
              f = (n.rotate, this.islandManager);

          if (this.overlapKeeper.tick(), this.lastTimeStep = t, this.useWorldGravityAsFrictionGravity) {
            var g = n.length(this.gravity);
            0 === g && this.useFrictionGravityOnZeroGravity || (this.frictionGravity = g);
          }

          if (this.applyGravity) for (var m = 0; m !== a; m++) {
            var v = s[m],
                b = v.force;
            v.type === u.DYNAMIC && v.sleepState !== u.SLEEPING && (n.scale(d, o, v.mass * v.gravityScale), p(b, b, d));
          }
          if (this.applySpringForces) for (var m = 0; m !== e; m++) {
            var _ = i[m];

            _.applyForce();
          }
          if (this.applyDamping) for (var m = 0; m !== a; m++) {
            var v = s[m];
            v.type === u.DYNAMIC && v.applyDamping(t);
          }

          for (var T = h.getCollisionPairs(this), S = this.disabledBodyCollisionPairs, m = S.length - 2; m >= 0; m -= 2) {
            for (var C = T.length - 2; C >= 0; C -= 2) {
              (S[m] === T[C] && S[m + 1] === T[C + 1] || S[m + 1] === T[C] && S[m] === T[C + 1]) && T.splice(C, 2);
            }
          }

          var A = c.length;

          for (m = 0; m !== A; m++) {
            var E = c[m];
            if (!E.collideConnected) for (var C = T.length - 2; C >= 0; C -= 2) {
              (E.bodyA === T[C] && E.bodyB === T[C + 1] || E.bodyB === T[C] && E.bodyA === T[C + 1]) && T.splice(C, 2);
            }
          }

          this.postBroadphaseEvent.pairs = T, this.emit(this.postBroadphaseEvent), this.postBroadphaseEvent.pairs = null, l.reset(this);

          for (var m = 0, M = T.length; m !== M; m += 2) {
            for (var R = T[m], L = T[m + 1], I = 0, k = R.shapes.length; I !== k; I++) {
              for (var O = R.shapes[I], B = O.position, F = O.angle, D = 0, U = L.shapes.length; D !== U; D++) {
                var G = L.shapes[D],
                    N = G.position,
                    W = G.angle,
                    X = this.defaultContactMaterial;

                if (O.material && G.material) {
                  var j = this.getContactMaterial(O.material, G.material);
                  j && (X = j);
                }

                this.runNarrowphase(l, R, O, B, F, L, G, N, W, X, this.frictionGravity);
              }
            }
          }

          for (var m = 0; m !== a; m++) {
            var H = s[m];
            H._wakeUpAfterNarrowphase && (H.wakeUp(), H._wakeUpAfterNarrowphase = !1);
          }

          if (this.has("endContact")) {
            this.overlapKeeper.getEndOverlaps(P);

            for (var V = this.endContactEvent, D = P.length; D--;) {
              var q = P[D];
              V.shapeA = q.shapeA, V.shapeB = q.shapeB, V.bodyA = q.bodyA, V.bodyB = q.bodyB, this.emit(V);
            }

            P.length = 0;
          }

          var Y = this.preSolveEvent;
          Y.contactEquations = l.contactEquations, Y.frictionEquations = l.frictionEquations, this.emit(Y), Y.contactEquations = Y.frictionEquations = null;
          var A = c.length;

          for (m = 0; m !== A; m++) {
            c[m].update();
          }

          if (l.contactEquations.length || l.frictionEquations.length || A) if (this.islandSplit) {
            for (f.equations.length = 0, y.appendArray(f.equations, l.contactEquations), y.appendArray(f.equations, l.frictionEquations), m = 0; m !== A; m++) {
              y.appendArray(f.equations, c[m].equations);
            }

            f.split(this);

            for (var m = 0; m !== f.islands.length; m++) {
              var z = f.islands[m];
              z.equations.length && r.solveIsland(t, z);
            }
          } else {
            for (r.addEquations(l.contactEquations), r.addEquations(l.frictionEquations), m = 0; m !== A; m++) {
              r.addEquations(c[m].equations);
            }

            this.solveConstraints && r.solve(t, this), r.removeAllEquations();
          }

          for (var m = 0; m !== a; m++) {
            var H = s[m];
            H.integrate(t);
          }

          for (var m = 0; m !== a; m++) {
            s[m].setZeroForce();
          }

          if (this.emitImpactEvent && this.has("impact")) for (var K = this.impactEvent, m = 0; m !== l.contactEquations.length; m++) {
            var J = l.contactEquations[m];
            J.firstImpact && (K.bodyA = J.bodyA, K.bodyB = J.bodyB, K.shapeA = J.shapeA, K.shapeB = J.shapeB, K.contactEquation = J, this.emit(K));
          }
          if (this.sleepMode === x.BODY_SLEEPING) for (m = 0; m !== a; m++) {
            s[m].sleepTick(this.time, !1, t);
          } else if (this.sleepMode === x.ISLAND_SLEEPING && this.islandSplit) {
            for (m = 0; m !== a; m++) {
              s[m].sleepTick(this.time, !0, t);
            }

            for (var m = 0; m < this.islandManager.islands.length; m++) {
              var z = this.islandManager.islands[m];
              z.wantsToSleep() && z.sleep();
            }
          }
          this.stepping = !1;

          for (var Q = this.bodiesToBeRemoved, m = 0; m !== Q.length; m++) {
            this.removeBody(Q[m]);
          }

          Q.length = 0, this.emit(this.postStepEvent);
        }, x.prototype.runNarrowphase = function (t, e, i, s, o, r, a, h, l, c, d) {
          if (0 != (i.collisionGroup & a.collisionMask) && 0 != (a.collisionGroup & i.collisionMask)) {
            n.rotate(_, s, e.angle), n.rotate(T, h, r.angle), n.add(_, _, e.position), n.add(T, T, r.position);
            var p,
                f = o + e.angle,
                g = l + r.angle;
            t.enableFriction = c.friction > 0, t.frictionCoefficient = c.friction, p = e.type === u.STATIC || e.type === u.KINEMATIC ? r.mass : r.type === u.STATIC || r.type === u.KINEMATIC ? e.mass : e.mass * r.mass / (e.mass + r.mass), t.slipForce = c.friction * d * p, t.restitution = c.restitution, t.surfaceVelocity = c.surfaceVelocity, t.frictionStiffness = c.frictionStiffness, t.frictionRelaxation = c.frictionRelaxation, t.stiffness = c.stiffness, t.relaxation = c.relaxation, t.contactSkinSize = c.contactSkinSize, t.enabledEquations = e.collisionResponse && r.collisionResponse && i.collisionResponse && a.collisionResponse;
            var m = t[i.type | a.type],
                y = 0;

            if (m) {
              var v = i.sensor || a.sensor,
                  b = t.frictionEquations.length;
              y = i.type < a.type ? m.call(t, e, i, _, f, r, a, T, g, v) : m.call(t, r, a, T, g, e, i, _, f, v);
              var x = t.frictionEquations.length - b;

              if (y) {
                if (e.allowSleep && e.type === u.DYNAMIC && e.sleepState === u.SLEEPING && r.sleepState === u.AWAKE && r.type !== u.STATIC) {
                  var w = n.squaredLength(r.velocity) + Math.pow(r.angularVelocity, 2),
                      P = Math.pow(r.sleepSpeedLimit, 2);
                  w >= 2 * P && (e._wakeUpAfterNarrowphase = !0);
                }

                if (r.allowSleep && r.type === u.DYNAMIC && r.sleepState === u.SLEEPING && e.sleepState === u.AWAKE && e.type !== u.STATIC) {
                  var S = n.squaredLength(e.velocity) + Math.pow(e.angularVelocity, 2),
                      C = Math.pow(e.sleepSpeedLimit, 2);
                  S >= 2 * C && (r._wakeUpAfterNarrowphase = !0);
                }

                if (this.overlapKeeper.setOverlapping(e, i, r, a), this.has("beginContact") && this.overlapKeeper.isNewOverlap(i, a)) {
                  var A = this.beginContactEvent;
                  if (A.shapeA = i, A.shapeB = a, A.bodyA = e, A.bodyB = r, A.contactEquations.length = 0, "number" == typeof y) for (var E = t.contactEquations.length - y; E < t.contactEquations.length; E++) {
                    A.contactEquations.push(t.contactEquations[E]);
                  }
                  this.emit(A);
                }

                if ("number" == typeof y && x > 1) for (var E = t.frictionEquations.length - x; E < t.frictionEquations.length; E++) {
                  var M = t.frictionEquations[E];
                  M.setSlipForce(M.getSlipForce() / x);
                }
              }
            }
          }
        }, x.prototype.addSpring = function (t) {
          this.springs.push(t);
          var e = this.addSpringEvent;
          e.spring = t, this.emit(e), e.spring = null;
        }, x.prototype.removeSpring = function (t) {
          var e = this.springs.indexOf(t);
          -1 !== e && y.splice(this.springs, e, 1);
        }, x.prototype.addBody = function (t) {
          if (-1 === this.bodies.indexOf(t)) {
            this.bodies.push(t), t.world = this;
            var e = this.addBodyEvent;
            e.body = t, this.emit(e), e.body = null;
          }
        }, x.prototype.removeBody = function (t) {
          if (this.stepping) this.bodiesToBeRemoved.push(t);else {
            t.world = null;
            var e = this.bodies.indexOf(t);
            -1 !== e && (y.splice(this.bodies, e, 1), this.removeBodyEvent.body = t, t.resetConstraintVelocity(), this.emit(this.removeBodyEvent), this.removeBodyEvent.body = null);
          }
        }, x.prototype.getBodyById = function (t) {
          for (var e = this.bodies, i = 0; i < e.length; i++) {
            var s = e[i];
            if (s.id === t) return s;
          }

          return !1;
        }, x.prototype.disableBodyCollision = function (t, e) {
          this.disabledBodyCollisionPairs.push(t, e);
        }, x.prototype.enableBodyCollision = function (t, e) {
          for (var i = this.disabledBodyCollisionPairs, s = 0; s < i.length; s += 2) {
            if (i[s] === t && i[s + 1] === e || i[s + 1] === t && i[s] === e) return void i.splice(s, 2);
          }
        }, x.prototype.clear = function () {
          this.time = 0, this.solver && this.solver.equations.length && this.solver.removeAllEquations();

          for (var t = this.constraints, e = t.length - 1; e >= 0; e--) {
            this.removeConstraint(t[e]);
          }

          for (var i = this.bodies, e = i.length - 1; e >= 0; e--) {
            this.removeBody(i[e]);
          }

          for (var s = this.springs, e = s.length - 1; e >= 0; e--) {
            this.removeSpring(s[e]);
          }

          for (var n = this.contactMaterials, e = n.length - 1; e >= 0; e--) {
            this.removeContactMaterial(n[e]);
          }

          x.apply(this);
        };
        var S = n.create(),
            C = (n.fromValues(0, 0), n.fromValues(0, 0));
        x.prototype.hitTest = function (t, e, i) {
          i = i || 0;
          var s = new u({
            position: t
          }),
              c = new l(),
              d = t,
              p = S,
              f = C;
          s.addShape(c);

          for (var g = this.narrowphase, m = [], y = 0, v = e.length; y !== v; y++) {
            for (var b = e[y], x = 0, w = b.shapes.length; x !== w; x++) {
              var _ = b.shapes[x];
              n.rotate(p, _.position, b.angle), n.add(p, p, b.position);
              var T = _.angle + b.angle;
              (_ instanceof o && g.circleParticle(b, _, p, T, s, c, d, 0, !0) || _ instanceof r && g.particleConvex(s, c, d, 0, b, _, p, T, !0) || _ instanceof a && g.particlePlane(s, c, d, 0, b, _, p, T, !0) || _ instanceof h && g.particleCapsule(s, c, d, 0, b, _, p, T, !0) || _ instanceof l && n.squaredLength(n.sub(f, p, t)) < i * i) && m.push(b);
            }
          }

          return m;
        }, x.prototype.setGlobalStiffness = function (t) {
          for (var e = this.constraints, i = 0; i !== e.length; i++) {
            for (var s = e[i], n = 0; n !== s.equations.length; n++) {
              var o = s.equations[n];
              o.stiffness = t, o.needsUpdate = !0;
            }
          }

          for (var r = this.contactMaterials, i = 0; i !== r.length; i++) {
            var s = r[i];
            s.stiffness = s.frictionStiffness = t;
          }

          var s = this.defaultContactMaterial;
          s.stiffness = s.frictionStiffness = t;
        }, x.prototype.setGlobalRelaxation = function (t) {
          for (var e = 0; e !== this.constraints.length; e++) {
            for (var i = this.constraints[e], s = 0; s !== i.equations.length; s++) {
              var n = i.equations[s];
              n.relaxation = t, n.needsUpdate = !0;
            }
          }

          for (var e = 0; e !== this.contactMaterials.length; e++) {
            var i = this.contactMaterials[e];
            i.relaxation = i.frictionRelaxation = t;
          }

          var i = this.defaultContactMaterial;
          i.relaxation = i.frictionRelaxation = t;
        };
        var A = new f(),
            E = [];

        x.prototype.raycast = function (t, e) {
          return e.getAABB(A), this.broadphase.aabbQuery(this, A, E), e.intersectBodies(t, E), E.length = 0, t.hasHit();
        };
      }, {
        "../../package.json": 6,
        "../collision/AABB": 7,
        "../collision/Broadphase": 8,
        "../collision/Narrowphase": 10,
        "../collision/Ray": 11,
        "../collision/SAPBroadphase": 13,
        "../constraints/Constraint": 14,
        "../constraints/DistanceConstraint": 15,
        "../constraints/GearConstraint": 16,
        "../constraints/LockConstraint": 17,
        "../constraints/PrismaticConstraint": 18,
        "../constraints/RevoluteConstraint": 19,
        "../events/EventEmitter": 26,
        "../material/ContactMaterial": 27,
        "../material/Material": 28,
        "../math/vec2": 30,
        "../objects/Body": 31,
        "../objects/LinearSpring": 32,
        "../objects/RotationalSpring": 33,
        "../shapes/Capsule": 38,
        "../shapes/Circle": 39,
        "../shapes/Convex": 40,
        "../shapes/Line": 42,
        "../shapes/Particle": 43,
        "../shapes/Plane": 44,
        "../shapes/Shape": 45,
        "../solver/GSSolver": 46,
        "../solver/Solver": 47,
        "../utils/OverlapKeeper": 52,
        "../utils/Utils": 57,
        "./IslandManager": 59
      }]
    }, {}, [36])(36);
  }, function (t, e, i) {
    (function (e) {
      t.exports = e.Phaser = i(7);
    }).call(this, i(0));
  }, function (t, e, i) {
    (function (i) {
      /**
      * @author       Richard Davey <rich@photonstorm.com>
      * @copyright    2016 Photon Storm Ltd.
      * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
      *
      * @overview
      *
      * Phaser - http://phaser.io
      *
      * v2.10.6 "2018-06-01" - Built: Fri Jun 01 2018 17:44:52
      *
      * By Richard Davey http://www.photonstorm.com @photonstorm
      *
      * Phaser is a fun, free and fast 2D game framework for making HTML5 games
      * for desktop and mobile web browsers, supporting Canvas and WebGL rendering.
      *
      * Phaser uses Pixi.js for rendering, created by Mat Groves http://matgroves.com @Doormat23
      * Phaser uses p2.js for full-body physics, created by Stefan Hedman https://github.com/schteppe/p2.js @schteppe
      * Phaser contains a port of N+ Physics, converted by Richard Davey, original by http://www.metanetsoftware.com
      *
      * Many thanks to Adam Saltsman (@ADAMATOMIC) for releasing Flixel, from which both Phaser and my love of framework development originate.
      *
      * Follow development at http://phaser.io and on our forum
      *
      * "If you want your children to be intelligent,  read them fairy tales."
      * "If you want them to be more intelligent, read them more fairy tales."
      *                                                     -- Albert Einstein
      */

      /**
      * @author       Richard Davey <rich@photonstorm.com>
      * @copyright    2016 Photon Storm Ltd.
      * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
      */
      (function () {
        var s = s || {
          VERSION: "2.10.6",
          GAMES: [],
          AUTO: 0,
          CANVAS: 1,
          WEBGL: 2,
          HEADLESS: 3,
          WEBGL_MULTI: 4,
          NONE: 0,
          LEFT: 1,
          RIGHT: 2,
          UP: 3,
          DOWN: 4,
          SPRITE: 0,
          BUTTON: 1,
          IMAGE: 2,
          GRAPHICS: 3,
          TEXT: 4,
          TILESPRITE: 5,
          BITMAPTEXT: 6,
          GROUP: 7,
          RENDERTEXTURE: 8,
          TILEMAP: 9,
          TILEMAPLAYER: 10,
          EMITTER: 11,
          POLYGON: 12,
          BITMAPDATA: 13,
          CANVAS_FILTER: 14,
          WEBGL_FILTER: 15,
          ELLIPSE: 16,
          SPRITEBATCH: 17,
          RETROFONT: 18,
          POINTER: 19,
          ROPE: 20,
          CIRCLE: 21,
          RECTANGLE: 22,
          LINE: 23,
          MATRIX: 24,
          POINT: 25,
          ROUNDEDRECTANGLE: 26,
          CREATURE: 27,
          VIDEO: 28,
          PENDING_ATLAS: -1,
          HORIZONTAL: 0,
          VERTICAL: 1,
          LANDSCAPE: 0,
          PORTRAIT: 1,
          ANGLE_UP: 270,
          ANGLE_DOWN: 90,
          ANGLE_LEFT: 180,
          ANGLE_RIGHT: 0,
          ANGLE_NORTH_EAST: 315,
          ANGLE_NORTH_WEST: 225,
          ANGLE_SOUTH_EAST: 45,
          ANGLE_SOUTH_WEST: 135,
          TOP_LEFT: 0,
          TOP_CENTER: 1,
          TOP_RIGHT: 2,
          LEFT_TOP: 3,
          LEFT_CENTER: 4,
          LEFT_BOTTOM: 5,
          CENTER: 6,
          RIGHT_TOP: 7,
          RIGHT_CENTER: 8,
          RIGHT_BOTTOM: 9,
          BOTTOM_LEFT: 10,
          BOTTOM_CENTER: 11,
          BOTTOM_RIGHT: 12,
          blendModes: {
            NORMAL: 0,
            ADD: 1,
            MULTIPLY: 2,
            SCREEN: 3,
            OVERLAY: 4,
            DARKEN: 5,
            LIGHTEN: 6,
            COLOR_DODGE: 7,
            COLOR_BURN: 8,
            HARD_LIGHT: 9,
            SOFT_LIGHT: 10,
            DIFFERENCE: 11,
            EXCLUSION: 12,
            HUE: 13,
            SATURATION: 14,
            COLOR: 15,
            LUMINOSITY: 16
          },
          scaleModes: {
            DEFAULT: 0,
            LINEAR: 0,
            NEAREST: 1
          },
          PIXI: PIXI || {},
          _UID: 0
        };
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */

        if (
        /**
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        Math.trunc || (Math.trunc = function (t) {
          return t < 0 ? Math.ceil(t) : Math.floor(t);
        }), Function.prototype.bind || (Function.prototype.bind = function () {
          var t = Array.prototype.slice;
          return function (e) {
            var i = this,
                s = t.call(arguments, 1);
            if ("function" != typeof i) throw new TypeError();

            function n() {
              var o = s.concat(t.call(arguments));
              i.apply(this instanceof n ? this : e, o);
            }

            return n.prototype = function t(e) {
              if (e && (t.prototype = e), !(this instanceof t)) return new t();
            }(i.prototype), n;
          };
        }()), Array.isArray || (Array.isArray = function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        }), Array.prototype.forEach || (Array.prototype.forEach = function (t) {
          "use strict";

          if (void 0 === this || null === this) throw new TypeError();
          var e = Object(this),
              i = e.length >>> 0;
          if ("function" != typeof t) throw new TypeError();

          for (var s = arguments.length >= 2 ? arguments[1] : void 0, n = 0; n < i; n++) {
            n in e && t.call(s, e[n], n, e);
          }
        }), "function" != typeof window.Uint32Array && "object" != typeof window.Uint32Array) {
          var n = function n(t) {
            var e = new Array();
            window[t] = function (t) {
              if ("number" == typeof t) {
                Array.call(this, t), this.length = t;

                for (var e = 0; e < this.length; e++) {
                  this[e] = 0;
                }
              } else {
                Array.call(this, t.length), this.length = t.length;

                for (e = 0; e < this.length; e++) {
                  this[e] = t[e];
                }
              }
            }, window[t].prototype = e, window[t].constructor = window[t];
          };

          n("Float32Array"), n("Uint32Array"), n("Uint16Array"), n("Int16Array"), n("ArrayBuffer");
        }

        function o(t, e) {
          this._scaleFactor = t, this._deltaMode = e, this.originalEvent = null;
        }

        for (var r in window.console || (window.console = {}, window.console.log = window.console.assert = function () {}, window.console.warn = window.console.assert = function () {}), Object.assign || (Object.assign = function (t, e) {
          "use strict";

          if (null == t) throw new TypeError("Cannot convert undefined or null to object");

          for (var i = Object(t), s = Object.prototype.hasOwnProperty, n = 1; n < arguments.length; n++) {
            var o = arguments[n];
            if (null != o) for (var r in o) {
              s.call(o, r) && (i[r] = o[r]);
            }
          }

          return i;
        })
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        , s.Utils = {
          reverseString: function reverseString(t) {
            return t.split("").reverse().join("");
          },
          getProperty: function getProperty(t, e) {
            var i = e.split(".");

            switch (i.length) {
              case 1:
                return t[e];

              case 2:
                return t[i[0]][i[1]];

              case 3:
                return t[i[0]][i[1]][i[2]];

              case 4:
                return t[i[0]][i[1]][i[2]][i[3]];

              default:
                return this._getProperty(t, e);
            }
          },
          setProperties: function setProperties(t, e) {
            for (var i in e) {
              this.setProperty(t, i, e[i]);
            }

            return t;
          },
          setProperty: function setProperty(t, e, i) {
            var s = e.split(".");

            switch (s.length) {
              case 1:
                t[e] = i;
                break;

              case 2:
                t[s[0]][s[1]] = i;
                break;

              case 3:
                t[s[0]][s[1]][s[2]] = i;
                break;

              case 4:
                t[s[0]][s[1]][s[2]][s[3]] = i;
                break;

              default:
                this._setProperty(t, e, i);

            }
          },
          _getProperty: function _getProperty(t, e) {
            for (var i = e.split("."), s = i.length, n = 0, o = t; n < s;) {
              var r = i[n];
              if (null == o) return;
              o = o[r], n++;
            }

            return o;
          },
          _setProperty: function _setProperty(t, e, i) {
            var s = e.split("."),
                n = s.length,
                o = 0,
                r = t,
                a = s[0];
            if (1 === n) t[e] = i;else {
              for (; o < n - 1;) {
                r = r[a], a = s[++o];
              }

              r[a] = i;
            }
            return t;
          },
          chanceRoll: function chanceRoll(t) {
            return void 0 === t && (t = 50), t > 0 && 100 * Math.random() <= t;
          },
          randomChoice: function randomChoice(t, e) {
            return Math.random() < .5 ? t : e;
          },
          parseDimension: function parseDimension(t, e) {
            var i = 0,
                s = 0;
            return "string" == typeof t ? "%" === t.substr(-1) ? (i = parseInt(t, 10) / 100, s = 0 === e ? window.innerWidth * i : window.innerHeight * i) : s = parseInt(t, 10) : s = t, s;
          },
          pad: function pad(t, e, i, s) {
            if (void 0 === e) e = 0;
            if (void 0 === i) i = " ";
            if (void 0 === s) s = 3;
            var n = 0;
            if (e + 1 >= (t = t.toString()).length) switch (s) {
              case 1:
                t = new Array(e + 1 - t.length).join(i) + t;
                break;

              case 3:
                var o = Math.ceil((n = e - t.length) / 2);
                t = new Array(n - o + 1).join(i) + t + new Array(o + 1).join(i);
                break;

              default:
                t += new Array(e + 1 - t.length).join(i);
            }
            return t;
          },
          isPlainObject: function isPlainObject(t) {
            if ("object" != typeof t || t.nodeType || t === t.window) return !1;

            try {
              if (t.constructor && !{}.hasOwnProperty.call(t.constructor.prototype, "isPrototypeOf")) return !1;
            } catch (t) {
              return !1;
            }

            return !0;
          },
          extend: function extend() {
            var t,
                e,
                i,
                n,
                o,
                r,
                a = arguments[0] || {},
                h = 1,
                l = arguments.length,
                c = !1;

            for ("boolean" == typeof a && (c = a, a = arguments[1] || {}, h = 2), l === h && (a = this, --h); h < l; h++) {
              if (null != (t = arguments[h])) for (e in t) {
                i = a[e], a !== (n = t[e]) && (c && n && (s.Utils.isPlainObject(n) || (o = Array.isArray(n))) ? (o ? (o = !1, r = i && Array.isArray(i) ? i : []) : r = i && s.Utils.isPlainObject(i) ? i : {}, a[e] = s.Utils.extend(c, r, n)) : void 0 !== n && (a[e] = n));
              }
            }

            return a;
          },
          mixinPrototype: function mixinPrototype(t, e, i) {
            void 0 === i && (i = !1);

            for (var s = Object.keys(e), n = 0; n < s.length; n++) {
              var o = s[n],
                  r = e[o];
              !i && o in t || (!r || "function" != typeof r.get && "function" != typeof r.set ? t[o] = r : "function" == typeof r.clone ? t[o] = r.clone() : Object.defineProperty(t, o, r));
            }
          },
          mixin: function mixin(t, e) {
            if (!t || "object" != typeof t) return e;

            for (var i in t) {
              var n = t[i];

              if (!n.childNodes && !n.cloneNode) {
                var o = typeof t[i];
                t[i] && "object" === o ? typeof e[i] === o ? e[i] = s.Utils.mixin(t[i], e[i]) : e[i] = s.Utils.mixin(t[i], new n.constructor()) : e[i] = t[i];
              }
            }

            return e;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Circle = function (t, e, i) {
          t = t || 0, e = e || 0, i = i || 0, this.x = t, this.y = e, this._diameter = i, this._radius = 0, i > 0 && (this._radius = .5 * i), this.type = s.CIRCLE;
        }, s.Circle.prototype = {
          circumference: function circumference() {
            return Math.PI * this._radius * 2;
          },
          random: function random(t) {
            void 0 === t && (t = new s.Point());
            var e = 2 * Math.PI * Math.random(),
                i = Math.random() + Math.random(),
                n = i > 1 ? 2 - i : i,
                o = n * Math.cos(e),
                r = n * Math.sin(e);
            return t.x = this.x + o * this.radius, t.y = this.y + r * this.radius, t;
          },
          getBounds: function getBounds() {
            return new s.Rectangle(this.x - this.radius, this.y - this.radius, this.diameter, this.diameter);
          },
          setTo: function setTo(t, e, i) {
            return this.x = t, this.y = e, this._diameter = i, this._radius = .5 * i, this;
          },
          copyFrom: function copyFrom(t) {
            return this.setTo(t.x, t.y, t.diameter);
          },
          copyTo: function copyTo(t) {
            return t.x = this.x, t.y = this.y, t.diameter = this._diameter, t;
          },
          distance: function distance(t, e) {
            var i = s.Math.distance(this.x, this.y, t.x, t.y);
            return e ? Math.round(i) : i;
          },
          clone: function clone(t) {
            return void 0 === t || null === t ? t = new s.Circle(this.x, this.y, this.diameter) : t.setTo(this.x, this.y, this.diameter), t;
          },
          contains: function contains(t, e) {
            return s.Circle.contains(this, t, e);
          },
          circumferencePoint: function circumferencePoint(t, e, i) {
            return s.Circle.circumferencePoint(this, t, e, i);
          },
          sample: function sample(t, e, i, n, o) {
            t || (t = 60), null == e && (e = 0), null == i && (i = s.Math.PI2), o || (o = []);

            for (var r = 0; r < t;) {
              this.circumferencePoint(s.Math.linear(e, i, r / t), n, o[r] || (o[r] = new s.Point())), r += 1;
            }

            return o;
          },
          offset: function offset(t, e) {
            return this.x += t, this.y += e, this;
          },
          offsetPoint: function offsetPoint(t) {
            return this.offset(t.x, t.y);
          },
          toString: function toString() {
            return "[{Phaser.Circle (x=" + this.x + " y=" + this.y + " diameter=" + this.diameter + " radius=" + this.radius + ")}]";
          }
        }, s.Circle.prototype.constructor = s.Circle, Object.defineProperty(s.Circle.prototype, "diameter", {
          get: function get() {
            return this._diameter;
          },
          set: function set(t) {
            t > 0 && (this._diameter = t, this._radius = .5 * t);
          }
        }), Object.defineProperty(s.Circle.prototype, "radius", {
          get: function get() {
            return this._radius;
          },
          set: function set(t) {
            t > 0 && (this._radius = t, this._diameter = 2 * t);
          }
        }), Object.defineProperty(s.Circle.prototype, "left", {
          get: function get() {
            return this.x - this._radius;
          },
          set: function set(t) {
            t > this.x ? (this._radius = 0, this._diameter = 0) : this.radius = this.x - t;
          }
        }), Object.defineProperty(s.Circle.prototype, "right", {
          get: function get() {
            return this.x + this._radius;
          },
          set: function set(t) {
            t < this.x ? (this._radius = 0, this._diameter = 0) : this.radius = t - this.x;
          }
        }), Object.defineProperty(s.Circle.prototype, "top", {
          get: function get() {
            return this.y - this._radius;
          },
          set: function set(t) {
            t > this.y ? (this._radius = 0, this._diameter = 0) : this.radius = this.y - t;
          }
        }), Object.defineProperty(s.Circle.prototype, "bottom", {
          get: function get() {
            return this.y + this._radius;
          },
          set: function set(t) {
            t < this.y ? (this._radius = 0, this._diameter = 0) : this.radius = t - this.y;
          }
        }), Object.defineProperty(s.Circle.prototype, "area", {
          get: function get() {
            return this._radius > 0 ? Math.PI * this._radius * this._radius : 0;
          }
        }), Object.defineProperty(s.Circle.prototype, "empty", {
          get: function get() {
            return 0 === this._diameter;
          },
          set: function set(t) {
            !0 === t && this.setTo(0, 0, 0);
          }
        }), s.Circle.contains = function (t, e, i) {
          return t.radius > 0 && e >= t.left && e <= t.right && i >= t.top && i <= t.bottom && (t.x - e) * (t.x - e) + (t.y - i) * (t.y - i) <= t.radius * t.radius;
        }, s.Circle.equals = function (t, e) {
          return t.x === e.x && t.y === e.y && t.diameter === e.diameter;
        }, s.Circle.intersects = function (t, e) {
          return s.Math.distance(t.x, t.y, e.x, e.y) <= t.radius + e.radius;
        }, s.Circle.circumferencePoint = function (t, e, i, n) {
          return void 0 === i && (i = !1), void 0 === n && (n = new s.Point()), !0 === i && (e = s.Math.degToRad(e)), n.x = t.x + t.radius * Math.cos(e), n.y = t.y + t.radius * Math.sin(e), n;
        }, s.Circle.intersectsRectangle = function (t, e) {
          var i = Math.abs(t.x - e.x - e.halfWidth);
          if (i > e.halfWidth + t.radius) return !1;
          var s = Math.abs(t.y - e.y - e.halfHeight);
          if (s > e.halfHeight + t.radius) return !1;
          if (i <= e.halfWidth || s <= e.halfHeight) return !0;
          var n = i - e.halfWidth,
              o = s - e.halfHeight;
          return n * n + o * o <= t.radius * t.radius;
        }, s.Circle.intersectsLine = function (t, e, i) {
          var n = t.x,
              o = t.y,
              r = (e.end.y - e.start.y) / (e.end.x - e.start.x),
              a = e.end.y - r * e.end.x,
              h = t.radius,
              l = t.radius,
              c = a + r * n,
              u = (n * (l * l) - r * (h * h) * (a - o) + h * l * Math.sqrt(h * h * (r * r) + l * l - c * c - o * o + 2 * c * o)) / (h * h * (r * r) + l * l),
              d = (n * (l * l) - r * (h * h) * (a - o) - h * l * Math.sqrt(h * h * (r * r) + l * l - c * c - o * o + 2 * c * o)) / (h * h * (r * r) + l * l),
              p = r * u + a,
              f = r * d + a,
              g = new s.Point(u, p),
              m = new s.Point(d, f),
              y = e.pointOnSegment(g.x, g.y, .01),
              v = e.pointOnSegment(m.x, m.y, .01);
          return y && v ? !i || [g, m] : y ? !i || [g] : v ? !i || [m] : !!i && [];
        }, PIXI.Circle = s.Circle,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @author       Chad Engler <chad@pantherdev.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Ellipse = function (t, e, i, n) {
          t = t || 0, e = e || 0, i = i || 0, n = n || 0, this.x = t, this.y = e, this.width = i, this.height = n, this.type = s.ELLIPSE;
        }, s.Ellipse.prototype = {
          setTo: function setTo(t, e, i, s) {
            return this.x = t, this.y = e, this.width = i, this.height = s, this;
          },
          getBounds: function getBounds() {
            return new s.Rectangle(this.x - this.width, this.y - this.height, this.width, this.height);
          },
          copyFrom: function copyFrom(t) {
            return this.setTo(t.x, t.y, t.width, t.height);
          },
          copyTo: function copyTo(t) {
            return t.x = this.x, t.y = this.y, t.width = this.width, t.height = this.height, t;
          },
          clone: function clone(t) {
            return void 0 === t || null === t ? t = new s.Ellipse(this.x, this.y, this.width, this.height) : t.setTo(this.x, this.y, this.width, this.height), t;
          },
          contains: function contains(t, e) {
            return s.Ellipse.contains(this, t, e);
          },
          random: function random(t) {
            void 0 === t && (t = new s.Point());
            var e = Math.random() * Math.PI * 2,
                i = Math.sqrt(Math.random());
            return t.x = this.centerX + .5 * i * Math.cos(e) * this.width, t.y = this.centerY + .5 * i * Math.sin(e) * this.height, t;
          },
          toString: function toString() {
            return "[{Phaser.Ellipse (x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + ")}]";
          }
        }, s.Ellipse.prototype.constructor = s.Ellipse, Object.defineProperty(s.Ellipse.prototype, "left", {
          get: function get() {
            return this.x;
          },
          set: function set(t) {
            this.x = t;
          }
        }), Object.defineProperty(s.Ellipse.prototype, "right", {
          get: function get() {
            return this.x + this.width;
          },
          set: function set(t) {
            t < this.x ? this.width = 0 : this.width = t - this.x;
          }
        }), Object.defineProperty(s.Ellipse.prototype, "top", {
          get: function get() {
            return this.y;
          },
          set: function set(t) {
            this.y = t;
          }
        }), Object.defineProperty(s.Ellipse.prototype, "bottom", {
          get: function get() {
            return this.y + this.height;
          },
          set: function set(t) {
            t < this.y ? this.height = 0 : this.height = t - this.y;
          }
        }), Object.defineProperty(s.Ellipse.prototype, "centerX", {
          get: function get() {
            return this.x + .5 * this.width;
          }
        }), Object.defineProperty(s.Ellipse.prototype, "centerY", {
          get: function get() {
            return this.y + .5 * this.height;
          }
        }), Object.defineProperty(s.Ellipse.prototype, "empty", {
          get: function get() {
            return 0 === this.width || 0 === this.height;
          },
          set: function set(t) {
            !0 === t && this.setTo(0, 0, 0, 0);
          }
        }), s.Ellipse.contains = function (t, e, i) {
          if (t.width <= 0 || t.height <= 0) return !1;
          var s = (e - t.x) / t.width - .5,
              n = (i - t.y) / t.height - .5;
          return (s *= s) + (n *= n) < .25;
        }, s.Ellipse.intersectsLine = function (t, e, i) {
          var n = t.x,
              o = t.y,
              r = (e.end.y - e.start.y) / (e.end.x - e.start.x),
              a = e.end.y - r * e.end.x,
              h = t.width / 2,
              l = t.height / 2,
              c = a + r * n,
              u = (n * (l * l) - r * (h * h) * (a - o) + h * l * Math.sqrt(h * h * (r * r) + l * l - c * c - o * o + 2 * c * o)) / (h * h * (r * r) + l * l),
              d = (n * (l * l) - r * (h * h) * (a - o) - h * l * Math.sqrt(h * h * (r * r) + l * l - c * c - o * o + 2 * c * o)) / (h * h * (r * r) + l * l),
              p = r * u + a,
              f = r * d + a,
              g = new s.Point(u, p),
              m = new s.Point(d, f),
              y = e.pointOnSegment(g.x, g.y, .01),
              v = e.pointOnSegment(m.x, m.y, .01);
          return y && v ? !i || [g, m] : y ? !i || [g] : v ? !i || [m] : !!i && [];
        }, PIXI.Ellipse = s.Ellipse,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Line = function (t, e, i, n) {
          t = t || 0, e = e || 0, i = i || 0, n = n || 0, this.start = new s.Point(t, e), this.end = new s.Point(i, n), this.type = s.LINE;
        }, s.Line.prototype = {
          setTo: function setTo(t, e, i, s) {
            return this.start.setTo(t, e), this.end.setTo(i, s), this;
          },
          fromPoints: function fromPoints(t, e) {
            return this.setTo(t.x, t.y, e.x, e.y), this;
          },
          fromSprite: function fromSprite(t, e, i) {
            return void 0 === i && (i = !1), i ? this.setTo(t.centerX, t.centerY, e.centerX, e.centerY) : this.fromPoints(t, e);
          },
          fromAngle: function fromAngle(t, e, i, s) {
            return this.start.setTo(t, e), this.end.setTo(t + Math.cos(i) * s, e + Math.sin(i) * s), this;
          },
          rotate: function rotate(t, e) {
            var i = (this.start.x + this.end.x) / 2,
                s = (this.start.y + this.end.y) / 2;
            return this.start.rotate(i, s, t, e), this.end.rotate(i, s, t, e), this;
          },
          rotateAround: function rotateAround(t, e, i, s) {
            return this.start.rotate(t, e, i, s), this.end.rotate(t, e, i, s), this;
          },
          intersects: function intersects(t, e, i) {
            return s.Line.intersectsPoints(this.start, this.end, t.start, t.end, e, i);
          },
          reflect: function reflect(t) {
            return s.Line.reflect(this, t);
          },
          midPoint: function midPoint(t) {
            return void 0 === t && (t = new s.Point()), t.x = (this.start.x + this.end.x) / 2, t.y = (this.start.y + this.end.y) / 2, t;
          },
          centerOn: function centerOn(t, e) {
            var i = t - (this.start.x + this.end.x) / 2,
                s = e - (this.start.y + this.end.y) / 2;
            this.start.add(i, s), this.end.add(i, s);
          },
          pointOnLine: function pointOnLine(t, e, i) {
            return s.Math.fuzzyEqual((t - this.start.x) * (this.end.y - this.start.y), (this.end.x - this.start.x) * (e - this.start.y), i || 0);
          },
          pointOnSegment: function pointOnSegment(t, e, i) {
            var s = Math.min(this.start.x, this.end.x),
                n = Math.max(this.start.x, this.end.x),
                o = Math.min(this.start.y, this.end.y),
                r = Math.max(this.start.y, this.end.y);
            return this.pointOnLine(t, e, i) && t >= s && t <= n && e >= o && e <= r;
          },
          random: function random(t) {
            void 0 === t && (t = new s.Point());
            var e = Math.random();
            return t.x = this.start.x + e * (this.end.x - this.start.x), t.y = this.start.y + e * (this.end.y - this.start.y), t;
          },
          coordinatesOnLine: function coordinatesOnLine(t, e) {
            void 0 === t && (t = 1), void 0 === e && (e = []);
            var i = Math.round(this.start.x),
                s = Math.round(this.start.y),
                n = Math.round(this.end.x),
                o = Math.round(this.end.y),
                r = Math.abs(n - i),
                a = Math.abs(o - s),
                h = i < n ? 1 : -1,
                l = s < o ? 1 : -1,
                c = r - a;
            e.push([i, s]);

            for (var u = 1; i !== n || s !== o;) {
              var d = c << 1;
              d > -a && (c -= a, i += h), d < r && (c += r, s += l), u % t == 0 && e.push([i, s]), u++;
            }

            return e;
          },
          clone: function clone(t) {
            return void 0 === t || null === t ? t = new s.Line(this.start.x, this.start.y, this.end.x, this.end.y) : t.setTo(this.start.x, this.start.y, this.end.x, this.end.y), t;
          }
        }, Object.defineProperty(s.Line.prototype, "length", {
          get: function get() {
            return Math.sqrt((this.end.x - this.start.x) * (this.end.x - this.start.x) + (this.end.y - this.start.y) * (this.end.y - this.start.y));
          }
        }), Object.defineProperty(s.Line.prototype, "angle", {
          get: function get() {
            return s.Point.angle(this.end, this.start);
          }
        }), Object.defineProperty(s.Line.prototype, "slope", {
          get: function get() {
            return (this.end.y - this.start.y) / (this.end.x - this.start.x);
          }
        }), Object.defineProperty(s.Line.prototype, "perpSlope", {
          get: function get() {
            return -(this.end.x - this.start.x) / (this.end.y - this.start.y);
          }
        }), Object.defineProperty(s.Line.prototype, "x", {
          get: function get() {
            return Math.min(this.start.x, this.end.x);
          }
        }), Object.defineProperty(s.Line.prototype, "y", {
          get: function get() {
            return Math.min(this.start.y, this.end.y);
          }
        }), Object.defineProperty(s.Line.prototype, "left", {
          get: function get() {
            return Math.min(this.start.x, this.end.x);
          }
        }), Object.defineProperty(s.Line.prototype, "right", {
          get: function get() {
            return Math.max(this.start.x, this.end.x);
          }
        }), Object.defineProperty(s.Line.prototype, "top", {
          get: function get() {
            return Math.min(this.start.y, this.end.y);
          }
        }), Object.defineProperty(s.Line.prototype, "bottom", {
          get: function get() {
            return Math.max(this.start.y, this.end.y);
          }
        }), Object.defineProperty(s.Line.prototype, "width", {
          get: function get() {
            return Math.abs(this.start.x - this.end.x);
          }
        }), Object.defineProperty(s.Line.prototype, "height", {
          get: function get() {
            return Math.abs(this.start.y - this.end.y);
          }
        }), Object.defineProperty(s.Line.prototype, "normalX", {
          get: function get() {
            return Math.cos(this.angle - 1.5707963267948966);
          }
        }), Object.defineProperty(s.Line.prototype, "normalY", {
          get: function get() {
            return Math.sin(this.angle - 1.5707963267948966);
          }
        }), Object.defineProperty(s.Line.prototype, "normalAngle", {
          get: function get() {
            return s.Math.wrap(this.angle - 1.5707963267948966, -Math.PI, Math.PI);
          }
        }), s.Line.intersectsPoints = function (t, e, i, n, o, r) {
          void 0 === o && (o = !0), void 0 === r && (r = new s.Point());
          var a = e.y - t.y,
              h = n.y - i.y,
              l = t.x - e.x,
              c = i.x - n.x,
              u = e.x * t.y - t.x * e.y,
              d = n.x * i.y - i.x * n.y,
              p = a * c - h * l;
          if (0 === p) return null;

          if (r.x = (l * d - c * u) / p, r.y = (h * u - a * d) / p, o) {
            var f = (n.y - i.y) * (e.x - t.x) - (n.x - i.x) * (e.y - t.y),
                g = ((n.x - i.x) * (t.y - i.y) - (n.y - i.y) * (t.x - i.x)) / f,
                m = ((e.x - t.x) * (t.y - i.y) - (e.y - t.y) * (t.x - i.x)) / f;
            return g >= 0 && g <= 1 && m >= 0 && m <= 1 ? r : null;
          }

          return r;
        }, s.Line.intersects = function (t, e, i, n) {
          return s.Line.intersectsPoints(t.start, t.end, e.start, e.end, i, n);
        }, s.Line.intersectsRectangle = function (t, e) {
          if (0 === t.length || e.empty) return !1;
          var i = t.start.x,
              s = t.start.y,
              n = t.end.x,
              o = t.end.y,
              r = e.x,
              a = e.y,
              h = e.right,
              l = e.bottom,
              c = 0;
          if (i >= r && i <= h && s >= a && s <= l || n >= r && n <= h && o >= a && o <= l) return !0;

          if (i < r && n >= r) {
            if ((c = s + (o - s) * (r - i) / (n - i)) > a && c <= l) return !0;
          } else if (i > h && n <= h && (c = s + (o - s) * (h - i) / (n - i)) >= a && c <= l) return !0;

          if (s < a && o >= a) {
            if ((c = i + (n - i) * (a - s) / (o - s)) >= r && c <= h) return !0;
          } else if (s > l && o <= l && (c = i + (n - i) * (l - s) / (o - s)) >= r && c <= h) return !0;

          return !1;
        }, s.Line.intersectionWithRectangle = function (t, e, i) {
          var n = s.Line.intersectionWithRectangle;
          i || (i = new s.Point()), n.edges || (n.edges = [new s.Line(), new s.Line(), new s.Line(), new s.Line()]), n.edgeIntersection || (n.edgeIntersection = new s.Point());
          var o = n.edges,
              r = n.edgeIntersection.set(0),
              a = e.x,
              h = e.y,
              l = e.right,
              c = e.bottom,
              u = 1 / 0;
          o[0].setTo(a, h, l, h), o[1].setTo(a, c, l, c), o[2].setTo(a, h, a, c), o[3].setTo(l, h, l, c);

          for (var d, p = 0; d = o[p]; p++) {
            if (t.intersects(d, !0, r)) {
              var f = t.start.distance(r);
              f < u && (u = f, i.copyFrom(r));
            }
          }

          return null != f ? i : null;
        }, s.Line.reflect = function (t, e) {
          return 2 * e.normalAngle - 3.141592653589793 - t.angle;
        },
        /**
        * @author       Mat Groves http://matgroves.com/ @Doormat23
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Matrix = function (t, e, i, n, o, r) {
          void 0 !== t && null !== t || (t = 1), void 0 !== e && null !== e || (e = 0), void 0 !== i && null !== i || (i = 0), void 0 !== n && null !== n || (n = 1), void 0 !== o && null !== o || (o = 0), void 0 !== r && null !== r || (r = 0), this.a = t, this.b = e, this.c = i, this.d = n, this.tx = o, this.ty = r, this.type = s.MATRIX;
        }, s.Matrix.prototype = {
          fromArray: function fromArray(t) {
            return this.setTo(t[0], t[1], t[3], t[4], t[2], t[5]);
          },
          setTo: function setTo(t, e, i, s, n, o) {
            return this.a = t, this.b = e, this.c = i, this.d = s, this.tx = n, this.ty = o, this;
          },
          clone: function clone(t) {
            return void 0 === t || null === t ? t = new s.Matrix(this.a, this.b, this.c, this.d, this.tx, this.ty) : (t.a = this.a, t.b = this.b, t.c = this.c, t.d = this.d, t.tx = this.tx, t.ty = this.ty), t;
          },
          copyTo: function copyTo(t) {
            return t.copyFrom(this), t;
          },
          copyFrom: function copyFrom(t) {
            return this.a = t.a, this.b = t.b, this.c = t.c, this.d = t.d, this.tx = t.tx, this.ty = t.ty, this;
          },
          toArray: function toArray(t, e) {
            return void 0 === e && (e = new Float32Array(9)), t ? (e[0] = this.a, e[1] = this.b, e[2] = 0, e[3] = this.c, e[4] = this.d, e[5] = 0, e[6] = this.tx, e[7] = this.ty, e[8] = 1) : (e[0] = this.a, e[1] = this.c, e[2] = this.tx, e[3] = this.b, e[4] = this.d, e[5] = this.ty, e[6] = 0, e[7] = 0, e[8] = 1), e;
          },
          apply: function apply(t, e) {
            return void 0 === e && (e = new s.Point()), e.x = this.a * t.x + this.c * t.y + this.tx, e.y = this.b * t.x + this.d * t.y + this.ty, e;
          },
          applyInverse: function applyInverse(t, e) {
            void 0 === e && (e = new s.Point());
            var i = 1 / (this.a * this.d + this.c * -this.b),
                n = t.x,
                o = t.y;
            return e.x = this.d * i * n + -this.c * i * o + (this.ty * this.c - this.tx * this.d) * i, e.y = this.a * i * o + -this.b * i * n + (-this.ty * this.a + this.tx * this.b) * i, e;
          },
          translate: function translate(t, e) {
            return this.tx += t, this.ty += e, this;
          },
          scale: function scale(t, e) {
            return this.a *= t, this.d *= e, this.c *= t, this.b *= e, this.tx *= t, this.ty *= e, this;
          },
          rotate: function rotate(t) {
            var e = Math.cos(t),
                i = Math.sin(t),
                s = this.a,
                n = this.c,
                o = this.tx;
            return this.a = s * e - this.b * i, this.b = s * i + this.b * e, this.c = n * e - this.d * i, this.d = n * i + this.d * e, this.tx = o * e - this.ty * i, this.ty = o * i + this.ty * e, this;
          },
          append: function append(t) {
            var e = this.a,
                i = this.b,
                s = this.c,
                n = this.d;
            return this.a = t.a * e + t.b * s, this.b = t.a * i + t.b * n, this.c = t.c * e + t.d * s, this.d = t.c * i + t.d * n, this.tx = t.tx * e + t.ty * s + this.tx, this.ty = t.tx * i + t.ty * n + this.ty, this;
          },
          identity: function identity() {
            return this.setTo(1, 0, 0, 1, 0, 0);
          }
        }, s.identityMatrix = new s.Matrix(),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Point = function (t, e) {
          t = t || 0, e = e || 0, this.x = t, this.y = e, this.type = s.POINT;
        }, s.Point.prototype = {
          copyFrom: function copyFrom(t) {
            return this.setTo(t.x, t.y);
          },
          invert: function invert() {
            return this.setTo(this.y, this.x);
          },
          setTo: function setTo(t, e) {
            return s.Point.set(this, t, e);
          },
          set: function set(t, e) {
            return s.Point.set(this, t, e);
          },
          setToPolar: function setToPolar(t, e, i) {
            return null == e && (e = 1), i && (t = s.Math.degToRad(t)), this.setTo(Math.cos(t) * e, Math.sin(t) * e);
          },
          add: function add(t, e) {
            return this.x += t, this.y += e, this;
          },
          subtract: function subtract(t, e) {
            return this.x -= t, this.y -= e, this;
          },
          multiply: function multiply(t, e) {
            return this.x *= t, this.y *= e, this;
          },
          divide: function divide(t, e) {
            return this.x /= t, this.y /= e, this;
          },
          clampX: function clampX(t, e) {
            return this.x = s.Math.clamp(this.x, t, e), this;
          },
          clampY: function clampY(t, e) {
            return this.y = s.Math.clamp(this.y, t, e), this;
          },
          clamp: function clamp(t, e) {
            return this.x = s.Math.clamp(this.x, t, e), this.y = s.Math.clamp(this.y, t, e), this;
          },
          clip: function clip(t) {
            var e = t.left,
                i = t.top,
                s = t.right,
                n = t.bottom;
            return this.x < e ? this.x = e : this.x > s && (this.x = s), this.y < i ? this.y = i : this.y > n && (this.y = n), this;
          },
          clone: function clone(t) {
            return void 0 === t || null === t ? t = new s.Point(this.x, this.y) : t.setTo(this.x, this.y), t;
          },
          copyTo: function copyTo(t) {
            return t.x = this.x, t.y = this.y, t;
          },
          distance: function distance(t, e) {
            return s.Point.distance(this, t, e);
          },
          equals: function equals(t) {
            return t.x === this.x && t.y === this.y;
          },
          equalsXY: function equalsXY(t, e) {
            return this.x === t && this.y === e;
          },
          fuzzyEquals: function fuzzyEquals(t, e) {
            return s.Point.fuzzyEquals(this, t, e);
          },
          fuzzyEqualsXY: function fuzzyEqualsXY(t, e, i) {
            return s.Point.fuzzyEqualsXY(this, t, e, i);
          },
          angle: function angle(t, e) {
            return this.angleXY(t.x, t.y, e);
          },
          angleXY: function angleXY(t, e, i) {
            var n = Math.atan2(e - this.y, t - this.x);
            return i ? s.Math.radToDeg(n) : n;
          },
          atan: function atan(t) {
            var e = Math.atan2(this.y, this.x);
            return t ? s.Math.radToDeg(e) : e;
          },
          rotate: function rotate(t, e, i, n, o) {
            return s.Point.rotate(this, t, e, i, n, o);
          },
          getMagnitude: function getMagnitude() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
          },
          getMagnitudeSq: function getMagnitudeSq() {
            return this.x * this.x + this.y * this.y;
          },
          setMagnitude: function setMagnitude(t) {
            return this.normalize().multiply(t, t);
          },
          normalize: function normalize() {
            if (!this.isZero()) {
              var t = this.getMagnitude();
              this.x /= t, this.y /= t;
            }

            return this;
          },
          limit: function limit(t) {
            return this.getMagnitudeSq() > t * t && this.setMagnitude(t), this;
          },
          expand: function expand(t) {
            return this.getMagnitudeSq() < t * t && this.setMagnitude(t), this;
          },
          isZero: function isZero() {
            return 0 === this.x && 0 === this.y;
          },
          dot: function dot(t) {
            return this.x * t.x + this.y * t.y;
          },
          cross: function cross(t) {
            return this.x * t.y - this.y * t.x;
          },
          perp: function perp() {
            return this.setTo(-this.y, this.x);
          },
          rperp: function rperp() {
            return this.setTo(this.y, -this.x);
          },
          normalRightHand: function normalRightHand() {
            return this.setTo(-1 * this.y, this.x);
          },
          floor: function floor() {
            return this.setTo(Math.floor(this.x), Math.floor(this.y));
          },
          ceil: function ceil() {
            return this.setTo(Math.ceil(this.x), Math.ceil(this.y));
          },
          round: function round() {
            return this.setTo(Math.round(this.x), Math.round(this.y));
          },
          toString: function toString() {
            return "[{Point (x=" + this.x + " y=" + this.y + ")}]";
          }
        }, s.Point.prototype.constructor = s.Point, s.Point.add = function (t, e, i) {
          return void 0 === i && (i = new s.Point()), i.x = t.x + e.x, i.y = t.y + e.y, i;
        }, s.Point.subtract = function (t, e, i) {
          return void 0 === i && (i = new s.Point()), i.x = t.x - e.x, i.y = t.y - e.y, i;
        }, s.Point.multiply = function (t, e, i) {
          return void 0 === i && (i = new s.Point()), i.x = t.x * e.x, i.y = t.y * e.y, i;
        }, s.Point.divide = function (t, e, i) {
          return void 0 === i && (i = new s.Point()), i.x = t.x / e.x, i.y = t.y / e.y, i;
        }, s.Point.equals = function (t, e) {
          return t.x === e.x && t.y === e.y;
        }, s.Point.equalsXY = function (t, e, i) {
          return t.x === e && t.y === i;
        }, s.Point.fuzzyEquals = function (t, e, i) {
          return s.Math.fuzzyEquals(t.x, e.x, i) && s.Math.fuzzyEquals(t.y, e.y, i);
        }, s.Point.fuzzyEqualsXY = function (t, e, i, n) {
          return s.Math.fuzzyEquals(t.x, e, n) && s.Math.fuzzyEquals(t.y, i, n);
        }, s.Point.angle = function (t, e) {
          return Math.atan2(t.y - e.y, t.x - e.x);
        }, s.Point.negative = function (t, e) {
          return void 0 === e && (e = new s.Point()), e.setTo(-t.x, -t.y);
        }, s.Point.multiplyAdd = function (t, e, i, n) {
          return void 0 === n && (n = new s.Point()), n.setTo(t.x + e.x * i, t.y + e.y * i);
        }, s.Point.interpolate = function (t, e, i, n) {
          return void 0 === n && (n = new s.Point()), n.setTo(t.x + (e.x - t.x) * i, t.y + (e.y - t.y) * i);
        }, s.Point.perp = function (t, e) {
          return void 0 === e && (e = new s.Point()), e.setTo(-t.y, t.x);
        }, s.Point.rperp = function (t, e) {
          return void 0 === e && (e = new s.Point()), e.setTo(t.y, -t.x);
        }, s.Point.distance = function (t, e, i) {
          var n = s.Math.distance(t.x, t.y, e.x, e.y);
          return i ? Math.round(n) : n;
        }, s.Point.project = function (t, e, i) {
          void 0 === i && (i = new s.Point());
          var n = t.dot(e) / e.getMagnitudeSq();
          return 0 !== n && i.setTo(n * e.x, n * e.y), i;
        }, s.Point.projectUnit = function (t, e, i) {
          void 0 === i && (i = new s.Point());
          var n = t.dot(e);
          return 0 !== n && i.setTo(n * e.x, n * e.y), i;
        }, s.Point.normalRightHand = function (t, e) {
          return void 0 === e && (e = new s.Point()), e.setTo(-1 * t.y, t.x);
        }, s.Point.normalize = function (t, e) {
          void 0 === e && (e = new s.Point());
          var i = t.getMagnitude();
          return 0 !== i && e.setTo(t.x / i, t.y / i), e;
        }, s.Point.rotate = function (t, e, i, n, o, r) {
          if (o && (n = s.Math.degToRad(n)), void 0 === r) {
            t.subtract(e, i);
            var a = Math.sin(n),
                h = Math.cos(n),
                l = h * t.x - a * t.y,
                c = a * t.x + h * t.y;
            t.x = l + e, t.y = c + i;
          } else {
            var u = n + Math.atan2(t.y - i, t.x - e);
            t.x = e + r * Math.cos(u), t.y = i + r * Math.sin(u);
          }

          return t;
        }, s.Point.centroid = function (t, e) {
          if (void 0 === e && (e = new s.Point()), "[object Array]" !== Object.prototype.toString.call(t)) throw new Error("Phaser.Point. Parameter 'points' must be an array");
          var i = t.length;
          if (i < 1) throw new Error("Phaser.Point. Parameter 'points' array must not be empty");
          if (1 === i) return e.copyFrom(t[0]), e;

          for (var n = 0; n < i; n++) {
            s.Point.add(e, t[n], e);
          }

          return e.divide(i, i), e;
        }, s.Point.parse = function (t, e, i) {
          e = e || "x", i = i || "y";
          var n = new s.Point();
          return t[e] && (n.x = parseInt(t[e], 10)), t[i] && (n.y = parseInt(t[i], 10)), n;
        }, s.Point.isPoint = function (t) {
          return null != t && "number" == typeof t.x && "number" == typeof t.y;
        }, s.Point.set = function (t, e, i) {
          return t.x = e || 0, t.y = i || (0 !== i ? t.x : 0), t;
        }, s.Point.sortClockwise = function (t, e) {
          e || (e = this.centroid(t));
          var i = e.x,
              s = e.y;
          return t.sort(function (t, e) {
            if (t.x - i >= 0 && e.x - i < 0) return -1;
            if (t.x - i < 0 && e.x - i >= 0) return 1;
            if (t.x - i == 0 && e.x - i == 0) return t.y - s >= 0 || e.y - s >= 0 ? t.y > e.y ? 1 : -1 : e.y > t.y ? 1 : -1;
            var n = (t.x - i) * -(e.y - s) - (e.x - i) * -(t.y - s);
            return n < 0 ? -1 : n > 0 ? 1 : (t.x - i) * (t.x - i) + (t.y - s) * (t.y - s) > (e.x - i) * (e.x - i) + (e.y - s) * (e.y - s) ? -1 : 1;
          });
        }, PIXI.Point = s.Point,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @author       Adrien Brault <adrien.brault@gmail.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Polygon = function () {
          this.area = 0, this._points = [], arguments.length > 0 && this.setTo.apply(this, arguments), this.closed = !0, this.flattened = !1, this.type = s.POLYGON;
        }, s.Polygon.prototype = {
          toNumberArray: function toNumberArray(t) {
            void 0 === t && (t = []);

            for (var e = 0; e < this._points.length; e++) {
              "number" == typeof this._points[e] ? (t.push(this._points[e]), t.push(this._points[e + 1]), e++) : (t.push(this._points[e].x), t.push(this._points[e].y));
            }

            return t;
          },
          flatten: function flatten() {
            return this._points = this.toNumberArray(), this.flattened = !0, this;
          },
          clone: function clone(t) {
            var e = this._points.slice();

            return void 0 === t || null === t ? t = new s.Polygon(e) : t.setTo(e), t;
          },
          contains: function contains(t, e) {
            var i = !1;
            if (this.flattened) for (var s = -2, n = this._points.length - 2; (s += 2) < this._points.length; n = s) {
              var o = this._points[s],
                  r = this._points[s + 1],
                  a = this._points[n],
                  h = this._points[n + 1];
              (r <= e && e < h || h <= e && e < r) && t < (a - o) * (e - r) / (h - r) + o && (i = !i);
            } else for (s = -1, n = this._points.length - 1; ++s < this._points.length; n = s) {
              o = this._points[s].x, r = this._points[s].y, a = this._points[n].x, h = this._points[n].y;
              (r <= e && e < h || h <= e && e < r) && t < (a - o) * (e - r) / (h - r) + o && (i = !i);
            }
            return i;
          },
          setTo: function setTo(t) {
            if (this.area = 0, this._points = [], arguments.length > 0) {
              Array.isArray(t) || (t = Array.prototype.slice.call(arguments));

              for (var e = Number.MAX_VALUE, i = 0, s = t.length; i < s; i++) {
                if ("number" == typeof t[i]) {
                  var n = new PIXI.Point(t[i], t[i + 1]);
                  i++;
                } else if (Array.isArray(t[i])) n = new PIXI.Point(t[i][0], t[i][1]);else n = new PIXI.Point(t[i].x, t[i].y);

                this._points.push(n), n.y < e && (e = n.y);
              }

              this.calculateArea(e);
            }

            return this;
          },
          calculateArea: function calculateArea(t) {
            for (var e, i, s, n, o = 0, r = this._points.length; o < r; o++) {
              e = this._points[o], i = o === r - 1 ? this._points[0] : this._points[o + 1], s = (e.y - t + (i.y - t)) / 2, n = e.x - i.x, this.area += s * n;
            }

            return this.area;
          }
        }, s.Polygon.prototype.constructor = s.Polygon, Object.defineProperty(s.Polygon.prototype, "points", {
          get: function get() {
            return this._points;
          }
        }), PIXI.Polygon = s.Polygon,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Rectangle = function (t, e, i, n) {
          t = t || 0, e = e || 0, i = i || 0, n = n || 0, this.x = t, this.y = e, this.width = i, this.height = n, this.type = s.RECTANGLE;
        }, s.Rectangle.prototype = {
          offset: function offset(t, e) {
            return this.x += t, this.y += e, this;
          },
          offsetPoint: function offsetPoint(t) {
            return this.offset(t.x, t.y);
          },
          setTo: function setTo(t, e, i, s) {
            return this.x = t, this.y = e, this.width = i, this.height = s, this;
          },
          scale: function scale(t, e) {
            return void 0 === e && (e = t), this.width *= t, this.height *= e, this;
          },
          centerOn: function centerOn(t, e) {
            return this.centerX = t, this.centerY = e, this;
          },
          floor: function floor() {
            this.x = Math.floor(this.x), this.y = Math.floor(this.y);
          },
          floorAll: function floorAll() {
            this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.width = Math.floor(this.width), this.height = Math.floor(this.height);
          },
          ceil: function ceil() {
            this.x = Math.ceil(this.x), this.y = Math.ceil(this.y);
          },
          ceilAll: function ceilAll() {
            this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.width = Math.ceil(this.width), this.height = Math.ceil(this.height);
          },
          copyFrom: function copyFrom(t) {
            return this.setTo(t.x, t.y, t.width, t.height);
          },
          copyFromBounds: function copyFromBounds(t) {
            return this.setTo(t.left, t.top, t.width, t.height);
          },
          copyTo: function copyTo(t) {
            return t.x = this.x, t.y = this.y, t.width = this.width, t.height = this.height, t;
          },
          inflate: function inflate(t, e) {
            return s.Rectangle.inflate(this, t, e);
          },
          size: function size(t) {
            return s.Rectangle.size(this, t);
          },
          resize: function resize(t, e) {
            return this.width = t, this.height = e, this;
          },
          clone: function clone(t) {
            return s.Rectangle.clone(this, t);
          },
          contains: function contains(t, e) {
            return s.Rectangle.contains(this, t, e);
          },
          containsRect: function containsRect(t) {
            return s.Rectangle.containsRect(t, this);
          },
          equals: function equals(t) {
            return s.Rectangle.equals(this, t);
          },
          intersection: function intersection(t, e) {
            return s.Rectangle.intersection(this, t, e);
          },
          intersects: function intersects(t) {
            return s.Rectangle.intersects(this, t);
          },
          intersectsRaw: function intersectsRaw(t, e, i, n, o) {
            return s.Rectangle.intersectsRaw(this, t, e, i, n, o);
          },
          union: function union(t, e) {
            return s.Rectangle.union(this, t, e);
          },
          random: function random(t) {
            return void 0 === t && (t = new s.Point()), t.x = this.randomX, t.y = this.randomY, t;
          },
          getPoint: function getPoint(t, e) {
            switch (void 0 === e && (e = new s.Point()), t) {
              default:
              case s.TOP_LEFT:
                return e.set(this.x, this.y);

              case s.TOP_CENTER:
                return e.set(this.centerX, this.y);

              case s.TOP_RIGHT:
                return e.set(this.right, this.y);

              case s.LEFT_CENTER:
                return e.set(this.x, this.centerY);

              case s.CENTER:
                return e.set(this.centerX, this.centerY);

              case s.RIGHT_CENTER:
                return e.set(this.right, this.centerY);

              case s.BOTTOM_LEFT:
                return e.set(this.x, this.bottom);

              case s.BOTTOM_CENTER:
                return e.set(this.centerX, this.bottom);

              case s.BOTTOM_RIGHT:
                return e.set(this.right, this.bottom);
            }
          },
          sides: function sides(t, e, i, n) {
            arguments.length || (t = new s.Line(), e = new s.Line(), i = new s.Line(), n = new s.Line());
            var o = this.x,
                r = this.y,
                a = this.right,
                h = this.bottom;
            return t.setTo(o, r, a, r), e.setTo(a, r, a, h), i.setTo(o, h, a, h), n.setTo(o, r, o, h), arguments.length ? null : [t, e, i, n];
          },
          toString: function toString() {
            return "[{Rectangle (x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + " empty=" + this.empty + ")}]";
          }
        }, Object.defineProperty(s.Rectangle.prototype, "halfWidth", {
          get: function get() {
            return Math.round(this.width / 2);
          }
        }), Object.defineProperty(s.Rectangle.prototype, "halfHeight", {
          get: function get() {
            return Math.round(this.height / 2);
          }
        }), Object.defineProperty(s.Rectangle.prototype, "bottom", {
          get: function get() {
            return this.y + this.height;
          },
          set: function set(t) {
            t <= this.y ? this.height = 0 : this.height = t - this.y;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "bottomLeft", {
          get: function get() {
            return new s.Point(this.x, this.bottom);
          },
          set: function set(t) {
            this.x = t.x, this.bottom = t.y;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "bottomRight", {
          get: function get() {
            return new s.Point(this.right, this.bottom);
          },
          set: function set(t) {
            this.right = t.x, this.bottom = t.y;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "left", {
          get: function get() {
            return this.x;
          },
          set: function set(t) {
            t >= this.right ? this.width = 0 : this.width = this.right - t, this.x = t;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "right", {
          get: function get() {
            return this.x + this.width;
          },
          set: function set(t) {
            t <= this.x ? this.width = 0 : this.width = t - this.x;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "volume", {
          get: function get() {
            return this.width * this.height;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "perimeter", {
          get: function get() {
            return 2 * this.width + 2 * this.height;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "centerX", {
          get: function get() {
            return this.x + this.halfWidth;
          },
          set: function set(t) {
            this.x = t - this.halfWidth;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "centerY", {
          get: function get() {
            return this.y + this.halfHeight;
          },
          set: function set(t) {
            this.y = t - this.halfHeight;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "randomX", {
          get: function get() {
            return this.x + Math.random() * this.width;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "randomY", {
          get: function get() {
            return this.y + Math.random() * this.height;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "top", {
          get: function get() {
            return this.y;
          },
          set: function set(t) {
            t >= this.bottom ? (this.height = 0, this.y = t) : this.height = this.bottom - t;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "topLeft", {
          get: function get() {
            return new s.Point(this.x, this.y);
          },
          set: function set(t) {
            this.x = t.x, this.y = t.y;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "topRight", {
          get: function get() {
            return new s.Point(this.x + this.width, this.y);
          },
          set: function set(t) {
            this.right = t.x, this.y = t.y;
          }
        }), Object.defineProperty(s.Rectangle.prototype, "empty", {
          get: function get() {
            return !this.width || !this.height;
          },
          set: function set(t) {
            !0 === t && this.setTo(0, 0, 0, 0);
          }
        }), s.Rectangle.prototype.constructor = s.Rectangle, s.Rectangle.inflate = function (t, e, i) {
          return t.x -= e, t.width += 2 * e, t.y -= i, t.height += 2 * i, t;
        }, s.Rectangle.inflatePoint = function (t, e) {
          return s.Rectangle.inflate(t, e.x, e.y);
        }, s.Rectangle.size = function (t, e) {
          return void 0 === e || null === e ? e = new s.Point(t.width, t.height) : e.setTo(t.width, t.height), e;
        }, s.Rectangle.clone = function (t, e) {
          return void 0 === e || null === e ? e = new s.Rectangle(t.x, t.y, t.width, t.height) : e.setTo(t.x, t.y, t.width, t.height), e;
        }, s.Rectangle.createFromBounds = function (t, e) {
          return void 0 !== e && null !== e || (e = new s.Rectangle(t.x, t.y, t.width, t.height)), e.copyFromBounds(t);
        }, s.Rectangle.contains = function (t, e, i) {
          return !(t.width <= 0 || t.height <= 0) && e >= t.x && e < t.right && i >= t.y && i < t.bottom;
        }, s.Rectangle.containsRaw = function (t, e, i, s, n, o) {
          return n >= t && n < t + i && o >= e && o < e + s;
        }, s.Rectangle.containsPoint = function (t, e) {
          return s.Rectangle.contains(t, e.x, e.y);
        }, s.Rectangle.containsRect = function (t, e) {
          return !(t.volume > e.volume) && t.x >= e.x && t.y >= e.y && t.right < e.right && t.bottom < e.bottom;
        }, s.Rectangle.equals = function (t, e) {
          return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
        }, s.Rectangle.sameDimensions = function (t, e) {
          return t.width === e.width && t.height === e.height;
        }, s.Rectangle.intersection = function (t, e, i) {
          return void 0 === i && (i = new s.Rectangle()), s.Rectangle.intersects(t, e) && (i.x = Math.max(t.x, e.x), i.y = Math.max(t.y, e.y), i.width = Math.min(t.right, e.right) - i.x, i.height = Math.min(t.bottom, e.bottom) - i.y), i;
        }, s.Rectangle.intersects = function (t, e) {
          return !(t.width <= 0 || t.height <= 0 || e.width <= 0 || e.height <= 0) && !(t.right < e.x || t.bottom < e.y || t.x > e.right || t.y > e.bottom);
        }, s.Rectangle.intersectsRaw = function (t, e, i, s, n, o) {
          return void 0 === o && (o = 0), !(e > t.right + o || i < t.left - o || s > t.bottom + o || n < t.top - o);
        }, s.Rectangle.union = function (t, e, i) {
          return void 0 === i && (i = new s.Rectangle()), i.setTo(Math.min(t.x, e.x), Math.min(t.y, e.y), Math.max(t.right, e.right) - Math.min(t.left, e.left), Math.max(t.bottom, e.bottom) - Math.min(t.top, e.top));
        }, s.Rectangle.aabb = function (t, e) {
          void 0 === e && (e = new s.Rectangle());
          var i = Number.NEGATIVE_INFINITY,
              n = Number.POSITIVE_INFINITY,
              o = Number.NEGATIVE_INFINITY,
              r = Number.POSITIVE_INFINITY;
          return t.forEach(function (t) {
            t.x > i && (i = t.x), t.x < n && (n = t.x), t.y > o && (o = t.y), t.y < r && (r = t.y);
          }), e.setTo(n, r, i - n, o - r), e;
        }, PIXI.Rectangle = s.Rectangle, PIXI.EmptyRectangle = new s.Rectangle(0, 0, 0, 0),
        /**
        * @author       Mat Groves http://matgroves.com/
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.RoundedRectangle = function (t, e, i, n, o) {
          void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === o && (o = 20), this.x = t, this.y = e, this.width = i, this.height = n, this.radius = o || 20, this.type = s.ROUNDEDRECTANGLE;
        }, s.RoundedRectangle.prototype = {
          clone: function clone() {
            return new s.RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
          },
          contains: function contains(t, e) {
            if (this.width <= 0 || this.height <= 0) return !1;
            var i = this.x;

            if (t >= i && t <= i + this.width) {
              var s = this.y;
              if (e >= s && e <= s + this.height) return !0;
            }

            return !1;
          }
        }, s.RoundedRectangle.prototype.constructor = s.RoundedRectangle, PIXI.RoundedRectangle = s.RoundedRectangle,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Camera = function (t, e, i, n, o, r) {
          this.game = t, this.world = t.world, this.id = 0, this.view = new s.Rectangle(i, n, o, r), this.bounds = new s.Rectangle(i, n, o, r), this.deadzone = null, this.visible = !0, this.roundPx = !0, this.atLimit = {
            x: !1,
            y: !1
          }, this.target = null, this.displayObject = null, this.scale = null, this.totalInView = 0, this.lerp = new s.Point(1, 1), this.onShakeComplete = new s.Signal(), this.onFlashComplete = new s.Signal(), this.onFadeComplete = new s.Signal(), this.fx = null, this._targetPosition = new s.Point(), this._edge = 0, this._position = new s.Point(), this._shake = {
            intensity: 0,
            duration: 0,
            horizontal: !1,
            vertical: !1,
            shakeBounds: !0,
            x: 0,
            y: 0
          }, this._fxDuration = 0, this._fxType = 0, this._fixedView = new s.Rectangle();
        }, s.Camera.FOLLOW_LOCKON = 0, s.Camera.FOLLOW_PLATFORMER = 1, s.Camera.FOLLOW_TOPDOWN = 2, s.Camera.FOLLOW_TOPDOWN_TIGHT = 3, s.Camera.SHAKE_BOTH = 4, s.Camera.SHAKE_HORIZONTAL = 5, s.Camera.SHAKE_VERTICAL = 6, s.Camera.ENABLE_FX = !0, s.Camera.prototype = {
          boot: function boot() {
            this.displayObject = this.game.world, this.scale = this.game.world.scale, this.game.camera = this, s.Graphics && s.Camera.ENABLE_FX && (this.fx = new s.Graphics(this.game), this.game.stage.addChild(this.fx));
          },
          preUpdate: function preUpdate() {
            this.totalInView = 0;
          },
          follow: function follow(t, e, i, n) {
            var o;

            switch (void 0 === e && (e = s.Camera.FOLLOW_LOCKON), void 0 === i && (i = 1), void 0 === n && (n = 1), this.target = t, this.lerp.set(i, n), e) {
              case s.Camera.FOLLOW_PLATFORMER:
                var r = this.width / 8,
                    a = this.height / 3;
                this.deadzone = new s.Rectangle((this.width - r) / 2, (this.height - a) / 2 - .25 * a, r, a);
                break;

              case s.Camera.FOLLOW_TOPDOWN:
                o = Math.max(this.width, this.height) / 4, this.deadzone = new s.Rectangle((this.width - o) / 2, (this.height - o) / 2, o, o);
                break;

              case s.Camera.FOLLOW_TOPDOWN_TIGHT:
                o = Math.max(this.width, this.height) / 8, this.deadzone = new s.Rectangle((this.width - o) / 2, (this.height - o) / 2, o, o);
                break;

              case s.Camera.FOLLOW_LOCKON:
              default:
                this.deadzone = null;
            }
          },
          unfollow: function unfollow() {
            this.target = null;
          },
          focusOn: function focusOn(t) {
            this.setPosition(Math.round(t.x - this.view.halfWidth), Math.round(t.y - this.view.halfHeight));
          },
          focusOnXY: function focusOnXY(t, e) {
            this.setPosition(Math.round(t - this.view.halfWidth), Math.round(e - this.view.halfHeight));
          },
          shake: function shake(t, e, i, n, o) {
            return void 0 === t && (t = .05), void 0 === e && (e = 500), void 0 === i && (i = !0), void 0 === n && (n = s.Camera.SHAKE_BOTH), void 0 === o && (o = !0), !(!i && this._shake.duration > 0) && (this._shake.intensity = t, this._shake.duration = e, this._shake.shakeBounds = o, this._shake.x = 0, this._shake.y = 0, this._shake.horizontal = n === s.Camera.SHAKE_BOTH || n === s.Camera.SHAKE_HORIZONTAL, this._shake.vertical = n === s.Camera.SHAKE_BOTH || n === s.Camera.SHAKE_VERTICAL, !0);
          },
          flash: function flash(t, e, i, s) {
            return void 0 === t && (t = 16777215), void 0 === e && (e = 500), void 0 === i && (i = !1), void 0 === s && (s = 1), !(!this.fx || !i && this._fxDuration > 0) && (this.fx.clear(), this.fx.beginFill(t, s), this.fx.drawRect(0, 0, this.width, this.height), this.fx.endFill(), this.fx.alpha = 1, this._fxDuration = e, this._fxType = 0, !0);
          },
          fade: function fade(t, e, i, s) {
            return void 0 === t && (t = 0), void 0 === e && (e = 500), void 0 === i && (i = !1), void 0 === s && (s = 1), !(!this.fx || !i && this._fxDuration > 0) && (this.fx.clear(), this.fx.beginFill(t, s), this.fx.drawRect(0, 0, this.width, this.height), this.fx.endFill(), this.fx.alpha = 0, this._fxDuration = e, this._fxType = 1, !0);
          },
          update: function update() {
            this._fxDuration > 0 && this.updateFX(), this._shake.duration > 0 && this.updateShake(), this.bounds && this.checkBounds(), this.roundPx && (this.view.floor(), this._shake.x = Math.floor(this._shake.x), this._shake.y = Math.floor(this._shake.y)), this.displayObject.position.x = -this.view.x, this.displayObject.position.y = -this.view.y;
          },
          updateFX: function updateFX() {
            0 === this._fxType ? (this.fx.alpha -= this.game.time.elapsedMS / this._fxDuration, this.fx.alpha <= 0 && (this._fxDuration = 0, this.fx.alpha = 0, this.onFlashComplete.dispatch())) : (this.fx.alpha += this.game.time.elapsedMS / this._fxDuration, this.fx.alpha >= 1 && (this._fxDuration = 0, this.fx.alpha = 1, this.onFadeComplete.dispatch()));
          },
          updateShake: function updateShake() {
            this._shake.duration -= this.game.time.elapsedMS, this._shake.duration <= 0 ? (this.onShakeComplete.dispatch(), this._shake.x = 0, this._shake.y = 0) : (this._shake.horizontal && (this._shake.x = this.game.rnd.frac() * this._shake.intensity * this.view.width * 2 - this._shake.intensity * this.view.width), this._shake.vertical && (this._shake.y = this.game.rnd.frac() * this._shake.intensity * this.view.height * 2 - this._shake.intensity * this.view.height));
          },
          updateTarget: function updateTarget() {
            this._targetPosition.x = this.view.x + this.target.worldPosition.x, this._targetPosition.y = this.view.y + this.target.worldPosition.y, this.deadzone ? (this._edge = this._targetPosition.x - this.view.x, this._edge < this.deadzone.left ? this.view.x = this.game.math.linear(this.view.x, this._targetPosition.x - this.deadzone.left, this.lerp.x) : this._edge > this.deadzone.right && (this.view.x = this.game.math.linear(this.view.x, this._targetPosition.x - this.deadzone.right, this.lerp.x)), this._edge = this._targetPosition.y - this.view.y, this._edge < this.deadzone.top ? this.view.y = this.game.math.linear(this.view.y, this._targetPosition.y - this.deadzone.top, this.lerp.y) : this._edge > this.deadzone.bottom && (this.view.y = this.game.math.linear(this.view.y, this._targetPosition.y - this.deadzone.bottom, this.lerp.y))) : (this.view.x = this.game.math.linear(this.view.x, this._targetPosition.x - this.view.halfWidth, this.lerp.x), this.view.y = this.game.math.linear(this.view.y, this._targetPosition.y - this.view.halfHeight, this.lerp.y)), this.bounds && this.checkBounds(), this.roundPx && this.view.floor(), this.displayObject.position.x = -this.view.x, this.displayObject.position.y = -this.view.y;
          },
          setBoundsToWorld: function setBoundsToWorld() {
            this.bounds && this.bounds.copyFrom(this.game.world.bounds);
          },
          checkBounds: function checkBounds() {
            this.atLimit.x = !1, this.atLimit.y = !1;
            var t = this.view.x + this._shake.x,
                e = this.view.right + this._shake.x,
                i = this.view.y + this._shake.y,
                s = this.view.bottom + this._shake.y;
            t <= this.bounds.x * this.scale.x ? (this.atLimit.x = !0, this.view.x = this.bounds.x * this.scale.x, this._shake.shakeBounds || (this._shake.x = 0)) : e >= this.bounds.right * this.scale.x && (this.atLimit.x = !0, this.view.x = this.bounds.right * this.scale.x - this.width, this._shake.shakeBounds || (this._shake.x = 0)), i <= this.bounds.top * this.scale.y ? (this.atLimit.y = !0, this.view.y = this.bounds.top * this.scale.y, this._shake.shakeBounds || (this._shake.y = 0)) : s >= this.bounds.bottom * this.scale.y && (this.atLimit.y = !0, this.view.y = this.bounds.bottom * this.scale.y - this.height, this._shake.shakeBounds || (this._shake.y = 0));
          },
          setPosition: function setPosition(t, e) {
            this.view.x = t, this.view.y = e, this.bounds && this.checkBounds();
          },
          setSize: function setSize(t, e) {
            this.view.width = t, this.view.height = e;
          },
          reset: function reset() {
            this.target = null, this.view.x = 0, this.view.y = 0, this._shake.duration = 0, this._shake.x = 0, this._shake.y = 0, this.resetFX();
          },
          resetFX: function resetFX() {
            this.fx && (this.fx.clear(), this.fx.alpha = 0), this._fxDuration = 0;
          }
        }, s.Camera.prototype.constructor = s.Camera, Object.defineProperty(s.Camera.prototype, "x", {
          get: function get() {
            return this.view.x;
          },
          set: function set(t) {
            this.view.x = t, this.bounds && this.checkBounds();
          }
        }), Object.defineProperty(s.Camera.prototype, "y", {
          get: function get() {
            return this.view.y;
          },
          set: function set(t) {
            this.view.y = t, this.bounds && this.checkBounds();
          }
        }), Object.defineProperty(s.Camera.prototype, "position", {
          get: function get() {
            return this._position.set(this.view.x, this.view.y), this._position;
          },
          set: function set(t) {
            void 0 !== t.x && (this.view.x = t.x), void 0 !== t.y && (this.view.y = t.y), this.bounds && this.checkBounds();
          }
        }), Object.defineProperty(s.Camera.prototype, "width", {
          get: function get() {
            return this.view.width;
          },
          set: function set(t) {
            this.view.width = t;
          }
        }), Object.defineProperty(s.Camera.prototype, "height", {
          get: function get() {
            return this.view.height;
          },
          set: function set(t) {
            this.view.height = t;
          }
        }), Object.defineProperty(s.Camera.prototype, "shakeIntensity", {
          get: function get() {
            return this._shake.intensity;
          },
          set: function set(t) {
            this._shake.intensity = t;
          }
        }), Object.defineProperty(s.Camera.prototype, "fixedView", {
          get: function get() {
            return this._fixedView.setTo(0, 0, this.view.width, this.view.height), this._fixedView;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.State = function () {
          this.game = null, this.key = "", this.add = null, this.make = null, this.camera = null, this.cache = null, this.input = null, this.load = null, this.math = null, this.sound = null, this.scale = null, this.stage = null, this.state = null, this.time = null, this.tweens = null, this.world = null, this.particles = null, this.physics = null, this.rnd = null;
        }, s.State.prototype = {
          init: function init() {},
          preload: function preload() {},
          loadUpdate: function loadUpdate() {},
          loadRender: function loadRender() {},
          create: function create() {},
          update: function update() {},
          preRender: function preRender() {},
          render: function render() {},
          resize: function resize() {},
          paused: function paused() {},
          resumed: function resumed() {},
          pauseUpdate: function pauseUpdate() {},
          shutdown: function shutdown() {}
        }, s.State.prototype.constructor = s.State,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.StateManager = function (t, e) {
          this.game = t, this.states = {}, this._pendingState = null, void 0 !== e && null !== e && (this._pendingState = e), this._clearWorld = !1, this._clearCache = !1, this._created = !1, this._args = [], this.current = "", this.onStateChange = new s.Signal(), this.onInitCallback = null, this.onPreloadCallback = null, this.onCreateCallback = null, this.onUpdateCallback = null, this.onRenderCallback = null, this.onResizeCallback = null, this.onPreRenderCallback = null, this.onLoadUpdateCallback = null, this.onLoadRenderCallback = null, this.onPausedCallback = null, this.onResumedCallback = null, this.onPauseUpdateCallback = null, this.onShutDownCallback = null;
        }, s.StateManager.prototype = {
          boot: function boot() {
            this.game.onPause.add(this.pause, this), this.game.onResume.add(this.resume, this), null !== this._pendingState && "string" != typeof this._pendingState && this.add("default", this._pendingState, !0);
          },
          add: function add(t, e, i) {
            var n;
            return void 0 === i && (i = !1), e instanceof s.State ? n = e : "object" == typeof e ? (n = e).game = this.game : "function" == typeof e && (n = new e(this.game)), this.states[t] = n, i && (this.game.isBooted ? this.start(t) : this._pendingState = t), n;
          },
          remove: function remove(t) {
            this.current === t && (this.callbackContext = null, this.onInitCallback = null, this.onShutDownCallback = null, this.onPreloadCallback = null, this.onLoadRenderCallback = null, this.onLoadUpdateCallback = null, this.onCreateCallback = null, this.onUpdateCallback = null, this.onPreRenderCallback = null, this.onRenderCallback = null, this.onResizeCallback = null, this.onPausedCallback = null, this.onResumedCallback = null, this.onPauseUpdateCallback = null), delete this.states[t];
          },
          start: function start(t, e, i) {
            void 0 === e && (e = !0), void 0 === i && (i = !1), this.checkState(t) && (this._pendingState = t, this._clearWorld = e, this._clearCache = i, arguments.length > 3 && (this._args = Array.prototype.splice.call(arguments, 3)));
          },
          restart: function restart(t, e) {
            void 0 === t && (t = !0), void 0 === e && (e = !1), this._pendingState = this.current, this._clearWorld = t, this._clearCache = e, arguments.length > 2 && (this._args = Array.prototype.slice.call(arguments, 2));
          },
          dummy: function dummy() {},
          preUpdate: function preUpdate() {
            if (this._pendingState && this.game.isBooted) {
              var t = this.current;
              if (this.clearCurrentState(), this.setCurrentState(this._pendingState), this.onStateChange.dispatch(this.current, t), this.current !== this._pendingState) return;
              this._pendingState = null, this.onPreloadCallback ? (this.game.load.reset(!0), this.onPreloadCallback.call(this.callbackContext, this.game), 0 === this.game.load.totalQueuedFiles() && 0 === this.game.load.totalQueuedPacks() ? this.loadComplete() : this.game.load.start()) : this.loadComplete();
            }
          },
          clearCurrentState: function clearCurrentState() {
            this.current && (this.onShutDownCallback && this.onShutDownCallback.call(this.callbackContext, this.game), this.game.tweens.removeAll(), this.game.camera.reset(), this.game.input.reset(!0), this.game.physics.clear(), this.game.time.removeAll(), this.game.scale.reset(this._clearWorld), this.game.debug && this.game.debug.reset(), this._clearWorld && (this.game.world.shutdown(), this._clearCache && this.game.cache.destroy()));
          },
          checkState: function checkState(t) {
            var e = this.states[t];
            return e ? !!(e.preload || e.create || e.update || e.render) || (console.warn("Invalid Phaser State object given. Must contain at least one of the required functions: preload, create, update or render"), !1) : (console.warn("Phaser.StateManager - No state found with the key: " + t), !1);
          },
          link: function link(t) {
            var e = this.states[t];
            e.game = this.game, e.add = this.game.add, e.make = this.game.make, e.camera = this.game.camera, e.cache = this.game.cache, e.input = this.game.input, e.load = this.game.load, e.math = this.game.math, e.sound = this.game.sound, e.scale = this.game.scale, e.state = this, e.stage = this.game.stage, e.time = this.game.time, e.tweens = this.game.tweens, e.world = this.game.world, e.particles = this.game.particles, e.rnd = this.game.rnd, e.physics = this.game.physics, e.key = t;
          },
          unlink: function unlink(t) {
            var e = this.states[t];
            e && (e.game = null, e.add = null, e.make = null, e.camera = null, e.cache = null, e.input = null, e.load = null, e.math = null, e.sound = null, e.scale = null, e.state = null, e.stage = null, e.time = null, e.tweens = null, e.world = null, e.particles = null, e.rnd = null, e.physics = null);
          },
          setCurrentState: function setCurrentState(t) {
            var e = this.states[t];
            this.callbackContext = e, this.link(t), this.onInitCallback = e.init || this.dummy, this.onPreloadCallback = e.preload || null, this.onLoadRenderCallback = e.loadRender || null, this.onLoadUpdateCallback = e.loadUpdate || null, this.onCreateCallback = e.create || null, this.onUpdateCallback = e.update || null, this.onPreRenderCallback = e.preRender || null, this.onRenderCallback = e.render || null, this.onResizeCallback = e.resize || null, this.onPausedCallback = e.paused || null, this.onResumedCallback = e.resumed || null, this.onPauseUpdateCallback = e.pauseUpdate || null, this.onShutDownCallback = e.shutdown || this.dummy, "" !== this.current && this.game.physics.reset(), this.current = t, this._created = !1, this.onInitCallback.apply(this.callbackContext, this._args), t === this._pendingState && (this._args = []), this.game._kickstart = !0;
          },
          getCurrentState: function getCurrentState() {
            return this.states[this.current];
          },
          loadComplete: function loadComplete() {
            !1 === this._created && this.onCreateCallback ? (this._created = !0, this.onCreateCallback.call(this.callbackContext, this.game)) : this._created = !0;
          },
          loadUpdate: function loadUpdate() {
            !1 === this._created && this.onLoadUpdateCallback && this.onLoadUpdateCallback.call(this.callbackContext, this.game);
          },
          pause: function pause() {
            this._created && this.onPausedCallback && this.onPausedCallback.call(this.callbackContext, this.game);
          },
          resume: function resume() {
            this._created && this.onResumedCallback && this.onResumedCallback.call(this.callbackContext, this.game);
          },
          update: function update() {
            this._created ? this.onUpdateCallback && this.onUpdateCallback.call(this.callbackContext, this.game) : this.onLoadUpdateCallback && this.onLoadUpdateCallback.call(this.callbackContext, this.game);
          },
          pauseUpdate: function pauseUpdate() {
            this._created ? this.onPauseUpdateCallback && this.onPauseUpdateCallback.call(this.callbackContext, this.game) : this.onLoadUpdateCallback && this.onLoadUpdateCallback.call(this.callbackContext, this.game);
          },
          preRender: function preRender(t) {
            this._created && this.onPreRenderCallback && this.onPreRenderCallback.call(this.callbackContext, this.game, t);
          },
          resize: function resize(t, e) {
            this.onResizeCallback && this.onResizeCallback.call(this.callbackContext, t, e);
          },
          render: function render() {
            this._created ? this.onRenderCallback && (this.game.renderType === s.CANVAS ? (this.game.context.save(), this.game.context.setTransform(1, 0, 0, 1, 0, 0), this.onRenderCallback.call(this.callbackContext, this.game), this.game.context.restore()) : this.onRenderCallback.call(this.callbackContext, this.game)) : this.onLoadRenderCallback && this.onLoadRenderCallback.call(this.callbackContext, this.game);
          },
          destroy: function destroy() {
            this._clearWorld = !0, this._clearCache = !0, this.clearCurrentState(), this.callbackContext = null, this.onInitCallback = null, this.onShutDownCallback = null, this.onPreloadCallback = null, this.onLoadRenderCallback = null, this.onLoadUpdateCallback = null, this.onCreateCallback = null, this.onUpdateCallback = null, this.onRenderCallback = null, this.onPausedCallback = null, this.onResumedCallback = null, this.onPauseUpdateCallback = null, this.game = null, this.states = {}, this._pendingState = null, this.current = "";
          }
        }, s.StateManager.prototype.constructor = s.StateManager, Object.defineProperty(s.StateManager.prototype, "created", {
          get: function get() {
            return this._created;
          }
        }),
        /**
        * @author       Miller Medeiros http://millermedeiros.github.com/js-signals/
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Signal = function () {}, s.Signal.prototype = {
          _bindings: null,
          _prevParams: null,
          memorize: !1,
          _shouldPropagate: !0,
          active: !0,
          _boundDispatch: !1,
          validateListener: function validateListener(t, e) {
            if ("function" != typeof t) throw new Error("Phaser.Signal: listener is a required param of {fn}() and should be a Function.".replace("{fn}", e));
          },
          _registerListener: function _registerListener(t, e, i, n, o) {
            var r,
                a = this._indexOfListener(t, i);

            if (-1 !== a) {
              if ((r = this._bindings[a]).isOnce() !== e) throw new Error("You cannot add" + (e ? "" : "Once") + "() then add" + (e ? "Once" : "") + "() the same listener without removing the relationship first.");
            } else r = new s.SignalBinding(this, t, e, i, n, o), this._addBinding(r);

            return this.memorize && this._prevParams && r.execute(this._prevParams), r;
          },
          _addBinding: function _addBinding(t) {
            this._bindings || (this._bindings = []);
            var e = this._bindings.length;

            do {
              e--;
            } while (this._bindings[e] && t._priority <= this._bindings[e]._priority);

            this._bindings.splice(e + 1, 0, t);
          },
          _indexOfListener: function _indexOfListener(t, e) {
            if (!this._bindings) return -1;
            void 0 === e && (e = null);

            for (var i, s = this._bindings.length; s--;) {
              if ((i = this._bindings[s])._listener === t && i.context === e) return s;
            }

            return -1;
          },
          has: function has(t, e) {
            return -1 !== this._indexOfListener(t, e);
          },
          add: function add(t, e, i) {
            this.validateListener(t, "add");
            var s = [];
            if (arguments.length > 3) for (var n = 3; n < arguments.length; n++) {
              s.push(arguments[n]);
            }
            return this._registerListener(t, !1, e, i, s);
          },
          addOnce: function addOnce(t, e, i) {
            this.validateListener(t, "addOnce");
            var s = [];
            if (arguments.length > 3) for (var n = 3; n < arguments.length; n++) {
              s.push(arguments[n]);
            }
            return this._registerListener(t, !0, e, i, s);
          },
          remove: function remove(t, e) {
            this.validateListener(t, "remove");

            var i = this._indexOfListener(t, e);

            return -1 !== i && (this._bindings[i]._destroy(), this._bindings.splice(i, 1)), t;
          },
          removeAll: function removeAll(t) {
            if (void 0 === t && (t = null), this._bindings) {
              for (var e = this._bindings.length; e--;) {
                t ? this._bindings[e].context === t && (this._bindings[e]._destroy(), this._bindings.splice(e, 1)) : this._bindings[e]._destroy();
              }

              t || (this._bindings.length = 0);
            }
          },
          getNumListeners: function getNumListeners() {
            return this._bindings ? this._bindings.length : 0;
          },
          halt: function halt() {
            this._shouldPropagate = !1;
          },
          dispatch: function dispatch() {
            if (this.active && (this._bindings || this.memorize)) {
              var t = Array.prototype.slice.call(arguments);
              this.memorize && (this._prevParams = t);
              var e = this._bindings ? this._bindings.length : 0;

              if (e) {
                var i = this._bindings.slice();

                this._shouldPropagate = !0;

                do {
                  e--;
                } while (i[e] && this._shouldPropagate && !1 !== i[e].execute(t));
              }
            }
          },
          forget: function forget() {
            this._prevParams && (this._prevParams = null);
          },
          dispose: function dispose() {
            this.removeAll(), this._bindings = null, this._prevParams && (this._prevParams = null);
          },
          toString: function toString() {
            return "[Phaser.Signal active:" + this.active + " numListeners:" + this.getNumListeners() + "]";
          }
        }, Object.defineProperty(s.Signal.prototype, "boundDispatch", {
          get: function get() {
            var t = this;
            return this._boundDispatch || (this._boundDispatch = function () {
              return t.dispatch.apply(t, arguments);
            });
          }
        }), s.Signal.prototype.constructor = s.Signal,
        /**
        * @author       Miller Medeiros http://millermedeiros.github.com/js-signals/
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.SignalBinding = function (t, e, i, s, n, o) {
          this._listener = e, i && (this._isOnce = !0), null != s && (this.context = s), this._signal = t, n && (this._priority = n), o && o.length && (this._args = o);
        }, s.SignalBinding.prototype = {
          context: null,
          _isOnce: !1,
          _priority: 0,
          _args: null,
          callCount: 0,
          active: !0,
          params: null,
          execute: function execute(t) {
            var e, i;
            return this.active && this._listener && (i = this.params ? this.params.concat(t) : t, this._args && (i = i.concat(this._args)), e = this._listener.apply(this.context, i), this.callCount++, this._isOnce && this.detach()), e;
          },
          detach: function detach() {
            return this.isBound() ? this._signal.remove(this._listener, this.context) : null;
          },
          isBound: function isBound() {
            return !!this._signal && !!this._listener;
          },
          isOnce: function isOnce() {
            return this._isOnce;
          },
          getListener: function getListener() {
            return this._listener;
          },
          getSignal: function getSignal() {
            return this._signal;
          },
          _destroy: function _destroy() {
            delete this._signal, delete this._listener, delete this.context;
          },
          toString: function toString() {
            return "[Phaser.SignalBinding isOnce:" + this._isOnce + ", isBound:" + this.isBound() + ", active:" + this.active + "]";
          }
        }, s.SignalBinding.prototype.constructor = s.SignalBinding,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @author       Mat Groves (@Doormat23)
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Filter = function (t, e, i) {
          this.game = t, this.type = s.WEBGL_FILTER, this.passes = [this], this.shaders = [], this.dirty = !0, this.padding = 0, this.prevPoint = new s.Point();
          var n = new Date();
          if (this.uniforms = {
            resolution: {
              type: "2f",
              value: {
                x: 256,
                y: 256
              }
            },
            time: {
              type: "1f",
              value: 0
            },
            mouse: {
              type: "2f",
              value: {
                x: 0,
                y: 0
              }
            },
            date: {
              type: "4fv",
              value: [n.getFullYear(), n.getMonth(), n.getDate(), 60 * n.getHours() * 60 + 60 * n.getMinutes() + n.getSeconds()]
            },
            sampleRate: {
              type: "1f",
              value: 44100
            },
            iChannel0: {
              type: "sampler2D",
              value: null,
              textureData: {
                repeat: !0
              }
            },
            iChannel1: {
              type: "sampler2D",
              value: null,
              textureData: {
                repeat: !0
              }
            },
            iChannel2: {
              type: "sampler2D",
              value: null,
              textureData: {
                repeat: !0
              }
            },
            iChannel3: {
              type: "sampler2D",
              value: null,
              textureData: {
                repeat: !0
              }
            }
          }, e) for (var o in e) {
            this.uniforms[o] = e[o];
          }
          "string" == typeof i && (i = i.split("\n")), this.fragmentSrc = i || [];
        }, s.Filter.prototype = {
          init: function init() {},
          setResolution: function setResolution(t, e) {
            this.uniforms.resolution.value.x = t, this.uniforms.resolution.value.y = e;
          },
          update: function update(t) {
            if (t) {
              var e = t.x / this.game.width,
                  i = 1 - t.y / this.game.height;
              e === this.prevPoint.x && i === this.prevPoint.y || (this.uniforms.mouse.value.x = e.toFixed(2), this.uniforms.mouse.value.y = i.toFixed(2), this.prevPoint.set(e, i));
            }

            this.uniforms.time.value = this.game.time.totalElapsedSeconds();
          },
          addToWorld: function addToWorld(t, e, i, n, o, r) {
            void 0 === o && (o = 0), void 0 === r && (r = 0), void 0 !== i && null !== i ? this.width = i : i = this.width, void 0 !== n && null !== n ? this.height = n : n = this.height;
            var a = this.game.add.image(t, e, s.Cache.DEFAULT);
            return a.width = i, a.height = n, a.anchor.set(o, r), a.filters = [this], a;
          },
          syncUniforms: function syncUniforms() {
            for (var t = 0; t < this.shaders.length; t++) {
              this.shaders[t].dirty = !0;
            }
          },
          destroy: function destroy() {
            this.passes.length = 0, this.shaders.length = 0, this.fragmentSrc.length = 0, this.game = null, this.uniforms = null, this.prevPoint = null;
          }
        }, s.Filter.prototype.constructor = s.Filter, Object.defineProperty(s.Filter.prototype, "width", {
          get: function get() {
            return this.uniforms.resolution.value.x;
          },
          set: function set(t) {
            this.uniforms.resolution.value.x = t;
          }
        }), Object.defineProperty(s.Filter.prototype, "height", {
          get: function get() {
            return this.uniforms.resolution.value.y;
          },
          set: function set(t) {
            this.uniforms.resolution.value.y = t;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Plugin = function (t, e) {
          void 0 === e && (e = null), this.game = t, this.parent = e, this.active = !1, this.visible = !1, this.hasPreUpdate = !1, this.hasUpdate = !1, this.hasPostUpdate = !1, this.hasRender = !1, this.hasPostRender = !1;
        }, s.Plugin.prototype = {
          preUpdate: function preUpdate() {},
          update: function update() {},
          render: function render() {},
          postRender: function postRender() {},
          destroy: function destroy() {
            this.game = null, this.parent = null, this.active = !1, this.visible = !1;
          }
        }, s.Plugin.prototype.constructor = s.Plugin,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.PluginManager = function (t) {
          this.game = t, this.plugins = [], this._len = 0, this._i = 0;
        }, s.PluginManager.prototype = {
          add: function add(t) {
            var e = Array.prototype.slice.call(arguments, 1),
                i = !1;
            return "function" == typeof t ? t = new t(this.game, this) : (t.game = this.game, t.parent = this), "function" == typeof t.preUpdate && (t.hasPreUpdate = !0, i = !0), "function" == typeof t.update && (t.hasUpdate = !0, i = !0), "function" == typeof t.postUpdate && (t.hasPostUpdate = !0, i = !0), "function" == typeof t.render && (t.hasRender = !0, i = !0), "function" == typeof t.postRender && (t.hasPostRender = !0, i = !0), i ? ((t.hasPreUpdate || t.hasUpdate || t.hasPostUpdate) && (t.active = !0), (t.hasRender || t.hasPostRender) && (t.visible = !0), this._len = this.plugins.push(t), "function" == typeof t.init && t.init.apply(t, e), t) : null;
          },
          remove: function remove(t, e) {
            for (void 0 === e && (e = !0), this._i = this._len; this._i--;) {
              if (this.plugins[this._i] === t) return e && t.destroy(), this.plugins.splice(this._i, 1), void this._len--;
            }
          },
          removeAll: function removeAll() {
            for (this._i = this._len; this._i--;) {
              this.plugins[this._i].destroy();
            }

            this.plugins.length = 0, this._len = 0;
          },
          preUpdate: function preUpdate() {
            for (this._i = this._len; this._i--;) {
              this.plugins[this._i].active && this.plugins[this._i].hasPreUpdate && this.plugins[this._i].preUpdate();
            }
          },
          update: function update() {
            for (this._i = this._len; this._i--;) {
              this.plugins[this._i].active && this.plugins[this._i].hasUpdate && this.plugins[this._i].update();
            }
          },
          postUpdate: function postUpdate() {
            for (this._i = this._len; this._i--;) {
              this.plugins[this._i].active && this.plugins[this._i].hasPostUpdate && this.plugins[this._i].postUpdate();
            }
          },
          render: function render() {
            for (this._i = this._len; this._i--;) {
              this.plugins[this._i].visible && this.plugins[this._i].hasRender && this.plugins[this._i].render();
            }
          },
          postRender: function postRender() {
            for (this._i = this._len; this._i--;) {
              this.plugins[this._i].visible && this.plugins[this._i].hasPostRender && this.plugins[this._i].postRender();
            }
          },
          destroy: function destroy() {
            this.removeAll(), this.game = null;
          }
        }, s.PluginManager.prototype.constructor = s.PluginManager,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Stage = function (t) {
          this.game = t, PIXI.DisplayObjectContainer.call(this), this.name = "_stage_root", this.disableVisibilityChange = !1, this.exists = !0, this.worldTransform = new s.Matrix(), this.stage = this, this.currentRenderOrderID = 0, this._hiddenVar = "hidden", this._onChange = null, this._bgColor = {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            color: 0,
            rgba: "#000000"
          }, this.game.transparent || (this._bgColor.a = 1), t.config && this.parseConfig(t.config);
        }, s.Stage.prototype = Object.create(PIXI.DisplayObjectContainer.prototype), s.Stage.prototype.constructor = s.Stage, s.Stage.prototype.parseConfig = function (t) {
          t.disableVisibilityChange && (this.disableVisibilityChange = t.disableVisibilityChange), t.backgroundColor && this.setBackgroundColor(t.backgroundColor);
        }, s.Stage.prototype.boot = function () {
          s.DOM.getOffset(this.game.canvas, this.offset), s.Canvas.setUserSelect(this.game.canvas, "none"), s.Canvas.setTouchAction(this.game.canvas, "none"), this.checkVisibility();
        }, s.Stage.prototype.preUpdate = function () {
          this.currentRenderOrderID = 0;

          for (var t = 0; t < this.children.length;) {
            var e = this.children[t];
            e.preUpdate(), this === e.parent && t++;
          }
        }, s.Stage.prototype.update = function () {
          for (var t = this.children.length; t--;) {
            this.children[t].update();
          }
        }, s.Stage.prototype.postUpdate = function () {
          this.game.camera.update(), this.game.camera.target && (this.game.camera.target.postUpdate(), this.updateTransform(), this.game.camera.updateTarget());

          for (var t = 0; t < this.children.length; t++) {
            this.children[t].postUpdate();
          }

          this.updateTransform();
        }, s.Stage.prototype.updateTransform = function () {
          this.worldAlpha = 1;

          for (var t = 0; t < this.children.length; t++) {
            this.children[t].updateTransform();
          }
        }, s.Stage.prototype.checkVisibility = function () {
          void 0 !== document.hidden ? this._hiddenVar = "visibilitychange" : void 0 !== document.webkitHidden ? this._hiddenVar = "webkitvisibilitychange" : void 0 !== document.mozHidden ? this._hiddenVar = "mozvisibilitychange" : void 0 !== document.msHidden ? this._hiddenVar = "msvisibilitychange" : this._hiddenVar = null;
          var t = this;
          this._onChange = function (e) {
            return t.visibilityChange(e);
          }, this._onChangePause = function () {
            return t._onChange({
              type: "pause"
            });
          }, this._onChangeResume = function () {
            return t._onChange({
              type: "resume"
            });
          }, this._onClick = function (e) {
            void 0 === document.hasFocus || document.hasFocus() || t.visibilityChange(e);
          }, this._hiddenVar && document.addEventListener(this._hiddenVar, this._onChange, !1), window.onblur = this._onChange, window.onfocus = this._onChange, window.onpagehide = this._onChange, window.onpageshow = this._onChange, window.addEventListener("click", this._onClick), this.game.device.cocoonJSApp && CocoonJS.App && (CocoonJS.App.onSuspended && CocoonJS.App.onSuspended.addEventListener(this._onChangePause), CocoonJS.App.onActivated && CocoonJS.App.onActivated.addEventListener(this._onChangeResume), CocoonJS.App.on && (CocoonJS.App.on("activated", this._onChangeResume), CocoonJS.App.on("suspended", this._onChangePause)));
        }, s.Stage.prototype.visibilityChange = function (t) {
          switch (t.type) {
            case "blur":
            case "pagehide":
              return void this.game.focusLoss(t);

            case "click":
            case "focus":
            case "pageshow":
              return void this.game.focusGain(t);
          }

          this.disableVisibilityChange || (document.hidden || document.mozHidden || document.msHidden || document.webkitHidden || "pause" === t.type ? this.game.gamePaused(t) : this.game.gameResumed(t));
        }, s.Stage.prototype.setBackgroundColor = function (t) {
          this.game.transparent || (s.Color.valueToColor(t, this._bgColor), s.Color.updateColor(this._bgColor), this._bgColor.r /= 255, this._bgColor.g /= 255, this._bgColor.b /= 255, this._bgColor.a = 1);
        }, s.Stage.prototype.destroy = function () {
          this._hiddenVar && document.removeEventListener(this._hiddenVar, this._onChange, !1), window.onpagehide = null, window.onpageshow = null, window.onblur = null, window.onfocus = null, window.removeEventListener("click", this._onClick);
        }, s.Stage.prototype.add = function (t, e, i) {
          return t.parent === this ? t : (t.body && t.parent && t.parent.hash && t.parent.removeFromHash(t), void 0 === i ? this.addChild(t) : this.addChildAt(t, i), t);
        }, Object.defineProperty(s.Stage.prototype, "backgroundColor", {
          get: function get() {
            return this._bgColor.color;
          },
          set: function set(t) {
            this.setBackgroundColor(t);
          }
        }), Object.defineProperty(s.Stage.prototype, "smoothed", {
          get: function get() {
            return PIXI.scaleModes.DEFAULT === PIXI.scaleModes.LINEAR;
          },
          set: function set(t) {
            PIXI.scaleModes.DEFAULT = t ? PIXI.scaleModes.LINEAR : PIXI.scaleModes.NEAREST;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Group = function (t, e, i, n, o, r) {
          void 0 === n && (n = !1), void 0 === o && (o = !1), void 0 === r && (r = s.Physics.ARCADE), this.game = t, void 0 === e && (e = t.world), this.name = i || "group", this.z = 0, PIXI.DisplayObjectContainer.call(this), n ? (this.game.stage.addChild(this), this.z = this.game.stage.children.length) : e && (e.addChild(this), this.z = e.children.length), this.type = s.GROUP, this.physicsType = s.GROUP, this.alive = !0, this.exists = !0, this.ignoreDestroy = !1, this.pendingDestroy = !1, this.classType = s.Sprite, this.cursor = null, this.inputEnableChildren = !1, this.updateOnlyExistingChildren = !1, this.onChildInputDown = new s.Signal(), this.onChildInputUp = new s.Signal(), this.onChildInputOver = new s.Signal(), this.onChildInputOut = new s.Signal(), this.enableBody = o, this.enableBodyDebug = !1, this.physicsBodyType = r, this.physicsSortDirection = null, this.onDestroy = new s.Signal(), this.cursorIndex = 0, this.fixedToCamera = !1, this.cameraOffset = new s.Point(), this.hash = [], this._sortProperty = "z";
        }, s.Group.prototype = Object.create(PIXI.DisplayObjectContainer.prototype), s.Group.prototype.constructor = s.Group, s.Group.RETURN_NONE = 0, s.Group.RETURN_TOTAL = 1, s.Group.RETURN_CHILD = 2, s.Group.RETURN_ALL = 3, s.Group.SORT_ASCENDING = -1, s.Group.SORT_DESCENDING = 1, s.Group.prototype.add = function (t, e, i) {
          return void 0 === e && (e = !1), t.parent === this ? t : (t.body && t.parent && t.parent.hash && t.parent.removeFromHash(t), void 0 === i ? (t.z = this.children.length, this.addChild(t)) : (this.addChildAt(t, i), this.updateZ()), this.enableBody && t.hasOwnProperty("body") && null === t.body ? this.game.physics.enable(t, this.physicsBodyType) : t.body && this.addToHash(t), !this.inputEnableChildren || t.input && !t.inputEnabled || (t.inputEnabled = !0), !e && t.events && t.events.onAddedToGroup$dispatch(t, this), null === this.cursor && (this.cursor = t), t);
        }, s.Group.prototype.addAt = function (t, e, i) {
          return this.add(t, i, e);
        }, s.Group.prototype.addToHash = function (t) {
          if (t.parent === this && -1 === this.hash.indexOf(t)) return this.hash.push(t), !0;
          return !1;
        }, s.Group.prototype.removeFromHash = function (t) {
          if (t) {
            var e = this.hash.indexOf(t);
            if (-1 !== e) return this.hash.splice(e, 1), !0;
          }

          return !1;
        }, s.Group.prototype.addMultiple = function (t, e) {
          if (t instanceof s.Group) t.moveAll(this, e);else if (Array.isArray(t)) for (var i = 0; i < t.length; i++) {
            this.add(t[i], e);
          }
          return t;
        }, s.Group.prototype.getAt = function (t) {
          return t < 0 || t >= this.children.length ? -1 : this.getChildAt(t);
        }, s.Group.prototype.create = function (t, e, i, s, n, o) {
          void 0 === n && (n = !0);
          var r = new this.classType(this.game, t, e, i, s);
          return r.exists = n, r.visible = n, r.alive = n, this.add(r, !1, o);
        }, s.Group.prototype.createMultiple = function (t, e, i, s, n, o) {
          void 0 === i && (i = 0), void 0 === s && (s = !1), Array.isArray(e) || (e = [e]), Array.isArray(i) || (i = [i]);
          var r = this,
              a = [];
          return e.forEach(function (e) {
            i.forEach(function (i) {
              for (var h = 0; h < t; h++) {
                var l = r.create(0, 0, e, i, s);
                n && n.call(o || l, l, h), a.push(l);
              }
            });
          }), a;
        }, s.Group.prototype.updateZ = function () {
          for (var t = this.children.length; t--;) {
            this.children[t].z = t;
          }
        }, s.Group.prototype.align = function (t, e, i, n, o, r) {
          if (void 0 === o && (o = s.TOP_LEFT), void 0 === r && (r = 0), 0 === this.children.length || r > this.children.length || -1 === t && -1 === e) return !1;

          for (var a = new s.Rectangle(0, 0, i, n), h = t * i, l = e * n, c = r; c < this.children.length; c++) {
            var u = this.children[c];
            if (u.alignIn) if (u.alignIn(a, o), -1 === t) a.y += n, a.y === l && (a.x += i, a.y = 0);else if (-1 === e) a.x += i, a.x === h && (a.x = 0, a.y += n);else if (a.x += i, a.x === h && (a.x = 0, a.y += n, a.y === l)) return !0;
          }

          return !0;
        }, s.Group.prototype.resetCursor = function (t) {
          if (void 0 === t && (t = 0), t > this.children.length - 1 && (t = 0), this.cursor) return this.cursorIndex = t, this.cursor = this.children[this.cursorIndex], this.cursor;
        }, s.Group.prototype.next = function () {
          if (this.cursor) return this.cursorIndex >= this.children.length - 1 ? this.cursorIndex = 0 : this.cursorIndex++, this.cursor = this.children[this.cursorIndex], this.cursor;
        }, s.Group.prototype.previous = function () {
          if (this.cursor) return 0 === this.cursorIndex ? this.cursorIndex = this.children.length - 1 : this.cursorIndex--, this.cursor = this.children[this.cursorIndex], this.cursor;
        }, s.Group.prototype.swap = function (t, e) {
          this.swapChildren(t, e), this.updateZ();
        }, s.Group.prototype.bringToTop = function (t) {
          return t.parent === this && this.getIndex(t) < this.children.length && (this.remove(t, !1, !0), this.add(t, !0)), t;
        }, s.Group.prototype.sendToBack = function (t) {
          return t.parent === this && this.getIndex(t) > 0 && (this.remove(t, !1, !0), this.addAt(t, 0, !0)), t;
        }, s.Group.prototype.moveUp = function (t) {
          if (t.parent === this && this.getIndex(t) < this.children.length - 1) {
            var e = this.getIndex(t),
                i = this.getAt(e + 1);
            i && this.swap(t, i);
          }

          return t;
        }, s.Group.prototype.moveDown = function (t) {
          if (t.parent === this && this.getIndex(t) > 0) {
            var e = this.getIndex(t),
                i = this.getAt(e - 1);
            i && this.swap(t, i);
          }

          return t;
        }, s.Group.prototype.xy = function (t, e, i) {
          if (t < 0 || t > this.children.length) return -1;
          this.getChildAt(t).x = e, this.getChildAt(t).y = i;
        }, s.Group.prototype.reverse = function () {
          this.children.reverse(), this.updateZ();
        }, s.Group.prototype.getIndex = function (t) {
          return this.children.indexOf(t);
        }, s.Group.prototype.getByName = function (t) {
          for (var e = 0; e < this.children.length; e++) {
            if (this.children[e].name === t) return this.children[e];
          }

          return null;
        }, s.Group.prototype.replace = function (t, e) {
          var i = this.getIndex(t);
          if (-1 !== i) return e.parent && (e.parent instanceof s.Group ? e.parent.remove(e) : e.parent.removeChild(e)), this.remove(t), this.addAt(e, i), t;
        }, s.Group.prototype.hasProperty = function (t, e) {
          var i = e.length;
          return 1 === i && e[0] in t || 2 === i && e[0] in t && e[1] in t[e[0]] || 3 === i && e[0] in t && e[1] in t[e[0]] && e[2] in t[e[0]][e[1]] || 4 === i && e[0] in t && e[1] in t[e[0]] && e[2] in t[e[0]][e[1]] && e[3] in t[e[0]][e[1]][e[2]];
        }, s.Group.prototype.setProperty = function (t, e, i, s, n) {
          if (void 0 === n && (n = !1), s = s || 0, !this.hasProperty(t, e) && (!n || s > 0)) return !1;
          var o = e.length;
          return 1 === o ? 0 === s ? t[e[0]] = i : 1 === s ? t[e[0]] += i : 2 === s ? t[e[0]] -= i : 3 === s ? t[e[0]] *= i : 4 === s && (t[e[0]] /= i) : 2 === o ? 0 === s ? t[e[0]][e[1]] = i : 1 === s ? t[e[0]][e[1]] += i : 2 === s ? t[e[0]][e[1]] -= i : 3 === s ? t[e[0]][e[1]] *= i : 4 === s && (t[e[0]][e[1]] /= i) : 3 === o ? 0 === s ? t[e[0]][e[1]][e[2]] = i : 1 === s ? t[e[0]][e[1]][e[2]] += i : 2 === s ? t[e[0]][e[1]][e[2]] -= i : 3 === s ? t[e[0]][e[1]][e[2]] *= i : 4 === s && (t[e[0]][e[1]][e[2]] /= i) : 4 === o && (0 === s ? t[e[0]][e[1]][e[2]][e[3]] = i : 1 === s ? t[e[0]][e[1]][e[2]][e[3]] += i : 2 === s ? t[e[0]][e[1]][e[2]][e[3]] -= i : 3 === s ? t[e[0]][e[1]][e[2]][e[3]] *= i : 4 === s && (t[e[0]][e[1]][e[2]][e[3]] /= i)), !0;
        }, s.Group.prototype.checkProperty = function (t, e, i, n) {
          if (void 0 === n && (n = !1), this !== t.parent) return !1;
          var o = s.Utils.getProperty(t, e);
          return !(void 0 === o && n || o !== i);
        }, s.Group.prototype.set = function (t, e, i, s, n, o, r) {
          if (void 0 === r && (r = !1), e = e.split("."), void 0 === s && (s = !1), void 0 === n && (n = !1), (!1 === s || s && t.alive) && (!1 === n || n && t.visible)) return this.setProperty(t, e, i, o, r);
        }, s.Group.prototype.setAll = function (t, e, i, s, n, o) {
          void 0 === i && (i = !1), void 0 === s && (s = !1), void 0 === o && (o = !1), t = t.split("."), n = n || 0;

          for (var r = 0; r < this.children.length; r++) {
            (!i || i && this.children[r].alive) && (!s || s && this.children[r].visible) && this.setProperty(this.children[r], t, e, n, o);
          }
        }, s.Group.prototype.setAllChildren = function (t, e, i, n, o, r) {
          void 0 === i && (i = !1), void 0 === n && (n = !1), void 0 === r && (r = !1), o = o || 0;

          for (var a = 0; a < this.children.length; a++) {
            (!i || i && this.children[a].alive) && (!n || n && this.children[a].visible) && (this.children[a] instanceof s.Group ? this.children[a].setAllChildren(t, e, i, n, o, r) : this.setProperty(this.children[a], t.split("."), e, o, r));
          }
        }, s.Group.prototype.checkAll = function (t, e, i, s, n) {
          void 0 === i && (i = !1), void 0 === s && (s = !1), void 0 === n && (n = !1);

          for (var o = 0; o < this.children.length; o++) {
            var r = this.children[o];
            if ((!i || i && r.alive) && (!s || s && r.visible) && !this.checkProperty(r, t, e, n)) return !1;
          }

          return !0;
        }, s.Group.prototype.checkAny = function (t, e, i, s) {
          void 0 === i && (i = !1), void 0 === s && (s = !1);

          for (var n = 0; n < this.children.length; n++) {
            var o = this.children[n];
            if ((!i || i && o.alive) && (!s || s && o.visible) && this.checkProperty(o, t, e)) return !0;
          }

          return !1;
        }, s.Group.prototype.addAll = function (t, e, i, s) {
          this.setAll(t, e, i, s, 1);
        }, s.Group.prototype.subAll = function (t, e, i, s) {
          this.setAll(t, e, i, s, 2);
        }, s.Group.prototype.multiplyAll = function (t, e, i, s) {
          this.setAll(t, e, i, s, 3);
        }, s.Group.prototype.divideAll = function (t, e, i, s) {
          this.setAll(t, e, i, s, 4);
        }, s.Group.prototype.kill = function () {
          this.alive = !1, this.exists = !1, this.visible = !1;
        }, s.Group.prototype.killAll = function () {
          this.callAllExists("kill", !0);
        }, s.Group.prototype.revive = function () {
          this.alive = !0, this.exists = !0, this.visible = !0;
        }, s.Group.prototype.reviveAll = function () {
          this.callAllExists("revive", !1);
        }, s.Group.prototype.resetAll = function (t, e, i, s, n) {
          this.forEach(this.resetChild, this, n, t, e, i, s);
        }, s.Group.prototype.callAllExists = function (t, e) {
          var i;

          if (arguments.length > 2) {
            i = [];

            for (var s = 2; s < arguments.length; s++) {
              i.push(arguments[s]);
            }
          }

          for (s = 0; s < this.children.length; s++) {
            this.children[s].exists === e && this.children[s][t] && this.children[s][t].apply(this.children[s], i);
          }
        }, s.Group.prototype.callbackFromArray = function (t, e, i) {
          if (1 === i) {
            if (t[e[0]]) return t[e[0]];
          } else if (2 === i) {
            if (t[e[0]][e[1]]) return t[e[0]][e[1]];
          } else if (3 === i) {
            if (t[e[0]][e[1]][e[2]]) return t[e[0]][e[1]][e[2]];
          } else if (4 === i) {
            if (t[e[0]][e[1]][e[2]][e[3]]) return t[e[0]][e[1]][e[2]][e[3]];
          } else if (t[e]) return t[e];

          return !1;
        }, s.Group.prototype.callAll = function (t, e) {
          if (void 0 !== t) {
            var i,
                s = (t = t.split(".")).length;
            if (void 0 === e || null === e || "" === e) e = null;else if ("string" == typeof e) var n = (e = e.split(".")).length;

            if (arguments.length > 2) {
              i = [];

              for (var o = 2; o < arguments.length; o++) {
                i.push(arguments[o]);
              }
            }

            var r = null,
                a = null;

            for (o = 0; o < this.children.length; o++) {
              r = this.callbackFromArray(this.children[o], t, s), e && r ? (a = this.callbackFromArray(this.children[o], e, n), r && r.apply(a, i)) : r && r.apply(this.children[o], i);
            }
          }
        }, s.Group.prototype.preUpdate = function () {
          if (this.pendingDestroy) return this.destroy(), !1;
          if (!this.exists || !this.parent.exists) return this.renderOrderID = -1, !1;

          for (var t = 0; t < this.children.length;) {
            var e = this.children[t];
            e.preUpdate(), this === e.parent && t++;
          }

          return !0;
        }, s.Group.prototype.update = function () {
          for (var t = this.children.length; t--;) {
            var e = this.children.length;
            t >= e && (t = e - 1);
            var i = this.children[t];
            this.updateOnlyExistingChildren && !i.exists || i.update();
          }
        }, s.Group.prototype.postUpdate = function () {
          this.fixedToCamera && (this.x = (this.game.camera.view.x + this.cameraOffset.x) / this.game.camera.scale.x, this.y = (this.game.camera.view.y + this.cameraOffset.y) / this.game.camera.scale.y);

          for (var t = 0; t < this.children.length; t++) {
            this.children[t].postUpdate();
          }
        }, s.Group.prototype.filter = function (t, e) {
          for (var i = -1, n = this.children.length, o = []; ++i < n;) {
            var r = this.children[i];
            (!e || e && r.exists) && t(r, i, this.children) && o.push(r);
          }

          return new s.ArraySet(o);
        }, s.Group.prototype.forEach = function (t, e, i) {
          if (void 0 === i && (i = !1), arguments.length <= 3) for (var s = 0; s < this.children.length; s++) {
            (!i || i && this.children[s].exists) && t.call(e, this.children[s]);
          } else {
            var n = [null];

            for (s = 3; s < arguments.length; s++) {
              n.push(arguments[s]);
            }

            for (s = 0; s < this.children.length; s++) {
              (!i || i && this.children[s].exists) && (n[0] = this.children[s], t.apply(e, n));
            }
          }
        }, s.Group.prototype.forEachExists = function (t, e) {
          var i;

          if (arguments.length > 2) {
            i = [null];

            for (var n = 2; n < arguments.length; n++) {
              i.push(arguments[n]);
            }
          }

          this.iterate("exists", !0, s.Group.RETURN_TOTAL, t, e, i);
        }, s.Group.prototype.forEachAlive = function (t, e) {
          var i;

          if (arguments.length > 2) {
            i = [null];

            for (var n = 2; n < arguments.length; n++) {
              i.push(arguments[n]);
            }
          }

          this.iterate("alive", !0, s.Group.RETURN_TOTAL, t, e, i);
        }, s.Group.prototype.forEachDead = function (t, e) {
          var i;

          if (arguments.length > 2) {
            i = [null];

            for (var n = 2; n < arguments.length; n++) {
              i.push(arguments[n]);
            }
          }

          this.iterate("alive", !1, s.Group.RETURN_TOTAL, t, e, i);
        }, s.Group.prototype.sort = function (t, e) {
          this.children.length < 2 || (void 0 === t && (t = "z"), void 0 === e && (e = s.Group.SORT_ASCENDING), this._sortProperty = t, e === s.Group.SORT_ASCENDING ? this.children.sort(this.ascendingSortHandler.bind(this)) : this.children.sort(this.descendingSortHandler.bind(this)), this.updateZ());
        }, s.Group.prototype.customSort = function (t, e) {
          this.children.length < 2 || (this.children.sort(t.bind(e)), this.updateZ());
        }, s.Group.prototype.ascendingSortHandler = function (t, e) {
          return t[this._sortProperty] < e[this._sortProperty] ? -1 : t[this._sortProperty] > e[this._sortProperty] ? 1 : t.z < e.z ? -1 : 1;
        }, s.Group.prototype.descendingSortHandler = function (t, e) {
          return t[this._sortProperty] < e[this._sortProperty] ? 1 : t[this._sortProperty] > e[this._sortProperty] ? -1 : 0;
        }, s.Group.prototype.iterate = function (t, e, i, n, o, r) {
          if (0 === this.children.length) {
            if (i === s.Group.RETURN_TOTAL) return 0;
            if (i === s.Group.RETURN_ALL) return [];
          }

          var a = 0;
          if (i === s.Group.RETURN_ALL) var h = [];

          for (var l = 0; l < this.children.length; l++) {
            if (this.children[l][t] === e) {
              if (a++, n && (r ? (r[0] = this.children[l], n.apply(o, r)) : n.call(o, this.children[l])), i === s.Group.RETURN_CHILD) return this.children[l];
              i === s.Group.RETURN_ALL && h.push(this.children[l]);
            }
          }

          return i === s.Group.RETURN_TOTAL ? a : i === s.Group.RETURN_ALL ? h : null;
        }, s.Group.prototype.getFirst = function (t, e) {
          return this.iterate(t, e, s.Group.RETURN_CHILD);
        }, s.Group.prototype.getFirstExists = function (t, e, i, s, n, o) {
          void 0 === e && (e = !1), "boolean" != typeof t && (t = !0);
          var r = this.getFirst("exists", t);
          return null === r && e ? this.create(i, s, n, o) : this.resetChild(r, i, s, n, o);
        }, s.Group.prototype.getFirstAlive = function (t, e, i, s, n) {
          void 0 === t && (t = !1);
          var o = this.getFirst("alive", !0);
          return null === o && t ? this.create(e, i, s, n) : this.resetChild(o, e, i, s, n);
        }, s.Group.prototype.getFirstDead = function (t, e, i, s, n) {
          void 0 === t && (t = !1);
          var o = this.getFirst("alive", !1);
          return null === o && t ? this.create(e, i, s, n) : this.resetChild(o, e, i, s, n);
        }, s.Group.prototype.resetChild = function (t, e, i, s, n) {
          return null === t ? null : (void 0 === e && (e = null), void 0 === i && (i = null), null !== e && null !== i && t.reset(e, i), void 0 !== s && t.loadTexture(s, n), t);
        }, s.Group.prototype.getTop = function () {
          if (this.children.length > 0) return this.children[this.children.length - 1];
        }, s.Group.prototype.getBottom = function () {
          if (this.children.length > 0) return this.children[0];
        }, s.Group.prototype.getClosestTo = function (t, e, i) {
          for (var n = Number.MAX_VALUE, o = 0, r = null, a = 0; a < this.children.length; a++) {
            var h = this.children[a];
            h.exists && (o = Math.abs(s.Point.distance(t, h))) < n && (!e || e.call(i, h, o)) && (n = o, r = h);
          }

          return r;
        }, s.Group.prototype.getFurthestFrom = function (t, e, i) {
          for (var n = 0, o = 0, r = null, a = 0; a < this.children.length; a++) {
            var h = this.children[a];
            h.exists && (o = Math.abs(s.Point.distance(t, h))) > n && (!e || e.call(i, h, o)) && (n = o, r = h);
          }

          return r;
        }, s.Group.prototype.count = function (t, e) {
          return this.iterate(t, e, s.Group.RETURN_TOTAL);
        }, s.Group.prototype.countLiving = function () {
          return this.count("alive", !0);
        }, s.Group.prototype.countDead = function () {
          return this.count("alive", !1);
        }, s.Group.prototype.getRandom = function (t, e) {
          return void 0 === t && (t = 0), void 0 === e && (e = this.children.length), 0 === e ? null : s.ArrayUtils.getRandomItem(this.children, t, e);
        }, s.Group.prototype.getRandomExists = function (t, e) {
          var i = this.getAll("exists", !0, t, e);
          return this.game.rnd.pick(i);
        }, s.Group.prototype.getAll = function (t, e, i, s) {
          void 0 === i && (i = 0), void 0 === s && (s = this.children.length);

          for (var n = [], o = i; o < s; o++) {
            var r = this.children[o];
            t ? r[t] === e && n.push(r) : n.push(r);
          }

          return n;
        }, s.Group.prototype.remove = function (t, e, i) {
          if (void 0 === e && (e = !1), void 0 === i && (i = !1), 0 === this.children.length || -1 === this.children.indexOf(t)) return !1;
          i || !t.events || t.destroyPhase || t.events.onRemovedFromGroup$dispatch(t, this);
          var s = this.removeChild(t);
          return this.removeFromHash(t), this.updateZ(), this.cursor === t && this.next(), e && s && s.destroy(!0), !0;
        }, s.Group.prototype.moveAll = function (t, e) {
          if (void 0 === e && (e = !1), this.children.length > 0 && t instanceof s.Group) {
            do {
              t.add(this.children[0], e);
            } while (this.children.length > 0);

            this.hash = [], this.cursor = null;
          }

          return t;
        }, s.Group.prototype.removeAll = function (t, e, i) {
          if (void 0 === t && (t = !1), void 0 === e && (e = !1), void 0 === i && (i = !1), 0 !== this.children.length) {
            do {
              !e && this.children[0].events && this.children[0].events.onRemovedFromGroup$dispatch(this.children[0], this);
              var s = this.removeChild(this.children[0]);
              this.removeFromHash(s), t && s && s.destroy(!0, i);
            } while (this.children.length > 0);

            this.hash = [], this.cursor = null;
          }
        }, s.Group.prototype.removeBetween = function (t, e, i, s) {
          if (void 0 === e && (e = this.children.length - 1), void 0 === i && (i = !1), void 0 === s && (s = !1), 0 !== this.children.length) {
            if (t > e || t < 0 || e > this.children.length) return !1;

            for (var n = e; n >= t;) {
              !s && this.children[n].events && this.children[n].events.onRemovedFromGroup$dispatch(this.children[n], this);
              var o = this.removeChild(this.children[n]);
              this.removeFromHash(o), i && o && o.destroy(!0), this.cursor === this.children[n] && (this.cursor = null), n--;
            }

            this.updateZ();
          }
        }, s.Group.prototype.scatter = function (t, e) {
          null == t && (t = this.game.world.bounds), this.forEach(function (e) {
            e.position.set(t.randomX, t.randomY);
          }, null, e);
        }, s.Group.prototype.shuffle = function () {
          s.ArrayUtils.shuffle(this.children), this.updateZ();
        }, s.Group.prototype.destroy = function (t, e) {
          null === this.game || this.ignoreDestroy || (void 0 === t && (t = !0), void 0 === e && (e = !1), this.onDestroy.dispatch(this, t, e), this.removeAll(t), this.cursor = null, this.filters = null, this.pendingDestroy = !1, e || (this.parent && this.parent.removeChild(this), this.game = null, this.exists = !1));
        }, Object.defineProperty(s.Group.prototype, "total", {
          get: function get() {
            return this.iterate("exists", !0, s.Group.RETURN_TOTAL);
          }
        }), Object.defineProperty(s.Group.prototype, "length", {
          get: function get() {
            return this.children.length;
          }
        }), Object.defineProperty(s.Group.prototype, "angle", {
          get: function get() {
            return s.Math.radToDeg(this.rotation);
          },
          set: function set(t) {
            this.rotation = s.Math.degToRad(t);
          }
        }), Object.defineProperty(s.Group.prototype, "centerX", {
          get: function get() {
            return this.getBounds(this.parent).centerX;
          },
          set: function set(t) {
            var e = this.getBounds(this.parent),
                i = this.x - e.x;
            this.x = t + i - e.halfWidth;
          }
        }), Object.defineProperty(s.Group.prototype, "centerY", {
          get: function get() {
            return this.getBounds(this.parent).centerY;
          },
          set: function set(t) {
            var e = this.getBounds(this.parent),
                i = this.y - e.y;
            this.y = t + i - e.halfHeight;
          }
        }), Object.defineProperty(s.Group.prototype, "left", {
          get: function get() {
            return this.getBounds(this.parent).left;
          },
          set: function set(t) {
            var e = this.getBounds(this.parent),
                i = this.x - e.x;
            this.x = t + i;
          }
        }), Object.defineProperty(s.Group.prototype, "right", {
          get: function get() {
            return this.getBounds(this.parent).right;
          },
          set: function set(t) {
            var e = this.getBounds(this.parent),
                i = this.x - e.x;
            this.x = t + i - e.width;
          }
        }), Object.defineProperty(s.Group.prototype, "top", {
          get: function get() {
            return this.getBounds(this.parent).top;
          },
          set: function set(t) {
            var e = this.getBounds(this.parent),
                i = this.y - e.y;
            this.y = t + i;
          }
        }), Object.defineProperty(s.Group.prototype, "bottom", {
          get: function get() {
            return this.getBounds(this.parent).bottom;
          },
          set: function set(t) {
            var e = this.getBounds(this.parent),
                i = this.y - e.y;
            this.y = t + i - e.height;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.World = function (t) {
          s.Group.call(this, t, null, "__world", !1), this.bounds = new s.Rectangle(0, 0, t.width, t.height), this.camera = null, this._definedSize = !1, this._width = t.width, this._height = t.height, this.game.state.onStateChange.add(this.stateChange, this);
        }, s.World.prototype = Object.create(s.Group.prototype), s.World.prototype.constructor = s.World, s.World.prototype.boot = function () {
          this.camera = new s.Camera(this.game, 0, 0, 0, this.game.width, this.game.height), this.game.stage.addChild(this), this.camera.boot();
        }, s.World.prototype.stateChange = function () {
          this.x = 0, this.y = 0, this.camera.reset();
        }, s.World.prototype.setBounds = function (t, e, i, s) {
          this._definedSize = !0, this._width = i, this._height = s, this.bounds.setTo(t, e, i, s), this.x = t, this.y = e, this.camera.bounds && this.camera.bounds.setTo(t, e, Math.max(i, this.game.width), Math.max(s, this.game.height)), this.game.physics.setBoundsToWorld();
        }, s.World.prototype.resize = function (t, e) {
          this._definedSize && (t < this._width && (t = this._width), e < this._height && (e = this._height)), this.bounds.width = t, this.bounds.height = e, this.game.camera.setBoundsToWorld(), this.game.physics.setBoundsToWorld();
        }, s.World.prototype.shutdown = function () {
          this.destroy(!0, !0);
        }, s.World.prototype.wrap = function (t, e, i, s, n) {
          void 0 === e && (e = 0), void 0 === i && (i = !1), void 0 === s && (s = !0), void 0 === n && (n = !0), i ? (t.getBounds(), s && (t.x + t._currentBounds.width < this.bounds.x ? t.x = this.bounds.right : t.x > this.bounds.right && (t.x = this.bounds.left)), n && (t.y + t._currentBounds.height < this.bounds.top ? t.y = this.bounds.bottom : t.y > this.bounds.bottom && (t.y = this.bounds.top))) : (s && t.x + e < this.bounds.x ? t.x = this.bounds.right + e : s && t.x - e > this.bounds.right && (t.x = this.bounds.left - e), n && t.y + e < this.bounds.top ? t.y = this.bounds.bottom + e : n && t.y - e > this.bounds.bottom && (t.y = this.bounds.top - e));
        }, s.World.prototype.wrapAll = function (t, e, i, s, n, o) {
          t.forEach(this.wrap, this, e, i, s, n, o);
        }, Object.defineProperty(s.World.prototype, "width", {
          get: function get() {
            return this.bounds.width;
          },
          set: function set(t) {
            t < this.game.width && (t = this.game.width), this.bounds.width = t, this._width = t, this._definedSize = !0;
          }
        }), Object.defineProperty(s.World.prototype, "height", {
          get: function get() {
            return this.bounds.height;
          },
          set: function set(t) {
            t < this.game.height && (t = this.game.height), this.bounds.height = t, this._height = t, this._definedSize = !0;
          }
        }), Object.defineProperty(s.World.prototype, "centerX", {
          get: function get() {
            return this.bounds.halfWidth + this.bounds.x;
          }
        }), Object.defineProperty(s.World.prototype, "centerY", {
          get: function get() {
            return this.bounds.halfHeight + this.bounds.y;
          }
        }), Object.defineProperty(s.World.prototype, "randomX", {
          get: function get() {
            return this.bounds.x < 0 ? this.game.rnd.between(this.bounds.x, this.bounds.width - Math.abs(this.bounds.x)) : this.game.rnd.between(this.bounds.x, this.bounds.width);
          }
        }), Object.defineProperty(s.World.prototype, "randomY", {
          get: function get() {
            return this.bounds.y < 0 ? this.game.rnd.between(this.bounds.y, this.bounds.height - Math.abs(this.bounds.y)) : this.game.rnd.between(this.bounds.y, this.bounds.height);
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Game = function (t, e, i, n, o, r, a, h) {
          return this.id = s.GAMES.push(this) - 1, this.config = null, this.physicsConfig = h, this.parent = "", this.width = 800, this.height = 600, this.resolution = 1, this._width = 800, this._height = 600, this.transparent = !1, this.antialias = !0, this.multiTexture = !1, this.preserveDrawingBuffer = !1, this.clearBeforeRender = !0, this.renderer = null, this.renderType = s.AUTO, this.state = null, this.isBooted = !1, this.isRunning = !1, this.raf = null, this.add = null, this.make = null, this.cache = null, this.input = null, this.load = null, this.math = null, this.net = null, this.scale = null, this.sound = null, this.stage = null, this.time = null, this.tweens = null, this.world = null, this.physics = null, this.plugins = null, this.rnd = null, this.device = s.Device, this.camera = null, this.canvas = null, this.context = null, this.debug = null, this.particles = null, this.create = null, this.lockRender = !1, this.pendingDestroy = !1, this.stepping = !1, this.pendingStep = !1, this.stepCount = 0, this.onPause = null, this.onResume = null, this.onBlur = null, this.onFocus = null, this._paused = !1, this._codePaused = !1, this.currentUpdateID = 0, this.updatesThisFrame = 1, this.rendersThisFrame = 1, this._deltaTime = 0, this._lastCount = 0, this._spiraling = 0, this._kickstart = !0, this.fpsProblemNotifier = new s.Signal(), this.forceSingleUpdate = !0, this.forceSingleRender = !0, this.dropFrames = !1, this._nextFpsNotification = 0, 1 === arguments.length && "object" == typeof arguments[0] ? this.parseConfig(arguments[0]) : (this.config = {
            enableDebug: !0
          }, void 0 !== t && (this._width = t), void 0 !== e && (this._height = e), void 0 !== i && (this.renderType = i), void 0 !== n && (this.parent = n), void 0 !== r && (this.transparent = r), void 0 !== a && (this.antialias = a), this.rnd = new s.RandomDataGenerator([(Date.now() * Math.random()).toString()]), this.state = new s.StateManager(this, o)), this.device.whenReady(this.boot, this), this;
        }, s.Game.prototype = {
          parseConfig: function parseConfig(t) {
            this.config = t, void 0 === t.enableDebug && (this.config.enableDebug = !0), t.width && (this._width = t.width), t.height && (this._height = t.height), t.renderer && (this.renderType = t.renderer), t.parent && (this.parent = t.parent), void 0 !== t.transparent && (this.transparent = t.transparent), void 0 !== t.antialias && (this.antialias = t.antialias), void 0 !== t.clearBeforeRender && (this.clearBeforeRender = t.clearBeforeRender), void 0 !== t.multiTexture && (this.multiTexture = t.multiTexture), t.resolution && (this.resolution = t.resolution), void 0 !== t.preserveDrawingBuffer && (this.preserveDrawingBuffer = t.preserveDrawingBuffer), t.physicsConfig && (this.physicsConfig = t.physicsConfig);
            var e = [(Date.now() * Math.random()).toString()];
            t.seed && (e = t.seed), this.rnd = new s.RandomDataGenerator(e);
            var i = null;
            t.state && (i = t.state), this.state = new s.StateManager(this, i);
          },
          boot: function boot() {
            this.isBooted || (this.onPause = new s.Signal(), this.onResume = new s.Signal(), this.onBlur = new s.Signal(), this.onFocus = new s.Signal(), this.isBooted = !0, PIXI.game = this, this.math = s.Math, this.scale = new s.ScaleManager(this, this._width, this._height), this.stage = new s.Stage(this), this.setUpRenderer(), this.world = new s.World(this), this.add = new s.GameObjectFactory(this), this.make = new s.GameObjectCreator(this), this.cache = new s.Cache(this), this.load = new s.Loader(this), this.time = new s.Time(this), this.tweens = new s.TweenManager(this), this.input = new s.Input(this), this.sound = new s.SoundManager(this), this.physics = new s.Physics(this, this.physicsConfig), this.particles = new s.Particles(this), this.create = new s.Create(this), this.plugins = new s.PluginManager(this), this.net = new s.Net(this), this.time.boot(), this.stage.boot(), this.world.boot(), this.scale.boot(), this.input.boot(), this.sound.boot(), this.state.boot(), this.config.enableDebug ? (this.debug = new s.Utils.Debug(this), this.debug.boot()) : this.debug = {
              preUpdate: function preUpdate() {},
              update: function update() {},
              reset: function reset() {},
              isDisabled: !0
            }, this.showDebugHeader(), this.isRunning = !0, this.config && this.config.forceSetTimeOut ? this.raf = new s.RequestAnimationFrame(this, this.config.forceSetTimeOut) : this.raf = new s.RequestAnimationFrame(this, !1), this._kickstart = !0, window.focus && (!window.PhaserGlobal || window.PhaserGlobal && !window.PhaserGlobal.stopFocus) && window.focus(), this.config.disableStart || (this.cache.isReady ? this.raf.start() : this.cache.onReady.addOnce(function () {
              this.raf.start();
            }, this)));
          },
          showDebugHeader: function showDebugHeader() {
            if (!window.PhaserGlobal || !window.PhaserGlobal.hideBanner) {
              var t = s.VERSION,
                  e = "Canvas",
                  i = "HTML Audio",
                  n = 1;
              if (this.renderType === s.WEBGL ? (e = "WebGL", n++) : this.renderType === s.HEADLESS && (e = "Headless"), this.device.webAudio && (i = "WebAudio", n++), this.device.ie) window.console && console.log("Phaser v" + t + " | Pixi.js | " + e + " | " + i + " | http://phaser.io");else {
                for (var o = ["%c %c %c Phaser CE v" + t + " | Pixi.js | " + e + " | " + i + "  %c %c %c http://phaser.io %c♥%c♥%c♥", "background: #fb8cb3", "background: #d44a52", "color: #ffffff; background: #871905;", "background: #d44a52", "background: #fb8cb3", "background: #ffffff"], r = 0; r < 3; r++) {
                  r < n ? o.push("color: #ff2424; background: #fff") : o.push("color: #959595; background: #fff");
                }

                console.log.apply(console, o);
              }
            }
          },
          setUpRenderer: function setUpRenderer() {
            if (!this.device.canvas) throw new Error("Phaser.Game - Cannot create Canvas 2d context, aborting.");

            if (this.config.canvas ? this.canvas = this.config.canvas : this.canvas = s.Canvas.create(this, this.width, this.height, this.config.canvasID, !0), this.config.canvasStyle ? this.canvas.style = this.config.canvasStyle : this.canvas.style["-webkit-full-screen"] = "width: 100%; height: 100%", this.config.crisp && s.Canvas.setImageRenderingCrisp(this.canvas), this.renderType === s.WEBGL || this.renderType === s.WEBGL_MULTI || this.renderType === s.AUTO && this.device.webGL) {
              (this.multiTexture || this.renderType === s.WEBGL_MULTI) && (PIXI.enableMultiTexture(), this.multiTexture = !0);

              try {
                this.renderer = new PIXI.WebGLRenderer(this, this.config), this.renderType = s.WEBGL, this.context = null, this.canvas.addEventListener("webglcontextlost", this.contextLost.bind(this), !1), this.canvas.addEventListener("webglcontextrestored", this.contextRestored.bind(this), !1);
              } catch (t) {
                if (this.renderer = null, this.multiTexture = !1, PIXI._enableMultiTextureToggle = !1, this.renderType === s.WEBGL) throw t;
              }
            }

            this.renderer || (this.renderer = new PIXI.CanvasRenderer(this, this.config), this.context = this.renderer.context, this.renderType === s.AUTO && (this.renderType = s.CANVAS)), this.device.cocoonJS && (this.canvas.screencanvas = this.renderType === s.CANVAS), this.renderType !== s.HEADLESS && (this.stage.smoothed = this.antialias, s.Canvas.addToDOM(this.canvas, this.parent, !1), s.Canvas.setTouchAction(this.canvas));
          },
          contextLost: function contextLost(t) {
            t.preventDefault(), this.renderer.contextLost = !0;
          },
          contextRestored: function contextRestored() {
            this.renderer.initContext(), this.cache.clearGLTextures(), this.renderer.contextLost = !1;
          },
          update: function update(t) {
            if (this.pendingDestroy) this.destroy();else {
              if (this.time.update(t), this._kickstart) return this.updateLogic(this.time.desiredFpsMult), this.updateRender(this.time.slowMotion * this.time.desiredFps), void (this._kickstart = !1);
              if (this._spiraling > 1 && !this.forceSingleUpdate) this.time.time > this._nextFpsNotification && (this._nextFpsNotification = this.time.time + 1e4, this.fpsProblemNotifier.dispatch()), this._deltaTime = 0, this._spiraling = 0, this.dropFrames ? this.rendersThisFrame = 0 : (this.updateRender(this.time.slowMotion * this.time.desiredFps), this.rendersThisFrame = 1);else {
                var e = 1e3 * this.time.slowMotion / this.time.desiredFps;
                this._deltaTime += Math.max(Math.min(3 * e, this.time.elapsed), 0);
                var i = 0;

                for (this.updatesThisFrame = Math.floor(this._deltaTime / e), this.forceSingleUpdate && (this.updatesThisFrame = Math.min(1, this.updatesThisFrame)), this.forceSingleRender ? this.rendersThisFrame = 1 : this.rendersThisFrame = Math.min(1, this.updatesThisFrame); this._deltaTime >= e && (this._deltaTime -= e, this.currentUpdateID = i, this.updateLogic(this.time.desiredFpsMult), i++, !this.forceSingleUpdate || 1 !== i);) {
                  this.time.refresh();
                }

                i > this._lastCount ? this._spiraling++ : i < this._lastCount && (this._spiraling = 0), this._lastCount = i, this.rendersThisFrame > 0 && this.updateRender(this._deltaTime / e);
              }
            }
          },
          updateLogic: function updateLogic(t) {
            this._paused || this.pendingStep ? (this.scale.pauseUpdate(), this.state.pauseUpdate(t), this.debug.preUpdate(), this.input.pauseUpdate()) : (this.stepping && (this.pendingStep = !0), this.time.countUpdate(), this.scale.preUpdate(), this.debug.preUpdate(), this.camera.preUpdate(), this.physics.preUpdate(), this.state.preUpdate(t), this.plugins.preUpdate(t), this.stage.preUpdate(), this.state.update(), this.stage.update(), this.tweens.update(), this.sound.update(), this.input.update(), this.physics.update(), this.plugins.update(), this.stage.postUpdate(), this.plugins.postUpdate()), this.stage.updateTransform();
          },
          updateRender: function updateRender(t) {
            this.lockRender || (this.time.countRender(), this.state.preRender(t), this.renderType !== s.HEADLESS && (this.renderer.render(this.stage), this.plugins.render(t), this.state.render(t)), this.plugins.postRender(t));
          },
          enableStep: function enableStep() {
            this.stepping = !0, this.pendingStep = !1, this.stepCount = 0;
          },
          disableStep: function disableStep() {
            this.stepping = !1, this.pendingStep = !1;
          },
          step: function step() {
            this.pendingStep = !1, this.stepCount++;
          },
          destroy: function destroy() {
            this.raf.stop(), this.debug.destroy && this.debug.destroy(), this.state.destroy(), this.sound.destroy(), this.scale.destroy(), this.stage.destroy(), this.input.destroy(), this.physics.destroy(), this.plugins.destroy(), this.debug = null, this.state = null, this.sound = null, this.scale = null, this.stage = null, this.input = null, this.physics = null, this.plugins = null, this.cache = null, this.load = null, this.time = null, this.world = null, this.isBooted = !1, this.renderer.destroy(!1), s.Canvas.removeFromDOM(this.canvas), PIXI.defaultRenderer = null, s.GAMES[this.id] = null;
          },
          gamePaused: function gamePaused(t) {
            this._paused || (this._paused = !0, this.time.gamePaused(), this.sound.muteOnPause && this.sound.setMute(), this.onPause.dispatch(t), this.device.cordova && this.device.iOS && (this.lockRender = !0));
          },
          gameResumed: function gameResumed(t) {
            this._paused && !this._codePaused && (this._paused = !1, this.time.gameResumed(), this.input.reset(), this.sound.muteOnPause && this.sound.unsetMute(), this.onResume.dispatch(t), this.device.cordova && this.device.iOS && (this.lockRender = !1));
          },
          focusLoss: function focusLoss(t) {
            this.onBlur.dispatch(t), this.stage.disableVisibilityChange || this.gamePaused(t);
          },
          focusGain: function focusGain(t) {
            this.onFocus.dispatch(t), this.stage.disableVisibilityChange || this.gameResumed(t);
          }
        }, s.Game.prototype.constructor = s.Game, Object.defineProperty(s.Game.prototype, "paused", {
          get: function get() {
            return this._paused;
          },
          set: function set(t) {
            !0 === t ? (!1 === this._paused && (this._paused = !0, this.sound.setMute(), this.time.gamePaused(), this.onPause.dispatch(this)), this._codePaused = !0) : (this._paused && (this._paused = !1, this.input.reset(), this.sound.unsetMute(), this.time.gameResumed(), this.onResume.dispatch(this)), this._codePaused = !1);
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Input = function (t) {
          this.game = t, this.hitCanvas = null, this.hitContext = null, this.moveCallbacks = [], this.customCandidateHandler = null, this.customCandidateHandlerContext = null, this.pollRate = 0, this.enabled = !0, this.multiInputOverride = s.Input.MOUSE_TOUCH_COMBINE, this.position = null, this.speed = null, this.circle = null, this.scale = null, this.maxPointers = -1, this.tapRate = 200, this.doubleTapRate = 300, this.holdRate = 2e3, this.justPressedRate = 200, this.justReleasedRate = 200, this.recordPointerHistory = !1, this.recordRate = 100, this.recordLimit = 100, this.touchLockCallbacks = [], this.pointer1 = null, this.pointer2 = null, this.pointer3 = null, this.pointer4 = null, this.pointer5 = null, this.pointer6 = null, this.pointer7 = null, this.pointer8 = null, this.pointer9 = null, this.pointer10 = null, this.pointers = [], this.activePointer = null, this.mousePointer = null, this.mouse = null, this.keyboard = null, this.touch = null, this.mspointer = null, this.gamepad = null, this.resetLocked = !1, this.onDown = null, this.onUp = null, this.onTap = null, this.onHold = null, this.minPriorityID = 0, this.interactiveItems = new s.ArraySet(), this._localPoint = new s.Point(), this._pollCounter = 0, this._oldPosition = null, this._x = 0, this._y = 0;
        }, s.Input.MOUSE_OVERRIDES_TOUCH = 0, s.Input.TOUCH_OVERRIDES_MOUSE = 1, s.Input.MOUSE_TOUCH_COMBINE = 2, s.Input.MAX_POINTERS = 10, s.Input.prototype = {
          boot: function boot() {
            this.mousePointer = new s.Pointer(this.game, 0, s.PointerMode.CURSOR), this.addPointer(), this.addPointer(), this.mouse = new s.Mouse(this.game), this.touch = new s.Touch(this.game), this.mspointer = new s.MSPointer(this.game), s.Keyboard && (this.keyboard = new s.Keyboard(this.game)), s.Gamepad && (this.gamepad = new s.Gamepad(this.game)), this.onDown = new s.Signal(), this.onUp = new s.Signal(), this.onTap = new s.Signal(), this.onHold = new s.Signal(), this.scale = new s.Point(1, 1), this.speed = new s.Point(), this.position = new s.Point(), this._oldPosition = new s.Point(), this.circle = new s.Circle(0, 0, 44), this.activePointer = this.mousePointer, this.hitCanvas = s.CanvasPool.create(this, 1, 1), this.hitContext = this.hitCanvas.getContext("2d"), this.mouse.start(), this.game.device.mspointer || this.touch.start(), this.mspointer.start(), this.mousePointer.active = !0, this.keyboard && this.keyboard.start();
            var t = this;
            this._onClickTrampoline = function (e) {
              t.onClickTrampoline(e);
            }, this.game.canvas.addEventListener("click", this._onClickTrampoline, !1);
          },
          destroy: function destroy() {
            this.mouse.stop(), this.touch.stop(), this.mspointer.stop(), this.keyboard && this.keyboard.stop(), this.gamepad && this.gamepad.stop(), this.moveCallbacks = [], s.CanvasPool.remove(this), this.game.canvas.removeEventListener("click", this._onClickTrampoline);
          },
          setInteractiveCandidateHandler: function setInteractiveCandidateHandler(t, e) {
            this.customCandidateHandler = t, this.customCandidateHandlerContext = e;
          },
          addMoveCallback: function addMoveCallback(t, e) {
            this.moveCallbacks.push({
              callback: t,
              context: e
            });
          },
          addTouchLockCallback: function addTouchLockCallback(t, e, i) {
            void 0 === i && (i = !1), this.touchLockCallbacks.push({
              callback: t,
              context: e,
              onEnd: i
            });
          },
          removeTouchLockCallback: function removeTouchLockCallback(t, e) {
            for (var i = this.touchLockCallbacks.length; i--;) {
              if (this.touchLockCallbacks[i].callback === t && this.touchLockCallbacks[i].context === e) return this.touchLockCallbacks.splice(i, 1), !0;
            }

            return !1;
          },
          executeTouchLockCallbacks: function executeTouchLockCallbacks(t, e) {
            for (var i = this.touchLockCallbacks.length; i--;) {
              var s = this.touchLockCallbacks[i];
              s.onEnd === t && s.callback.call(s.context, this, e) && this.touchLockCallbacks.splice(i, 1);
            }
          },
          deleteMoveCallback: function deleteMoveCallback(t, e) {
            for (var i = this.moveCallbacks.length; i--;) {
              if (this.moveCallbacks[i].callback === t && this.moveCallbacks[i].context === e) return void this.moveCallbacks.splice(i, 1);
            }
          },
          addPointer: function addPointer() {
            if (this.pointers.length >= s.Input.MAX_POINTERS) return console.warn("Phaser.Input.addPointer: Maximum limit of " + s.Input.MAX_POINTERS + " pointers reached."), null;
            var t = this.pointers.length + 1,
                e = new s.Pointer(this.game, t, s.PointerMode.CONTACT);
            return this.pointers.push(e), this["pointer" + t] = e, e;
          },
          update: function update() {
            if (this.keyboard && this.keyboard.update(), this.pollRate > 0 && this._pollCounter < this.pollRate) this._pollCounter++;else {
              this.speed.x = this.position.x - this._oldPosition.x, this.speed.y = this.position.y - this._oldPosition.y, this._oldPosition.copyFrom(this.position), this.mousePointer.update(), this.gamepad && this.gamepad.active && this.gamepad.update();

              for (var t = 0; t < this.pointers.length; t++) {
                this.pointers[t].update();
              }

              this._pollCounter = 0;
            }
          },
          pauseUpdate: function pauseUpdate() {
            this.gamepad && this.gamepad.active && this.gamepad.update();
          },
          reset: function reset(t) {
            if (this.game.isBooted && !this.resetLocked) {
              void 0 === t && (t = !1), this.mousePointer.reset(), this.keyboard && this.keyboard.reset(t);

              for (var e = 0; e < this.pointers.length; e++) {
                this.pointers[e].reset();
              }

              "none" !== this.game.canvas.style.cursor && (this.game.canvas.style.cursor = ""), t && (this.onDown.dispose(), this.onUp.dispose(), this.onTap.dispose(), this.onHold.dispose(), this.onDown = new s.Signal(), this.onUp = new s.Signal(), this.onTap = new s.Signal(), this.onHold = new s.Signal(), this.moveCallbacks = []), this._pollCounter = 0;
            }
          },
          resetSpeed: function resetSpeed(t, e) {
            this._oldPosition.setTo(t, e), this.speed.setTo(0, 0);
          },
          startPointer: function startPointer(t) {
            if (this.maxPointers >= 0 && this.countActivePointers(this.maxPointers) >= this.maxPointers) return null;
            if (!this.pointer1.active) return this.pointer1.start(t);
            if (!this.pointer2.active) return this.pointer2.start(t);

            for (var e = 2; e < this.pointers.length; e++) {
              var i = this.pointers[e];
              if (!i.active) return i.start(t);
            }

            return null;
          },
          updatePointer: function updatePointer(t) {
            if (this.pointer1.active && this.pointer1.identifier === t.identifier) return this.pointer1.move(t);
            if (this.pointer2.active && this.pointer2.identifier === t.identifier) return this.pointer2.move(t);

            for (var e = 2; e < this.pointers.length; e++) {
              var i = this.pointers[e];
              if (i.active && i.identifier === t.identifier) return i.move(t);
            }

            return null;
          },
          stopPointer: function stopPointer(t) {
            if (this.pointer1.active && this.pointer1.identifier === t.identifier) return this.pointer1.stop(t);
            if (this.pointer2.active && this.pointer2.identifier === t.identifier) return this.pointer2.stop(t);

            for (var e = 2; e < this.pointers.length; e++) {
              var i = this.pointers[e];
              if (i.active && i.identifier === t.identifier) return i.stop(t);
            }

            return null;
          },
          countActivePointers: function countActivePointers(t) {
            void 0 === t && (t = this.pointers.length);

            for (var e = t, i = 0; i < this.pointers.length && e > 0; i++) {
              this.pointers[i].active && e--;
            }

            return t - e;
          },
          getPointer: function getPointer(t) {
            void 0 === t && (t = !1);

            for (var e = 0; e < this.pointers.length; e++) {
              var i = this.pointers[e];
              if (i.active === t) return i;
            }

            return null;
          },
          getPointerFromIdentifier: function getPointerFromIdentifier(t) {
            for (var e = 0; e < this.pointers.length; e++) {
              var i = this.pointers[e];
              if (i.identifier === t) return i;
            }

            return null;
          },
          getPointerFromId: function getPointerFromId(t) {
            for (var e = 0; e < this.pointers.length; e++) {
              var i = this.pointers[e];
              if (i.pointerId === t) return i;
            }

            return null;
          },
          getLocalPosition: function getLocalPosition(t, e, i) {
            void 0 === i && (i = new s.Point());
            var n = t.worldTransform,
                o = 1 / (n.a * n.d + n.c * -n.b);
            return i.setTo(n.d * o * e.x + -n.c * o * e.y + (n.ty * n.c - n.tx * n.d) * o, n.a * o * e.y + -n.b * o * e.x + (-n.ty * n.a + n.tx * n.b) * o);
          },
          hitTest: function hitTest(t, e, i) {
            if (!t.worldVisible) return !1;
            if (this.getLocalPosition(t, e, this._localPoint), i.copyFrom(this._localPoint), t.hitArea && t.hitArea.contains) return t.hitArea.contains(this._localPoint.x, this._localPoint.y);

            if (s.Creature && t instanceof s.Creature) {
              var n = Math.abs(t.width),
                  o = Math.abs(t.height),
                  r = t.x - n * t.anchorX;

              if (this.game.camera.x + e.x >= r && this.game.camera.x + e.x < r + n) {
                var a = t.y - o * t.anchorY;
                if (this.game.camera.y + e.y >= a && this.game.camera.y + e.y < a + o) return !0;
              }
            } else if (t instanceof s.TileSprite) {
              n = t.width, o = t.height, r = -n * t.anchor.x;

              if (this._localPoint.x >= r && this._localPoint.x < r + n) {
                a = -o * t.anchor.y;
                if (this._localPoint.y >= a && this._localPoint.y < a + o) return !0;
              }
            } else if (t instanceof PIXI.Sprite) {
              n = t.texture.frame.width / t.texture.baseTexture.resolution, o = t.texture.frame.height / t.texture.baseTexture.resolution, r = -n * t.anchor.x;

              if (this._localPoint.x >= r && this._localPoint.x < r + n) {
                a = -o * t.anchor.y;
                if (this._localPoint.y >= a && this._localPoint.y < a + o) return !0;
              }
            } else if (t instanceof s.Graphics) for (var h = 0; h < t.graphicsData.length; h++) {
              var l = t.graphicsData[h];
              if (l.fill && l.shape && l.shape.contains(this._localPoint.x, this._localPoint.y)) return !0;
            }

            for (h = 0; h < t.children.length; h++) {
              if (this.hitTest(t.children[h], e, i)) return !0;
            }

            return !1;
          },
          onClickTrampoline: function onClickTrampoline() {
            this.activePointer.processClickTrampolines();
          }
        }, s.Input.prototype.constructor = s.Input, Object.defineProperty(s.Input.prototype, "x", {
          get: function get() {
            return this._x;
          },
          set: function set(t) {
            this._x = Math.floor(t);
          }
        }), Object.defineProperty(s.Input.prototype, "y", {
          get: function get() {
            return this._y;
          },
          set: function set(t) {
            this._y = Math.floor(t);
          }
        }), Object.defineProperty(s.Input.prototype, "pollLocked", {
          get: function get() {
            return this.pollRate > 0 && this._pollCounter < this.pollRate;
          }
        }), Object.defineProperty(s.Input.prototype, "totalInactivePointers", {
          get: function get() {
            return this.pointers.length - this.countActivePointers();
          }
        }), Object.defineProperty(s.Input.prototype, "totalActivePointers", {
          get: function get() {
            return this.countActivePointers();
          }
        }), Object.defineProperty(s.Input.prototype, "worldX", {
          get: function get() {
            return this.game.camera.view.x + this.x;
          }
        }), Object.defineProperty(s.Input.prototype, "worldY", {
          get: function get() {
            return this.game.camera.view.y + this.y;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Mouse = function (t) {
          this.game = t, this.input = t.input, this.callbackContext = this.game, this.mouseDownCallback = null, this.mouseUpCallback = null, this.mouseOutCallback = null, this.mouseOverCallback = null, this.mouseWheelCallback = null, this.capture = !1, this.button = -1, this.wheelDelta = 0, this.enabled = !0, this.locked = !1, this.stopOnGameOut = !1, this.pointerLock = new s.Signal(), this.event = null, this._onMouseDown = null, this._onMouseMove = null, this._onMouseUp = null, this._onMouseOut = null, this._onMouseOver = null, this._onMouseWheel = null, this._wheelEvent = null;
        }, s.Mouse.NO_BUTTON = -1, s.Mouse.LEFT_BUTTON = 0, s.Mouse.MIDDLE_BUTTON = 1, s.Mouse.RIGHT_BUTTON = 2, s.Mouse.BACK_BUTTON = 3, s.Mouse.FORWARD_BUTTON = 4, s.Mouse.WHEEL_UP = 1, s.Mouse.WHEEL_DOWN = -1, s.Mouse.prototype = {
          start: function start() {
            if ((!this.game.device.android || !1 !== this.game.device.chrome) && null === this._onMouseDown) {
              var t = this;
              this._onMouseDown = function (e) {
                return t.onMouseDown(e);
              }, this._onMouseMove = function (e) {
                return t.onMouseMove(e);
              }, this._onMouseUp = function (e) {
                return t.onMouseUp(e);
              }, this._onMouseUpGlobal = function (e) {
                return t.onMouseUpGlobal(e);
              }, this._onMouseOutGlobal = function (e) {
                return t.onMouseOutGlobal(e);
              }, this._onMouseOut = function (e) {
                return t.onMouseOut(e);
              }, this._onMouseOver = function (e) {
                return t.onMouseOver(e);
              }, this._onMouseWheel = function (e) {
                return t.onMouseWheel(e);
              };
              var e = this.game.canvas;
              e.addEventListener("mousedown", this._onMouseDown, !0), e.addEventListener("mousemove", this._onMouseMove, !0), e.addEventListener("mouseup", this._onMouseUp, !0), this.game.device.cocoonJS || (window.addEventListener("mouseup", this._onMouseUpGlobal, !0), window.addEventListener("mouseout", this._onMouseOutGlobal, !0), e.addEventListener("mouseover", this._onMouseOver, !0), e.addEventListener("mouseout", this._onMouseOut, !0));
              var i = this.game.device.wheelEvent;
              i && (e.addEventListener(i, this._onMouseWheel, !0), "mousewheel" === i ? this._wheelEvent = new o(-.025, 1) : "DOMMouseScroll" === i && (this._wheelEvent = new o(1, 1)));
            }
          },
          onMouseDown: function onMouseDown(t) {
            this.event = t, this.capture && t.preventDefault(), this.mouseDownCallback && this.mouseDownCallback.call(this.callbackContext, t), this.input.enabled && this.enabled && (t.identifier = 0, this.input.mousePointer.start(t));
          },
          onMouseMove: function onMouseMove(t) {
            this.event = t, this.capture && t.preventDefault(), this.mouseMoveCallback && this.mouseMoveCallback.call(this.callbackContext, t), this.input.enabled && this.enabled && (t.identifier = 0, this.input.mousePointer.move(t));
          },
          onMouseUp: function onMouseUp(t) {
            this.event = t, this.capture && t.preventDefault(), this.mouseUpCallback && this.mouseUpCallback.call(this.callbackContext, t), this.input.enabled && this.enabled && (t.identifier = 0, this.input.mousePointer.stop(t));
          },
          onMouseUpGlobal: function onMouseUpGlobal(t) {
            this.input.mousePointer.withinGame || (this.mouseUpCallback && this.mouseUpCallback.call(this.callbackContext, t), t.identifier = 0, this.input.mousePointer.stop(t));
          },
          onMouseOutGlobal: function onMouseOutGlobal(t) {
            this.event = t, this.capture && t.preventDefault(), this.input.mousePointer.withinGame = !1, this.input.enabled && this.enabled && (this.input.mousePointer.stop(t), this.input.mousePointer.resetButtons());
          },
          onMouseOut: function onMouseOut(t) {
            if (this.event = t, this.capture && t.preventDefault(), this.input.mousePointer.withinGame = !1, this.mouseOutCallback && this.mouseOutCallback.call(this.callbackContext, t), this.input.enabled && this.enabled) for (var e in this.stopOnGameOut && (t.identifier = 0, this.input.mousePointer.stop(t)), this.input.interactiveItems.list) {
              !0 === this.input.interactiveItems.list[e].enabled && this.input.interactiveItems.list[e]._pointerOutHandler(this.input.mousePointer);
            }
          },
          onMouseOver: function onMouseOver(t) {
            this.event = t, this.capture && t.preventDefault(), this.input.mousePointer.withinGame = !0, this.mouseOverCallback && this.mouseOverCallback.call(this.callbackContext, t);
          },
          onMouseWheel: function onMouseWheel(t) {
            this._wheelEvent && (t = this._wheelEvent.bindEvent(t)), this.event = t, this.capture && t.preventDefault(), this.wheelDelta = s.Math.clamp(-t.deltaY, -1, 1), this.mouseWheelCallback && this.mouseWheelCallback.call(this.callbackContext, t);
          },
          requestPointerLock: function requestPointerLock() {
            if (this.game.device.pointerLock) {
              var t = this.game.canvas;
              t.requestPointerLock = t.requestPointerLock || t.mozRequestPointerLock || t.webkitRequestPointerLock, t.requestPointerLock();
              var e = this;
              this._pointerLockChange = function (t) {
                return e.pointerLockChange(t);
              }, document.addEventListener("pointerlockchange", this._pointerLockChange, !0), document.addEventListener("mozpointerlockchange", this._pointerLockChange, !0), document.addEventListener("webkitpointerlockchange", this._pointerLockChange, !0);
            }
          },
          pointerLockChange: function pointerLockChange(t) {
            var e = this.game.canvas;
            document.pointerLockElement === e || document.mozPointerLockElement === e || document.webkitPointerLockElement === e ? (this.locked = !0, this.pointerLock.dispatch(!0, t)) : (this.locked = !1, this.pointerLock.dispatch(!1, t));
          },
          releasePointerLock: function releasePointerLock() {
            document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock, document.exitPointerLock(), document.removeEventListener("pointerlockchange", this._pointerLockChange, !0), document.removeEventListener("mozpointerlockchange", this._pointerLockChange, !0), document.removeEventListener("webkitpointerlockchange", this._pointerLockChange, !0);
          },
          stop: function stop() {
            var t = this.game.canvas;
            t.removeEventListener("mousedown", this._onMouseDown, !0), t.removeEventListener("mousemove", this._onMouseMove, !0), t.removeEventListener("mouseup", this._onMouseUp, !0), t.removeEventListener("mouseover", this._onMouseOver, !0), t.removeEventListener("mouseout", this._onMouseOut, !0);
            var e = this.game.device.wheelEvent;
            e && t.removeEventListener(e, this._onMouseWheel, !0), window.removeEventListener("mouseup", this._onMouseUpGlobal, !0), window.removeEventListener("mouseout", this._onMouseOutGlobal, !0), document.removeEventListener("pointerlockchange", this._pointerLockChange, !0), document.removeEventListener("mozpointerlockchange", this._pointerLockChange, !0), document.removeEventListener("webkitpointerlockchange", this._pointerLockChange, !0);
          }
        }, s.Mouse.prototype.constructor = s.Mouse, o.prototype = {}, o.prototype.constructor = o, o.prototype.bindEvent = function (t) {
          if (!o._stubsGenerated && t) {
            var e = function e(t) {
              return function () {
                var e = this.originalEvent[t];
                return "function" != typeof e ? e : e.bind(this.originalEvent);
              };
            };

            for (var i in t) {
              i in o.prototype || Object.defineProperty(o.prototype, i, {
                get: e(i)
              });
            }

            o._stubsGenerated = !0;
          }

          return this.originalEvent = t, this;
        }, Object.defineProperties(o.prototype, {
          type: {
            value: "wheel"
          },
          deltaMode: {
            get: function get() {
              return this._deltaMode;
            }
          },
          deltaY: {
            get: function get() {
              return this._scaleFactor * (this.originalEvent.wheelDelta || this.originalEvent.detail) || 0;
            }
          },
          deltaX: {
            get: function get() {
              return this._scaleFactor * this.originalEvent.wheelDeltaX || 0;
            }
          },
          deltaZ: {
            value: 0
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.MSPointer = function (t) {
          this.game = t, this.input = t.input, this.callbackContext = this.game, this.pointerDownCallback = null, this.pointerMoveCallback = null, this.pointerUpCallback = null, this.capture = !0, this.button = -1, this.event = null, this.enabled = !0, this._onMSPointerDown = null, this._onMSPointerMove = null, this._onMSPointerUp = null, this._onMSPointerUpGlobal = null, this._onMSPointerOut = null, this._onMSPointerOver = null;
        }, s.MSPointer.prototype = {
          start: function start() {
            if (null === this._onMSPointerDown) {
              var t = this;

              if (this.game.device.mspointer) {
                this._onMSPointerDown = function (e) {
                  return t.onPointerDown(e);
                }, this._onMSPointerMove = function (e) {
                  return t.onPointerMove(e);
                }, this._onMSPointerUp = function (e) {
                  return t.onPointerUp(e);
                }, this._onMSPointerUpGlobal = function (e) {
                  return t.onPointerUpGlobal(e);
                }, this._onMSPointerOut = function (e) {
                  return t.onPointerOut(e);
                }, this._onMSPointerOver = function (e) {
                  return t.onPointerOver(e);
                };
                var e = this.game.canvas;
                e.addEventListener("MSPointerDown", this._onMSPointerDown, !1), e.addEventListener("MSPointerMove", this._onMSPointerMove, !1), e.addEventListener("MSPointerUp", this._onMSPointerUp, !1), e.addEventListener("pointerdown", this._onMSPointerDown, !1), e.addEventListener("pointermove", this._onMSPointerMove, !1), e.addEventListener("pointerup", this._onMSPointerUp, !1), e.style["-ms-content-zooming"] = "none", e.style["-ms-touch-action"] = "none", this.game.device.cocoonJS || (window.addEventListener("MSPointerUp", this._onMSPointerUpGlobal, !0), e.addEventListener("MSPointerOver", this._onMSPointerOver, !0), e.addEventListener("MSPointerOut", this._onMSPointerOut, !0), window.addEventListener("pointerup", this._onMSPointerUpGlobal, !0), e.addEventListener("pointerover", this._onMSPointerOver, !0), e.addEventListener("pointerout", this._onMSPointerOut, !0));
              }
            }
          },
          onPointerDown: function onPointerDown(t) {
            this.game.input.executeTouchLockCallbacks(!1, t), this.event = t, this.capture && t.preventDefault(), this.pointerDownCallback && this.pointerDownCallback.call(this.callbackContext, t), this.input.enabled && this.enabled && (t.identifier = t.pointerId, "mouse" === t.pointerType || 4 === t.pointerType ? this.input.mousePointer.start(t) : this.input.startPointer(t));
          },
          onPointerMove: function onPointerMove(t) {
            this.event = t, this.capture && t.preventDefault(), this.pointerMoveCallback && this.pointerMoveCallback.call(this.callbackContext, t), this.input.enabled && this.enabled && (t.identifier = t.pointerId, "mouse" === t.pointerType || 4 === t.pointerType ? this.input.mousePointer.move(t) : this.input.updatePointer(t));
          },
          onPointerUp: function onPointerUp(t) {
            this.game.input.executeTouchLockCallbacks(!0, t), this.event = t, this.capture && t.preventDefault(), this.pointerUpCallback && this.pointerUpCallback.call(this.callbackContext, t), this.input.enabled && this.enabled && (t.identifier = t.pointerId, "mouse" === t.pointerType || 4 === t.pointerType ? this.input.mousePointer.stop(t) : this.input.stopPointer(t));
          },
          onPointerUpGlobal: function onPointerUpGlobal(t) {
            if ("mouse" !== t.pointerType && 4 !== t.pointerType || this.input.mousePointer.withinGame) {
              var e = this.input.getPointerFromIdentifier(t.identifier);
              e && e.withinGame && this.onPointerUp(t);
            } else this.onPointerUp(t);
          },
          onPointerOut: function onPointerOut(t) {
            if (this.event = t, this.capture && t.preventDefault(), "mouse" === t.pointerType || 4 === t.pointerType) this.input.mousePointer.withinGame = !1;else {
              var e = this.input.getPointerFromIdentifier(t.identifier);
              e && (e.withinGame = !1);
            }
            this.input.mouse.mouseOutCallback && this.input.mouse.mouseOutCallback.call(this.input.mouse.callbackContext, t), this.input.enabled && this.enabled && this.input.mouse.stopOnGameOut && (t.identifier = 0, e ? e.stop(t) : this.input.mousePointer.stop(t));
          },
          onPointerOver: function onPointerOver(t) {
            if (this.event = t, this.capture && t.preventDefault(), "mouse" === t.pointerType || 4 === t.pointerType) this.input.mousePointer.withinGame = !0;else {
              var e = this.input.getPointerFromIdentifier(t.identifier);
              e && (e.withinGame = !0);
            }
            this.input.mouse.mouseOverCallback && this.input.mouse.mouseOverCallback.call(this.input.mouse.callbackContext, t);
          },
          stop: function stop() {
            var t = this.game.canvas;
            t.removeEventListener("MSPointerDown", this._onMSPointerDown, !1), t.removeEventListener("MSPointerMove", this._onMSPointerMove, !1), t.removeEventListener("MSPointerUp", this._onMSPointerUp, !1), t.removeEventListener("pointerdown", this._onMSPointerDown, !1), t.removeEventListener("pointermove", this._onMSPointerMove, !1), t.removeEventListener("pointerup", this._onMSPointerUp, !1), window.removeEventListener("MSPointerUp", this._onMSPointerUpGlobal, !0), t.removeEventListener("MSPointerOver", this._onMSPointerOver, !0), t.removeEventListener("MSPointerOut", this._onMSPointerOut, !0), window.removeEventListener("pointerup", this._onMSPointerUpGlobal, !0), t.removeEventListener("pointerover", this._onMSPointerOver, !0), t.removeEventListener("pointerout", this._onMSPointerOut, !0);
          }
        }, s.MSPointer.prototype.constructor = s.MSPointer,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @author       @karlmacklin <tacklemcclean@gmail.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.DeviceButton = function (t, e) {
          this.parent = t, this.game = t.game, this.event = null, this.isDown = !1, this.isUp = !0, this.timeDown = 0, this.timeUp = 0, this.repeats = 0, this.altKey = !1, this.shiftKey = !1, this.ctrlKey = !1, this.value = 0, this.buttonCode = e, this.onDown = new s.Signal(), this.onUp = new s.Signal(), this.onFloat = new s.Signal();
        }, s.DeviceButton.prototype = {
          start: function start(t, e) {
            this.isDown || (this.isDown = !0, this.isUp = !1, this.timeDown = this.game.time.time, this.repeats = 0, this.event = t, this.value = e, t && (this.altKey = t.altKey, this.shiftKey = t.shiftKey, this.ctrlKey = t.ctrlKey), this.onDown.dispatch(this, e));
          },
          stop: function stop(t, e) {
            this.isUp || (this.isDown = !1, this.isUp = !0, this.timeUp = this.game.time.time, this.event = t, this.value = e, t && (this.altKey = t.altKey, this.shiftKey = t.shiftKey, this.ctrlKey = t.ctrlKey), this.onUp.dispatch(this, e));
          },
          startStop: function startStop(t, e, i) {
            t ? this.start(e, i) : this.stop(e, i);
          },
          padFloat: function padFloat(t) {
            this.isDown = !1, this.isUp = !1, this.value = t, this.onFloat.dispatch(this, t);
          },
          justPressed: function justPressed(t) {
            return t = t || 250, this.isDown && this.timeDown + t > this.game.time.time;
          },
          justReleased: function justReleased(t) {
            return t = t || 250, this.isUp && this.timeUp + t > this.game.time.time;
          },
          reset: function reset() {
            this.isDown = !1, this.isUp = !0, this.timeDown = this.game.time.time, this.repeats = 0, this.altKey = !1, this.shiftKey = !1, this.ctrlKey = !1;
          },
          destroy: function destroy() {
            this.onDown.dispose(), this.onUp.dispose(), this.onFloat.dispose(), this.parent = null, this.game = null;
          }
        }, s.DeviceButton.prototype.constructor = s.DeviceButton, Object.defineProperty(s.DeviceButton.prototype, "duration", {
          get: function get() {
            return this.isUp ? -1 : this.game.time.time - this.timeDown;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Pointer = function (t, e, i) {
          this.game = t, this.id = e, this.type = s.POINTER, this.exists = !0, this.identifier = 0, this.pointerId = null, this.pointerMode = i || s.PointerMode.CURSOR | s.PointerMode.CONTACT, this.target = null, this.button = null, this.leftButton = new s.DeviceButton(this, s.Pointer.LEFT_BUTTON), this.middleButton = new s.DeviceButton(this, s.Pointer.MIDDLE_BUTTON), this.rightButton = new s.DeviceButton(this, s.Pointer.RIGHT_BUTTON), this.backButton = new s.DeviceButton(this, s.Pointer.BACK_BUTTON), this.forwardButton = new s.DeviceButton(this, s.Pointer.FORWARD_BUTTON), this.eraserButton = new s.DeviceButton(this, s.Pointer.ERASER_BUTTON), this._holdSent = !1, this._history = [], this._nextDrop = 0, this._stateReset = !1, this.withinGame = !1, this.clientX = -1, this.clientY = -1, this.pageX = -1, this.pageY = -1, this.screenX = -1, this.screenY = -1, this.rawMovementX = 0, this.rawMovementY = 0, this.movementX = 0, this.movementY = 0, this.x = -1, this.y = -1, this.isMouse = 0 === e, this.isDown = !1, this.isUp = !0, this.timeDown = 0, this.timeUp = 0, this.previousTapTime = 0, this.totalTouches = 0, this.msSinceLastClick = Number.MAX_VALUE, this.targetObject = null, this.interactiveCandidates = [], this.active = !1, this.dirty = !1, this.position = new s.Point(), this.positionDown = new s.Point(), this.positionUp = new s.Point(), this.circle = new s.Circle(0, 0, 44), this._clickTrampolines = null, this._trampolineTargetObject = null;
        }, s.Pointer.NO_BUTTON = 0, s.Pointer.LEFT_BUTTON = 1, s.Pointer.RIGHT_BUTTON = 2, s.Pointer.MIDDLE_BUTTON = 4, s.Pointer.BACK_BUTTON = 8, s.Pointer.FORWARD_BUTTON = 16, s.Pointer.ERASER_BUTTON = 32, s.Pointer.prototype = {
          resetButtons: function resetButtons() {
            this.isDown = !1, this.isUp = !0, this.isMouse && (this.leftButton.reset(), this.middleButton.reset(), this.rightButton.reset(), this.backButton.reset(), this.forwardButton.reset(), this.eraserButton.reset());
          },
          processButtonsDown: function processButtonsDown(t, e) {
            t === s.Mouse.LEFT_BUTTON && this.leftButton.start(e), t === s.Mouse.RIGHT_BUTTON && this.rightButton.start(e), t === s.Mouse.MIDDLE_BUTTON && this.middleButton.start(e), t === s.Mouse.BACK_BUTTON && this.backButton.start(e), t === s.Mouse.FORWARD_BUTTON && this.forwardButton.start(e);
          },
          processButtonsUp: function processButtonsUp(t, e) {
            t === s.Mouse.LEFT_BUTTON && this.leftButton.stop(e), t === s.Mouse.RIGHT_BUTTON && this.rightButton.stop(e), t === s.Mouse.MIDDLE_BUTTON && this.middleButton.stop(e), t === s.Mouse.BACK_BUTTON && this.backButton.stop(e), t === s.Mouse.FORWARD_BUTTON && this.forwardButton.stop(e);
          },
          processButtonsUpDown: function processButtonsUpDown(t, e) {
            var i = "down" === e.type.toLowerCase().substr(-4),
                n = "move" === e.type.toLowerCase().substr(-4);
            void 0 !== t ? (i && 1 === t && e.ctrlKey && (t = 2), this.leftButton.startStop(s.Pointer.LEFT_BUTTON & t, e), this.rightButton.startStop(s.Pointer.RIGHT_BUTTON & t, e), this.middleButton.startStop(s.Pointer.MIDDLE_BUTTON & t, e), this.backButton.startStop(s.Pointer.BACK_BUTTON & t, e), this.forwardButton.startStop(s.Pointer.FORWARD_BUTTON & t, e), this.eraserButton.startStop(s.Pointer.ERASER_BUTTON & t, e)) : void 0 !== e.button ? i && e.ctrlKey && 0 === e.button ? this.rightButton.start(e) : i ? this.processButtonsDown(e.button, e) : n || this.processButtonsUp(e.button, e) : i ? e.ctrlKey ? this.rightButton.start(e) : this.leftButton.start(e) : (this.leftButton.stop(e), this.rightButton.stop(e));
          },
          updateButtons: function updateButtons(t) {
            this.button = t.button, this.processButtonsUpDown(t.buttons, t), this.isUp = !0, this.isDown = !1, (this.leftButton.isDown || this.rightButton.isDown || this.middleButton.isDown || this.backButton.isDown || this.forwardButton.isDown || this.eraserButton.isDown) && (this.isUp = !1, this.isDown = !0);
          },
          start: function start(t) {
            var e = this.game.input;
            return t.pointerId && (this.pointerId = t.pointerId), this.identifier = t.identifier, this.target = t.target, this.isMouse ? this.updateButtons(t) : (this.isDown = !0, this.isUp = !1), this.active = !0, this.withinGame = !0, this.dirty = !1, this._history = [], this._clickTrampolines = null, this._trampolineTargetObject = null, this.msSinceLastClick = this.game.time.time - this.timeDown, this.timeDown = this.game.time.time, this._holdSent = !1, this.move(t, !0), this.positionDown.setTo(this.x, this.y), (e.multiInputOverride === s.Input.MOUSE_OVERRIDES_TOUCH || e.multiInputOverride === s.Input.MOUSE_TOUCH_COMBINE || e.multiInputOverride === s.Input.TOUCH_OVERRIDES_MOUSE && 0 === e.totalActivePointers) && (e.x = this.x, e.y = this.y, e.position.setTo(this.x, this.y), e.onDown.dispatch(this, t), e.resetSpeed(this.x, this.y)), this._stateReset = !1, this.totalTouches++, null !== this.targetObject && this.targetObject._touchedHandler(this), this;
          },
          update: function update() {
            var t = this.game.input;
            this.active && (this.dirty && (t.interactiveItems.total > 0 && this.processInteractiveObjects(!1), this.dirty = !1), !1 === this._holdSent && this.duration >= t.holdRate && ((t.multiInputOverride === s.Input.MOUSE_OVERRIDES_TOUCH || t.multiInputOverride === s.Input.MOUSE_TOUCH_COMBINE || t.multiInputOverride === s.Input.TOUCH_OVERRIDES_MOUSE && 0 === t.totalActivePointers) && t.onHold.dispatch(this), this._holdSent = !0), t.recordPointerHistory && this.game.time.time >= this._nextDrop && (this._nextDrop = this.game.time.time + t.recordRate, this._history.push({
              x: this.position.x,
              y: this.position.y
            }), this._history.length > t.recordLimit && this._history.shift()));
          },
          move: function move(t, e) {
            var i = this.game.input;

            if (!i.pollLocked) {
              void 0 === e && (e = !1), void 0 !== t.button && (this.button = t.button), this.isMouse && this.updateButtons(t), this.clientX = t.clientX, this.clientY = t.clientY, this.pageX = t.pageX, this.pageY = t.pageY, this.screenX = t.screenX, this.screenY = t.screenY, this.isMouse && i.mouse.locked && !e && (this.rawMovementX = t.movementX || t.mozMovementX || t.webkitMovementX || 0, this.rawMovementY = t.movementY || t.mozMovementY || t.webkitMovementY || 0, this.movementX += this.rawMovementX, this.movementY += this.rawMovementY), this.x = (this.pageX - this.game.scale.offset.x) * i.scale.x, this.y = (this.pageY - this.game.scale.offset.y) * i.scale.y, this.position.setTo(this.x, this.y), this.circle.x = this.x, this.circle.y = this.y, (i.multiInputOverride === s.Input.MOUSE_OVERRIDES_TOUCH || i.multiInputOverride === s.Input.MOUSE_TOUCH_COMBINE || i.multiInputOverride === s.Input.TOUCH_OVERRIDES_MOUSE && 0 === i.totalActivePointers) && (i.activePointer = this, i.x = this.x, i.y = this.y, i.position.setTo(i.x, i.y), i.circle.x = i.x, i.circle.y = i.y), this.withinGame = this.game.scale.bounds.contains(this.pageX, this.pageY);

              for (var n = i.moveCallbacks.length; n--;) {
                i.moveCallbacks[n].callback.call(i.moveCallbacks[n].context, this, this.x, this.y, e, t);
              }

              return null === this.targetObject || this.game.paused && !this.targetObject.noPause || !0 !== this.targetObject.isDragged ? i.interactiveItems.total > 0 && this.processInteractiveObjects(e) : !1 === this.targetObject.update(this) && (this.targetObject = null), this;
            }
          },
          processInteractiveObjects: function processInteractiveObjects(t) {
            var e = 0,
                i = -1,
                s = null,
                n = this.game.input.interactiveItems.first;

            for (this.interactiveCandidates = []; n;) {
              n.checked = !1, !n.validForInput(i, e, !1) || this.game.paused && !n.sprite.noPause || (n.checked = !0, (t && n.checkPointerDown(this, !0) || !t && n.checkPointerOver(this, !0)) && (e = n.sprite.renderOrderID, i = n.priorityID, s = n, this.interactiveCandidates.push(n))), n = this.game.input.interactiveItems.next;
            }

            for (n = this.game.input.interactiveItems.first; n;) {
              !n.checked && n.validForInput(i, e, !0) && (t && n.checkPointerDown(this, !1) || !t && n.checkPointerOver(this, !1)) && (e = n.sprite.renderOrderID, i = n.priorityID, s = n, this.interactiveCandidates.push(n)), n = this.game.input.interactiveItems.next;
            }

            return this.game.input.customCandidateHandler && (s = this.game.input.customCandidateHandler.call(this.game.input.customCandidateHandlerContext, this, this.interactiveCandidates, s)), this.swapTarget(s, !1), null !== this.targetObject;
          },
          swapTarget: function swapTarget(t, e) {
            void 0 === e && (e = !1), null === t ? this.targetObject && (this.targetObject._pointerOutHandler(this, e), this.targetObject = null) : null === this.targetObject ? (this.targetObject = t, t._pointerOverHandler(this, e)) : this.targetObject === t ? !1 === t.update(this) && (this.targetObject = null) : (this.targetObject._pointerOutHandler(this, e), this.targetObject = t, this.targetObject._pointerOverHandler(this, e));
          },
          leave: function leave(t) {
            this.withinGame = !1, this.move(t, !1);
          },
          stop: function stop(t) {
            var e = this.game.input;
            if (!this._stateReset || !this.withinGame) return this.timeUp = this.game.time.time, (e.multiInputOverride === s.Input.MOUSE_OVERRIDES_TOUCH || e.multiInputOverride === s.Input.MOUSE_TOUCH_COMBINE || e.multiInputOverride === s.Input.TOUCH_OVERRIDES_MOUSE && 0 === e.totalActivePointers) && (e.onUp.dispatch(this, t), this.duration >= 0 && this.duration <= e.tapRate && (this.timeUp - this.previousTapTime < e.doubleTapRate ? e.onTap.dispatch(this, !0) : e.onTap.dispatch(this, !1), this.previousTapTime = this.timeUp)), this.isMouse ? this.updateButtons(t) : (this.isDown = !1, this.isUp = !0), this.id > 0 && (this.active = !1), this.withinGame = this.game.scale.bounds.contains(t.pageX, t.pageY), this.pointerId = null, this.identifier = null, this.positionUp.setTo(this.x, this.y), !1 === this.isMouse && e.currentPointers--, e.interactiveItems.callAll("_releasedHandler", this), this._clickTrampolines && (this._trampolineTargetObject = this.targetObject), this.targetObject = null, this;
            t.preventDefault();
          },
          justPressed: function justPressed(t) {
            return t = t || this.game.input.justPressedRate, !0 === this.isDown && this.timeDown + t > this.game.time.time;
          },
          justReleased: function justReleased(t) {
            return t = t || this.game.input.justReleasedRate, this.isUp && this.timeUp + t > this.game.time.time;
          },
          addClickTrampoline: function addClickTrampoline(t, e, i, s) {
            if (this.isDown) {
              for (var n = this._clickTrampolines = this._clickTrampolines || [], o = 0; o < n.length; o++) {
                if (n[o].name === t) {
                  n.splice(o, 1);
                  break;
                }
              }

              n.push({
                name: t,
                targetObject: this.targetObject,
                callback: e,
                callbackContext: i,
                callbackArgs: s
              });
            }
          },
          processClickTrampolines: function processClickTrampolines() {
            var t = this._clickTrampolines;

            if (t) {
              for (var e = 0; e < t.length; e++) {
                var i = t[e];
                i.targetObject === this._trampolineTargetObject && i.callback.apply(i.callbackContext, i.callbackArgs);
              }

              this._clickTrampolines = null, this._trampolineTargetObject = null;
            }
          },
          reset: function reset() {
            !1 === this.isMouse && (this.active = !1), this.pointerId = null, this.identifier = null, this.dirty = !1, this.totalTouches = 0, this._holdSent = !1, this._history.length = 0, this._stateReset = !0, this.resetButtons(), this.targetObject && this.targetObject._releasedHandler(this), this.targetObject = null;
          },
          resetMovement: function resetMovement() {
            this.movementX = 0, this.movementY = 0;
          }
        }, s.Pointer.prototype.constructor = s.Pointer, Object.defineProperty(s.Pointer.prototype, "duration", {
          get: function get() {
            return this.isUp ? -1 : this.game.time.time - this.timeDown;
          }
        }), Object.defineProperty(s.Pointer.prototype, "worldX", {
          get: function get() {
            return this.game.world.camera.x + this.x;
          }
        }), Object.defineProperty(s.Pointer.prototype, "worldY", {
          get: function get() {
            return this.game.world.camera.y + this.y;
          }
        }), s.PointerMode = {
          CURSOR: 1,
          CONTACT: 2
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Touch = function (t) {
          this.game = t, this.enabled = !0, this.callbackContext = this.game, this.touchStartCallback = null, this.touchMoveCallback = null, this.touchEndCallback = null, this.touchEnterCallback = null, this.touchLeaveCallback = null, this.touchCancelCallback = null, this.preventDefault = !0, this.event = null, this._onTouchStart = null, this._onTouchMove = null, this._onTouchEnd = null, this._onTouchEnter = null, this._onTouchLeave = null, this._onTouchCancel = null, this._onTouchMove = null;
        }, s.Touch.prototype = {
          start: function start() {
            if (null === this._onTouchStart) {
              var t = this;
              this.game.device.touch && (this._onTouchStart = function (e) {
                return t.onTouchStart(e);
              }, this._onTouchMove = function (e) {
                return t.onTouchMove(e);
              }, this._onTouchEnd = function (e) {
                return t.onTouchEnd(e);
              }, this._onTouchEnter = function (e) {
                return t.onTouchEnter(e);
              }, this._onTouchLeave = function (e) {
                return t.onTouchLeave(e);
              }, this._onTouchCancel = function (e) {
                return t.onTouchCancel(e);
              }, this.game.canvas.addEventListener("touchstart", this._onTouchStart, !1), this.game.canvas.addEventListener("touchmove", this._onTouchMove, !1), this.game.canvas.addEventListener("touchend", this._onTouchEnd, !1), this.game.canvas.addEventListener("touchcancel", this._onTouchCancel, !1), this.game.device.cocoonJS || (this.game.canvas.addEventListener("touchenter", this._onTouchEnter, !1), this.game.canvas.addEventListener("touchleave", this._onTouchLeave, !1)));
            }
          },
          consumeDocumentTouches: function consumeDocumentTouches() {
            this._documentTouchMove = function (t) {
              t.preventDefault();
            }, document.addEventListener("touchmove", this._documentTouchMove, !1);
          },
          onTouchStart: function onTouchStart(t) {
            if (this.game.input.executeTouchLockCallbacks(!1, t), this.event = t, this.game.input.enabled && this.enabled) {
              this.touchStartCallback && this.touchStartCallback.call(this.callbackContext, t), this.preventDefault && t.preventDefault();

              for (var e = 0; e < t.changedTouches.length; e++) {
                this.game.input.startPointer(t.changedTouches[e]);
              }
            }
          },
          onTouchCancel: function onTouchCancel(t) {
            if (this.event = t, this.touchCancelCallback && this.touchCancelCallback.call(this.callbackContext, t), this.game.input.enabled && this.enabled) {
              this.preventDefault && t.preventDefault();

              for (var e = 0; e < t.changedTouches.length; e++) {
                this.game.input.stopPointer(t.changedTouches[e]);
              }
            }
          },
          onTouchEnter: function onTouchEnter(t) {
            this.event = t, this.touchEnterCallback && this.touchEnterCallback.call(this.callbackContext, t), this.game.input.enabled && this.enabled && this.preventDefault && t.preventDefault();
          },
          onTouchLeave: function onTouchLeave(t) {
            this.event = t, this.touchLeaveCallback && this.touchLeaveCallback.call(this.callbackContext, t), this.preventDefault && t.preventDefault();
          },
          onTouchMove: function onTouchMove(t) {
            this.event = t, this.touchMoveCallback && this.touchMoveCallback.call(this.callbackContext, t), this.preventDefault && t.preventDefault();

            for (var e = 0; e < t.changedTouches.length; e++) {
              this.game.input.updatePointer(t.changedTouches[e]);
            }
          },
          onTouchEnd: function onTouchEnd(t) {
            this.game.input.executeTouchLockCallbacks(!0, t), this.event = t, this.touchEndCallback && this.touchEndCallback.call(this.callbackContext, t), this.preventDefault && t.preventDefault();

            for (var e = 0; e < t.changedTouches.length; e++) {
              this.game.input.stopPointer(t.changedTouches[e]);
            }
          },
          stop: function stop() {
            this.game.device.touch && (this.game.canvas.removeEventListener("touchstart", this._onTouchStart), this.game.canvas.removeEventListener("touchmove", this._onTouchMove), this.game.canvas.removeEventListener("touchend", this._onTouchEnd), this.game.canvas.removeEventListener("touchenter", this._onTouchEnter), this.game.canvas.removeEventListener("touchleave", this._onTouchLeave), this.game.canvas.removeEventListener("touchcancel", this._onTouchCancel));
          }
        }, s.Touch.prototype.constructor = s.Touch,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.InputHandler = function (t) {
          this.sprite = t, this.game = t.game, this.enabled = !1, this.checked = !1, this.priorityID = 0, this.useHandCursor = !1, this._setHandCursor = !1, this.isDragged = !1, this.allowHorizontalDrag = !0, this.allowVerticalDrag = !0, this.bringToTop = !1, this.snapOffset = null, this.snapOnDrag = !1, this.snapOnRelease = !1, this.snapX = 0, this.snapY = 0, this.snapOffsetX = 0, this.snapOffsetY = 0, this.pixelPerfectOver = !1, this.pixelPerfectClick = !1, this.pixelPerfectAlpha = 255, this.draggable = !1, this.boundsRect = null, this.boundsSprite = null, this.scaleLayer = !1, this.dragOffset = new s.Point(), this.dragFromCenter = !1, this.dragStopBlocksInputUp = !1, this.dragStartPoint = new s.Point(), this.dragDistanceThreshold = 0, this.dragTimeThreshold = 0, this.downPoint = new s.Point(), this.snapPoint = new s.Point(), this._dragPoint = new s.Point(), this._dragPhase = !1, this._pendingDrag = !1, this._dragTimePass = !1, this._dragDistancePass = !1, this._wasEnabled = !1, this._tempPoint = new s.Point(), this._pointerData = [], this._pointerData.push({
            id: 0,
            x: 0,
            y: 0,
            camX: 0,
            camY: 0,
            isDown: !1,
            isUp: !1,
            isOver: !1,
            isOut: !1,
            timeOver: 0,
            timeOut: 0,
            timeDown: 0,
            timeUp: 0,
            downDuration: 0,
            isDragged: !1
          });
        }, s.InputHandler.prototype = {
          start: function start(t, e) {
            if (t = t || 0, void 0 === e && (e = !1), !1 === this.enabled) {
              this.game.input.interactiveItems.add(this), this.useHandCursor = e, this.priorityID = t;

              for (var i = 0; i < 10; i++) {
                this._pointerData[i] = {
                  id: i,
                  x: 0,
                  y: 0,
                  isDown: !1,
                  isUp: !1,
                  isOver: !1,
                  isOut: !1,
                  timeOver: 0,
                  timeOut: 0,
                  timeDown: 0,
                  timeUp: 0,
                  downDuration: 0,
                  isDragged: !1
                };
              }

              this.snapOffset = new s.Point(), this.enabled = !0, this._wasEnabled = !0;
            }

            return this.sprite.events.onAddedToGroup.add(this.addedToGroup, this), this.sprite.events.onRemovedFromGroup.add(this.removedFromGroup, this), this.sprite;
          },
          addedToGroup: function addedToGroup() {
            this._dragPhase || this._wasEnabled && !this.enabled && this.start();
          },
          removedFromGroup: function removedFromGroup() {
            this._dragPhase || (this.enabled ? (this._wasEnabled = !0, this.stop()) : this._wasEnabled = !1);
          },
          reset: function reset() {
            this.enabled = !1;

            for (var t = 0; t < 10; t++) {
              this._pointerData[t] = {
                id: t,
                x: 0,
                y: 0,
                isDown: !1,
                isUp: !1,
                isOver: !1,
                isOut: !1,
                timeOver: 0,
                timeOut: 0,
                timeDown: 0,
                timeUp: 0,
                downDuration: 0,
                isDragged: !1
              };
            }
          },
          stop: function stop() {
            !1 !== this.enabled && (this.enabled = !1, this.game.input.interactiveItems.remove(this));
          },
          destroy: function destroy() {
            this.sprite && (this._setHandCursor && (this.game.canvas.style.cursor = "", this._setHandCursor = !1), this.enabled = !1, this.game.input.interactiveItems.remove(this), this._pointerData.length = 0, this.boundsRect = null, this.boundsSprite = null, this.sprite = null);
          },
          validForInput: function validForInput(t, e, i) {
            return void 0 === i && (i = !0), !(!this.enabled || 0 === this.sprite.scale.x || 0 === this.sprite.scale.y || this.priorityID < this.game.input.minPriorityID || this.sprite.parent && this.sprite.parent.ignoreChildInput) && !(!i && (this.pixelPerfectClick || this.pixelPerfectOver)) && (this.priorityID > t || this.priorityID === t && this.sprite.renderOrderID > e);
          },
          isPixelPerfect: function isPixelPerfect() {
            return this.pixelPerfectClick || this.pixelPerfectOver;
          },
          pointerX: function pointerX(t) {
            return t = t || 0, this._pointerData[t].x;
          },
          pointerY: function pointerY(t) {
            return t = t || 0, this._pointerData[t].y;
          },
          pointerDown: function pointerDown(t) {
            return t = t || 0, this._pointerData[t].isDown;
          },
          pointerUp: function pointerUp(t) {
            return t = t || 0, this._pointerData[t].isUp;
          },
          pointerTimeDown: function pointerTimeDown(t) {
            return t = t || 0, this._pointerData[t].timeDown;
          },
          pointerTimeUp: function pointerTimeUp(t) {
            return t = t || 0, this._pointerData[t].timeUp;
          },
          pointerOver: function pointerOver(t) {
            if (!this.enabled) return !1;

            if (void 0 === t) {
              for (var e = 0; e < 10; e++) {
                if (this._pointerData[e].isOver) return !0;
              }

              return !1;
            }

            return this._pointerData[t].isOver;
          },
          pointerOut: function pointerOut(t) {
            if (!this.enabled) return !1;
            if (void 0 !== t) return this._pointerData[t].isOut;

            for (var e = 0; e < 10; e++) {
              if (this._pointerData[e].isOut) return !0;
            }
          },
          pointerTimeOver: function pointerTimeOver(t) {
            return t = t || 0, this._pointerData[t].timeOver;
          },
          pointerTimeOut: function pointerTimeOut(t) {
            return t = t || 0, this._pointerData[t].timeOut;
          },
          pointerDragged: function pointerDragged(t) {
            return t = t || 0, this._pointerData[t].isDragged;
          },
          checkPointerDown: function checkPointerDown(t, e) {
            return !!(t.isDown && this.enabled && this.sprite && this.sprite.parent && this.sprite.visible && this.sprite.parent.visible && 0 !== this.sprite.worldScale.x && 0 !== this.sprite.worldScale.y) && !!this.game.input.hitTest(this.sprite, t, this._tempPoint) && (void 0 === e && (e = !1), !(!e && this.pixelPerfectClick) || this.checkPixel(this._tempPoint.x, this._tempPoint.y));
          },
          checkPointerOver: function checkPointerOver(t, e) {
            return !!(this.enabled && this.sprite && this.sprite.parent && this.sprite.visible && this.sprite.parent.visible && 0 !== this.sprite.worldScale.x && 0 !== this.sprite.worldScale.y) && !!this.game.input.hitTest(this.sprite, t, this._tempPoint) && (void 0 === e && (e = !1), !(!e && this.pixelPerfectOver) || this.checkPixel(this._tempPoint.x, this._tempPoint.y));
          },
          checkPixel: function checkPixel(t, e, i) {
            if (this.sprite.texture.baseTexture.source) {
              if (null === t && null === e) {
                this.game.input.getLocalPosition(this.sprite, i, this._tempPoint);
                t = this._tempPoint.x, e = this._tempPoint.y;
              }

              if (0 !== this.sprite.anchor.x && (t -= -this.sprite.texture.frame.width * this.sprite.anchor.x), 0 !== this.sprite.anchor.y && (e -= -this.sprite.texture.frame.height * this.sprite.anchor.y), t += this.sprite.texture.frame.x, e += this.sprite.texture.frame.y, this.sprite.texture.trim && (t -= this.sprite.texture.trim.x, e -= this.sprite.texture.trim.y, t < this.sprite.texture.crop.x || t > this.sprite.texture.crop.right || e < this.sprite.texture.crop.y || e > this.sprite.texture.crop.bottom)) return this._dx = t, this._dy = e, !1;
              if (this._dx = t, this._dy = e, this.game.input.hitContext.clearRect(0, 0, 1, 1), this.game.input.hitContext.drawImage(this.sprite.texture.baseTexture.source, t, e, 1, 1, 0, 0, 1, 1), this.game.input.hitContext.getImageData(0, 0, 1, 1).data[3] >= this.pixelPerfectAlpha) return !0;
            }

            return !1;
          },
          update: function update(t) {
            if (null !== this.sprite && void 0 !== this.sprite.parent) return this.enabled && this.sprite.visible && this.sprite.parent.visible ? this._pendingDrag ? (this._dragDistancePass || (this._dragDistancePass = s.Math.distance(t.x, t.y, this.downPoint.x, this.downPoint.y) >= this.dragDistanceThreshold), this._dragDistancePass && this._dragTimePass && this.startDrag(t), !0) : this.draggable && this._draggedPointerID === t.id ? this.updateDrag(t, !1) : this._pointerData[t.id].isOver ? this.checkPointerOver(t) ? (this._pointerData[t.id].x = t.x - this.sprite.x, this._pointerData[t.id].y = t.y - this.sprite.y, !0) : (this._pointerOutHandler(t), !1) : void 0 : (this._pointerOutHandler(t), !1);
          },
          _pointerOverHandler: function _pointerOverHandler(t, e) {
            if (null !== this.sprite) {
              var i = this._pointerData[t.id];

              if (!1 === i.isOver || t.dirty) {
                var s = !1 === i.isOver;
                i.isOver = !0, i.isOut = !1, i.timeOver = this.game.time.time, i.x = t.x - this.sprite.x, i.y = t.y - this.sprite.y, this.useHandCursor && !1 === i.isDragged && (this.game.canvas.style.cursor = "pointer", this._setHandCursor = !0), !e && s && this.sprite && this.sprite.events && this.sprite.events.onInputOver$dispatch(this.sprite, t), this.sprite.parent && this.sprite.parent.onChildInputOver && this.sprite.parent.onChildInputOver.dispatch(this.sprite, t);
              }
            }
          },
          _pointerOutHandler: function _pointerOutHandler(t, e) {
            if (null !== this.sprite) {
              var i = this._pointerData[t.id];
              i.isOver = !1, i.isOut = !0, i.timeOut = this.game.time.time, this.useHandCursor && !1 === i.isDragged && (this.game.canvas.style.cursor = "", this._setHandCursor = !1), !e && this.sprite && this.sprite.events && (this.sprite.events.onInputOut$dispatch(this.sprite, t), this.sprite && this.sprite.parent && this.sprite.parent.onChildInputOut && this.sprite.parent.onChildInputOut.dispatch(this.sprite, t));
            }
          },
          _touchedHandler: function _touchedHandler(t) {
            if (null !== this.sprite) {
              var e = this._pointerData[t.id];

              if (!e.isDown && e.isOver) {
                if (this.pixelPerfectClick && !this.checkPixel(null, null, t)) return;
                if (e.isDown = !0, e.isUp = !1, e.timeDown = this.game.time.time, this.downPoint.set(t.x, t.y), t.dirty = !0, this.sprite && this.sprite.events && (this.sprite.events.onInputDown$dispatch(this.sprite, t), this.sprite && this.sprite.parent && this.sprite.parent.onChildInputDown && this.sprite.parent.onChildInputDown.dispatch(this.sprite, t), null === this.sprite)) return;
                this.draggable && !1 === this.isDragged && (0 === this.dragTimeThreshold && 0 === this.dragDistanceThreshold ? this.startDrag(t) : (this._pendingDrag = !0, this._dragDistancePass = 0 === this.dragDistanceThreshold, this.dragTimeThreshold > 0 ? (this._dragTimePass = !1, this.game.time.events.add(this.dragTimeThreshold, this.dragTimeElapsed, this, t)) : this._dragTimePass = !0)), this.bringToTop && this.sprite.bringToTop();
              }
            }
          },
          dragTimeElapsed: function dragTimeElapsed(t) {
            this._dragTimePass = !0, this._pendingDrag && this.sprite && this._dragDistancePass && this.startDrag(t);
          },
          _releasedHandler: function _releasedHandler(t) {
            if (null !== this.sprite) {
              var e = this._pointerData[t.id];

              if (e.isDown && t.isUp) {
                e.isDown = !1, e.isUp = !0, e.timeUp = this.game.time.time, e.downDuration = e.timeUp - e.timeDown;
                var i = this.checkPointerOver(t);
                this.sprite && this.sprite.events && (this.dragStopBlocksInputUp && (!this.dragStopBlocksInputUp || this.draggable && this.isDragged && this._draggedPointerID === t.id) || this.sprite.events.onInputUp$dispatch(this.sprite, t, i), this.sprite && this.sprite.parent && this.sprite.parent.onChildInputUp && this.sprite.parent.onChildInputUp.dispatch(this.sprite, t, i), i && (i = this.checkPointerOver(t))), e.isOver = i, !i && this.useHandCursor && (this.game.canvas.style.cursor = "default", this._setHandCursor = !1), t.dirty = !0, this._pendingDrag = !1, this.draggable && this.isDragged && this._draggedPointerID === t.id && this.stopDrag(t);
              }
            }
          },
          updateDrag: function updateDrag(t, e) {
            if (void 0 === e && (e = !1), t.isUp) return this.stopDrag(t), !1;
            var i = this.globalToLocal(t);
            if (this.sprite.fixedToCamera) var s = this.game.camera.scale.x * i.x + this._dragPoint.x + this.dragOffset.x,
                n = this.game.camera.scale.y * i.y + this._dragPoint.y + this.dragOffset.y;else s = i.x + this._dragPoint.x + this.dragOffset.x, n = i.y + this._dragPoint.y + this.dragOffset.y;
            if (this.sprite.fixedToCamera) this.allowHorizontalDrag && (this.sprite.cameraOffset.x = s - this.game.camera.x), this.allowVerticalDrag && (this.sprite.cameraOffset.y = n - this.game.camera.y), this.boundsRect && this.checkBoundsRect(), this.boundsSprite && this.checkBoundsSprite(), this.snapOnDrag && (this.sprite.cameraOffset.x = Math.round((this.sprite.cameraOffset.x - this.snapOffsetX % this.snapX) / this.snapX) * this.snapX + this.snapOffsetX % this.snapX, this.sprite.cameraOffset.y = Math.round((this.sprite.cameraOffset.y - this.snapOffsetY % this.snapY) / this.snapY) * this.snapY + this.snapOffsetY % this.snapY, this.snapPoint.set(this.sprite.cameraOffset.x, this.sprite.cameraOffset.y));else {
              var o = this.game.camera.x - this._pointerData[t.id].camX,
                  r = this.game.camera.y - this._pointerData[t.id].camY;
              this.allowHorizontalDrag && (this.sprite.x = s + o), this.allowVerticalDrag && (this.sprite.y = n + r), this.boundsRect && this.checkBoundsRect(), this.boundsSprite && this.checkBoundsSprite(), this.snapOnDrag && (this.sprite.x = Math.round((this.sprite.x - this.snapOffsetX % this.snapX) / this.snapX) * this.snapX + this.snapOffsetX % this.snapX, this.sprite.y = Math.round((this.sprite.y - this.snapOffsetY % this.snapY) / this.snapY) * this.snapY + this.snapOffsetY % this.snapY, this.snapPoint.set(this.sprite.x, this.sprite.y));
            }
            return this.sprite.events.onDragUpdate.dispatch(this.sprite, t, s, n, this.snapPoint, e), !0;
          },
          justOver: function justOver(t, e) {
            return t = t || 0, e = e || 500, this._pointerData[t].isOver && this.overDuration(t) < e;
          },
          justOut: function justOut(t, e) {
            return t = t || 0, e = e || 500, this._pointerData[t].isOut && this.game.time.time - this._pointerData[t].timeOut < e;
          },
          justPressed: function justPressed(t, e) {
            return t = t || 0, e = e || 500, this._pointerData[t].isDown && this.downDuration(t) < e;
          },
          justReleased: function justReleased(t, e) {
            return t = t || 0, e = e || 500, this._pointerData[t].isUp && this.game.time.time - this._pointerData[t].timeUp < e;
          },
          overDuration: function overDuration(t) {
            return t = t || 0, this._pointerData[t].isOver ? this.game.time.time - this._pointerData[t].timeOver : -1;
          },
          downDuration: function downDuration(t) {
            return t = t || 0, this._pointerData[t].isDown ? this.game.time.time - this._pointerData[t].timeDown : -1;
          },
          enableDrag: function enableDrag(t, e, i, n, o, r) {
            void 0 === t && (t = !1), void 0 === e && (e = !1), void 0 === i && (i = !1), void 0 === n && (n = 255), void 0 === o && (o = null), void 0 === r && (r = null), this._dragPoint = new s.Point(), this.draggable = !0, this.bringToTop = e, this.dragOffset = new s.Point(), this.dragFromCenter = t, this.pixelPerfectClick = i, this.pixelPerfectAlpha = n, o && (this.boundsRect = o), r && (this.boundsSprite = r);
          },
          disableDrag: function disableDrag() {
            if (this._pointerData) for (var t = 0; t < 10; t++) {
              this._pointerData[t].isDragged = !1;
            }
            this.draggable = !1, this.isDragged = !1, this._draggedPointerID = -1, this._pendingDrag = !1;
          },
          startDrag: function startDrag(t) {
            var e = this.sprite.x,
                i = this.sprite.y,
                n = this.globalToLocal(t);

            if (this.isDragged = !0, this._draggedPointerID = t.id, this._pointerData[t.id].camX = this.game.camera.x, this._pointerData[t.id].camY = this.game.camera.y, this._pointerData[t.id].isDragged = !0, this.sprite.fixedToCamera) {
              if (this.dragFromCenter) {
                var o = this.sprite.getBounds(),
                    r = this.globalToLocal(new s.Point(o.centerX, o.centerY));
                this.sprite.cameraOffset.x = n.x + (this.sprite.cameraOffset.x - r.x), this.sprite.cameraOffset.y = n.y + (this.sprite.cameraOffset.y - r.y);
              }

              this._dragPoint.setTo(this.sprite.cameraOffset.x - t.x, this.sprite.cameraOffset.y - t.y);
            } else {
              if (this.dragFromCenter) {
                o = this.sprite.getBounds(), r = this.globalToLocal(new s.Point(o.centerX, o.centerY));
                this.sprite.x = n.x + (this.sprite.x - r.x), this.sprite.y = n.y + (this.sprite.y - r.y);
              }

              this._dragPoint.setTo(this.sprite.x - n.x, this.sprite.y - n.y);
            }

            this.updateDrag(t, !0), this.bringToTop && (this._dragPhase = !0, this.sprite.bringToTop()), this.dragStartPoint.set(e, i), this.sprite.events.onDragStart$dispatch(this.sprite, t, e, i), this._pendingDrag = !1;
          },
          globalToLocalX: function globalToLocalX(t) {
            return this.scaleLayer && (t -= this.game.scale.grid.boundsFluid.x, t *= this.game.scale.grid.scaleFluidInversed.x), t;
          },
          globalToLocalY: function globalToLocalY(t) {
            return this.scaleLayer && (t -= this.game.scale.grid.boundsFluid.y, t *= this.game.scale.grid.scaleFluidInversed.y), t;
          },
          globalToLocal: function globalToLocal(t) {
            return this.sprite.parent ? this.game.input.getLocalPosition(this.sprite.parent, {
              x: t.x,
              y: t.y
            }) : t;
          },
          stopDrag: function stopDrag(t) {
            this.isDragged = !1, this._draggedPointerID = -1, this._pointerData[t.id].isDragged = !1, this._dragPhase = !1, this._pendingDrag = !1, this.snapOnRelease && (this.sprite.fixedToCamera ? (this.sprite.cameraOffset.x = Math.round((this.sprite.cameraOffset.x - this.snapOffsetX % this.snapX) / this.snapX) * this.snapX + this.snapOffsetX % this.snapX, this.sprite.cameraOffset.y = Math.round((this.sprite.cameraOffset.y - this.snapOffsetY % this.snapY) / this.snapY) * this.snapY + this.snapOffsetY % this.snapY) : (this.sprite.x = Math.round((this.sprite.x - this.snapOffsetX % this.snapX) / this.snapX) * this.snapX + this.snapOffsetX % this.snapX, this.sprite.y = Math.round((this.sprite.y - this.snapOffsetY % this.snapY) / this.snapY) * this.snapY + this.snapOffsetY % this.snapY)), this.sprite.events.onDragStop$dispatch(this.sprite, t), !1 === this.checkPointerOver(t) && this._pointerOutHandler(t);
          },
          setDragLock: function setDragLock(t, e) {
            void 0 === t && (t = !0), void 0 === e && (e = !0), this.allowHorizontalDrag = t, this.allowVerticalDrag = e;
          },
          enableSnap: function enableSnap(t, e, i, s, n, o) {
            void 0 === i && (i = !0), void 0 === s && (s = !1), void 0 === n && (n = 0), void 0 === o && (o = 0), this.snapX = t, this.snapY = e, this.snapOffsetX = n, this.snapOffsetY = o, this.snapOnDrag = i, this.snapOnRelease = s;
          },
          disableSnap: function disableSnap() {
            this.snapOnDrag = !1, this.snapOnRelease = !1;
          },
          checkBoundsRect: function checkBoundsRect() {
            this.sprite.fixedToCamera ? (this.sprite.cameraOffset.x < this.boundsRect.left ? this.sprite.cameraOffset.x = this.boundsRect.left : this.sprite.cameraOffset.x + this.sprite.width > this.boundsRect.right && (this.sprite.cameraOffset.x = this.boundsRect.right - this.sprite.width), this.sprite.cameraOffset.y < this.boundsRect.top ? this.sprite.cameraOffset.y = this.boundsRect.top : this.sprite.cameraOffset.y + this.sprite.height > this.boundsRect.bottom && (this.sprite.cameraOffset.y = this.boundsRect.bottom - this.sprite.height)) : (this.sprite.left < this.boundsRect.left ? this.sprite.x = this.boundsRect.x + this.sprite.offsetX : this.sprite.right > this.boundsRect.right && (this.sprite.x = this.boundsRect.right - (this.sprite.width - this.sprite.offsetX)), this.sprite.top < this.boundsRect.top ? this.sprite.y = this.boundsRect.top + this.sprite.offsetY : this.sprite.bottom > this.boundsRect.bottom && (this.sprite.y = this.boundsRect.bottom - (this.sprite.height - this.sprite.offsetY)));
          },
          checkBoundsSprite: function checkBoundsSprite() {
            this.sprite.fixedToCamera && this.boundsSprite.fixedToCamera ? (this.sprite.cameraOffset.x < this.boundsSprite.cameraOffset.x ? this.sprite.cameraOffset.x = this.boundsSprite.cameraOffset.x : this.sprite.cameraOffset.x + this.sprite.width > this.boundsSprite.cameraOffset.x + this.boundsSprite.width && (this.sprite.cameraOffset.x = this.boundsSprite.cameraOffset.x + this.boundsSprite.width - this.sprite.width), this.sprite.cameraOffset.y < this.boundsSprite.cameraOffset.y ? this.sprite.cameraOffset.y = this.boundsSprite.cameraOffset.y : this.sprite.cameraOffset.y + this.sprite.height > this.boundsSprite.cameraOffset.y + this.boundsSprite.height && (this.sprite.cameraOffset.y = this.boundsSprite.cameraOffset.y + this.boundsSprite.height - this.sprite.height)) : (this.sprite.left < this.boundsSprite.left ? this.sprite.x = this.boundsSprite.left + this.sprite.offsetX : this.sprite.right > this.boundsSprite.right && (this.sprite.x = this.boundsSprite.right - (this.sprite.width - this.sprite.offsetX)), this.sprite.top < this.boundsSprite.top ? this.sprite.y = this.boundsSprite.top + this.sprite.offsetY : this.sprite.bottom > this.boundsSprite.bottom && (this.sprite.y = this.boundsSprite.bottom - (this.sprite.height - this.sprite.offsetY)));
          }
        }, s.InputHandler.prototype.constructor = s.InputHandler,
        /**
        * @author       @karlmacklin <tacklemcclean@gmail.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Gamepad = function (t) {
          this.game = t, this._gamepadIndexMap = {}, this._rawPads = [], this._active = !1, this.enabled = !0, this._gamepadSupportAvailable = !!navigator.webkitGetGamepads || !!navigator.webkitGamepads || -1 !== navigator.userAgent.indexOf("Firefox/") || !!navigator.getGamepads, this._prevRawGamepadTypes = [], this._prevTimestamps = [], this.callbackContext = this, this.onConnectCallback = null, this.onDisconnectCallback = null, this.onDownCallback = null, this.onUpCallback = null, this.onAxisCallback = null, this.onFloatCallback = null, this._ongamepadconnected = null, this._gamepaddisconnected = null, this._gamepads = [new s.SinglePad(t, this), new s.SinglePad(t, this), new s.SinglePad(t, this), new s.SinglePad(t, this)];
        }, s.Gamepad.prototype = {
          addCallbacks: function addCallbacks(t, e) {
            void 0 !== e && (this.onConnectCallback = "function" == typeof e.onConnect ? e.onConnect : this.onConnectCallback, this.onDisconnectCallback = "function" == typeof e.onDisconnect ? e.onDisconnect : this.onDisconnectCallback, this.onDownCallback = "function" == typeof e.onDown ? e.onDown : this.onDownCallback, this.onUpCallback = "function" == typeof e.onUp ? e.onUp : this.onUpCallback, this.onAxisCallback = "function" == typeof e.onAxis ? e.onAxis : this.onAxisCallback, this.onFloatCallback = "function" == typeof e.onFloat ? e.onFloat : this.onFloatCallback, this.callbackContext = t);
          },
          start: function start() {
            if (!this._active) {
              this._active = !0;
              var t = this;
              this._onGamepadConnected = function (e) {
                return t.onGamepadConnected(e);
              }, this._onGamepadDisconnected = function (e) {
                return t.onGamepadDisconnected(e);
              }, window.addEventListener("gamepadconnected", this._onGamepadConnected, !1), window.addEventListener("gamepaddisconnected", this._onGamepadDisconnected, !1);
            }
          },
          onGamepadConnected: function onGamepadConnected(t) {
            var e = t.gamepad;
            this._rawPads.push(e), this._gamepads[e.index].connect(e);
          },
          onGamepadDisconnected: function onGamepadDisconnected(t) {
            var e = t.gamepad;

            for (var i in this._rawPads) {
              this._rawPads[i].index === e.index && this._rawPads.splice(i, 1);
            }

            this._gamepads[e.index].disconnect();
          },
          update: function update() {
            this._pollGamepads(), this.pad1.pollStatus(), this.pad2.pollStatus(), this.pad3.pollStatus(), this.pad4.pollStatus();
          },
          _pollGamepads: function _pollGamepads() {
            if (this._active) {
              if (navigator.getGamepads) var t = navigator.getGamepads();else if (navigator.webkitGetGamepads) t = navigator.webkitGetGamepads();else if (navigator.webkitGamepads) t = navigator.webkitGamepads();

              if (t) {
                this._rawPads = [];

                for (var e = !1, i = 0; i < t.length && (typeof t[i] !== this._prevRawGamepadTypes[i] && (e = !0, this._prevRawGamepadTypes[i] = typeof t[i]), t[i] && this._rawPads.push(t[i]), 3 !== i); i++) {
                  ;
                }

                for (var s = 0; s < this._gamepads.length; s++) {
                  this._gamepads[s]._rawPad = this._rawPads[s];
                }

                if (e) {
                  for (var n, o = {
                    rawIndices: {},
                    padIndices: {}
                  }, r = 0; r < this._gamepads.length; r++) {
                    if ((n = this._gamepads[r]).connected) for (var a = 0; a < this._rawPads.length; a++) {
                      this._rawPads[a].index === n.index && (o.rawIndices[n.index] = !0, o.padIndices[r] = !0);
                    }
                  }

                  for (var h = 0; h < this._gamepads.length; h++) {
                    if (n = this._gamepads[h], !o.padIndices[h]) {
                      this._rawPads.length < 1 && n.disconnect();

                      for (var l = 0; l < this._rawPads.length && !o.padIndices[h]; l++) {
                        var c = this._rawPads[l];

                        if (c) {
                          if (o.rawIndices[c.index]) {
                            n.disconnect();
                            continue;
                          }

                          n.connect(c), o.rawIndices[c.index] = !0, o.padIndices[h] = !0;
                        } else n.disconnect();
                      }
                    }
                  }
                }
              }
            }
          },
          setDeadZones: function setDeadZones(t) {
            for (var e = 0; e < this._gamepads.length; e++) {
              this._gamepads[e].deadZone = t;
            }
          },
          stop: function stop() {
            this._active = !1, window.removeEventListener("gamepadconnected", this._onGamepadConnected), window.removeEventListener("gamepaddisconnected", this._onGamepadDisconnected);
          },
          reset: function reset() {
            this.update();

            for (var t = 0; t < this._gamepads.length; t++) {
              this._gamepads[t].reset();
            }
          },
          justPressed: function justPressed(t, e) {
            for (var i = 0; i < this._gamepads.length; i++) {
              if (!0 === this._gamepads[i].justPressed(t, e)) return !0;
            }

            return !1;
          },
          justReleased: function justReleased(t, e) {
            for (var i = 0; i < this._gamepads.length; i++) {
              if (!0 === this._gamepads[i].justReleased(t, e)) return !0;
            }

            return !1;
          },
          isDown: function isDown(t) {
            for (var e = 0; e < this._gamepads.length; e++) {
              if (!0 === this._gamepads[e].isDown(t)) return !0;
            }

            return !1;
          },
          destroy: function destroy() {
            this.stop();

            for (var t = 0; t < this._gamepads.length; t++) {
              this._gamepads[t].destroy();
            }
          }
        }, s.Gamepad.prototype.constructor = s.Gamepad, Object.defineProperty(s.Gamepad.prototype, "active", {
          get: function get() {
            return this._active;
          }
        }), Object.defineProperty(s.Gamepad.prototype, "supported", {
          get: function get() {
            return this._gamepadSupportAvailable;
          }
        }), Object.defineProperty(s.Gamepad.prototype, "padsConnected", {
          get: function get() {
            return this._rawPads.length;
          }
        }), Object.defineProperty(s.Gamepad.prototype, "pad1", {
          get: function get() {
            return this._gamepads[0];
          }
        }), Object.defineProperty(s.Gamepad.prototype, "pad2", {
          get: function get() {
            return this._gamepads[1];
          }
        }), Object.defineProperty(s.Gamepad.prototype, "pad3", {
          get: function get() {
            return this._gamepads[2];
          }
        }), Object.defineProperty(s.Gamepad.prototype, "pad4", {
          get: function get() {
            return this._gamepads[3];
          }
        }), s.Gamepad.BUTTON_0 = 0, s.Gamepad.BUTTON_1 = 1, s.Gamepad.BUTTON_2 = 2, s.Gamepad.BUTTON_3 = 3, s.Gamepad.BUTTON_4 = 4, s.Gamepad.BUTTON_5 = 5, s.Gamepad.BUTTON_6 = 6, s.Gamepad.BUTTON_7 = 7, s.Gamepad.BUTTON_8 = 8, s.Gamepad.BUTTON_9 = 9, s.Gamepad.BUTTON_10 = 10, s.Gamepad.BUTTON_11 = 11, s.Gamepad.BUTTON_12 = 12, s.Gamepad.BUTTON_13 = 13, s.Gamepad.BUTTON_14 = 14, s.Gamepad.BUTTON_15 = 15, s.Gamepad.AXIS_0 = 0, s.Gamepad.AXIS_1 = 1, s.Gamepad.AXIS_2 = 2, s.Gamepad.AXIS_3 = 3, s.Gamepad.AXIS_4 = 4, s.Gamepad.AXIS_5 = 5, s.Gamepad.AXIS_6 = 6, s.Gamepad.AXIS_7 = 7, s.Gamepad.AXIS_8 = 8, s.Gamepad.AXIS_9 = 9, s.Gamepad.XBOX360_A = 0, s.Gamepad.XBOX360_B = 1, s.Gamepad.XBOX360_X = 2, s.Gamepad.XBOX360_Y = 3, s.Gamepad.XBOX360_LEFT_BUMPER = 4, s.Gamepad.XBOX360_RIGHT_BUMPER = 5, s.Gamepad.XBOX360_LEFT_TRIGGER = 6, s.Gamepad.XBOX360_RIGHT_TRIGGER = 7, s.Gamepad.XBOX360_BACK = 8, s.Gamepad.XBOX360_START = 9, s.Gamepad.XBOX360_STICK_LEFT_BUTTON = 10, s.Gamepad.XBOX360_STICK_RIGHT_BUTTON = 11, s.Gamepad.XBOX360_DPAD_LEFT = 14, s.Gamepad.XBOX360_DPAD_RIGHT = 15, s.Gamepad.XBOX360_DPAD_UP = 12, s.Gamepad.XBOX360_DPAD_DOWN = 13, s.Gamepad.XBOX360_STICK_LEFT_X = 0, s.Gamepad.XBOX360_STICK_LEFT_Y = 1, s.Gamepad.XBOX360_STICK_RIGHT_X = 2, s.Gamepad.XBOX360_STICK_RIGHT_Y = 3, s.Gamepad.PS3XC_X = 0, s.Gamepad.PS3XC_CIRCLE = 1, s.Gamepad.PS3XC_SQUARE = 2, s.Gamepad.PS3XC_TRIANGLE = 3, s.Gamepad.PS3XC_L1 = 4, s.Gamepad.PS3XC_R1 = 5, s.Gamepad.PS3XC_L2 = 6, s.Gamepad.PS3XC_R2 = 7, s.Gamepad.PS3XC_SELECT = 8, s.Gamepad.PS3XC_START = 9, s.Gamepad.PS3XC_STICK_LEFT_BUTTON = 10, s.Gamepad.PS3XC_STICK_RIGHT_BUTTON = 11, s.Gamepad.PS3XC_DPAD_UP = 12, s.Gamepad.PS3XC_DPAD_DOWN = 13, s.Gamepad.PS3XC_DPAD_LEFT = 14, s.Gamepad.PS3XC_DPAD_RIGHT = 15, s.Gamepad.PS3XC_STICK_LEFT_X = 0, s.Gamepad.PS3XC_STICK_LEFT_Y = 1, s.Gamepad.PS3XC_STICK_RIGHT_X = 2, s.Gamepad.PS3XC_STICK_RIGHT_Y = 3,
        /**
        * @author       @karlmacklin <tacklemcclean@gmail.com>
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.SinglePad = function (t, e) {
          this.game = t, this.index = null, this.connected = !1, this.callbackContext = this, this.onConnectCallback = null, this.onDisconnectCallback = null, this.onDownCallback = null, this.onUpCallback = null, this.onAxisCallback = null, this.onFloatCallback = null, this.deadZone = .26, this._padParent = e, this._rawPad = null, this._prevTimestamp = null, this._buttons = [], this._buttonsLen = 0, this._axes = [], this._axesLen = 0;
        }, s.SinglePad.prototype = {
          addCallbacks: function addCallbacks(t, e) {
            void 0 !== e && (this.onConnectCallback = "function" == typeof e.onConnect ? e.onConnect : this.onConnectCallback, this.onDisconnectCallback = "function" == typeof e.onDisconnect ? e.onDisconnect : this.onDisconnectCallback, this.onDownCallback = "function" == typeof e.onDown ? e.onDown : this.onDownCallback, this.onUpCallback = "function" == typeof e.onUp ? e.onUp : this.onUpCallback, this.onAxisCallback = "function" == typeof e.onAxis ? e.onAxis : this.onAxisCallback, this.onFloatCallback = "function" == typeof e.onFloat ? e.onFloat : this.onFloatCallback, this.callbackContext = t);
          },
          getButton: function getButton(t) {
            return this._buttons[t] ? this._buttons[t] : null;
          },
          pollStatus: function pollStatus() {
            if (this.connected && this.game.input.enabled && this.game.input.gamepad.enabled && (!this._rawPad.timestamp || this._rawPad.timestamp !== this._prevTimestamp)) {
              for (var t = 0; t < this._buttonsLen; t++) {
                var e = isNaN(this._rawPad.buttons[t]) ? this._rawPad.buttons[t].value : this._rawPad.buttons[t];
                e !== this._buttons[t].value && (1 === e ? this.processButtonDown(t, e) : 0 === e ? this.processButtonUp(t, e) : this.processButtonFloat(t, e));
              }

              for (var i = 0; i < this._axesLen; i++) {
                var s = this._rawPad.axes[i];
                s > 0 && s > this.deadZone || s < 0 && s < -this.deadZone ? this.processAxisChange(i, s) : this.processAxisChange(i, 0);
              }

              this._prevTimestamp = this._rawPad.timestamp;
            }
          },
          connect: function connect(t) {
            var e = !this.connected;
            this.connected = !0, this.index = t.index, this._rawPad = t, this._buttons = [], this._buttonsLen = t.buttons.length, this._axes = [], this._axesLen = t.axes.length;

            for (var i = 0; i < this._axesLen; i++) {
              this._axes[i] = t.axes[i];
            }

            for (var n in t.buttons) {
              n = parseInt(n, 10), this._buttons[n] = new s.DeviceButton(this, n);
            }

            e && this._padParent.onConnectCallback && this._padParent.onConnectCallback.call(this._padParent.callbackContext, this.index), e && this.onConnectCallback && this.onConnectCallback.call(this.callbackContext);
          },
          disconnect: function disconnect() {
            var t = this.connected,
                e = this.index;
            this.connected = !1, this.index = null, this._rawPad = void 0;

            for (var i = 0; i < this._buttonsLen; i++) {
              this._buttons[i].destroy();
            }

            this._buttons = [], this._buttonsLen = 0, this._axes = [], this._axesLen = 0, t && this._padParent.onDisconnectCallback && this._padParent.onDisconnectCallback.call(this._padParent.callbackContext, e), t && this.onDisconnectCallback && this.onDisconnectCallback.call(this.callbackContext);
          },
          destroy: function destroy() {
            this._rawPad = void 0;

            for (var t = 0; t < this._buttonsLen; t++) {
              this._buttons[t].destroy();
            }

            this._buttons = [], this._buttonsLen = 0, this._axes = [], this._axesLen = 0, this.onConnectCallback = null, this.onDisconnectCallback = null, this.onDownCallback = null, this.onUpCallback = null, this.onAxisCallback = null, this.onFloatCallback = null;
          },
          processAxisChange: function processAxisChange(t, e) {
            this._axes[t] !== e && (this._axes[t] = e, this._padParent.onAxisCallback && this._padParent.onAxisCallback.call(this._padParent.callbackContext, this, t, e), this.onAxisCallback && this.onAxisCallback.call(this.callbackContext, this, t, e));
          },
          processButtonDown: function processButtonDown(t, e) {
            this._buttons[t] && this._buttons[t].start(null, e), this._padParent.onDownCallback && this._padParent.onDownCallback.call(this._padParent.callbackContext, t, e, this.index), this.onDownCallback && this.onDownCallback.call(this.callbackContext, t, e);
          },
          processButtonUp: function processButtonUp(t, e) {
            this._padParent.onUpCallback && this._padParent.onUpCallback.call(this._padParent.callbackContext, t, e, this.index), this.onUpCallback && this.onUpCallback.call(this.callbackContext, t, e), this._buttons[t] && this._buttons[t].stop(null, e);
          },
          processButtonFloat: function processButtonFloat(t, e) {
            this._padParent.onFloatCallback && this._padParent.onFloatCallback.call(this._padParent.callbackContext, t, e, this.index), this.onFloatCallback && this.onFloatCallback.call(this.callbackContext, t, e), this._buttons[t] && this._buttons[t].padFloat(e);
          },
          axis: function axis(t) {
            return !!this._axes[t] && this._axes[t];
          },
          isDown: function isDown(t) {
            return !!this._buttons[t] && this._buttons[t].isDown;
          },
          isUp: function isUp(t) {
            return !!this._buttons[t] && this._buttons[t].isUp;
          },
          justReleased: function justReleased(t, e) {
            if (this._buttons[t]) return this._buttons[t].justReleased(e);
          },
          justPressed: function justPressed(t, e) {
            if (this._buttons[t]) return this._buttons[t].justPressed(e);
          },
          buttonValue: function buttonValue(t) {
            return this._buttons[t] ? this._buttons[t].value : null;
          },
          reset: function reset() {
            for (var t = 0; t < this._axes.length; t++) {
              this._axes[t] = 0;
            }
          }
        }, s.SinglePad.prototype.constructor = s.SinglePad,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Key = function (t, e) {
          this.game = t, this._enabled = !0, this.event = null, this.isDown = !1, this.isUp = !0, this.altKey = !1, this.ctrlKey = !1, this.shiftKey = !1, this.timeDown = 0, this.duration = 0, this.timeUp = -2500, this.durationUp = -2500, this.repeats = 0, this.keyCode = e, this.onDown = new s.Signal(), this.onHoldCallback = null, this.onHoldContext = null, this.onUp = new s.Signal(), this._justDown = !1, this._justUp = !1;
        }, s.Key.prototype = {
          update: function update() {
            this._enabled && (this.isDown ? (this.duration = this.game.time.time - this.timeDown, this.repeats++, this.onHoldCallback && this.onHoldCallback.call(this.onHoldContext, this)) : this.durationUp = this.game.time.time - this.timeUp);
          },
          processKeyDown: function processKeyDown(t) {
            this._enabled && (this.event = t, this.isDown || (this.altKey = t.altKey, this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.isDown = !0, this.isUp = !1, this.timeDown = this.game.time.time, this.duration = 0, this.durationUp = this.game.time.time - this.timeUp, this.repeats = 0, this._justDown = !0, this.onDown.dispatch(this)));
          },
          processKeyUp: function processKeyUp(t) {
            this._enabled && (this.event = t, this.isUp || (this.isDown = !1, this.isUp = !0, this.timeUp = this.game.time.time, this.duration = this.game.time.time - this.timeDown, this.durationUp = 0, this._justUp = !0, this.onUp.dispatch(this)));
          },
          reset: function reset(t) {
            void 0 === t && (t = !0), this.isDown = !1, this.isUp = !0, this.timeUp = this.game.time.time, this.duration = 0, this.durationUp = -2500, this._enabled = !0, this._justDown = !1, this._justUp = !1, t && (this.onDown.removeAll(), this.onUp.removeAll(), this.onHoldCallback = null, this.onHoldContext = null);
          },
          downDuration: function downDuration(t) {
            return void 0 === t && (t = 50), this.isDown && this.duration < t;
          },
          upDuration: function upDuration(t) {
            return void 0 === t && (t = 50), !this.isDown && this.game.time.time - this.timeUp < t;
          },
          justPressed: function justPressed() {
            return this.isDown && 0 === this.duration;
          },
          justReleased: function justReleased() {
            return !this.isDown && 0 === this.durationUp;
          }
        }, Object.defineProperty(s.Key.prototype, "justDown", {
          get: function get() {
            var t = this._justDown;
            return this._justDown = !1, t;
          }
        }), Object.defineProperty(s.Key.prototype, "justUp", {
          get: function get() {
            var t = this._justUp;
            return this._justUp = !1, t;
          }
        }), Object.defineProperty(s.Key.prototype, "enabled", {
          get: function get() {
            return this._enabled;
          },
          set: function set(t) {
            (t = !!t) !== this._enabled && (t || this.reset(!1), this._enabled = t);
          }
        }), s.Key.prototype.constructor = s.Key,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Keyboard = function (t) {
          this.game = t, this.enabled = !0, this.event = null, this.pressEvent = null, this.callbackContext = this, this.onDownCallback = null, this.onPressCallback = null, this.onUpCallback = null, this._keys = [], this._capture = [], this._onKeyDown = null, this._onKeyPress = null, this._onKeyUp = null, this._i = 0, this._k = 0;
        }, s.Keyboard.prototype = {
          addCallbacks: function addCallbacks(t, e, i, s) {
            this.callbackContext = t, void 0 !== e && null !== e && (this.onDownCallback = e), void 0 !== i && null !== i && (this.onUpCallback = i), void 0 !== s && null !== s && (this.onPressCallback = s);
          },
          removeCallbacks: function removeCallbacks() {
            this.callbackContext = this, this.onDownCallback = null, this.onUpCallback = null, this.onPressCallback = null;
          },
          addKey: function addKey(t) {
            return this._keys[t] || (this._keys[t] = new s.Key(this.game, t), this.addKeyCapture(t)), this._keys[t];
          },
          addKeys: function addKeys(t) {
            var e = {};

            for (var i in t) {
              e[i] = this.addKey(t[i]);
            }

            return e;
          },
          removeKey: function removeKey(t) {
            this._keys[t] && (this._keys[t] = null, this.removeKeyCapture(t));
          },
          createCursorKeys: function createCursorKeys() {
            return this.addKeys({
              up: s.KeyCode.UP,
              down: s.KeyCode.DOWN,
              left: s.KeyCode.LEFT,
              right: s.KeyCode.RIGHT
            });
          },
          start: function start() {
            if (!this.game.device.cocoonJS && null === this._onKeyDown) {
              var t = this;
              this._onKeyDown = function (e) {
                return t.processKeyDown(e);
              }, this._onKeyUp = function (e) {
                return t.processKeyUp(e);
              }, this._onKeyPress = function (e) {
                return t.processKeyPress(e);
              }, window.addEventListener("keydown", this._onKeyDown, !1), window.addEventListener("keyup", this._onKeyUp, !1), window.addEventListener("keypress", this._onKeyPress, !1);
            }
          },
          stop: function stop() {
            window.removeEventListener("keydown", this._onKeyDown), window.removeEventListener("keyup", this._onKeyUp), window.removeEventListener("keypress", this._onKeyPress), this._onKeyDown = null, this._onKeyUp = null, this._onKeyPress = null;
          },
          destroy: function destroy() {
            this.stop(), this.clearCaptures(), this._keys.length = 0, this._i = 0;
          },
          addKeyCapture: function addKeyCapture(t) {
            if ("object" == typeof t) for (var e in t) {
              this._capture[t[e]] = !0;
            } else this._capture[t] = !0;
          },
          removeKeyCapture: function removeKeyCapture(t) {
            delete this._capture[t];
          },
          clearCaptures: function clearCaptures() {
            this._capture = {};
          },
          update: function update() {
            for (this._i = this._keys.length; this._i--;) {
              this._keys[this._i] && this._keys[this._i].update();
            }
          },
          processKeyDown: function processKeyDown(t) {
            if (this.event = t, this.game.input.enabled && this.enabled) {
              var e = t.keyCode;
              this._capture[e] && t.preventDefault(), this._keys[e] || (this._keys[e] = new s.Key(this.game, e)), this._keys[e].processKeyDown(t), this._k = e, this.onDownCallback && this.onDownCallback.call(this.callbackContext, t);
            }
          },
          processKeyPress: function processKeyPress(t) {
            this.pressEvent = t, this.game.input.enabled && this.enabled && this.onPressCallback && this.onPressCallback.call(this.callbackContext, String.fromCharCode(t.charCode), t);
          },
          processKeyUp: function processKeyUp(t) {
            if (this.event = t, this.game.input.enabled && this.enabled) {
              var e = t.keyCode;
              this._capture[e] && t.preventDefault(), this._keys[e] || (this._keys[e] = new s.Key(this.game, e)), this._keys[e].processKeyUp(t), this.onUpCallback && this.onUpCallback.call(this.callbackContext, t);
            }
          },
          reset: function reset(t) {
            void 0 === t && (t = !0), this.event = null;

            for (var e = this._keys.length; e--;) {
              this._keys[e] && this._keys[e].reset(t);
            }
          },
          downDuration: function downDuration(t, e) {
            return this._keys[t] ? this._keys[t].downDuration(e) : null;
          },
          upDuration: function upDuration(t, e) {
            return this._keys[t] ? this._keys[t].upDuration(e) : null;
          },
          justPressed: function justPressed(t) {
            return this._keys[t] ? this._keys[t].justPressed() : null;
          },
          justReleased: function justReleased(t) {
            return this._keys[t] ? this._keys[t].justReleased() : null;
          },
          isDown: function isDown(t) {
            return this._keys[t] ? this._keys[t].isDown : null;
          }
        }, Object.defineProperty(s.Keyboard.prototype, "lastChar", {
          get: function get() {
            return this.event && 32 === this.event.charCode ? "" : this.pressEvent ? String.fromCharCode(this.pressEvent.charCode) : null;
          }
        }), Object.defineProperty(s.Keyboard.prototype, "lastKey", {
          get: function get() {
            return this._keys[this._k];
          }
        }), s.Keyboard.prototype.constructor = s.Keyboard, s.KeyCode = {
          A: "A".charCodeAt(0),
          B: "B".charCodeAt(0),
          C: "C".charCodeAt(0),
          D: "D".charCodeAt(0),
          E: "E".charCodeAt(0),
          F: "F".charCodeAt(0),
          G: "G".charCodeAt(0),
          H: "H".charCodeAt(0),
          I: "I".charCodeAt(0),
          J: "J".charCodeAt(0),
          K: "K".charCodeAt(0),
          L: "L".charCodeAt(0),
          M: "M".charCodeAt(0),
          N: "N".charCodeAt(0),
          O: "O".charCodeAt(0),
          P: "P".charCodeAt(0),
          Q: "Q".charCodeAt(0),
          R: "R".charCodeAt(0),
          S: "S".charCodeAt(0),
          T: "T".charCodeAt(0),
          U: "U".charCodeAt(0),
          V: "V".charCodeAt(0),
          W: "W".charCodeAt(0),
          X: "X".charCodeAt(0),
          Y: "Y".charCodeAt(0),
          Z: "Z".charCodeAt(0),
          ZERO: "0".charCodeAt(0),
          ONE: "1".charCodeAt(0),
          TWO: "2".charCodeAt(0),
          THREE: "3".charCodeAt(0),
          FOUR: "4".charCodeAt(0),
          FIVE: "5".charCodeAt(0),
          SIX: "6".charCodeAt(0),
          SEVEN: "7".charCodeAt(0),
          EIGHT: "8".charCodeAt(0),
          NINE: "9".charCodeAt(0),
          NUMPAD_0: 96,
          NUMPAD_1: 97,
          NUMPAD_2: 98,
          NUMPAD_3: 99,
          NUMPAD_4: 100,
          NUMPAD_5: 101,
          NUMPAD_6: 102,
          NUMPAD_7: 103,
          NUMPAD_8: 104,
          NUMPAD_9: 105,
          NUMPAD_MULTIPLY: 106,
          NUMPAD_ADD: 107,
          NUMPAD_ENTER: 108,
          NUMPAD_SUBTRACT: 109,
          NUMPAD_DECIMAL: 110,
          NUMPAD_DIVIDE: 111,
          F1: 112,
          F2: 113,
          F3: 114,
          F4: 115,
          F5: 116,
          F6: 117,
          F7: 118,
          F8: 119,
          F9: 120,
          F10: 121,
          F11: 122,
          F12: 123,
          F13: 124,
          F14: 125,
          F15: 126,
          COLON: 186,
          EQUALS: 187,
          COMMA: 188,
          UNDERSCORE: 189,
          PERIOD: 190,
          QUESTION_MARK: 191,
          TILDE: 192,
          OPEN_BRACKET: 219,
          BACKWARD_SLASH: 220,
          CLOSED_BRACKET: 221,
          QUOTES: 222,
          BACKSPACE: 8,
          TAB: 9,
          CLEAR: 12,
          ENTER: 13,
          SHIFT: 16,
          CONTROL: 17,
          ALT: 18,
          CAPS_LOCK: 20,
          ESC: 27,
          SPACEBAR: 32,
          PAGE_UP: 33,
          PAGE_DOWN: 34,
          END: 35,
          HOME: 36,
          LEFT: 37,
          UP: 38,
          RIGHT: 39,
          DOWN: 40,
          PLUS: 43,
          MINUS: 44,
          INSERT: 45,
          DELETE: 46,
          HELP: 47,
          NUM_LOCK: 144
        }, s.KeyCode) {
          s.KeyCode.hasOwnProperty(r) && !r.match(/[a-z]/) && (s.Keyboard[r] = s.KeyCode[r]);
        }
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */


        for (var a in s.Component = function () {},
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Angle = function () {}, s.Component.Angle.prototype = {
          angle: {
            get: function get() {
              return s.Math.wrapAngle(s.Math.radToDeg(this.rotation));
            },
            set: function set(t) {
              this.rotation = s.Math.degToRad(s.Math.wrapAngle(t));
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Animation = function () {}, s.Component.Animation.prototype = {
          play: function play(t, e, i, s) {
            if (this.animations) return this.animations.play(t, e, i, s);
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.AutoCull = function () {}, s.Component.AutoCull.prototype = {
          autoCull: !1,
          inCamera: {
            get: function get() {
              return this.autoCull || this.checkWorldBounds || (this._bounds.copyFrom(this.getBounds()), this._bounds.x += this.game.camera.view.x, this._bounds.y += this.game.camera.view.y), this.game.world.camera.view.intersects(this._bounds);
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Bounds = function () {}, s.Component.Bounds.prototype = {
          offsetX: {
            get: function get() {
              return this.anchor.x * this.width;
            }
          },
          offsetY: {
            get: function get() {
              return this.anchor.y * this.height;
            }
          },
          centerX: {
            get: function get() {
              return this.x - this.offsetX + .5 * this.width;
            },
            set: function set(t) {
              this.x = t + this.offsetX - .5 * this.width;
            }
          },
          centerY: {
            get: function get() {
              return this.y - this.offsetY + .5 * this.height;
            },
            set: function set(t) {
              this.y = t + this.offsetY - .5 * this.height;
            }
          },
          left: {
            get: function get() {
              return this.x - this.offsetX;
            },
            set: function set(t) {
              this.x = t + this.offsetX;
            }
          },
          right: {
            get: function get() {
              return this.x + this.width - this.offsetX;
            },
            set: function set(t) {
              this.x = t - this.width + this.offsetX;
            }
          },
          top: {
            get: function get() {
              return this.y - this.offsetY;
            },
            set: function set(t) {
              this.y = t + this.offsetY;
            }
          },
          bottom: {
            get: function get() {
              return this.y + this.height - this.offsetY;
            },
            set: function set(t) {
              this.y = t - this.height + this.offsetY;
            }
          },
          alignIn: function alignIn(t, e, i, n) {
            switch (void 0 === i && (i = 0), void 0 === n && (n = 0), e) {
              default:
              case s.TOP_LEFT:
                this.left = t.left - i, this.top = t.top - n;
                break;

              case s.TOP_CENTER:
                this.centerX = t.centerX + i, this.top = t.top - n;
                break;

              case s.TOP_RIGHT:
                this.right = t.right + i, this.top = t.top - n;
                break;

              case s.LEFT_CENTER:
                this.left = t.left - i, this.centerY = t.centerY + n;
                break;

              case s.CENTER:
                this.centerX = t.centerX + i, this.centerY = t.centerY + n;
                break;

              case s.RIGHT_CENTER:
                this.right = t.right + i, this.centerY = t.centerY + n;
                break;

              case s.BOTTOM_LEFT:
                this.left = t.left - i, this.bottom = t.bottom + n;
                break;

              case s.BOTTOM_CENTER:
                this.centerX = t.centerX + i, this.bottom = t.bottom + n;
                break;

              case s.BOTTOM_RIGHT:
                this.right = t.right + i, this.bottom = t.bottom + n;
            }

            return this;
          },
          alignTo: function alignTo(t, e, i, n) {
            switch (void 0 === i && (i = 0), void 0 === n && (n = 0), e) {
              default:
              case s.TOP_LEFT:
                this.left = t.left - i, this.bottom = t.top - n;
                break;

              case s.TOP_CENTER:
                this.centerX = t.centerX + i, this.bottom = t.top - n;
                break;

              case s.TOP_RIGHT:
                this.right = t.right + i, this.bottom = t.top - n;
                break;

              case s.LEFT_TOP:
                this.right = t.left - i, this.top = t.top - n;
                break;

              case s.LEFT_CENTER:
                this.right = t.left - i, this.centerY = t.centerY + n;
                break;

              case s.LEFT_BOTTOM:
                this.right = t.left - i, this.bottom = t.bottom + n;
                break;

              case s.RIGHT_TOP:
                this.left = t.right + i, this.top = t.top - n;
                break;

              case s.RIGHT_CENTER:
                this.left = t.right + i, this.centerY = t.centerY + n;
                break;

              case s.RIGHT_BOTTOM:
                this.left = t.right + i, this.bottom = t.bottom + n;
                break;

              case s.BOTTOM_LEFT:
                this.left = t.left - i, this.top = t.bottom + n;
                break;

              case s.BOTTOM_CENTER:
                this.centerX = t.centerX + i, this.top = t.bottom + n;
                break;

              case s.BOTTOM_RIGHT:
                this.right = t.right + i, this.top = t.bottom + n;
            }

            return this;
          }
        }, s.Group.prototype.alignIn = s.Component.Bounds.prototype.alignIn, s.Group.prototype.alignTo = s.Component.Bounds.prototype.alignTo,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.BringToTop = function () {}, s.Component.BringToTop.prototype.bringToTop = function () {
          return this.parent && this.parent.bringToTop(this), this;
        }, s.Component.BringToTop.prototype.sendToBack = function () {
          return this.parent && this.parent.sendToBack(this), this;
        }, s.Component.BringToTop.prototype.moveUp = function () {
          return this.parent && this.parent.moveUp(this), this;
        }, s.Component.BringToTop.prototype.moveDown = function () {
          return this.parent && this.parent.moveDown(this), this;
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Core = function () {}, s.Component.Core.skipTypeChecks = !1, s.Component.Core.install = function (t) {
          s.Utils.mixinPrototype(this, s.Component.Core.prototype), this.components = {};

          for (var e = 0; e < t.length; e++) {
            var i = t[e],
                n = !1;
            "Destroy" === i && (n = !0), s.Utils.mixinPrototype(this, s.Component[i].prototype, n), this.components[i] = !0;
          }
        }, s.Component.Core.init = function (t, e, i, n, o) {
          if (!s.Component.Core.skipTypeChecks) {
            if (!(t instanceof s.Game)) throw new Error("The value passed as the `game` argument (" + t + ") is not an instance of Phaser.Game.");
            "number" != typeof e && (console.warn("The `x` argument value (%s) should be a number.", e), e = 0), "number" != typeof i && (console.warn("The `y` argument value (%s) should be a number.", i), i = 0);
          }

          this.game = t, this.key = n, this.data = {}, this.position.set(e, i), this.world = new s.Point(e, i), this.previousPosition = new s.Point(e, i), this.events = new s.Events(this), this._bounds = new s.Rectangle(), this.components.PhysicsBody && (this.body = this.body), this.components.Animation && (this.animations = new s.AnimationManager(this)), this.components.LoadTexture && null !== n && this.loadTexture(n, o), this.components.FixedToCamera && (this.cameraOffset = new s.Point(e, i));
        }, s.Component.Core.preUpdate = function () {
          return this.pendingDestroy ? (this.destroy(), !1) : (this.previousPosition.set(this.world.x, this.world.y), this.previousRotation = this.rotation, this.exists && this.parent.exists ? (this.world.setTo(this.game.camera.x + this.worldTransform.tx, this.game.camera.y + this.worldTransform.ty), this.visible && (this.renderOrderID = this.game.stage.currentRenderOrderID++), this.animations && this.animations.update(), this.body && this.body.preUpdate(), this.preUpdateChildren(), !0) : (this.renderOrderID = -1, !1));
        }, s.Component.Core.prototype = {
          game: null,
          name: "",
          data: {},
          components: {},
          z: 0,
          events: void 0,
          animations: void 0,
          key: "",
          world: null,
          debug: !1,
          previousPosition: null,
          previousRotation: 0,
          renderOrderID: 0,
          fresh: !0,
          pendingDestroy: !1,
          _bounds: null,
          _exists: !0,
          exists: {
            get: function get() {
              return this._exists;
            },
            set: function set(t) {
              t ? (this._exists = !0, this.body && this.body.type === s.Physics.P2JS && this.body.addToWorld(), this.visible = !0) : (this._exists = !1, this.body && this.body.type === s.Physics.P2JS && this.body.removeFromWorld(), this.visible = !1);
            }
          },
          preUpdateChildren: function preUpdateChildren() {
            for (var t = 0; t < this.children.length;) {
              var e = this.children[t];
              e.preUpdate(), this === e.parent && t++;
            }
          },
          update: function update() {},
          postUpdate: function postUpdate() {
            this.customRender && this.key.render(), this.components.PhysicsBody && s.Component.PhysicsBody.postUpdate.call(this), this.components.FixedToCamera && s.Component.FixedToCamera.postUpdate.call(this);

            for (var t = 0; t < this.children.length; t++) {
              this.children[t].postUpdate();
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Crop = function () {}, s.Component.Crop.prototype = {
          cropRect: null,
          _crop: null,
          crop: function crop(t, e) {
            void 0 === e && (e = !1), t ? (e && null !== this.cropRect ? this.cropRect.setTo(t.x, t.y, t.width, t.height) : e && null === this.cropRect ? this.cropRect = new s.Rectangle(t.x, t.y, t.width, t.height) : this.cropRect = t, this.updateCrop()) : (this._crop = null, this.cropRect = null, this.resetFrame());
          },
          updateCrop: function updateCrop() {
            if (this.cropRect) {
              var t = this.texture.crop.x,
                  e = this.texture.crop.y,
                  i = this.texture.crop.width,
                  n = this.texture.crop.height;
              this._crop = s.Rectangle.clone(this.cropRect, this._crop), this._crop.x += this._frame.x, this._crop.y += this._frame.y;
              var o = Math.max(this._frame.x, this._crop.x),
                  r = Math.max(this._frame.y, this._crop.y),
                  a = Math.min(this._frame.right, this._crop.right) - o,
                  h = Math.min(this._frame.bottom, this._crop.bottom) - r;
              this.texture.crop.x = o, this.texture.crop.y = r, this.texture.crop.width = a, this.texture.crop.height = h, this.texture.frame.width = Math.min(a, this.cropRect.width), this.texture.frame.height = Math.min(h, this.cropRect.height), this.texture.width = this.texture.frame.width, this.texture.height = this.texture.frame.height, this.texture._updateUvs(), 16777215 === this.tint || t === o && e === r && i === a && n === h || (this.texture.requiresReTint = !0);
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Delta = function () {}, s.Component.Delta.prototype = {
          deltaX: {
            get: function get() {
              return this.world.x - this.previousPosition.x;
            }
          },
          deltaY: {
            get: function get() {
              return this.world.y - this.previousPosition.y;
            }
          },
          deltaZ: {
            get: function get() {
              return this.rotation - this.previousRotation;
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Destroy = function () {}, s.Component.Destroy.prototype = {
          destroyPhase: !1,
          destroy: function destroy(t, e) {
            if (null !== this.game && !this.destroyPhase) {
              void 0 === t && (t = !0), void 0 === e && (e = !1), this.destroyPhase = !0, this.events && this.events.onDestroy$dispatch(this), this.parent && (this.parent instanceof s.Group ? this.parent.remove(this) : this.parent.removeChild(this)), this.input && this.input.destroy(), this.animations && this.animations.destroy(), this.body && this.body.destroy(), this.events && this.events.destroy(), this.game.tweens.removeFrom(this);
              var i = this.children.length;
              if (t) for (; i--;) {
                this.children[i].destroy(t);
              } else for (; i--;) {
                this.removeChild(this.children[i]);
              }
              this._crop && (this._crop = null, this.cropRect = null), this._frame && (this._frame = null), s.Video && this.key instanceof s.Video && this.key.onChangeSource.remove(this.resizeFrame, this), s.BitmapText && this._glyphs && (this._glyphs = []), this.alive = !1, this.exists = !1, this.visible = !1, this.filters = null, this.mask = null, this.game = null, this.data = {}, this.renderable = !1, this.transformCallback && (this.transformCallback = null, this.transformCallbackContext = null), this.hitArea = null, this.parent = null, this.stage = null, this.worldTransform = null, this.filterArea = null, this._bounds = null, this._currentBounds = null, this._mask = null, this._destroyCachedSprite(), e && this.texture.destroy(!0), this.destroyPhase = !1, this.pendingDestroy = !1;
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Events = function (t) {
          this.parent = t;
        }, s.Events.prototype = {
          destroy: function destroy() {
            this._parent = null, this._onDestroy && this._onDestroy.dispose(), this._onAddedToGroup && this._onAddedToGroup.dispose(), this._onRemovedFromGroup && this._onRemovedFromGroup.dispose(), this._onKilled && this._onKilled.dispose(), this._onRevived && this._onRevived.dispose(), this._onEnterBounds && this._onEnterBounds.dispose(), this._onOutOfBounds && this._onOutOfBounds.dispose(), this._onInputOver && this._onInputOver.dispose(), this._onInputOut && this._onInputOut.dispose(), this._onInputDown && this._onInputDown.dispose(), this._onInputUp && this._onInputUp.dispose(), this._onDragStart && this._onDragStart.dispose(), this._onDragUpdate && this._onDragUpdate.dispose(), this._onDragStop && this._onDragStop.dispose(), this._onAnimationStart && this._onAnimationStart.dispose(), this._onAnimationComplete && this._onAnimationComplete.dispose(), this._onAnimationLoop && this._onAnimationLoop.dispose();
          },
          onAddedToGroup: null,
          onRemovedFromGroup: null,
          onDestroy: null,
          onKilled: null,
          onRevived: null,
          onOutOfBounds: null,
          onEnterBounds: null,
          onInputOver: null,
          onInputOut: null,
          onInputDown: null,
          onInputUp: null,
          onDragStart: null,
          onDragUpdate: null,
          onDragStop: null,
          onAnimationStart: null,
          onAnimationComplete: null,
          onAnimationLoop: null
        }, s.Events.prototype.constructor = s.Events, s.Events.prototype) {
          s.Events.prototype.hasOwnProperty(a) && 0 === a.indexOf("on") && null === s.Events.prototype[a] && function (t, e) {
            "use strict";

            Object.defineProperty(s.Events.prototype, t, {
              get: function get() {
                return this[e] || (this[e] = new s.Signal());
              }
            }), s.Events.prototype[t + "$dispatch"] = function () {
              return this[e] ? this[e].dispatch.apply(this[e], arguments) : null;
            };
          }(a, "_" + a);
        }
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */


        s.Component.FixedToCamera = function () {}, s.Component.FixedToCamera.postUpdate = function () {
          this.fixedToCamera && (this.position.x = (this.game.camera.view.x + this.cameraOffset.x) / this.game.camera.scale.x, this.position.y = (this.game.camera.view.y + this.cameraOffset.y) / this.game.camera.scale.y);
        }, s.Component.FixedToCamera.prototype = {
          _fixedToCamera: !1,
          fixedToCamera: {
            get: function get() {
              return this._fixedToCamera;
            },
            set: function set(t) {
              t ? (this._fixedToCamera = !0, this.cameraOffset.set(this.x, this.y)) : this._fixedToCamera = !1;
            }
          },
          cameraOffset: new s.Point()
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Health = function () {}, s.Component.Health.prototype = {
          health: 1,
          maxHealth: 100,
          damage: function damage(t) {
            return this.alive && (this.health -= t, this.health <= 0 && this.kill()), this;
          },
          setHealth: function setHealth(t) {
            return this.health = t, this.health > this.maxHealth && (this.health = this.maxHealth), this;
          },
          heal: function heal(t) {
            return this.alive && (this.health += t, this.health > this.maxHealth && (this.health = this.maxHealth)), this;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.InCamera = function () {}, s.Component.InCamera.prototype = {
          inCamera: {
            get: function get() {
              return this.game.world.camera.view.intersects(this._bounds);
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.InputEnabled = function () {}, s.Component.InputEnabled.prototype = {
          input: null,
          inputEnabled: {
            get: function get() {
              return this.input && this.input.enabled;
            },
            set: function set(t) {
              t ? null === this.input ? (this.input = new s.InputHandler(this), this.input.start()) : this.input && !this.input.enabled && this.input.start() : this.input && this.input.enabled && this.input.stop();
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.InWorld = function () {}, s.Component.InWorld.preUpdate = function () {
          if (this.pendingDestroy) return this.destroy(), !1;

          if (this.autoCull || this.checkWorldBounds) {
            if (this._bounds.copyFrom(this.getBounds()), this._bounds.x += this.game.camera.view.x, this._bounds.y += this.game.camera.view.y, this.autoCull) if (this.game.world.camera.view.intersects(this._bounds)) this.renderable = !0, this.game.world.camera.totalInView++;else if (this.renderable = !1, this.outOfCameraBoundsKill) return this.kill(), !1;
            if (this.checkWorldBounds) if (this._outOfBoundsFired && this.game.world.bounds.intersects(this._bounds)) this._outOfBoundsFired = !1, this.events.onEnterBounds$dispatch(this);else if (!this._outOfBoundsFired && !this.game.world.bounds.intersects(this._bounds) && (this._outOfBoundsFired = !0, this.events.onOutOfBounds$dispatch(this), this.outOfBoundsKill)) return this.kill(), !1;
          }

          return !0;
        }, s.Component.InWorld.prototype = {
          checkWorldBounds: !1,
          outOfBoundsKill: !1,
          outOfCameraBoundsKill: !1,
          _outOfBoundsFired: !1,
          inWorld: {
            get: function get() {
              return this.game.world.bounds.intersects(this.getBounds());
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.LifeSpan = function () {}, s.Component.LifeSpan.preUpdate = function () {
          return this.pendingDestroy ? (this.destroy(), !1) : !(this.lifespan > 0 && (this.lifespan -= this.game.time.physicsElapsedMS, this.lifespan <= 0)) || (this.kill(), !1);
        }, s.Component.LifeSpan.prototype = {
          alive: !0,
          lifespan: 0,
          revive: function revive(t) {
            return void 0 === t && (t = 100), this.alive = !0, this.exists = !0, this.visible = !0, "function" == typeof this.setHealth && this.setHealth(t), this.events && this.events.onRevived$dispatch(this), this;
          },
          kill: function kill() {
            return this.alive = !1, this.exists = !1, this.visible = !1, this.events && this.events.onKilled$dispatch(this), this;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.LoadTexture = function () {}, s.Component.LoadTexture.prototype = {
          customRender: !1,
          _frame: null,
          loadTexture: function loadTexture(t, e, i) {
            t === s.PENDING_ATLAS ? (t = e, e = 0) : e = e || 0, (i || void 0 === i) && this.animations && this.animations.stop(), this.key = t, this.customRender = !1;
            var n = this.game.cache,
                o = !0,
                r = !this.texture.baseTexture.scaleMode;
            if (s.RenderTexture && t instanceof s.RenderTexture) this.key = t.key, this.setTexture(t);else if (s.BitmapData && t instanceof s.BitmapData) this.customRender = !0, this.setTexture(t.texture), o = n.hasFrameData(t.key, s.Cache.BITMAPDATA) ? !this.animations.loadFrameData(n.getFrameData(t.key, s.Cache.BITMAPDATA), e) : !this.animations.loadFrameData(t.frameData, 0);else if (s.Video && t instanceof s.Video) {
              this.customRender = !0;
              var a = t.texture.valid;
              this.setTexture(t.texture), this.setFrame(t.texture.frame.clone()), t.onChangeSource.add(this.resizeFrame, this), this.texture.valid = a;
            } else if (s.Tilemap && t instanceof s.TilemapLayer) this.setTexture(PIXI.Texture.fromCanvas(t.canvas));else if (t instanceof PIXI.Texture) this.setTexture(t);else {
              var h = n.getImage(t, !0);
              this.key = h.key, this.setTexture(new PIXI.Texture(h.base)), this.texture.baseTexture.skipRender = "__default" === t, o = !this.animations.loadFrameData(h.frameData, e);
            }
            o && (this._frame = s.Rectangle.clone(this.texture.frame)), r || (this.texture.baseTexture.scaleMode = 1);
          },
          setFrame: function setFrame(t) {
            this._frame = t, this.texture.frame.x = t.x, this.texture.frame.y = t.y, this.texture.frame.width = t.width, this.texture.frame.height = t.height, this.texture.crop.x = t.x, this.texture.crop.y = t.y, this.texture.crop.width = t.width, this.texture.crop.height = t.height, t.trimmed ? (this.texture.trim ? (this.texture.trim.x = t.spriteSourceSizeX, this.texture.trim.y = t.spriteSourceSizeY, this.texture.trim.width = t.sourceSizeW, this.texture.trim.height = t.sourceSizeH) : this.texture.trim = {
              x: t.spriteSourceSizeX,
              y: t.spriteSourceSizeY,
              width: t.sourceSizeW,
              height: t.sourceSizeH
            }, this.texture.width = t.sourceSizeW, this.texture.height = t.sourceSizeH, this.texture.frame.width = t.sourceSizeW, this.texture.frame.height = t.sourceSizeH) : !t.trimmed && this.texture.trim && (this.texture.trim = null), t.rotated && (this.texture.rotated = !0), this.cropRect && this.updateCrop(), this.texture.requiresReTint = !0, this.texture._updateUvs(), this.tilingTexture && (this.refreshTexture = !0);
          },
          resizeFrame: function resizeFrame(t, e, i) {
            this.texture.frame.resize(e, i), this.texture.setFrame(this.texture.frame);
          },
          resetFrame: function resetFrame() {
            this._frame && this.setFrame(this._frame);
          },
          frame: {
            get: function get() {
              return this.animations.frame;
            },
            set: function set(t) {
              this.animations.frame = t;
            }
          },
          frameName: {
            get: function get() {
              return this.animations.frameName;
            },
            set: function set(t) {
              this.animations.frameName = t;
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Overlap = function () {}, s.Component.Overlap.prototype = {
          overlap: function overlap(t) {
            return s.Rectangle.intersects(this.getBounds(), t.getBounds());
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.PhysicsBody = function () {}, s.Component.PhysicsBody.preUpdate = function () {
          return this.pendingDestroy ? (this.destroy(), !1) : this.fresh && this.exists ? (this.world.setTo(this.parent.position.x + this.position.x, this.parent.position.y + this.position.y), this.worldTransform.tx = this.world.x, this.worldTransform.ty = this.world.y, this.previousPosition.set(this.world.x, this.world.y), this.previousRotation = this.rotation, this.body && this.body.preUpdate(), this.fresh = !1, this.preUpdateChildren(), !1) : (this.previousPosition.set(this.world.x, this.world.y), this.previousRotation = this.rotation, !(!this._exists || !this.parent.exists) || (this.renderOrderID = -1, !1));
        }, s.Component.PhysicsBody.postUpdate = function () {
          this.exists && this.body && this.body.postUpdate();
        }, s.Component.PhysicsBody.prototype = {
          body: null,
          x: {
            get: function get() {
              return this.position.x;
            },
            set: function set(t) {
              this.position.x = t, this.body && !this.body.dirty && (this.body._reset = !0);
            }
          },
          y: {
            get: function get() {
              return this.position.y;
            },
            set: function set(t) {
              this.position.y = t, this.body && !this.body.dirty && (this.body._reset = !0);
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Reset = function () {}, s.Component.Reset.prototype.reset = function (t, e, i) {
          return void 0 === i && (i = 1), this.world.set(t, e), this.position.set(t, e), this.fresh = !0, this.exists = !0, this.visible = !0, this.renderable = !0, this.components.InWorld && (this._outOfBoundsFired = !1), this.components.LifeSpan && (this.alive = !0, this.health = i), this.components.PhysicsBody && this.body && this.body.reset(t, e, !1, !1), this;
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.ScaleMinMax = function () {}, s.Component.ScaleMinMax.prototype = {
          transformCallback: null,
          transformCallbackContext: this,
          scaleMin: null,
          scaleMax: null,
          checkTransform: function checkTransform(t) {
            this.scaleMin && (t.a < this.scaleMin.x && (t.a = this.scaleMin.x), t.d < this.scaleMin.y && (t.d = this.scaleMin.y)), this.scaleMax && (t.a > this.scaleMax.x && (t.a = this.scaleMax.x), t.d > this.scaleMax.y && (t.d = this.scaleMax.y));
          },
          setScaleMinMax: function setScaleMinMax(t, e, i, n) {
            void 0 === e ? e = i = n = t : void 0 === i && (i = n = e, e = t), null === t ? this.scaleMin = null : this.scaleMin ? this.scaleMin.set(t, e) : this.scaleMin = new s.Point(t, e), null === i ? this.scaleMax = null : this.scaleMax ? this.scaleMax.set(i, n) : this.scaleMax = new s.Point(i, n), null === this.scaleMin ? this.transformCallback = null : (this.transformCallback = this.checkTransform, this.transformCallbackContext = this);
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Component.Smoothed = function () {}, s.Component.Smoothed.prototype = {
          smoothed: {
            get: function get() {
              return !this.texture.baseTexture.scaleMode;
            },
            set: function set(t) {
              t ? this.texture && (this.texture.baseTexture.scaleMode = 0, this.texture.baseTexture.dirty()) : this.texture && (this.texture.baseTexture.scaleMode = 1, this.texture.baseTexture.dirty());
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.GameObjectFactory = function (t) {
          this.game = t, this.world = this.game.world;
        }, s.GameObjectFactory.prototype = {
          existing: function existing(t) {
            return this.world.add(t);
          },
          weapon: function weapon(t, e, i, n, o) {
            var r = this.game.plugins.add(s.Weapon);
            return o && (r.bulletClass = o), r.createBullets(t, e, i, n), r;
          },
          image: function image(t, e, i, n, o) {
            return void 0 === o && (o = this.world), o.add(new s.Image(this.game, t, e, i, n));
          },
          sprite: function sprite(t, e, i, n, o) {
            return void 0 === o && (o = this.world), o.add(new s.Sprite(this.game, t, e, i, n));
          },
          creature: function creature(t, e, i, n, o) {
            void 0 === o && (o = this.world);
            var r = new s.Creature(this.game, t, e, i, n);
            return o.add(r), r;
          },
          tween: function tween(t) {
            return this.game.tweens.create(t);
          },
          group: function group(t, e, i, n, o) {
            return new s.Group(this.game, t, e, i, n, o);
          },
          physicsGroup: function physicsGroup(t, e, i, n) {
            return new s.Group(this.game, e, i, n, !0, t);
          },
          spriteBatch: function spriteBatch(t, e, i) {
            return void 0 === t && (t = null), void 0 === e && (e = "group"), void 0 === i && (i = !1), new s.SpriteBatch(this.game, t, e, i);
          },
          audio: function audio(t, e, i, s) {
            return this.game.sound.add(t, e, i, s);
          },
          sound: function sound(t, e, i, s) {
            return this.game.sound.add(t, e, i, s);
          },
          audioSprite: function audioSprite(t) {
            return this.game.sound.addSprite(t);
          },
          tileSprite: function tileSprite(t, e, i, n, o, r, a) {
            return void 0 === a && (a = this.world), a.add(new s.TileSprite(this.game, t, e, i, n, o, r));
          },
          rope: function rope(t, e, i, n, o, r) {
            return void 0 === r && (r = this.world), r.add(new s.Rope(this.game, t, e, i, n, o));
          },
          text: function text(t, e, i, n, o) {
            return void 0 === o && (o = this.world), o.add(new s.Text(this.game, t, e, i, n));
          },
          button: function button(t, e, i, n, o, r, a, h, l, c) {
            return void 0 === c && (c = this.world), c.add(new s.Button(this.game, t, e, i, n, o, r, a, h, l));
          },
          graphics: function graphics(t, e, i) {
            return void 0 === i && (i = this.world), i.add(new s.Graphics(this.game, t, e));
          },
          emitter: function emitter(t, e, i) {
            return this.game.particles.add(new s.Particles.Arcade.Emitter(this.game, t, e, i));
          },
          retroFont: function retroFont(t, e, i, n, o, r, a, h, l) {
            return new s.RetroFont(this.game, t, e, i, n, o, r, a, h, l);
          },
          bitmapText: function bitmapText(t, e, i, n, o, r) {
            return void 0 === r && (r = this.world), r.add(new s.BitmapText(this.game, t, e, i, n, o));
          },
          tilemap: function tilemap(t, e, i, n, o) {
            return new s.Tilemap(this.game, t, e, i, n, o);
          },
          renderTexture: function renderTexture(t, e, i, n) {
            void 0 !== i && "" !== i || (i = this.game.rnd.uuid()), void 0 === n && (n = !1);
            var o = new s.RenderTexture(this.game, t, e, i);
            return n && this.game.cache.addRenderTexture(i, o), o;
          },
          video: function video(t, e) {
            return new s.Video(this.game, t, e);
          },
          bitmapData: function bitmapData(t, e, i, n) {
            void 0 === n && (n = !1), void 0 !== i && "" !== i || (i = this.game.rnd.uuid());
            var o = new s.BitmapData(this.game, i, t, e);
            return n && this.game.cache.addBitmapData(i, o), o;
          },
          filter: function filter(t) {
            var e = Array.prototype.slice.call(arguments, 1);
            return (t = new s.Filter[t](this.game)).init.apply(t, e), t;
          },
          plugin: function plugin() {
            return this.game.plugins.add.apply(this.game.plugins, arguments);
          }
        }, s.GameObjectFactory.prototype.constructor = s.GameObjectFactory,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.GameObjectCreator = function (t) {
          this.game = t, this.world = this.game.world;
        }, s.GameObjectCreator.prototype = {
          image: function image(t, e, i, n) {
            return new s.Image(this.game, t, e, i, n);
          },
          sprite: function sprite(t, e, i, n) {
            return new s.Sprite(this.game, t, e, i, n);
          },
          tween: function tween(t) {
            return new s.Tween(t, this.game, this.game.tweens);
          },
          group: function group(t, e, i, n, o) {
            return new s.Group(this.game, t, e, i, n, o);
          },
          spriteBatch: function spriteBatch(t, e, i) {
            return void 0 === e && (e = "group"), void 0 === i && (i = !1), new s.SpriteBatch(this.game, t, e, i);
          },
          audio: function audio(t, e, i, s) {
            return this.game.sound.add(t, e, i, s);
          },
          audioSprite: function audioSprite(t) {
            return this.game.sound.addSprite(t);
          },
          sound: function sound(t, e, i, s) {
            return this.game.sound.add(t, e, i, s);
          },
          tileSprite: function tileSprite(t, e, i, n, o, r) {
            return new s.TileSprite(this.game, t, e, i, n, o, r);
          },
          rope: function rope(t, e, i, n, o) {
            return new s.Rope(this.game, t, e, i, n, o);
          },
          text: function text(t, e, i, n) {
            return new s.Text(this.game, t, e, i, n);
          },
          button: function button(t, e, i, n, o, r, a, h, l) {
            return new s.Button(this.game, t, e, i, n, o, r, a, h, l);
          },
          graphics: function graphics(t, e) {
            return new s.Graphics(this.game, t, e);
          },
          emitter: function emitter(t, e, i) {
            return new s.Particles.Arcade.Emitter(this.game, t, e, i);
          },
          retroFont: function retroFont(t, e, i, n, o, r, a, h, l) {
            return new s.RetroFont(this.game, t, e, i, n, o, r, a, h, l);
          },
          bitmapText: function bitmapText(t, e, i, n, o, r) {
            return new s.BitmapText(this.game, t, e, i, n, o, r);
          },
          tilemap: function tilemap(t, e, i, n, o) {
            return new s.Tilemap(this.game, t, e, i, n, o);
          },
          renderTexture: function renderTexture(t, e, i, n) {
            void 0 !== i && "" !== i || (i = this.game.rnd.uuid()), void 0 === n && (n = !1);
            var o = new s.RenderTexture(this.game, t, e, i);
            return n && this.game.cache.addRenderTexture(i, o), o;
          },
          bitmapData: function bitmapData(t, e, i, n) {
            void 0 === n && (n = !1), void 0 !== i && "" !== i || (i = this.game.rnd.uuid());
            var o = new s.BitmapData(this.game, i, t, e);
            return n && this.game.cache.addBitmapData(i, o), o;
          },
          filter: function filter(t) {
            var e = Array.prototype.slice.call(arguments, 1);
            return (t = new s.Filter[t](this.game)).init.apply(t, e), t;
          }
        }, s.GameObjectCreator.prototype.constructor = s.GameObjectCreator,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Sprite = function (t, e, i, n, o) {
          e = e || 0, i = i || 0, n = n || null, o = o || null, this.type = s.SPRITE, this.physicsType = s.SPRITE, PIXI.Sprite.call(this, s.Cache.DEFAULT), s.Component.Core.init.call(this, t, e, i, n, o);
        }, s.Sprite.prototype = Object.create(PIXI.Sprite.prototype), s.Sprite.prototype.constructor = s.Sprite, s.Component.Core.install.call(s.Sprite.prototype, ["Angle", "Animation", "AutoCull", "Bounds", "BringToTop", "Crop", "Delta", "Destroy", "FixedToCamera", "Health", "InCamera", "InputEnabled", "InWorld", "LifeSpan", "LoadTexture", "Overlap", "PhysicsBody", "Reset", "ScaleMinMax", "Smoothed"]), s.Sprite.prototype.preUpdatePhysics = s.Component.PhysicsBody.preUpdate, s.Sprite.prototype.preUpdateLifeSpan = s.Component.LifeSpan.preUpdate, s.Sprite.prototype.preUpdateInWorld = s.Component.InWorld.preUpdate, s.Sprite.prototype.preUpdateCore = s.Component.Core.preUpdate, s.Sprite.prototype.preUpdate = function () {
          return !!(this.preUpdatePhysics() && this.preUpdateLifeSpan() && this.preUpdateInWorld()) && this.preUpdateCore();
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Image = function (t, e, i, n, o) {
          e = e || 0, i = i || 0, n = n || null, o = o || null, this.type = s.IMAGE, PIXI.Sprite.call(this, s.Cache.DEFAULT), s.Component.Core.init.call(this, t, e, i, n, o);
        }, s.Image.prototype = Object.create(PIXI.Sprite.prototype), s.Image.prototype.constructor = s.Image, s.Component.Core.install.call(s.Image.prototype, ["Angle", "Animation", "AutoCull", "Bounds", "BringToTop", "Crop", "Destroy", "FixedToCamera", "InputEnabled", "LifeSpan", "LoadTexture", "Overlap", "Reset", "ScaleMinMax", "Smoothed"]), s.Image.prototype.preUpdateLifeSpan = s.Component.LifeSpan.preUpdate, s.Image.prototype.preUpdateInWorld = s.Component.InWorld.preUpdate, s.Image.prototype.preUpdateCore = s.Component.Core.preUpdate, s.Image.prototype.preUpdate = function () {
          return !(!this.preUpdateInWorld() || !this.preUpdateLifeSpan()) && this.preUpdateCore();
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Button = function (t, e, i, n, o, r, a, h, l, c) {
          e = e || 0, i = i || 0, n = n || null, o = o || null, r = r || this, s.Image.call(this, t, e, i, n, h), this.type = s.BUTTON, this.physicsType = s.SPRITE, this._onOverFrame = null, this._onOutFrame = null, this._onDownFrame = null, this._onUpFrame = null, this.onOverSound = null, this.onOutSound = null, this.onDownSound = null, this.onUpSound = null, this.onOverSoundMarker = "", this.onOutSoundMarker = "", this.onDownSoundMarker = "", this.onUpSoundMarker = "", this.onInputOver = new s.Signal(), this.onInputOut = new s.Signal(), this.onInputDown = new s.Signal(), this.onInputUp = new s.Signal(), this.onOverMouseOnly = !0, this.justReleasedPreventsOver = s.PointerMode.CONTACT, this.freezeFrames = !1, this.forceOut = !1, this.inputEnabled = !0, this.input.start(0, !0), this.input.useHandCursor = !0, this.setFrames(a, h, l, c), null !== o && this.onInputUp.add(o, r), this.events.onInputOver.add(this.onInputOverHandler, this), this.events.onInputOut.add(this.onInputOutHandler, this), this.events.onInputDown.add(this.onInputDownHandler, this), this.events.onInputUp.add(this.onInputUpHandler, this);
        }, s.Button.prototype = Object.create(s.Image.prototype), s.Button.prototype.constructor = s.Button;
        return s.Button.prototype.clearFrames = function () {
          this.setFrames(null, null, null, null);
        }, s.Button.prototype.setStateFrame = function (t, e, i) {
          var s = "_on" + t + "Frame";
          null !== e ? (this[s] = e, i && this.changeStateFrame(t)) : this[s] = null;
        }, s.Button.prototype.changeStateFrame = function (t) {
          if (this.freezeFrames) return !1;
          var e = this["_on" + t + "Frame"];
          return "string" == typeof e ? (this.frameName = e, !0) : "number" == typeof e && (this.frame = e, !0);
        }, s.Button.prototype.setFrames = function (t, e, i, s) {
          this.setStateFrame("Over", t, this.input.pointerOver()), this.setStateFrame("Out", e, !this.input.pointerOver()), this.setStateFrame("Down", i, this.input.pointerDown()), this.setStateFrame("Up", s, this.input.pointerUp());
        }, s.Button.prototype.setStateSound = function (t, e, i) {
          var n = "on" + t + "Sound",
              o = "on" + t + "SoundMarker";
          e instanceof s.Sound || e instanceof s.AudioSprite ? (this[n] = e, this[o] = "string" == typeof i ? i : "") : (this[n] = null, this[o] = "");
        }, s.Button.prototype.playStateSound = function (t) {
          var e = this["on" + t + "Sound"];

          if (e) {
            var i = this["on" + t + "SoundMarker"];
            return e.play(i), !0;
          }

          return !1;
        }, s.Button.prototype.setSounds = function (t, e, i, s, n, o, r, a) {
          this.setStateSound("Over", t, e), this.setStateSound("Out", n, o), this.setStateSound("Down", i, s), this.setStateSound("Up", r, a);
        }, s.Button.prototype.setOverSound = function (t, e) {
          this.setStateSound("Over", t, e);
        }, s.Button.prototype.setOutSound = function (t, e) {
          this.setStateSound("Out", t, e);
        }, s.Button.prototype.setDownSound = function (t, e) {
          this.setStateSound("Down", t, e);
        }, s.Button.prototype.setUpSound = function (t, e) {
          this.setStateSound("Up", t, e);
        }, s.Button.prototype.onInputOverHandler = function (t, e) {
          e.justReleased() && (this.justReleasedPreventsOver & e.pointerMode) === e.pointerMode || (this.changeStateFrame("Over"), this.onOverMouseOnly && !e.isMouse || (this.playStateSound("Over"), this.onInputOver && this.onInputOver.dispatch(this, e)));
        }, s.Button.prototype.onInputOutHandler = function (t, e) {
          this.changeStateFrame("Out"), this.playStateSound("Out"), this.onInputOut && this.onInputOut.dispatch(this, e);
        }, s.Button.prototype.onInputDownHandler = function (t, e) {
          this.changeStateFrame("Down"), this.playStateSound("Down"), this.onInputDown && this.onInputDown.dispatch(this, e);
        }, s.Button.prototype.onInputUpHandler = function (t, e, i) {
          (this.playStateSound("Up"), this.onInputUp && this.onInputUp.dispatch(this, e, i), this.freezeFrames) || (!0 === this.forceOut || (this.forceOut & e.pointerMode) === e.pointerMode ? this.changeStateFrame("Out") : this.changeStateFrame("Up") || (i ? this.changeStateFrame("Over") : this.changeStateFrame("Out")));
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.SpriteBatch = function (t, e, i, n) {
          void 0 !== e && null !== e || (e = t.world), s.Group.call(this, t, e, i, n), this.type = s.SPRITEBATCH, this.fastSpriteBatch = null, this.ready = !1;
        }, s.SpriteBatch.prototype = Object.create(s.Group.prototype), s.SpriteBatch.prototype.constructor = s.SpriteBatch, s.SpriteBatch.prototype._renderWebGL = function (t) {
          !this.visible || this.alpha <= 0 || !this.children.length || (this.ready || (this.fastSpriteBatch = new PIXI.WebGLFastSpriteBatch(t.gl), this.ready = !0), this.fastSpriteBatch.gl !== t.gl && this.fastSpriteBatch.setContext(t.gl), t.spriteBatch.stop(), t.shaderManager.setShader(t.shaderManager.fastShader), this.fastSpriteBatch.begin(this, t), this.fastSpriteBatch.render(this), t.spriteBatch.start());
        }, s.SpriteBatch.prototype._renderCanvas = function (t) {
          if (this.visible && !(this.alpha <= 0) && this.children.length) {
            var e = t.context;
            e.globalAlpha = this.worldAlpha, this.displayObjectUpdateTransform();

            for (var i = this.worldTransform, s = !0, n = 0; n < this.children.length; n++) {
              var o = this.children[n];

              if (o.visible) {
                var r = o.texture,
                    a = r.frame;
                if (e.globalAlpha = this.worldAlpha * o.alpha, o.rotation % (2 * Math.PI) == 0) s && (e.setTransform(i.a, i.b, i.c, i.d, i.tx, i.ty), s = !1), e.drawImage(r.baseTexture.source, a.x, a.y, a.width, a.height, o.anchor.x * (-a.width * o.scale.x) + o.position.x + .5 + t.shakeX | 0, o.anchor.y * (-a.height * o.scale.y) + o.position.y + .5 + t.shakeY | 0, a.width * o.scale.x, a.height * o.scale.y);else {
                  s || (s = !0), o.displayObjectUpdateTransform();
                  var h = o.worldTransform,
                      l = h.tx * t.resolution + t.shakeX,
                      c = h.ty * t.resolution + t.shakeY;
                  t.roundPixels ? e.setTransform(h.a, h.b, h.c, h.d, 0 | l, 0 | c) : e.setTransform(h.a, h.b, h.c, h.d, l, c), e.drawImage(r.baseTexture.source, a.x, a.y, a.width, a.height, o.anchor.x * -a.width + .5 | 0, o.anchor.y * -a.height + .5 | 0, a.width, a.height);
                }
              }
            }
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.BitmapData = function (t, e, i, n, o) {
          void 0 !== i && 0 !== i || (i = 256), void 0 !== n && 0 !== n || (n = 256), void 0 === o && (o = !1), this.game = t, this.key = e, this.width = i, this.height = n, this.canvas = s.Canvas.create(this, i, n, null, o), this.context = this.canvas.getContext("2d", {
            alpha: !0
          }), this.ctx = this.context, this.smoothProperty = t.renderType === s.CANVAS ? t.renderer.renderSession.smoothProperty : s.Canvas.getSmoothingPrefix(this.context), this.imageData = this.context.getImageData(0, 0, i, n), this.data = null, this.imageData && (this.data = this.imageData.data), this.pixels = null, this.data && (this.imageData.data.buffer ? (this.buffer = this.imageData.data.buffer, this.pixels = new Uint32Array(this.buffer)) : window.ArrayBuffer ? (this.buffer = new ArrayBuffer(this.imageData.data.length), this.pixels = new Uint32Array(this.buffer)) : this.pixels = this.imageData.data), this.baseTexture = new PIXI.BaseTexture(this.canvas, null, this.game.resolution), this.texture = new PIXI.Texture(this.baseTexture), this.frameData = new s.FrameData(), this.textureFrame = this.frameData.addFrame(new s.Frame(0, 0, 0, i, n, "bitmapData")), this.texture.frame = this.textureFrame, this.type = s.BITMAPDATA, this.disableTextureUpload = !1, this.dirty = !1, this.cls = this.clear, this._image = null, this._pos = new s.Point(), this._size = new s.Point(), this._scale = new s.Point(), this._rotate = 0, this._alpha = {
            prev: 1,
            current: 1
          }, this._anchor = new s.Point(), this._tempR = 0, this._tempG = 0, this._tempB = 0, this._circle = new s.Circle(), this._swapCanvas = void 0;
        }, s.BitmapData.prototype = {
          move: function move(t, e, i) {
            return 0 !== t && this.moveH(t, i), 0 !== e && this.moveV(e, i), this;
          },
          moveH: function moveH(t, e) {
            void 0 === e && (e = !0), void 0 === this._swapCanvas && (this._swapCanvas = s.CanvasPool.create(this, this.width, this.height));

            var i = this._swapCanvas.getContext("2d"),
                n = this.height,
                o = this.canvas;

            if (i.clearRect(0, 0, this.width, this.height), t < 0) {
              t = Math.abs(t);
              var r = this.width - t;
              e && i.drawImage(o, 0, 0, t, n, r, 0, t, n), i.drawImage(o, t, 0, r, n, 0, 0, r, n);
            } else {
              r = this.width - t;
              e && i.drawImage(o, r, 0, t, n, 0, 0, t, n), i.drawImage(o, 0, 0, r, n, t, 0, r, n);
            }

            return this.clear(), this.copy(this._swapCanvas);
          },
          moveV: function moveV(t, e) {
            void 0 === e && (e = !0), void 0 === this._swapCanvas && (this._swapCanvas = s.CanvasPool.create(this, this.width, this.height));

            var i = this._swapCanvas.getContext("2d"),
                n = this.width,
                o = this.canvas;

            if (i.clearRect(0, 0, this.width, this.height), t < 0) {
              t = Math.abs(t);
              var r = this.height - t;
              e && i.drawImage(o, 0, 0, n, t, 0, r, n, t), i.drawImage(o, 0, t, n, r, 0, 0, n, r);
            } else {
              r = this.height - t;
              e && i.drawImage(o, 0, r, n, t, 0, 0, n, t), i.drawImage(o, 0, 0, n, r, 0, t, n, r);
            }

            return this.clear(), this.copy(this._swapCanvas);
          },
          add: function add(t) {
            if (Array.isArray(t)) for (var e = 0; e < t.length; e++) {
              t[e].loadTexture && t[e].loadTexture(this);
            } else t.loadTexture(this);
            return this;
          },
          load: function load(t) {
            if ("string" == typeof t && (t = this.game.cache.getImage(t)), t) return this.resize(t.width, t.height), this.cls(), this.draw(t), this.update(), this;
          },
          clear: function clear(t, e, i, s) {
            return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.width), void 0 === s && (s = this.height), this.context.clearRect(t, e, i, s), this.dirty = !0, this;
          },
          fill: function fill(t, e, i, s) {
            return void 0 === s && (s = 1), this.context.fillStyle = "rgba(" + t + "," + e + "," + i + "," + s + ")", this.context.fillRect(0, 0, this.width, this.height), this.dirty = !0, this;
          },
          generateTexture: function generateTexture(t, e, i) {
            var s = this.game.cache,
                n = new Image();

            if (e && (n.onload = function () {
              var o = s.addImage(t, "", n),
                  r = new PIXI.Texture(o.base);
              e.call(i || null, r), n.onload = null;
            }), n.src = this.canvas.toDataURL("image/png"), !e) {
              var o = s.addImage(t, "", n);
              return new PIXI.Texture(o.base);
            }

            return null;
          },
          resize: function resize(t, e) {
            return t === this.width && e === this.height || (this.width = t, this.height = e, this.canvas.width = t, this.canvas.height = e, void 0 !== this._swapCanvas && (this._swapCanvas.width = t, this._swapCanvas.height = e), this.baseTexture.width = t, this.baseTexture.height = e, this.textureFrame.width = t, this.textureFrame.height = e, this.texture.width = t, this.texture.height = e, this.texture.crop.width = t, this.texture.crop.height = e, this.update(), this.dirty = !0), this;
          },
          update: function update(t, e, i, s) {
            return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = Math.max(1, this.width)), void 0 === s && (s = Math.max(1, this.height)), this.imageData = this.context.getImageData(t, e, i, s), this.data = this.imageData.data, this.imageData.data.buffer ? (this.buffer = this.imageData.data.buffer, this.pixels = new Uint32Array(this.buffer)) : window.ArrayBuffer ? (this.buffer = new ArrayBuffer(this.imageData.data.length), this.pixels = new Uint32Array(this.buffer)) : this.pixels = this.imageData.data, this;
          },
          processPixelRGB: function processPixelRGB(t, e, i, n, o, r) {
            void 0 === i && (i = 0), void 0 === n && (n = 0), void 0 === o && (o = this.width), void 0 === r && (r = this.height);

            for (var a = i + o, h = n + r, l = s.Color.createColor(), c = {
              r: 0,
              g: 0,
              b: 0,
              a: 0
            }, u = !1, d = n; d < h; d++) {
              for (var p = i; p < a; p++) {
                s.Color.unpackPixel(this.getPixel32(p, d), l), !1 !== (c = t.call(e, l, p, d)) && null !== c && void 0 !== c && (this.setPixel32(p, d, c.r, c.g, c.b, c.a, !1), u = !0);
              }
            }

            return u && (this.context.putImageData(this.imageData, 0, 0), this.dirty = !0), this;
          },
          processPixel: function processPixel(t, e, i, s, n, o) {
            void 0 === i && (i = 0), void 0 === s && (s = 0), void 0 === n && (n = this.width), void 0 === o && (o = this.height);

            for (var r = i + n, a = s + o, h = 0, l = 0, c = !1, u = s; u < a; u++) {
              for (var d = i; d < r; d++) {
                h = this.getPixel32(d, u), (l = t.call(e, h, d, u)) !== h && (this.pixels[u * this.width + d] = l, c = !0);
              }
            }

            return c && (this.context.putImageData(this.imageData, 0, 0), this.dirty = !0), this;
          },
          replaceRGB: function replaceRGB(t, e, i, n, o, r, a, h, l) {
            var c = 0,
                u = 0,
                d = this.width,
                p = this.height,
                f = s.Color.packPixel(t, e, i, n);
            void 0 !== l && l instanceof s.Rectangle && (c = l.x, u = l.y, d = l.width, p = l.height);

            for (var g = 0; g < p; g++) {
              for (var m = 0; m < d; m++) {
                this.getPixel32(c + m, u + g) === f && this.setPixel32(c + m, u + g, o, r, a, h, !1);
              }
            }

            return this.context.putImageData(this.imageData, 0, 0), this.dirty = !0, this;
          },
          setHSL: function setHSL(t, e, i, n) {
            var o = t || 0 === t,
                r = e || 0 === e,
                a = i || 0 === i;

            if (o || r || a) {
              void 0 === n && (n = new s.Rectangle(0, 0, this.width, this.height));

              for (var h = s.Color.createColor(), l = n.y; l < n.bottom; l++) {
                for (var c = n.x; c < n.right; c++) {
                  s.Color.unpackPixel(this.getPixel32(c, l), h, !0), o && (h.h = t), r && (h.s = e), a && (h.l = i), s.Color.HSLtoRGB(h.h, h.s, h.l, h), this.setPixel32(c, l, h.r, h.g, h.b, h.a, !1);
                }
              }

              return this.context.putImageData(this.imageData, 0, 0), this.dirty = !0, this;
            }
          },
          shiftHSL: function shiftHSL(t, e, i, n) {
            if (void 0 !== t && null !== t || (t = !1), void 0 !== e && null !== e || (e = !1), void 0 !== i && null !== i || (i = !1), t || e || i) {
              void 0 === n && (n = new s.Rectangle(0, 0, this.width, this.height));

              for (var o = s.Color.createColor(), r = n.y; r < n.bottom; r++) {
                for (var a = n.x; a < n.right; a++) {
                  s.Color.unpackPixel(this.getPixel32(a, r), o, !0), t && (o.h = this.game.math.wrap(o.h + t, 0, 1)), e && (o.s = this.game.math.clamp(o.s + e, 0, 1)), i && (o.l = this.game.math.clamp(o.l + i, 0, 1)), s.Color.HSLtoRGB(o.h, o.s, o.l, o), this.setPixel32(a, r, o.r, o.g, o.b, o.a, !1);
                }
              }

              return this.context.putImageData(this.imageData, 0, 0), this.dirty = !0, this;
            }
          },
          setPixel32: function setPixel32(t, e, i, n, o, r, a) {
            return void 0 === a && (a = !0), t >= 0 && t <= this.width && e >= 0 && e <= this.height && (s.Device.LITTLE_ENDIAN ? this.pixels[e * this.width + t] = r << 24 | o << 16 | n << 8 | i : this.pixels[e * this.width + t] = i << 24 | n << 16 | o << 8 | r, a && (this.context.putImageData(this.imageData, 0, 0), this.dirty = !0)), this;
          },
          setPixel: function setPixel(t, e, i, s, n, o) {
            return this.setPixel32(t, e, i, s, n, 255, o);
          },
          getPixel: function getPixel(t, e, i) {
            i || (i = s.Color.createColor());
            var n = ~~(t + e * this.width);
            return n *= 4, i.r = this.data[n], i.g = this.data[++n], i.b = this.data[++n], i.a = this.data[++n], i;
          },
          getPixel32: function getPixel32(t, e) {
            if (t >= 0 && t <= this.width && e >= 0 && e <= this.height) return this.pixels[e * this.width + t];
          },
          getPixelRGB: function getPixelRGB(t, e, i, n, o) {
            return s.Color.unpackPixel(this.getPixel32(t, e), i, n, o);
          },
          getPixels: function getPixels(t) {
            return this.context.getImageData(t.x, t.y, t.width, t.height);
          },
          getFirstPixel: function getFirstPixel(t) {
            void 0 === t && (t = 0);
            var e = s.Color.createColor(),
                i = 0,
                n = 0,
                o = 1,
                r = !1;
            1 === t ? (o = -1, n = this.height) : 3 === t && (o = -1, i = this.width);

            do {
              s.Color.unpackPixel(this.getPixel32(i, n), e), 0 === t || 1 === t ? ++i === this.width && (i = 0, ((n += o) >= this.height || n <= 0) && (r = !0)) : 2 !== t && 3 !== t || ++n === this.height && (n = 0, ((i += o) >= this.width || i <= 0) && (r = !0));
            } while (0 === e.a && !r);

            return e.x = i, e.y = n, e;
          },
          getBounds: function getBounds(t) {
            return void 0 === t && (t = new s.Rectangle()), t.x = this.getFirstPixel(2).x, t.x === this.width ? t.setTo(0, 0, 0, 0) : (t.y = this.getFirstPixel(0).y, t.width = this.getFirstPixel(3).x - t.x + 1, t.height = this.getFirstPixel(1).y - t.y + 1, t);
          },
          addToWorld: function addToWorld(t, e, i, s, n, o) {
            n = n || 1, o = o || 1;
            var r = this.game.add.image(t, e, this);
            return r.anchor.set(i, s), r.scale.set(n, o), r;
          },
          copy: function copy(t, e, i, n, o, r, a, h, l, c, u, d, p, f, g, m, y) {
            if (void 0 !== t && null !== t || (t = this), t instanceof s.RenderTexture && (t = t.getCanvas()), this._image = t, t instanceof s.Sprite || t instanceof s.Image || t instanceof s.Text || t instanceof PIXI.Sprite) this._pos.set(t.texture.crop.x, t.texture.crop.y), this._size.set(t.texture.crop.width, t.texture.crop.height), this._scale.set(t.scale.x, t.scale.y), this._anchor.set(t.anchor.x, t.anchor.y), this._rotate = t.rotation, this._alpha.current = t.alpha, t.texture instanceof s.RenderTexture ? this._image = t.texture.getCanvas() : this._image = t.texture.baseTexture.source, void 0 !== r && null !== r || (r = t.x), void 0 !== a && null !== a || (a = t.y), t.texture.trim && (r += t.texture.trim.x - t.anchor.x * t.texture.trim.width, a += t.texture.trim.y - t.anchor.y * t.texture.trim.height), 16777215 !== t.tint && (t.cachedTint !== t.tint && (t.cachedTint = t.tint, t.tintedTexture = PIXI.CanvasTinter.getTintedTexture(t, t.tint)), this._image = t.tintedTexture, this._pos.set(0));else {
              if (this._pos.set(0), this._scale.set(1), this._anchor.set(0), this._rotate = 0, this._alpha.current = 1, t instanceof s.BitmapData) this._image = t.canvas;else if ("string" == typeof t) {
                if (null === (t = this.game.cache.getImage(t))) return;
                this._image = t;
              }

              this._size.set(this._image.width, this._image.height);
            }

            if (void 0 !== e && null !== e || (e = 0), void 0 !== i && null !== i || (i = 0), n && (this._size.x = n), o && (this._size.y = o), void 0 !== r && null !== r || (r = e), void 0 !== a && null !== a || (a = i), void 0 !== h && null !== h || (h = this._size.x), void 0 !== l && null !== l || (l = this._size.y), "number" == typeof c && (this._rotate = c), "number" == typeof u && (this._anchor.x = u), "number" == typeof d && (this._anchor.y = d), "number" == typeof p && (this._scale.x = p), "number" == typeof f && (this._scale.y = f), "number" == typeof g && (this._alpha.current = g), void 0 === m && (m = null), void 0 === y && (y = !1), !(this._alpha.current <= 0 || 0 === this._scale.x || 0 === this._scale.y || 0 === this._size.x || 0 === this._size.y)) {
              var v = this.context;
              return this._alpha.prev = v.globalAlpha, v.save(), v.globalAlpha = this._alpha.current, m && (this.op = m), y && (r |= 0, a |= 0), v.translate(r, a), v.scale(this._scale.x, this._scale.y), v.rotate(this._rotate), v.drawImage(this._image, this._pos.x + e, this._pos.y + i, this._size.x, this._size.y, -h * this._anchor.x, -l * this._anchor.y, h, l), v.restore(), v.globalAlpha = this._alpha.prev, this.dirty = !0, this;
            }
          },
          copyTransform: function copyTransform(t, e, i) {
            if (void 0 === e && (e = null), void 0 === i && (i = !1), !t.hasOwnProperty("worldTransform") || !t.worldVisible || 0 === t.worldAlpha) return this;
            var n = t.worldTransform;
            if (this._pos.set(t.texture.crop.x, t.texture.crop.y), this._size.set(t.texture.crop.width, t.texture.crop.height), 0 === n.a || 0 === n.d || 0 === this._size.x || 0 === this._size.y) return this;
            t.texture instanceof s.RenderTexture ? this._image = t.texture.getCanvas() : this._image = t.texture.baseTexture.source;
            var o = n.tx,
                r = n.ty;
            t.texture.trim && (o += t.texture.trim.x - t.anchor.x * t.texture.trim.width, r += t.texture.trim.y - t.anchor.y * t.texture.trim.height), 16777215 !== t.tint && (t.cachedTint !== t.tint && (t.cachedTint = t.tint, t.tintedTexture = PIXI.CanvasTinter.getTintedTexture(t, t.tint)), this._image = t.tintedTexture, this._pos.set(0)), i && (o |= 0, r |= 0);
            var a = this.context;
            return this._alpha.prev = a.globalAlpha, a.save(), a.globalAlpha = this._alpha.current, e && (this.op = e), a[this.smoothProperty] = t.texture.baseTexture.scaleMode === PIXI.scaleModes.LINEAR, a.setTransform(n.a, n.b, n.c, n.d, o, r), a.drawImage(this._image, this._pos.x, this._pos.y, this._size.x, this._size.y, -this._size.x * t.anchor.x, -this._size.y * t.anchor.y, this._size.x, this._size.y), a.restore(), a.globalAlpha = this._alpha.prev, this.dirty = !0, this;
          },
          copyRect: function copyRect(t, e, i, s, n, o, r) {
            return this.copy(t, e.x, e.y, e.width, e.height, i, s, e.width, e.height, 0, 0, 0, 1, 1, n, o, r);
          },
          draw: function draw(t, e, i, s, n, o, r) {
            return this.copy(t, null, null, null, null, e, i, s, n, null, null, null, null, null, null, o, r);
          },
          drawGroup: function drawGroup(t, e, i) {
            return t.total > 0 && t.forEachExists(this.drawGroupProxy, this, e, i), this;
          },
          drawGroupProxy: function drawGroupProxy(t, e, i) {
            if (t.hasOwnProperty("texture") && this.copyTransform(t, e, i), t.type === s.GROUP && t.exists) this.drawGroup(t, e, i);else if (t.hasOwnProperty("children") && t.children.length > 0) for (var n = 0; n < t.children.length; n++) {
              t.children[n].exists && this.copyTransform(t.children[n], e, i);
            }
          },
          drawFull: function drawFull(t, e, i) {
            if (!1 === t.worldVisible || 0 === t.worldAlpha || t.hasOwnProperty("exists") && !1 === t.exists) return this;
            if (t.type !== s.GROUP && t.type !== s.EMITTER && t.type !== s.BITMAPTEXT) if (t.type === s.GRAPHICS) {
              var n = t.getBounds();
              this.ctx.save(), this.ctx.translate(n.x, n.y), PIXI.CanvasGraphics.renderGraphics(t, this.ctx), this.ctx.restore();
            } else this.copy(t, null, null, null, null, t.worldPosition.x, t.worldPosition.y, null, null, t.worldRotation, null, null, t.worldScale.x, t.worldScale.y, t.worldAlpha, e, i);
            if (t.children) for (var o = 0; o < t.children.length; o++) {
              this.drawFull(t.children[o], e, i);
            }
            return this;
          },
          shadow: function shadow(t, e, i, s) {
            var n = this.context;
            return void 0 === t || null === t ? n.shadowColor = "rgba(0,0,0,0)" : (n.shadowColor = t, n.shadowBlur = e || 5, n.shadowOffsetX = i || 10, n.shadowOffsetY = s || 10), this;
          },
          alphaMask: function alphaMask(t, e, i, s) {
            return void 0 === s || null === s ? this.draw(e).blendSourceAtop() : this.draw(e, s.x, s.y, s.width, s.height).blendSourceAtop(), void 0 === i || null === i ? this.draw(t).blendReset() : this.draw(t, i.x, i.y, i.width, i.height).blendReset(), this;
          },
          extract: function extract(t, e, i, s, n, o, r, a, h) {
            return void 0 === n && (n = 255), void 0 === o && (o = !1), void 0 === r && (r = e), void 0 === a && (a = i), void 0 === h && (h = s), o && t.resize(this.width, this.height), this.processPixelRGB(function (o, l, c) {
              return o.r === e && o.g === i && o.b === s && t.setPixel32(l, c, r, a, h, n, !1), !1;
            }, this), t.context.putImageData(t.imageData, 0, 0), t.dirty = !0, t;
          },
          rect: function rect(t, e, i, s, n) {
            return void 0 !== n && (this.context.fillStyle = n), this.context.fillRect(t, e, i, s), this;
          },
          text: function text(t, e, i, s, n, o) {
            void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === s && (s = "14px Courier"), void 0 === n && (n = "rgb(255,255,255)"), void 0 === o && (o = !0);
            var r = this.context,
                a = r.font;
            return r.font = s, o && (r.fillStyle = "rgb(0,0,0)", r.fillText(t, e + 1, i + 1)), r.fillStyle = n, r.fillText(t, e, i), r.font = a, this;
          },
          circle: function circle(t, e, i, s) {
            var n = this.context;
            return void 0 !== s && (n.fillStyle = s), n.beginPath(), n.arc(t, e, i, 0, 2 * Math.PI, !1), n.closePath(), n.fill(), this;
          },
          line: function line(t, e, i, s, n, o) {
            void 0 === n && (n = "#fff"), void 0 === o && (o = 1);
            var r = this.context;
            return r.beginPath(), r.moveTo(t, e), r.lineTo(i, s), r.lineWidth = o, r.strokeStyle = n, r.stroke(), r.closePath(), this;
          },
          polygon: function polygon(t, e, i, s) {
            void 0 === s && (s = "#fff"), void 0 === i && (i = 0);
            var n = this.context;
            e && (n.fillStyle = e), i && (n.lineWidth = i, n.strokeStyle = s), n.beginPath(), n.moveTo(t[0].x, t[0].y);

            for (var o = 1, r = t.length; o < r; o++) {
              var a = t[o];
              n.lineTo(a.x, a.y);
            }

            return n.closePath(), e && n.fill(), i && n.stroke(), this;
          },
          textureLine: function textureLine(t, e, i) {
            if (void 0 === i && (i = "repeat-x"), "string" != typeof e || (e = this.game.cache.getImage(e))) {
              var n = t.length;
              "no-repeat" === i && n > e.width && (n = e.width);
              var o = this.context;
              return o.fillStyle = o.createPattern(e, i), this._circle = new s.Circle(t.start.x, t.start.y, e.height), this._circle.circumferencePoint(t.angle - 1.5707963267948966, !1, this._pos), o.save(), o.translate(this._pos.x, this._pos.y), o.rotate(t.angle), o.fillRect(0, 0, n, e.height), o.restore(), this.dirty = !0, this;
            }
          },
          render: function render() {
            return !this.disableTextureUpload && this.dirty && (this.baseTexture.dirty(), this.dirty = !1), this;
          },
          destroy: function destroy() {
            this.frameData.destroy(), this.texture.destroy(!0), s.CanvasPool.remove(this);
          },
          blendReset: function blendReset() {
            return this.op = "source-over", this;
          },
          blendSourceOver: function blendSourceOver() {
            return this.op = "source-over", this;
          },
          blendSourceIn: function blendSourceIn() {
            return this.op = "source-in", this;
          },
          blendSourceOut: function blendSourceOut() {
            return this.op = "source-out", this;
          },
          blendSourceAtop: function blendSourceAtop() {
            return this.op = "source-atop", this;
          },
          blendDestinationOver: function blendDestinationOver() {
            return this.op = "destination-over", this;
          },
          blendDestinationIn: function blendDestinationIn() {
            return this.op = "destination-in", this;
          },
          blendDestinationOut: function blendDestinationOut() {
            return this.op = "destination-out", this;
          },
          blendDestinationAtop: function blendDestinationAtop() {
            return this.op = "destination-atop", this;
          },
          blendXor: function blendXor() {
            return this.op = "xor", this;
          },
          blendAdd: function blendAdd() {
            return this.op = "lighter", this;
          },
          blendMultiply: function blendMultiply() {
            return this.op = "multiply", this;
          },
          blendScreen: function blendScreen() {
            return this.op = "screen", this;
          },
          blendOverlay: function blendOverlay() {
            return this.op = "overlay", this;
          },
          blendDarken: function blendDarken() {
            return this.op = "darken", this;
          },
          blendLighten: function blendLighten() {
            return this.op = "lighten", this;
          },
          blendColorDodge: function blendColorDodge() {
            return this.op = "color-dodge", this;
          },
          blendColorBurn: function blendColorBurn() {
            return this.op = "color-burn", this;
          },
          blendHardLight: function blendHardLight() {
            return this.op = "hard-light", this;
          },
          blendSoftLight: function blendSoftLight() {
            return this.op = "soft-light", this;
          },
          blendDifference: function blendDifference() {
            return this.op = "difference", this;
          },
          blendExclusion: function blendExclusion() {
            return this.op = "exclusion", this;
          },
          blendHue: function blendHue() {
            return this.op = "hue", this;
          },
          blendSaturation: function blendSaturation() {
            return this.op = "saturation", this;
          },
          blendColor: function blendColor() {
            return this.op = "color", this;
          },
          blendLuminosity: function blendLuminosity() {
            return this.op = "luminosity", this;
          },
          copyBitmapData: function copyBitmapData(t, e, i) {
            t.update();

            for (var s, n = 0; n < t.height; n++) {
              s = (i + n) * this.width + e;

              for (var o = 0; o < t.width; o++) {
                this.pixels[s + o] = t.pixels[n * t.width + o];
              }
            }

            return this;
          }
        }, Object.defineProperty(s.BitmapData.prototype, "smoothed", {
          get: function get() {
            s.Canvas.getSmoothingEnabled(this.context);
          },
          set: function set(t) {
            s.Canvas.setSmoothingEnabled(this.context, t);
          }
        }), Object.defineProperty(s.BitmapData.prototype, "op", {
          get: function get() {
            return this.context.globalCompositeOperation;
          },
          set: function set(t) {
            this.context.globalCompositeOperation = t;
          }
        }), s.BitmapData.getTransform = function (t, e, i, s, n, o) {
          return "number" != typeof t && (t = 0), "number" != typeof e && (e = 0), "number" != typeof i && (i = 1), "number" != typeof s && (s = 1), "number" != typeof n && (n = 0), "number" != typeof o && (o = 0), {
            sx: i,
            sy: s,
            scaleX: i,
            scaleY: s,
            skewX: n,
            skewY: o,
            translateX: t,
            translateY: e,
            tx: t,
            ty: e
          };
        }, s.BitmapData.prototype.constructor = s.BitmapData, s.EarCut = {}, s.EarCut.Triangulate = function (t, e, i) {
          i = i || 2;
          var n,
              o,
              r,
              a,
              h,
              l,
              c,
              u = e && e.length,
              d = u ? e[0] * i : t.length,
              p = s.EarCut.linkedList(t, 0, d, i, !0),
              f = [];
          if (!p) return f;

          if (u && (p = s.EarCut.eliminateHoles(t, e, p, i)), t.length > 80 * i) {
            n = r = t[0], o = a = t[1];

            for (var g = i; g < d; g += i) {
              h = t[g], l = t[g + 1], h < n && (n = h), l < o && (o = l), h > r && (r = h), l > a && (a = l);
            }

            c = Math.max(r - n, a - o);
          }

          return s.EarCut.earcutLinked(p, f, i, n, o, c), f;
        }, s.EarCut.linkedList = function (t, e, i, n, o) {
          var r,
              a,
              h,
              l = 0;

          for (r = e, a = i - n; r < i; r += n) {
            l += (t[a] - t[r]) * (t[r + 1] + t[a + 1]), a = r;
          }

          if (o === l > 0) for (r = e; r < i; r += n) {
            h = s.EarCut.insertNode(r, t[r], t[r + 1], h);
          } else for (r = i - n; r >= e; r -= n) {
            h = s.EarCut.insertNode(r, t[r], t[r + 1], h);
          }
          return h;
        }, s.EarCut.filterPoints = function (t, e) {
          if (!t) return t;
          e || (e = t);
          var i,
              n = t;

          do {
            if (i = !1, n.steiner || !s.EarCut.equals(n, n.next) && 0 !== s.EarCut.area(n.prev, n, n.next)) n = n.next;else {
              if (s.EarCut.removeNode(n), (n = e = n.prev) === n.next) return null;
              i = !0;
            }
          } while (i || n !== e);

          return e;
        }, s.EarCut.earcutLinked = function (t, e, i, n, o, r, a) {
          if (t) {
            !a && r && s.EarCut.indexCurve(t, n, o, r);

            for (var h, l, c = t; t.prev !== t.next;) {
              if (h = t.prev, l = t.next, r ? s.EarCut.isEarHashed(t, n, o, r) : s.EarCut.isEar(t)) e.push(h.i / i), e.push(t.i / i), e.push(l.i / i), s.EarCut.removeNode(t), t = l.next, c = l.next;else if ((t = l) === c) {
                a ? 1 === a ? (t = s.EarCut.cureLocalIntersections(t, e, i), s.EarCut.earcutLinked(t, e, i, n, o, r, 2)) : 2 === a && s.EarCut.splitEarcut(t, e, i, n, o, r) : s.EarCut.earcutLinked(s.EarCut.filterPoints(t), e, i, n, o, r, 1);
                break;
              }
            }
          }
        }, s.EarCut.isEar = function (t) {
          var e = t.prev,
              i = t,
              n = t.next;
          if (s.EarCut.area(e, i, n) >= 0) return !1;

          for (var o = t.next.next; o !== t.prev;) {
            if (s.EarCut.pointInTriangle(e.x, e.y, i.x, i.y, n.x, n.y, o.x, o.y) && s.EarCut.area(o.prev, o, o.next) >= 0) return !1;
            o = o.next;
          }

          return !0;
        }, s.EarCut.isEarHashed = function (t, e, i, n) {
          var o = t.prev,
              r = t,
              a = t.next;
          if (s.EarCut.area(o, r, a) >= 0) return !1;

          for (var h = o.x < r.x ? o.x < a.x ? o.x : a.x : r.x < a.x ? r.x : a.x, l = o.y < r.y ? o.y < a.y ? o.y : a.y : r.y < a.y ? r.y : a.y, c = o.x > r.x ? o.x > a.x ? o.x : a.x : r.x > a.x ? r.x : a.x, u = o.y > r.y ? o.y > a.y ? o.y : a.y : r.y > a.y ? r.y : a.y, d = s.EarCut.zOrder(h, l, e, i, n), p = s.EarCut.zOrder(c, u, e, i, n), f = t.nextZ; f && f.z <= p;) {
            if (f !== t.prev && f !== t.next && s.EarCut.pointInTriangle(o.x, o.y, r.x, r.y, a.x, a.y, f.x, f.y) && s.EarCut.area(f.prev, f, f.next) >= 0) return !1;
            f = f.nextZ;
          }

          for (f = t.prevZ; f && f.z >= d;) {
            if (f !== t.prev && f !== t.next && s.EarCut.pointInTriangle(o.x, o.y, r.x, r.y, a.x, a.y, f.x, f.y) && s.EarCut.area(f.prev, f, f.next) >= 0) return !1;
            f = f.prevZ;
          }

          return !0;
        }, s.EarCut.cureLocalIntersections = function (t, e, i) {
          var n = t;

          do {
            var o = n.prev,
                r = n.next.next;
            s.EarCut.intersects(o, n, n.next, r) && s.EarCut.locallyInside(o, r) && s.EarCut.locallyInside(r, o) && (e.push(o.i / i), e.push(n.i / i), e.push(r.i / i), s.EarCut.removeNode(n), s.EarCut.removeNode(n.next), n = t = r), n = n.next;
          } while (n !== t);

          return n;
        }, s.EarCut.splitEarcut = function (t, e, i, n, o, r) {
          var a = t;

          do {
            for (var h = a.next.next; h !== a.prev;) {
              if (a.i !== h.i && s.EarCut.isValidDiagonal(a, h)) {
                var l = s.EarCut.splitPolygon(a, h);
                return a = s.EarCut.filterPoints(a, a.next), l = s.EarCut.filterPoints(l, l.next), s.EarCut.earcutLinked(a, e, i, n, o, r), void s.EarCut.earcutLinked(l, e, i, n, o, r);
              }

              h = h.next;
            }

            a = a.next;
          } while (a !== t);
        }, s.EarCut.eliminateHoles = function (t, e, i, n) {
          var o,
              r,
              a,
              h,
              l,
              c = [];

          for (o = 0, r = e.length; o < r; o++) {
            a = e[o] * n, h = o < r - 1 ? e[o + 1] * n : t.length, (l = s.EarCut.linkedList(t, a, h, n, !1)) === l.next && (l.steiner = !0), c.push(s.EarCut.getLeftmost(l));
          }

          for (c.sort(s.EarCut.compareX), o = 0; o < c.length; o++) {
            s.EarCut.eliminateHole(c[o], i), i = s.EarCut.filterPoints(i, i.next);
          }

          return i;
        }, s.EarCut.compareX = function (t, e) {
          return t.x - e.x;
        }, s.EarCut.eliminateHole = function (t, e) {
          if (e = s.EarCut.findHoleBridge(t, e)) {
            var i = s.EarCut.splitPolygon(e, t);
            s.EarCut.filterPoints(i, i.next);
          }
        }, s.EarCut.findHoleBridge = function (t, e) {
          var i,
              n = e,
              o = t.x,
              r = t.y,
              a = -1 / 0;

          do {
            if (r <= n.y && r >= n.next.y) {
              var h = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
              h <= o && h > a && (a = h, i = n.x < n.next.x ? n : n.next);
            }

            n = n.next;
          } while (n !== e);

          if (!i) return null;
          if (t.x === i.x) return i.prev;
          var l,
              c = i,
              u = 1 / 0;

          for (n = i.next; n !== c;) {
            o >= n.x && n.x >= i.x && s.EarCut.pointInTriangle(r < i.y ? o : a, r, i.x, i.y, r < i.y ? a : o, r, n.x, n.y) && ((l = Math.abs(r - n.y) / (o - n.x)) < u || l === u && n.x > i.x) && s.EarCut.locallyInside(n, t) && (i = n, u = l), n = n.next;
          }

          return i;
        }, s.EarCut.indexCurve = function (t, e, i, n) {
          var o = t;

          do {
            null === o.z && (o.z = s.EarCut.zOrder(o.x, o.y, e, i, n)), o.prevZ = o.prev, o.nextZ = o.next, o = o.next;
          } while (o !== t);

          o.prevZ.nextZ = null, o.prevZ = null, s.EarCut.sortLinked(o);
        }, s.EarCut.sortLinked = function (t) {
          var e,
              i,
              s,
              n,
              o,
              r,
              a,
              h,
              l = 1;

          do {
            for (i = t, t = null, o = null, r = 0; i;) {
              for (r++, s = i, a = 0, e = 0; e < l && (a++, s = s.nextZ); e++) {
                ;
              }

              for (h = l; a > 0 || h > 0 && s;) {
                0 === a ? (n = s, s = s.nextZ, h--) : 0 !== h && s ? i.z <= s.z ? (n = i, i = i.nextZ, a--) : (n = s, s = s.nextZ, h--) : (n = i, i = i.nextZ, a--), o ? o.nextZ = n : t = n, n.prevZ = o, o = n;
              }

              i = s;
            }

            o.nextZ = null, l *= 2;
          } while (r > 1);

          return t;
        }, s.EarCut.zOrder = function (t, e, i, s, n) {
          return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - i) / n) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - s) / n) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }, s.EarCut.getLeftmost = function (t) {
          var e = t,
              i = t;

          do {
            e.x < i.x && (i = e), e = e.next;
          } while (e !== t);

          return i;
        }, s.EarCut.pointInTriangle = function (t, e, i, s, n, o, r, a) {
          return (n - r) * (e - a) - (t - r) * (o - a) >= 0 && (t - r) * (s - a) - (i - r) * (e - a) >= 0 && (i - r) * (o - a) - (n - r) * (s - a) >= 0;
        }, s.EarCut.isValidDiagonal = function (t, e) {
          return s.EarCut.equals(t, e) || t.next.i !== e.i && t.prev.i !== e.i && !s.EarCut.intersectsPolygon(t, e) && s.EarCut.locallyInside(t, e) && s.EarCut.locallyInside(e, t) && s.EarCut.middleInside(t, e);
        }, s.EarCut.area = function (t, e, i) {
          return (e.y - t.y) * (i.x - e.x) - (e.x - t.x) * (i.y - e.y);
        }, s.EarCut.equals = function (t, e) {
          return t.x === e.x && t.y === e.y;
        }, s.EarCut.intersects = function (t, e, i, n) {
          return s.EarCut.area(t, e, i) > 0 != s.EarCut.area(t, e, n) > 0 && s.EarCut.area(i, n, t) > 0 != s.EarCut.area(i, n, e) > 0;
        }, s.EarCut.intersectsPolygon = function (t, e) {
          var i = t;

          do {
            if (i.i !== t.i && i.next.i !== t.i && i.i !== e.i && i.next.i !== e.i && s.EarCut.intersects(i, i.next, t, e)) return !0;
            i = i.next;
          } while (i !== t);

          return !1;
        }, s.EarCut.locallyInside = function (t, e) {
          return s.EarCut.area(t.prev, t, t.next) < 0 ? s.EarCut.area(t, e, t.next) >= 0 && s.EarCut.area(t, t.prev, e) >= 0 : s.EarCut.area(t, e, t.prev) < 0 || s.EarCut.area(t, t.next, e) < 0;
        }, s.EarCut.middleInside = function (t, e) {
          var i = t,
              s = !1,
              n = (t.x + e.x) / 2,
              o = (t.y + e.y) / 2;

          do {
            i.y > o != i.next.y > o && n < (i.next.x - i.x) * (o - i.y) / (i.next.y - i.y) + i.x && (s = !s), i = i.next;
          } while (i !== t);

          return s;
        }, s.EarCut.splitPolygon = function (t, e) {
          var i = new s.EarCut.Node(t.i, t.x, t.y),
              n = new s.EarCut.Node(e.i, e.x, e.y),
              o = t.next,
              r = e.prev;
          return t.next = e, e.prev = t, i.next = o, o.prev = i, n.next = i, i.prev = n, r.next = n, n.prev = r, n;
        }, s.EarCut.insertNode = function (t, e, i, n) {
          var o = new s.EarCut.Node(t, e, i);
          return n ? (o.next = n.next, o.prev = n, n.next.prev = o, n.next = o) : (o.prev = o, o.next = o), o;
        }, s.EarCut.removeNode = function (t) {
          t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }, s.EarCut.Node = function (t, e, i) {
          this.i = t, this.x = e, this.y = i, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }, PIXI.WebGLGraphics = function () {}, PIXI.WebGLGraphics.stencilBufferLimit = 6, PIXI.WebGLGraphics.renderGraphics = function (t, e) {
          var i,
              n = e.gl,
              o = e.projection,
              r = e.offset,
              a = e.shaderManager.primitiveShader;
          t.dirty && PIXI.WebGLGraphics.updateGraphics(t, n);
          var h = t._webGL[n.id];
          if (h) for (var l = 0; l < h.data.length; l++) {
            1 === h.data[l].mode ? (i = h.data[l], e.stencilManager.pushStencil(t, i, e), n.drawElements(n.TRIANGLE_FAN, 4, n.UNSIGNED_SHORT, 2 * (i.indices.length - 4)), e.stencilManager.popStencil(t, i, e)) : (i = h.data[l], e.shaderManager.setShader(a), a = e.shaderManager.primitiveShader, n.uniformMatrix3fv(a.translationMatrix, !1, t.worldTransform.toArray(!0)), n.uniform1f(a.flipY, 1), n.uniform2f(a.projectionVector, o.x, -o.y), n.uniform2f(a.offsetVector, -r.x, -r.y), n.uniform3fv(a.tintColor, s.Color.hexToRGBArray(t.tint)), n.uniform1f(a.alpha, t.worldAlpha), n.bindBuffer(n.ARRAY_BUFFER, i.buffer), n.vertexAttribPointer(a.aVertexPosition, 2, n.FLOAT, !1, 24, 0), n.vertexAttribPointer(a.colorAttribute, 4, n.FLOAT, !1, 24, 8), n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, i.indexBuffer), n.drawElements(n.TRIANGLE_STRIP, i.indices.length, n.UNSIGNED_SHORT, 0));
          }
        }, PIXI.WebGLGraphics.updateGraphics = function (t, e) {
          var i,
              n,
              o = t._webGL[e.id];

          if (o || (o = t._webGL[e.id] = {
            lastIndex: 0,
            data: [],
            gl: e
          }), t.dirty = !1, t.clearDirty) {
            for (t.clearDirty = !1, i = 0; i < o.data.length; i++) {
              var r = o.data[i];
              r.reset(), PIXI.WebGLGraphics.graphicsDataPool.push(r);
            }

            o.data = [], o.lastIndex = 0;
          }

          for (i = o.lastIndex; i < t.graphicsData.length; i++) {
            var a = t.graphicsData[i];

            if (a.type === s.POLYGON) {
              if (a.points = a.shape.points.slice(), a.shape.closed && (a.points[0] === a.points[a.points.length - 2] && a.points[1] === a.points[a.points.length - 1] || a.points.push(a.points[0], a.points[1])), a.fill) if (a.points.length >= PIXI.WebGLGraphics.stencilBufferLimit) if (a.points.length < 2 * PIXI.WebGLGraphics.stencilBufferLimit) n = PIXI.WebGLGraphics.switchMode(o, 0), PIXI.WebGLGraphics.buildPoly(a, n) || (n = PIXI.WebGLGraphics.switchMode(o, 1), PIXI.WebGLGraphics.buildComplexPoly(a, n));else n = PIXI.WebGLGraphics.switchMode(o, 1), PIXI.WebGLGraphics.buildComplexPoly(a, n);
              a.lineWidth > 0 && (n = PIXI.WebGLGraphics.switchMode(o, 0), PIXI.WebGLGraphics.buildLine(a, n));
            } else n = PIXI.WebGLGraphics.switchMode(o, 0), a.type === s.RECTANGLE ? PIXI.WebGLGraphics.buildRectangle(a, n) : a.type === s.CIRCLE || a.type === s.ELLIPSE ? PIXI.WebGLGraphics.buildCircle(a, n) : a.type === s.ROUNDEDRECTANGLE && PIXI.WebGLGraphics.buildRoundedRectangle(a, n);

            o.lastIndex++;
          }

          for (i = 0; i < o.data.length; i++) {
            (n = o.data[i]).dirty && n.upload();
          }
        }, PIXI.WebGLGraphics.switchMode = function (t, e) {
          var i;
          return t.data.length && (i = t.data[t.data.length - 1]).mode === e && 1 !== e || ((i = PIXI.WebGLGraphics.graphicsDataPool.pop() || new PIXI.WebGLGraphicsData(t.gl)).mode = e, t.data.push(i)), i.dirty = !0, i;
        }, PIXI.WebGLGraphics.buildRectangle = function (t, e) {
          var i = t.shape,
              n = i.x,
              o = i.y,
              r = i.width,
              a = i.height;

          if (t.fill) {
            var h = s.Color.hexToRGBArray(t.fillColor),
                l = t.fillAlpha,
                c = h[0] * l,
                u = h[1] * l,
                d = h[2] * l,
                p = e.points,
                f = e.indices,
                g = p.length / 6;
            p.push(n, o), p.push(c, u, d, l), p.push(n + r, o), p.push(c, u, d, l), p.push(n, o + a), p.push(c, u, d, l), p.push(n + r, o + a), p.push(c, u, d, l), f.push(g, g, g + 1, g + 2, g + 3, g + 3);
          }

          if (t.lineWidth) {
            var m = t.points;
            t.points = [n, o, n + r, o, n + r, o + a, n, o + a, n, o], PIXI.WebGLGraphics.buildLine(t, e), t.points = m;
          }
        }, PIXI.WebGLGraphics.buildRoundedRectangle = function (t, e) {
          var i = t.shape,
              n = i.x,
              o = i.y,
              r = i.width,
              a = i.height,
              h = i.radius,
              l = [];

          if (l.push(n, o + h), l = (l = (l = (l = l.concat(PIXI.WebGLGraphics.quadraticBezierCurve(n, o + a - h, n, o + a, n + h, o + a))).concat(PIXI.WebGLGraphics.quadraticBezierCurve(n + r - h, o + a, n + r, o + a, n + r, o + a - h))).concat(PIXI.WebGLGraphics.quadraticBezierCurve(n + r, o + h, n + r, o, n + r - h, o))).concat(PIXI.WebGLGraphics.quadraticBezierCurve(n + h, o, n, o, n, o + h)), t.fill) {
            var c = s.Color.hexToRGBArray(t.fillColor),
                u = t.fillAlpha,
                d = c[0] * u,
                p = c[1] * u,
                f = c[2] * u,
                g = e.points,
                m = e.indices,
                y = g.length / 6,
                v = s.EarCut.Triangulate(l, null, 2),
                b = 0;

            for (b = 0; b < v.length; b += 3) {
              m.push(v[b] + y), m.push(v[b] + y), m.push(v[b + 1] + y), m.push(v[b + 2] + y), m.push(v[b + 2] + y);
            }

            for (b = 0; b < l.length; b++) {
              g.push(l[b], l[++b], d, p, f, u);
            }
          }

          if (t.lineWidth) {
            var x = t.points;
            t.points = l, PIXI.WebGLGraphics.buildLine(t, e), t.points = x;
          }
        }, PIXI.WebGLGraphics.quadraticBezierCurve = function (t, e, i, s, n, o) {
          var r,
              a,
              h,
              l,
              c,
              u,
              d = [];

          function p(t, e, i) {
            return t + (e - t) * i;
          }

          for (var f = 0, g = 0; g <= 20; g++) {
            r = p(t, i, f = g / 20), a = p(e, s, f), h = p(i, n, f), l = p(s, o, f), c = p(r, h, f), u = p(a, l, f), d.push(c, u);
          }

          return d;
        }, PIXI.WebGLGraphics.buildCircle = function (t, e) {
          var i,
              n,
              o = t.shape,
              r = o.x,
              a = o.y;
          t.type === s.CIRCLE ? (i = o.radius, n = o.radius) : (i = o.width, n = o.height);
          var h = 2 * Math.PI / 40,
              l = 0;

          if (t.fill) {
            var c = s.Color.hexToRGBArray(t.fillColor),
                u = t.fillAlpha,
                d = c[0] * u,
                p = c[1] * u,
                f = c[2] * u,
                g = e.points,
                m = e.indices,
                y = g.length / 6;

            for (m.push(y), l = 0; l < 41; l++) {
              g.push(r, a, d, p, f, u), g.push(r + Math.sin(h * l) * i, a + Math.cos(h * l) * n, d, p, f, u), m.push(y++, y++);
            }

            m.push(y - 1);
          }

          if (t.lineWidth) {
            var v = t.points;

            for (t.points = [], l = 0; l < 41; l++) {
              t.points.push(r + Math.sin(h * l) * i, a + Math.cos(h * l) * n);
            }

            PIXI.WebGLGraphics.buildLine(t, e), t.points = v;
          }
        }, PIXI.WebGLGraphics.buildLine = function (t, e) {
          var i = 0,
              n = t.points;

          if (0 !== n.length) {
            if (t.lineWidth % 2) for (i = 0; i < n.length; i++) {
              n[i] += .5;
            }
            var o = new PIXI.Point(n[0], n[1]),
                r = new PIXI.Point(n[n.length - 2], n[n.length - 1]);

            if (o.x === r.x && o.y === r.y) {
              (n = n.slice()).pop(), n.pop();
              var a = (r = new PIXI.Point(n[n.length - 2], n[n.length - 1])).x + .5 * (o.x - r.x),
                  h = r.y + .5 * (o.y - r.y);
              n.unshift(a, h), n.push(a, h);
            }

            var l,
                c,
                u,
                d,
                p,
                f,
                g,
                m,
                y,
                v,
                b,
                x,
                w,
                _,
                T,
                P,
                S,
                C,
                A,
                E,
                M,
                R,
                L = e.points,
                I = e.indices,
                k = n.length / 2,
                O = n.length,
                B = L.length / 6,
                F = t.lineWidth / 2,
                D = s.Color.hexToRGBArray(t.lineColor),
                U = t.lineAlpha,
                G = D[0] * U,
                N = D[1] * U,
                W = D[2] * U;

            for (u = n[0], d = n[1], p = n[2], y = -(d - (f = n[3])), v = u - p, y /= R = Math.sqrt(y * y + v * v), v /= R, y *= F, v *= F, L.push(u - y, d - v, G, N, W, U), L.push(u + y, d + v, G, N, W, U), i = 1; i < k - 1; i++) {
              u = n[2 * (i - 1)], d = n[2 * (i - 1) + 1], p = n[2 * i], f = n[2 * i + 1], g = n[2 * (i + 1)], m = n[2 * (i + 1) + 1], y = -(d - f), v = u - p, y /= R = Math.sqrt(y * y + v * v), v /= R, y *= F, v *= F, b = -(f - m), x = p - g, b /= R = Math.sqrt(b * b + x * x), x /= R, S = (-y + u) * (-v + f) - (-y + p) * (-v + d), E = (-(b *= F) + g) * (-(x *= F) + f) - (-b + p) * (-x + m), M = (T = -v + d - (-v + f)) * (A = -b + p - (-b + g)) - (C = -x + m - (-x + f)) * (P = -y + p - (-y + u)), Math.abs(M) < .1 ? (M += 10.1, L.push(p - y, f - v, G, N, W, U), L.push(p + y, f + v, G, N, W, U)) : ((l = (P * E - A * S) / M) - p) * (l - p) + ((c = (C * S - T * E) / M) - f) + (c - f) > 19600 ? (w = y - b, _ = v - x, w /= R = Math.sqrt(w * w + _ * _), _ /= R, w *= F, _ *= F, L.push(p - w, f - _), L.push(G, N, W, U), L.push(p + w, f + _), L.push(G, N, W, U), L.push(p - w, f - _), L.push(G, N, W, U), O++) : (L.push(l, c), L.push(G, N, W, U), L.push(p - (l - p), f - (c - f)), L.push(G, N, W, U));
            }

            for (u = n[2 * (k - 2)], d = n[2 * (k - 2) + 1], p = n[2 * (k - 1)], y = -(d - (f = n[2 * (k - 1) + 1])), v = u - p, y /= R = Math.sqrt(y * y + v * v), v /= R, y *= F, v *= F, L.push(p - y, f - v), L.push(G, N, W, U), L.push(p + y, f + v), L.push(G, N, W, U), I.push(B), i = 0; i < O; i++) {
              I.push(B++);
            }

            I.push(B - 1);
          }
        }, PIXI.WebGLGraphics.buildComplexPoly = function (t, e) {
          var i = t.points.slice();

          if (!(i.length < 6)) {
            var n = e.indices;
            e.points = i, e.alpha = t.fillAlpha, e.color = s.Color.hexToRGBArray(t.fillColor);

            for (var o, r, a = 1 / 0, h = -1 / 0, l = 1 / 0, c = -1 / 0, u = 0; u < i.length; u += 2) {
              o = i[u], r = i[u + 1], a = o < a ? o : a, h = o > h ? o : h, l = r < l ? r : l, c = r > c ? r : c;
            }

            i.push(a, l, h, l, h, c, a, c);
            var d = i.length / 2;

            for (u = 0; u < d; u++) {
              n.push(u);
            }
          }
        }, PIXI.WebGLGraphics.buildPoly = function (t, e) {
          var i = t.points;

          if (!(i.length < 6)) {
            var n = e.points,
                o = e.indices,
                r = i.length / 2,
                a = s.Color.hexToRGBArray(t.fillColor),
                h = t.fillAlpha,
                l = a[0] * h,
                c = a[1] * h,
                u = a[2] * h,
                d = s.EarCut.Triangulate(i, null, 2);
            if (!d) return !1;
            var p = n.length / 6,
                f = 0;

            for (f = 0; f < d.length; f += 3) {
              o.push(d[f] + p), o.push(d[f] + p), o.push(d[f + 1] + p), o.push(d[f + 2] + p), o.push(d[f + 2] + p);
            }

            for (f = 0; f < r; f++) {
              n.push(i[2 * f], i[2 * f + 1], l, c, u, h);
            }

            return !0;
          }
        }, PIXI.WebGLGraphics.graphicsDataPool = [], PIXI.WebGLGraphicsData = function (t) {
          this.gl = t, this.color = [0, 0, 0], this.points = [], this.indices = [], this.buffer = t.createBuffer(), this.indexBuffer = t.createBuffer(), this.mode = 1, this.alpha = 1, this.dirty = !0;
        }, PIXI.WebGLGraphicsData.prototype.reset = function () {
          this.points = [], this.indices = [];
        }, PIXI.WebGLGraphicsData.prototype.upload = function () {
          var t = this.gl;
          this.glPoints = new Float32Array(this.points), t.bindBuffer(t.ARRAY_BUFFER, this.buffer), t.bufferData(t.ARRAY_BUFFER, this.glPoints, t.STATIC_DRAW), this.glIndicies = new Uint16Array(this.indices), t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, this.indexBuffer), t.bufferData(t.ELEMENT_ARRAY_BUFFER, this.glIndicies, t.STATIC_DRAW), this.dirty = !1;
        }, PIXI.CanvasGraphics = function () {}, PIXI.CanvasGraphics.renderGraphics = function (t, e) {
          var i = t.worldAlpha;
          t.dirty && (this.updateGraphicsTint(t), t.dirty = !1);

          for (var n = 0; n < t.graphicsData.length; n++) {
            var o = t.graphicsData[n],
                r = o.shape,
                a = o._fillTint,
                h = o._lineTint;

            if (e.lineWidth = o.lineWidth, o.type === s.POLYGON) {
              e.beginPath();
              var l = r.points;
              e.moveTo(l[0], l[1]);

              for (var c = 1; c < l.length / 2; c++) {
                e.lineTo(l[2 * c], l[2 * c + 1]);
              }

              r.closed && e.lineTo(l[0], l[1]), l[0] === l[l.length - 2] && l[1] === l[l.length - 1] && e.closePath(), o.fill && (e.globalAlpha = o.fillAlpha * i, e.fillStyle = "#" + ("00000" + (0 | a).toString(16)).substr(-6), e.fill()), o.lineWidth && (e.globalAlpha = o.lineAlpha * i, e.strokeStyle = "#" + ("00000" + (0 | h).toString(16)).substr(-6), e.stroke());
            } else if (o.type === s.RECTANGLE) (o.fillColor || 0 === o.fillColor) && (e.globalAlpha = o.fillAlpha * i, e.fillStyle = "#" + ("00000" + (0 | a).toString(16)).substr(-6), e.fillRect(r.x, r.y, r.width, r.height)), o.lineWidth && (e.globalAlpha = o.lineAlpha * i, e.strokeStyle = "#" + ("00000" + (0 | h).toString(16)).substr(-6), e.strokeRect(r.x, r.y, r.width, r.height));else if (o.type === s.CIRCLE) e.beginPath(), e.arc(r.x, r.y, r.radius, 0, 2 * Math.PI), e.closePath(), o.fill && (e.globalAlpha = o.fillAlpha * i, e.fillStyle = "#" + ("00000" + (0 | a).toString(16)).substr(-6), e.fill()), o.lineWidth && (e.globalAlpha = o.lineAlpha * i, e.strokeStyle = "#" + ("00000" + (0 | h).toString(16)).substr(-6), e.stroke());else if (o.type === s.ELLIPSE) {
              var u = 2 * r.width,
                  d = 2 * r.height,
                  p = r.x - u / 2,
                  f = r.y - d / 2;
              e.beginPath();
              var g = u / 2 * .5522848,
                  m = d / 2 * .5522848,
                  y = p + u,
                  v = f + d,
                  b = p + u / 2,
                  x = f + d / 2;
              e.moveTo(p, x), e.bezierCurveTo(p, x - m, b - g, f, b, f), e.bezierCurveTo(b + g, f, y, x - m, y, x), e.bezierCurveTo(y, x + m, b + g, v, b, v), e.bezierCurveTo(b - g, v, p, x + m, p, x), e.closePath(), o.fill && (e.globalAlpha = o.fillAlpha * i, e.fillStyle = "#" + ("00000" + (0 | a).toString(16)).substr(-6), e.fill()), o.lineWidth && (e.globalAlpha = o.lineAlpha * i, e.strokeStyle = "#" + ("00000" + (0 | h).toString(16)).substr(-6), e.stroke());
            } else if (o.type === s.ROUNDEDRECTANGLE) {
              var w = r.x,
                  _ = r.y,
                  T = r.width,
                  P = r.height,
                  S = r.radius,
                  C = Math.min(T, P) / 2 | 0;
              S = S > C ? C : S, e.beginPath(), e.moveTo(w, _ + S), e.lineTo(w, _ + P - S), e.quadraticCurveTo(w, _ + P, w + S, _ + P), e.lineTo(w + T - S, _ + P), e.quadraticCurveTo(w + T, _ + P, w + T, _ + P - S), e.lineTo(w + T, _ + S), e.quadraticCurveTo(w + T, _, w + T - S, _), e.lineTo(w + S, _), e.quadraticCurveTo(w, _, w, _ + S), e.closePath(), (o.fillColor || 0 === o.fillColor) && (e.globalAlpha = o.fillAlpha * i, e.fillStyle = "#" + ("00000" + (0 | a).toString(16)).substr(-6), e.fill()), o.lineWidth && (e.globalAlpha = o.lineAlpha * i, e.strokeStyle = "#" + ("00000" + (0 | h).toString(16)).substr(-6), e.stroke());
            }
          }
        }, PIXI.CanvasGraphics.renderGraphicsMask = function (t, e) {
          var i = t.graphicsData.length;

          if (0 !== i) {
            e.beginPath();

            for (var n = 0; n < i; n++) {
              var o = t.graphicsData[n],
                  r = o.shape;

              if (o.type === s.POLYGON) {
                var a = r.points;
                e.moveTo(a[0], a[1]);

                for (var h = 1; h < a.length / 2; h++) {
                  e.lineTo(a[2 * h], a[2 * h + 1]);
                }

                a[0] === a[a.length - 2] && a[1] === a[a.length - 1] && e.closePath();
              } else if (o.type === s.RECTANGLE) e.rect(r.x, r.y, r.width, r.height), e.closePath();else if (o.type === s.CIRCLE) e.arc(r.x, r.y, r.radius, 0, 2 * Math.PI), e.closePath();else if (o.type === s.ELLIPSE) {
                var l = 2 * r.width,
                    c = 2 * r.height,
                    u = r.x - l / 2,
                    d = r.y - c / 2,
                    p = l / 2 * .5522848,
                    f = c / 2 * .5522848,
                    g = u + l,
                    m = d + c,
                    y = u + l / 2,
                    v = d + c / 2;
                e.moveTo(u, v), e.bezierCurveTo(u, v - f, y - p, d, y, d), e.bezierCurveTo(y + p, d, g, v - f, g, v), e.bezierCurveTo(g, v + f, y + p, m, y, m), e.bezierCurveTo(y - p, m, u, v + f, u, v), e.closePath();
              } else if (o.type === s.ROUNDEDRECTANGLE) {
                var b = r.x,
                    x = r.y,
                    w = r.width,
                    _ = r.height,
                    T = r.radius,
                    P = Math.min(w, _) / 2 | 0;
                T = T > P ? P : T, e.moveTo(b, x + T), e.lineTo(b, x + _ - T), e.quadraticCurveTo(b, x + _, b + T, x + _), e.lineTo(b + w - T, x + _), e.quadraticCurveTo(b + w, x + _, b + w, x + _ - T), e.lineTo(b + w, x + T), e.quadraticCurveTo(b + w, x, b + w - T, x), e.lineTo(b + T, x), e.quadraticCurveTo(b, x, b, x + T), e.closePath();
              }
            }
          }
        }, PIXI.CanvasGraphics.updateGraphicsTint = function (t) {
          if (16777215 !== t.tint) for (var e = (t.tint >> 16 & 255) / 255, i = (t.tint >> 8 & 255) / 255, s = (255 & t.tint) / 255, n = 0; n < t.graphicsData.length; n++) {
            var o = t.graphicsData[n],
                r = 0 | o.fillColor,
                a = 0 | o.lineColor;
            o._fillTint = ((r >> 16 & 255) / 255 * e * 255 << 16) + ((r >> 8 & 255) / 255 * i * 255 << 8) + (255 & r) / 255 * s * 255, o._lineTint = ((a >> 16 & 255) / 255 * e * 255 << 16) + ((a >> 8 & 255) / 255 * i * 255 << 8) + (255 & a) / 255 * s * 255;
          }
        }, s.GraphicsData = function (t, e, i, s, n, o, r) {
          this.lineWidth = t, this.lineColor = e, this.lineAlpha = i, this._lineTint = e, this.fillColor = s, this.fillAlpha = n, this._fillTint = s, this.fill = o, this.shape = r, this.type = r.type;
        }, s.GraphicsData.prototype.constructor = s.GraphicsData, s.GraphicsData.prototype.clone = function () {
          return new s.GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.fill, this.shape);
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Graphics = function (t, e, i) {
          void 0 === e && (e = 0), void 0 === i && (i = 0), this.type = s.GRAPHICS, this.physicsType = s.SPRITE, this.anchor = new s.Point(), PIXI.DisplayObjectContainer.call(this), this.renderable = !0, this.fillAlpha = 1, this.lineWidth = 0, this.lineColor = 0, this.graphicsData = [], this.tint = 16777215, this.blendMode = PIXI.blendModes.NORMAL, this.currentPath = null, this._webGL = [], this.isMask = !1, this.boundsPadding = 0, this._localBounds = new s.Rectangle(0, 0, 1, 1), this.dirty = !0, this._boundsDirty = !1, this.webGLDirty = !1, this.cachedSpriteDirty = !1, s.Component.Core.init.call(this, t, e, i, "", null);
        }, s.Graphics.prototype = Object.create(PIXI.DisplayObjectContainer.prototype), s.Graphics.prototype.constructor = s.Graphics, s.Component.Core.install.call(s.Graphics.prototype, ["Angle", "AutoCull", "Bounds", "Destroy", "FixedToCamera", "InputEnabled", "InWorld", "LifeSpan", "PhysicsBody", "Reset"]), s.Graphics.prototype.preUpdatePhysics = s.Component.PhysicsBody.preUpdate, s.Graphics.prototype.preUpdateLifeSpan = s.Component.LifeSpan.preUpdate, s.Graphics.prototype.preUpdateInWorld = s.Component.InWorld.preUpdate, s.Graphics.prototype.preUpdateCore = s.Component.Core.preUpdate, s.Graphics.prototype.preUpdate = function () {
          return !!(this.preUpdatePhysics() && this.preUpdateLifeSpan() && this.preUpdateInWorld()) && this.preUpdateCore();
        }, s.Graphics.prototype.postUpdate = function () {
          s.Component.PhysicsBody.postUpdate.call(this), s.Component.FixedToCamera.postUpdate.call(this), this._boundsDirty && (this.updateLocalBounds(), this._boundsDirty = !1);

          for (var t = 0; t < this.children.length; t++) {
            this.children[t].postUpdate();
          }
        }, s.Graphics.prototype.destroy = function (t) {
          this.clear(), s.Component.Destroy.prototype.destroy.call(this, t);
        }, s.Graphics.prototype.drawTriangle = function (t, e) {
          void 0 === e && (e = !1);
          var i = new s.Polygon(t);

          if (e) {
            var n = new s.Point(this.game.camera.x - t[0].x, this.game.camera.y - t[0].y),
                o = new s.Point(t[1].x - t[0].x, t[1].y - t[0].y),
                r = new s.Point(t[1].x - t[2].x, t[1].y - t[2].y).cross(o);
            n.dot(r) > 0 && this.drawPolygon(i);
          } else this.drawPolygon(i);
        }, s.Graphics.prototype.drawTriangles = function (t, e, i) {
          void 0 === i && (i = !1);
          var n,
              o = new s.Point(),
              r = new s.Point(),
              a = new s.Point(),
              h = [];
          if (e) {
            if (t[0] instanceof s.Point) for (n = 0; n < e.length / 3; n++) {
              h.push(t[e[3 * n]]), h.push(t[e[3 * n + 1]]), h.push(t[e[3 * n + 2]]), 3 === h.length && (this.drawTriangle(h, i), h = []);
            } else for (n = 0; n < e.length; n++) {
              o.x = t[2 * e[n]], o.y = t[2 * e[n] + 1], h.push(o.copyTo({})), 3 === h.length && (this.drawTriangle(h, i), h = []);
            }
          } else if (t[0] instanceof s.Point) for (n = 0; n < t.length / 3; n++) {
            this.drawTriangle([t[3 * n], t[3 * n + 1], t[3 * n + 2]], i);
          } else for (n = 0; n < t.length / 6; n++) {
            o.x = t[6 * n + 0], o.y = t[6 * n + 1], r.x = t[6 * n + 2], r.y = t[6 * n + 3], a.x = t[6 * n + 4], a.y = t[6 * n + 5], this.drawTriangle([o, r, a], i);
          }
        }, s.Graphics.prototype.lineStyle = function (t, e, i) {
          return this.lineWidth = t || 0, this.lineColor = e || 0, this.lineAlpha = void 0 === i ? 1 : i, this.currentPath && (this.currentPath.shape.points.length ? this.drawShape(new s.Polygon(this.currentPath.shape.points.slice(-2))) : (this.currentPath.lineWidth = this.lineWidth, this.currentPath.lineColor = this.lineColor, this.currentPath.lineAlpha = this.lineAlpha)), this;
        }, s.Graphics.prototype.moveTo = function (t, e) {
          return this.drawShape(new s.Polygon([t, e])), this;
        }, s.Graphics.prototype.lineTo = function (t, e) {
          return this.currentPath || this.moveTo(0, 0), this.currentPath.shape.points.push(t, e), this.dirty = !0, this._boundsDirty = !0, this;
        }, s.Graphics.prototype.quadraticCurveTo = function (t, e, i, s) {
          this.currentPath ? 0 === this.currentPath.shape.points.length && (this.currentPath.shape.points = [0, 0]) : this.moveTo(0, 0);
          var n,
              o,
              r = this.currentPath.shape.points;
          0 === r.length && this.moveTo(0, 0);

          for (var a = r[r.length - 2], h = r[r.length - 1], l = 0, c = 1; c <= 20; ++c) {
            n = a + (t - a) * (l = c / 20), o = h + (e - h) * l, r.push(n + (t + (i - t) * l - n) * l, o + (e + (s - e) * l - o) * l);
          }

          return this.dirty = !0, this._boundsDirty = !0, this;
        }, s.Graphics.prototype.bezierCurveTo = function (t, e, i, s, n, o) {
          this.currentPath ? 0 === this.currentPath.shape.points.length && (this.currentPath.shape.points = [0, 0]) : this.moveTo(0, 0);

          for (var r, a, h, l, c, u = this.currentPath.shape.points, d = u[u.length - 2], p = u[u.length - 1], f = 0, g = 1; g <= 20; ++g) {
            h = (a = (r = 1 - (f = g / 20)) * r) * r, c = (l = f * f) * f, u.push(h * d + 3 * a * f * t + 3 * r * l * i + c * n, h * p + 3 * a * f * e + 3 * r * l * s + c * o);
          }

          return this.dirty = !0, this._boundsDirty = !0, this;
        }, s.Graphics.prototype.arcTo = function (t, e, i, s, n) {
          this.currentPath ? 0 === this.currentPath.shape.points.length && this.currentPath.shape.points.push(t, e) : this.moveTo(t, e);
          var o = this.currentPath.shape.points,
              r = o[o.length - 2],
              a = o[o.length - 1] - e,
              h = r - t,
              l = s - e,
              c = i - t,
              u = Math.abs(a * c - h * l);
          if (u < 1e-8 || 0 === n) o[o.length - 2] === t && o[o.length - 1] === e || o.push(t, e);else {
            var d = a * a + h * h,
                p = l * l + c * c,
                f = a * l + h * c,
                g = n * Math.sqrt(d) / u,
                m = n * Math.sqrt(p) / u,
                y = g * f / d,
                v = m * f / p,
                b = g * c + m * h,
                x = g * l + m * a,
                w = h * (m + y),
                _ = a * (m + y),
                T = c * (g + v),
                P = l * (g + v),
                S = Math.atan2(_ - x, w - b),
                C = Math.atan2(P - x, T - b);

            this.arc(b + t, x + e, n, S, C, h * l > c * a);
          }
          return this.dirty = !0, this._boundsDirty = !0, this;
        }, s.Graphics.prototype.arc = function (t, e, i, s, n, o, r) {
          if (s === n) return this;
          void 0 === o && (o = !1), void 0 === r && (r = 40), !o && n <= s ? n += 2 * Math.PI : o && s <= n && (s += 2 * Math.PI);
          var a = o ? -1 * (s - n) : n - s,
              h = Math.ceil(Math.abs(a) / (2 * Math.PI)) * r;
          if (0 === a) return this;
          var l = t + Math.cos(s) * i,
              c = e + Math.sin(s) * i;
          o && this.filling ? this.moveTo(t, e) : this.moveTo(l, c);

          for (var u = this.currentPath.shape.points, d = a / (2 * h), p = 2 * d, f = Math.cos(d), g = Math.sin(d), m = h - 1, y = m % 1 / m, v = 0; v <= m; v++) {
            var b = d + s + p * (v + y * v),
                x = Math.cos(b),
                w = -Math.sin(b);
            u.push((f * x + g * w) * i + t, (f * -w + g * x) * i + e);
          }

          return this.dirty = !0, this._boundsDirty = !0, this;
        }, s.Graphics.prototype.beginFill = function (t, e) {
          return this.filling = !0, this.fillColor = t || 0, this.fillAlpha = void 0 === e ? 1 : e, this.currentPath && this.currentPath.shape.points.length <= 2 && (this.currentPath.fill = this.filling, this.currentPath.fillColor = this.fillColor, this.currentPath.fillAlpha = this.fillAlpha), this;
        }, s.Graphics.prototype.endFill = function () {
          return this.filling = !1, this.fillColor = null, this.fillAlpha = 1, this;
        }, s.Graphics.prototype.drawRect = function (t, e, i, n) {
          return this.drawShape(new s.Rectangle(t, e, i, n)), this;
        }, s.Graphics.prototype.drawRoundedRect = function (t, e, i, n, o) {
          return this.drawShape(new s.RoundedRectangle(t, e, i, n, o)), this;
        }, s.Graphics.prototype.drawCircle = function (t, e, i) {
          return this.drawShape(new s.Circle(t, e, i)), this;
        }, s.Graphics.prototype.drawEllipse = function (t, e, i, n) {
          return this.drawShape({
            x: t,
            y: e,
            width: i,
            height: n,
            type: s.ELLIPSE
          }), this;
        }, s.Graphics.prototype.drawPolygon = function (t) {
          t instanceof s.Polygon && (t = t.points);
          var e = t;

          if (!Array.isArray(e)) {
            e = new Array(arguments.length);

            for (var i = 0; i < e.length; ++i) {
              e[i] = arguments[i];
            }
          }

          return this.drawShape(new s.Polygon(e)), this;
        }, s.Graphics.prototype.clear = function () {
          return this.lineWidth = 0, this.filling = !1, this.dirty = !0, this._boundsDirty = !0, this.clearDirty = !0, this.graphicsData = [], this.updateLocalBounds(), this;
        }, s.Graphics.prototype.generateTexture = function (t, e, i) {
          void 0 === t && (t = 1), void 0 === e && (e = PIXI.scaleModes.DEFAULT), void 0 === i && (i = 0);
          var s = this.getBounds();
          s.width += i, s.height += i;
          var n = new PIXI.CanvasBuffer(s.width * t, s.height * t),
              o = PIXI.Texture.fromCanvas(n.canvas, e);
          return o.baseTexture.resolution = t, n.context.scale(t, t), n.context.translate(-s.x, -s.y), PIXI.CanvasGraphics.renderGraphics(this, n.context), o;
        }, s.Graphics.prototype._renderWebGL = function (t) {
          if (!1 !== this.visible && 0 !== this.alpha && !0 !== this.isMask) {
            if (this._cacheAsBitmap) return (this.dirty || this.cachedSpriteDirty) && (this._generateCachedSprite(), this.updateCachedSpriteTexture(), this.cachedSpriteDirty = !1, this.dirty = !1), this._cachedSprite.worldAlpha = this.worldAlpha, void PIXI.Sprite.prototype._renderWebGL.call(this._cachedSprite, t);

            if (t.spriteBatch.stop(), t.blendModeManager.setBlendMode(this.blendMode), this._mask && t.maskManager.pushMask(this._mask, t), this._filters && t.filterManager.pushFilter(this._filterBlock), this.blendMode !== t.spriteBatch.currentBlendMode) {
              t.spriteBatch.currentBlendMode = this.blendMode;
              var e = PIXI.blendModesWebGL[t.spriteBatch.currentBlendMode];
              t.spriteBatch.gl.blendFunc(e[0], e[1]);
            }

            if (this.webGLDirty && (this.dirty = !0, this.webGLDirty = !1), PIXI.WebGLGraphics.renderGraphics(this, t), this.children.length) {
              t.spriteBatch.start();

              for (var i = 0; i < this.children.length; i++) {
                this.children[i]._renderWebGL(t);
              }

              t.spriteBatch.stop();
            }

            this._filters && t.filterManager.popFilter(), this._mask && t.maskManager.popMask(this.mask, t), t.drawCount++, t.spriteBatch.start();
          }
        }, s.Graphics.prototype._renderCanvas = function (t) {
          if (!1 !== this.visible && 0 !== this.alpha && !0 !== this.isMask) {
            if (this._prevTint !== this.tint && (this.dirty = !0, this._prevTint = this.tint), this._cacheAsBitmap) return (this.dirty || this.cachedSpriteDirty) && (this._generateCachedSprite(), this.updateCachedSpriteTexture(), this.cachedSpriteDirty = !1, this.dirty = !1), this._cachedSprite.alpha = this.alpha, void PIXI.Sprite.prototype._renderCanvas.call(this._cachedSprite, t);
            var e = t.context,
                i = this.worldTransform;
            this.blendMode !== t.currentBlendMode && (t.currentBlendMode = this.blendMode, e.globalCompositeOperation = PIXI.blendModesCanvas[t.currentBlendMode]), this._mask && t.maskManager.pushMask(this._mask, t);
            var s = t.resolution,
                n = i.tx * t.resolution + t.shakeX,
                o = i.ty * t.resolution + t.shakeY;
            e.setTransform(i.a * s, i.b * s, i.c * s, i.d * s, n, o), PIXI.CanvasGraphics.renderGraphics(this, e);

            for (var r = 0; r < this.children.length; r++) {
              this.children[r]._renderCanvas(t);
            }

            this._mask && t.maskManager.popMask(t);
          }
        }, s.Graphics.prototype.getBounds = function (t) {
          if (this._currentBounds) return this._currentBounds;
          if (!this.renderable) return s.EmptyRectangle;
          this.dirty && (this.updateLocalBounds(), this.webGLDirty = !0, this.cachedSpriteDirty = !0, this.dirty = !1);
          var e = this._localBounds,
              i = e.x,
              n = e.width + e.x,
              o = e.y,
              r = e.height + e.y,
              a = t || this.worldTransform,
              h = a.a,
              l = a.b,
              c = a.c,
              u = a.d,
              d = a.tx,
              p = a.ty,
              f = h * n + c * r + d,
              g = u * r + l * n + p,
              m = h * i + c * r + d,
              y = u * r + l * i + p,
              v = h * i + c * o + d,
              b = u * o + l * i + p,
              x = h * n + c * o + d,
              w = u * o + l * n + p,
              _ = f,
              T = g,
              P = f,
              S = g;
          return P = x < (P = v < (P = m < P ? m : P) ? v : P) ? x : P, S = w < (S = b < (S = y < S ? y : S) ? b : S) ? w : S, _ = x > (_ = v > (_ = m > _ ? m : _) ? v : _) ? x : _, T = w > (T = b > (T = y > T ? y : T) ? b : T) ? w : T, this._bounds.x = P, this._bounds.width = _ - P, this._bounds.y = S, this._bounds.height = T - S, this._currentBounds = this._bounds, this._currentBounds;
        }, s.Graphics.prototype.getLocalBounds = function () {
          var t = this.worldTransform;
          this.worldTransform = s.identityMatrix;

          for (var e = 0; e < this.children.length; e++) {
            this.children[e].updateTransform();
          }

          var i = this.getBounds();

          for (this.worldTransform = t, e = 0; e < this.children.length; e++) {
            this.children[e].updateTransform();
          }

          return i;
        }, s.Graphics.prototype.containsPoint = function (t, e) {
          void 0 === e && (e = new s.Point()), this.worldTransform.applyInverse(t, e);

          for (var i = this.graphicsData, n = 0; n < i.length; n++) {
            var o = i[n];
            if (o.fill && o.shape && o.shape.contains(e.x, e.y)) return !0;
          }

          return !1;
        }, s.Graphics.prototype.updateLocalBounds = function () {
          var t = 1 / 0,
              e = -1 / 0,
              i = 1 / 0,
              n = -1 / 0;
          if (this.graphicsData.length) for (var o, r, a, h, l, c, u = 0; u < this.graphicsData.length; u++) {
            var d = this.graphicsData[u],
                p = d.type,
                f = d.lineWidth;
            if (o = d.shape, p === s.RECTANGLE || p === s.ROUNDEDRECTANGLE) a = o.x - f / 2, h = o.y - f / 2, l = o.width + f, c = o.height + f, t = a < t ? a : t, e = a + l > e ? a + l : e, i = h < i ? h : i, n = h + c > n ? h + c : n;else if (p === s.CIRCLE) a = o.x, h = o.y, l = o.radius + f / 2, c = o.radius + f / 2, t = a - l < t ? a - l : t, e = a + l > e ? a + l : e, i = h - c < i ? h - c : i, n = h + c > n ? h + c : n;else if (p === s.ELLIPSE) a = o.x, h = o.y, l = o.width + f / 2, c = o.height + f / 2, t = a - l < t ? a - l : t, e = a + l > e ? a + l : e, i = h - c < i ? h - c : i, n = h + c > n ? h + c : n;else {
              r = o.points;

              for (var g = 0; g < r.length; g++) {
                r[g] instanceof s.Point ? (a = r[g].x, h = r[g].y) : (a = r[g], h = r[g + 1], g < r.length - 1 && g++), t = a - f < t ? a - f : t, e = a + f > e ? a + f : e, i = h - f < i ? h - f : i, n = h + f > n ? h + f : n;
              }
            }
          } else t = 0, e = 0, i = 0, n = 0;
          var m = this.boundsPadding;
          this._localBounds.x = t - m, this._localBounds.width = e - t + 2 * m, this._localBounds.y = i - m, this._localBounds.height = n - i + 2 * m;
        }, s.Graphics.prototype._generateCachedSprite = function () {
          var t = this.getLocalBounds();
          if (this._cachedSprite) this._cachedSprite.buffer.resize(t.width, t.height);else {
            var e = new PIXI.CanvasBuffer(t.width, t.height),
                i = PIXI.Texture.fromCanvas(e.canvas);
            this._cachedSprite = new PIXI.Sprite(i), this._cachedSprite.buffer = e, this._cachedSprite.worldTransform = this.worldTransform;
          }
          this._cachedSprite.anchor.x = -t.x / t.width, this._cachedSprite.anchor.y = -t.y / t.height, this._cachedSprite.buffer.context.translate(-t.x, -t.y), this.worldAlpha = 1, PIXI.CanvasGraphics.renderGraphics(this, this._cachedSprite.buffer.context), this._cachedSprite.alpha = this.alpha;
        }, s.Graphics.prototype.updateCachedSpriteTexture = function () {
          var t = this._cachedSprite,
              e = t.texture,
              i = t.buffer.canvas;
          e.baseTexture.width = i.width, e.baseTexture.height = i.height, e.crop.width = e.frame.width = i.width, e.crop.height = e.frame.height = i.height, t._width = i.width, t._height = i.height, e.baseTexture.dirty();
        }, s.Graphics.prototype.destroyCachedSprite = function () {
          this._cachedSprite.texture.destroy(!0), this._cachedSprite = null;
        }, s.Graphics.prototype.drawShape = function (t) {
          this.currentPath && this.currentPath.shape.points.length <= 2 && this.graphicsData.pop(), this.currentPath = null, t instanceof s.Polygon && (t = t.clone()).flatten();
          var e = new s.GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, t);
          return this.graphicsData.push(e), e.type === s.POLYGON && (e.shape.closed = this.filling, this.currentPath = e), this.dirty = !0, this._boundsDirty = !0, e;
        }, Object.defineProperty(s.Graphics.prototype, "cacheAsBitmap", {
          get: function get() {
            return this._cacheAsBitmap;
          },
          set: function set(t) {
            this._cacheAsBitmap = t, this._cacheAsBitmap ? this._generateCachedSprite() : this.destroyCachedSprite(), this.dirty = !0, this.webGLDirty = !0;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.RenderTexture = function (t, e, i, n, o, r, a, h) {
          if (void 0 === e && (e = 100), void 0 === i && (i = 100), void 0 === n && (n = ""), void 0 === o && (o = s.scaleModes.DEFAULT), void 0 === r && (r = 1), void 0 === a && (a = PIXI.defaultRenderer), void 0 === h && (h = 0), this.game = t, this.key = n, this.type = s.RENDERTEXTURE, this._tempMatrix = new s.Matrix(), this.width = e, this.height = i, this.resolution = r, this.frame = new s.Rectangle(0, 0, this.width * this.resolution, this.height * this.resolution), this.crop = this.frame.clone(), this.baseTexture = new PIXI.BaseTexture(), this.baseTexture.width = this.width * this.resolution, this.baseTexture.height = this.height * this.resolution, this.baseTexture._glTextures = [], this.baseTexture.resolution = this.resolution, this.baseTexture.scaleMode = o, this.baseTexture.hasLoaded = !0, PIXI.Texture.call(this, this.baseTexture, this.frame.clone()), this.renderer = a, this.renderer.type === s.WEBGL) {
            var l = this.renderer.gl;
            this.baseTexture.textureIndex = h, this.baseTexture._dirty[l.id] = !1, this.textureBuffer = new PIXI.FilterTexture(l, this.width, this.height, this.baseTexture.scaleMode, h), this.baseTexture._glTextures[l.id] = this.textureBuffer.texture, this.projection = new s.Point(.5 * this.width, .5 * -this.height);
          } else this.textureBuffer = new PIXI.CanvasBuffer(this.width * this.resolution, this.height * this.resolution), this.baseTexture.source = this.textureBuffer.canvas;

          this.valid = !0, this.tempMatrix = new s.Matrix(), this._updateUvs();
        }, s.RenderTexture.prototype = Object.create(PIXI.Texture.prototype), s.RenderTexture.prototype.constructor = s.RenderTexture, s.RenderTexture.prototype.renderXY = function (t, e, i, n) {
          t.updateTransform(), this._tempMatrix.copyFrom(t.worldTransform), this._tempMatrix.tx = e, this._tempMatrix.ty = i, this.renderer.type === s.WEBGL ? this._renderWebGL(t, this._tempMatrix, n) : this._renderCanvas(t, this._tempMatrix, n);
        }, s.RenderTexture.prototype.renderRawXY = function (t, e, i, n) {
          this._tempMatrix.identity().translate(e, i), this.renderer.type === s.WEBGL ? this._renderWebGL(t, this._tempMatrix, n) : this._renderCanvas(t, this._tempMatrix, n);
        }, s.RenderTexture.prototype.render = function (t, e, i) {
          void 0 === e || null === e ? this._tempMatrix.copyFrom(t.worldTransform) : this._tempMatrix.copyFrom(e), this.renderer.type === s.WEBGL ? this._renderWebGL(t, this._tempMatrix, i) : this._renderCanvas(t, this._tempMatrix, i);
        }, s.RenderTexture.prototype.resize = function (t, e, i) {
          t === this.width && e === this.height || (this.valid = t > 0 && e > 0, this.width = t, this.height = e, this.frame.width = this.crop.width = t * this.resolution, this.frame.height = this.crop.height = e * this.resolution, i && (this.baseTexture.width = this.width * this.resolution, this.baseTexture.height = this.height * this.resolution), this.renderer.type === s.WEBGL && (this.projection.x = this.width / 2, this.projection.y = -this.height / 2), this.valid && this.textureBuffer.resize(this.width, this.height));
        }, s.RenderTexture.prototype.clear = function () {
          this.valid && (this.renderer.type === s.WEBGL && this.renderer.gl.bindFramebuffer(this.renderer.gl.FRAMEBUFFER, this.textureBuffer.frameBuffer), this.textureBuffer.clear());
        }, s.RenderTexture.prototype._renderWebGL = function (t, e, i) {
          if (this.valid && 0 !== t.alpha) {
            var s = t.worldTransform;
            s.identity(), s.translate(0, 2 * this.projection.y), e && s.append(e), s.scale(1, -1);

            for (var n = 0; n < t.children.length; n++) {
              t.children[n].updateTransform();
            }

            var o = this.renderer.gl;
            o.viewport(0, 0, this.width * this.resolution, this.height * this.resolution), o.bindFramebuffer(o.FRAMEBUFFER, this.textureBuffer.frameBuffer), i && this.textureBuffer.clear(), this.renderer.spriteBatch.dirty = !0, this.renderer.renderDisplayObject(t, this.projection, this.textureBuffer.frameBuffer, e), this.renderer.spriteBatch.dirty = !0, o.bindFramebuffer(o.FRAMEBUFFER, null);
          }
        }, s.RenderTexture.prototype._renderCanvas = function (t, e, i) {
          if (this.valid && 0 !== t.alpha) {
            var s = t.worldTransform;
            s.identity(), e && s.append(e);

            for (var n = 0; n < t.children.length; n++) {
              t.children[n].updateTransform();
            }

            i && this.textureBuffer.clear();
            var o = this.renderer.resolution;
            this.renderer.resolution = this.resolution, this.renderer.renderDisplayObject(t, this.textureBuffer.context, e), this.renderer.resolution = o;
          }
        }, s.RenderTexture.prototype.getImage = function () {
          var t = new Image();
          return t.src = this.getBase64(), t;
        }, s.RenderTexture.prototype.getBase64 = function () {
          return this.getCanvas().toDataURL();
        }, s.RenderTexture.prototype.getCanvas = function () {
          if (this.renderer.type === s.WEBGL) {
            var t = this.renderer.gl,
                e = this.textureBuffer.width,
                i = this.textureBuffer.height,
                n = new Uint8Array(4 * e * i);
            t.bindFramebuffer(t.FRAMEBUFFER, this.textureBuffer.frameBuffer), t.readPixels(0, 0, e, i, t.RGBA, t.UNSIGNED_BYTE, n), t.bindFramebuffer(t.FRAMEBUFFER, null);
            var o = new PIXI.CanvasBuffer(e, i),
                r = o.context.getImageData(0, 0, e, i);
            return r.data.set(n), o.context.putImageData(r, 0, 0), o.canvas;
          }

          return this.textureBuffer.canvas;
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Text = function (t, e, i, n, o) {
          e = e || 0, i = i || 0, n = void 0 === n || null === n ? "" : n.toString(), this.canvas = s.CanvasPool.create(this), s.Sprite.call(this, t, e, i, PIXI.Texture.fromCanvas(this.canvas)), this.type = s.TEXT, this.physicsType = s.SPRITE, this.padding = new s.Point(), this.textBounds = null, this.context = this.canvas.getContext("2d"), this.colors = [], this.strokeColors = [], this.fontStyles = [], this.fontWeights = [], this.autoRound = !1, this.useAdvancedWrap = !1, this.splitRegExp = /(?:\r\n|\r|\n)/, this.characterLimitSize = -1, this.characterLimitSuffix = "", this._testString = "|MÉq", this._res = t.renderer.resolution, this._text = n, this._fontComponents = null, this._lineSpacing = 0, this._charCount = 0, this._width = 0, this._height = 0, this.style = {}, this.setStyle(o || {}), "" !== n && this.updateText();
        }, s.Text.prototype = Object.create(s.Sprite.prototype), s.Text.prototype.constructor = s.Text, s.Text.prototype.preUpdate = function () {
          return !!(this.preUpdatePhysics() && this.preUpdateLifeSpan() && this.preUpdateInWorld()) && this.preUpdateCore();
        }, s.Text.prototype.update = function () {}, s.Text.prototype.destroy = function (t) {
          this.texture.destroy(!0), s.Component.Destroy.prototype.destroy.call(this, t);
        }, s.Text.prototype.setShadow = function (t, e, i, s, n, o) {
          return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = "rgba(0, 0, 0, 1)"), void 0 === s && (s = 0), void 0 === n && (n = !0), void 0 === o && (o = !0), this.style.shadowOffsetX = t, this.style.shadowOffsetY = e, this.style.shadowColor = i, this.style.shadowBlur = s, this.style.shadowStroke = n, this.style.shadowFill = o, this.dirty = !0, this;
        }, s.Text.prototype.setStyle = function (t, e) {
          void 0 === e && (e = !1);
          var i = Object.assign({}, t);
          i.font = t.font || "bold 20pt Arial", i.backgroundColor = t.backgroundColor || null, i.fill = t.fill || "black", i.align = (t.align || "left").toLowerCase(), i.boundsAlignH = (t.boundsAlignH || "left").toLowerCase(), i.boundsAlignV = (t.boundsAlignV || "top").toLowerCase(), i.stroke = t.stroke || "black", i.strokeThickness = Number(t.strokeThickness) || 0, i.wordWrap = t.wordWrap || !1, i.wordWrapWidth = t.wordWrapWidth || 100, i.maxLines = t.maxLines || 0, i.shadowOffsetX = t.shadowOffsetX || 0, i.shadowOffsetY = t.shadowOffsetY || 0, i.shadowColor = t.shadowColor || "rgba(0,0,0,0)", i.shadowBlur = t.shadowBlur || 0, i.tabs = t.tabs || 0;
          var s = this.fontToComponents(i.font);
          return i.fontStyle && (s.fontStyle = i.fontStyle), i.fontVariant && (s.fontVariant = i.fontVariant), i.fontWeight && (s.fontWeight = i.fontWeight), i.fontSize && ("number" == typeof i.fontSize && (i.fontSize = i.fontSize + "px"), s.fontSize = i.fontSize), this._fontComponents = s, i.font = this.componentsToFont(this._fontComponents), this.style = i, this.dirty = !0, e && this.updateText(), this;
        }, s.Text.prototype.updateText = function () {
          this.texture.baseTexture.resolution = this._res, this.context.font = this.style.font;
          var t = this.text;
          this.characterLimitSize > -1 && this.characterLimitSize < t.length && (t = this.text.substring(0, this.characterLimitSize) + this.characterLimitSuffix), this.style.wordWrap && (t = this.runWordWrap(this.text));
          var e = t.split(this.splitRegExp),
              i = this.style.tabs,
              s = [],
              n = 0,
              o = this.determineFontProperties(this.style.font),
              r = e.length;
          this.style.maxLines > 0 && this.style.maxLines < e.length && (r = this.style.maxLines), this._charCount = 0;

          for (var a = 0; a < r; a++) {
            if (0 === i) {
              var h = this.style.strokeThickness + this.padding.x;
              this.colors.length > 0 || this.strokeColors.length > 0 || this.fontWeights.length > 0 || this.fontStyles.length > 0 ? h += this.measureLine(e[a]) : h += this.context.measureText(e[a]).width, this.style.wordWrap && (h -= this.context.measureText(" ").width);
            } else {
              var l = e[a].split(/(?:\t)/);
              h = this.padding.x + this.style.strokeThickness;
              if (Array.isArray(i)) for (var c = 0, u = 0; u < l.length; u++) {
                var d = 0;
                d = this.colors.length > 0 || this.strokeColors.length > 0 || this.fontWeights.length > 0 || this.fontStyles.length > 0 ? this.measureLine(l[u]) : Math.ceil(this.context.measureText(l[u]).width), u > 0 && (c += i[u - 1]), h = c + d;
              } else for (u = 0; u < l.length; u++) {
                this.colors.length > 0 || this.strokeColors.length > 0 || this.fontWeights.length > 0 || this.fontStyles.length > 0 ? h += this.measureLine(l[u]) : h += Math.ceil(this.context.measureText(l[u]).width), h += this.game.math.snapToCeil(h, i) - h;
              }
            }

            s[a] = Math.ceil(h), n = Math.max(n, s[a]);
          }

          this.canvas.width = n * this._res;
          var p,
              f,
              g = o.fontSize + this.style.strokeThickness + this.padding.y,
              m = g * r,
              y = this._lineSpacing;

          for (y < 0 && Math.abs(y) > g && (y = -g), 0 !== y && (m += y > 0 ? y * e.length : y * (e.length - 1)), this.canvas.height = m * this._res, this.context.scale(this._res, this._res), navigator.isCocoonJS && this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.style.backgroundColor && (this.context.fillStyle = this.style.backgroundColor, this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)), this.context.fillStyle = this.style.fill, this.context.font = this.style.font, this.context.strokeStyle = this.style.stroke, this.context.textBaseline = "alphabetic", this.context.lineWidth = this.style.strokeThickness, this.context.lineCap = "round", this.context.lineJoin = "round", this._charCount = 0, a = 0; a < r; a++) {
            p = this.style.strokeThickness / 2, f = this.style.strokeThickness / 2 + a * g + o.ascent, a > 0 && (f += y * a), "right" === this.style.align ? p += n - s[a] : "center" === this.style.align && (p += (n - s[a]) / 2), this.autoRound && (p = Math.round(p), f = Math.round(f)), this.colors.length > 0 || this.strokeColors.length > 0 || this.fontWeights.length > 0 || this.fontStyles.length > 0 ? this.updateLine(e[a], p, f) : (this.style.stroke && this.style.strokeThickness && (this.updateShadow(this.style.shadowStroke), 0 === i ? this.context.strokeText(e[a], p, f) : this.renderTabLine(e[a], p, f, !1)), this.style.fill && (this.updateShadow(this.style.shadowFill), 0 === i ? this.context.fillText(e[a], p, f) : this.renderTabLine(e[a], p, f, !0)));
          }

          this.updateTexture(), this.dirty = !1;
        }, s.Text.prototype.renderTabLine = function (t, e, i, s) {
          var n = t.split(/(?:\t)/),
              o = this.style.tabs,
              r = 0;
          if (Array.isArray(o)) for (var a = 0, h = 0; h < n.length; h++) {
            h > 0 && (a += o[h - 1]), r = e + a, s ? this.context.fillText(n[h], r, i) : this.context.strokeText(n[h], r, i);
          } else for (h = 0; h < n.length; h++) {
            var l = Math.ceil(this.context.measureText(n[h]).width);
            r = this.game.math.snapToCeil(e, o), s ? this.context.fillText(n[h], r, i) : this.context.strokeText(n[h], r, i), e = r + l;
          }
        }, s.Text.prototype.updateShadow = function (t) {
          t ? (this.context.shadowOffsetX = this.style.shadowOffsetX, this.context.shadowOffsetY = this.style.shadowOffsetY, this.context.shadowColor = this.style.shadowColor, this.context.shadowBlur = this.style.shadowBlur) : (this.context.shadowOffsetX = 0, this.context.shadowOffsetY = 0, this.context.shadowColor = 0, this.context.shadowBlur = 0);
        }, s.Text.prototype.measureLine = function (t) {
          for (var e = 0, i = 0; i < t.length; i++) {
            var s = t[i];

            if (this.fontWeights.length > 0 || this.fontStyles.length > 0) {
              var n = this.fontToComponents(this.context.font);
              this.fontStyles[this._charCount] && (n.fontStyle = this.fontStyles[this._charCount]), this.fontWeights[this._charCount] && (n.fontWeight = this.fontWeights[this._charCount]), this.context.font = this.componentsToFont(n);
            }

            this.style.stroke && this.style.strokeThickness && (this.strokeColors[this._charCount] && (this.context.strokeStyle = this.strokeColors[this._charCount]), this.updateShadow(this.style.shadowStroke)), this.style.fill && (this.colors[this._charCount] && (this.context.fillStyle = this.colors[this._charCount]), this.updateShadow(this.style.shadowFill)), e += this.context.measureText(s).width, this._charCount++;
          }

          return Math.ceil(e);
        }, s.Text.prototype.updateLine = function (t, e, i) {
          for (var s = 0; s < t.length; s++) {
            var n = t[s];

            if (this.fontWeights.length > 0 || this.fontStyles.length > 0) {
              var o = this.fontToComponents(this.context.font);
              this.fontStyles[this._charCount] && (o.fontStyle = this.fontStyles[this._charCount]), this.fontWeights[this._charCount] && (o.fontWeight = this.fontWeights[this._charCount]), this.context.font = this.componentsToFont(o);
            }

            this.style.stroke && this.style.strokeThickness && (this.strokeColors[this._charCount] && (this.context.strokeStyle = this.strokeColors[this._charCount]), this.updateShadow(this.style.shadowStroke), this.context.strokeText(n, e, i)), this.style.fill && (this.colors[this._charCount] && (this.context.fillStyle = this.colors[this._charCount]), this.updateShadow(this.style.shadowFill), this.context.fillText(n, e, i)), e += this.context.measureText(n).width, this._charCount++;
          }
        }, s.Text.prototype.clearColors = function () {
          return this.colors = [], this.strokeColors = [], this.dirty = !0, this;
        }, s.Text.prototype.clearFontValues = function () {
          return this.fontStyles = [], this.fontWeights = [], this.dirty = !0, this;
        }, s.Text.prototype.addColor = function (t, e) {
          return this.colors[e] = t, this.dirty = !0, this;
        }, s.Text.prototype.addStrokeColor = function (t, e) {
          return this.strokeColors[e] = t, this.dirty = !0, this;
        }, s.Text.prototype.addFontStyle = function (t, e) {
          return this.fontStyles[e] = t, this.dirty = !0, this;
        }, s.Text.prototype.addFontWeight = function (t, e) {
          return this.fontWeights[e] = t, this.dirty = !0, this;
        }, s.Text.prototype.precalculateWordWrap = function (t) {
          return this.texture.baseTexture.resolution = this._res, this.context.font = this.style.font, this.runWordWrap(t).split(/(?:\r\n|\r|\n)/);
        }, s.Text.prototype.runWordWrap = function (t) {
          return this.useAdvancedWrap ? this.advancedWordWrap(t) : this.basicWordWrap(t);
        }, s.Text.prototype.advancedWordWrap = function (t) {
          for (var e = this.context, i = this.style.wordWrapWidth, s = "", n = t.replace(/ +/gi, " ").split(/\r?\n/gi), o = n.length, r = 0; r < o; r++) {
            var a = n[r],
                h = "";
            if (a = a.replace(/^ *|\s*$/gi, ""), e.measureText(a).width < i) s += a + "\n";else {
              for (var l = i, c = a.split(" "), u = 0; u < c.length; u++) {
                var d = c[u],
                    p = d + " ",
                    f = e.measureText(p).width;

                if (f > l) {
                  if (0 === u) {
                    for (var g = p; g.length && (g = g.slice(0, -1), !((f = e.measureText(g).width) <= l));) {
                      ;
                    }

                    if (!g.length) throw new Error("This text's wordWrapWidth setting is less than a single character!");
                    var m = d.substr(g.length);
                    c[u] = m, h += g;
                  }

                  var y = c[u].length ? u : u + 1,
                      v = c.slice(y).join(" ").replace(/[ \n]*$/gi, "");
                  n[r + 1] = v + " " + (n[r + 1] || ""), o = n.length;
                  break;
                }

                h += p, l -= f;
              }

              s += h.replace(/[ \n]*$/gi, "") + "\n";
            }
          }

          return s = s.replace(/[\s|\n]*$/gi, "");
        }, s.Text.prototype.basicWordWrap = function (t) {
          for (var e = "", i = t.split("\n"), s = 0; s < i.length; s++) {
            for (var n = this.style.wordWrapWidth, o = i[s].split(" "), r = 0; r < o.length; r++) {
              var a = this.context.measureText(o[r]).width,
                  h = a + this.context.measureText(" ").width;
              h > n ? (r > 0 && (e += "\n"), e += o[r] + " ", n = this.style.wordWrapWidth - a) : (n -= h, e += o[r] + " ");
            }

            s < i.length - 1 && (e += "\n");
          }

          return e;
        }, s.Text.prototype.updateFont = function (t) {
          var e = this.componentsToFont(t);
          this.style.font !== e && (this.style.font = e, this.dirty = !0, this.parent && this.updateTransform());
        }, s.Text.prototype.fontToComponents = function (t) {
          var e = t.match(/^\s*(?:\b(normal|italic|oblique|inherit)?\b)\s*(?:\b(normal|small-caps|inherit)?\b)\s*(?:\b(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit)?\b)\s*(?:\b(xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller|0|\d*(?:[.]\d*)?(?:%|[a-z]{2,5}))?\b)\s*(.*)\s*$/);

          if (e) {
            var i = e[5].trim();
            return /^(?:inherit|serif|sans-serif|cursive|fantasy|monospace)$/.exec(i) || /['",]/.exec(i) || (i = "'" + i + "'"), {
              font: t,
              fontStyle: e[1] || "normal",
              fontVariant: e[2] || "normal",
              fontWeight: e[3] || "normal",
              fontSize: e[4] || "medium",
              fontFamily: i
            };
          }

          return console.warn("Phaser.Text - unparsable CSS font: " + t), {
            font: t
          };
        }, s.Text.prototype.componentsToFont = function (t) {
          var e,
              i = [];
          return (e = t.fontStyle) && "normal" !== e && i.push(e), (e = t.fontVariant) && "normal" !== e && i.push(e), (e = t.fontWeight) && "normal" !== e && i.push(e), (e = t.fontSize) && "medium" !== e && i.push(e), (e = t.fontFamily) && i.push(e), i.length || i.push(t.font), i.join(" ");
        }, s.Text.prototype.setText = function (t, e) {
          return void 0 === e && (e = !1), (t = t.toString() || "") === this._text ? this : (this.text = t, e ? this.updateText() : this.dirty = !0, this);
        }, s.Text.prototype.parseList = function (t) {
          if (!Array.isArray(t)) return this;

          for (var e = "", i = 0; i < t.length; i++) {
            Array.isArray(t[i]) ? (e += t[i].join("\t"), i < t.length - 1 && (e += "\n")) : (e += t[i], i < t.length - 1 && (e += "\t"));
          }

          return this.text = e, this.dirty = !0, this;
        }, s.Text.prototype.setTextBounds = function (t, e, i, n) {
          return void 0 === t ? this.textBounds = null : (this.textBounds ? this.textBounds.setTo(t, e, i, n) : this.textBounds = new s.Rectangle(t, e, i, n), this.style.wordWrapWidth > i && (this.style.wordWrapWidth = i)), this.updateTexture(), this;
        }, s.Text.prototype.updateTexture = function () {
          var t = this.texture.baseTexture,
              e = this.texture.crop,
              i = this.texture.frame,
              s = this.canvas.width,
              n = this.canvas.height;

          if (t.width = s, t.height = n, e.width = s, e.height = n, i.width = s, i.height = n, this.texture.width = s, this.texture.height = n, this._width = s, this._height = n, this.textBounds) {
            var o = this.textBounds.x,
                r = this.textBounds.y;
            "right" === this.style.boundsAlignH ? o += this.textBounds.width - this.canvas.width / this.resolution : "center" === this.style.boundsAlignH && (o += this.textBounds.halfWidth - this.canvas.width / this.resolution / 2), "bottom" === this.style.boundsAlignV ? r += this.textBounds.height - this.canvas.height / this.resolution : "middle" === this.style.boundsAlignV && (r += this.textBounds.halfHeight - this.canvas.height / this.resolution / 2), this.pivot.x = -o, this.pivot.y = -r;
          }

          this.renderable = 0 !== s && 0 !== n, this.texture.requiresReTint = !0, this.texture.baseTexture.dirty();
        }, s.Text.prototype._renderWebGL = function (t) {
          this.dirty && (this.updateText(), this.dirty = !1), PIXI.Sprite.prototype._renderWebGL.call(this, t);
        }, s.Text.prototype._renderCanvas = function (t) {
          this.dirty && (this.updateText(), this.dirty = !1), PIXI.Sprite.prototype._renderCanvas.call(this, t);
        }, s.Text.prototype.determineFontProperties = function (t) {
          var e = s.Text.fontPropertiesCache[t],
              i = this.testString || "|MÉq";

          if (!e) {
            e = {};
            var n = s.Text.fontPropertiesCanvas,
                o = s.Text.fontPropertiesContext;
            o.font = t;
            var r = Math.ceil(o.measureText(i).width),
                a = Math.ceil(o.measureText(i).width),
                h = 2 * a;
            if (a = 1.4 * a | 0, n.width = r, n.height = h, o.fillStyle = "#f00", o.fillRect(0, 0, r, h), o.font = t, o.textBaseline = "alphabetic", o.fillStyle = "#000", o.fillText(i, 0, a), !o.getImageData(0, 0, r, h)) return e.ascent = a, e.descent = a + 6, e.fontSize = e.ascent + e.descent, s.Text.fontPropertiesCache[t] = e, e;
            var l,
                c,
                u = o.getImageData(0, 0, r, h).data,
                d = u.length,
                p = 4 * r,
                f = 0,
                g = !1;

            for (l = 0; l < a; l++) {
              for (c = 0; c < p; c += 4) {
                if (255 !== u[f + c]) {
                  g = !0;
                  break;
                }
              }

              if (g) break;
              f += p;
            }

            for (e.ascent = a - l, f = d - p, g = !1, l = h; l > a; l--) {
              for (c = 0; c < p; c += 4) {
                if (255 !== u[f + c]) {
                  g = !0;
                  break;
                }
              }

              if (g) break;
              f -= p;
            }

            e.descent = l - a, e.descent += 6, e.fontSize = e.ascent + e.descent, s.Text.fontPropertiesCache[t] = e;
          }

          return e;
        }, s.Text.prototype.getBounds = function (t) {
          return this.dirty && (this.updateText(), this.dirty = !1), PIXI.Sprite.prototype.getBounds.call(this, t);
        }, s.Text.prototype.setCharacterLimit = function (t, e) {
          this.characterLimitSuffix = void 0 === e ? "" : e, this.characterLimitSize = t, this.updateText();
        }, Object.defineProperty(s.Text.prototype, "text", {
          get: function get() {
            return this._text;
          },
          set: function set(t) {
            t !== this._text && (this._text = t.toString() || "", this.dirty = !0, this.parent && this.updateTransform());
          }
        }), Object.defineProperty(s.Text.prototype, "cssFont", {
          get: function get() {
            return this.componentsToFont(this._fontComponents);
          },
          set: function set(t) {
            t = t || "bold 20pt Arial", this._fontComponents = this.fontToComponents(t), this.updateFont(this._fontComponents);
          }
        }), Object.defineProperty(s.Text.prototype, "font", {
          get: function get() {
            return this._fontComponents.fontFamily;
          },
          set: function set(t) {
            t = (t = t || "Arial").trim(), /^(?:inherit|serif|sans-serif|cursive|fantasy|monospace)$/.exec(t) || /['",]/.exec(t) || (t = "'" + t + "'"), this._fontComponents.fontFamily = t, this.updateFont(this._fontComponents);
          }
        }), Object.defineProperty(s.Text.prototype, "fontSize", {
          get: function get() {
            var t = this._fontComponents.fontSize;
            return t && /(?:^0$|px$)/.exec(t) ? parseInt(t, 10) : t;
          },
          set: function set(t) {
            "number" == typeof (t = t || "0") && (t += "px"), this._fontComponents.fontSize = t, this.updateFont(this._fontComponents);
          }
        }), Object.defineProperty(s.Text.prototype, "fontWeight", {
          get: function get() {
            return this._fontComponents.fontWeight || "normal";
          },
          set: function set(t) {
            t = t || "normal", this._fontComponents.fontWeight = t, this.updateFont(this._fontComponents);
          }
        }), Object.defineProperty(s.Text.prototype, "fontStyle", {
          get: function get() {
            return this._fontComponents.fontStyle || "normal";
          },
          set: function set(t) {
            t = t || "normal", this._fontComponents.fontStyle = t, this.updateFont(this._fontComponents);
          }
        }), Object.defineProperty(s.Text.prototype, "fontVariant", {
          get: function get() {
            return this._fontComponents.fontVariant || "normal";
          },
          set: function set(t) {
            t = t || "normal", this._fontComponents.fontVariant = t, this.updateFont(this._fontComponents);
          }
        }), Object.defineProperty(s.Text.prototype, "fill", {
          get: function get() {
            return this.style.fill;
          },
          set: function set(t) {
            t !== this.style.fill && (this.style.fill = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "align", {
          get: function get() {
            return this.style.align;
          },
          set: function set(t) {
            (t = t.toLowerCase()) !== this.style.align && (this.style.align = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "resolution", {
          get: function get() {
            return this._res;
          },
          set: function set(t) {
            t !== this._res && (this._res = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "tabs", {
          get: function get() {
            return this.style.tabs;
          },
          set: function set(t) {
            t !== this.style.tabs && (this.style.tabs = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "boundsAlignH", {
          get: function get() {
            return this.style.boundsAlignH;
          },
          set: function set(t) {
            (t = t.toLowerCase()) !== this.style.boundsAlignH && (this.style.boundsAlignH = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "boundsAlignV", {
          get: function get() {
            return this.style.boundsAlignV;
          },
          set: function set(t) {
            (t = t.toLowerCase()) !== this.style.boundsAlignV && (this.style.boundsAlignV = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "stroke", {
          get: function get() {
            return this.style.stroke;
          },
          set: function set(t) {
            t !== this.style.stroke && (this.style.stroke = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "strokeThickness", {
          get: function get() {
            return this.style.strokeThickness;
          },
          set: function set(t) {
            t !== this.style.strokeThickness && (this.style.strokeThickness = Number(t), this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "wordWrap", {
          get: function get() {
            return this.style.wordWrap;
          },
          set: function set(t) {
            t !== this.style.wordWrap && (this.style.wordWrap = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "wordWrapWidth", {
          get: function get() {
            return this.style.wordWrapWidth;
          },
          set: function set(t) {
            t !== this.style.wordWrapWidth && (this.style.wordWrapWidth = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "lineSpacing", {
          get: function get() {
            return this._lineSpacing;
          },
          set: function set(t) {
            t !== this._lineSpacing && (this._lineSpacing = parseFloat(t), this.dirty = !0, this.parent && this.updateTransform());
          }
        }), Object.defineProperty(s.Text.prototype, "shadowOffsetX", {
          get: function get() {
            return this.style.shadowOffsetX;
          },
          set: function set(t) {
            t !== this.style.shadowOffsetX && (this.style.shadowOffsetX = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "shadowOffsetY", {
          get: function get() {
            return this.style.shadowOffsetY;
          },
          set: function set(t) {
            t !== this.style.shadowOffsetY && (this.style.shadowOffsetY = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "shadowColor", {
          get: function get() {
            return this.style.shadowColor;
          },
          set: function set(t) {
            t !== this.style.shadowColor && (this.style.shadowColor = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "shadowBlur", {
          get: function get() {
            return this.style.shadowBlur;
          },
          set: function set(t) {
            t !== this.style.shadowBlur && (this.style.shadowBlur = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "shadowStroke", {
          get: function get() {
            return this.style.shadowStroke;
          },
          set: function set(t) {
            t !== this.style.shadowStroke && (this.style.shadowStroke = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "shadowFill", {
          get: function get() {
            return this.style.shadowFill;
          },
          set: function set(t) {
            t !== this.style.shadowFill && (this.style.shadowFill = t, this.dirty = !0);
          }
        }), Object.defineProperty(s.Text.prototype, "width", {
          get: function get() {
            return this.dirty && (this.updateText(), this.dirty = !1), this.scale.x * (this.texture.frame.width / this.resolution);
          },
          set: function set(t) {
            this.scale.x = t / this.texture.frame.width, this._width = t;
          }
        }), Object.defineProperty(s.Text.prototype, "height", {
          get: function get() {
            return this.dirty && (this.updateText(), this.dirty = !1), this.scale.y * (this.texture.frame.height / this.resolution);
          },
          set: function set(t) {
            this.scale.y = t / this.texture.frame.height, this._height = t;
          }
        }), Object.defineProperty(s.Text.prototype, "testString", {
          get: function get() {
            return this._testString;
          },
          set: function set(t) {
            this._testString = t, this.updateText();
          }
        }), s.Text.fontPropertiesCache = {}, s.Text.fontPropertiesCanvas = document.createElement("canvas"), s.Text.fontPropertiesContext = s.Text.fontPropertiesCanvas.getContext("2d"),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.BitmapText = function (t, e, i, n, o, r, a) {
          e = e || 0, i = i || 0, n = n || "", o = o || "", r = r || 32, a = a || "left", PIXI.DisplayObjectContainer.call(this), this.type = s.BITMAPTEXT, this.physicsType = s.SPRITE, this.textWidth = 0, this.textHeight = 0, this.anchor = new s.Point(), this._prevAnchor = new s.Point(), this._glyphs = [], this._maxWidth = 0, this._text = o.toString() || "", this._data = t.cache.getBitmapFont(n), this._font = n, this._fontSize = r, this._align = a, this._tint = 16777215, this.updateText(), this.dirty = !1, s.Component.Core.init.call(this, t, e, i, "", null);
        }, s.BitmapText.prototype = Object.create(PIXI.DisplayObjectContainer.prototype), s.BitmapText.prototype.constructor = s.BitmapText, s.Component.Core.install.call(s.BitmapText.prototype, ["Angle", "AutoCull", "Bounds", "Destroy", "FixedToCamera", "InputEnabled", "InWorld", "LifeSpan", "PhysicsBody", "Reset"]), s.BitmapText.prototype.preUpdatePhysics = s.Component.PhysicsBody.preUpdate, s.BitmapText.prototype.preUpdateLifeSpan = s.Component.LifeSpan.preUpdate, s.BitmapText.prototype.preUpdateInWorld = s.Component.InWorld.preUpdate, s.BitmapText.prototype.preUpdateCore = s.Component.Core.preUpdate, s.BitmapText.prototype.preUpdate = function () {
          return !!(this.preUpdatePhysics() && this.preUpdateLifeSpan() && this.preUpdateInWorld()) && this.preUpdateCore();
        }, s.BitmapText.prototype.postUpdate = function () {
          s.Component.PhysicsBody.postUpdate.call(this), s.Component.FixedToCamera.postUpdate.call(this), this.body && this.body.type === s.Physics.ARCADE && (this.textWidth === this.body.sourceWidth && this.textHeight === this.body.sourceHeight || this.body.setSize(this.textWidth, this.textHeight));
        }, s.BitmapText.prototype.setText = function (t) {
          this.text = t;
        }, s.BitmapText.prototype.scanLine = function (t, e, i) {
          for (var s = 0, n = 0, o = -1, r = 0, a = null, h = this._maxWidth > 0 ? this._maxWidth : null, l = [], c = 0; c < i.length; c++) {
            var u = c === i.length - 1;
            if (/(?:\r\n|\r|\n)/.test(i.charAt(c))) return {
              width: n,
              text: i.substr(0, c),
              end: u,
              chars: l
            };
            var d,
                p = i.charCodeAt(c),
                f = t.chars[p];
            void 0 === f && (p = 32, f = t.chars[p]);
            var g = a && f.kerning[a] ? f.kerning[a] : 0;
            if (/(\s)/.test(i.charAt(c)) && (o = c, r = n), d = (g + f.texture.width + f.xOffset) * e, h && n + d >= h && o > -1) return {
              width: r || n,
              text: i.substr(0, c - (c - o)),
              end: !1,
              chars: l
            };
            n += (f.xAdvance + g) * e, l.push(s + (f.xOffset + g) * e), s += (f.xAdvance + g) * e, a = p;
          }

          return {
            width: n,
            text: i,
            end: u,
            chars: l
          };
        }, s.BitmapText.prototype.cleanText = function (t, e) {
          void 0 === e && (e = "");
          var i = this._data.font;
          if (!i) return "";

          for (var s = t.replace(/\r\n|\n\r|\n|\r/g, "\n").split("\n"), n = 0; n < s.length; n++) {
            for (var o = "", r = s[n], a = 0; a < r.length; a++) {
              o = i.chars[r.charCodeAt(a)] ? o.concat(r[a]) : o.concat(e);
            }

            s[n] = o;
          }

          return s.join("\n");
        }, s.BitmapText.prototype.updateText = function () {
          var t = this._data.font;

          if (t) {
            var e = this.text,
                i = this._fontSize / t.size,
                s = [],
                n = 0;
            this.textWidth = 0;

            do {
              (c = this.scanLine(t, i, e)).y = n, s.push(c), c.width > this.textWidth && (this.textWidth = c.width), n += t.lineHeight * i, e = e.substr(c.text.length + 1);
            } while (!1 === c.end);

            this.textHeight = n;

            for (var o = 0, r = 0, a = this.textWidth * this.anchor.x, h = this.textHeight * this.anchor.y, l = 0; l < s.length; l++) {
              var c = s[l];
              "right" === this._align ? r = this.textWidth - c.width : "center" === this._align && (r = (this.textWidth - c.width) / 2);

              for (var u = 0; u < c.text.length; u++) {
                var d = c.text.charCodeAt(u),
                    p = t.chars[d];
                void 0 === p && (d = 32, p = t.chars[d]);
                var f = this._glyphs[o];
                f ? f.texture = p.texture : ((f = new PIXI.Sprite(p.texture)).name = c.text[u], this._glyphs.push(f)), f.position.x = c.chars[u] + r - a, f.position.y = c.y + p.yOffset * i - h, f.scale.set(i), f.tint = this.tint, f.texture.requiresReTint = !0, f.cachedTint = 16777215, f.parent || this.addChild(f), o++;
              }
            }

            for (l = o; l < this._glyphs.length; l++) {
              this.removeChild(this._glyphs[l]);
            }
          }
        }, s.BitmapText.prototype.purgeGlyphs = function () {
          for (var t = this._glyphs.length, e = [], i = 0; i < this._glyphs.length; i++) {
            this._glyphs[i].parent !== this ? this._glyphs[i].destroy() : e.push(this._glyphs[i]);
          }

          return this._glyphs = [], this._glyphs = e, this.updateText(), t - e.length;
        }, s.BitmapText.prototype.updateTransform = function () {
          !this.dirty && this.anchor.equals(this._prevAnchor) || (this.updateText(), this.dirty = !1, this._prevAnchor.copyFrom(this.anchor)), PIXI.DisplayObjectContainer.prototype.updateTransform.call(this);
        }, Object.defineProperty(s.BitmapText.prototype, "align", {
          get: function get() {
            return this._align;
          },
          set: function set(t) {
            t === this._align || "left" !== t && "center" !== t && "right" !== t || (this._align = t, this.updateText());
          }
        }), Object.defineProperty(s.BitmapText.prototype, "tint", {
          get: function get() {
            return this._tint;
          },
          set: function set(t) {
            t !== this._tint && (this._tint = t, this.updateText());
          }
        }), Object.defineProperty(s.BitmapText.prototype, "font", {
          get: function get() {
            return this._font;
          },
          set: function set(t) {
            t !== this._font && (this._font = t.trim(), this._data = this.game.cache.getBitmapFont(this._font), this.updateText());
          }
        }), Object.defineProperty(s.BitmapText.prototype, "fontSize", {
          get: function get() {
            return this._fontSize;
          },
          set: function set(t) {
            (t = parseInt(t, 10)) !== this._fontSize && t > 0 && (this._fontSize = t, this.updateText());
          }
        }), Object.defineProperty(s.BitmapText.prototype, "text", {
          get: function get() {
            return this._text;
          },
          set: function set(t) {
            t !== this._text && (this._text = t.toString() || "", this.updateText());
          }
        }), Object.defineProperty(s.BitmapText.prototype, "maxWidth", {
          get: function get() {
            return this._maxWidth;
          },
          set: function set(t) {
            t !== this._maxWidth && (this._maxWidth = t, this.updateText());
          }
        }), Object.defineProperty(s.BitmapText.prototype, "smoothed", {
          get: function get() {
            return !this._data.base.scaleMode;
          },
          set: function set(t) {
            this._data.base.scaleMode = t ? 0 : 1, this._data.base.dirty();
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.RetroFont = function (t, e, i, n, o, r, a, h, l, c) {
          if (!t.cache.checkImageKey(e)) return !1;
          void 0 !== r && null !== r || (r = t.cache.getImage(e).width / i), this.characterWidth = i, this.characterHeight = n, this.characterSpacingX = a || 0, this.characterSpacingY = h || 0, this.characterPerRow = r, this.offsetX = l || 0, this.offsetY = c || 0, this.align = "left", this.multiLine = !1, this.autoUpperCase = !0, this.customSpacingX = 0, this.customSpacingY = 0, this.fixedWidth = 0, this.fontSet = t.cache.getImage(e), this._text = "", this.grabData = [], this.frameData = new s.FrameData();

          for (var u = this.offsetX, d = this.offsetY, p = 0, f = 0; f < o.length; f++) {
            var g = this.frameData.addFrame(new s.Frame(f, u, d, this.characterWidth, this.characterHeight));
            this.grabData[o.charCodeAt(f)] = g.index, ++p === this.characterPerRow ? (p = 0, u = this.offsetX, d += this.characterHeight + this.characterSpacingY) : u += this.characterWidth + this.characterSpacingX;
          }

          t.cache.updateFrameData(e, this.frameData), this.stamp = new s.Image(t, 0, 0, e, 0), s.RenderTexture.call(this, t, 100, 100, "", s.scaleModes.NEAREST), this.type = s.RETROFONT;
        }, s.RetroFont.prototype = Object.create(s.RenderTexture.prototype), s.RetroFont.prototype.constructor = s.RetroFont, s.RetroFont.ALIGN_LEFT = "left", s.RetroFont.ALIGN_RIGHT = "right", s.RetroFont.ALIGN_CENTER = "center", s.RetroFont.TEXT_SET1 = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~", s.RetroFont.TEXT_SET2 = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ", s.RetroFont.TEXT_SET3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ", s.RetroFont.TEXT_SET4 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789", s.RetroFont.TEXT_SET5 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789", s.RetroFont.TEXT_SET6 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789\"(),-.' ", s.RetroFont.TEXT_SET7 = "AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW\")28FLRX-'39", s.RetroFont.TEXT_SET8 = "0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ", s.RetroFont.TEXT_SET9 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'\"?!", s.RetroFont.TEXT_SET10 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", s.RetroFont.TEXT_SET11 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ.,\"-+!?()':;0123456789", s.RetroFont.prototype.setFixedWidth = function (t, e) {
          void 0 === e && (e = "left"), this.fixedWidth = t, this.align = e;
        }, s.RetroFont.prototype.setText = function (t, e, i, s, n, o) {
          this.multiLine = e || !1, this.customSpacingX = i || 0, this.customSpacingY = s || 0, this.align = n || "left", this.autoUpperCase = !o, t.length > 0 && (this.text = t);
        }, s.RetroFont.prototype.buildRetroFontText = function () {
          var t = 0,
              e = 0;

          if (this.clear(), this.multiLine) {
            var i = this._text.split("\n");

            this.fixedWidth > 0 ? this.resize(this.fixedWidth, i.length * (this.characterHeight + this.customSpacingY) - this.customSpacingY, !0) : this.resize(this.getLongestLine() * (this.characterWidth + this.customSpacingX), i.length * (this.characterHeight + this.customSpacingY) - this.customSpacingY, !0);

            for (var n = 0; n < i.length; n++) {
              t = 0, this.align === s.RetroFont.ALIGN_RIGHT ? t = this.width - i[n].length * (this.characterWidth + this.customSpacingX) : this.align === s.RetroFont.ALIGN_CENTER && (t = this.width / 2 - i[n].length * (this.characterWidth + this.customSpacingX) / 2, t += this.customSpacingX / 2), t < 0 && (t = 0), this.pasteLine(i[n], t, e, this.customSpacingX), e += this.characterHeight + this.customSpacingY;
            }
          } else this.fixedWidth > 0 ? this.resize(this.fixedWidth, this.characterHeight, !0) : this.resize(this._text.length * (this.characterWidth + this.customSpacingX), this.characterHeight, !0), t = 0, this.align === s.RetroFont.ALIGN_RIGHT ? t = this.width - this._text.length * (this.characterWidth + this.customSpacingX) : this.align === s.RetroFont.ALIGN_CENTER && (t = this.width / 2 - this._text.length * (this.characterWidth + this.customSpacingX) / 2, t += this.customSpacingX / 2), t < 0 && (t = 0), this.pasteLine(this._text, t, 0, this.customSpacingX);

          this.requiresReTint = !0;
        }, s.RetroFont.prototype.pasteLine = function (t, e, i, s) {
          for (var n = 0; n < t.length; n++) {
            if (" " === t.charAt(n)) e += this.characterWidth + s;else if (this.grabData[t.charCodeAt(n)] >= 0 && (this.stamp.frame = this.grabData[t.charCodeAt(n)], this.renderXY(this.stamp, e, i, !1), (e += this.characterWidth + s) > this.width)) break;
          }
        }, s.RetroFont.prototype.getLongestLine = function () {
          var t = 0;
          if (this._text.length > 0) for (var e = this._text.split("\n"), i = 0; i < e.length; i++) {
            e[i].length > t && (t = e[i].length);
          }
          return t;
        }, s.RetroFont.prototype.removeUnsupportedCharacters = function (t) {
          for (var e = "", i = 0; i < this._text.length; i++) {
            var s = this._text[i],
                n = s.charCodeAt(0);
            (this.grabData[n] >= 0 || !t && "\n" === s) && (e = e.concat(s));
          }

          return e;
        }, s.RetroFont.prototype.updateOffset = function (t, e) {
          if (this.offsetX !== t || this.offsetY !== e) {
            for (var i = t - this.offsetX, s = e - this.offsetY, n = this.game.cache.getFrameData(this.stamp.key).getFrames(), o = n.length; o--;) {
              n[o].x += i, n[o].y += s;
            }

            this.buildRetroFontText();
          }
        }, Object.defineProperty(s.RetroFont.prototype, "text", {
          get: function get() {
            return this._text;
          },
          set: function set(t) {
            var e;
            (e = this.autoUpperCase ? t.toUpperCase() : t) !== this._text && (this._text = e, this.removeUnsupportedCharacters(this.multiLine), this.buildRetroFontText());
          }
        }), Object.defineProperty(s.RetroFont.prototype, "smoothed", {
          get: function get() {
            return this.stamp.smoothed;
          },
          set: function set(t) {
            this.stamp.smoothed = t, this.buildRetroFontText();
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @author       Mat Groves (@Doormat23)
        * @author       Rovanion Luckey
        * @copyright    2016 Photon Storm Ltd, Richard Davey
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Rope = function (t, e, i, n, o, r) {
          this.points = r || [], this._hasUpdateAnimation = !1, this._updateAnimationCallback = null, e = e || 0, i = i || 0, n = n || null, o = o || null, this.type = s.ROPE, PIXI.DisplayObjectContainer.call(this), this.texture = s.Cache.DEFAULT, this.uvs = new Float32Array([0, 1, 1, 1, 1, 0, 0, 1]), this.vertices = new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]), this.colors = new Float32Array([1, 1, 1, 1]), this.indices = new Uint16Array([0, 1, 2, 3]), r && (this.vertices = new Float32Array(4 * r.length), this.uvs = new Float32Array(4 * r.length), this.colors = new Float32Array(2 * r.length), this.indices = new Uint16Array(2 * r.length)), this.dirty = !0, this.canvasPadding = 0, this.drawMode = s.Rope.TRIANGLE_STRIP, s.Component.Core.init.call(this, t, e, i, n, o), this.refresh();
        }, s.Rope.prototype = Object.create(PIXI.DisplayObjectContainer.prototype), s.Rope.prototype.constructor = s.Rope, s.Component.Core.install.call(s.Rope.prototype, ["Angle", "Animation", "AutoCull", "Bounds", "BringToTop", "Crop", "Delta", "Destroy", "FixedToCamera", "InWorld", "LifeSpan", "LoadTexture", "Overlap", "PhysicsBody", "Reset", "ScaleMinMax", "Smoothed"]), s.Rope.prototype.preUpdatePhysics = s.Component.PhysicsBody.preUpdate, s.Rope.prototype.preUpdateLifeSpan = s.Component.LifeSpan.preUpdate, s.Rope.prototype.preUpdateInWorld = s.Component.InWorld.preUpdate, s.Rope.prototype.preUpdateCore = s.Component.Core.preUpdate, s.Rope.TRIANGLE_STRIP = 0, s.Rope.TRIANGLES = 1, s.Rope.prototype.preUpdate = function () {
          return !!(this.preUpdatePhysics() && this.preUpdateLifeSpan() && this.preUpdateInWorld()) && this.preUpdateCore();
        }, s.Rope.prototype.update = function () {
          this._hasUpdateAnimation && this.updateAnimation.call(this);
        }, s.Rope.prototype.reset = function (t, e) {
          return s.Component.Reset.prototype.reset.call(this, t, e), this;
        }, s.Rope.prototype.refresh = function () {
          var t = this.points;

          if (!(t.length < 1)) {
            var e = this.uvs,
                i = this.indices,
                s = this.colors;
            this.count -= .2, e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, s[0] = 1, s[1] = 1, i[0] = 0, i[1] = 1;

            for (var n, o, r = t.length, a = 1; a < r; a++) {
              o = a / (r - 1), e[n = 4 * a] = o, e[n + 1] = 0, e[n + 2] = o, e[n + 3] = 1, s[n = 2 * a] = 1, s[n + 1] = 1, i[n = 2 * a] = n, i[n + 1] = n + 1;
            }
          }
        }, s.Rope.prototype.updateTransform = function () {
          var t = this.points;

          if (!(t.length < 1)) {
            var e,
                i = t[0],
                s = {
              x: 0,
              y: 0
            };
            this.count -= .2;

            for (var n, o, r, a, h = this.vertices, l = t.length, c = 0; c < l; c++) {
              n = t[c], o = 4 * c, e = c < t.length - 1 ? t[c + 1] : n, s.y = -(e.x - i.x), s.x = e.y - i.y, 10 * (1 - c / (l - 1)) > 1 && 1, r = Math.sqrt(s.x * s.x + s.y * s.y), a = this.texture.height / 2, s.x /= r, s.y /= r, s.x *= a, s.y *= a, h[o] = n.x + s.x, h[o + 1] = n.y + s.y, h[o + 2] = n.x - s.x, h[o + 3] = n.y - s.y, i = n;
            }

            PIXI.DisplayObjectContainer.prototype.updateTransform.call(this);
          }
        }, s.Rope.prototype.setTexture = function (t) {
          this.texture = t;
        }, s.Rope.prototype._renderWebGL = function (t) {
          !this.visible || this.alpha <= 0 || (t.spriteBatch.stop(), this._vertexBuffer || this._initWebGL(t), t.shaderManager.setShader(t.shaderManager.stripShader), this._renderStrip(t), t.spriteBatch.start());
        }, s.Rope.prototype._initWebGL = function (t) {
          var e = t.gl;
          this._vertexBuffer = e.createBuffer(), this._indexBuffer = e.createBuffer(), this._uvBuffer = e.createBuffer(), this._colorBuffer = e.createBuffer(), e.bindBuffer(e.ARRAY_BUFFER, this._vertexBuffer), e.bufferData(e.ARRAY_BUFFER, this.vertices, e.DYNAMIC_DRAW), e.bindBuffer(e.ARRAY_BUFFER, this._uvBuffer), e.bufferData(e.ARRAY_BUFFER, this.uvs, e.STATIC_DRAW), e.bindBuffer(e.ARRAY_BUFFER, this._colorBuffer), e.bufferData(e.ARRAY_BUFFER, this.colors, e.STATIC_DRAW), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this._indexBuffer), e.bufferData(e.ELEMENT_ARRAY_BUFFER, this.indices, e.STATIC_DRAW);
        }, s.Rope.prototype._renderStrip = function (t) {
          var e = t.gl,
              i = t.projection,
              n = t.offset,
              o = t.shaderManager.stripShader,
              r = this.drawMode === s.Rope.TRIANGLE_STRIP ? e.TRIANGLE_STRIP : e.TRIANGLES;
          t.blendModeManager.setBlendMode(this.blendMode), e.uniformMatrix3fv(o.translationMatrix, !1, this.worldTransform.toArray(!0)), e.uniform2f(o.projectionVector, i.x, -i.y), e.uniform2f(o.offsetVector, -n.x, -n.y), e.uniform1f(o.alpha, this.worldAlpha), this.dirty ? (this.dirty = !1, e.bindBuffer(e.ARRAY_BUFFER, this._vertexBuffer), e.bufferData(e.ARRAY_BUFFER, this.vertices, e.STATIC_DRAW), e.vertexAttribPointer(o.aVertexPosition, 2, e.FLOAT, !1, 0, 0), e.bindBuffer(e.ARRAY_BUFFER, this._uvBuffer), e.bufferData(e.ARRAY_BUFFER, this.uvs, e.STATIC_DRAW), e.vertexAttribPointer(o.aTextureCoord, 2, e.FLOAT, !1, 0, 0), e.activeTexture(e.TEXTURE0), this.texture.baseTexture._dirty[e.id] ? t.renderer.updateTexture(this.texture.baseTexture) : e.bindTexture(e.TEXTURE_2D, this.texture.baseTexture._glTextures[e.id]), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this._indexBuffer), e.bufferData(e.ELEMENT_ARRAY_BUFFER, this.indices, e.STATIC_DRAW)) : (e.bindBuffer(e.ARRAY_BUFFER, this._vertexBuffer), e.bufferSubData(e.ARRAY_BUFFER, 0, this.vertices), e.vertexAttribPointer(o.aVertexPosition, 2, e.FLOAT, !1, 0, 0), e.bindBuffer(e.ARRAY_BUFFER, this._uvBuffer), e.vertexAttribPointer(o.aTextureCoord, 2, e.FLOAT, !1, 0, 0), e.activeTexture(e.TEXTURE0), this.texture.baseTexture._dirty[e.id] ? t.renderer.updateTexture(this.texture.baseTexture) : e.bindTexture(e.TEXTURE_2D, this.texture.baseTexture._glTextures[e.id]), e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this._indexBuffer)), e.drawElements(r, this.indices.length, e.UNSIGNED_SHORT, 0);
        }, s.Rope.prototype._renderCanvas = function (t) {
          var e = t.context,
              i = this.worldTransform,
              n = i.tx * t.resolution + t.shakeX,
              o = i.ty * t.resolution + t.shakeY;
          t.roundPixels ? e.setTransform(i.a, i.b, i.c, i.d, 0 | n, 0 | o) : e.setTransform(i.a, i.b, i.c, i.d, n, o), this.drawMode === s.Rope.TRIANGLE_STRIP ? this._renderCanvasTriangleStrip(e) : this._renderCanvasTriangles(e);
        }, s.Rope.prototype._renderCanvasTriangleStrip = function (t) {
          var e = this.vertices,
              i = this.uvs,
              s = e.length / 2;
          this.count++;

          for (var n = 0; n < s - 2; n++) {
            var o = 2 * n;

            this._renderCanvasDrawTriangle(t, e, i, o, o + 2, o + 4);
          }
        }, s.Rope.prototype._renderCanvasTriangles = function (t) {
          var e = this.vertices,
              i = this.uvs,
              s = this.indices,
              n = s.length;
          this.count++;

          for (var o = 0; o < n; o += 3) {
            var r = 2 * s[o],
                a = 2 * s[o + 1],
                h = 2 * s[o + 2];

            this._renderCanvasDrawTriangle(t, e, i, r, a, h);
          }
        }, s.Rope.prototype._renderCanvasDrawTriangle = function (t, e, i, s, n, o) {
          var r = this.texture.baseTexture.source,
              a = this.texture.width,
              h = this.texture.height,
              l = e[s],
              c = e[n],
              u = e[o],
              d = e[s + 1],
              p = e[n + 1],
              f = e[o + 1],
              g = i[s] * a,
              m = i[n] * a,
              y = i[o] * a,
              v = i[s + 1] * h,
              b = i[n + 1] * h,
              x = i[o + 1] * h;

          if (this.canvasPadding > 0) {
            var w = this.canvasPadding / this.worldTransform.a,
                _ = this.canvasPadding / this.worldTransform.d,
                T = (l + c + u) / 3,
                P = (d + p + f) / 3,
                S = l - T,
                C = d - P,
                A = Math.sqrt(S * S + C * C);

            l = T + S / A * (A + w), d = P + C / A * (A + _), C = p - P, c = T + (S = c - T) / (A = Math.sqrt(S * S + C * C)) * (A + w), p = P + C / A * (A + _), C = f - P, u = T + (S = u - T) / (A = Math.sqrt(S * S + C * C)) * (A + w), f = P + C / A * (A + _);
          }

          t.save(), t.beginPath(), t.moveTo(l, d), t.lineTo(c, p), t.lineTo(u, f), t.closePath(), t.clip();
          var E = g * b + v * y + m * x - b * y - v * m - g * x,
              M = l * b + v * u + c * x - b * u - v * c - l * x,
              R = g * c + l * y + m * u - c * y - l * m - g * u,
              L = g * b * u + v * c * y + l * m * x - l * b * y - v * m * u - g * c * x,
              I = d * b + v * f + p * x - b * f - v * p - d * x,
              k = g * p + d * y + m * f - p * y - d * m - g * f,
              O = g * b * f + v * p * y + d * m * x - d * b * y - v * m * f - g * p * x;
          t.transform(M / E, I / E, R / E, k / E, L / E, O / E), t.drawImage(r, 0, 0), t.restore();
        }, s.Rope.prototype.renderStripFlat = function (t) {
          var e = this.context,
              i = t.vertices,
              s = i.length / 2;
          this.count++, e.beginPath();

          for (var n = 1; n < s - 2; n++) {
            var o = 2 * n,
                r = i[o],
                a = i[o + 2],
                h = i[o + 4],
                l = i[o + 1],
                c = i[o + 3],
                u = i[o + 5];
            e.moveTo(r, l), e.lineTo(a, c), e.lineTo(h, u);
          }

          e.fillStyle = "#FF0000", e.fill(), e.closePath();
        }, s.Rope.prototype.getBounds = function (t) {
          for (var e = t || this.worldTransform, i = e.a, s = e.b, n = e.c, o = e.d, r = e.tx, a = e.ty, h = -1 / 0, l = -1 / 0, c = 1 / 0, u = 1 / 0, d = this.vertices, p = 0; p < d.length; p += 2) {
            var f = d[p],
                g = d[p + 1],
                m = i * f + n * g + r,
                y = o * g + s * f + a;
            c = m < c ? m : c, u = y < u ? y : u, h = m > h ? m : h, l = y > l ? y : l;
          }

          if (c === -1 / 0 || l === 1 / 0) return PIXI.EmptyRectangle;
          var v = this._bounds;
          return v.x = c, v.width = h - c, v.y = u, v.height = l - u, this._currentBounds = v, v;
        }, Object.defineProperty(s.Rope.prototype, "updateAnimation", {
          get: function get() {
            return this._updateAnimation;
          },
          set: function set(t) {
            t && "function" == typeof t ? (this._hasUpdateAnimation = !0, this._updateAnimation = t) : (this._hasUpdateAnimation = !1, this._updateAnimation = null);
          }
        }), Object.defineProperty(s.Rope.prototype, "segments", {
          get: function get() {
            for (var t, e, i, n, o, r, a, h, l = [], c = 0; c < this.points.length; c++) {
              t = 4 * c, e = this.vertices[t] * this.scale.x, i = this.vertices[t + 1] * this.scale.y, n = this.vertices[t + 4] * this.scale.x, o = this.vertices[t + 3] * this.scale.y, r = s.Math.difference(e, n), a = s.Math.difference(i, o), e += this.world.x, i += this.world.y, h = new s.Rectangle(e, i, r, a), l.push(h);
            }

            return l;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.TileSprite = function (t, e, i, n, o, r, a) {
          e = e || 0, i = i || 0, n = n || 256, o = o || 256, r = r || null, a = a || null, PIXI.Sprite.call(this, new PIXI.Texture(s.Cache.DEFAULT.baseTexture), n, o), this.type = s.TILESPRITE, this.physicsType = s.SPRITE, this._scroll = new s.Point(), this.tileScale = new s.Point(1, 1), this.tileScaleOffset = new s.Point(1, 1), this.tilePosition = new s.Point(), this.textureDebug = !1, this.canvasBuffer = null, this.tilingTexture = null, this.tilePattern = null, this.refreshTexture = !0, this.frameWidth = 0, this.frameHeight = 0, this._width = n, this._height = o, s.Component.Core.init.call(this, t, e, i, r, a);
        }, s.TileSprite.prototype = Object.create(PIXI.Sprite.prototype), s.TileSprite.prototype.constructor = s.TileSprite, s.Component.Core.install.call(s.TileSprite.prototype, ["Angle", "Animation", "AutoCull", "Bounds", "BringToTop", "Destroy", "FixedToCamera", "Health", "InCamera", "InputEnabled", "InWorld", "LifeSpan", "LoadTexture", "Overlap", "PhysicsBody", "Reset", "Smoothed"]), s.TileSprite.prototype.preUpdatePhysics = s.Component.PhysicsBody.preUpdate, s.TileSprite.prototype.preUpdateLifeSpan = s.Component.LifeSpan.preUpdate, s.TileSprite.prototype.preUpdateInWorld = s.Component.InWorld.preUpdate, s.TileSprite.prototype.preUpdateCore = s.Component.Core.preUpdate, s.TileSprite.prototype.preUpdate = function () {
          return 0 !== this._scroll.x && (this.tilePosition.x += this._scroll.x * this.game.time.physicsElapsed), 0 !== this._scroll.y && (this.tilePosition.y += this._scroll.y * this.game.time.physicsElapsed), !!(this.preUpdatePhysics() && this.preUpdateLifeSpan() && this.preUpdateInWorld()) && this.preUpdateCore();
        }, s.TileSprite.prototype.autoScroll = function (t, e) {
          return this._scroll.set(t, e), this;
        }, s.TileSprite.prototype.stopScroll = function () {
          return this._scroll.set(0, 0), this;
        }, s.TileSprite.prototype.destroy = function (t) {
          s.Component.Destroy.prototype.destroy.call(this, t), PIXI.Sprite.prototype.destroy.call(this), this.canvasBuffer && (this.canvasBuffer.destroy(), this.canvasBuffer = null), this.tileScale = null, this.tileScaleOffset = null, this.tilePosition = null, this.tilingTexture && (this.tilingTexture.destroy(!0), this.tilingTexture = null);
        }, s.TileSprite.prototype.reset = function (t, e) {
          return s.Component.Reset.prototype.reset.call(this, t, e), this.tilePosition.x = 0, this.tilePosition.y = 0, this;
        }, s.TileSprite.prototype.setTexture = function (t) {
          return this.texture !== t && (this.texture = t, this.refreshTexture = !0, this.cachedTint = 16777215), this;
        }, s.TileSprite.prototype._renderWebGL = function (t) {
          if (this.visible && this.renderable && 0 !== this.alpha) {
            if (this._mask && (t.spriteBatch.stop(), t.maskManager.pushMask(this.mask, t), t.spriteBatch.start()), this._filters && (t.spriteBatch.flush(), t.filterManager.pushFilter(this._filterBlock)), this.refreshTexture) {
              if (this.generateTilingTexture(!0, t), !this.tilingTexture) return;
              this.tilingTexture.needsUpdate && (this.tilingTexture.baseTexture.textureIndex = this.texture.baseTexture.textureIndex, t.renderer.updateTexture(this.tilingTexture.baseTexture), this.tilingTexture.needsUpdate = !1);
            }

            t.spriteBatch.renderTilingSprite(this);

            for (var e = 0; e < this.children.length; e++) {
              this.children[e]._renderWebGL(t);
            }

            var i = !1;
            this._filters && (i = !0, t.spriteBatch.stop(), t.filterManager.popFilter()), this._mask && (i || t.spriteBatch.stop(), t.maskManager.popMask(this._mask, t)), i && t.spriteBatch.start();
          }
        }, s.TileSprite.prototype._renderCanvas = function (t) {
          if (this.visible && this.renderable && 0 !== this.alpha) {
            var e = t.context;
            this._mask && t.maskManager.pushMask(this._mask, t), e.globalAlpha = this.worldAlpha;
            var i = this.worldTransform,
                s = t.resolution,
                n = i.tx * s + t.shakeX,
                o = i.ty * s + t.shakeY;

            if (e.setTransform(i.a * s, i.b * s, i.c * s, i.d * s, n, o), 16777215 === this.tint || !this.texture.requiresReTint && this.cachedTint === this.tint || (this.tintedTexture = PIXI.CanvasTinter.getTintedTexture(this, this.tint), this.cachedTint = this.tint, this.texture.requiresReTint = !1, this.refreshTexture = !0), this.refreshTexture) {
              if (this.generateTilingTexture(!1, t), !this.tilingTexture) return;
              this.tilePattern = e.createPattern(this.tilingTexture.baseTexture.source, "repeat");
            }

            var r = t.currentBlendMode;
            this.blendMode !== t.currentBlendMode && (t.currentBlendMode = this.blendMode, e.globalCompositeOperation = PIXI.blendModesCanvas[t.currentBlendMode]);
            var a = this.tilePosition,
                h = this.tileScale;
            a.x %= this.tilingTexture.baseTexture.width, a.y %= this.tilingTexture.baseTexture.height, e.scale(h.x, h.y), e.translate(a.x + this.anchor.x * -this._width, a.y + this.anchor.y * -this._height), e.fillStyle = this.tilePattern, n = -a.x, o = -a.y;
            var l = this._width / h.x,
                c = this._height / h.y;
            t.roundPixels && (n |= 0, o |= 0, l |= 0, c |= 0), e.fillRect(n, o, l, c), e.scale(1 / h.x, 1 / h.y), e.translate(-a.x + this.anchor.x * this._width, -a.y + this.anchor.y * this._height), this._mask && t.maskManager.popMask(t);

            for (var u = 0; u < this.children.length; u++) {
              this.children[u]._renderCanvas(t);
            }

            r !== this.blendMode && (t.currentBlendMode = r, e.globalCompositeOperation = PIXI.blendModesCanvas[r]);
          }
        }, s.TileSprite.prototype.onTextureUpdate = function () {}, s.TileSprite.prototype.generateTilingTexture = function (t) {
          if (this.texture.baseTexture.hasLoaded) {
            var e = this.texture,
                i = e.frame,
                n = this._frame.sourceSizeW || this._frame.width,
                o = this._frame.sourceSizeH || this._frame.height,
                r = 0,
                a = 0;
            this._frame.trimmed && (r = this._frame.spriteSourceSizeX, a = this._frame.spriteSourceSizeY), t && (n = s.Math.getNextPowerOfTwo(n), o = s.Math.getNextPowerOfTwo(o)), this.canvasBuffer ? (this.canvasBuffer.resize(n, o), this.tilingTexture.baseTexture.width = n, this.tilingTexture.baseTexture.height = o, this.tilingTexture.needsUpdate = !0) : (this.canvasBuffer = new PIXI.CanvasBuffer(n, o), this.tilingTexture = PIXI.Texture.fromCanvas(this.canvasBuffer.canvas), this.tilingTexture.isTiling = !0, this.tilingTexture.needsUpdate = !0), this.textureDebug && (this.canvasBuffer.context.strokeStyle = "#00ff00", this.canvasBuffer.context.strokeRect(0, 0, n, o));
            var h = e.crop.width,
                l = e.crop.height;
            h === n && l === o || (h = n, l = o);
            var c = this.tintedTexture ? this.tintedTexture : e.baseTexture.source;
            this.canvasBuffer.context.drawImage(c, e.crop.x, e.crop.y, e.crop.width, e.crop.height, r, a, h, l), this.tileScaleOffset.x = i.width / n, this.tileScaleOffset.y = i.height / o, this.refreshTexture = !1, this.tilingTexture.baseTexture._powerOf2 = !0;
          }
        }, s.TileSprite.prototype.getBounds = function () {
          var t = this._width,
              e = this._height,
              i = t * (1 - this.anchor.x),
              s = t * -this.anchor.x,
              n = e * (1 - this.anchor.y),
              o = e * -this.anchor.y,
              r = this.worldTransform,
              a = r.a,
              h = r.b,
              l = r.c,
              c = r.d,
              u = r.tx,
              d = r.ty,
              p = a * s + l * o + u,
              f = c * o + h * s + d,
              g = a * i + l * o + u,
              m = c * o + h * i + d,
              y = a * i + l * n + u,
              v = c * n + h * i + d,
              b = a * s + l * n + u,
              x = c * n + h * s + d,
              w = -1 / 0,
              _ = -1 / 0,
              T = 1 / 0,
              P = 1 / 0;

          T = b < (T = y < (T = g < (T = p < T ? p : T) ? g : T) ? y : T) ? b : T, P = x < (P = v < (P = m < (P = f < P ? f : P) ? m : P) ? v : P) ? x : P, w = b > (w = y > (w = g > (w = p > w ? p : w) ? g : w) ? y : w) ? b : w, _ = x > (_ = v > (_ = m > (_ = f > _ ? f : _) ? m : _) ? v : _) ? x : _;
          var S = this._bounds;
          return S.x = T, S.width = w - T, S.y = P, S.height = _ - P, this._currentBounds = S, S;
        }, Object.defineProperty(s.TileSprite.prototype, "width", {
          get: function get() {
            return this._width;
          },
          set: function set(t) {
            this._width = t;
          }
        }), Object.defineProperty(s.TileSprite.prototype, "height", {
          get: function get() {
            return this._height;
          },
          set: function set(t) {
            this._height = t;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.CanvasPool = {
          create: function create(t, e, i) {
            var n,
                o = s.CanvasPool.getFirst();

            if (-1 === o) {
              var r = {
                parent: t,
                canvas: document.createElement("canvas")
              };
              s.CanvasPool.pool.push(r), n = r.canvas;
            } else s.CanvasPool.pool[o].parent = t, n = s.CanvasPool.pool[o].canvas;

            return void 0 !== e && (n.width = e, n.height = i), n;
          },
          getFirst: function getFirst() {
            for (var t = s.CanvasPool.pool, e = 0; e < t.length; e++) {
              if (!t[e].parent) return e;
            }

            return -1;
          },
          remove: function remove(t) {
            for (var e = s.CanvasPool.pool, i = 0; i < e.length; i++) {
              e[i].parent === t && (e[i].parent = null, e[i].canvas.width = 1, e[i].canvas.height = 1);
            }
          },
          removeByCanvas: function removeByCanvas(t) {
            for (var e = s.CanvasPool.pool, i = 0; i < e.length; i++) {
              e[i].canvas === t && (e[i].parent = null, e[i].canvas.width = 1, e[i].canvas.height = 1);
            }
          },
          getTotal: function getTotal() {
            for (var t = s.CanvasPool.pool, e = 0, i = 0; i < t.length; i++) {
              t[i].parent && e++;
            }

            return e;
          },
          getFree: function getFree() {
            for (var t = s.CanvasPool.pool, e = 0, i = 0; i < t.length; i++) {
              t[i].parent || e++;
            }

            return e;
          },
          log: function log() {
            console.log("CanvasPool: %s used, %s free, %s total", this.getTotal(), this.getFree(), this.pool.length);
          }
        }, s.CanvasPool.pool = [], Object.defineProperty(s.CanvasPool, "length", {
          get: function get() {
            return this.pool.length;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Device = function () {
          this.deviceReadyAt = 0, this.initialized = !1, this.desktop = !1, this.iOS = !1, this.iOSVersion = 0, this.cocoonJS = !1, this.cocoonJSApp = !1, this.cordova = !1, this.node = !1, this.nodeWebkit = !1, this.electron = !1, this.ejecta = !1, this.crosswalk = !1, this.android = !1, this.chromeOS = !1, this.linux = !1, this.macOS = !1, this.windows = !1, this.windowsPhone = !1, this.canvas = !1, this.canvasBitBltShift = null, this.canHandleAlpha = !1, this.canUseMultiply = !1, this.webGL = !1, this.file = !1, this.fileSystem = !1, this.localStorage = !1, this.worker = !1, this.css3D = !1, this.pointerLock = !1, this.typedArray = !1, this.vibration = !1, this.getUserMedia = !0, this.quirksMode = !1, this.touch = !1, this.mspointer = !1, this.wheelEvent = null, this.arora = !1, this.chrome = !1, this.chromeVersion = 0, this.epiphany = !1, this.firefox = !1, this.firefoxVersion = 0, this.ie = !1, this.ieVersion = 0, this.trident = !1, this.tridentVersion = 0, this.edge = !1, this.mobileSafari = !1, this.midori = !1, this.opera = !1, this.safari = !1, this.safariVersion = 0, this.webApp = !1, this.silk = !1, this.audioData = !1, this.webAudio = !1, this.ogg = !1, this.opus = !1, this.mp3 = !1, this.wav = !1, this.m4a = !1, this.webm = !1, this.dolby = !1, this.oggVideo = !1, this.h264Video = !1, this.mp4Video = !1, this.webmVideo = !1, this.vp9Video = !1, this.hlsVideo = !1, this.iPhone = !1, this.iPhone4 = !1, this.iPad = !1, this.pixelRatio = 0, this.littleEndian = !1, this.LITTLE_ENDIAN = !1, this.support32bit = !1, this.fullscreen = !1, this.requestFullscreen = "", this.cancelFullscreen = "", this.fullscreenKeyboard = !1;
        }, s.Device = new s.Device(), s.Device.onInitialized = new s.Signal(), s.Device.whenReady = function (t, e, i) {
          var s = this._readyCheck;
          if (this.deviceReadyAt || !s) t.call(e, this);else if (s._monitor || i) s._queue = s._queue || [], s._queue.push([t, e]);else {
            s._monitor = s.bind(this), s._queue = s._queue || [], s._queue.push([t, e]);
            var n = void 0 !== window.cordova,
                o = navigator.isCocoonJS;
            "complete" === document.readyState || "interactive" === document.readyState ? window.setTimeout(s._monitor, 0) : n && !o ? document.addEventListener("deviceready", s._monitor, !1) : (document.addEventListener("DOMContentLoaded", s._monitor, !1), window.addEventListener("load", s._monitor, !1));
          }
        }, s.Device._readyCheck = function () {
          var t = this._readyCheck;

          if (document.body) {
            if (!this.deviceReadyAt) {
              var e;

              for (this.deviceReadyAt = Date.now(), document.removeEventListener("deviceready", t._monitor), document.removeEventListener("DOMContentLoaded", t._monitor), window.removeEventListener("load", t._monitor), this._initialize(), this.initialized = !0, this.onInitialized.dispatch(this); e = t._queue.shift();) {
                var i = e[0],
                    s = e[1];
                i.call(s, this);
              }

              this._readyCheck = null, this._initialize = null, this.onInitialized = null;
            }
          } else window.setTimeout(t._monitor, 20);
        }, s.Device._initialize = function () {
          var t = this;
          !function () {
            var e = navigator.userAgent;
            /Playstation Vita/.test(e) ? t.vita = !0 : /Kindle/.test(e) || /\bKF[A-Z][A-Z]+/.test(e) || /Silk.*Mobile Safari/.test(e) ? t.kindle = !0 : /Android/.test(e) ? t.android = !0 : /CrOS/.test(e) ? t.chromeOS = !0 : /iP[ao]d|iPhone/i.test(e) ? (t.iOS = !0, navigator.appVersion.match(/OS (\d+)/), t.iOSVersion = parseInt(RegExp.$1, 10)) : /Linux/.test(e) ? t.linux = !0 : /Mac OS/.test(e) ? t.macOS = !0 : /Windows/.test(e) && (t.windows = !0), (/Windows Phone/i.test(e) || /IEMobile/i.test(e)) && (t.android = !1, t.iOS = !1, t.macOS = !1, t.windows = !0, t.windowsPhone = !0);
            var i = /Silk/.test(e);
            (t.windows || t.macOS || t.linux && !i || t.chromeOS) && (t.desktop = !0), (t.windowsPhone || /Windows NT/i.test(e) && /Touch/i.test(e)) && (t.desktop = !1);
          }(), function () {
            var e = navigator.userAgent;
            if (/Arora/.test(e) ? t.arora = !0 : /Edge\/\d+/.test(e) ? t.edge = !0 : /Chrome\/(\d+)/.test(e) && !t.windowsPhone ? (t.chrome = !0, t.chromeVersion = parseInt(RegExp.$1, 10)) : /Epiphany/.test(e) ? t.epiphany = !0 : /Firefox\D+(\d+)/.test(e) ? (t.firefox = !0, t.firefoxVersion = parseInt(RegExp.$1, 10)) : /AppleWebKit/.test(e) && t.iOS ? t.mobileSafari = !0 : /MSIE (\d+\.\d+);/.test(e) ? (t.ie = !0, t.ieVersion = parseInt(RegExp.$1, 10)) : /Midori/.test(e) ? t.midori = !0 : /Opera/.test(e) ? t.opera = !0 : /Safari\/(\d+)/.test(e) && !t.windowsPhone ? (t.safari = !0, /Version\/(\d+)\./.test(e) && (t.safariVersion = parseInt(RegExp.$1, 10))) : /Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(e) && (t.ie = !0, t.trident = !0, t.tridentVersion = parseInt(RegExp.$1, 10), t.ieVersion = parseInt(RegExp.$3, 10)), /Silk/.test(e) && (t.silk = !0), navigator.standalone && (t.webApp = !0), void 0 !== window.cordova && (t.cordova = !0), void 0 !== i && (t.node = !0), t.node && "object" == typeof i.versions && (t.nodeWebkit = !!i.versions["node-webkit"], t.electron = !!i.versions.electron), navigator.isCocoonJS && (t.cocoonJS = !0), t.cocoonJS) try {
              t.cocoonJSApp = "undefined" != typeof CocoonJS;
            } catch (e) {
              t.cocoonJSApp = !1;
            }
            void 0 !== window.ejecta && (t.ejecta = !0), /Crosswalk/.test(e) && (t.crosswalk = !0);
          }(), function () {
            t.audioData = !!window.Audio, t.webAudio = !(!window.AudioContext && !window.webkitAudioContext);
            var e = document.createElement("audio");

            try {
              if (e.canPlayType && (e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, "") && (t.ogg = !0), (e.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, "") || e.canPlayType("audio/opus;").replace(/^no$/, "")) && (t.opus = !0), e.canPlayType("audio/mpeg;").replace(/^no$/, "") && (t.mp3 = !0), e.canPlayType('audio/wav; codecs="1"').replace(/^no$/, "") && (t.wav = !0), (e.canPlayType("audio/x-m4a;") || e.canPlayType("audio/aac;").replace(/^no$/, "")) && (t.m4a = !0), e.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "") && (t.webm = !0), "" !== e.canPlayType('audio/mp4;codecs="ec-3"'))) if (t.edge) t.dolby = !0;else if (t.safari && t.safariVersion >= 9 && /Mac OS X (\d+)_(\d+)/.test(navigator.userAgent)) {
                var i = parseInt(RegExp.$1, 10),
                    s = parseInt(RegExp.$2, 10);
                (10 === i && s >= 11 || i > 10) && (t.dolby = !0);
              }
            } catch (t) {}
          }(), function () {
            var e = document.createElement("video");

            try {
              e.canPlayType && (e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, "") && (t.oggVideo = !0), e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, "") && (t.h264Video = !0, t.mp4Video = !0), e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, "") && (t.webmVideo = !0), e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, "") && (t.vp9Video = !0), e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, "") && (t.hlsVideo = !0));
            } catch (t) {}
          }(), function () {
            var e,
                i = document.createElement("p"),
                s = {
              webkitTransform: "-webkit-transform",
              OTransform: "-o-transform",
              msTransform: "-ms-transform",
              MozTransform: "-moz-transform",
              transform: "transform"
            };

            for (var n in document.body.insertBefore(i, null), s) {
              void 0 !== i.style[n] && (i.style[n] = "translate3d(1px,1px,1px)", e = window.getComputedStyle(i).getPropertyValue(s[n]));
            }

            document.body.removeChild(i), t.css3D = void 0 !== e && e.length > 0 && "none" !== e;
          }(), t.pixelRatio = window.devicePixelRatio || 1, t.iPhone = -1 !== navigator.userAgent.toLowerCase().indexOf("iphone"), t.iPhone4 = 2 === t.pixelRatio && t.iPhone, t.iPad = -1 !== navigator.userAgent.toLowerCase().indexOf("ipad"), "undefined" != typeof Int8Array ? t.typedArray = !0 : t.typedArray = !1, "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && "undefined" != typeof Uint32Array && (t.littleEndian = function () {
            var t = new ArrayBuffer(4),
                e = new Uint8Array(t),
                i = new Uint32Array(t);
            return e[0] = 161, e[1] = 178, e[2] = 195, e[3] = 212, 3569595041 === i[0] || 2712847316 !== i[0] && null;
          }(), t.LITTLE_ENDIAN = t.littleEndian), t.support32bit = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8ClampedArray && "undefined" != typeof Int32Array && null !== t.littleEndian && function () {
            if (void 0 === Uint8ClampedArray) return !1;
            var t = s.CanvasPool.create(this, 1, 1).getContext("2d");
            if (!t) return !1;
            var e = t.createImageData(1, 1);
            return s.CanvasPool.remove(this), e.data instanceof Uint8ClampedArray;
          }(), navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate, navigator.vibrate && (t.vibration = !0), function () {
            t.canvas = !!window.CanvasRenderingContext2D || t.cocoonJS;

            try {
              t.localStorage = !!localStorage.getItem;
            } catch (e) {
              t.localStorage = !1;
            }

            t.file = !!(window.File && window.FileReader && window.FileList && window.Blob), t.fileSystem = !!window.requestFileSystem, t.webGL = !!window.WebGLRenderingContext, t.worker = !!window.Worker, t.pointerLock = "pointerLockElement" in document || "mozPointerLockElement" in document || "webkitPointerLockElement" in document, t.quirksMode = "CSS1Compat" !== document.compatMode, navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia, window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL, t.getUserMedia = t.getUserMedia && !!navigator.getUserMedia && !!window.URL, t.firefox && t.firefoxVersion < 21 && (t.getUserMedia = !1), !t.iOS && (t.ie || t.firefox || t.chrome) && (t.canvasBitBltShift = !0), (t.safari || t.mobileSafari) && (t.canvasBitBltShift = !1);
          }(), function () {
            var e = s.CanvasPool.create(this, 6, 1),
                i = e.getContext("2d");
            i.fillStyle = "rgba(10, 20, 30, 0.5)", i.fillRect(0, 0, 1, 1);
            var n = i.getImageData(0, 0, 1, 1);

            if (n) {
              i.putImageData(n, 1, 0);
              var o = i.getImageData(1, 0, 1, 1);
              t.canHandleAlpha = o.data[0] === n.data[0] && o.data[1] === n.data[1] && o.data[2] === n.data[2] && o.data[3] === n.data[3];
            }

            i.globalCompositeOperation = "multiply", t.canUseMultiply = "multiply" === i.globalCompositeOperation, s.CanvasPool.removeByCanvas(e), PIXI.CanvasTinter.tintMethod = t.canUseMultiply ? PIXI.CanvasTinter.tintWithMultiply : PIXI.CanvasTinter.tintWithPerPixel;
          }(), function () {
            for (var e = ["requestFullscreen", "requestFullScreen", "webkitRequestFullscreen", "webkitRequestFullScreen", "msRequestFullscreen", "msRequestFullScreen", "mozRequestFullScreen", "mozRequestFullscreen"], i = document.createElement("div"), s = 0; s < e.length; s++) {
              if (i[e[s]]) {
                t.fullscreen = !0, t.requestFullscreen = e[s];
                break;
              }
            }

            var n = ["cancelFullScreen", "exitFullscreen", "webkitCancelFullScreen", "webkitExitFullscreen", "msCancelFullScreen", "msExitFullscreen", "mozCancelFullScreen", "mozExitFullscreen"];
            if (t.fullscreen) for (s = 0; s < n.length; s++) {
              if (document[n[s]]) {
                t.cancelFullscreen = n[s];
                break;
              }
            }
            window.Element && Element.ALLOW_KEYBOARD_INPUT && (t.fullscreenKeyboard = !0);
          }(), ("ontouchstart" in document.documentElement || window.navigator.maxTouchPoints && window.navigator.maxTouchPoints >= 1) && (t.touch = !0), (window.PointerEvent || window.MSPointerEvent || window.navigator.msPointerEnabled || window.navigator.pointerEnabled) && (t.mspointer = !0), t.cocoonJS || ("onwheel" in window || t.ie && "WheelEvent" in window ? t.wheelEvent = "wheel" : "onmousewheel" in window ? t.wheelEvent = "mousewheel" : t.firefox && "MouseScrollEvent" in window && (t.wheelEvent = "DOMMouseScroll"));
        }, s.Device.canPlayAudio = function (t) {
          return !("mp3" !== t || !this.mp3) || !("ogg" !== t || !this.ogg && !this.opus) || !("m4a" !== t || !this.m4a) || !("opus" !== t || !this.opus) || !("wav" !== t || !this.wav) || !("webm" !== t || !this.webm) || !("mp4" !== t || !this.dolby);
        }, s.Device.canPlayVideo = function (t) {
          return !("webm" !== t || !this.webmVideo && !this.vp9Video) || !("mp4" !== t || !this.mp4Video && !this.h264Video) || !("ogg" !== t && "ogv" !== t || !this.oggVideo) || !("mpeg" !== t || !this.hlsVideo);
        }, s.Device.needsTouchUnlock = function () {
          return !!(!this.cocoonJS && (this.iOS || this.android) || window.PhaserGlobal && window.PhaserGlobal.fakeiOSTouchLock);
        }, s.Device.isAndroidStockBrowser = function () {
          var t = window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);
          return t && t[1] < 537;
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Canvas = {
          create: function create(t, e, i, n, o) {
            e = e || 256, i = i || 256;
            var r = o ? document.createElement("canvas") : s.CanvasPool.create(t, e, i);
            return "string" == typeof n && "" !== n && (r.id = n), r.width = e, r.height = i, r.style.display = "block", r;
          },
          setBackgroundColor: function setBackgroundColor(t, e) {
            return e = e || "rgb(0,0,0)", t.style.backgroundColor = e, t;
          },
          setTouchAction: function setTouchAction(t, e) {
            return e = e || "none", t.style.msTouchAction = e, t.style["ms-touch-action"] = e, t.style["touch-action"] = e, t;
          },
          setUserSelect: function setUserSelect(t, e) {
            return e = e || "none", t.style["-webkit-touch-callout"] = e, t.style["-webkit-user-select"] = e, t.style["-khtml-user-select"] = e, t.style["-moz-user-select"] = e, t.style["-ms-user-select"] = e, t.style["user-select"] = e, t.style["-webkit-tap-highlight-color"] = "rgba(0, 0, 0, 0)", t;
          },
          addToDOM: function addToDOM(t, e, i) {
            var s;
            return void 0 === i && (i = !0), e && ("string" == typeof e ? s = document.getElementById(e) : "object" == typeof e && 1 === e.nodeType && (s = e)), s || (s = document.body), i && s.style && (s.style.overflow = "hidden"), s.appendChild(t), t;
          },
          removeFromDOM: function removeFromDOM(t) {
            t.parentNode && t.parentNode.removeChild(t);
          },
          setTransform: function setTransform(t, e, i, s, n, o, r) {
            return t.setTransform(s, o, r, n, e, i), t;
          },
          setSmoothingEnabled: function setSmoothingEnabled(t, e) {
            var i = s.Canvas.getSmoothingPrefix(t);
            return i && (t[i] = e), t;
          },
          getSmoothingPrefix: function getSmoothingPrefix(t) {
            var e = ["i", "webkitI", "msI", "mozI", "oI"];

            for (var i in e) {
              var s = e[i] + "mageSmoothingEnabled";
              if (s in t) return s;
            }

            return null;
          },
          getSmoothingEnabled: function getSmoothingEnabled(t) {
            var e = s.Canvas.getSmoothingPrefix(t);
            if (e) return t[e];
          },
          setImageRenderingCrisp: function setImageRenderingCrisp(t) {
            for (var e = ["-webkit-optimize-contrast", "-moz-crisp-edges", "crisp-edges", "pixelated"], i = 0; i < e.length; i++) {
              t.style["image-rendering"] = e[i];
            }

            return t.style.msInterpolationMode = "nearest-neighbor", t;
          },
          setImageRenderingBicubic: function setImageRenderingBicubic(t) {
            return t.style["image-rendering"] = "auto", t.style.msInterpolationMode = "bicubic", t;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.RequestAnimationFrame = function (t, e) {
          void 0 === e && (e = !1), this.game = t, this.isRunning = !1, this.forceSetTimeOut = e;

          for (var i = ["ms", "moz", "webkit", "o"], s = 0; s < i.length && !window.requestAnimationFrame; s++) {
            window.requestAnimationFrame = window[i[s] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[i[s] + "CancelAnimationFrame"] || window[i[s] + "CancelRequestAnimationFrame"];
          }

          this._isSetTimeOut = !1, this._onLoop = null, this._timeOutID = null;
        }, s.RequestAnimationFrame.prototype = {
          start: function start() {
            this.isRunning = !0;
            var t = this;
            !window.requestAnimationFrame || this.forceSetTimeOut ? (this._isSetTimeOut = !0, this._onLoop = function () {
              return t.updateSetTimeout();
            }, this._timeOutID = window.setTimeout(this._onLoop, 0)) : (this._isSetTimeOut = !1, this._onLoop = function (e) {
              return t.updateRAF(e);
            }, this._timeOutID = window.requestAnimationFrame(this._onLoop));
          },
          updateRAF: function updateRAF(t) {
            this.isRunning && (this.game.update(Math.floor(t)), this._timeOutID = window.requestAnimationFrame(this._onLoop));
          },
          updateSetTimeout: function updateSetTimeout() {
            this.isRunning && (this.game.update(Date.now()), this._timeOutID = window.setTimeout(this._onLoop, this.game.time.timeToCall));
          },
          stop: function stop() {
            this._isSetTimeOut ? clearTimeout(this._timeOutID) : window.cancelAnimationFrame(this._timeOutID), this.isRunning = !1;
          },
          isSetTimeOut: function isSetTimeOut() {
            return this._isSetTimeOut;
          },
          isRAF: function isRAF() {
            return !1 === this._isSetTimeOut;
          }
        }, s.RequestAnimationFrame.prototype.constructor = s.RequestAnimationFrame,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Math = {
          PI2: 2 * Math.PI,
          HALF_PI: .5 * Math.PI,
          DEG_TO_RAD: Math.PI / 180,
          RAD_TO_DEG: 180 / Math.PI,
          degToRad: function degToRad(t) {
            return t * s.Math.DEG_TO_RAD;
          },
          radToDeg: function radToDeg(t) {
            return t * s.Math.RAD_TO_DEG;
          },
          getNextPowerOfTwo: function getNextPowerOfTwo(t) {
            if (t > 0 && 0 == (t & t - 1)) return t;

            for (var e = 1; e < t;) {
              e <<= 1;
            }

            return e;
          },
          isPowerOfTwo: function isPowerOfTwo(t, e) {
            return t > 0 && 0 == (t & t - 1) && e > 0 && 0 == (e & e - 1);
          },
          random: function random(t, e) {
            if (void 0 === t && (t = 0), void 0 === e && (e = 1), t === e) return t;

            if (t > e) {
              var i = t;
              t = e, e = i;
            }

            return Math.random() * (e - t) + t;
          },
          between: function between(t, e) {
            if (void 0 === t && (t = 0), void 0 === e && (e = 1), t === e) return t;

            if (t > e) {
              var i = t;
              t = e, e = i;
            }

            return t = Math.ceil(t), e = Math.floor(e), Math.floor(Math.random() * (e - t + 1)) + t;
          },
          fuzzyEqual: function fuzzyEqual(t, e, i) {
            return void 0 === i && (i = 1e-4), Math.abs(t - e) < i;
          },
          fuzzyLessThan: function fuzzyLessThan(t, e, i) {
            return void 0 === i && (i = 1e-4), t < e + i;
          },
          fuzzyGreaterThan: function fuzzyGreaterThan(t, e, i) {
            return void 0 === i && (i = 1e-4), t > e - i;
          },
          fuzzyCeil: function fuzzyCeil(t, e) {
            return void 0 === e && (e = 1e-4), Math.ceil(t - e);
          },
          fuzzyFloor: function fuzzyFloor(t, e) {
            return void 0 === e && (e = 1e-4), Math.floor(t + e);
          },
          average: function average() {
            for (var t = 0, e = arguments.length, i = 0; i < e; i++) {
              t += +arguments[i];
            }

            return t / e;
          },
          shear: function shear(t) {
            return t % 1;
          },
          snapTo: function snapTo(t, e, i) {
            return void 0 === i && (i = 0), 0 === e ? t : (t -= i, i + (t = e * Math.round(t / e)));
          },
          snapToFloor: function snapToFloor(t, e, i) {
            return void 0 === i && (i = 0), 0 === e ? t : (t -= i, i + (t = e * Math.floor(t / e)));
          },
          snapToCeil: function snapToCeil(t, e, i) {
            return void 0 === i && (i = 0), 0 === e ? t : (t -= i, i + (t = e * Math.ceil(t / e)));
          },
          roundTo: function roundTo(t, e, i) {
            void 0 === e && (e = 0), void 0 === i && (i = 10);
            var s = Math.pow(i, -e);
            return Math.round(t * s) / s;
          },
          floorTo: function floorTo(t, e, i) {
            void 0 === e && (e = 0), void 0 === i && (i = 10);
            var s = Math.pow(i, -e);
            return Math.floor(t * s) / s;
          },
          ceilTo: function ceilTo(t, e, i) {
            void 0 === e && (e = 0), void 0 === i && (i = 10);
            var s = Math.pow(i, -e);
            return Math.ceil(t * s) / s;
          },
          rotateToAngle: function rotateToAngle(t, e, i) {
            return void 0 === i && (i = .05), t === e ? t : (Math.abs(e - t) <= i || Math.abs(e - t) >= s.Math.PI2 - i ? t = e : (Math.abs(e - t) > Math.PI && (e < t ? e += s.Math.PI2 : e -= s.Math.PI2), e > t ? t += i : e < t && (t -= i)), t);
          },
          getShortestAngle: function getShortestAngle(t, e) {
            var i = e - t;
            return 0 === i ? 0 : i - 360 * Math.floor((i - -180) / 360);
          },
          angleBetween: function angleBetween(t, e, i, s) {
            return Math.atan2(s - e, i - t);
          },
          angleBetweenY: function angleBetweenY(t, e, i, s) {
            return Math.atan2(i - t, s - e);
          },
          angleBetweenPoints: function angleBetweenPoints(t, e) {
            return Math.atan2(e.y - t.y, e.x - t.x);
          },
          angleBetweenPointsY: function angleBetweenPointsY(t, e) {
            return Math.atan2(e.x - t.x, e.y - t.y);
          },
          reverseAngle: function reverseAngle(t) {
            return this.normalizeAngle(t + Math.PI, !0);
          },
          normalizeAngle: function normalizeAngle(t) {
            return (t %= 2 * Math.PI) >= 0 ? t : t + 2 * Math.PI;
          },
          maxAdd: function maxAdd(t, e, i) {
            return Math.min(t + e, i);
          },
          minSub: function minSub(t, e, i) {
            return Math.max(t - e, i);
          },
          wrap: function wrap(t, e, i) {
            var s = i - e;
            if (s <= 0) return 0;
            var n = (t - e) % s;
            return n < 0 && (n += s), n + e;
          },
          wrapValue: function wrapValue(t, e, i) {
            return ((t = Math.abs(t)) + (e = Math.abs(e))) % (i = Math.abs(i));
          },
          isOdd: function isOdd(t) {
            return !!(1 & t);
          },
          isEven: function isEven(t) {
            return !(1 & t);
          },
          min: function min() {
            if (1 === arguments.length && "object" == typeof arguments[0]) var t = arguments[0];else t = arguments;

            for (var e = 1, i = 0, s = t.length; e < s; e++) {
              t[e] < t[i] && (i = e);
            }

            return t[i];
          },
          max: function max() {
            if (1 === arguments.length && "object" == typeof arguments[0]) var t = arguments[0];else t = arguments;

            for (var e = 1, i = 0, s = t.length; e < s; e++) {
              t[e] > t[i] && (i = e);
            }

            return t[i];
          },
          minProperty: function minProperty(t) {
            if (2 === arguments.length && "object" == typeof arguments[1]) var e = arguments[1];else e = arguments.slice(1);

            for (var i = 1, s = 0, n = e.length; i < n; i++) {
              e[i][t] < e[s][t] && (s = i);
            }

            return e[s][t];
          },
          maxProperty: function maxProperty(t) {
            if (2 === arguments.length && "object" == typeof arguments[1]) var e = arguments[1];else e = arguments.slice(1);

            for (var i = 1, s = 0, n = e.length; i < n; i++) {
              e[i][t] > e[s][t] && (s = i);
            }

            return e[s][t];
          },
          wrapAngle: function wrapAngle(t, e) {
            return e ? this.wrap(t, -Math.PI, Math.PI) : this.wrap(t, -180, 180);
          },
          linearInterpolation: function linearInterpolation(t, e) {
            var i = t.length - 1,
                s = i * e,
                n = Math.floor(s);
            return e < 0 ? this.linear(t[0], t[1], s) : e > 1 ? this.linear(t[i], t[i - 1], i - s) : this.linear(t[n], t[n + 1 > i ? i : n + 1], s - n);
          },
          bezierInterpolation: function bezierInterpolation(t, e) {
            for (var i = 0, s = t.length - 1, n = 0; n <= s; n++) {
              i += Math.pow(1 - e, s - n) * Math.pow(e, n) * t[n] * this.bernstein(s, n);
            }

            return i;
          },
          catmullRomInterpolation: function catmullRomInterpolation(t, e) {
            var i = t.length - 1,
                s = i * e,
                n = Math.floor(s);
            return t[0] === t[i] ? (e < 0 && (n = Math.floor(s = i * (1 + e))), this.catmullRom(t[(n - 1 + i) % i], t[n], t[(n + 1) % i], t[(n + 2) % i], s - n)) : e < 0 ? t[0] - (this.catmullRom(t[0], t[0], t[1], t[1], -s) - t[0]) : e > 1 ? t[i] - (this.catmullRom(t[i], t[i], t[i - 1], t[i - 1], s - i) - t[i]) : this.catmullRom(t[n ? n - 1 : 0], t[n], t[i < n + 1 ? i : n + 1], t[i < n + 2 ? i : n + 2], s - n);
          },
          linear: function linear(t, e, i) {
            return (e - t) * i + t;
          },
          bernstein: function bernstein(t, e) {
            return this.factorial(t) / this.factorial(e) / this.factorial(t - e);
          },
          factorial: function factorial(t) {
            if (0 === t) return 1;

            for (var e = t; --t;) {
              e *= t;
            }

            return e;
          },
          catmullRom: function catmullRom(t, e, i, s, n) {
            var o = .5 * (i - t),
                r = .5 * (s - e),
                a = n * n;
            return (2 * e - 2 * i + o + r) * (n * a) + (-3 * e + 3 * i - 2 * o - r) * a + o * n + e;
          },
          difference: function difference(t, e) {
            return Math.abs(t - e);
          },
          roundAwayFromZero: function roundAwayFromZero(t) {
            return t > 0 ? Math.ceil(t) : Math.floor(t);
          },
          sinCosGenerator: function sinCosGenerator(t, e, i, s) {
            void 0 === e && (e = 1), void 0 === i && (i = 1), void 0 === s && (s = 1);

            for (var n = e, o = i, r = s * Math.PI / t, a = [], h = [], l = 0; l < t; l++) {
              n += (o -= n * r) * r, a[l] = o, h[l] = n;
            }

            return {
              sin: h,
              cos: a,
              length: t
            };
          },
          hypot: function hypot(t, e) {
            return Math.sqrt(t * t + e * e);
          },
          distance: function distance(t, e, i, s) {
            var n = t - i,
                o = e - s;
            return Math.sqrt(n * n + o * o);
          },
          distanceSq: function distanceSq(t, e, i, s) {
            var n = t - i,
                o = e - s;
            return n * n + o * o;
          },
          distancePow: function distancePow(t, e, i, s, n) {
            return void 0 === n && (n = 2), Math.sqrt(Math.pow(i - t, n) + Math.pow(s - e, n));
          },
          clamp: function clamp(t, e, i) {
            return t < e ? e : i < t ? i : t;
          },
          clampBottom: function clampBottom(t, e) {
            return t < e ? e : t;
          },
          within: function within(t, e, i) {
            return Math.abs(t - e) <= i;
          },
          mapLinear: function mapLinear(t, e, i, s, n) {
            return s + (t - e) * (n - s) / (i - e);
          },
          smoothstep: function smoothstep(t, e, i) {
            return (t = Math.max(0, Math.min(1, (t - e) / (i - e)))) * t * (3 - 2 * t);
          },
          smootherstep: function smootherstep(t, e, i) {
            return (t = Math.max(0, Math.min(1, (t - e) / (i - e)))) * t * t * (t * (6 * t - 15) + 10);
          },
          sign: function sign(t) {
            return t < 0 ? -1 : t > 0 ? 1 : 0;
          },
          percent: function percent(t, e, i) {
            return void 0 === i && (i = 0), t > e || i > e ? 1 : t < i || i > t ? 0 : (t - i) / e;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.RandomDataGenerator = function (t) {
          void 0 === t && (t = []), this.c = 1, this.s0 = 0, this.s1 = 0, this.s2 = 0, "string" == typeof t ? this.state(t) : this.sow(t);
        }, s.RandomDataGenerator.prototype = {
          rnd: function rnd() {
            var t = 2091639 * this.s0 + 2.3283064365386963e-10 * this.c;
            return this.c = 0 | t, this.s0 = this.s1, this.s1 = this.s2, this.s2 = t - this.c, this.s2;
          },
          sow: function sow(t) {
            if (this.s0 = this.hash(" "), this.s1 = this.hash(this.s0), this.s2 = this.hash(this.s1), this.c = 1, t) for (var e = 0; e < t.length && null != t[e]; e++) {
              var i = t[e];
              this.s0 -= this.hash(i), this.s0 += ~~(this.s0 < 0), this.s1 -= this.hash(i), this.s1 += ~~(this.s1 < 0), this.s2 -= this.hash(i), this.s2 += ~~(this.s2 < 0);
            }
          },
          hash: function hash(t) {
            var e, i, s;

            for (s = 4022871197, t = t.toString(), i = 0; i < t.length; i++) {
              e = .02519603282416938 * (s += t.charCodeAt(i)), e -= s = e >>> 0, s = (e *= s) >>> 0, s += 4294967296 * (e -= s);
            }

            return 2.3283064365386963e-10 * (s >>> 0);
          },
          integer: function integer() {
            return 4294967296 * this.rnd.apply(this);
          },
          frac: function frac() {
            return this.rnd.apply(this) + 1.1102230246251565e-16 * (2097152 * this.rnd.apply(this) | 0);
          },
          real: function real() {
            return this.integer() + this.frac();
          },
          integerInRange: function integerInRange(t, e) {
            return Math.floor(this.realInRange(0, e - t + 1) + t);
          },
          between: function between(t, e) {
            return this.integerInRange(t, e);
          },
          realInRange: function realInRange(t, e) {
            return this.frac() * (e - t) + t;
          },
          normal: function normal() {
            return 1 - 2 * this.frac();
          },
          uuid: function uuid() {
            var t = "",
                e = "";

            for (e = t = ""; t++ < 36; e += ~t % 5 | 3 * t & 4 ? (15 ^ t ? 8 ^ this.frac() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
              ;
            }

            return e;
          },
          pick: function pick(t) {
            return t[this.integerInRange(0, t.length - 1)];
          },
          sign: function sign() {
            return this.pick([-1, 1]);
          },
          weightedPick: function weightedPick(t) {
            return t[~~(Math.pow(this.frac(), 2) * (t.length - 1) + .5)];
          },
          timestamp: function timestamp(t, e) {
            return this.realInRange(t || 9466848e5, e || 1577862e6);
          },
          angle: function angle() {
            return this.integerInRange(-180, 180);
          },
          state: function state(t) {
            return "string" == typeof t && t.match(/^!rnd/) && (t = t.split(","), this.c = parseFloat(t[1]), this.s0 = parseFloat(t[2]), this.s1 = parseFloat(t[3]), this.s2 = parseFloat(t[4])), ["!rnd", this.c, this.s0, this.s1, this.s2].join(",");
          }
        }, s.RandomDataGenerator.prototype.constructor = s.RandomDataGenerator,
        /**
         * @author       Timo Hausmann
         * @author       Richard Davey <rich@photonstorm.com>
         * @copyright    2016 Photon Storm Ltd.
         * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
         */
        s.QuadTree = function (t, e, i, s, n, o, r) {
          this.maxObjects = 10, this.maxLevels = 4, this.level = 0, this.bounds = {}, this.objects = [], this.nodes = [], this._empty = [], this.reset(t, e, i, s, n, o, r);
        }, s.QuadTree.prototype = {
          reset: function reset(t, e, i, s, n, o, r) {
            this.maxObjects = n || 10, this.maxLevels = o || 4, this.level = r || 0, this.bounds = {
              x: Math.round(t),
              y: Math.round(e),
              width: i,
              height: s,
              subWidth: Math.floor(i / 2),
              subHeight: Math.floor(s / 2),
              right: Math.round(t) + Math.floor(i / 2),
              bottom: Math.round(e) + Math.floor(s / 2)
            }, this.objects.length = 0, this.nodes.length = 0;
          },
          populate: function populate(t) {
            t.forEach(this.populateHandler, this, !0);
          },
          populateHandler: function populateHandler(t) {
            t.body && t.exists && this.insert(t.body);
          },
          split: function split() {
            this.nodes[0] = new s.QuadTree(this.bounds.right, this.bounds.y, this.bounds.subWidth, this.bounds.subHeight, this.maxObjects, this.maxLevels, this.level + 1), this.nodes[1] = new s.QuadTree(this.bounds.x, this.bounds.y, this.bounds.subWidth, this.bounds.subHeight, this.maxObjects, this.maxLevels, this.level + 1), this.nodes[2] = new s.QuadTree(this.bounds.x, this.bounds.bottom, this.bounds.subWidth, this.bounds.subHeight, this.maxObjects, this.maxLevels, this.level + 1), this.nodes[3] = new s.QuadTree(this.bounds.right, this.bounds.bottom, this.bounds.subWidth, this.bounds.subHeight, this.maxObjects, this.maxLevels, this.level + 1);
          },
          insert: function insert(t) {
            var e,
                i = 0;

            if (null == this.nodes[0] || -1 === (e = this.getIndex(t))) {
              if (this.objects.push(t), this.objects.length > this.maxObjects && this.level < this.maxLevels) for (null == this.nodes[0] && this.split(); i < this.objects.length;) {
                -1 !== (e = this.getIndex(this.objects[i])) ? this.nodes[e].insert(this.objects.splice(i, 1)[0]) : i++;
              }
            } else this.nodes[e].insert(t);
          },
          getIndex: function getIndex(t) {
            var e = -1;
            return t.x < this.bounds.right && t.right < this.bounds.right ? t.y < this.bounds.bottom && t.bottom < this.bounds.bottom ? e = 1 : t.y > this.bounds.bottom && (e = 2) : t.x > this.bounds.right && (t.y < this.bounds.bottom && t.bottom < this.bounds.bottom ? e = 0 : t.y > this.bounds.bottom && (e = 3)), e;
          },
          retrieve: function retrieve(t) {
            if (t instanceof s.Rectangle) var e = this.objects,
                i = this.getIndex(t);else {
              if (!t.body) return this._empty;
              e = this.objects, i = this.getIndex(t.body);
            }
            return this.nodes[0] && (e = -1 !== i ? e.concat(this.nodes[i].retrieve(t)) : (e = (e = (e = e.concat(this.nodes[0].retrieve(t))).concat(this.nodes[1].retrieve(t))).concat(this.nodes[2].retrieve(t))).concat(this.nodes[3].retrieve(t))), e;
          },
          clear: function clear() {
            this.objects.length = 0;

            for (var t = this.nodes.length; t--;) {
              this.nodes[t].clear(), this.nodes.splice(t, 1);
            }

            this.nodes.length = 0;
          }
        }, s.QuadTree.prototype.constructor = s.QuadTree,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Net = function (t) {
          this.game = t;
        }, s.Net.prototype = {
          getHostName: function getHostName() {
            return window.location && window.location.hostname ? window.location.hostname : null;
          },
          checkDomainName: function checkDomainName(t) {
            return -1 !== window.location.hostname.indexOf(t);
          },
          updateQueryString: function updateQueryString(t, e, i, s) {
            void 0 === i && (i = !1), void 0 !== s && "" !== s || (s = window.location.href);
            var n = "",
                o = new RegExp("([?|&])" + t + "=.*?(&|#|$)(.*)", "gi");
            if (o.test(s)) n = void 0 !== e && null !== e ? s.replace(o, "$1" + t + "=" + e + "$2$3") : s.replace(o, "$1$3").replace(/(&|\?)$/, "");else if (void 0 !== e && null !== e) {
              var r = -1 !== s.indexOf("?") ? "&" : "?",
                  a = s.split("#");
              s = a[0] + r + t + "=" + e, a[1] && (s += "#" + a[1]), n = s;
            } else n = s;
            if (!i) return n;
            window.location.href = n;
          },
          getQueryString: function getQueryString(t) {
            void 0 === t && (t = "");
            var e = {},
                i = location.search.substring(1).split("&");

            for (var s in i) {
              var n = i[s].split("=");

              if (n.length > 1) {
                if (t && t === this.decodeURI(n[0])) return this.decodeURI(n[1]);
                e[this.decodeURI(n[0])] = this.decodeURI(n[1]);
              }
            }

            return e;
          },
          decodeURI: function decodeURI(t) {
            return decodeURIComponent(t.replace(/\+/g, " "));
          }
        }, s.Net.prototype.constructor = s.Net,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.TweenManager = function (t) {
          this.game = t, this.frameBased = !1, this._tweens = [], this._add = [], this.easeMap = {
            Power0: s.Easing.Power0,
            Power1: s.Easing.Power1,
            Power2: s.Easing.Power2,
            Power3: s.Easing.Power3,
            Power4: s.Easing.Power4,
            Linear: s.Easing.Linear.None,
            Quad: s.Easing.Quadratic.Out,
            Cubic: s.Easing.Cubic.Out,
            Quart: s.Easing.Quartic.Out,
            Quint: s.Easing.Quintic.Out,
            Sine: s.Easing.Sinusoidal.Out,
            Expo: s.Easing.Exponential.Out,
            Circ: s.Easing.Circular.Out,
            Elastic: s.Easing.Elastic.Out,
            Back: s.Easing.Back.Out,
            Bounce: s.Easing.Bounce.Out,
            "Quad.easeIn": s.Easing.Quadratic.In,
            "Cubic.easeIn": s.Easing.Cubic.In,
            "Quart.easeIn": s.Easing.Quartic.In,
            "Quint.easeIn": s.Easing.Quintic.In,
            "Sine.easeIn": s.Easing.Sinusoidal.In,
            "Expo.easeIn": s.Easing.Exponential.In,
            "Circ.easeIn": s.Easing.Circular.In,
            "Elastic.easeIn": s.Easing.Elastic.In,
            "Back.easeIn": s.Easing.Back.In,
            "Bounce.easeIn": s.Easing.Bounce.In,
            "Quad.easeOut": s.Easing.Quadratic.Out,
            "Cubic.easeOut": s.Easing.Cubic.Out,
            "Quart.easeOut": s.Easing.Quartic.Out,
            "Quint.easeOut": s.Easing.Quintic.Out,
            "Sine.easeOut": s.Easing.Sinusoidal.Out,
            "Expo.easeOut": s.Easing.Exponential.Out,
            "Circ.easeOut": s.Easing.Circular.Out,
            "Elastic.easeOut": s.Easing.Elastic.Out,
            "Back.easeOut": s.Easing.Back.Out,
            "Bounce.easeOut": s.Easing.Bounce.Out,
            "Quad.easeInOut": s.Easing.Quadratic.InOut,
            "Cubic.easeInOut": s.Easing.Cubic.InOut,
            "Quart.easeInOut": s.Easing.Quartic.InOut,
            "Quint.easeInOut": s.Easing.Quintic.InOut,
            "Sine.easeInOut": s.Easing.Sinusoidal.InOut,
            "Expo.easeInOut": s.Easing.Exponential.InOut,
            "Circ.easeInOut": s.Easing.Circular.InOut,
            "Elastic.easeInOut": s.Easing.Elastic.InOut,
            "Back.easeInOut": s.Easing.Back.InOut,
            "Bounce.easeInOut": s.Easing.Bounce.InOut
          }, this.game.onPause.add(this._pauseAll, this), this.game.onResume.add(this._resumeAll, this);
        }, s.TweenManager.prototype = {
          getAll: function getAll() {
            return this._tweens;
          },
          removeAll: function removeAll() {
            for (var t = 0; t < this._tweens.length; t++) {
              this._tweens[t].pendingDelete = !0;
            }

            this._add = [];
          },
          removeFrom: function removeFrom(t, e) {
            if (void 0 === e && (e = !0), Array.isArray(t)) for (i = 0, n = t.length; i < n; i++) {
              this.removeFrom(t[i]);
            } else if (t.type === s.GROUP && e) for (var i = 0, n = t.children.length; i < n; i++) {
              this.removeFrom(t.children[i]);
            } else {
              for (i = 0, n = this._tweens.length; i < n; i++) {
                t === this._tweens[i].target && this.remove(this._tweens[i]);
              }

              for (i = 0, n = this._add.length; i < n; i++) {
                t === this._add[i].target && this.remove(this._add[i]);
              }
            }
          },
          add: function add(t) {
            t._manager = this, this._add.push(t);
          },
          create: function create(t) {
            return new s.Tween(t, this.game, this);
          },
          remove: function remove(t) {
            var e = this._tweens.indexOf(t);

            -1 !== e ? this._tweens[e].pendingDelete = !0 : -1 !== (e = this._add.indexOf(t)) && (this._add[e].pendingDelete = !0);
          },
          update: function update() {
            var t = this._add.length,
                e = this._tweens.length;
            if (0 === e && 0 === t) return !1;

            for (var i = 0; i < e;) {
              this._tweens[i].update(this.game.time.time) ? i++ : (this._tweens.splice(i, 1), e--);
            }

            return t > 0 && (this._tweens = this._tweens.concat(this._add), this._add.length = 0), !0;
          },
          isTweening: function isTweening(t, e) {
            return e || (e = !1), this._tweens.some(function (i) {
              return i.target === t && (!e || i.isRunning && !i.pendingDelete);
            });
          },
          _pauseAll: function _pauseAll() {
            for (var t = this._tweens.length - 1; t >= 0; t--) {
              this._tweens[t]._pause();
            }
          },
          _resumeAll: function _resumeAll() {
            for (var t = this._tweens.length - 1; t >= 0; t--) {
              this._tweens[t]._resume();
            }
          },
          pauseAll: function pauseAll() {
            for (var t = this._tweens.length - 1; t >= 0; t--) {
              this._tweens[t].pause();
            }
          },
          resumeAll: function resumeAll() {
            for (var t = this._tweens.length - 1; t >= 0; t--) {
              this._tweens[t].resume(!0);
            }
          }
        }, s.TweenManager.prototype.constructor = s.TweenManager,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Tween = function (t, e, i) {
          this.game = e, this.target = t, this.manager = i, this.timeline = [], this.reverse = !1, this.timeScale = 1, this.repeatCounter = 0, this.pendingDelete = !1, this.onStart = new s.Signal(), this.onLoop = new s.Signal(), this.onRepeat = new s.Signal(), this.onChildComplete = new s.Signal(), this.onComplete = new s.Signal(), this.isRunning = !1, this.current = 0, this.properties = {}, this.chainedTween = null, this.isPaused = !1, this.frameBased = i.frameBased, this._onUpdateCallback = null, this._onUpdateCallbackContext = null, this._pausedTime = 0, this._codePaused = !1, this._hasStarted = !1;
        }, s.Tween.updateColor = function (t) {
          s.Color.updateColor(t.target);
        }, s.Tween.prototype = {
          to: function to(t, e, i, n, o, r, a) {
            return (void 0 === e || e <= 0) && (e = 1e3), void 0 !== i && null !== i || (i = s.Easing.Default), void 0 === n && (n = !1), void 0 === o && (o = 0), void 0 === r && (r = 0), void 0 === a && (a = !1), "string" == typeof i && this.manager.easeMap[i] && (i = this.manager.easeMap[i]), this.isRunning ? (console.warn("Phaser.Tween.to cannot be called after Tween.start"), this) : (this.timeline.push(new s.TweenData(this).to(t, e, i, o, r, a)), n && this.start(), this);
          },
          from: function from(t, e, i, n, o, r, a) {
            return void 0 === e && (e = 1e3), void 0 !== i && null !== i || (i = s.Easing.Default), void 0 === n && (n = !1), void 0 === o && (o = 0), void 0 === r && (r = 0), void 0 === a && (a = !1), "string" == typeof i && this.manager.easeMap[i] && (i = this.manager.easeMap[i]), this.isRunning ? (console.warn("Phaser.Tween.from cannot be called after Tween.start"), this) : (this.timeline.push(new s.TweenData(this).from(t, e, i, o, r, a)), n && this.start(), this);
          },
          start: function start(t) {
            if (void 0 === t && (t = 0), this.pendingDelete) return console.warn("Phaser.Tween.start cannot be called after Tween.stop"), this;
            if (null === this.game || null === this.target || 0 === this.timeline.length || this.isRunning) return this;

            for (var e = 0; e < this.timeline.length; e++) {
              for (var i in this.timeline[e].vEnd) {
                this.properties[i] = this.target[i] || 0, Array.isArray(this.properties[i]) || (this.properties[i] *= 1);
              }
            }

            for (e = 0; e < this.timeline.length; e++) {
              this.timeline[e].loadValues();
            }

            return this.manager.add(this), this.isRunning = !0, (t < 0 || t > this.timeline.length - 1) && (t = 0), this.current = t, this.timeline[this.current].start(), this;
          },
          stop: function stop(t) {
            return void 0 === t && (t = !1), this.isRunning = !1, this._onUpdateCallback = null, this._onUpdateCallbackContext = null, t && (this.onComplete.dispatch(this.target, this), this._hasStarted = !1, this.chainedTween && this.chainedTween.start()), this.manager.remove(this), this;
          },
          updateTweenData: function updateTweenData(t, e, i) {
            if (0 === this.timeline.length) return this;
            if (void 0 === i && (i = 0), -1 === i) for (var s = 0; s < this.timeline.length; s++) {
              this.timeline[s][t] = e;
            } else this.timeline[i][t] = e;
            return this;
          },
          delay: function delay(t, e) {
            return this.updateTweenData("delay", t, e);
          },
          repeat: function repeat(t, e, i) {
            return void 0 === e && (e = 0), this.updateTweenData("repeatCounter", t, i), this.updateTweenData("repeatTotal", t, i), this.updateTweenData("repeatDelay", e, i);
          },
          repeatDelay: function repeatDelay(t, e) {
            return this.updateTweenData("repeatDelay", t, e);
          },
          yoyo: function yoyo(t, e, i) {
            return void 0 === e && (e = 0), this.updateTweenData("yoyo", t, i), this.updateTweenData("yoyoDelay", e, i);
          },
          yoyoDelay: function yoyoDelay(t, e) {
            return this.updateTweenData("yoyoDelay", t, e);
          },
          easing: function easing(t, e) {
            return "string" == typeof t && this.manager.easeMap[t] && (t = this.manager.easeMap[t]), this.updateTweenData("easingFunction", t, e);
          },
          interpolation: function interpolation(t, e, i) {
            return void 0 === e && (e = s.Math), this.updateTweenData("interpolationFunction", t, i), this.updateTweenData("interpolationContext", e, i);
          },
          repeatAll: function repeatAll(t) {
            return void 0 === t && (t = 0), this.repeatCounter = t, this;
          },
          chain: function chain() {
            for (var t = arguments.length; t--;) {
              t > 0 ? arguments[t - 1].chainedTween = arguments[t] : this.chainedTween = arguments[t];
            }

            return this;
          },
          loop: function loop(t) {
            return void 0 === t && (t = !0), this.repeatCounter = t ? -1 : 0, this;
          },
          onUpdateCallback: function onUpdateCallback(t, e) {
            return this._onUpdateCallback = t, this._onUpdateCallbackContext = e, this;
          },
          pause: function pause() {
            this.isPaused = !0, this._codePaused = !0, this._pausedTime = this.game.time.time;
          },
          _pause: function _pause() {
            this._codePaused || (this.isPaused = !0, this._pausedTime = this.game.time.time);
          },
          resume: function resume() {
            if (this.isPaused) {
              this.isPaused = !1, this._codePaused = !1;

              for (var t = 0; t < this.timeline.length; t++) {
                this.timeline[t].isRunning || (this.timeline[t].startTime += this.game.time.time - this._pausedTime);
              }
            }
          },
          _resume: function _resume() {
            this._codePaused || this.resume();
          },
          update: function update(t) {
            if (this.pendingDelete || !this.target) return !1;
            if (this.isPaused) return !0;
            var e = this.timeline[this.current].update(t);
            if (e === s.TweenData.PENDING) return !0;
            if (e === s.TweenData.RUNNING) return this._hasStarted || (this.onStart.dispatch(this.target, this), this._hasStarted = !0), null !== this._onUpdateCallback && this._onUpdateCallback.call(this._onUpdateCallbackContext, this, this.timeline[this.current].value, this.timeline[this.current]), this.isRunning;
            if (e === s.TweenData.LOOPED) return -1 === this.timeline[this.current].repeatCounter ? this.onLoop.dispatch(this.target, this) : this.onRepeat.dispatch(this.target, this), !0;

            if (e === s.TweenData.COMPLETE) {
              var i = !1;
              return this.reverse ? (this.current--, this.current < 0 && (this.current = this.timeline.length - 1, i = !0)) : (this.current++, this.current === this.timeline.length && (this.current = 0, i = !0)), i ? -1 === this.repeatCounter ? (this.timeline[this.current].start(), this.onLoop.dispatch(this.target, this), !0) : this.repeatCounter > 0 ? (this.repeatCounter--, this.timeline[this.current].start(), this.onRepeat.dispatch(this.target, this), !0) : (this.isRunning = !1, this.onComplete.dispatch(this.target, this), this._hasStarted = !1, this.chainedTween && this.chainedTween.start(), !1) : (this.onChildComplete.dispatch(this.target, this), this.timeline[this.current].start(), !0);
            }
          },
          generateData: function generateData(t, e) {
            if (null === this.game || null === this.target) return null;
            void 0 === t && (t = 60), void 0 === e && (e = []);

            for (var i = 0; i < this.timeline.length; i++) {
              for (var s in this.timeline[i].vEnd) {
                this.properties[s] = this.target[s] || 0, Array.isArray(this.properties[s]) || (this.properties[s] *= 1);
              }
            }

            for (i = 0; i < this.timeline.length; i++) {
              this.timeline[i].loadValues();
            }

            for (i = 0; i < this.timeline.length; i++) {
              e = e.concat(this.timeline[i].generateData(t));
            }

            return e;
          }
        }, Object.defineProperty(s.Tween.prototype, "totalDuration", {
          get: function get() {
            for (var t = 0, e = 0; e < this.timeline.length; e++) {
              t += this.timeline[e].duration;
            }

            return t;
          }
        }), s.Tween.prototype.constructor = s.Tween,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.TweenData = function (t) {
          this.parent = t, this.game = t.game, this.vStart = {}, this.vStartCache = {}, this.vEnd = {}, this.vEndCache = {}, this.duration = 1e3, this.percent = 0, this.value = 0, this.repeatCounter = 0, this.repeatDelay = 0, this.repeatTotal = 0, this.interpolate = !1, this.yoyo = !1, this.yoyoDelay = 0, this.inReverse = !1, this.delay = 0, this.dt = 0, this.startTime = null, this.easingFunction = s.Easing.Default, this.interpolationFunction = s.Math.linearInterpolation, this.interpolationContext = s.Math, this.isRunning = !1, this.isFrom = !1;
        }, s.TweenData.PENDING = 0, s.TweenData.RUNNING = 1, s.TweenData.LOOPED = 2, s.TweenData.COMPLETE = 3, s.TweenData.prototype = {
          to: function to(t, e, i, s, n, o) {
            return this.vEnd = t, this.duration = e, this.easingFunction = i, this.delay = s, this.repeatTotal = n, this.yoyo = o, this.isFrom = !1, this;
          },
          from: function from(t, e, i, s, n, o) {
            return this.vEnd = t, this.duration = e, this.easingFunction = i, this.delay = s, this.repeatTotal = n, this.yoyo = o, this.isFrom = !0, this;
          },
          start: function start() {
            if (this.startTime = this.game.time.time + this.delay, this.parent.reverse ? this.dt = this.duration : this.dt = 0, this.delay > 0 ? this.isRunning = !1 : this.isRunning = !0, this.isFrom) for (var t in this.vStartCache) {
              this.vStart[t] = this.vEndCache[t], this.vEnd[t] = this.vStartCache[t], this.parent.target[t] = this.vStart[t];
            }
            return this.value = 0, this.repeatCounter = this.repeatTotal, this;
          },
          loadValues: function loadValues() {
            for (var t in this.parent.properties) {
              if (this.vStart[t] = this.parent.properties[t], Array.isArray(this.vEnd[t])) {
                if (0 === this.vEnd[t].length) continue;
                0 === this.percent && (this.vEnd[t] = [this.vStart[t]].concat(this.vEnd[t]));
              }

              void 0 !== this.vEnd[t] ? ("string" == typeof this.vEnd[t] && (this.vEnd[t] = this.vStart[t] + parseFloat(this.vEnd[t], 10)), this.parent.properties[t] = this.vEnd[t]) : this.vEnd[t] = this.vStart[t], this.vStartCache[t] = this.vStart[t], this.vEndCache[t] = this.vEnd[t];
            }

            return this;
          },
          update: function update(t) {
            if (this.isRunning) {
              if (t < this.startTime) return s.TweenData.RUNNING;
            } else {
              if (!(t >= this.startTime)) return s.TweenData.PENDING;
              this.isRunning = !0;
            }

            var e = this.parent.frameBased ? this.game.time.physicsElapsedMS : this.game.time.elapsedMS;

            for (var i in this.parent.reverse ? (this.dt -= e * this.parent.timeScale, this.dt = Math.max(this.dt, 0)) : (this.dt += e * this.parent.timeScale, this.dt = Math.min(this.dt, this.duration)), this.percent = this.dt / this.duration, this.value = this.easingFunction(this.percent), this.vEnd) {
              var n = this.vStart[i],
                  o = this.vEnd[i];
              Array.isArray(o) ? this.parent.target[i] = this.interpolationFunction.call(this.interpolationContext, o, this.value) : this.parent.target[i] = n + (o - n) * this.value;
            }

            return !this.parent.reverse && 1 === this.percent || this.parent.reverse && 0 === this.percent ? this.repeat() : s.TweenData.RUNNING;
          },
          generateData: function generateData(t) {
            this.parent.reverse ? this.dt = this.duration : this.dt = 0;
            var e = [],
                i = !1,
                s = 1 / t * 1e3;

            do {
              this.parent.reverse ? (this.dt -= s, this.dt = Math.max(this.dt, 0)) : (this.dt += s, this.dt = Math.min(this.dt, this.duration)), this.percent = this.dt / this.duration, this.value = this.easingFunction(this.percent);
              var n = {};

              for (var o in this.vEnd) {
                var r = this.vStart[o],
                    a = this.vEnd[o];
                Array.isArray(a) ? n[o] = this.interpolationFunction.call(this.interpolationContext, a, this.value) : n[o] = r + (a - r) * this.value;
              }

              e.push(n), (!this.parent.reverse && 1 === this.percent || this.parent.reverse && 0 === this.percent) && (i = !0);
            } while (!i);

            if (this.yoyo) {
              var h = e.slice();
              h.reverse(), e = e.concat(h);
            }

            return e;
          },
          repeat: function repeat() {
            if (this.yoyo) {
              if (this.inReverse && 0 === this.repeatCounter) {
                for (var t in this.vStartCache) {
                  this.vStart[t] = this.vStartCache[t], this.vEnd[t] = this.vEndCache[t];
                }

                return this.inReverse = !1, s.TweenData.COMPLETE;
              }

              this.inReverse = !this.inReverse;
            } else if (0 === this.repeatCounter) return s.TweenData.COMPLETE;

            if (this.inReverse) for (var t in this.vStartCache) {
              this.vStart[t] = this.vEndCache[t], this.vEnd[t] = this.vStartCache[t];
            } else {
              for (var t in this.vStartCache) {
                this.vStart[t] = this.vStartCache[t], this.vEnd[t] = this.vEndCache[t];
              }

              this.repeatCounter > 0 && this.repeatCounter--;
            }
            return this.startTime = this.game.time.time, this.yoyo && this.inReverse ? this.startTime += this.yoyoDelay : this.inReverse || (this.startTime += this.repeatDelay), this.parent.reverse ? this.dt = this.duration : this.dt = 0, s.TweenData.LOOPED;
          }
        }, s.TweenData.prototype.constructor = s.TweenData,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Easing = {
          Linear: {
            None: function None(t) {
              return t;
            }
          },
          Quadratic: {
            In: function In(t) {
              return t * t;
            },
            Out: function Out(t) {
              return t * (2 - t);
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1);
            }
          },
          Cubic: {
            In: function In(t) {
              return t * t * t;
            },
            Out: function Out(t) {
              return --t * t * t + 1;
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2);
            }
          },
          Quartic: {
            In: function In(t) {
              return t * t * t * t;
            },
            Out: function Out(t) {
              return 1 - --t * t * t * t;
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t * t * t : -.5 * ((t -= 2) * t * t * t - 2);
            }
          },
          Quintic: {
            In: function In(t) {
              return t * t * t * t * t;
            },
            Out: function Out(t) {
              return --t * t * t * t * t + 1;
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2);
            }
          },
          Sinusoidal: {
            In: function In(t) {
              return 0 === t ? 0 : 1 === t ? 1 : 1 - Math.cos(t * Math.PI / 2);
            },
            Out: function Out(t) {
              return 0 === t ? 0 : 1 === t ? 1 : Math.sin(t * Math.PI / 2);
            },
            InOut: function InOut(t) {
              return 0 === t ? 0 : 1 === t ? 1 : .5 * (1 - Math.cos(Math.PI * t));
            }
          },
          Exponential: {
            In: function In(t) {
              return 0 === t ? 0 : Math.pow(1024, t - 1);
            },
            Out: function Out(t) {
              return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
            },
            InOut: function InOut(t) {
              return 0 === t ? 0 : 1 === t ? 1 : (t *= 2) < 1 ? .5 * Math.pow(1024, t - 1) : .5 * (2 - Math.pow(2, -10 * (t - 1)));
            }
          },
          Circular: {
            In: function In(t) {
              return 1 - Math.sqrt(1 - t * t);
            },
            Out: function Out(t) {
              return Math.sqrt(1 - --t * t);
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
            }
          },
          Elastic: {
            In: function In(t) {
              var e,
                  i = .1;
              return 0 === t ? 0 : 1 === t ? 1 : (!i || i < 1 ? (i = 1, e = .1) : e = .4 * Math.asin(1 / i) / (2 * Math.PI), -i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / .4));
            },
            Out: function Out(t) {
              var e,
                  i = .1;
              return 0 === t ? 0 : 1 === t ? 1 : (!i || i < 1 ? (i = 1, e = .1) : e = .4 * Math.asin(1 / i) / (2 * Math.PI), i * Math.pow(2, -10 * t) * Math.sin((t - e) * (2 * Math.PI) / .4) + 1);
            },
            InOut: function InOut(t) {
              var e,
                  i = .1;
              return 0 === t ? 0 : 1 === t ? 1 : (!i || i < 1 ? (i = 1, e = .1) : e = .4 * Math.asin(1 / i) / (2 * Math.PI), (t *= 2) < 1 ? i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / .4) * -.5 : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / .4) * .5 + 1);
            }
          },
          Back: {
            In: function In(t) {
              var e = 1.70158;
              return t * t * ((e + 1) * t - e);
            },
            Out: function Out(t) {
              var e = 1.70158;
              return --t * t * ((e + 1) * t + e) + 1;
            },
            InOut: function InOut(t) {
              var e = 2.5949095;
              return (t *= 2) < 1 ? t * t * ((e + 1) * t - e) * .5 : .5 * ((t -= 2) * t * ((e + 1) * t + e) + 2);
            }
          },
          Bounce: {
            In: function In(t) {
              return 1 - s.Easing.Bounce.Out(1 - t);
            },
            Out: function Out(t) {
              return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
            },
            InOut: function InOut(t) {
              return t < .5 ? .5 * s.Easing.Bounce.In(2 * t) : .5 * s.Easing.Bounce.Out(2 * t - 1) + .5;
            }
          }
        }, s.Easing.Default = s.Easing.Linear.None, s.Easing.Power0 = s.Easing.Linear.None, s.Easing.Power1 = s.Easing.Quadratic.Out, s.Easing.Power2 = s.Easing.Cubic.Out, s.Easing.Power3 = s.Easing.Quartic.Out, s.Easing.Power4 = s.Easing.Quintic.Out,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Time = function (t) {
          this.game = t, this.time = 0, this.prevTime = 0, this.now = 0, this.elapsed = 0, this.elapsedMS = 0, this.physicsElapsed = 1 / 60, this.physicsElapsedMS = 1 / 60 * 1e3, this.desiredFpsMult = 1 / 60, this._desiredFps = 60, this.suggestedFps = this.desiredFps, this.slowMotion = 1, this.advancedTiming = !1, this.frames = 0, this.updates = 0, this.renders = 0, this.fps = 0, this.ups = 0, this.rps = 0, this.fpsMin = 1e3, this.fpsMax = 0, this.msMin = 1e3, this.msMax = 0, this.pauseDuration = 0, this.timeToCall = 0, this.timeExpected = 0, this.events = new s.Timer(this.game, !1), this._frameCount = 0, this._elapsedAccumulator = 0, this._started = 0, this._timeLastSecond = 0, this._pauseStarted = 0, this._justResumed = !1, this._timers = [];
        }, s.Time.prototype = {
          boot: function boot() {
            this._started = Date.now(), this.time = Date.now(), this.events.start(), this.timeExpected = this.time;
          },
          add: function add(t) {
            return this._timers.push(t), t;
          },
          create: function create(t) {
            void 0 === t && (t = !0);
            var e = new s.Timer(this.game, t);
            return this._timers.push(e), e;
          },
          removeAll: function removeAll() {
            for (var t = 0; t < this._timers.length; t++) {
              this._timers[t].destroy();
            }

            this._timers = [], this.events.removeAll();
          },
          refresh: function refresh() {
            var t = this.time;
            this.time = Date.now(), this.elapsedMS = this.time - t;
          },
          update: function update(t) {
            var e = this.time;
            this.time = Date.now(), this.elapsedMS = this.time - e, this.prevTime = this.now, this.now = t, this.elapsed = this.now - this.prevTime, this.game.raf._isSetTimeOut && (this.timeToCall = Math.floor(Math.max(0, 1e3 / this._desiredFps - (this.timeExpected - t))), this.timeExpected = t + this.timeToCall), this.advancedTiming && this.updateAdvancedTiming(), this.game.paused || (this.events.update(this.time), this._timers.length && this.updateTimers());
          },
          updateTimers: function updateTimers() {
            for (var t = 0, e = this._timers.length; t < e;) {
              this._timers[t].update(this.time) ? t++ : (this._timers.splice(t, 1), e--);
            }
          },
          updateAdvancedTiming: function updateAdvancedTiming() {
            if (this._frameCount++, this._elapsedAccumulator += this.elapsed, this._frameCount >= 2 * this._desiredFps && (this.suggestedFps = 5 * Math.floor(200 / (this._elapsedAccumulator / this._frameCount)), this._frameCount = 0, this._elapsedAccumulator = 0), this.msMin = Math.min(this.msMin, this.elapsed), this.msMax = Math.max(this.msMax, this.elapsed), this.frames++, this.now > this._timeLastSecond + 1e3) {
              var t = this.now - this._timeLastSecond;
              this.fps = Math.round(1e3 * this.frames / t), this.ups = Math.round(1e3 * this.updates / t), this.rps = Math.round(1e3 * this.renders / t), this.fpsMin = Math.min(this.fpsMin, this.fps), this.fpsMax = Math.max(this.fpsMax, this.fps), this._timeLastSecond = this.now, this.frames = 0, this.updates = 0, this.renders = 0;
            }
          },
          countUpdate: function countUpdate() {
            this.advancedTiming && this.updates++;
          },
          countRender: function countRender() {
            this.advancedTiming && this.renders++;
          },
          gamePaused: function gamePaused() {
            this._pauseStarted = Date.now(), this.events.pause();

            for (var t = this._timers.length; t--;) {
              this._timers[t]._pause();
            }
          },
          gameResumed: function gameResumed() {
            this.time = Date.now(), this.pauseDuration = this.time - this._pauseStarted, this.events.resume();

            for (var t = this._timers.length; t--;) {
              this._timers[t]._resume();
            }
          },
          totalElapsedSeconds: function totalElapsedSeconds() {
            return .001 * (this.time - this._started);
          },
          elapsedSince: function elapsedSince(t) {
            return this.time - t;
          },
          elapsedSecondsSince: function elapsedSecondsSince(t) {
            return .001 * (this.time - t);
          },
          reset: function reset() {
            this._started = this.time, this.removeAll();
          }
        }, Object.defineProperty(s.Time.prototype, "desiredFps", {
          get: function get() {
            return this._desiredFps;
          },
          set: function set(t) {
            this._desiredFps = t, this.physicsElapsed = 1 / t, this.physicsElapsedMS = 1e3 * this.physicsElapsed, this.desiredFpsMult = 1 / t;
          }
        }), s.Time.prototype.constructor = s.Time,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Timer = function (t, e) {
          void 0 === e && (e = !0), this.game = t, this.running = !1, this.autoDestroy = e, this.expired = !1, this.elapsed = 0, this.events = [], this.onComplete = new s.Signal(), this.nextTick = 0, this.timeCap = 1e3, this.paused = !1, this._codePaused = !1, this._started = 0, this._pauseStarted = 0, this._pauseTotal = 0, this._now = Date.now(), this._len = 0, this._marked = 0, this._i = 0, this._diff = 0, this._newTick = 0;
        }, s.Timer.MINUTE = 6e4, s.Timer.SECOND = 1e3, s.Timer.HALF = 500, s.Timer.QUARTER = 250, s.Timer.prototype = {
          create: function create(t, e, i, n, o, r) {
            var a = t = Math.round(t);
            0 === this._now ? a += this.game.time.time : a += this._now;
            var h = new s.TimerEvent(this, t, a, i, e, n, o, r);
            return this.events.push(h), this.order(), this.expired = !1, h;
          },
          add: function add(t, e, i) {
            return this.create(t, !1, 0, e, i, Array.prototype.slice.call(arguments, 3));
          },
          repeat: function repeat(t, e, i, s) {
            return this.create(t, !1, e, i, s, Array.prototype.slice.call(arguments, 4));
          },
          loop: function loop(t, e, i) {
            return this.create(t, !0, 0, e, i, Array.prototype.slice.call(arguments, 3));
          },
          start: function start(t) {
            if (!this.running) {
              this._started = this.game.time.time + (t || 0), this.running = !0;

              for (var e = 0; e < this.events.length; e++) {
                this.events[e].tick = this.events[e].delay + this._started;
              }
            }
          },
          stop: function stop(t) {
            this.running = !1, void 0 === t && (t = !0), t && (this.events.length = 0);
          },
          remove: function remove(t) {
            for (var e = 0; e < this.events.length; e++) {
              if (this.events[e] === t) return this.events[e].pendingDelete = !0, !0;
            }

            return !1;
          },
          order: function order() {
            this.events.length > 0 && (this.events.sort(this.sortHandler), this.nextTick = this.events[0].tick);
          },
          sortHandler: function sortHandler(t, e) {
            return t.tick < e.tick ? -1 : t.tick > e.tick ? 1 : 0;
          },
          clearPendingEvents: function clearPendingEvents() {
            for (this._i = this.events.length; this._i--;) {
              this.events[this._i].pendingDelete && this.events.splice(this._i, 1);
            }

            this._len = this.events.length, this._i = 0;
          },
          update: function update(t) {
            if (this.paused) return !0;

            if (this.elapsed = t - this._now, this._now = t, this.elapsed > this.timeCap && this.adjustEvents(t - this.elapsed), this._marked = 0, this.clearPendingEvents(), this.running && this._now >= this.nextTick && this._len > 0) {
              for (; this._i < this._len && this.running;) {
                var e = this.events[this._i];
                if (!(this._now >= e.tick) || e.pendingDelete) break;
                this._newTick = this._now + e.delay - (this._now - e.tick), this._newTick < 0 && (this._newTick = this._now + e.delay), !0 === e.loop ? (e.tick = this._newTick, e.callback.apply(e.callbackContext, e.args)) : e.repeatCount > 0 ? (e.repeatCount--, e.tick = this._newTick, e.callback.apply(e.callbackContext, e.args)) : (this._marked++, e.pendingDelete = !0, e.callback.apply(e.callbackContext, e.args)), this._i++;
              }

              this.events.length > this._marked ? this.order() : (this.expired = !0, this.onComplete.dispatch(this));
            }

            return !this.expired || !this.autoDestroy;
          },
          pause: function pause() {
            this.running && (this._codePaused = !0, this.paused || (this._pauseStarted = this.game.time.time, this.paused = !0));
          },
          _pause: function _pause() {
            !this.paused && this.running && (this._pauseStarted = this.game.time.time, this.paused = !0);
          },
          adjustEvents: function adjustEvents(t) {
            for (var e = 0; e < this.events.length; e++) {
              if (!this.events[e].pendingDelete) {
                var i = this.events[e].tick - t;
                i < 0 && (i = 0), this.events[e].tick = this._now + i;
              }
            }

            var s = this.nextTick - t;
            this.nextTick = s < 0 ? this._now : this._now + s;
          },
          resume: function resume() {
            if (this.paused) {
              var t = this.game.time.time;
              this._pauseTotal += t - this._now, this._now = t, this.adjustEvents(this._pauseStarted), this.paused = !1, this._codePaused = !1;
            }
          },
          _resume: function _resume() {
            this._codePaused || this.resume();
          },
          removeAll: function removeAll() {
            this.onComplete.removeAll(), this.events.length = 0, this._len = 0, this._i = 0;
          },
          destroy: function destroy() {
            this.onComplete.removeAll(), this.running = !1, this.expired = !0, this.events = [], this._len = 0, this._i = 0;
          }
        }, Object.defineProperty(s.Timer.prototype, "next", {
          get: function get() {
            return this.nextTick;
          }
        }), Object.defineProperty(s.Timer.prototype, "duration", {
          get: function get() {
            return this.running && this.nextTick > this._now ? this.nextTick - this._now : 0;
          }
        }), Object.defineProperty(s.Timer.prototype, "length", {
          get: function get() {
            return this.events.length;
          }
        }), Object.defineProperty(s.Timer.prototype, "ms", {
          get: function get() {
            return this.running ? this._now - this._started - this._pauseTotal : 0;
          }
        }), Object.defineProperty(s.Timer.prototype, "seconds", {
          get: function get() {
            return this.running ? .001 * this.ms : 0;
          }
        }), s.Timer.prototype.constructor = s.Timer,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.TimerEvent = function (t, e, i, s, n, o, r, a) {
          this.timer = t, this.delay = e, this.tick = i, this.repeatCount = s - 1, this.loop = n, this.callback = o, this.callbackContext = r, this.args = a, this.pendingDelete = !1;
        }, s.TimerEvent.prototype.constructor = s.TimerEvent,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.AnimationManager = function (t) {
          this.sprite = t, this.game = t.game, this.currentFrame = null, this.currentAnim = null, this.updateIfVisible = !0, this.isLoaded = !1, this._frameData = null, this._anims = {}, this._outputFrames = [];
        }, s.AnimationManager.prototype = {
          loadFrameData: function loadFrameData(t, e) {
            if (void 0 === t) return !1;
            if (this.isLoaded) for (var i in this._anims) {
              this._anims[i].updateFrameData(t);
            }
            return this._frameData = t, void 0 === e || null === e ? this.frame = 0 : "string" == typeof e ? this.frameName = e : this.frame = e, this.isLoaded = !0, !0;
          },
          copyFrameData: function copyFrameData(t, e) {
            if (this._frameData = t.clone(), this.isLoaded) for (var i in this._anims) {
              this._anims[i].updateFrameData(this._frameData);
            }
            return void 0 === e || null === e ? this.frame = 0 : "string" == typeof e ? this.frameName = e : this.frame = e, this.isLoaded = !0, !0;
          },
          add: function add(t, e, i, n, o) {
            return e = e || [], i = i || 60, void 0 === n && (n = !1), void 0 === o && (o = !(!e || "number" != typeof e[0])), this._outputFrames = [], this._frameData.getFrameIndexes(e, o, this._outputFrames), this._anims[t] = new s.Animation(this.game, this.sprite, t, this._frameData, this._outputFrames, i, n), this.currentAnim = this._anims[t], this.sprite.tilingTexture && (this.sprite.refreshTexture = !0), this._anims[t];
          },
          validateFrames: function validateFrames(t, e) {
            void 0 === e && (e = !0);

            for (var i = 0; i < t.length; i++) {
              if (!0 === e) {
                if (t[i] > this._frameData.total) return !1;
              } else if (!1 === this._frameData.checkFrameName(t[i])) return !1;
            }

            return !0;
          },
          play: function play(t, e, i, s) {
            if (this._anims[t]) return this.currentAnim === this._anims[t] ? !1 === this.currentAnim.isPlaying ? (this.currentAnim.paused = !1, this.currentAnim.play(e, i, s)) : this.currentAnim : (this.currentAnim && this.currentAnim.isPlaying && this.currentAnim.stop(), this.currentAnim = this._anims[t], this.currentAnim.paused = !1, this.currentFrame = this.currentAnim.currentFrame, this.currentAnim.play(e, i, s));
          },
          stop: function stop(t, e) {
            void 0 === e && (e = !1), !this.currentAnim || "string" == typeof t && t !== this.currentAnim.name || this.currentAnim.stop(e);
          },
          update: function update() {
            return !(this.updateIfVisible && !this.sprite.visible) && !(!this.currentAnim || !this.currentAnim.update()) && (this.currentFrame = this.currentAnim.currentFrame, !0);
          },
          next: function next(t) {
            this.currentAnim && (this.currentAnim.next(t), this.currentFrame = this.currentAnim.currentFrame);
          },
          previous: function previous(t) {
            this.currentAnim && (this.currentAnim.previous(t), this.currentFrame = this.currentAnim.currentFrame);
          },
          getAnimation: function getAnimation(t) {
            return "string" == typeof t && this._anims[t] ? this._anims[t] : null;
          },
          refreshFrame: function refreshFrame() {},
          destroy: function destroy() {
            var t = null;

            for (var t in this._anims) {
              this._anims.hasOwnProperty(t) && this._anims[t].destroy();
            }

            this._anims = {}, this._outputFrames = [], this._frameData = null, this.currentAnim = null, this.currentFrame = null, this.sprite = null, this.game = null;
          }
        }, s.AnimationManager.prototype.constructor = s.AnimationManager, Object.defineProperty(s.AnimationManager.prototype, "frameData", {
          get: function get() {
            return this._frameData;
          }
        }), Object.defineProperty(s.AnimationManager.prototype, "frameTotal", {
          get: function get() {
            return this._frameData.total;
          }
        }), Object.defineProperty(s.AnimationManager.prototype, "paused", {
          get: function get() {
            return this.currentAnim.isPaused;
          },
          set: function set(t) {
            this.currentAnim.paused = t;
          }
        }), Object.defineProperty(s.AnimationManager.prototype, "name", {
          get: function get() {
            if (this.currentAnim) return this.currentAnim.name;
          }
        }), Object.defineProperty(s.AnimationManager.prototype, "frame", {
          get: function get() {
            if (this.currentFrame) return this.currentFrame.index;
          },
          set: function set(t) {
            var e;
            "number" == typeof t && this._frameData && (e = this._frameData.getFrame(t)) && (this.currentFrame = e, this.sprite.setFrame(this.currentFrame));
          }
        }), Object.defineProperty(s.AnimationManager.prototype, "frameName", {
          get: function get() {
            if (this.currentFrame) return this.currentFrame.name;
          },
          set: function set(t) {
            var e;
            "string" == typeof t && this._frameData && (e = this._frameData.getFrameByName(t)) ? (this.currentFrame = e, this._frameIndex = this.currentFrame.index, this.sprite.setFrame(this.currentFrame)) : console.warn("Cannot set frameName: " + t);
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Animation = function (t, e, i, n, o, r, a) {
          void 0 === a && (a = !1), this.game = t, this._parent = e, this._frameData = n, this.name = i, this._frames = [], this._frames = this._frames.concat(o), this.delay = 1e3 / r, this.loop = a, this.loopCount = 0, this.killOnComplete = !1, this.isFinished = !1, this.isPlaying = !1, this.isPaused = !1, this._pauseStartTime = 0, this._frameIndex = 0, this._frameDiff = 0, this._frameSkip = 1, this.currentFrame = this._frameData.getFrame(this._frames[this._frameIndex]), this.onStart = new s.Signal(), this.onUpdate = null, this.onComplete = new s.Signal(), this.onLoop = new s.Signal(), this.isReversed = !1, this.game.onPause.add(this.onPause, this), this.game.onResume.add(this.onResume, this);
        }, s.Animation.prototype = {
          play: function play(t, e, i) {
            return "number" == typeof t && (this.delay = 1e3 / t), "boolean" == typeof e && (this.loop = e), void 0 !== i && (this.killOnComplete = i), this.isPlaying = !0, this.isFinished = !1, this.paused = !1, this.loopCount = 0, this._timeLastFrame = this.game.time.time, this._timeNextFrame = this.game.time.time + this.delay, this._frameIndex = this.isReversed ? this._frames.length - 1 : 0, this.updateCurrentFrame(!1, !0), this._parent.events.onAnimationStart$dispatch(this._parent, this), this.onStart.dispatch(this._parent, this), this._parent.animations.currentAnim = this, this._parent.animations.currentFrame = this.currentFrame, this;
          },
          restart: function restart() {
            this.isPlaying = !0, this.isFinished = !1, this.paused = !1, this.loopCount = 0, this._timeLastFrame = this.game.time.time, this._timeNextFrame = this.game.time.time + this.delay, this._frameIndex = 0, this.currentFrame = this._frameData.getFrame(this._frames[this._frameIndex]), this._parent.setFrame(this.currentFrame), this._parent.animations.currentAnim = this, this._parent.animations.currentFrame = this.currentFrame, this.onStart.dispatch(this._parent, this);
          },
          reverse: function reverse() {
            return this.reversed = !this.reversed, this;
          },
          reverseOnce: function reverseOnce() {
            return this.onComplete.addOnce(this.reverse, this), this.reverse();
          },
          setFrame: function setFrame(t, e) {
            var i;
            if (void 0 === e && (e = !1), "string" == typeof t) for (var s = 0; s < this._frames.length; s++) {
              this._frameData.getFrame(this._frames[s]).name === t && (i = s);
            } else if ("number" == typeof t) if (e) i = t;else for (s = 0; s < this._frames.length; s++) {
              this._frames[s] === t && (i = s);
            }

            if (i) {
              var n = this.isReversed ? -1 : 1;
              this._frameIndex = i - n, this._timeNextFrame = this.game.time.time, this.update();
            }
          },
          stop: function stop(t, e) {
            void 0 === t && (t = !1), void 0 === e && (e = !1), this.isPlaying = !1, this.isFinished = !0, this.paused = !1, t && (this.currentFrame = this._frameData.getFrame(this._frames[0]), this._parent.setFrame(this.currentFrame)), e && (this._parent.events.onAnimationComplete$dispatch(this._parent, this), this.onComplete.dispatch(this._parent, this));
          },
          onPause: function onPause() {
            this.isPlaying && (this._frameDiff = this._timeNextFrame - this.game.time.time);
          },
          onResume: function onResume() {
            this.isPlaying && (this._timeNextFrame = this.game.time.time + this._frameDiff);
          },
          update: function update() {
            return !this.isPaused && !!(this.isPlaying && this.game.time.time >= this._timeNextFrame) && (this._frameSkip = 1, this._frameDiff = this.game.time.time - this._timeNextFrame, this._timeLastFrame = this.game.time.time, this._frameDiff > this.delay ? (this._frameSkip = Math.floor(this._frameDiff / this.delay), this._frameDiff -= this._frameSkip * this.delay) : this._frameDiff = 0, this._timeNextFrame = this.game.time.time + (this.delay - this._frameDiff), this.isReversed ? this._frameIndex -= this._frameSkip : this._frameIndex += this._frameSkip, !this.isReversed && this._frameIndex >= this._frames.length || this.isReversed && this._frameIndex <= -1 ? this.loop ? (this._frameIndex = Math.abs(this._frameIndex) % this._frames.length, this.isReversed && (this._frameIndex = this._frames.length - 1 - this._frameIndex), this.currentFrame = this._frameData.getFrame(this._frames[this._frameIndex]), this.currentFrame && this._parent.setFrame(this.currentFrame), this.loopCount++, this._parent.events.onAnimationLoop$dispatch(this._parent, this), this.onLoop.dispatch(this._parent, this), !this.onUpdate || (this.onUpdate.dispatch(this, this.currentFrame), !!this._frameData)) : (this.complete(), !1) : this.updateCurrentFrame(!0));
          },
          updateCurrentFrame: function updateCurrentFrame(t, e) {
            if (void 0 === e && (e = !1), !this._frameData) return !1;
            var i = this.currentFrame.index;
            return this.currentFrame = this._frameData.getFrame(this._frames[this._frameIndex]), this.currentFrame && (e || !e && i !== this.currentFrame.index) && this._parent.setFrame(this.currentFrame), !this.onUpdate || !t || (this.onUpdate.dispatch(this, this.currentFrame), !!this._frameData);
          },
          next: function next(t) {
            void 0 === t && (t = 1);
            var e = this._frameIndex + t;
            e >= this._frames.length && (this.loop ? e %= this._frames.length : e = this._frames.length - 1), e !== this._frameIndex && (this._frameIndex = e, this.updateCurrentFrame(!0));
          },
          previous: function previous(t) {
            void 0 === t && (t = 1);
            var e = this._frameIndex - t;
            e < 0 && (this.loop ? e = this._frames.length + e : e++), e !== this._frameIndex && (this._frameIndex = e, this.updateCurrentFrame(!0));
          },
          updateFrameData: function updateFrameData(t) {
            this._frameData = t, this.currentFrame = this._frameData ? this._frameData.getFrame(this._frames[this._frameIndex % this._frames.length]) : null;
          },
          destroy: function destroy() {
            this._frameData && (this.game.onPause.remove(this.onPause, this), this.game.onResume.remove(this.onResume, this), this.game = null, this._parent = null, this._frames = null, this._frameData = null, this.currentFrame = null, this.isPlaying = !1, this.onStart.dispose(), this.onLoop.dispose(), this.onComplete.dispose(), this.onUpdate && this.onUpdate.dispose());
          },
          complete: function complete() {
            this._frameIndex = this._frames.length - 1, this.currentFrame = this._frameData.getFrame(this._frames[this._frameIndex]), this.updateCurrentFrame(!1), this.isPlaying = !1, this.isFinished = !0, this.paused = !1, this._parent.events.onAnimationComplete$dispatch(this._parent, this), this.onComplete.dispatch(this._parent, this), this.killOnComplete && this._parent.kill();
          }
        }, s.Animation.prototype.constructor = s.Animation, Object.defineProperty(s.Animation.prototype, "paused", {
          get: function get() {
            return this.isPaused;
          },
          set: function set(t) {
            this.isPaused = t, t ? this._pauseStartTime = this.game.time.time : this.isPlaying && (this._timeNextFrame = this.game.time.time + this.delay);
          }
        }), Object.defineProperty(s.Animation.prototype, "reversed", {
          get: function get() {
            return this.isReversed;
          },
          set: function set(t) {
            this.isReversed = t;
          }
        }), Object.defineProperty(s.Animation.prototype, "frameTotal", {
          get: function get() {
            return this._frames.length;
          }
        }), Object.defineProperty(s.Animation.prototype, "frame", {
          get: function get() {
            return null !== this.currentFrame ? this.currentFrame.index : this._frameIndex;
          },
          set: function set(t) {
            this.currentFrame = this._frameData.getFrame(this._frames[t]), null !== this.currentFrame && (this._frameIndex = t, this._parent.setFrame(this.currentFrame), this.onUpdate && this.onUpdate.dispatch(this, this.currentFrame));
          }
        }), Object.defineProperty(s.Animation.prototype, "speed", {
          get: function get() {
            return 1e3 / this.delay;
          },
          set: function set(t) {
            t > 0 && (this.delay = 1e3 / t);
          }
        }), Object.defineProperty(s.Animation.prototype, "enableUpdate", {
          get: function get() {
            return null !== this.onUpdate;
          },
          set: function set(t) {
            t && null === this.onUpdate ? this.onUpdate = new s.Signal() : t || null === this.onUpdate || (this.onUpdate.dispose(), this.onUpdate = null);
          }
        }), s.Animation.generateFrameNames = function (t, e, i, n, o) {
          void 0 === n && (n = "");
          var r = [],
              a = "";
          if (e < i) for (var h = e; h <= i; h++) {
            a = t + (a = "number" == typeof o ? s.Utils.pad(h.toString(), o, "0", 1) : h.toString()) + n, r.push(a);
          } else for (h = e; h >= i; h--) {
            a = t + (a = "number" == typeof o ? s.Utils.pad(h.toString(), o, "0", 1) : h.toString()) + n, r.push(a);
          }
          return r;
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Frame = function (t, e, i, n, o, r) {
          this.index = t, this.x = e, this.y = i, this.width = n, this.height = o, 0 !== this.width && 0 !== this.height || console.warn('Phaser.Frame: Frame "' + this.name + '" has a width or height of zero'), this.name = r, this.centerX = Math.floor(n / 2), this.centerY = Math.floor(o / 2), this.distance = s.Math.distance(0, 0, n, o), this.rotated = !1, this.trimmed = !1, this.sourceSizeW = n, this.sourceSizeH = o, this.spriteSourceSizeX = 0, this.spriteSourceSizeY = 0, this.spriteSourceSizeW = 0, this.spriteSourceSizeH = 0, this.right = this.x + this.width, this.bottom = this.y + this.height;
        }, s.Frame.prototype = {
          resize: function resize(t, e) {
            this.width = t, this.height = e, this.centerX = Math.floor(t / 2), this.centerY = Math.floor(e / 2), this.distance = s.Math.distance(0, 0, t, e), this.sourceSizeW = t, this.sourceSizeH = e, this.right = this.x + t, this.bottom = this.y + e;
          },
          setTrim: function setTrim(t, e, i, s, n, o, r) {
            this.trimmed = t, t && (this.sourceSizeW = e, this.sourceSizeH = i, this.centerX = Math.floor(e / 2), this.centerY = Math.floor(i / 2), this.spriteSourceSizeX = s, this.spriteSourceSizeY = n, this.spriteSourceSizeW = o, this.spriteSourceSizeH = r);
          },
          clone: function clone() {
            var t = new s.Frame(this.index, this.x, this.y, this.width, this.height, this.name);

            for (var e in this) {
              this.hasOwnProperty(e) && (t[e] = this[e]);
            }

            return t;
          },
          getRect: function getRect(t) {
            return void 0 === t ? t = new s.Rectangle(this.x, this.y, this.width, this.height) : t.setTo(this.x, this.y, this.width, this.height), t;
          }
        }, s.Frame.prototype.constructor = s.Frame,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.FrameData = function () {
          this._frames = [], this._frameNames = [];
        }, s.FrameData.prototype = {
          addFrame: function addFrame(t) {
            return t.index = this._frames.length, this._frames.push(t), "" !== t.name && (this._frameNames[t.name] = t.index), t;
          },
          getFrame: function getFrame(t) {
            return t >= this._frames.length && (t = 0), this._frames[t];
          },
          getFrameByName: function getFrameByName(t) {
            return "number" == typeof this._frameNames[t] ? this._frames[this._frameNames[t]] : null;
          },
          checkFrameName: function checkFrameName(t) {
            return null != this._frameNames[t];
          },
          clone: function clone() {
            for (var t = new s.FrameData(), e = 0; e < this._frames.length; e++) {
              t._frames.push(this._frames[e].clone());
            }

            for (var i in this._frameNames) {
              this._frameNames.hasOwnProperty(i) && t._frameNames.push(this._frameNames[i]);
            }

            return t;
          },
          getFrameRange: function getFrameRange(t, e, i) {
            void 0 === i && (i = []);

            for (var s = t; s <= e; s++) {
              i.push(this._frames[s]);
            }

            return i;
          },
          getFrames: function getFrames(t, e, i) {
            if (void 0 === e && (e = !0), void 0 === i && (i = []), void 0 === t || 0 === t.length) for (var s = 0; s < this._frames.length; s++) {
              i.push(this._frames[s]);
            } else for (s = 0; s < t.length; s++) {
              e ? i.push(this.getFrame(t[s])) : i.push(this.getFrameByName(t[s]));
            }
            return i;
          },
          getFrameIndexes: function getFrameIndexes(t, e, i) {
            if (void 0 === e && (e = !0), void 0 === i && (i = []), void 0 === t || 0 === t.length) for (var s = 0; s < this._frames.length; s++) {
              i.push(this._frames[s].index);
            } else for (s = 0; s < t.length; s++) {
              e && this._frames[t[s]] ? i.push(this._frames[t[s]].index) : this.getFrameByName(t[s]) && i.push(this.getFrameByName(t[s]).index);
            }
            return i;
          },
          destroy: function destroy() {
            this._frames = null, this._frameNames = null;
          }
        }, s.FrameData.prototype.constructor = s.FrameData, Object.defineProperty(s.FrameData.prototype, "total", {
          get: function get() {
            return this._frames.length;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.AnimationParser = {
          spriteSheet: function spriteSheet(t, e, i, n, o, r, a, h) {
            void 0 === o && (o = -1), void 0 === r && (r = 0), void 0 === a && (a = 0), void 0 === h && (h = 0);
            var l = e;
            if ("string" == typeof e && (l = t.cache.getImage(e)), null === l) return null;
            var c = l.width,
                u = l.height;
            if (0 === c || 0 === u) return console.warn("Phaser.AnimationParser.spriteSheet: '%s' width (%f) or height (%f) is zero", e, c, u), null;
            if (i <= 0 && (i = Math.floor(-c / Math.min(-1, i))), n <= 0 && (n = Math.floor(-u / Math.min(-1, n))), c < i || u < n) return console.warn("Phaser.AnimationParser.spriteSheet: '%s' width (%f) or height (%f) is less than the given frameWidth (%f) or frameHeight (%f)", e, c, u, i, n), null;
            var d = Math.floor((c - r) / (i + a)) * Math.floor((u - r) / (n + a));
            if (h > d || h < -d) return console.warn("Phaser.AnimationParser.spriteSheet: '%s' skipFrames = %f is larger than the frame total %f", e, h, d), null;
            if (h < 0 && (h = d + h), -1 !== o && (d = h + o), 0 === d) return console.warn("Phaser.AnimationParser.spriteSheet: '%s' zero frames were produced", e), null;

            for (var p = new s.FrameData(), f = r, g = r, m = 0; m < d; m++) {
              p.addFrame(new s.Frame(m, f, g, i, n, "")), (f += i + a) + i > c && (f = r, g += n + a);
            }

            return p;
          },
          JSONData: function JSONData(t, e) {
            if (!e.frames) return console.warn("Phaser.AnimationParser.JSONData: Invalid Texture Atlas JSON given, missing 'frames' array"), void console.log(e);

            for (var i, n = new s.FrameData(), o = e.frames, r = 0; r < o.length; r++) {
              i = n.addFrame(new s.Frame(r, o[r].frame.x, o[r].frame.y, o[r].frame.w, o[r].frame.h, o[r].filename)), o[r].trimmed && i.setTrim(o[r].trimmed, o[r].sourceSize.w, o[r].sourceSize.h, o[r].spriteSourceSize.x, o[r].spriteSourceSize.y, o[r].spriteSourceSize.w, o[r].spriteSourceSize.h), o[r].rotated && (i.rotated = !0);
            }

            return n;
          },
          JSONDataPyxel: function JSONDataPyxel(t, e) {
            if (["layers", "tilewidth", "tileheight", "tileswide", "tileshigh"].forEach(function (t) {
              if (!e[t]) return console.warn('Phaser.AnimationParser.JSONDataPyxel: Invalid Pyxel Tilemap JSON given, missing "' + t + '" key.'), void console.log(e);
            }), 1 !== e.layers.length) return console.warn("Phaser.AnimationParser.JSONDataPyxel: Too many layers, this parser only supports flat Tilemaps."), void console.log(e);

            for (var i = new s.FrameData(), n = e.tileheight, o = e.tilewidth, r = e.layers[0].tiles, a = 0; a < r.length; a++) {
              i.addFrame(new s.Frame(a, r[a].x, r[a].y, o, n, "frame_" + a)).setTrim(!1);
            }

            return i;
          },
          JSONDataHash: function JSONDataHash(t, e) {
            if (!e.frames) return console.warn("Phaser.AnimationParser.JSONDataHash: Invalid Texture Atlas JSON given, missing 'frames' object"), void console.log(e);
            var i,
                n = new s.FrameData(),
                o = e.frames,
                r = 0;

            for (var a in o) {
              i = n.addFrame(new s.Frame(r, o[a].frame.x, o[a].frame.y, o[a].frame.w, o[a].frame.h, a)), o[a].trimmed && i.setTrim(o[a].trimmed, o[a].sourceSize.w, o[a].sourceSize.h, o[a].spriteSourceSize.x, o[a].spriteSourceSize.y, o[a].spriteSourceSize.w, o[a].spriteSourceSize.h), o[a].rotated && (i.rotated = !0), r++;
            }

            return n;
          },
          XMLData: function XMLData(t, e) {
            if (e.getElementsByTagName("TextureAtlas")) {
              for (var i, n, o, r, a, h, l, c, u, d, p, f = new s.FrameData(), g = e.getElementsByTagName("SubTexture"), m = 0; m < g.length; m++) {
                n = (o = g[m].attributes).name.value, r = parseInt(o.x.value, 10), a = parseInt(o.y.value, 10), h = parseInt(o.width.value, 10), l = parseInt(o.height.value, 10), c = null, u = null, o.frameX && (c = Math.abs(parseInt(o.frameX.value, 10)), u = Math.abs(parseInt(o.frameY.value, 10)), d = parseInt(o.frameWidth.value, 10), p = parseInt(o.frameHeight.value, 10)), i = f.addFrame(new s.Frame(m, r, a, h, l, n)), null === c && null === u || i.setTrim(!0, h, l, c, u, d, p);
              }

              return f;
            }

            console.warn("Phaser.AnimationParser.XMLData: Invalid Texture Atlas XML given, missing <TextureAtlas> tag");
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Cache = function (t) {
          this.game = t, this.autoResolveURL = !1, this._cache = {
            canvas: {},
            image: {},
            texture: {},
            sound: {},
            video: {},
            text: {},
            json: {},
            xml: {},
            physics: {},
            tilemap: {},
            binary: {},
            bitmapData: {},
            bitmapFont: {},
            shader: {},
            renderTexture: {},
            compressedTexture: {}
          }, this._urlMap = {}, this._urlResolver = new Image(), this._urlTemp = null, this.onSoundUnlock = new s.Signal(), this._cacheMap = [], this._cacheMap[s.Cache.CANVAS] = this._cache.canvas, this._cacheMap[s.Cache.IMAGE] = this._cache.image, this._cacheMap[s.Cache.TEXTURE] = this._cache.texture, this._cacheMap[s.Cache.SOUND] = this._cache.sound, this._cacheMap[s.Cache.TEXT] = this._cache.text, this._cacheMap[s.Cache.PHYSICS] = this._cache.physics, this._cacheMap[s.Cache.TILEMAP] = this._cache.tilemap, this._cacheMap[s.Cache.BINARY] = this._cache.binary, this._cacheMap[s.Cache.BITMAPDATA] = this._cache.bitmapData, this._cacheMap[s.Cache.BITMAPFONT] = this._cache.bitmapFont, this._cacheMap[s.Cache.JSON] = this._cache.json, this._cacheMap[s.Cache.XML] = this._cache.xml, this._cacheMap[s.Cache.VIDEO] = this._cache.video, this._cacheMap[s.Cache.SHADER] = this._cache.shader, this._cacheMap[s.Cache.RENDER_TEXTURE] = this._cache.renderTexture, this._pendingCount = 0, this.onReady = new s.Signal(), this._addImages();
        }, s.Cache.CANVAS = 1, s.Cache.IMAGE = 2, s.Cache.TEXTURE = 3, s.Cache.SOUND = 4, s.Cache.TEXT = 5, s.Cache.PHYSICS = 6, s.Cache.TILEMAP = 7, s.Cache.BINARY = 8, s.Cache.BITMAPDATA = 9, s.Cache.BITMAPFONT = 10, s.Cache.JSON = 11, s.Cache.XML = 12, s.Cache.VIDEO = 13, s.Cache.SHADER = 14, s.Cache.RENDER_TEXTURE = 15, s.Cache.DEFAULT = null, s.Cache.DEFAULT_KEY = "__default", s.Cache.DEFAULT_SRC = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg==", s.Cache.MISSING = null, s.Cache.MISSING_KEY = "__missing", s.Cache.MISSING_SRC = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg==", s.Cache.READY_TIMEOUT = 1e3, s.Cache.prototype = {
          addCompressedTextureMetaData: function addCompressedTextureMetaData(t, e, i, n) {
            this.checkImageKey(t) && this.removeImage(t);
            var o = i in s.LoaderParser ? s.LoaderParser[i](n) : n,
                r = {
              key: t,
              url: e,
              data: o,
              base: new PIXI.BaseTexture(o, null, this.game.resolution),
              frame: new s.Frame(0, 0, 0, o.width, o.height, t),
              frameData: new s.FrameData(),
              fileFormat: i
            };
            return r.frameData.addFrame(new s.Frame(0, 0, 0, o.width, o.height, e)), this._cache.image[t] = r, this._resolveURL(e, r), r;
          },
          addCanvas: function addCanvas(t, e, i) {
            void 0 === i && (i = e.getContext("2d")), this._cache.canvas[t] = {
              canvas: e,
              context: i
            };
          },
          addImage: function addImage(t, e, i) {
            this.checkImageKey(t) && this.removeImage(t), !1 === i.complete && console.warn('Phaser.Cache.addImage: Image "' + t + "\" hasn't been retrieved yet");
            var n = {
              key: t,
              url: e,
              data: i,
              base: new PIXI.BaseTexture(i, null, this.game.resolution),
              frame: new s.Frame(0, 0, 0, i.width, i.height, t),
              frameData: new s.FrameData()
            };
            return n.frameData.addFrame(new s.Frame(0, 0, 0, i.width, i.height, e)), this._cache.image[t] = n, this._resolveURL(e, n), "__default" === t ? s.Cache.DEFAULT = new PIXI.Texture(n.base) : "__missing" === t && (s.Cache.MISSING = new PIXI.Texture(n.base)), n;
          },
          addImageAsync: function addImageAsync(t, e, i) {
            var s = this,
                n = new Image();
            n.onload = function () {
              i.call(this, s.addImage(t, null, n)), s._removePending(), n.onload = null;
            }, this._addPending(), n.src = e;
          },
          addDefaultImage: function addDefaultImage() {
            this.addImageAsync(s.Cache.DEFAULT_KEY, s.Cache.DEFAULT_SRC, function (t) {
              t.base.skipRender = !0, s.Cache.DEFAULT = new PIXI.Texture(t.base);
            });
          },
          addMissingImage: function addMissingImage() {
            this.addImageAsync(s.Cache.MISSING_KEY, s.Cache.MISSING_SRC, function (t) {
              s.Cache.MISSING = new PIXI.Texture(t.base);
            });
          },
          addSound: function addSound(t, e, i, s, n) {
            void 0 === s && (s = !0, n = !1), void 0 === n && (s = !1, n = !0);
            var o = !1;
            n && (o = !0), this._cache.sound[t] = {
              url: e,
              data: i,
              isDecoding: !1,
              decoded: o,
              webAudio: s,
              audioTag: n,
              locked: this.game.sound.touchLocked
            }, this._resolveURL(e, this._cache.sound[t]);
          },
          addText: function addText(t, e, i) {
            this._cache.text[t] = {
              url: e,
              data: i
            }, this._resolveURL(e, this._cache.text[t]);
          },
          addPhysicsData: function addPhysicsData(t, e, i, s) {
            this._cache.physics[t] = {
              url: e,
              data: i,
              format: s
            }, this._resolveURL(e, this._cache.physics[t]);
          },
          addTilemap: function addTilemap(t, e, i, s) {
            this._cache.tilemap[t] = {
              url: e,
              data: i,
              format: s
            }, this._resolveURL(e, this._cache.tilemap[t]);
          },
          addBinary: function addBinary(t, e) {
            this._cache.binary[t] = e;
          },
          addBitmapData: function addBitmapData(t, e, i) {
            return e.key = t, void 0 === i && (i = new s.FrameData()).addFrame(e.textureFrame), this._cache.bitmapData[t] = {
              data: e,
              frameData: i
            }, e;
          },
          addBitmapFont: function addBitmapFont(t, e, i, n, o, r, a) {
            var h = {
              url: e,
              data: i,
              font: null,
              base: new PIXI.BaseTexture(i, null, this.game.resolution)
            };
            void 0 === r && (r = 0), void 0 === a && (a = 0), h.font = "json" === o ? s.LoaderParser.jsonBitmapFont(n, h.base, r, a, !1, this.game.resolution) : s.LoaderParser.xmlBitmapFont(n, h.base, r, a, !1, this.game.resolution), this._cache.bitmapFont[t] = h, this._resolveURL(e, h);
          },
          addBitmapFontFromAtlas: function addBitmapFontFromAtlas(t, e, i, n, o, r, a) {
            var h = this.getFrameByName(e, i);

            if (h) {
              var l,
                  c = {
                font: null,
                base: this.getBaseTexture(e),
                frame: h
              };
              void 0 === r && (r = 0), void 0 === a && (a = 0), "json" === o ? (l = this.getJSON(n), c.font = s.LoaderParser.jsonBitmapFont(l, c.base, r, a, h, this.game.resolution)) : (l = this.getXML(n), c.font = s.LoaderParser.xmlBitmapFont(l, c.base, r, a, h, this.game.resolution)), this._cache.bitmapFont[t] = c;
            }
          },
          addJSON: function addJSON(t, e, i) {
            this._cache.json[t] = {
              url: e,
              data: i
            }, this._resolveURL(e, this._cache.json[t]);
          },
          addXML: function addXML(t, e, i) {
            this._cache.xml[t] = {
              url: e,
              data: i
            }, this._resolveURL(e, this._cache.xml[t]);
          },
          addVideo: function addVideo(t, e, i, s) {
            this._cache.video[t] = {
              url: e,
              data: i,
              isBlob: s,
              locked: !0
            }, this._resolveURL(e, this._cache.video[t]);
          },
          addShader: function addShader(t, e, i) {
            this._cache.shader[t] = {
              url: e,
              data: i
            }, this._resolveURL(e, this._cache.shader[t]);
          },
          addRenderTexture: function addRenderTexture(t, e) {
            this._cache.renderTexture[t] = {
              texture: e,
              frame: new s.Frame(0, 0, 0, e.width, e.height, "", "")
            };
          },
          addSpriteSheet: function addSpriteSheet(t, e, i, n, o, r, a, h, l) {
            void 0 === r && (r = -1), void 0 === a && (a = 0), void 0 === h && (h = 0);
            var c = {
              key: t,
              url: e,
              data: i,
              frameWidth: n,
              frameHeight: o,
              margin: a,
              spacing: h,
              base: new PIXI.BaseTexture(i, null, this.game.resolution),
              frameData: s.AnimationParser.spriteSheet(this.game, i, n, o, r, a, h, l)
            };
            this._cache.image[t] = c, this._resolveURL(e, c);
          },
          addTextureAtlas: function addTextureAtlas(t, e, i, n, o) {
            var r = {
              key: t,
              url: e,
              data: i,
              base: new PIXI.BaseTexture(i, null, this.game.resolution)
            };
            o === s.Loader.TEXTURE_ATLAS_XML_STARLING ? r.frameData = s.AnimationParser.XMLData(this.game, n, t) : o === s.Loader.TEXTURE_ATLAS_JSON_PYXEL ? r.frameData = s.AnimationParser.JSONDataPyxel(this.game, n, t) : Array.isArray(n.frames) ? r.frameData = s.AnimationParser.JSONData(this.game, n, t) : r.frameData = s.AnimationParser.JSONDataHash(this.game, n, t), this._cache.image[t] = r, this._resolveURL(e, r);
          },
          reloadSound: function reloadSound(t) {
            var e = this,
                i = this.getSound(t);
            i && (i.data.src = i.url, i.data.addEventListener("canplaythrough", function () {
              return e.reloadSoundComplete(t);
            }, !1), i.data.load());
          },
          reloadSoundComplete: function reloadSoundComplete(t) {
            var e = this.getSound(t);
            e && (e.locked = !1, this.onSoundUnlock.dispatch(t));
          },
          updateSound: function updateSound(t, e, i) {
            var s = this.getSound(t);
            s && (s[e] = i);
          },
          decodedSound: function decodedSound(t, e) {
            var i = this.getSound(t);
            i.data = e, i.decoded = !0, i.isDecoding = !1;
          },
          isSoundDecoded: function isSoundDecoded(t) {
            var e = this.getItem(t, s.Cache.SOUND, "isSoundDecoded");
            if (e) return e.decoded;
          },
          isSoundReady: function isSoundReady(t) {
            var e = this.getItem(t, s.Cache.SOUND, "isSoundDecoded");
            if (e) return e.decoded && !this.game.sound.touchLocked;
          },
          checkKey: function checkKey(t, e) {
            return !!this._cacheMap[t][e];
          },
          checkURL: function checkURL(t) {
            return !!this._urlMap[this._resolveURL(t)];
          },
          checkCanvasKey: function checkCanvasKey(t) {
            return this.checkKey(s.Cache.CANVAS, t);
          },
          checkImageKey: function checkImageKey(t) {
            return this.checkKey(s.Cache.IMAGE, t);
          },
          checkTextureKey: function checkTextureKey(t) {
            return this.checkKey(s.Cache.TEXTURE, t);
          },
          checkSoundKey: function checkSoundKey(t) {
            return this.checkKey(s.Cache.SOUND, t);
          },
          checkTextKey: function checkTextKey(t) {
            return this.checkKey(s.Cache.TEXT, t);
          },
          checkPhysicsKey: function checkPhysicsKey(t) {
            return this.checkKey(s.Cache.PHYSICS, t);
          },
          checkTilemapKey: function checkTilemapKey(t) {
            return this.checkKey(s.Cache.TILEMAP, t);
          },
          checkBinaryKey: function checkBinaryKey(t) {
            return this.checkKey(s.Cache.BINARY, t);
          },
          checkBitmapDataKey: function checkBitmapDataKey(t) {
            return this.checkKey(s.Cache.BITMAPDATA, t);
          },
          checkBitmapFontKey: function checkBitmapFontKey(t) {
            return this.checkKey(s.Cache.BITMAPFONT, t);
          },
          checkJSONKey: function checkJSONKey(t) {
            return this.checkKey(s.Cache.JSON, t);
          },
          checkXMLKey: function checkXMLKey(t) {
            return this.checkKey(s.Cache.XML, t);
          },
          checkVideoKey: function checkVideoKey(t) {
            return this.checkKey(s.Cache.VIDEO, t);
          },
          checkShaderKey: function checkShaderKey(t) {
            return this.checkKey(s.Cache.SHADER, t);
          },
          checkRenderTextureKey: function checkRenderTextureKey(t) {
            return this.checkKey(s.Cache.RENDER_TEXTURE, t);
          },
          getItem: function getItem(t, e, i, s) {
            return this.checkKey(e, t) ? void 0 === s ? this._cacheMap[e][t] : this._cacheMap[e][t][s] : (i && console.warn("Phaser.Cache." + i + ': Key "' + t + '" not found in Cache.'), null);
          },
          getCanvas: function getCanvas(t) {
            return this.getItem(t, s.Cache.CANVAS, "getCanvas", "canvas");
          },
          getImage: function getImage(t, e) {
            void 0 !== t && null !== t || (t = "__default"), void 0 === e && (e = !1);
            var i = this.getItem(t, s.Cache.IMAGE, "getImage");
            return null === i && (i = this.getItem("__missing", s.Cache.IMAGE, "getImage")), e ? i : i.data;
          },
          getTextureFrame: function getTextureFrame(t) {
            return this.getItem(t, s.Cache.TEXTURE, "getTextureFrame", "frame");
          },
          getSound: function getSound(t) {
            return this.getItem(t, s.Cache.SOUND, "getSound");
          },
          getSoundData: function getSoundData(t) {
            return this.getItem(t, s.Cache.SOUND, "getSoundData", "data");
          },
          getText: function getText(t) {
            return this.getItem(t, s.Cache.TEXT, "getText", "data");
          },
          getPhysicsData: function getPhysicsData(t, e, i) {
            var n = this.getItem(t, s.Cache.PHYSICS, "getPhysicsData", "data");
            if (null === n || void 0 === e || null === e) return n;

            if (n[e]) {
              var o = n[e];
              if (!o || !i) return o;

              for (var r in o) {
                if ((r = o[r]).fixtureKey === i) return r;
              }

              console.warn('Phaser.Cache.getPhysicsData: Could not find given fixtureKey: "' + i + " in " + t + '"');
            } else console.warn('Phaser.Cache.getPhysicsData: Invalid key/object: "' + t + " / " + e + '"');

            return null;
          },
          getTilemapData: function getTilemapData(t) {
            return this.getItem(t, s.Cache.TILEMAP, "getTilemapData");
          },
          getBinary: function getBinary(t) {
            return this.getItem(t, s.Cache.BINARY, "getBinary");
          },
          getBitmapData: function getBitmapData(t) {
            return this.getItem(t, s.Cache.BITMAPDATA, "getBitmapData", "data");
          },
          getBitmapFont: function getBitmapFont(t) {
            return this.getItem(t, s.Cache.BITMAPFONT, "getBitmapFont");
          },
          getJSON: function getJSON(t, e) {
            var i = this.getItem(t, s.Cache.JSON, "getJSON", "data");
            return i ? e ? s.Utils.extend(!0, Array.isArray(i) ? [] : {}, i) : i : null;
          },
          getXML: function getXML(t) {
            return this.getItem(t, s.Cache.XML, "getXML", "data");
          },
          getVideo: function getVideo(t) {
            return this.getItem(t, s.Cache.VIDEO, "getVideo");
          },
          getShader: function getShader(t) {
            return this.getItem(t, s.Cache.SHADER, "getShader", "data");
          },
          getRenderTexture: function getRenderTexture(t) {
            return this.getItem(t, s.Cache.RENDER_TEXTURE, "getRenderTexture");
          },
          getBaseTexture: function getBaseTexture(t, e) {
            return void 0 === e && (e = s.Cache.IMAGE), this.getItem(t, e, "getBaseTexture", "base");
          },
          getFrame: function getFrame(t, e) {
            return void 0 === e && (e = s.Cache.IMAGE), this.getItem(t, e, "getFrame", "frame");
          },
          getFrameCount: function getFrameCount(t, e) {
            var i = this.getFrameData(t, e);
            return i ? i.total : 0;
          },
          getFrameData: function getFrameData(t, e) {
            return void 0 === e && (e = s.Cache.IMAGE), this.getItem(t, e, "getFrameData", "frameData");
          },
          hasFrameData: function hasFrameData(t, e) {
            return void 0 === e && (e = s.Cache.IMAGE), null !== this.getItem(t, e, "", "frameData");
          },
          updateFrameData: function updateFrameData(t, e, i) {
            void 0 === i && (i = s.Cache.IMAGE), this._cacheMap[i][t] && (this._cacheMap[i][t].frameData = e);
          },
          getFrameByIndex: function getFrameByIndex(t, e, i) {
            var s = this.getFrameData(t, i);
            return s ? s.getFrame(e) : null;
          },
          getFrameByName: function getFrameByName(t, e, i) {
            var s = this.getFrameData(t, i);
            return s ? s.getFrameByName(e) : null;
          },
          getURL: function getURL(t) {
            return (t = this._resolveURL(t)) ? this._urlMap[t] : (console.warn('Phaser.Cache.getUrl: Invalid url: "' + t + '" or Cache.autoResolveURL was false'), null);
          },
          getKeys: function getKeys(t) {
            void 0 === t && (t = s.Cache.IMAGE);
            var e = [];
            if (this._cacheMap[t]) for (var i in this._cacheMap[t]) {
              "__default" !== i && "__missing" !== i && e.push(i);
            }
            return e;
          },
          removeCanvas: function removeCanvas(t) {
            delete this._cache.canvas[t];
          },
          removeImage: function removeImage(t, e) {
            void 0 === e && (e = !0);
            var i = this.getImage(t, !0);
            e && i.base && i.base.destroy(), delete this._cache.image[t];
          },
          removeSound: function removeSound(t) {
            delete this._cache.sound[t];
          },
          removeText: function removeText(t) {
            delete this._cache.text[t];
          },
          removePhysics: function removePhysics(t) {
            delete this._cache.physics[t];
          },
          removeTilemap: function removeTilemap(t) {
            delete this._cache.tilemap[t];
          },
          removeBinary: function removeBinary(t) {
            delete this._cache.binary[t];
          },
          removeBitmapData: function removeBitmapData(t) {
            delete this._cache.bitmapData[t];
          },
          removeBitmapFont: function removeBitmapFont(t) {
            delete this._cache.bitmapFont[t];
          },
          removeJSON: function removeJSON(t) {
            delete this._cache.json[t];
          },
          removeXML: function removeXML(t) {
            delete this._cache.xml[t];
          },
          removeVideo: function removeVideo(t) {
            delete this._cache.video[t];
          },
          removeShader: function removeShader(t) {
            delete this._cache.shader[t];
          },
          removeRenderTexture: function removeRenderTexture(t) {
            delete this._cache.renderTexture[t];
          },
          removeSpriteSheet: function removeSpriteSheet(t) {
            delete this._cache.spriteSheet[t];
          },
          removeTextureAtlas: function removeTextureAtlas(t) {
            delete this._cache.image[t];
          },
          clearGLTextures: function clearGLTextures() {
            for (var t in this._cache.image) {
              this._cache.image[t].base._glTextures = [];
            }
          },
          _resolveURL: function _resolveURL(t, e) {
            return this.autoResolveURL ? (this._urlResolver.src = this.game.load.baseURL + t, this._urlTemp = this._urlResolver.src, this._urlResolver.src = "", e && (this._urlMap[this._urlTemp] = e), this._urlTemp) : null;
          },
          destroy: function destroy() {
            for (var t = 0; t < this._cacheMap.length; t++) {
              var e = this._cacheMap[t];

              for (var i in e) {
                "__default" !== i && "__missing" !== i && (this.destroyItem(e[i]), delete e[i]);
              }
            }

            this._urlMap = null, this._urlResolver = null, this._urlTemp = null;
          },
          destroyItem: function destroyItem(t) {
            t.destroy ? t.destroy() : (t.base && t.base.destroy && t.base.destroy(), t.data && t.data.destroy && t.data.destroy(), t.frameData && t.frameData.destroy && t.frameData.destroy(), t.texture && t.texture.destroy && t.texture.destroy(!0));
          },
          _addImages: function _addImages() {
            this._pendingCount = 0, this.addDefaultImage(), this.addMissingImage();
            var t = this,
                e = s.Cache.READY_TIMEOUT;
            s.Cache.READY_TIMEOUT > 0 ? setTimeout(function () {
              t.isReady || (console.warn("Phaser.Cache: Still waiting for images after %s ms.", e), t._ready());
            }, s.Cache.READY_TIMEOUT) : this._ready();
          },
          _addPending: function _addPending() {
            this._pendingCount += 1;
          },
          _removePending: function _removePending() {
            this._pendingCount -= 1, this._checkReady();
          },
          _checkReady: function _checkReady() {
            this.isReady && this._ready();
          },
          _ready: function _ready() {
            this._pendingCount = 0, this.onReady.dispatch(this);
          }
        }, s.Cache.prototype.constructor = s.Cache, Object.defineProperty(s.Cache.prototype, "isReady", {
          get: function get() {
            return this._pendingCount <= 0;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Loader = function (t) {
          this.game = t, this.cache = t.cache, this.resetLocked = !1, this.isLoading = !1, this.hasLoaded = !1, this.preloadSprite = null, this.crossOrigin = !1, this.baseURL = "", this.path = "", this.headers = {
            requestedWith: !1,
            json: "application/json",
            xml: "application/xml"
          }, this.onLoadStart = new s.Signal(), this.onBeforeLoadComplete = new s.Signal(), this.onLoadComplete = new s.Signal(), this.onPackComplete = new s.Signal(), this.onFileStart = new s.Signal(), this.onFileComplete = new s.Signal(), this.onFileError = new s.Signal(), this.enableParallel = !0, this.maxParallelDownloads = 4, this._withSyncPointDepth = 0, this._fileList = [], this._flightQueue = [], this._processingHead = 0, this._fileLoadStarted = !1, this._totalPackCount = 0, this._totalFileCount = 0, this._loadedPackCount = 0, this._loadedFileCount = 0;
        }, s.Loader.TEXTURE_ATLAS_JSON_ARRAY = 0, s.Loader.TEXTURE_ATLAS_JSON_HASH = 1, s.Loader.TEXTURE_ATLAS_XML_STARLING = 2, s.Loader.PHYSICS_LIME_CORONA_JSON = 3, s.Loader.PHYSICS_PHASER_JSON = 4, s.Loader.TEXTURE_ATLAS_JSON_PYXEL = 5, s.Loader.prototype = {
          setPreloadSprite: function setPreloadSprite(t, e) {
            e = e || 0, this.preloadSprite = {
              sprite: t,
              direction: e,
              width: t.width,
              height: t.height,
              rect: null
            }, this.preloadSprite.rect = 0 === e ? new s.Rectangle(0, 0, 1, t.height) : new s.Rectangle(0, 0, t.width, 1), t.crop(this.preloadSprite.rect), t.visible = !0;
          },
          resize: function resize() {
            this.preloadSprite && this.preloadSprite.height !== this.preloadSprite.sprite.height && (this.preloadSprite.rect.height = this.preloadSprite.sprite.height);
          },
          checkKeyExists: function checkKeyExists(t, e) {
            return this.getAssetIndex(t, e) > -1;
          },
          getAssetIndex: function getAssetIndex(t, e) {
            for (var i = -1, s = 0; s < this._fileList.length; s++) {
              var n = this._fileList[s];
              if (n.type === t && n.key === e && (i = s, !n.loaded && !n.loading)) break;
            }

            return i;
          },
          getAsset: function getAsset(t, e) {
            var i = this.getAssetIndex(t, e);
            return i > -1 && {
              index: i,
              file: this._fileList[i]
            };
          },
          reset: function reset(t, e) {
            void 0 === e && (e = !1), this.resetLocked || (t && (this.preloadSprite = null), this.isLoading = !1, this._processingHead = 0, this._fileList.length = 0, this._flightQueue.length = 0, this._fileLoadStarted = !1, this._totalFileCount = 0, this._totalPackCount = 0, this._loadedPackCount = 0, this._loadedFileCount = 0, e && (this.onLoadStart.removeAll(), this.onLoadComplete.removeAll(), this.onPackComplete.removeAll(), this.onFileStart.removeAll(), this.onFileComplete.removeAll(), this.onFileError.removeAll()));
          },
          addToFileList: function addToFileList(t, e, i, s, n, o) {
            if (void 0 === n && (n = !1), void 0 === e || "" === e) return console.warn("Phaser.Loader: Invalid or no key given of type " + t), this;

            if (void 0 === i || null === i) {
              if (!o) return console.warn("Phaser.Loader: No URL given for file type: " + t + " key: " + e), this;
              i = e + o;
            }

            var r = {
              type: t,
              key: e,
              path: this.path,
              url: i,
              syncPoint: this._withSyncPointDepth > 0,
              data: null,
              loading: !1,
              loaded: !1,
              error: !1
            };
            if (s) for (var a in s) {
              r[a] = s[a];
            }
            var h = this.getAssetIndex(t, e);

            if (n && h > -1) {
              var l = this._fileList[h];
              l.loading || l.loaded ? (this._fileList.push(r), this._totalFileCount++) : this._fileList[h] = r;
            } else -1 === h && (this._fileList.push(r), this._totalFileCount++);

            return this;
          },
          replaceInFileList: function replaceInFileList(t, e, i, s) {
            return this.addToFileList(t, e, i, s, !0);
          },
          pack: function pack(t, e, i, s) {
            if (void 0 === e && (e = null), void 0 === i && (i = null), void 0 === s && (s = null), !e && !i) return console.warn("Phaser.Loader.pack - Both url and data are null. One must be set."), this;
            var n = {
              type: "packfile",
              key: t,
              url: e,
              path: this.path,
              syncPoint: !0,
              data: null,
              loading: !1,
              loaded: !1,
              error: !1,
              callbackContext: s
            };
            i && ("string" == typeof i && (i = JSON.parse(i)), n.data = i || {}, n.loaded = !0);

            for (var o = 0; o < this._fileList.length + 1; o++) {
              var r = this._fileList[o];

              if (!r || !r.loaded && !r.loading && "packfile" !== r.type) {
                this._fileList.splice(o, 0, n), this._totalPackCount++;
                break;
              }
            }

            return this;
          },
          image: function image(t, e, i) {
            return "object" == typeof e ? this.texture(t, e, i) : this.addToFileList("image", t, e, void 0, i, ".png");
          },
          imageFromBitmapData: function imageFromBitmapData(t, e, i) {
            return this.image(t, e.canvas.toDataURL("image/png"), i);
          },
          imageFromGrid: function imageFromGrid(t, e, i, s, n, o) {
            return this.imageFromBitmapData(t, this.game.create.grid(t, e, i, s, n, o, !1));
          },
          imageFromTexture: function imageFromTexture(t, e, i, s, n) {
            return this.imageFromBitmapData(t, this.game.create.texture(t, e, i, s, n, !1));
          },
          texture: function texture(t, e, i) {
            if (this.game.renderType === s.WEBGL) {
              var n,
                  o = this.game.renderer.extensions.compression;

              for (n in e) {
                if (n.toUpperCase() in o) return this.addToFileList("texture", t, e[n], void 0, i, ".pvr");
              }
            }

            return e.truecolor && this.addToFileList("image", t, e.truecolor, void 0, i, ".png"), this;
          },
          images: function images(t, e) {
            if (Array.isArray(e)) for (var i = 0; i < t.length; i++) {
              this.image(t[i], e[i]);
            } else for (i = 0; i < t.length; i++) {
              this.image(t[i]);
            }
            return this;
          },
          text: function text(t, e, i) {
            return this.addToFileList("text", t, e, void 0, i, ".txt");
          },
          json: function json(t, e, i) {
            return this.addToFileList("json", t, e, void 0, i, ".json");
          },
          shader: function shader(t, e, i) {
            return this.addToFileList("shader", t, e, void 0, i, ".frag");
          },
          xml: function xml(t, e, i) {
            return this.addToFileList("xml", t, e, void 0, i, ".xml");
          },
          script: function script(t, e, i, s) {
            return void 0 === i && (i = !1), !1 !== i && void 0 === s && (s = this), this.addToFileList("script", t, e, {
              syncPoint: !0,
              callback: i,
              callbackContext: s
            }, !1, ".js");
          },
          binary: function binary(t, e, i, s) {
            return void 0 === i && (i = !1), !1 !== i && void 0 === s && (s = i), this.addToFileList("binary", t, e, {
              callback: i,
              callbackContext: s
            }, !1, ".bin");
          },
          spritesheet: function spritesheet(t, e, i, s, n, o, r, a) {
            return void 0 === n && (n = -1), void 0 === o && (o = 0), void 0 === r && (r = 0), void 0 === a && (a = 0), this.addToFileList("spritesheet", t, e, {
              frameWidth: i,
              frameHeight: s,
              frameMax: n,
              margin: o,
              spacing: r,
              skipFrames: a
            }, !1, ".png");
          },
          audio: function audio(t, e, i) {
            return this.game.sound.noAudio ? this : (void 0 === i && (i = !0), "string" == typeof e && (e = [e]), this.addToFileList("audio", t, e, {
              buffer: null,
              autoDecode: i
            }));
          },
          audioSprite: function audioSprite(t, e, i, s, n) {
            return this.game.sound.noAudio ? this : (void 0 === i && (i = null), void 0 === s && (s = null), void 0 === n && (n = !0), this.audio(t, e, n), i ? this.json(t + "-audioatlas", i) : s ? ("string" == typeof s && (s = JSON.parse(s)), this.cache.addJSON(t + "-audioatlas", "", s)) : console.warn("Phaser.Loader.audiosprite - You must specify either a jsonURL or provide a jsonData object"), this);
          },
          audiosprite: function audiosprite(t, e, i, s, n) {
            return this.audioSprite(t, e, i, s, n);
          },
          video: function video(t, e, i, s) {
            return void 0 === i && (i = this.game.device.firefox ? "loadeddata" : "canplaythrough"), void 0 === s && (s = !1), "string" == typeof e && (e = [e]), this.addToFileList("video", t, e, {
              buffer: null,
              asBlob: s,
              loadEvent: i
            });
          },
          tilemap: function tilemap(t, e, i, n) {
            if (void 0 === e && (e = null), void 0 === i && (i = null), void 0 === n && (n = s.Tilemap.CSV), e || i || (e = n === s.Tilemap.CSV ? t + ".csv" : t + ".json"), i) {
              switch (n) {
                case s.Tilemap.CSV:
                  break;

                case s.Tilemap.TILED_JSON:
                  "string" == typeof i && (i = JSON.parse(i));
              }

              this.cache.addTilemap(t, null, i, n);
            } else this.addToFileList("tilemap", t, e, {
              format: n
            });

            return this;
          },
          physics: function physics(t, e, i, n) {
            return void 0 === e && (e = null), void 0 === i && (i = null), void 0 === n && (n = s.Physics.LIME_CORONA_JSON), e || i || (e = t + ".json"), i ? ("string" == typeof i && (i = JSON.parse(i)), this.cache.addPhysicsData(t, null, i, n)) : this.addToFileList("physics", t, e, {
              format: n
            }), this;
          },
          bitmapFont: function bitmapFont(t, e, i, s, n, o) {
            if (void 0 !== e && null !== e || (e = t + ".png"), void 0 === i && (i = null), void 0 === s && (s = null), null === i && null === s && (i = t + ".xml"), void 0 === n && (n = 0), void 0 === o && (o = 0), i) this.addToFileList("bitmapfont", t, e, {
              atlasURL: i,
              xSpacing: n,
              ySpacing: o
            });else if ("string" == typeof s) {
              var r, a;

              try {
                r = JSON.parse(s);
              } catch (t) {
                a = this.parseXml(s);
              }

              if (!a && !r) throw new Error("Phaser.Loader. Invalid Bitmap Font atlas given");
              this.addToFileList("bitmapfont", t, e, {
                atlasURL: null,
                atlasData: r || a,
                atlasType: r ? "json" : "xml",
                xSpacing: n,
                ySpacing: o
              });
            }
            return this;
          },
          atlasJSONArray: function atlasJSONArray(t, e, i, n) {
            return this.atlas(t, e, i, n, s.Loader.TEXTURE_ATLAS_JSON_ARRAY);
          },
          atlasJSONHash: function atlasJSONHash(t, e, i, n) {
            return this.atlas(t, e, i, n, s.Loader.TEXTURE_ATLAS_JSON_HASH);
          },
          atlasXML: function atlasXML(t, e, i, n) {
            return void 0 === i && (i = null), void 0 === n && (n = null), i || n || (i = t + ".xml"), this.atlas(t, e, i, n, s.Loader.TEXTURE_ATLAS_XML_STARLING);
          },
          atlas: function atlas(t, e, i, n, o) {
            if (void 0 !== e && null !== e || (e = t + ".png"), void 0 === i && (i = null), void 0 === n && (n = null), void 0 === o && (o = s.Loader.TEXTURE_ATLAS_JSON_ARRAY), i || n || (i = o === s.Loader.TEXTURE_ATLAS_XML_STARLING ? t + ".xml" : t + ".json"), i) this.addToFileList("textureatlas", t, e, {
              atlasURL: i,
              format: o
            });else {
              switch (o) {
                case s.Loader.TEXTURE_ATLAS_JSON_ARRAY:
                  "string" == typeof n && (n = JSON.parse(n));
                  break;

                case s.Loader.TEXTURE_ATLAS_XML_STARLING:
                  if ("string" == typeof n) {
                    var r = this.parseXml(n);
                    if (!r) throw new Error("Phaser.Loader. Invalid Texture Atlas XML given");
                    n = r;
                  }

              }

              this.addToFileList("textureatlas", t, e, {
                atlasURL: null,
                atlasData: n,
                format: o
              });
            }
            return this;
          },
          withSyncPoint: function withSyncPoint(t, e) {
            this._withSyncPointDepth++;

            try {
              t.call(e || this, this);
            } finally {
              this._withSyncPointDepth--;
            }

            return this;
          },
          addSyncPoint: function addSyncPoint(t, e) {
            var i = this.getAsset(t, e);
            return i && (i.file.syncPoint = !0), this;
          },
          removeFile: function removeFile(t, e) {
            var i = this.getAsset(t, e);
            i && (i.loaded || i.loading || this._fileList.splice(i.index, 1));
          },
          removeAll: function removeAll() {
            this._fileList.length = 0, this._flightQueue.length = 0;
          },
          start: function start() {
            this.isLoading || (this.hasLoaded = !1, this.isLoading = !0, this.updateProgress(), this.processLoadQueue());
          },
          processLoadQueue: function processLoadQueue() {
            if (!this.isLoading) return console.warn("Phaser.Loader - active loading canceled / reset"), void this.finishedLoading(!0);

            for (var t = 0; t < this._flightQueue.length; t++) {
              ((s = this._flightQueue[t]).loaded || s.error) && (this._flightQueue.splice(t, 1), t--, s.loading = !1, s.requestUrl = null, s.requestObject = null, s.error && this.onFileError.dispatch(s.key, s), "packfile" !== s.type ? (this._loadedFileCount++, this.onFileComplete.dispatch(this.progress, s.key, !s.error, this._loadedFileCount, this._totalFileCount)) : "packfile" === s.type && s.error && (this._loadedPackCount++, this.onPackComplete.dispatch(s.key, !s.error, this._loadedPackCount, this._totalPackCount)));
            }

            var e = !1,
                i = this.enableParallel ? Math.max(1, this.maxParallelDownloads) : 1;

            for (t = this._processingHead; t < this._fileList.length; t++) {
              var s;
              if ("packfile" === (s = this._fileList[t]).type && !s.error && s.loaded && t === this._processingHead && (this.processPack(s), this._loadedPackCount++, this.onPackComplete.dispatch(s.key, !s.error, this._loadedPackCount, this._totalPackCount)), s.loaded || s.error ? t === this._processingHead && (this._processingHead = t + 1) : !s.loading && this._flightQueue.length < i && ("packfile" !== s.type || s.data ? e || (this._fileLoadStarted || (this._fileLoadStarted = !0, this.onLoadStart.dispatch()), this._flightQueue.push(s), s.loading = !0, this.onFileStart.dispatch(this.progress, s.key, s.url), this.loadFile(s)) : (this._flightQueue.push(s), s.loading = !0, this.loadFile(s))), !s.loaded && s.syncPoint && (e = !0), this._flightQueue.length >= i || e && this._loadedPackCount === this._totalPackCount) break;
            }

            if (this.updateProgress(), this._processingHead >= this._fileList.length) this.finishedLoading();else if (!this._flightQueue.length) {
              console.warn("Phaser.Loader - aborting: processing queue empty, loading may have stalled");
              var n = this;
              setTimeout(function () {
                n.finishedLoading(!0);
              }, 2e3);
            }
          },
          finishedLoading: function finishedLoading(t) {
            this.hasLoaded || (this.hasLoaded = !0, this.isLoading = !1, t || this._fileLoadStarted || (this._fileLoadStarted = !0, this.onLoadStart.dispatch()), this.game.state.loadUpdate(), this.onBeforeLoadComplete.dispatch(), this.reset(), this.onLoadComplete.dispatch(), this.game.state && this.game.state.loadComplete());
          },
          asyncComplete: function asyncComplete(t, e) {
            void 0 === e && (e = ""), t.loaded = !0, t.error = !!e, e && (t.errorMessage = e, console.warn("Phaser.Loader - " + t.type + "[" + t.key + "]: " + e)), this.processLoadQueue();
          },
          processPack: function processPack(t) {
            var e = t.data[t.key];
            if (e) for (var i = 0; i < e.length; i++) {
              var n = e[i];

              switch (n.type) {
                case "image":
                  this.image(n.key, n.url, n.overwrite);
                  break;

                case "text":
                  this.text(n.key, n.url, n.overwrite);
                  break;

                case "json":
                  this.json(n.key, n.url, n.overwrite);
                  break;

                case "xml":
                  this.xml(n.key, n.url, n.overwrite);
                  break;

                case "script":
                  this.script(n.key, n.url, n.callback, t.callbackContext || this);
                  break;

                case "binary":
                  this.binary(n.key, n.url, n.callback, t.callbackContext || this);
                  break;

                case "spritesheet":
                  this.spritesheet(n.key, n.url, n.frameWidth, n.frameHeight, n.frameMax, n.margin, n.spacing, n.skipFrames);
                  break;

                case "video":
                  this.video(n.key, n.urls);
                  break;

                case "audio":
                  this.audio(n.key, n.urls, n.autoDecode);
                  break;

                case "audiosprite":
                  this.audiosprite(n.key, n.urls, n.jsonURL, n.jsonData, n.autoDecode);
                  break;

                case "tilemap":
                  this.tilemap(n.key, n.url, n.data, s.Tilemap[n.format]);
                  break;

                case "physics":
                  this.physics(n.key, n.url, n.data, s.Loader[n.format]);
                  break;

                case "bitmapFont":
                  this.bitmapFont(n.key, n.textureURL, n.atlasURL, n.atlasData, n.xSpacing, n.ySpacing);
                  break;

                case "atlasJSONArray":
                  this.atlasJSONArray(n.key, n.textureURL, n.atlasURL, n.atlasData);
                  break;

                case "atlasJSONHash":
                  this.atlasJSONHash(n.key, n.textureURL, n.atlasURL, n.atlasData);
                  break;

                case "atlasXML":
                  this.atlasXML(n.key, n.textureURL, n.atlasURL, n.atlasData);
                  break;

                case "atlas":
                  this.atlas(n.key, n.textureURL, n.atlasURL, n.atlasData, s.Loader[n.format]);
                  break;

                case "shader":
                  this.shader(n.key, n.url, n.overwrite);
              }
            } else console.warn("Phaser.Loader - " + t.key + ": pack has data, but not for pack key");
          },
          transformUrl: function transformUrl(t, e) {
            return !!t && (t.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/) ? t : this.baseURL + e.path + t);
          },
          loadFile: function loadFile(t) {
            switch (t.type) {
              case "packfile":
                this.xhrLoad(t, this.transformUrl(t.url, t), "text", this.fileComplete);
                break;

              case "image":
              case "spritesheet":
              case "textureatlas":
              case "bitmapfont":
                this.loadImageTag(t);
                break;

              case "audio":
                t.url = this.getAudioURL(t.url), t.url ? this.game.sound.usingWebAudio ? this.xhrLoad(t, this.transformUrl(t.url, t), "arraybuffer", this.fileComplete) : this.game.sound.usingAudioTag && this.loadAudioTag(t) : this.fileError(t, null, "No supported audio URL specified or device does not have audio playback support");
                break;

              case "video":
                t.url = this.getVideoURL(t.url), t.url ? t.asBlob ? this.xhrLoad(t, this.transformUrl(t.url, t), "blob", this.fileComplete) : this.loadVideoTag(t) : this.fileError(t, null, "No supported video URL specified or device does not have video playback support");
                break;

              case "json":
                this.xhrLoad(t, this.transformUrl(t.url, t), "text", this.jsonLoadComplete);
                break;

              case "xml":
                this.xhrLoad(t, this.transformUrl(t.url, t), "text", this.xmlLoadComplete);
                break;

              case "tilemap":
                t.format === s.Tilemap.TILED_JSON ? this.xhrLoad(t, this.transformUrl(t.url, t), "text", this.jsonLoadComplete) : t.format === s.Tilemap.CSV ? this.xhrLoad(t, this.transformUrl(t.url, t), "text", this.csvLoadComplete) : this.asyncComplete(t, "invalid Tilemap format: " + t.format);
                break;

              case "text":
              case "script":
              case "shader":
              case "physics":
                this.xhrLoad(t, this.transformUrl(t.url, t), "text", this.fileComplete);
                break;

              case "texture":
                "truecolor" === t.key.split("_").pop() ? this.loadImageTag(t) : this.xhrLoad(t, this.transformUrl(t.url, t), "arraybuffer", this.fileComplete);
                break;

              case "binary":
                this.xhrLoad(t, this.transformUrl(t.url, t), "arraybuffer", this.fileComplete);
            }
          },
          loadImageTag: function loadImageTag(t) {
            var e = this;
            t.data = new Image(), t.data.name = t.key, this.crossOrigin && (t.data.crossOrigin = this.crossOrigin), t.data.onload = function () {
              t.data.onload && (t.data.onload = null, t.data.onerror = null, e.fileComplete(t));
            }, t.data.onerror = function () {
              t.data.onload && (t.data.onload = null, t.data.onerror = null, e.fileError(t));
            }, t.data.src = this.transformUrl(t.url, t), !this.game.device.firefox && t.data.complete && t.data.width && t.data.height && (t.data.onload = null, t.data.onerror = null, this.fileComplete(t));
          },
          loadVideoTag: function loadVideoTag(t) {
            var e = this;
            t.data = document.createElement("video"), t.data.name = t.key, t.data.controls = !1, t.data.autoplay = !1;

            var i = function i() {
              t.data.removeEventListener(t.loadEvent, i, !1), t.data.onerror = null, t.data.canplay = !0, s.GAMES[e.game.id].load.fileComplete(t);
            };

            t.data.onerror = function () {
              t.data.removeEventListener(t.loadEvent, i, !1), t.data.onerror = null, t.data.canplay = !1, e.fileError(t);
            }, t.data.addEventListener(t.loadEvent, i, !1), t.data.src = this.transformUrl(t.url, t), t.data.load();
          },
          loadAudioTag: function loadAudioTag(t) {
            var e = this;
            if (this.game.sound.touchLocked) t.data = new Audio(), t.data.name = t.key, t.data.preload = "auto", t.data.src = this.transformUrl(t.url, t), this.fileComplete(t);else {
              t.data = new Audio(), t.data.name = t.key;

              var i = function i() {
                t.data.removeEventListener("canplaythrough", i, !1), t.data.onerror = null, e.fileComplete(t);
              };

              t.data.onerror = function () {
                t.data.removeEventListener("canplaythrough", i, !1), t.data.onerror = null, e.fileError(t);
              }, t.data.preload = "auto", t.data.src = this.transformUrl(t.url, t), t.data.addEventListener("canplaythrough", i, !1), t.data.load();
            }
          },
          xhrLoad: function xhrLoad(t, e, i, s, n) {
            var o = new XMLHttpRequest();
            o.open("GET", e, !0), o.responseType = i, !1 !== this.headers.requestedWith && o.setRequestHeader("X-Requested-With", this.headers.requestedWith), this.headers[t.type] && o.setRequestHeader("Accept", this.headers[t.type]), n = n || this.fileError;
            var r = this;
            o.onload = function () {
              try {
                return 4 === o.readyState && o.status >= 400 && o.status <= 599 ? n.call(r, t, o) : s.call(r, t, o);
              } catch (e) {
                r.hasLoaded ? window.console && console.error(e) : r.asyncComplete(t, e.message || "Exception");
              }
            }, o.onerror = function () {
              try {
                return n.call(r, t, o);
              } catch (e) {
                r.hasLoaded ? window.console && console.error(e) : r.asyncComplete(t, e.message || "Exception");
              }
            }, t.requestObject = o, t.requestUrl = e, o.send();
          },
          getVideoURL: function getVideoURL(t) {
            for (var e = 0; e < t.length; e++) {
              var i,
                  s = t[e];

              if (s.uri) {
                if (i = s.type, s = s.uri, this.game.device.canPlayVideo(i)) return s;
              } else {
                if (0 === s.indexOf("blob:") || 0 === s.indexOf("data:")) return s;
                if (s.indexOf("?") >= 0 && (s = s.substr(0, s.indexOf("?"))), i = s.substr((Math.max(0, s.lastIndexOf(".")) || 1 / 0) + 1).toLowerCase(), this.game.device.canPlayVideo(i)) return t[e];
              }
            }

            return null;
          },
          getAudioURL: function getAudioURL(t) {
            if (this.game.sound.noAudio) return null;

            for (var e = 0; e < t.length; e++) {
              var i,
                  s = t[e];

              if (s.uri) {
                if (i = s.type, s = s.uri, this.game.device.canPlayAudio(i)) return s;
              } else {
                if (0 === s.indexOf("blob:") || 0 === s.indexOf("data:")) return s;
                if (s.indexOf("?") >= 0 && (s = s.substr(0, s.indexOf("?"))), i = s.substr((Math.max(0, s.lastIndexOf(".")) || 1 / 0) + 1).toLowerCase(), this.game.device.canPlayAudio(i)) return t[e];
              }
            }

            return null;
          },
          fileError: function fileError(t, e, i) {
            var s = "error loading asset from URL " + (t.requestUrl || this.transformUrl(t.url, t));
            !i && e && (i = e.status), i && (s = s + " (" + i + ")"), this.asyncComplete(t, s);
          },
          fileComplete: function fileComplete(t, e) {
            var i = !0;

            switch (t.type) {
              case "packfile":
                var n = JSON.parse(e.responseText);
                t.data = n || {};
                break;

              case "texture":
                var o = /\.([^.]+)$/.exec(t.url.split("?", 1)[0])[1].toLowerCase();
                null !== t.data ? this.cache.addCompressedTextureMetaData(t.key, t.url, o, t.data) : this.cache.addCompressedTextureMetaData(t.key, t.url, o, e.response);
                break;

              case "image":
                this.cache.addImage(t.key, t.url, t.data);
                break;

              case "spritesheet":
                this.cache.addSpriteSheet(t.key, t.url, t.data, t.frameWidth, t.frameHeight, t.frameMax, t.margin, t.spacing, t.skipFrames);
                break;

              case "textureatlas":
                if (null == t.atlasURL) this.cache.addTextureAtlas(t.key, t.url, t.data, t.atlasData, t.format);else if (i = !1, t.format === s.Loader.TEXTURE_ATLAS_JSON_ARRAY || t.format === s.Loader.TEXTURE_ATLAS_JSON_HASH || t.format === s.Loader.TEXTURE_ATLAS_JSON_PYXEL) this.xhrLoad(t, this.transformUrl(t.atlasURL, t), "text", this.jsonLoadComplete);else {
                  if (t.format !== s.Loader.TEXTURE_ATLAS_XML_STARLING) throw new Error("Phaser.Loader. Invalid Texture Atlas format: " + t.format);
                  this.xhrLoad(t, this.transformUrl(t.atlasURL, t), "text", this.xmlLoadComplete);
                }
                break;

              case "bitmapfont":
                t.atlasURL ? (i = !1, this.xhrLoad(t, this.transformUrl(t.atlasURL, t), "text", function (t, e) {
                  var i;

                  try {
                    i = JSON.parse(e.responseText);
                  } catch (t) {}

                  i ? (t.atlasType = "json", this.jsonLoadComplete(t, e)) : (t.atlasType = "xml", this.xmlLoadComplete(t, e));
                })) : this.cache.addBitmapFont(t.key, t.url, t.data, t.atlasData, t.atlasType, t.xSpacing, t.ySpacing);
                break;

              case "video":
                if (t.asBlob) try {
                  t.data = e.response;
                } catch (e) {
                  throw new Error("Phaser.Loader. Unable to parse video file as Blob: " + t.key);
                }
                this.cache.addVideo(t.key, t.url, t.data, t.asBlob);
                break;

              case "audio":
                this.game.sound.usingWebAudio ? (t.data = e.response, this.cache.addSound(t.key, t.url, t.data, !0, !1), t.autoDecode && this.game.sound.decode(t.key)) : this.cache.addSound(t.key, t.url, t.data, !1, !0);
                break;

              case "text":
                t.data = e.responseText, this.cache.addText(t.key, t.url, t.data);
                break;

              case "shader":
                t.data = e.responseText, this.cache.addShader(t.key, t.url, t.data);
                break;

              case "physics":
                n = JSON.parse(e.responseText);
                this.cache.addPhysicsData(t.key, t.url, n, t.format);
                break;

              case "script":
                t.data = document.createElement("script"), t.data.language = "javascript", t.data.type = "text/javascript", t.data.defer = !1, t.data.text = e.responseText, document.head.appendChild(t.data), t.callback && (t.data = t.callback.call(t.callbackContext, t.key, e.responseText));
                break;

              case "binary":
                t.callback ? t.data = t.callback.call(t.callbackContext, t.key, e.response) : t.data = e.response, this.cache.addBinary(t.key, t.data);
            }

            i && this.asyncComplete(t);
          },
          jsonLoadComplete: function jsonLoadComplete(t, e) {
            var i = JSON.parse(e.responseText);
            "tilemap" === t.type ? this.cache.addTilemap(t.key, t.url, i, t.format) : "bitmapfont" === t.type ? this.cache.addBitmapFont(t.key, t.url, t.data, i, t.atlasType, t.xSpacing, t.ySpacing) : "json" === t.type ? this.cache.addJSON(t.key, t.url, i) : this.cache.addTextureAtlas(t.key, t.url, t.data, i, t.format), this.asyncComplete(t);
          },
          csvLoadComplete: function csvLoadComplete(t, e) {
            var i = e.responseText;
            this.cache.addTilemap(t.key, t.url, i, t.format), this.asyncComplete(t);
          },
          xmlLoadComplete: function xmlLoadComplete(t, e) {
            var i = e.responseText,
                s = this.parseXml(i);

            if (!s) {
              var n = e.responseType || e.contentType;
              return console.warn("Phaser.Loader - " + t.key + ": invalid XML (" + n + ")"), void this.asyncComplete(t, "invalid XML");
            }

            "bitmapfont" === t.type ? this.cache.addBitmapFont(t.key, t.url, t.data, s, t.atlasType, t.xSpacing, t.ySpacing) : "textureatlas" === t.type ? this.cache.addTextureAtlas(t.key, t.url, t.data, s, t.format) : "xml" === t.type && this.cache.addXML(t.key, t.url, s), this.asyncComplete(t);
          },
          parseXml: function parseXml(t) {
            var e;

            try {
              if (window.DOMParser) e = new DOMParser().parseFromString(t, "text/xml");else (e = new ActiveXObject("Microsoft.XMLDOM")).async = "false", e.loadXML(t);
            } catch (t) {
              e = null;
            }

            return e && e.documentElement && !e.getElementsByTagName("parsererror").length ? e : null;
          },
          updateProgress: function updateProgress() {
            this.preloadSprite && (0 === this.preloadSprite.direction ? this.preloadSprite.rect.width = Math.floor(this.preloadSprite.width / 100 * this.progress) : this.preloadSprite.rect.height = Math.floor(this.preloadSprite.height / 100 * this.progress), this.preloadSprite.sprite ? this.preloadSprite.sprite.updateCrop() : this.preloadSprite = null);
          },
          totalLoadedFiles: function totalLoadedFiles() {
            return this._loadedFileCount;
          },
          totalQueuedFiles: function totalQueuedFiles() {
            return this._totalFileCount - this._loadedFileCount;
          },
          totalLoadedPacks: function totalLoadedPacks() {
            return this._totalPackCount;
          },
          totalQueuedPacks: function totalQueuedPacks() {
            return this._totalPackCount - this._loadedPackCount;
          }
        }, Object.defineProperty(s.Loader.prototype, "progressFloat", {
          get: function get() {
            var t = this._loadedFileCount / this._totalFileCount * 100;
            return s.Math.clamp(t || 0, 0, 100);
          }
        }), Object.defineProperty(s.Loader.prototype, "progress", {
          get: function get() {
            return Math.round(this.progressFloat);
          }
        }), s.Loader.prototype.constructor = s.Loader,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.LoaderParser = {
          bitmapFont: function bitmapFont(t, e, i, s, n, o) {
            return this.xmlBitmapFont(t, e, i, s, n, o);
          },
          xmlBitmapFont: function xmlBitmapFont(t, e, i, s, n, o) {
            null == o && (o = 1);
            var r = {},
                a = t.getElementsByTagName("info")[0],
                h = t.getElementsByTagName("common")[0];
            r.font = a.getAttribute("face"), r.size = parseInt(a.getAttribute("size"), 10), r.lineHeight = parseInt(h.getAttribute("lineHeight"), 10) + s, r.chars = {};

            for (var l = t.getElementsByTagName("char"), c = n ? n.x : 0, u = n ? n.y : 0, d = 0; d < l.length; d++) {
              var p = parseInt(l[d].getAttribute("id"), 10);
              r.chars[p] = {
                x: c + parseInt(l[d].getAttribute("x"), 10),
                y: u + parseInt(l[d].getAttribute("y"), 10),
                width: parseInt(l[d].getAttribute("width"), 10),
                height: parseInt(l[d].getAttribute("height"), 10),
                xOffset: parseInt(l[d].getAttribute("xoffset"), 10) / o,
                yOffset: parseInt(l[d].getAttribute("yoffset"), 10) / o,
                xAdvance: (parseInt(l[d].getAttribute("xadvance"), 10) + i) / o,
                kerning: {}
              };
            }

            var f = t.getElementsByTagName("kerning");

            for (d = 0; d < f.length; d++) {
              var g = parseInt(f[d].getAttribute("first"), 10),
                  m = parseInt(f[d].getAttribute("second"), 10),
                  y = parseInt(f[d].getAttribute("amount"), 10) / o;
              r.chars[m].kerning[g] = y;
            }

            return this.finalizeBitmapFont(e, r);
          },
          jsonBitmapFont: function jsonBitmapFont(t, e, i, s, n, o) {
            null == o && (o = 1);
            var r = {
              font: t.font.info._face,
              size: parseInt(t.font.info._size, 10),
              lineHeight: parseInt(t.font.common._lineHeight, 10) + s,
              chars: {}
            },
                a = n ? n.x : 0,
                h = n ? n.y : 0;
            return t.font.chars.char.forEach(function (t) {
              var e = parseInt(t._id, 10);
              r.chars[e] = {
                x: a + parseInt(t._x, 10),
                y: h + parseInt(t._y, 10),
                width: parseInt(t._width, 10),
                height: parseInt(t._height, 10),
                xOffset: parseInt(t._xoffset, 10) / o,
                yOffset: parseInt(t._yoffset, 10) / o,
                xAdvance: (parseInt(t._xadvance, 10) + i) / o,
                kerning: {}
              };
            }), t.font.kernings && t.font.kernings.kerning && t.font.kernings.kerning.forEach(function (t) {
              r.chars[t._second].kerning[t._first] = parseInt(t._amount, 10) / o;
            }), this.finalizeBitmapFont(e, r);
          },
          finalizeBitmapFont: function finalizeBitmapFont(t, e) {
            return Object.keys(e.chars).forEach(function (i) {
              var n = e.chars[i];
              n.texture = new PIXI.Texture(t, new s.Rectangle(n.x, n.y, n.width, n.height));
            }), e;
          },
          pvr: function pvr(t) {
            var e,
                i = new Uint32Array(t.slice(0, 52)),
                s = new Uint8Array(t),
                n = null,
                o = i[3] << 32 | i[2],
                r = 0;

            if (55727696 === i[0] && [0, 1, 2, 3, 6, 7, 9, 11].indexOf(o) >= 0) {
              switch (o >= 0 && o <= 3 ? e = "PVRTC" : o >= 7 && o <= 11 ? e = "S3TC" : 6 === o && (e = "ETC1"), o) {
                case 0:
                  r = 35841;
                  break;

                case 1:
                  r = 35843;
                  break;

                case 2:
                  r = 35840;
                  break;

                case 3:
                  r = 35842;
                  break;

                case 6:
                  r = 36196;
                  break;

                case 7:
                  r = 33777;
                  break;

                case 9:
                  r = 33778;
                  break;

                case 11:
                  r = 33779;
                  break;

                default:
                  r = -1;
              }

              n = {
                complete: !0,
                fileFormat: "PVR",
                compressionAlgorithm: e,
                flags: i[1],
                pixelFormat: o,
                colorSpace: i[4],
                channelType: i[5],
                height: i[6],
                width: i[7],
                depth: i[8],
                numberOfSurfaces: i[9],
                numberOfFaces: i[10],
                numberOfMipmaps: i[11],
                metaDataSize: i[12],
                textureData: s.subarray(52 + i[12], s.byteLength),
                glExtensionFormat: r
              };
            }

            return n;
          },
          dds: function dds(t) {
            var e = new Uint8Array(t),
                i = new Uint32Array(t),
                s = null;
            return 68 === e[0] && 68 === e[1] && 83 === e[2] && 32 === e[3] && "DX10" === (s = {
              complete: !0,
              fileFormat: "DDS",
              compressionAlgorithm: "S3TC",
              size: i[1],
              flags: i[2],
              height: i[3],
              width: i[4],
              pitch: i[5],
              depth: i[6],
              mipmapCount: i[7],
              formatSize: i[19],
              formatFlag: i[19],
              formatFourCC: [String.fromCharCode(e[84]), String.fromCharCode(e[85]), String.fromCharCode(e[86]), String.fromCharCode(e[87])].join(""),
              formatBitCount: i[21],
              formatRBitMask: i[22],
              formatGBitMask: i[23],
              formatBBitMask: i[24],
              formatABitMask: i[25],
              caps1: i[26],
              caps2: i[27],
              caps3: i[28],
              caps4: i[29],
              reserved2: i[30],
              DXGIFormat: null,
              resourceDimension: null,
              miscFlag: null,
              arraySize: null,
              textureData: e.subarray(i[1] + 4, e.byteLength)
            }).formatFourCC && (s.DXGIFormat = i[31], s.resourceDimension = i[32], s.miscFlag = i[33], s.arraySize = i[34], s.miscFlag = i[35]), s;
          },
          ktx: function ktx(t) {
            var e = new Uint8Array(t),
                i = new Uint32Array(t),
                s = null,
                n = 16 + i[15] / 4 | 0,
                o = i[n],
                r = i[7],
                a = 0;

            if (171 === e[0] && 75 === e[1] && 84 === e[2] && 88 === e[3] && 32 === e[4] && 49 === e[5] && 49 === e[6] && 187 === e[7] && 13 === e[8] && 10 === e[9] && 26 === e[10] && 10 === e[11] && [36196, 35840, 35841, 35842, 35843, 33776, 33777, 33778, 33779].indexOf(r) >= 0) {
              switch (r) {
                case 36196:
                  a = "ETC1";
                  break;

                case 35840:
                case 35841:
                case 35842:
                case 35843:
                  a = "PVRTC";
                  break;

                case 33776:
                case 33777:
                case 33778:
                case 33779:
                  a = "S3TC";
              }

              s = {
                complete: !0,
                fileFormat: "KTX",
                compressionAlgorithm: a,
                endianness: i[3],
                glType: i[4],
                glTypeSize: i[5],
                glFormat: i[6],
                glInternalFormat: i[7],
                glBaseInternalFormat: i[8],
                width: i[9],
                height: i[10],
                pixelDepth: i[11],
                numberOfArrayElements: i[12],
                numberOfFaces: i[13],
                numberOfMipmapLevels: i[14],
                bytesOfKeyValueData: i[15],
                keyAndValueByteSize: i[16],
                imageSize: o,
                textureData: e.subarray(4 * (n + 1), o + 100)
              };
            }

            return s;
          },
          pkm: function pkm(t) {
            var e = new Uint8Array(t),
                i = null;
            return 80 === e[0] && 75 === e[1] && 77 === e[2] && 32 === e[3] && (i = {
              complete: !0,
              fileFormat: "PKM",
              compressionAlgorithm: "ETC1",
              format: 65535 & (e[6] << 8 | e[7]),
              width: 65535 & (e[8] << 8 | e[9]),
              height: 65535 & (e[10] << 8 | e[11]),
              originalWidth: 65535 & (e[12] << 8 | e[13]),
              originalHeight: 65535 & (e[14] << 8 | e[15]),
              textureData: e.subarray(16, e.length)
            }), i;
          }
        },
        /**
         * @author       Jeremy Dowell <jeremy@codevinsky.com>
         * @author       Richard Davey <rich@photonstorm.com>
         * @copyright    2016 Photon Storm Ltd.
         * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
         */
        s.AudioSprite = function (t, e) {
          for (var i in this.game = t, this.key = e, this.config = this.game.cache.getJSON(e + "-audioatlas"), this.autoplayKey = null, this.autoplay = !1, this.sounds = {}, this.config.spritemap) {
            var s = this.config.spritemap[i],
                n = this.game.add.sound(this.key);
            n.addMarker(i, s.start, s.end - s.start, null, s.loop), this.sounds[i] = n;
          }

          this.config.autoplay && (this.autoplayKey = this.config.autoplay, this.play(this.autoplayKey), this.autoplay = this.sounds[this.autoplayKey]);
        }, s.AudioSprite.prototype = {
          play: function play(t, e) {
            return void 0 === e && (e = 1), this.sounds[t].play(t, null, e);
          },
          stop: function stop(t) {
            if (t) this.sounds[t].stop();else for (var e in this.sounds) {
              this.sounds[e].stop();
            }
          },
          get: function get(t) {
            return this.sounds[t];
          }
        }, s.AudioSprite.prototype.constructor = s.AudioSprite,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Sound = function (t, e, i, n, o) {
          void 0 === i && (i = 1), void 0 === n && (n = !1), void 0 === o && (o = t.sound.connectToMaster), this.game = t, this.name = e, this.key = e, this.loop = n, this.markers = {}, this.context = null, this.autoplay = !1, this.totalDuration = 0, this.startTime = 0, this.currentTime = 0, this.duration = 0, this.durationMS = 0, this.position = 0, this.stopTime = 0, this.paused = !1, this.pausedPosition = 0, this.pausedTime = 0, this.isPlaying = !1, this.currentMarker = "", this.fadeTween = null, this.pendingPlayback = !1, this.override = !1, this.allowMultiple = !1, this.playOnce = !1, this.usingWebAudio = this.game.sound.usingWebAudio, this.usingAudioTag = this.game.sound.usingAudioTag, this.externalNode = null, this.masterGainNode = null, this.gainNode = null, this._sound = null, this._globalVolume = 1, this._markedToDelete = !1, this._removeFromSoundManager = !1, this._sourceId = 0, this.usingWebAudio ? (this.context = this.game.sound.context, this.masterGainNode = this.game.sound.masterGain, void 0 === this.context.createGain ? this.gainNode = this.context.createGainNode() : this.gainNode = this.context.createGain(), this.gainNode.gain.value = i, o && this.gainNode.connect(this.masterGainNode)) : this.usingAudioTag && (this.game.cache.getSound(e) && this.game.cache.isSoundReady(e) ? (this._sound = this.game.cache.getSoundData(e), this.totalDuration = 0, this._sound.duration && (this.totalDuration = this._sound.duration)) : this.game.cache.onSoundUnlock.add(this.soundHasUnlocked, this)), this.onDecoded = new s.Signal(), this.onPlay = new s.Signal(), this.onPause = new s.Signal(), this.onResume = new s.Signal(), this.onLoop = new s.Signal(), this.onStop = new s.Signal(), this.onMute = new s.Signal(), this.onMarkerComplete = new s.Signal(), this.onFadeComplete = new s.Signal(), this._volume = i, this._buffer = null, this._muted = !1, this._tempMarker = 0, this._tempPosition = 0, this._tempVolume = 0, this._tempPause = 0, this._muteVolume = 0, this._tempLoop = 0, this._paused = !1, this._onDecodedEventDispatched = !1;
        }, s.Sound.prototype = {
          soundHasUnlocked: function soundHasUnlocked(t) {
            t === this.key && (this._sound = this.game.cache.getSoundData(this.key), this.totalDuration = this._sound.duration);
          },
          addMarker: function addMarker(t, e, i, s, n) {
            void 0 !== i && null !== i || (i = 1), void 0 !== s && null !== s || (s = 1), void 0 === n && (n = !1), this.markers[t] = {
              name: t,
              start: e,
              stop: e + i,
              volume: s,
              duration: i,
              durationMS: 1e3 * i,
              loop: n
            };
          },
          removeMarker: function removeMarker(t) {
            delete this.markers[t];
          },
          onEndedHandler: function onEndedHandler() {
            this._removeOnEndedHandler(), this.isPlaying = !1, this.currentTime = this.durationMS, this.stop(), this.playOnce && (this._markedToDelete = !0, this._removeFromSoundManager = !0), this._markedToDelete && (this._disconnectSource(), this._removeFromSoundManager ? this.game.sound.remove(this) : (this.markers = {}, this.context = null, this._buffer = null, this.externalNode = null, this.onDecoded.dispose(), this.onPlay.dispose(), this.onPause.dispose(), this.onResume.dispose(), this.onLoop.dispose(), this.onStop.dispose(), this.onMute.dispose(), this.onMarkerComplete.dispose()));
          },
          update: function update() {
            this.game.cache.checkSoundKey(this.key) ? (this.isDecoded && !this._onDecodedEventDispatched && (this.onDecoded.dispatch(this), this._onDecodedEventDispatched = !0), this.pendingPlayback && this.game.cache.isSoundReady(this.key) && (this.pendingPlayback = !1, this.play(this._tempMarker, this._tempPosition, this._tempVolume, this._tempLoop)), this.isPlaying && (this.currentTime = this.game.time.time - this.startTime, this.currentTime >= this.durationMS && (this.usingWebAudio ? this.loop ? (this.onLoop.dispatch(this), this.isPlaying = !1, "" === this.currentMarker ? (this.currentTime = 0, this.startTime = this.game.time.time, this.isPlaying = !0) : (this.onMarkerComplete.dispatch(this.currentMarker, this), this.play(this.currentMarker, 0, this.volume, !0, !0))) : "" !== this.currentMarker && this.stop() : this.loop ? (this.onLoop.dispatch(this), "" === this.currentMarker && (this.currentTime = 0, this.startTime = this.game.time.time), this.isPlaying = !1, this.play(this.currentMarker, 0, this.volume, !0, !0)) : this.stop()))) : this.destroy();
          },
          loopFull: function loopFull(t) {
            return this.play(null, 0, t, !0);
          },
          play: function play(t, e, i, s, n) {
            if (void 0 !== t && !1 !== t && null !== t || (t = ""), void 0 === n && (n = !0), this.isPlaying && !this.allowMultiple && !n && !this.override) return this;
            if (this._sound && this.isPlaying && !this.allowMultiple && (this.override || n) && (this.usingWebAudio ? this._stopSourceAndDisconnect() : this.usingAudioTag && (this._sound.pause(), this._sound.currentTime = 0), this.isPlaying = !1), "" === t && Object.keys(this.markers).length > 0) return this;

            if ("" !== t) {
              if (!this.markers[t]) return console.warn("Phaser.Sound.play: audio marker " + t + " doesn't exist"), this;
              this.currentMarker = t, this.position = this.markers[t].start, this.volume = this.markers[t].volume, this.loop = this.markers[t].loop, this.duration = this.markers[t].duration, this.durationMS = this.markers[t].durationMS, void 0 !== i && (this.volume = i), void 0 !== s && (this.loop = s), this._tempMarker = t, this._tempPosition = this.position, this._tempVolume = this.volume, this._tempLoop = this.loop;
            } else e = e || 0, void 0 === i && (i = this._volume), void 0 === s && (s = this.loop), this.position = Math.max(0, e), this.volume = i, this.loop = s, this.duration = 0, this.durationMS = 0, this._tempMarker = t, this._tempPosition = e, this._tempVolume = i, this._tempLoop = s;

            return this.usingWebAudio ? this.game.cache.isSoundDecoded(this.key) ? (this._createSourceAndConnect(), this.loop && "" === t && (this._sound.loop = !0), this.loop || "" !== t || this._addOnEndedHandler(), this.totalDuration = this._sound.buffer.duration, 0 === this.duration && (this.duration = this.totalDuration, this.durationMS = Math.ceil(1e3 * this.totalDuration)), this.loop && "" === t ? this._startSource(0, 0) : this._startSource(0, this.position, this.duration), this.isPlaying = !0, this.paused = !1, this.startTime = this.game.time.time, this.currentTime = 0, this.stopTime = this.startTime + this.durationMS, this.onPlay.dispatch(this)) : (this.pendingPlayback = !0, this.game.cache.getSound(this.key) && !1 === this.game.cache.getSound(this.key).isDecoding && this.game.sound.decode(this.key, this)) : this.game.cache.getSound(this.key) && this.game.cache.getSound(this.key).locked ? (this.game.cache.reloadSound(this.key), this.pendingPlayback = !0) : this._sound && (this.game.device.cocoonJS || 4 === this._sound.readyState) ? (this._sound.play(), this._sound.loop = this.loop, this.totalDuration = this._sound.duration, 0 === this.duration && (this.duration = this.totalDuration, this.durationMS = 1e3 * this.totalDuration), this._sound.currentTime = this.position, this._sound.muted = this._muted, this._muted || this.game.sound.mute ? this._sound.volume = 0 : this._sound.volume = this._volume, this.isPlaying = !0, this.paused = !1, this.startTime = this.game.time.time, this.currentTime = 0, this.stopTime = this.startTime + this.durationMS, this.onPlay.dispatch(this)) : this.pendingPlayback = !0, this.playOnce && (this.loop && console.warn("Phaser.Sound.play: audio clip " + this.name + " cannot be deleted while looping."), this._markedToDelete = !0, this._removeFromSoundManager = !0), this;
          },
          restart: function restart(t, e, i, s) {
            t = t || "", e = e || 0, i = i || 1, void 0 === s && (s = !1), this.play(t, e, i, s, !0);
          },
          pause: function pause() {
            this.isPlaying && (this.paused = !0, this.pausedPosition = this.currentTime, this.pausedTime = this.game.time.time, this._tempPause = this._sound.currentTime, this.onPause.dispatch(this), this.stop());
          },
          resume: function resume() {
            if (this.paused) {
              if (this.usingWebAudio) {
                var t = Math.max(0, this.position + this.pausedPosition / 1e3);
                this._createSourceAndConnect(), "" === this.currentMarker && (this.loop ? this._sound.loop = !0 : this._addOnEndedHandler());
                var e = this.duration - this.pausedPosition / 1e3;
                this.loop && "" === this.currentMarker ? this._startSource(0, t) : this._startSource(0, t, e);
              } else this._sound.currentTime = this._tempPause, this._sound.play();

              this.isPlaying = !0, this.paused = !1, this.startTime += this.game.time.time - this.pausedTime, this.onResume.dispatch(this);
            }
          },
          stop: function stop() {
            if (this.isPlaying && this._sound && (this.usingWebAudio ? this._stopSourceAndDisconnect() : this.usingAudioTag && (this._sound.pause(), this._sound.currentTime = 0)), this.pendingPlayback = !1, this.isPlaying = !1, !this.paused) {
              var t = this.currentMarker;
              "" !== this.currentMarker && this.onMarkerComplete.dispatch(this.currentMarker, this), this.currentMarker = "", null !== this.fadeTween && this.fadeTween.stop(), this.onStop.dispatch(this, t);
            }
          },
          fadeIn: function fadeIn(t, e, i) {
            void 0 === e && (e = !1), void 0 === i && (i = this.currentMarker), this.paused || (this.play(i, 0, 0, e), this.fadeTo(t, 1));
          },
          fadeOut: function fadeOut(t) {
            this.fadeTo(t, 0);
          },
          fadeTo: function fadeTo(t, e) {
            this.isPlaying && !this.paused && e !== this.volume && (void 0 === t && (t = 1e3), void 0 !== e ? (this.fadeTween = this.game.add.tween(this).to({
              volume: e
            }, t, s.Easing.Linear.None, !0), this.fadeTween.onComplete.add(this.fadeComplete, this)) : console.warn("Phaser.Sound.fadeTo: No Volume Specified."));
          },
          fadeComplete: function fadeComplete() {
            this.onFadeComplete.dispatch(this, this.volume), 0 === this.volume && this.stop();
          },
          updateGlobalVolume: function updateGlobalVolume(t) {
            this.usingAudioTag && this._sound && (this._globalVolume = t, this._sound.volume = this._globalVolume * this._volume);
          },
          destroy: function destroy(t) {
            void 0 === t && (t = !0), this._markedToDelete = !0, this._removeFromSoundManager = t, this.stop(), t ? this.game.sound.remove(this) : (this.markers = {}, this.context = null, this._buffer = null, this.externalNode = null, this.onDecoded.dispose(), this.onPlay.dispose(), this.onPause.dispose(), this.onResume.dispose(), this.onLoop.dispose(), this.onStop.dispose(), this.onMute.dispose(), this.onMarkerComplete.dispose());
          },
          _createSourceAndConnect: function _createSourceAndConnect() {
            this._sound && !this.allowMultiple && console.warn("Phaser.Sound: Audio source already exists"), this._sound = this.context.createBufferSource(), this._sourceId++, this.externalNode ? this._sound.connect(this.externalNode) : this._sound.connect(this.gainNode), this._buffer = this.game.cache.getSoundData(this.key), this._sound.buffer = this._buffer;
          },
          _disconnectSource: function _disconnectSource() {
            this.externalNode ? this._sound.disconnect(this.externalNode) : this.gainNode && this._sound.disconnect(this.gainNode);
          },
          _startSource: function _startSource(t, e, i) {
            t || (t = 0), void 0 === this._sound.start ? this._sound.noteGrainOn(t, e, i) : this._sound.start(t, e, i);
          },
          _stopSourceAndDisconnect: function _stopSourceAndDisconnect() {
            if (this._removeOnEndedHandler(), void 0 === this._sound.stop) this._sound.noteOff(0);else try {
              this._sound.stop(0);
            } catch (t) {}
            this._disconnectSource(), this._sound = null;
          },
          _addOnEndedHandler: function _addOnEndedHandler() {
            this._sound.onended = this.onEndedHandler.bind(this);
          },
          _removeOnEndedHandler: function _removeOnEndedHandler() {
            this._sound.onended = null;
          }
        }, s.Sound.prototype.constructor = s.Sound, Object.defineProperty(s.Sound.prototype, "isDecoding", {
          get: function get() {
            return this.game.cache.getSound(this.key).isDecoding;
          }
        }), Object.defineProperty(s.Sound.prototype, "isDecoded", {
          get: function get() {
            return this.game.cache.isSoundDecoded(this.key);
          }
        }), Object.defineProperty(s.Sound.prototype, "mute", {
          get: function get() {
            return this._muted || this.game.sound.mute;
          },
          set: function set(t) {
            (t = t || !1) !== this._muted && (t ? (this._muted = !0, this._muteVolume = this._tempVolume, this.usingWebAudio ? this.gainNode.gain.value = 0 : this.usingAudioTag && this._sound && (this._sound.volume = 0)) : (this._muted = !1, this.usingWebAudio ? this.gainNode.gain.value = this._muteVolume : this.usingAudioTag && this._sound && (this._sound.volume = this._muteVolume)), this.onMute.dispatch(this));
          }
        }), Object.defineProperty(s.Sound.prototype, "volume", {
          get: function get() {
            return this._volume;
          },
          set: function set(t) {
            this.usingAudioTag && (t = this.game.math.clamp(t, 0, 1)), this._muted ? this._muteVolume = t : (this._tempVolume = t, this._volume = t, this.usingWebAudio ? this.gainNode.gain.value = t : this.usingAudioTag && this._sound && (this._sound.volume = this._globalVolume * t));
          }
        }), Object.defineProperty(s.Sound.prototype, "sourceId", {
          get: function get() {
            return this._sound ? this._sourceId : null;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.SoundManager = function (t) {
          this.game = t, this.onSoundDecode = new s.Signal(), this.onVolumeChange = new s.Signal(), this.onMute = new s.Signal(), this.onUnMute = new s.Signal(), this.onTouchUnlock = new s.Signal(), this.context = null, this.usingWebAudio = !1, this.usingAudioTag = !1, this.noAudio = !1, this.connectToMaster = !0, this.touchLocked = !1, this.channels = 32, this.muteOnPause = !0, this._codeMuted = !1, this._muted = !1, this._unlockSource = null, this._volume = 1, this._sounds = [], this._watchList = new s.ArraySet(), this._watching = !1, this._watchCallback = null, this._watchContext = null, this._resumeWebAudioOnClick = this._resumeWebAudioOnClick.bind(this);
        }, s.SoundManager.prototype = {
          boot: function boot() {
            var t = this.game.device,
                e = window.PhaserGlobal;

            if (t.iOS && !1 === t.webAudio && (this.channels = 1), e) {
              if (!0 === e.disableAudio) return this.noAudio = !0, void (this.touchLocked = !1);
              if (!0 === e.disableWebAudio) return this.usingAudioTag = !0, void (this.touchLocked = !1);
            }

            if (e && e.audioContext) this.context = e.audioContext;else {
              var i = window.AudioContext || window.webkitAudioContext;
              if (i) try {
                this.context = new i();
              } catch (t) {
                this.context = null, this.usingWebAudio = !1, this.touchLocked = !1, console.warn(t);
              }
            }

            if (null === this.context) {
              if (void 0 === window.Audio) return void (this.noAudio = !0);
              this.usingAudioTag = !0;
            } else this.usingWebAudio = !0, void 0 === this.context.createGain ? this.masterGain = this.context.createGainNode() : this.masterGain = this.context.createGain(), this.masterGain.gain.value = 1, this.masterGain.connect(this.context.destination), "suspended" === this.context.state && this.game.canvas.addEventListener("click", this._resumeWebAudioOnClick);

            this.noAudio || t.needsTouchUnlock() && this.setTouchLock(), this.usingWebAudio && t.chrome && t.chromeVersion <= 65 && console.log('A "GainNode.gain.value setter smoothing is deprecated" notice in Chrome is normal. <https://github.com/photonstorm/phaser-ce/issues/385>');
          },
          setTouchLock: function setTouchLock() {
            this.noAudio || window.PhaserGlobal && !0 === window.PhaserGlobal.disableAudio || (this.game.input.addTouchLockCallback(this.unlock, this, !0), this.touchLocked = !0);
          },
          setTouchUnlock: function setTouchUnlock() {
            this.touchLocked = !1, this._unlockSource = null, this.onTouchUnlock.dispatch();
          },
          resumeWebAudio: function resumeWebAudio() {
            if (this.usingWebAudio && "suspended" === this.context.state) return this.context.resume();
          },
          unlock: function unlock() {
            if (this.noAudio || !this.touchLocked || null !== this._unlockSource) return !0;
            if (this.usingAudioTag) this.setTouchUnlock();else if (this.usingWebAudio) {
              var t = this.context.createBuffer(1, 1, 22050);
              this._unlockSource = this.context.createBufferSource(), this._unlockSource.buffer = t, this._unlockSource.connect(this.context.destination);
              var e = this;
              this._unlockSource.onended = function () {
                e.setTouchUnlock(), e.resumeWebAudio();
              }, void 0 === this._unlockSource.start ? this._unlockSource.noteOn(0) : this._unlockSource.start(0), this.resumeWebAudio();
            }
            return !0;
          },
          stopAll: function stopAll() {
            if (!this.noAudio) for (var t = 0; t < this._sounds.length; t++) {
              this._sounds[t] && this._sounds[t].stop();
            }
          },
          pauseAll: function pauseAll() {
            if (!this.noAudio) for (var t = 0; t < this._sounds.length; t++) {
              this._sounds[t] && this._sounds[t].pause();
            }
          },
          resumeAll: function resumeAll() {
            if (!this.noAudio) for (var t = 0; t < this._sounds.length; t++) {
              this._sounds[t] && this._sounds[t].resume();
            }
          },
          decode: function decode(t, e) {
            e = e || null;
            var i = this.game.cache.getSoundData(t);

            if (i && !1 === this.game.cache.isSoundDecoded(t)) {
              this.game.cache.updateSound(t, "isDecoding", !0);
              var s = this;

              try {
                this.context.decodeAudioData(i, function (i) {
                  i && (s.game.cache.decodedSound(t, i), s.onSoundDecode.dispatch(t, e));
                });
              } catch (t) {}
            }
          },
          setDecodedCallback: function setDecodedCallback(t, e, i) {
            "string" == typeof t && (t = [t]), this._watchList.reset();

            for (var n = 0; n < t.length; n++) {
              t[n] instanceof s.Sound ? this.game.cache.isSoundDecoded(t[n].key) || this._watchList.add(t[n].key) : this.game.cache.isSoundDecoded(t[n]) || this._watchList.add(t[n]);
            }

            0 === this._watchList.total ? (this._watching = !1, e.call(i)) : (this._watching = !0, this._watchCallback = e, this._watchContext = i);
          },
          update: function update() {
            if (!this.noAudio) {
              for (var t = 0; t < this._sounds.length; t++) {
                this._sounds[t].update();
              }

              if (this._watching) {
                for (var e = this._watchList.first; e;) {
                  this.game.cache.isSoundDecoded(e) && this._watchList.remove(e), e = this._watchList.next;
                }

                0 === this._watchList.total && (this._watching = !1, this._watchCallback.call(this._watchContext));
              }
            }
          },
          add: function add(t, e, i, n) {
            void 0 === e && (e = 1), void 0 === i && (i = !1), void 0 === n && (n = this.connectToMaster);
            var o = new s.Sound(this.game, t, e, i, n);
            return this._sounds.push(o), o;
          },
          addSprite: function addSprite(t) {
            return new s.AudioSprite(this.game, t);
          },
          remove: function remove(t) {
            for (var e = this._sounds.length; e--;) {
              if (this._sounds[e] === t) return this._sounds[e].destroy(!1), this._sounds.splice(e, 1), !0;
            }

            return !1;
          },
          removeAll: function removeAll() {
            this.stopAll();

            for (var t = 0; t < this._sounds.length; t++) {
              this._sounds[t] && this._sounds[t].destroy();
            }

            this._sounds.length = 0;
          },
          removeByKey: function removeByKey(t) {
            for (var e = this._sounds.length, i = 0; e--;) {
              this._sounds[e].key === t && (this._sounds[e].destroy(!1), this._sounds.splice(e, 1), i++);
            }

            return i;
          },
          play: function play(t, e, i) {
            if (!this.noAudio) {
              var s = this.add(t, e, i);
              return s.play(), s;
            }
          },
          setMute: function setMute() {
            if (!this._muted) {
              this._muted = !0, this.usingWebAudio && (this._muteVolume = this.masterGain.gain.value, this.masterGain.gain.value = 0);

              for (var t = 0; t < this._sounds.length; t++) {
                this._sounds[t].usingAudioTag && (this._sounds[t].mute = !0);
              }

              this.onMute.dispatch();
            }
          },
          unsetMute: function unsetMute() {
            if (this._muted && !this._codeMuted) {
              this._muted = !1, this.usingWebAudio && (this.masterGain.gain.value = this._muteVolume);

              for (var t = 0; t < this._sounds.length; t++) {
                this._sounds[t].usingAudioTag && (this._sounds[t].mute = !1);
              }

              this.onUnMute.dispatch();
            }
          },
          destroy: function destroy() {
            this.removeAll(), this.onSoundDecode.dispose(), this.game.canvas.removeEventListener("click", this._resumeWebAudioOnClick), this.context && (window.PhaserGlobal ? window.PhaserGlobal.audioContext = this.context : this.context.close && this.context.close());
          },
          _resumeWebAudioOnClick: function _resumeWebAudioOnClick() {
            this.resumeWebAudio(), this.game.canvas.removeEventListener("click", this._resumeWebAudioOnClick);
          }
        }, s.SoundManager.prototype.constructor = s.SoundManager, Object.defineProperty(s.SoundManager.prototype, "mute", {
          get: function get() {
            return this._muted;
          },
          set: function set(t) {
            if (t = t || !1) {
              if (this._muted) return;
              this._codeMuted = !0, this.setMute();
            } else {
              if (!this._muted) return;
              this._codeMuted = !1, this.unsetMute();
            }
          }
        }), Object.defineProperty(s.SoundManager.prototype, "volume", {
          get: function get() {
            return this._volume;
          },
          set: function set(t) {
            if (t < 0 ? t = 0 : t > 1 && (t = 1), this._volume !== t) {
              if (this._volume = t, this.usingWebAudio) this.masterGain.gain.value = t;else for (var e = 0; e < this._sounds.length; e++) {
                this._sounds[e].usingAudioTag && this._sounds[e].updateGlobalVolume(t);
              }
              this.onVolumeChange.dispatch(t);
            }
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.ScaleManager = function (t, e, i) {
          this.game = t, this.dom = s.DOM, this.grid = null, this.width = 0, this.height = 0, this.minWidth = null, this.maxWidth = null, this.minHeight = null, this.maxHeight = null, this.offset = new s.Point(), this.forceLandscape = !1, this.forcePortrait = !1, this.incorrectOrientation = !1, this._pageAlignHorizontally = !1, this._pageAlignVertically = !1, this.onOrientationChange = new s.Signal(), this.enterIncorrectOrientation = new s.Signal(), this.leaveIncorrectOrientation = new s.Signal(), this.hasPhaserSetFullScreen = !1, this.fullScreenTarget = null, this._createdFullScreenTarget = null, this.onFullScreenInit = new s.Signal(), this.onFullScreenChange = new s.Signal(), this.onFullScreenError = new s.Signal(), this.screenOrientation = this.dom.getScreenOrientation(), this.scaleFactor = new s.Point(1, 1), this.scaleFactorInversed = new s.Point(1, 1), this.margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            x: 0,
            y: 0
          }, this.bounds = new s.Rectangle(), this.aspectRatio = 0, this.sourceAspectRatio = 0, this.event = null, this.windowConstraints = {
            right: "layout",
            bottom: ""
          }, this.compatibility = {
            supportsFullScreen: !1,
            orientationFallback: null,
            noMargins: !1,
            scrollTo: null,
            forceMinimumDocumentHeight: !1,
            canExpandParent: !0,
            clickTrampoline: ""
          }, this._scaleMode = s.ScaleManager.NO_SCALE, this._fullScreenScaleMode = s.ScaleManager.NO_SCALE, this.parentIsWindow = !1, this.parentNode = null, this.parentScaleFactor = new s.Point(1, 1), this.trackParentInterval = 2e3, this.onSizeChange = new s.Signal(), this.onResize = null, this.onResizeContext = null, this._pendingScaleMode = null, this._fullScreenRestore = null, this._gameSize = new s.Rectangle(), this._userScaleFactor = new s.Point(1, 1), this._userScaleTrim = new s.Point(0, 0), this._lastUpdate = 0, this._updateThrottle = 0, this._updateThrottleReset = 100, this._parentBounds = new s.Rectangle(), this._tempBounds = new s.Rectangle(), this._lastReportedCanvasSize = new s.Rectangle(), this._lastReportedGameSize = new s.Rectangle(), this._booted = !1, t.config && this.parseConfig(t.config), this.setupScale(e, i);
        }, s.ScaleManager.EXACT_FIT = 0, s.ScaleManager.NO_SCALE = 1, s.ScaleManager.SHOW_ALL = 2, s.ScaleManager.RESIZE = 3, s.ScaleManager.USER_SCALE = 4, s.ScaleManager.MODES = ["EXACT_FIT", "NO_SCALE", "SHOW_ALL", "RESIZE", "USER_SCALE"], s.ScaleManager.prototype = {
          boot: function boot() {
            var t = this.compatibility;
            t.supportsFullScreen = this.game.device.fullscreen && !this.game.device.cocoonJS, this.game.device.iPad || this.game.device.webApp || this.game.device.desktop || (this.game.device.android && !this.game.device.chrome ? t.scrollTo = new s.Point(0, 1) : t.scrollTo = new s.Point(0, 0)), this.game.device.desktop ? (t.orientationFallback = "screen", t.clickTrampoline = "when-not-mouse") : (t.orientationFallback = "", t.clickTrampoline = "");
            var e = this;
            this._orientationChange = function (t) {
              return e.orientationChange(t);
            }, this._windowResize = function (t) {
              return e.windowResize(t);
            }, window.addEventListener("orientationchange", this._orientationChange, !1), window.addEventListener("resize", this._windowResize, !1), this.compatibility.supportsFullScreen && (this._fullScreenChange = function (t) {
              return e.fullScreenChange(t);
            }, this._fullScreenError = function (t) {
              return e.fullScreenError(t);
            }, document.addEventListener("webkitfullscreenchange", this._fullScreenChange, !1), document.addEventListener("mozfullscreenchange", this._fullScreenChange, !1), document.addEventListener("MSFullscreenChange", this._fullScreenChange, !1), document.addEventListener("fullscreenchange", this._fullScreenChange, !1), document.addEventListener("webkitfullscreenerror", this._fullScreenError, !1), document.addEventListener("mozfullscreenerror", this._fullScreenError, !1), document.addEventListener("MSFullscreenError", this._fullScreenError, !1), document.addEventListener("fullscreenerror", this._fullScreenError, !1)), this.game.onResume.add(this._gameResumed, this), this.dom.getOffset(this.game.canvas, this.offset), this.bounds.setTo(this.offset.x, this.offset.y, this.width, this.height), this.setGameSize(this.game.width, this.game.height), this.screenOrientation = this.dom.getScreenOrientation(this.compatibility.orientationFallback), s.FlexGrid && (this.grid = new s.FlexGrid(this, this.width, this.height)), this._booted = !0, null !== this._pendingScaleMode && (this.scaleMode = this._pendingScaleMode, this._pendingScaleMode = null);
          },
          parseConfig: function parseConfig(t) {
            void 0 !== t.scaleMode && (this._booted ? this.scaleMode = t.scaleMode : this._pendingScaleMode = t.scaleMode), void 0 !== t.fullScreenScaleMode && (this.fullScreenScaleMode = t.fullScreenScaleMode), t.fullScreenTarget && (this.fullScreenTarget = t.fullScreenTarget), this.pageAlignHorizontally = t.alignH || !1, this.pageAlignVertically = t.alignV || !1, t.scaleH && t.scaleV && this.setUserScale(t.scaleH, t.scaleV, t.trimH, t.trimV);
          },
          setupScale: function setupScale(t, e) {
            var i,
                n = new s.Rectangle();
            "" !== this.game.parent && ("string" == typeof this.game.parent ? i = document.getElementById(this.game.parent) : this.game.parent && 1 === this.game.parent.nodeType && (i = this.game.parent)), i ? (this.parentNode = i, this.parentIsWindow = !1, this.getParentBounds(this._parentBounds, this.parentNode), n.width = this._parentBounds.width, n.height = this._parentBounds.height, this.offset.set(this._parentBounds.x, this._parentBounds.y)) : (this.parentNode = null, this.parentIsWindow = !0, n.width = this.dom.visualBounds.width, n.height = this.dom.visualBounds.height, this.offset.set(0, 0));
            var o = 0,
                r = 0;
            "number" == typeof t ? o = t : (this.parentScaleFactor.x = parseInt(t, 10) / 100, o = n.width * this.parentScaleFactor.x), "number" == typeof e ? r = e : (this.parentScaleFactor.y = parseInt(e, 10) / 100, r = n.height * this.parentScaleFactor.y), o = Math.floor(o), r = Math.floor(r), this._gameSize.setTo(0, 0, o, r), this.updateDimensions(o, r, !1);
          },
          _gameResumed: function _gameResumed() {
            this.queueUpdate(!0);
          },
          setGameSize: function setGameSize(t, e) {
            this._gameSize.setTo(0, 0, t, e), this.currentScaleMode !== s.ScaleManager.RESIZE && this.updateDimensions(t, e, !0), this.queueUpdate(!0);
          },
          setUserScale: function setUserScale(t, e, i, s, n, o) {
            this._userScaleFactor.setTo(t, e), this._userScaleTrim.setTo(0 | i, 0 | s), void 0 === n && (n = !0), void 0 === o && (o = !0), n && this.queueUpdate(o);
          },
          setResizeCallback: function setResizeCallback(t, e) {
            this.onResize = t, this.onResizeContext = e;
          },
          signalSizeChange: function signalSizeChange() {
            if (!s.Rectangle.sameDimensions(this, this._lastReportedCanvasSize) || !s.Rectangle.sameDimensions(this.game, this._lastReportedGameSize)) {
              var t = this.width,
                  e = this.height;
              this._lastReportedCanvasSize.setTo(0, 0, t, e), this._lastReportedGameSize.setTo(0, 0, this.game.width, this.game.height), this.grid && this.grid.onResize(t, e), this.onSizeChange.dispatch(this, t, e), this.currentScaleMode === s.ScaleManager.RESIZE && (this.game.state.resize(t, e), this.game.load.resize(t, e));
            }
          },
          setMinMax: function setMinMax(t, e, i, s) {
            this.minWidth = t, this.minHeight = e, void 0 !== i && (this.maxWidth = i), void 0 !== s && (this.maxHeight = s);
          },
          preUpdate: function preUpdate() {
            if (!(this.game.time.time < this._lastUpdate + this._updateThrottle)) {
              var t = this._updateThrottle;
              this._updateThrottleReset = t >= 400 ? 0 : 100, this.dom.getOffset(this.game.canvas, this.offset);
              var e = this._parentBounds.width,
                  i = this._parentBounds.height,
                  n = this.getParentBounds(this._parentBounds),
                  o = n.width !== e || n.height !== i,
                  r = this.updateOrientationState();
              (o || r) && (this.onResize && this.onResize.call(this.onResizeContext, this, n), this.updateLayout(), this.signalSizeChange());
              var a = 2 * this._updateThrottle;
              this._updateThrottle < t && (a = Math.min(t, this._updateThrottleReset)), this._updateThrottle = s.Math.clamp(a, 25, this.trackParentInterval), this._lastUpdate = this.game.time.time;
            }
          },
          pauseUpdate: function pauseUpdate() {
            this.preUpdate(), this._updateThrottle = this.trackParentInterval;
          },
          updateDimensions: function updateDimensions(t, e, i) {
            this.width = t * this.parentScaleFactor.x, this.height = e * this.parentScaleFactor.y, this.game.width = this.width, this.game.height = this.height, this.sourceAspectRatio = this.width / this.height, this.updateScalingAndBounds(), i && (this.game.renderer.resize(this.width, this.height), this.game.camera.setSize(this.width, this.height), this.game.world.resize(this.width, this.height));
          },
          updateScalingAndBounds: function updateScalingAndBounds() {
            this.scaleFactor.x = this.game.width / this.width, this.scaleFactor.y = this.game.height / this.height, this.scaleFactorInversed.x = this.width / this.game.width, this.scaleFactorInversed.y = this.height / this.game.height, this.aspectRatio = this.width / this.height, this.game.canvas && this.dom.getOffset(this.game.canvas, this.offset), this.bounds.setTo(this.offset.x, this.offset.y, this.width, this.height), this.game.input && this.game.input.scale && this.game.input.scale.setTo(this.scaleFactor.x, this.scaleFactor.y);
          },
          forceOrientation: function forceOrientation(t, e) {
            void 0 === e && (e = !1), !0 !== t || !0 !== e ? (this.forceLandscape = t, this.forcePortrait = e, this.queueUpdate(!0)) : console.warn("Phaser.ScaleManager: forceLandscape and forcePortrait cannot both be true.");
          },
          classifyOrientation: function classifyOrientation(t) {
            return "portrait-primary" === t || "portrait-secondary" === t ? "portrait" : "landscape-primary" === t || "landscape-secondary" === t ? "landscape" : null;
          },
          updateOrientationState: function updateOrientationState() {
            var t = this.screenOrientation,
                e = this.incorrectOrientation;
            this.screenOrientation = this.dom.getScreenOrientation(this.compatibility.orientationFallback), this.incorrectOrientation = this.forceLandscape && !this.isLandscape || this.forcePortrait && !this.isPortrait;
            var i = t !== this.screenOrientation,
                s = e !== this.incorrectOrientation;
            return s && (this.incorrectOrientation ? this.enterIncorrectOrientation.dispatch() : this.leaveIncorrectOrientation.dispatch()), (i || s) && this.onOrientationChange.dispatch(this, t, e), i || s;
          },
          orientationChange: function orientationChange(t) {
            this.event = t, this.queueUpdate(!0);
          },
          windowResize: function windowResize(t) {
            this.event = t, this.queueUpdate(!0);
          },
          scrollTop: function scrollTop() {
            var t = this.compatibility.scrollTo;
            t && window.scrollTo(t.x, t.y);
          },
          refresh: function refresh() {
            this.scrollTop(), this.queueUpdate(!0);
          },
          updateLayout: function updateLayout() {
            var t = this.currentScaleMode;

            if (t !== s.ScaleManager.RESIZE) {
              if (this.scrollTop(), this.compatibility.forceMinimumDocumentHeight && (document.documentElement.style.minHeight = window.innerHeight + "px"), this.incorrectOrientation ? this.setMaximum() : t === s.ScaleManager.EXACT_FIT ? this.setExactFit() : t === s.ScaleManager.SHOW_ALL ? !this.isFullScreen && this.boundingParent && this.compatibility.canExpandParent ? (this.setShowAll(!0), this.resetCanvas(), this.setShowAll()) : this.setShowAll() : t === s.ScaleManager.NO_SCALE ? (this.width = this.game.width, this.height = this.game.height) : t === s.ScaleManager.USER_SCALE && (this.width = this.game.width * this._userScaleFactor.x - this._userScaleTrim.x, this.height = this.game.height * this._userScaleFactor.y - this._userScaleTrim.y), !this.compatibility.canExpandParent && (t === s.ScaleManager.SHOW_ALL || t === s.ScaleManager.USER_SCALE)) {
                var e = this.getParentBounds(this._tempBounds);
                this.width = Math.min(this.width, e.width), this.height = Math.min(this.height, e.height);
              }

              this.width = 0 | this.width, this.height = 0 | this.height, this.reflowCanvas();
            } else this.reflowGame();
          },
          getParentBounds: function getParentBounds(t, e) {
            var i = t || new s.Rectangle(),
                n = e || this.boundingParent,
                o = this.dom.visualBounds,
                r = this.dom.layoutBounds;

            if (n) {
              var a = n.getBoundingClientRect(),
                  h = n.offsetParent ? n.offsetParent.getBoundingClientRect() : n.getBoundingClientRect();
              i.setTo(a.left - h.left, a.top - h.top, a.width, a.height);
              var l = this.windowConstraints;

              if (l.right) {
                var c = "layout" === l.right ? r : o;
                i.right = Math.min(i.right, c.width);
              }

              if (l.bottom) {
                c = "layout" === l.bottom ? r : o;
                i.bottom = Math.min(i.bottom, c.height);
              }
            } else i.setTo(0, 0, o.width, o.height);

            return i.setTo(Math.round(i.x), Math.round(i.y), Math.round(i.width), Math.round(i.height)), i;
          },
          align: function align(t, e) {
            null != t && (this.pageAlignHorizontally = t), null != e && (this.pageAlignVertically = e);
          },
          alignCanvas: function alignCanvas(t, e) {
            var i = this.getParentBounds(this._tempBounds),
                s = this.game.canvas,
                n = this.margin;

            if (t) {
              n.left = n.right = 0;
              var o = s.getBoundingClientRect();

              if (this.width < i.width && !this.incorrectOrientation) {
                var r = o.left - i.x,
                    a = i.width / 2 - this.width / 2,
                    h = (a = Math.max(a, 0)) - r;
                n.left = Math.round(h);
              }

              s.style.marginLeft = n.left + "px", 0 !== n.left && (n.right = -(i.width - o.width - n.left), s.style.marginRight = n.right + "px");
            }

            if (e) {
              n.top = n.bottom = 0;
              o = s.getBoundingClientRect();

              if (this.height < i.height && !this.incorrectOrientation) {
                r = o.top - i.y, a = i.height / 2 - this.height / 2, h = (a = Math.max(a, 0)) - r;
                n.top = Math.round(h);
              }

              s.style.marginTop = n.top + "px", 0 !== n.top && (n.bottom = -(i.height - o.height - n.top), s.style.marginBottom = n.bottom + "px");
            }

            n.x = n.left, n.y = n.top;
          },
          reflowGame: function reflowGame() {
            this.resetCanvas("", "");
            var t = this.getParentBounds(this._tempBounds);
            this.updateDimensions(t.width, t.height, !0);
          },
          reflowCanvas: function reflowCanvas() {
            this.incorrectOrientation || (this.width = s.Math.clamp(this.width, this.minWidth || 0, this.maxWidth || this.width), this.height = s.Math.clamp(this.height, this.minHeight || 0, this.maxHeight || this.height)), this.resetCanvas(), this.compatibility.noMargins || (this.isFullScreen && this._createdFullScreenTarget ? this.alignCanvas(!0, !0) : this.alignCanvas(this.pageAlignHorizontally, this.pageAlignVertically)), this.updateScalingAndBounds();
          },
          resetCanvas: function resetCanvas(t, e) {
            void 0 === t && (t = this.width + "px"), void 0 === e && (e = this.height + "px");
            var i = this.game.canvas;
            this.compatibility.noMargins || (i.style.marginLeft = "", i.style.marginTop = "", i.style.marginRight = "", i.style.marginBottom = ""), i.style.width = t, i.style.height = e;
          },
          queueUpdate: function queueUpdate(t) {
            t && (this._parentBounds.width = 0, this._parentBounds.height = 0), this._updateThrottle = this._updateThrottleReset;
          },
          reset: function reset(t) {
            t && this.grid && this.grid.reset();
          },
          setMaximum: function setMaximum() {
            this.width = this.dom.visualBounds.width, this.height = this.dom.visualBounds.height;
          },
          setShowAll: function setShowAll(t) {
            var e,
                i = this.getParentBounds(this._tempBounds),
                s = i.width,
                n = i.height;
            e = t ? Math.max(n / this.game.height, s / this.game.width) : Math.min(n / this.game.height, s / this.game.width), this.width = Math.round(this.game.width * e), this.height = Math.round(this.game.height * e);
          },
          setExactFit: function setExactFit() {
            var t = this.getParentBounds(this._tempBounds);
            this.width = t.width, this.height = t.height, this.isFullScreen || (this.maxWidth && (this.width = Math.min(this.width, this.maxWidth)), this.maxHeight && (this.height = Math.min(this.height, this.maxHeight)));
          },
          createFullScreenTarget: function createFullScreenTarget() {
            var t = document.createElement("div");
            return t.style.margin = "0", t.style.padding = "0", t.style.background = "#000", t;
          },
          startFullScreen: function startFullScreen(t, e) {
            if (this.isFullScreen) return !1;

            if (this.compatibility.supportsFullScreen) {
              if ("when-not-mouse" === this.compatibility.clickTrampoline) {
                var i = this.game.input;
                if (i.activePointer && i.activePointer !== i.mousePointer && (e || !1 !== e)) return void i.activePointer.addClickTrampoline("startFullScreen", this.startFullScreen, this, [t, !1]);
              }

              void 0 !== t && this.game.renderType === s.CANVAS && (this.game.stage.smoothed = t);
              var n = this.fullScreenTarget;
              n || (this.cleanupCreatedTarget(), this._createdFullScreenTarget = this.createFullScreenTarget(), n = this._createdFullScreenTarget);
              var o = {
                targetElement: n
              };

              if (this.hasPhaserSetFullScreen = !0, this.onFullScreenInit.dispatch(this, o), this._createdFullScreenTarget) {
                var r = this.game.canvas;
                r.parentNode.insertBefore(n, r), n.appendChild(r);
              }

              return this.game.device.fullscreenKeyboard ? n[this.game.device.requestFullscreen](Element.ALLOW_KEYBOARD_INPUT) : n[this.game.device.requestFullscreen](), !0;
            }

            var a = this;
            setTimeout(function () {
              a.fullScreenError();
            }, 10);
          },
          stopFullScreen: function stopFullScreen() {
            return !(!this.isFullScreen || !this.compatibility.supportsFullScreen) && (this.hasPhaserSetFullScreen = !1, document[this.game.device.cancelFullscreen](), !0);
          },
          cleanupCreatedTarget: function cleanupCreatedTarget() {
            var t = this._createdFullScreenTarget;

            if (t && t.parentNode) {
              var e = t.parentNode;
              e.insertBefore(this.game.canvas, t), e.removeChild(t);
            }

            this._createdFullScreenTarget = null;
          },
          prepScreenMode: function prepScreenMode(t) {
            var e = !!this._createdFullScreenTarget,
                i = this._createdFullScreenTarget || this.fullScreenTarget;
            t ? (e || this.fullScreenScaleMode === s.ScaleManager.EXACT_FIT) && i !== this.game.canvas && (this._fullScreenRestore = {
              targetWidth: i.style.width,
              targetHeight: i.style.height
            }, i.style.width = "100%", i.style.height = "100%") : (this._fullScreenRestore && (i.style.width = this._fullScreenRestore.targetWidth, i.style.height = this._fullScreenRestore.targetHeight, this._fullScreenRestore = null), this.updateDimensions(this._gameSize.width, this._gameSize.height, !0), this.resetCanvas());
          },
          fullScreenChange: function fullScreenChange(t) {
            this.event = t, this.isFullScreen ? (this.prepScreenMode(!0), this.updateLayout(), this.queueUpdate(!0)) : (this.prepScreenMode(!1), this.cleanupCreatedTarget(), this.updateLayout(), this.queueUpdate(!0)), this.onFullScreenChange.dispatch(this, this.width, this.height);
          },
          fullScreenError: function fullScreenError(t) {
            this.event = t, this.cleanupCreatedTarget(), console.warn("Phaser.ScaleManager: requestFullscreen failed or device does not support the Fullscreen API"), this.onFullScreenError.dispatch(this);
          },
          scaleSprite: function scaleSprite(t, e, i, s) {
            if (void 0 === e && (e = this.width), void 0 === i && (i = this.height), void 0 === s && (s = !1), !t || !t.scale) return t;
            if (t.scale.x = 1, t.scale.y = 1, t.width <= 0 || t.height <= 0 || e <= 0 || i <= 0) return t;
            var n = e,
                o = t.height * e / t.width,
                r = t.width * i / t.height,
                a = i,
                h = r > e;
            return (h = h ? s : !s) ? (t.width = Math.floor(n), t.height = Math.floor(o)) : (t.width = Math.floor(r), t.height = Math.floor(a)), t;
          },
          destroy: function destroy() {
            this.game.onResume.remove(this._gameResumed, this), window.removeEventListener("orientationchange", this._orientationChange, !1), window.removeEventListener("resize", this._windowResize, !1), this.compatibility.supportsFullScreen && (document.removeEventListener("webkitfullscreenchange", this._fullScreenChange, !1), document.removeEventListener("mozfullscreenchange", this._fullScreenChange, !1), document.removeEventListener("MSFullscreenChange", this._fullScreenChange, !1), document.removeEventListener("fullscreenchange", this._fullScreenChange, !1), document.removeEventListener("webkitfullscreenerror", this._fullScreenError, !1), document.removeEventListener("mozfullscreenerror", this._fullScreenError, !1), document.removeEventListener("MSFullscreenError", this._fullScreenError, !1), document.removeEventListener("fullscreenerror", this._fullScreenError, !1));
          }
        }, s.ScaleManager.prototype.constructor = s.ScaleManager, Object.defineProperty(s.ScaleManager.prototype, "boundingParent", {
          get: function get() {
            return this.parentIsWindow || this.isFullScreen && this.hasPhaserSetFullScreen && !this._createdFullScreenTarget ? null : this.game.canvas && this.game.canvas.parentNode || null;
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "scaleMode", {
          get: function get() {
            return this._scaleMode;
          },
          set: function set(t) {
            return t !== this._scaleMode && (this.isFullScreen || (this.updateDimensions(this._gameSize.width, this._gameSize.height, !0), this.queueUpdate(!0)), this._scaleMode = t), this._scaleMode;
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "fullScreenScaleMode", {
          get: function get() {
            return this._fullScreenScaleMode;
          },
          set: function set(t) {
            return t !== this._fullScreenScaleMode && (this.isFullScreen ? (this.prepScreenMode(!1), this._fullScreenScaleMode = t, this.prepScreenMode(!0), this.queueUpdate(!0)) : this._fullScreenScaleMode = t), this._fullScreenScaleMode;
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "currentScaleMode", {
          get: function get() {
            return this.isFullScreen ? this._fullScreenScaleMode : this._scaleMode;
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "pageAlignHorizontally", {
          get: function get() {
            return this._pageAlignHorizontally;
          },
          set: function set(t) {
            t !== this._pageAlignHorizontally && (this._pageAlignHorizontally = t, this.queueUpdate(!0));
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "pageAlignVertically", {
          get: function get() {
            return this._pageAlignVertically;
          },
          set: function set(t) {
            t !== this._pageAlignVertically && (this._pageAlignVertically = t, this.queueUpdate(!0));
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "isFullScreen", {
          get: function get() {
            return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "isPortrait", {
          get: function get() {
            return "portrait" === this.classifyOrientation(this.screenOrientation);
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "isLandscape", {
          get: function get() {
            return "landscape" === this.classifyOrientation(this.screenOrientation);
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "isGamePortrait", {
          get: function get() {
            return this.height > this.width;
          }
        }), Object.defineProperty(s.ScaleManager.prototype, "isGameLandscape", {
          get: function get() {
            return this.width > this.height;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Utils.Debug = function (t) {
          this.game = t, this.sprite = null, this.bmd = null, this.canvas = null, this.context = null, this.font = "14px Courier", this.columnWidth = 100, this.lineHeight = 16, this.lineWidth = 1, this.renderShadow = !0, this.currentColor = null, this.currentX = 0, this.currentY = 0, this.currentAlpha = 1, this.dirty = !1, this.isDisabled = !1, this._line = null, this._rect = null;
        }, s.Utils.Debug.GEOM_AUTO = 0, s.Utils.Debug.GEOM_RECTANGLE = 1, s.Utils.Debug.GEOM_CIRCLE = 2, s.Utils.Debug.GEOM_POINT = 3, s.Utils.Debug.GEOM_LINE = 4, s.Utils.Debug.GEOM_ELLIPSE = 5, s.Utils.Debug.prototype = {
          boot: function boot() {
            this.game.renderType === s.CANVAS ? this.context = this.game.context : (this.bmd = new s.BitmapData(this.game, "__DEBUG", this.game.width, this.game.height, !0), this.sprite = this.game.make.image(0, 0, this.bmd), this.game.stage.addChild(this.sprite), this.game.scale.onSizeChange.add(this.resize, this), this.canvas = s.CanvasPool.create(this, this.game.width, this.game.height), this.context = this.canvas.getContext("2d")), this._line = new s.Line(), this._rect = new s.Rectangle();
          },
          resize: function resize() {
            this.bmd.resize(this.game.width, this.game.height), this.canvas.width = this.game.width, this.canvas.height = this.game.height;
          },
          preUpdate: function preUpdate() {
            this.dirty && this.sprite && (this.bmd.clear(), this.bmd.draw(this.canvas, 0, 0), this.context.clearRect(0, 0, this.game.width, this.game.height), this.dirty = !1);
          },
          reset: function reset() {
            this.context && this.context.clearRect(0, 0, this.game.width, this.game.height), this.sprite && this.bmd.clear();
          },
          start: function start(t, e, i, s) {
            "number" != typeof t && (t = 0), "number" != typeof e && (e = 0), i = i || "rgb(255,255,255)", void 0 === s && (s = 0), this.currentX = t, this.currentY = e, this.currentColor = i, this.columnWidth = s, this.dirty = !0, this.context.save(), this.context.setTransform(1, 0, 0, 1, 0, 0), this.context.strokeStyle = i, this.context.fillStyle = i, this.context.font = this.font, this.context.globalAlpha = this.currentAlpha;
          },
          stop: function stop() {
            this.context.restore();
          },
          line: function line() {
            for (var t = this.currentX, e = 0; e < arguments.length; e++) {
              this.renderShadow && (this.context.fillStyle = "rgb(0,0,0)", this.context.fillText(arguments[e], t + 1, this.currentY + 1), this.context.fillStyle = this.currentColor), this.context.fillText(arguments[e], t, this.currentY), t += this.columnWidth;
            }

            this.currentY += this.lineHeight;
          },
          sound: function sound(t, e, i) {
            var s = this.game.sound;
            this.start(t, e, i), s.noAudio ? this.line("Audio is disabled") : (this.line("Volume: " + s.volume.toFixed(2) + (s.mute ? " (Mute)" : "")), this.line("Mute on pause: " + s.muteOnPause), this.line("Using: " + (s.usingWebAudio ? "Web Audio - " + s.context.state : "Audio Tag")), this.line("Touch locked: " + s.touchLocked), this.line("Sounds: " + s._sounds.length)), this.stop();
          },
          soundInfo: function soundInfo(t, e, i, s) {
            this.start(e, i, s), this.line("Sound: " + t.key + "  Touch locked: " + t.game.sound.touchLocked), this.line("Is Ready?: " + this.game.cache.isSoundReady(t.key) + "  Pending Playback: " + t.pendingPlayback), this.line("Decoded: " + t.isDecoded + "  Decoding: " + t.isDecoding), this.line("Playing: " + t.isPlaying + "  Loop: " + t.loop), this.line("Time: " + (.001 * t.currentTime).toFixed(3) + "s  Total: " + t.totalDuration.toFixed(3) + "s"), this.line("Volume: " + t.volume.toFixed(2) + (t.mute ? " (Mute)" : "")), this.line("Using: " + (t.usingWebAudio ? "Web Audio" : "Audio Tag") + "  " + (t.usingWebAudio ? "Source: " + (t.sourceId || "none") : "")), "" !== t.currentMarker && (this.line("Marker: " + t.currentMarker + "  Duration: " + t.duration.toFixed(3) + "s (" + t.durationMS + "ms)"), this.line("Start: " + t.markers[t.currentMarker].start + "  Stop: " + t.markers[t.currentMarker].stop), this.line("Position: " + t.position)), this.stop();
          },
          camera: function camera(t, e, i) {
            var s = t.deadzone,
                n = t.target,
                o = t.view;
            s && (this._rect.setTo(o.x + s.x, o.y + s.y, s.width, s.height), this.rectangle(this._rect, e, i)), n && (this._line.setTo(o.centerX, o.centerY, n.x, n.y), this.geom(this._line, e, i), this.geom(n, e, !1, 3));
          },
          cameraInfo: function cameraInfo(t, e, i, s) {
            var n = t.bounds,
                o = t.deadzone,
                r = t.target,
                a = t.view;
            this.start(e, i, s), this.line("Camera (" + t.width + " x " + t.height + ")"), this.line("x: " + t.x + " y: " + t.y), this.line("Bounds: " + (n ? "x: " + n.x + " y: " + n.y + " w: " + n.width + " h: " + n.height : "none")), this.line("View: x: " + a.x + " y: " + a.y + " w: " + a.width + " h: " + a.height), this.line("Deadzone: " + (o ? "x: " + o.x + " y: " + o.y + " w: " + o.width + " h: " + o.height : o)), this.line("Total in view: " + t.totalInView), this.line("At limit: x: " + t.atLimit.x + " y: " + t.atLimit.y), this.line("Target: " + (r ? r.name || r : "none")), this.stop();
          },
          timer: function timer(t, e, i, s) {
            this.start(e, i, s), this.line("Timer (running: " + t.running + " expired: " + t.expired + ")"), this.line("Next Tick: " + t.next + " Duration: " + t.duration), this.line("Paused: " + t.paused + " Length: " + t.length), this.stop();
          },
          pointer: function pointer(t, e, i, s, n) {
            null != t && (void 0 === e && (e = !1), i = i || "rgba(0,255,0,0.5)", s = s || "rgba(255,0,0,0.5)", !0 === e && !0 === t.isUp || (this.start(t.x, t.y - 100, n), this.context.beginPath(), this.context.arc(t.x, t.y, t.circle.radius, 0, 2 * Math.PI), t.active ? this.context.fillStyle = i : this.context.fillStyle = s, this.context.fill(), this.context.closePath(), this.context.beginPath(), this.context.moveTo(t.positionDown.x, t.positionDown.y), this.context.lineTo(t.position.x, t.position.y), this.context.lineWidth = 2, this.context.stroke(), this.context.closePath(), this.line("ID: " + t.id + " Active: " + t.active), this.line("World X: " + t.worldX + " World Y: " + t.worldY), this.line("Screen X: " + t.x + " Screen Y: " + t.y + " In: " + t.withinGame), this.line("Duration: " + t.duration + " ms"), this.line("is Down: " + t.isDown + " is Up: " + t.isUp), this.stop()));
          },
          spriteInputInfo: function spriteInputInfo(t, e, i, s) {
            this.start(e, i, s), this.line("Sprite Input: (" + t.width + " x " + t.height + ")"), this.line("x: " + t.input.pointerX().toFixed(1) + " y: " + t.input.pointerY().toFixed(1)), this.line("over: " + t.input.pointerOver() + " duration: " + t.input.overDuration().toFixed(0)), this.line("down: " + t.input.pointerDown() + " duration: " + t.input.downDuration().toFixed(0)), this.line("just over: " + t.input.justOver() + " just out: " + t.input.justOut()), this.stop();
          },
          key: function key(t, e, i, s) {
            this.start(e, i, s, 150), this.line("Key:", t.keyCode, "isDown:", t.isDown), this.line("justDown:", t.justDown, "justUp:", t.justUp), this.line("Time Down:", t.timeDown.toFixed(0), "duration:", t.duration.toFixed(0)), this.stop();
          },
          inputInfo: function inputInfo(t, e, i) {
            this.start(t, e, i), this.line("Input"), this.line("X: " + this.game.input.x + " Y: " + this.game.input.y), this.line("World X: " + this.game.input.worldX + " World Y: " + this.game.input.worldY), this.line("Scale X: " + this.game.input.scale.x.toFixed(1) + " Scale Y: " + this.game.input.scale.x.toFixed(1)), this.line("Screen X: " + this.game.input.activePointer.screenX + " Screen Y: " + this.game.input.activePointer.screenY), this.stop();
          },
          spriteBounds: function spriteBounds(t, e, i) {
            var s = t.getBounds();
            s.x += this.game.camera.x, s.y += this.game.camera.y, this.rectangle(s, e, i);
          },
          ropeSegments: function ropeSegments(t, e, i) {
            var s = this;
            t.segments.forEach(function (t) {
              s.rectangle(t, e, i);
            }, this);
          },
          spriteInfo: function spriteInfo(t, e, i, s) {
            this.start(e, i, s), this.line("Sprite: " + (t.name || "") + " (" + t.width + " x " + t.height + ") anchor: " + t.anchor.x + " x " + t.anchor.y), this.line("x: " + t.x.toFixed(1) + " y: " + t.y.toFixed(1)), this.line("angle: " + t.angle.toFixed(1) + " rotation: " + t.rotation.toFixed(1)), this.line("visible: " + t.visible + " in camera: " + t.inCamera), this.line("bounds x: " + t._bounds.x.toFixed(1) + " y: " + t._bounds.y.toFixed(1) + " w: " + t._bounds.width.toFixed(1) + " h: " + t._bounds.height.toFixed(1)), this.stop();
          },
          spriteCoords: function spriteCoords(t, e, i, s) {
            this.start(e, i, s, 100), t.name && this.line(t.name), this.line("x:", t.x.toFixed(2), "y:", t.y.toFixed(2)), this.line("pos x:", t.position.x.toFixed(2), "pos y:", t.position.y.toFixed(2)), this.line("world x:", t.world.x.toFixed(2), "world y:", t.world.y.toFixed(2)), this.stop();
          },
          lineInfo: function lineInfo(t, e, i, s) {
            this.start(e, i, s, 80), this.line("start.x:", t.start.x.toFixed(2), "start.y:", t.start.y.toFixed(2)), this.line("end.x:", t.end.x.toFixed(2), "end.y:", t.end.y.toFixed(2)), this.line("length:", t.length.toFixed(2), "angle:", t.angle), this.stop();
          },
          pixel: function pixel(t, e, i, s) {
            s = s || 2, this.start(), this.context.fillStyle = i, this.context.fillRect(t, e, s, s), this.stop();
          },
          geom: function geom(t, e, i, n) {
            void 0 === i && (i = !0), void 0 === n && (n = 0), e = e || "rgba(0,255,0,0.4)", this.start(), this.context.fillStyle = e, this.context.strokeStyle = e, this.context.lineWidth = this.lineWidth;
            var o = s.Utils.Debug;
            n === o.GEOM_RECTANGLE || t instanceof s.Rectangle ? i ? this.context.fillRect(t.x - this.game.camera.x, t.y - this.game.camera.y, t.width, t.height) : this.context.strokeRect(t.x - this.game.camera.x, t.y - this.game.camera.y, t.width, t.height) : n === o.GEOM_CIRCLE || t instanceof s.Circle ? (this.context.beginPath(), this.context.arc(t.x - this.game.camera.x, t.y - this.game.camera.y, t.radius, 0, 2 * Math.PI, !1), this.context.closePath(), i ? this.context.fill() : this.context.stroke()) : n === o.GEOM_POINT || t instanceof s.Point ? this.context.fillRect(t.x - this.game.camera.x, t.y - this.game.camera.y, 4, 4) : n === o.GEOM_LINE || t instanceof s.Line ? (this.context.beginPath(), this.context.moveTo(t.start.x + .5 - this.game.camera.x, t.start.y + .5 - this.game.camera.y), this.context.lineTo(t.end.x + .5 - this.game.camera.x, t.end.y + .5 - this.game.camera.y), this.context.closePath(), this.context.stroke()) : (n === o.GEOM_ELLIPSE || t instanceof s.Ellipse) && (this.context.beginPath(), this.context.ellipse(t.centerX - this.game.camera.x, t.centerY - this.game.camera.y, t.width / 2, t.height / 2, 0, 2 * Math.PI, !1), this.context.closePath(), i ? this.context.fill() : this.context.stroke()), this.stop();
          },
          rectangle: function rectangle(t, e, i) {
            void 0 === i && (i = !0), e = e || "rgba(0, 255, 0, 0.4)", this.start(), i ? (this.context.fillStyle = e, this.context.fillRect(t.x - this.game.camera.x, t.y - this.game.camera.y, t.width, t.height)) : (this.context.lineWidth = this.lineWidth, this.context.strokeStyle = e, this.context.strokeRect(t.x - this.game.camera.x, t.y - this.game.camera.y, t.width, t.height)), this.stop();
          },
          text: function text(t, e, i, s, n) {
            s = s || "rgb(255,255,255)", n = n || this.font, this.start(), this.context.font = n, this.renderShadow && (this.context.fillStyle = "rgb(0,0,0)", this.context.fillText(t, e + 1, i + 1)), this.context.fillStyle = s, this.context.fillText(t, e, i), this.stop();
          },
          quadTree: function quadTree(t, e) {
            e = e || "rgba(255,0,0,0.3)", this.start();
            var i = t.bounds;

            if (0 === t.nodes.length) {
              this.context.strokeStyle = e, this.context.strokeRect(i.x, i.y, i.width, i.height), this.text("size: " + t.objects.length, i.x + 4, i.y + 16, "rgb(0,200,0)", "12px Courier"), this.context.strokeStyle = "rgb(0,255,0)";

              for (var s = 0; s < t.objects.length; s++) {
                this.context.strokeRect(t.objects[s].x, t.objects[s].y, t.objects[s].width, t.objects[s].height);
              }
            } else for (s = 0; s < t.nodes.length; s++) {
              this.quadTree(t.nodes[s]);
            }

            this.stop();
          },
          body: function body(t, e, i) {
            t.body && (this.start(), t.body.type === s.Physics.ARCADE ? s.Physics.Arcade.Body.render(this.context, t.body, e, i, this.lineWidth) : t.body.type === s.Physics.NINJA ? s.Physics.Ninja.Body.render(this.context, t.body, e, i) : t.body.type === s.Physics.BOX2D && s.Physics.Box2D.renderBody(this.context, t.body, e), this.stop());
          },
          bodyInfo: function bodyInfo(t, e, i, n) {
            t.body && (this.start(e, i, n, 210), t.body.type === s.Physics.ARCADE ? s.Physics.Arcade.Body.renderBodyInfo(this, t.body) : t.body.type === s.Physics.BOX2D && this.game.physics.box2d.renderBodyInfo(this, t.body), this.stop());
          },
          box2dWorld: function box2dWorld() {
            this.start(), this.context.translate(-this.game.camera.view.x, -this.game.camera.view.y, 0), this.game.physics.box2d.renderDebugDraw(this.context), this.stop();
          },
          box2dBody: function box2dBody(t, e) {
            this.start(), s.Physics.Box2D.renderBody(this.context, t, e), this.stop();
          },
          displayList: function displayList(t) {
            if (void 0 === t && (t = this.game.world), t.hasOwnProperty("renderOrderID") ? console.log("[" + t.renderOrderID + "]", t) : console.log("[]", t), t.children && t.children.length > 0) for (var e = 0; e < t.children.length; e++) {
              this.game.debug.displayList(t.children[e]);
            }
          },
          renderer: function renderer(t, e, i) {
            var s = this.game.renderer,
                n = s.renderSession;

            if (this.start(t, e, i), this.line((s.gl ? "WebGL" : "Canvas") + " Renderer (" + s.width + " x " + s.height + ")"), this.line("autoResize: " + s.autoResize), this.line("clearBeforeRender: " + s.clearBeforeRender), this.line("resolution: " + s.resolution), this.line("transparent: " + s.transparent), this.line("renderSession:"), s.gl) {
              this.line("  currentBatchedTextures: (" + s.currentBatchedTextures.length + ")");

              for (var o = 0; o < s.currentBatchedTextures.length; o++) {
                this.line("    " + s.currentBatchedTextures[o]);
              }

              this.line("  drawCount: " + n.drawCount), this.line("  maxTextures: " + s.maxTextures), this.line("  maxTextureSize: " + s.maxTextureSize), this.line("  maxTextureAvailableSpace: " + n.maxTextureAvailableSpace), this.line("  roundPixels: " + n.roundPixels);
            } else this.line("  roundPixels: " + n.roundPixels), this.line("  scaleMode: " + (0 === n.scaleMode ? "LINEAR" : 1 === n.scaleMode ? "NEAREST" : n.scaleMode));

            this.stop();
          },
          canvasPool: function canvasPool(t, e, i, n) {
            var o = s.CanvasPool;
            this.start(t, e, i, n || 100), this.line("Canvas Pool"), this.line("Used:", o.getTotal()), this.line("Free:", o.getFree()), this.line("Total:", o.length), this.stop();
          },
          physicsGroup: function physicsGroup(t, e, i, s) {
            t.forEach(this.body, this, s, e, i);
          },
          phaser: function phaser(t, e, i) {
            this.text("Phaser v" + s.VERSION + " " + (this.game.renderType === s.WEBGL ? "WebGL" : "Canvas") + " " + (this.game.device.webAudio ? "WebAudio" : "HTML Audio"), t, e, i, this.font);
          },
          scale: function scale(t, e, i) {
            this.start(t, e, i);
            var n = this.game.scale,
                o = n.scaleFactorInversed,
                r = n._parentBounds;
            t = " x ";
            this.line("Game: " + this.game.width + t + this.game.height), this.line("Canvas: " + n.width + t + n.height + " (" + o.x.toFixed(2) + t + o.y.toFixed(2) + ") [" + n.aspectRatio.toFixed(2) + "]"), this.line("Mode: " + s.ScaleManager.MODES[n.currentScaleMode] + (n.currentScaleMode === s.ScaleManager.USER_SCALE ? " (" + n._userScaleFactor.x + t + n._userScaleFactor.y + ")" : "")), this.line("Parent: " + (n.parentIsWindow ? "window" : n.parentNode) + (r.empty ? "" : " (" + r.width + t + r.height + ")")), this.line("Screen: " + n.classifyOrientation(n.screenOrientation) + (n.incorrectOrientation ? " (incorrect)" : "")), this.stop();
          },
          loader: function loader(t, e, i, n) {
            var o = s.Utils.pad;
            this.start(e, i, n), t.hasLoaded ? this.line("Complete" + (t.resetLocked ? " [locked]" : "")) : t.isLoading ? this.line("Loading") : this.line("Not started"), t.hasLoaded && !t.resetLocked || (this.line("Progress: " + o(t.progress, 3) + "%"), this.line("Files: " + t._loadedFileCount + " of " + t._totalFileCount), this.line("Packs: " + t._loadedPackCount + " of " + t._loadedPackCount)), this.stop();
          },
          destroy: function destroy() {
            s.CanvasPool.remove(this);
          }
        }, s.Utils.Debug.prototype.constructor = s.Utils.Debug,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.DOM = {
          getOffset: function getOffset(t, e) {
            e = e || new s.Point();
            var i = t.getBoundingClientRect(),
                n = s.DOM.scrollY,
                o = s.DOM.scrollX,
                r = document.documentElement.clientTop,
                a = document.documentElement.clientLeft;
            return e.x = i.left + o - a, e.y = i.top + n - r, e;
          },
          getBounds: function getBounds(t, e) {
            return void 0 === e && (e = 0), !(!(t = t && !t.nodeType ? t[0] : t) || 1 !== t.nodeType) && this.calibrate(t.getBoundingClientRect(), e);
          },
          calibrate: function calibrate(t, e) {
            e = +e || 0;
            var i = {
              width: 0,
              height: 0,
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            };
            return i.width = (i.right = t.right + e) - (i.left = t.left - e), i.height = (i.bottom = t.bottom + e) - (i.top = t.top - e), i;
          },
          getAspectRatio: function getAspectRatio(t) {
            var e = (t = null == t ? this.visualBounds : 1 === t.nodeType ? this.getBounds(t) : t).width,
                i = t.height;
            return "function" == typeof e && (e = e.call(t)), "function" == typeof i && (i = i.call(t)), e / i;
          },
          inLayoutViewport: function inLayoutViewport(t, e) {
            var i = this.getBounds(t, e);
            return !!i && i.bottom >= 0 && i.right >= 0 && i.top <= this.layoutBounds.width && i.left <= this.layoutBounds.height;
          },
          getScreenOrientation: function getScreenOrientation(t) {
            var e = window.screen,
                i = e.orientation || e.mozOrientation || e.msOrientation;
            if (i && "string" == typeof i.type) return i.type;
            if ("string" == typeof i) return i;
            var s = "portrait-primary",
                n = "landscape-primary";
            if ("screen" === t) return e.height > e.width ? s : n;
            if ("viewport" === t) return this.visualBounds.height > this.visualBounds.width ? s : n;
            if ("window.orientation" === t && "number" == typeof window.orientation) return 0 === window.orientation || 180 === window.orientation ? s : n;

            if (window.matchMedia) {
              if (window.matchMedia("(orientation: portrait)").matches) return s;
              if (window.matchMedia("(orientation: landscape)").matches) return n;
            }

            return this.visualBounds.height > this.visualBounds.width ? s : n;
          },
          visualBounds: new s.Rectangle(),
          layoutBounds: new s.Rectangle(),
          documentBounds: new s.Rectangle()
        }, s.Device.whenReady(function (t) {
          var e = window && "pageXOffset" in window ? function () {
            return window.pageXOffset;
          } : function () {
            return document.documentElement.scrollLeft;
          },
              i = window && "pageYOffset" in window ? function () {
            return window.pageYOffset;
          } : function () {
            return document.documentElement.scrollTop;
          };

          if (Object.defineProperty(s.DOM, "scrollX", {
            get: e
          }), Object.defineProperty(s.DOM, "scrollY", {
            get: i
          }), Object.defineProperty(s.DOM.visualBounds, "x", {
            get: e
          }), Object.defineProperty(s.DOM.visualBounds, "y", {
            get: i
          }), Object.defineProperty(s.DOM.layoutBounds, "x", {
            value: 0
          }), Object.defineProperty(s.DOM.layoutBounds, "y", {
            value: 0
          }), t.desktop && document.documentElement.clientWidth <= window.innerWidth && document.documentElement.clientHeight <= window.innerHeight) {
            var n = function n() {
              return Math.max(window.innerWidth, document.documentElement.clientWidth);
            },
                o = function o() {
              return Math.max(window.innerHeight, document.documentElement.clientHeight);
            };

            Object.defineProperty(s.DOM.visualBounds, "width", {
              get: n
            }), Object.defineProperty(s.DOM.visualBounds, "height", {
              get: o
            }), Object.defineProperty(s.DOM.layoutBounds, "width", {
              get: n
            }), Object.defineProperty(s.DOM.layoutBounds, "height", {
              get: o
            });
          } else Object.defineProperty(s.DOM.visualBounds, "width", {
            get: function get() {
              return window.innerWidth;
            }
          }), Object.defineProperty(s.DOM.visualBounds, "height", {
            get: function get() {
              return window.innerHeight;
            }
          }), Object.defineProperty(s.DOM.layoutBounds, "width", {
            get: function get() {
              var t = document.documentElement.clientWidth,
                  e = window.innerWidth;
              return t < e ? e : t;
            }
          }), Object.defineProperty(s.DOM.layoutBounds, "height", {
            get: function get() {
              var t = document.documentElement.clientHeight,
                  e = window.innerHeight;
              return t < e ? e : t;
            }
          });

          Object.defineProperty(s.DOM.documentBounds, "x", {
            value: 0
          }), Object.defineProperty(s.DOM.documentBounds, "y", {
            value: 0
          }), Object.defineProperty(s.DOM.documentBounds, "width", {
            get: function get() {
              var t = document.documentElement;
              return Math.max(t.clientWidth, t.offsetWidth, t.scrollWidth);
            }
          }), Object.defineProperty(s.DOM.documentBounds, "height", {
            get: function get() {
              var t = document.documentElement;
              return Math.max(t.clientHeight, t.offsetHeight, t.scrollHeight);
            }
          });
        }, null, !0),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.ArraySet = function (t) {
          this.position = 0, this.list = t || [];
        }, s.ArraySet.prototype = {
          add: function add(t) {
            return this.exists(t) || this.list.push(t), t;
          },
          getIndex: function getIndex(t) {
            return this.list.indexOf(t);
          },
          getByKey: function getByKey(t, e) {
            for (var i = this.list.length; i--;) {
              if (this.list[i][t] === e) return this.list[i];
            }

            return null;
          },
          exists: function exists(t) {
            return this.list.indexOf(t) > -1;
          },
          reset: function reset() {
            this.list.length = 0;
          },
          remove: function remove(t) {
            var e = this.list.indexOf(t);
            if (e > -1) return this.list.splice(e, 1), t;
          },
          setAll: function setAll(t, e) {
            for (var i = this.list.length; i--;) {
              this.list[i] && (this.list[i][t] = e);
            }
          },
          callAll: function callAll(t) {
            for (var e = Array.prototype.slice.call(arguments, 1), i = this.list.length; i--;) {
              this.list[i] && this.list[i][t] && this.list[i][t].apply(this.list[i], e);
            }
          },
          removeAll: function removeAll(t) {
            void 0 === t && (t = !1);

            for (var e = this.list.length; e--;) {
              if (this.list[e]) {
                var i = this.remove(this.list[e]);
                t && i.destroy();
              }
            }

            this.position = 0, this.list = [];
          }
        }, Object.defineProperty(s.ArraySet.prototype, "total", {
          get: function get() {
            return this.list.length;
          }
        }), Object.defineProperty(s.ArraySet.prototype, "first", {
          get: function get() {
            return this.position = 0, this.list.length > 0 ? this.list[0] : null;
          }
        }), Object.defineProperty(s.ArraySet.prototype, "next", {
          get: function get() {
            return this.position < this.list.length ? (this.position++, this.list[this.position]) : null;
          }
        }), s.ArraySet.prototype.constructor = s.ArraySet,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.ArrayUtils = {
          getRandomItem: function getRandomItem(t, e, i) {
            if (null === t) return null;
            void 0 === e && (e = 0), void 0 === i && (i = t.length);
            var s = e + Math.floor(Math.random() * i);
            return void 0 === t[s] ? null : t[s];
          },
          removeRandomItem: function removeRandomItem(t, e, i) {
            if (null == t) return null;
            void 0 === e && (e = 0), void 0 === i && (i = t.length);
            var s = e + Math.floor(Math.random() * i);

            if (s < t.length) {
              var n = t.splice(s, 1);
              return void 0 === n[0] ? null : n[0];
            }

            return null;
          },
          remove: function remove(t, e, i) {
            var s = t.length;

            if (!(e >= s || 0 === i)) {
              null == i && (i = 1);

              for (var n = s - i, o = e; o < n; ++o) {
                t[o] = t[o + i];
              }

              t.length = n;
            }
          },
          shuffle: function shuffle(t) {
            for (var e = t.length - 1; e > 0; e--) {
              var i = Math.floor(Math.random() * (e + 1)),
                  s = t[e];
              t[e] = t[i], t[i] = s;
            }

            return t;
          },
          transposeMatrix: function transposeMatrix(t) {
            for (var e = t.length, i = t[0].length, s = new Array(i), n = 0; n < i; n++) {
              s[n] = new Array(e);

              for (var o = e - 1; o > -1; o--) {
                s[n][o] = t[o][n];
              }
            }

            return s;
          },
          rotateMatrix: function rotateMatrix(t, e) {
            if ("string" != typeof e && (e = (e % 360 + 360) % 360), 90 === e || -270 === e || "rotateLeft" === e) t = (t = s.ArrayUtils.transposeMatrix(t)).reverse();else if (-90 === e || 270 === e || "rotateRight" === e) t = t.reverse(), t = s.ArrayUtils.transposeMatrix(t);else if (180 === Math.abs(e) || "rotate180" === e) {
              for (var i = 0; i < t.length; i++) {
                t[i].reverse();
              }

              t = t.reverse();
            }
            return t;
          },
          findClosest: function findClosest(t, e) {
            if (!e.length) return NaN;
            if (1 === e.length || t < e[0]) return e[0];

            for (var i = 1; e[i] < t;) {
              i++;
            }

            var s = e[i - 1],
                n = i < e.length ? e[i] : Number.POSITIVE_INFINITY;
            return n - t <= t - s ? n : s;
          },
          rotateRight: function rotateRight(t) {
            var e = t.pop();
            return t.unshift(e), e;
          },
          rotateLeft: function rotateLeft(t) {
            var e = t.shift();
            return t.push(e), e;
          },
          numberArray: function numberArray(t, e) {
            void 0 !== e && null !== e || (e = t, t = 0);

            for (var i = [], s = t; s <= e; s++) {
              i.push(s);
            }

            return i;
          },
          numberArrayStep: function numberArrayStep(t, e, i) {
            void 0 !== t && null !== t || (t = 0), void 0 !== e && null !== e || (e = t, t = 0), void 0 === i && (i = 1);

            for (var n = [], o = Math.max(s.Math.roundAwayFromZero((e - t) / (i || 1)), 0), r = 0; r < o; r++) {
              n.push(t), t += i;
            }

            return n;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.LinkedList = function () {
          this.next = null, this.prev = null, this.first = null, this.last = null, this.total = 0;
        }, s.LinkedList.prototype = {
          add: function add(t) {
            return 0 === this.total && null === this.first && null === this.last ? (this.first = t, this.last = t, this.next = t, t.prev = this, this.total++, t) : (this.last.next = t, t.prev = this.last, this.last = t, this.total++, t);
          },
          reset: function reset() {
            this.first = null, this.last = null, this.next = null, this.prev = null, this.total = 0;
          },
          remove: function remove(t) {
            if (1 === this.total) return this.reset(), void (t.next = t.prev = null);
            t === this.first ? this.first = this.first.next : t === this.last && (this.last = this.last.prev), t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t.next = t.prev = null, null === this.first && (this.last = null), this.total--;
          },
          callAll: function callAll(t) {
            if (this.first && this.last) {
              var e = this.first;

              do {
                e && e[t] && e[t].call(e), e = e.next;
              } while (e !== this.last.next);
            }
          }
        }, s.LinkedList.prototype.constructor = s.LinkedList,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Create = function (t) {
          this.game = t, this.bmd = null, this.canvas = null, this.ctx = null, this.palettes = [{
            0: "#000",
            1: "#9D9D9D",
            2: "#FFF",
            3: "#BE2633",
            4: "#E06F8B",
            5: "#493C2B",
            6: "#A46422",
            7: "#EB8931",
            8: "#F7E26B",
            9: "#2F484E",
            A: "#44891A",
            B: "#A3CE27",
            C: "#1B2632",
            D: "#005784",
            E: "#31A2F2",
            F: "#B2DCEF"
          }, {
            0: "#000",
            1: "#191028",
            2: "#46af45",
            3: "#a1d685",
            4: "#453e78",
            5: "#7664fe",
            6: "#833129",
            7: "#9ec2e8",
            8: "#dc534b",
            9: "#e18d79",
            A: "#d6b97b",
            B: "#e9d8a1",
            C: "#216c4b",
            D: "#d365c8",
            E: "#afaab9",
            F: "#f5f4eb"
          }, {
            0: "#000",
            1: "#2234d1",
            2: "#0c7e45",
            3: "#44aacc",
            4: "#8a3622",
            5: "#5c2e78",
            6: "#aa5c3d",
            7: "#b5b5b5",
            8: "#5e606e",
            9: "#4c81fb",
            A: "#6cd947",
            B: "#7be2f9",
            C: "#eb8a60",
            D: "#e23d69",
            E: "#ffd93f",
            F: "#fff"
          }, {
            0: "#000",
            1: "#fff",
            2: "#8b4131",
            3: "#7bbdc5",
            4: "#8b41ac",
            5: "#6aac41",
            6: "#3931a4",
            7: "#d5de73",
            8: "#945a20",
            9: "#5a4100",
            A: "#bd736a",
            B: "#525252",
            C: "#838383",
            D: "#acee8b",
            E: "#7b73de",
            F: "#acacac"
          }, {
            0: "#000",
            1: "#191028",
            2: "#46af45",
            3: "#a1d685",
            4: "#453e78",
            5: "#7664fe",
            6: "#833129",
            7: "#9ec2e8",
            8: "#dc534b",
            9: "#e18d79",
            A: "#d6b97b",
            B: "#e9d8a1",
            C: "#216c4b",
            D: "#d365c8",
            E: "#afaab9",
            F: "#fff"
          }];
        }, s.Create.PALETTE_ARNE = 0, s.Create.PALETTE_JMP = 1, s.Create.PALETTE_CGA = 2, s.Create.PALETTE_C64 = 3, s.Create.PALETTE_JAPANESE_MACHINE = 4, s.Create.prototype = {
          texture: function texture(t, e, i, s, n, o, r, a) {
            void 0 === i && (i = 8), void 0 === s && (s = i), void 0 === n && (n = 0), void 0 === o && (o = !0);
            var h = e[0].length * i,
                l = e.length * s;
            null === this.bmd && (this.bmd = this.game.make.bitmapData(), this.canvas = this.bmd.canvas, this.ctx = this.bmd.context), this.bmd.resize(h, l), this.bmd.clear();

            for (var c = 0; c < e.length; c++) {
              for (var u = e[c], d = 0; d < u.length; d++) {
                var p = u[d];
                "." !== p && " " !== p && (this.ctx.fillStyle = this.palettes[n][p], this.ctx.fillRect(d * i, c * s, i, s));
              }
            }

            return o ? this.bmd.generateTexture(t, r, a) : this.copy();
          },
          grid: function grid(t, e, i, s, n, o, r, a, h) {
            void 0 === r && (r = !0), null === this.bmd && (this.bmd = this.game.make.bitmapData(), this.canvas = this.bmd.canvas, this.ctx = this.bmd.context), this.bmd.resize(e, i), this.ctx.fillStyle = o;

            for (var l = 0; l < i; l += n) {
              this.ctx.fillRect(0, l, e, 1);
            }

            for (var c = 0; c < e; c += s) {
              this.ctx.fillRect(c, 0, 1, i);
            }

            return r ? this.bmd.generateTexture(t, a, h) : this.copy();
          },
          copy: function copy(t, e, i, s, n, o, r) {
            return null == t && (t = this.game.make.bitmapData()), t.resize(this.bmd.width, this.bmd.height), t.draw(this.bmd, e, i, s, n, o, r);
          }
        }, s.Create.prototype.constructor = s.Create,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.FlexGrid = function (t, e, i) {
          this.game = t.game, this.manager = t, this.width = e, this.height = i, this.boundsCustom = new s.Rectangle(0, 0, e, i), this.boundsFluid = new s.Rectangle(0, 0, e, i), this.boundsFull = new s.Rectangle(0, 0, e, i), this.boundsNone = new s.Rectangle(0, 0, e, i), this.positionCustom = new s.Point(0, 0), this.positionFluid = new s.Point(0, 0), this.positionFull = new s.Point(0, 0), this.positionNone = new s.Point(0, 0), this.scaleCustom = new s.Point(1, 1), this.scaleFluid = new s.Point(1, 1), this.scaleFluidInversed = new s.Point(1, 1), this.scaleFull = new s.Point(1, 1), this.scaleNone = new s.Point(1, 1), this.customWidth = 0, this.customHeight = 0, this.customOffsetX = 0, this.customOffsetY = 0, this.ratioH = e / i, this.ratioV = i / e, this.multiplier = 0, this.layers = [];
        }, s.FlexGrid.prototype = {
          setSize: function setSize(t, e) {
            this.width = t, this.height = e, this.ratioH = t / e, this.ratioV = e / t, this.scaleNone = new s.Point(1, 1), this.boundsNone.width = this.width, this.boundsNone.height = this.height, this.refresh();
          },
          createCustomLayer: function createCustomLayer(t, e, i, n) {
            void 0 === n && (n = !0), this.customWidth = t, this.customHeight = e, this.boundsCustom.width = t, this.boundsCustom.height = e;
            var o = new s.FlexLayer(this, this.positionCustom, this.boundsCustom, this.scaleCustom);
            return n && this.game.world.add(o), this.layers.push(o), i && o.addMultiple(i), o;
          },
          createFluidLayer: function createFluidLayer(t, e) {
            void 0 === e && (e = !0);
            var i = new s.FlexLayer(this, this.positionFluid, this.boundsFluid, this.scaleFluid);
            return e && this.game.world.add(i), this.layers.push(i), t && i.addMultiple(t), i;
          },
          createFullLayer: function createFullLayer(t) {
            var e = new s.FlexLayer(this, this.positionFull, this.boundsFull, this.scaleFluid);
            return this.game.world.add(e), this.layers.push(e), void 0 !== t && e.addMultiple(t), e;
          },
          createFixedLayer: function createFixedLayer(t) {
            var e = new s.FlexLayer(this, this.positionNone, this.boundsNone, this.scaleNone);
            return this.game.world.add(e), this.layers.push(e), void 0 !== t && e.addMultiple(t), e;
          },
          reset: function reset() {
            for (var t = this.layers.length; t--;) {
              this.layers[t].persist || (this.layers[t].position = null, this.layers[t].scale = null, this.layers.slice(t, 1));
            }
          },
          onResize: function onResize(t, e) {
            this.ratioH = t / e, this.ratioV = e / t, this.refresh(t, e);
          },
          refresh: function refresh() {
            this.multiplier = Math.min(this.manager.height / this.height, this.manager.width / this.width), this.boundsFluid.width = Math.round(this.width * this.multiplier), this.boundsFluid.height = Math.round(this.height * this.multiplier), this.scaleFluid.set(this.boundsFluid.width / this.width, this.boundsFluid.height / this.height), this.scaleFluidInversed.set(this.width / this.boundsFluid.width, this.height / this.boundsFluid.height), this.scaleFull.set(this.boundsFull.width / this.width, this.boundsFull.height / this.height), this.boundsFull.width = Math.round(this.manager.width * this.scaleFluidInversed.x), this.boundsFull.height = Math.round(this.manager.height * this.scaleFluidInversed.y), this.boundsFluid.centerOn(this.manager.bounds.centerX, this.manager.bounds.centerY), this.boundsNone.centerOn(this.manager.bounds.centerX, this.manager.bounds.centerY), this.positionFluid.set(this.boundsFluid.x, this.boundsFluid.y), this.positionNone.set(this.boundsNone.x, this.boundsNone.y);
          },
          fitSprite: function fitSprite(t) {
            this.manager.scaleSprite(t), t.x = this.manager.bounds.centerX, t.y = this.manager.bounds.centerY;
          },
          debug: function debug() {
            this.game.debug.text(this.boundsFluid.width + " x " + this.boundsFluid.height, this.boundsFluid.x + 4, this.boundsFluid.y + 16), this.game.debug.geom(this.boundsFluid, "rgba(255,0,0,0.9", !1);
          }
        }, s.FlexGrid.prototype.constructor = s.FlexGrid,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.FlexLayer = function (t, e, i, n) {
          s.Group.call(this, t.game, null, "__flexLayer" + t.game.rnd.uuid(), !1), this.manager = t.manager, this.grid = t, this.persist = !1, this.position = e, this.bounds = i, this.scale = n, this.topLeft = i.topLeft, this.topMiddle = new s.Point(i.halfWidth, 0), this.topRight = i.topRight, this.bottomLeft = i.bottomLeft, this.bottomMiddle = new s.Point(i.halfWidth, i.bottom), this.bottomRight = i.bottomRight;
        }, s.FlexLayer.prototype = Object.create(s.Group.prototype), s.FlexLayer.prototype.constructor = s.FlexLayer, s.FlexLayer.prototype.resize = function () {}, s.FlexLayer.prototype.debug = function () {
          this.game.debug.text(this.bounds.width + " x " + this.bounds.height, this.bounds.x + 4, this.bounds.y + 16), this.game.debug.geom(this.bounds, "rgba(0,0,255,0.9", !1), this.game.debug.geom(this.topLeft, "rgba(255,255,255,0.9"), this.game.debug.geom(this.topMiddle, "rgba(255,255,255,0.9"), this.game.debug.geom(this.topRight, "rgba(255,255,255,0.9");
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Color = {
          RED: 16711680,
          ORANGE: 16750848,
          YELLOW: 16776960,
          GREEN: 65280,
          AQUA: 65535,
          BLUE: 255,
          VIOLET: 16711935,
          WHITE: 16777215,
          BLACK: 0,
          GRAY: 6710886,
          packPixel: function packPixel(t, e, i, n) {
            return s.Device.LITTLE_ENDIAN ? (n << 24 | i << 16 | e << 8 | t) >>> 0 : (t << 24 | e << 16 | i << 8 | n) >>> 0;
          },
          unpackPixel: function unpackPixel(t, e, i, n) {
            return void 0 !== e && null !== e || (e = s.Color.createColor()), void 0 !== i && null !== i || (i = !1), void 0 !== n && null !== n || (n = !1), s.Device.LITTLE_ENDIAN ? (e.a = (4278190080 & t) >>> 24, e.b = (16711680 & t) >>> 16, e.g = (65280 & t) >>> 8, e.r = 255 & t) : (e.r = (4278190080 & t) >>> 24, e.g = (16711680 & t) >>> 16, e.b = (65280 & t) >>> 8, e.a = 255 & t), e.color = t, e.rgba = "rgba(" + e.r + "," + e.g + "," + e.b + "," + e.a / 255 + ")", i && s.Color.RGBtoHSL(e.r, e.g, e.b, e), n && s.Color.RGBtoHSV(e.r, e.g, e.b, e), e;
          },
          fromRGBA: function fromRGBA(t, e) {
            return e || (e = s.Color.createColor()), e.r = (4278190080 & t) >>> 24, e.g = (16711680 & t) >>> 16, e.b = (65280 & t) >>> 8, e.a = 255 & t, e.rgba = "rgba(" + e.r + "," + e.g + "," + e.b + "," + e.a + ")", e;
          },
          toRGBA: function toRGBA(t, e, i, s) {
            return t << 24 | e << 16 | i << 8 | s;
          },
          toABGR: function toABGR(t, e, i, s) {
            return (s << 24 | i << 16 | e << 8 | t) >>> 0;
          },
          hexToRGBArray: function hexToRGBArray(t) {
            return [(t >> 16 & 255) / 255, (t >> 8 & 255) / 255, (255 & t) / 255];
          },
          RGBArrayToHex: function RGBArrayToHex(t) {
            return (255 * t[0] << 16) + (255 * t[1] << 8) + 255 * t[2];
          },
          RGBtoHSL: function RGBtoHSL(t, e, i, n) {
            n || (n = s.Color.createColor(t, e, i, 1)), t /= 255, e /= 255, i /= 255;
            var o = Math.min(t, e, i),
                r = Math.max(t, e, i);

            if (n.h = 0, n.s = 0, n.l = (r + o) / 2, r !== o) {
              var a = r - o;
              n.s = n.l > .5 ? a / (2 - r - o) : a / (r + o), r === t ? n.h = (e - i) / a + (e < i ? 6 : 0) : r === e ? n.h = (i - t) / a + 2 : r === i && (n.h = (t - e) / a + 4), n.h /= 6;
            }

            return n;
          },
          HSLtoRGB: function HSLtoRGB(t, e, i, n) {
            if (n ? (n.r = i, n.g = i, n.b = i) : n = s.Color.createColor(i, i, i), 0 !== e) {
              var o = i < .5 ? i * (1 + e) : i + e - i * e,
                  r = 2 * i - o;
              n.r = s.Color.hueToColor(r, o, t + 1 / 3), n.g = s.Color.hueToColor(r, o, t), n.b = s.Color.hueToColor(r, o, t - 1 / 3);
            }

            return n.r = Math.floor(255 * n.r | 0), n.g = Math.floor(255 * n.g | 0), n.b = Math.floor(255 * n.b | 0), s.Color.updateColor(n), n;
          },
          RGBtoHSV: function RGBtoHSV(t, e, i, n) {
            n || (n = s.Color.createColor(t, e, i, 255)), t /= 255, e /= 255, i /= 255;
            var o = Math.min(t, e, i),
                r = Math.max(t, e, i),
                a = r - o;
            return n.h = 0, n.s = 0 === r ? 0 : a / r, n.v = r, r !== o && (r === t ? n.h = (e - i) / a + (e < i ? 6 : 0) : r === e ? n.h = (i - t) / a + 2 : r === i && (n.h = (t - e) / a + 4), n.h /= 6), n;
          },
          HSVtoRGB: function HSVtoRGB(t, e, i, n) {
            var o, r, a;
            void 0 === n && (n = s.Color.createColor(0, 0, 0, 1, t, e, 0, i));
            var h = Math.floor(6 * t),
                l = 6 * t - h,
                c = i * (1 - e),
                u = i * (1 - l * e),
                d = i * (1 - (1 - l) * e);

            switch (h % 6) {
              case 0:
                o = i, r = d, a = c;
                break;

              case 1:
                o = u, r = i, a = c;
                break;

              case 2:
                o = c, r = i, a = d;
                break;

              case 3:
                o = c, r = u, a = i;
                break;

              case 4:
                o = d, r = c, a = i;
                break;

              case 5:
                o = i, r = c, a = u;
            }

            return n.r = Math.floor(255 * o), n.g = Math.floor(255 * r), n.b = Math.floor(255 * a), s.Color.updateColor(n), n;
          },
          hueToColor: function hueToColor(t, e, i) {
            return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + 6 * (e - t) * i : i < .5 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
          },
          createColor: function createColor(t, e, i, n, o, r, a, h) {
            var l = {
              r: t || 0,
              g: e || 0,
              b: i || 0,
              a: n || 1,
              h: o || 0,
              s: r || 0,
              l: a || 0,
              v: h || 0,
              color: 0,
              color32: 0,
              rgba: ""
            };
            return s.Color.updateColor(l);
          },
          updateColor: function updateColor(t) {
            return t.rgba = "rgba(" + t.r.toFixed() + "," + t.g.toFixed() + "," + t.b.toFixed() + "," + t.a.toString() + ")", t.color = s.Color.getColor(t.r, t.g, t.b), t.color32 = s.Color.getColor32(255 * t.a, t.r, t.g, t.b), t;
          },
          getColor32: function getColor32(t, e, i, s) {
            return t << 24 | e << 16 | i << 8 | s;
          },
          getColor: function getColor(t, e, i) {
            return t << 16 | e << 8 | i;
          },
          RGBtoString: function RGBtoString(t, e, i, n, o) {
            return void 0 === n && (n = 255), void 0 === o && (o = "#"), "#" === o ? "#" + ((1 << 24) + (t << 16) + (e << 8) + i).toString(16).slice(1) : "0x" + s.Color.componentToHex(n) + s.Color.componentToHex(t) + s.Color.componentToHex(e) + s.Color.componentToHex(i);
          },
          hexToRGB: function hexToRGB(t) {
            var e = s.Color.hexToColor(t);
            if (e) return s.Color.getColor32(e.a, e.r, e.g, e.b);
          },
          hexToColor: function hexToColor(t, e) {
            t = t.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, i, s) {
              return e + e + i + i + s + s;
            });
            var i = /^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);

            if (i) {
              var n = parseInt(i[1], 16),
                  o = parseInt(i[2], 16),
                  r = parseInt(i[3], 16);
              e ? (e.r = n, e.g = o, e.b = r) : e = s.Color.createColor(n, o, r);
            }

            return e;
          },
          webToColor: function webToColor(t, e) {
            e || (e = s.Color.createColor());
            var i = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(t);
            return i && (e.r = ~~Number(i[1]), e.g = ~~Number(i[2]), e.b = ~~Number(i[3]), e.a = void 0 !== i[4] ? Number(i[4]) : 1, s.Color.updateColor(e)), e;
          },
          valueToColor: function valueToColor(t, e) {
            if (e || (e = s.Color.createColor()), "string" == typeof t) return 0 === t.indexOf("rgb") ? s.Color.webToColor(t, e) : (e.a = 1, s.Color.hexToColor(t, e));

            if ("number" == typeof t) {
              var i = s.Color.getRGB(t);
              return e.r = i.r, e.g = i.g, e.b = i.b, e.a = i.a / 255, e;
            }

            return e;
          },
          componentToHex: function componentToHex(t) {
            var e = t.toString(16);
            return 1 === e.length ? "0" + e : e;
          },
          HSVColorWheel: function HSVColorWheel(t, e) {
            void 0 === t && (t = 1), void 0 === e && (e = 1);

            for (var i = [], n = 0; n <= 359; n++) {
              i.push(s.Color.HSVtoRGB(n / 359, t, e));
            }

            return i;
          },
          HSLColorWheel: function HSLColorWheel(t, e) {
            void 0 === t && (t = .5), void 0 === e && (e = .5);

            for (var i = [], n = 0; n <= 359; n++) {
              i.push(s.Color.HSLtoRGB(n / 359, t, e));
            }

            return i;
          },
          interpolateColor: function interpolateColor(t, e, i, n, o, r) {
            void 0 === o && (o = 255), void 0 === r && (r = 0);
            var a = s.Color.getRGB(t),
                h = s.Color.getRGB(e);
            if (0 === r) var l = (h.red - a.red) * n / i + a.red,
                c = (h.green - a.green) * n / i + a.green,
                u = (h.blue - a.blue) * n / i + a.blue;

            if (1 === r) {
              var d,
                  p = s.Color.RGBtoHSV(a.r, a.g, a.b),
                  f = s.Color.RGBtoHSV(h.r, h.g, h.b),
                  g = f.h - p.h;

              if (p.h > f.h) {
                var m = f.h;
                f.h = p.h, p.h = m, g = -g, n = i - n;
              }

              g > .5 && (p.h = p.h + 1, d = ((f.h - p.h) * n / i + p.h) % 1), g <= .5 && (d = (f.h - p.h) * n / i + p.h);
              var y = (f.s - p.s) * n / i + p.s,
                  v = (f.v - p.v) * n / i + p.v,
                  b = s.Color.HSVtoRGB(d, y, v, b);
              l = b.r, c = b.g, u = b.b;
            }

            return s.Color.getColor32(o, l, c, u);
          },
          interpolateColorWithRGB: function interpolateColorWithRGB(t, e, i, n, o, r) {
            var a = s.Color.getRGB(t),
                h = (e - a.red) * r / o + a.red,
                l = (i - a.green) * r / o + a.green,
                c = (n - a.blue) * r / o + a.blue;
            return s.Color.getColor(h, l, c);
          },
          interpolateRGB: function interpolateRGB(t, e, i, n, o, r, a, h) {
            var l = (n - t) * h / a + t,
                c = (o - e) * h / a + e,
                u = (r - i) * h / a + i;
            return s.Color.getColor(l, c, u);
          },
          linear: function linear(t, e, i) {
            return this.interpolateColor(t, e, 1, i);
          },
          linearInterpolation: function linearInterpolation(t, e) {
            var i = s.Math.linear(0, t.length - 1, e),
                n = t[Math.floor(i)],
                o = t[Math.ceil(i)];
            return this.linear(n, o, i % 1);
          },
          getRandomColor: function getRandomColor(t, e, i) {
            if (void 0 === t && (t = 0), void 0 === e && (e = 255), void 0 === i && (i = 255), e > 255 || t > e) return s.Color.getColor(255, 255, 255);
            var n = t + Math.round(Math.random() * (e - t)),
                o = t + Math.round(Math.random() * (e - t)),
                r = t + Math.round(Math.random() * (e - t));
            return s.Color.getColor32(i, n, o, r);
          },
          getRGB: function getRGB(t) {
            return t > 16777215 ? {
              alpha: t >>> 24,
              red: t >> 16 & 255,
              green: t >> 8 & 255,
              blue: 255 & t,
              a: t >>> 24,
              r: t >> 16 & 255,
              g: t >> 8 & 255,
              b: 255 & t
            } : {
              alpha: 255,
              red: t >> 16 & 255,
              green: t >> 8 & 255,
              blue: 255 & t,
              a: 255,
              r: t >> 16 & 255,
              g: t >> 8 & 255,
              b: 255 & t
            };
          },
          getWebRGB: function getWebRGB(t) {
            if ("object" == typeof t) return "rgba(" + t.r.toString() + "," + t.g.toString() + "," + t.b.toString() + "," + (t.a / 255).toString() + ")";
            var e = s.Color.getRGB(t);
            return "rgba(" + e.r.toString() + "," + e.g.toString() + "," + e.b.toString() + "," + (e.a / 255).toString() + ")";
          },
          getAlpha: function getAlpha(t) {
            return t >>> 24;
          },
          getAlphaFloat: function getAlphaFloat(t) {
            return (t >>> 24) / 255;
          },
          getRed: function getRed(t) {
            return t >> 16 & 255;
          },
          getGreen: function getGreen(t) {
            return t >> 8 & 255;
          },
          getBlue: function getBlue(t) {
            return 255 & t;
          },
          blendNormal: function blendNormal(t) {
            return t;
          },
          blendLighten: function blendLighten(t, e) {
            return e > t ? e : t;
          },
          blendDarken: function blendDarken(t, e) {
            return e > t ? t : e;
          },
          blendMultiply: function blendMultiply(t, e) {
            return t * e / 255;
          },
          blendAverage: function blendAverage(t, e) {
            return (t + e) / 2;
          },
          blendAdd: function blendAdd(t, e) {
            return Math.min(255, t + e);
          },
          blendSubtract: function blendSubtract(t, e) {
            return Math.max(0, t + e - 255);
          },
          blendDifference: function blendDifference(t, e) {
            return Math.abs(t - e);
          },
          blendNegation: function blendNegation(t, e) {
            return 255 - Math.abs(255 - t - e);
          },
          blendScreen: function blendScreen(t, e) {
            return 255 - ((255 - t) * (255 - e) >> 8);
          },
          blendExclusion: function blendExclusion(t, e) {
            return t + e - 2 * t * e / 255;
          },
          blendOverlay: function blendOverlay(t, e) {
            return e < 128 ? 2 * t * e / 255 : 255 - 2 * (255 - t) * (255 - e) / 255;
          },
          blendSoftLight: function blendSoftLight(t, e) {
            return e < 128 ? 2 * (64 + (t >> 1)) * (e / 255) : 255 - 2 * (255 - (64 + (t >> 1))) * (255 - e) / 255;
          },
          blendHardLight: function blendHardLight(t, e) {
            return s.Color.blendOverlay(e, t);
          },
          blendColorDodge: function blendColorDodge(t, e) {
            return 255 === e ? e : Math.min(255, (t << 8) / (255 - e));
          },
          blendColorBurn: function blendColorBurn(t, e) {
            return 0 === e ? e : Math.max(0, 255 - (255 - t << 8) / e);
          },
          blendLinearDodge: function blendLinearDodge(t, e) {
            return s.Color.blendAdd(t, e);
          },
          blendLinearBurn: function blendLinearBurn(t, e) {
            return s.Color.blendSubtract(t, e);
          },
          blendLinearLight: function blendLinearLight(t, e) {
            return e < 128 ? s.Color.blendLinearBurn(t, 2 * e) : s.Color.blendLinearDodge(t, 2 * (e - 128));
          },
          blendVividLight: function blendVividLight(t, e) {
            return e < 128 ? s.Color.blendColorBurn(t, 2 * e) : s.Color.blendColorDodge(t, 2 * (e - 128));
          },
          blendPinLight: function blendPinLight(t, e) {
            return e < 128 ? s.Color.blendDarken(t, 2 * e) : s.Color.blendLighten(t, 2 * (e - 128));
          },
          blendHardMix: function blendHardMix(t, e) {
            return s.Color.blendVividLight(t, e) < 128 ? 0 : 255;
          },
          blendReflect: function blendReflect(t, e) {
            return 255 === e ? e : Math.min(255, t * t / (255 - e));
          },
          blendGlow: function blendGlow(t, e) {
            return s.Color.blendReflect(e, t);
          },
          blendPhoenix: function blendPhoenix(t, e) {
            return Math.min(t, e) - Math.max(t, e) + 255;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics = function (t, e) {
          e = e || {}, this.game = t, this.config = e, this.arcade = null, this.p2 = null, this.ninja = null, this.box2d = null, this.chipmunk = null, this.matter = null, this.parseConfig();
        }, s.Physics.ARCADE = 0, s.Physics.P2JS = 1, s.Physics.NINJA = 2, s.Physics.BOX2D = 3, s.Physics.CHIPMUNK = 4, s.Physics.MATTERJS = 5, s.Physics.prototype = {
          parseConfig: function parseConfig() {
            this.config.hasOwnProperty("arcade") && !0 !== this.config.arcade || !s.Physics.hasOwnProperty("Arcade") || (this.arcade = new s.Physics.Arcade(this.game)), this.config.hasOwnProperty("ninja") && !0 === this.config.ninja && s.Physics.hasOwnProperty("Ninja") && (this.ninja = new s.Physics.Ninja(this.game)), this.config.hasOwnProperty("p2") && !0 === this.config.p2 && s.Physics.hasOwnProperty("P2") && (this.p2 = new s.Physics.P2(this.game, this.config)), this.config.hasOwnProperty("box2d") && !0 === this.config.box2d && s.Physics.hasOwnProperty("BOX2D") && (this.box2d = new s.Physics.BOX2D(this.game, this.config)), this.config.hasOwnProperty("matter") && !0 === this.config.matter && s.Physics.hasOwnProperty("Matter") && (this.matter = new s.Physics.Matter(this.game, this.config));
          },
          startSystem: function startSystem(t) {
            t === s.Physics.ARCADE ? this.arcade = new s.Physics.Arcade(this.game) : t === s.Physics.P2JS ? null === this.p2 ? this.p2 = new s.Physics.P2(this.game, this.config) : this.p2.reset() : t === s.Physics.NINJA ? this.ninja = new s.Physics.Ninja(this.game) : t === s.Physics.BOX2D ? null === this.box2d ? this.box2d = new s.Physics.Box2D(this.game, this.config) : this.box2d.reset() : t === s.Physics.MATTERJS && (null === this.matter ? this.matter = new s.Physics.Matter(this.game, this.config) : this.matter.reset());
          },
          enable: function enable(t, e, i) {
            void 0 === e && (e = s.Physics.ARCADE), void 0 === i && (i = !1), e === s.Physics.ARCADE ? this.arcade.enable(t) : e === s.Physics.P2JS && this.p2 ? this.p2.enable(t, i) : e === s.Physics.NINJA && this.ninja ? this.ninja.enableAABB(t) : e === s.Physics.BOX2D && this.box2d ? this.box2d.enable(t) : e === s.Physics.MATTERJS && this.matter ? this.matter.enable(t) : console.warn(t.key + " is attempting to enable a physics body using an unknown physics system.");
          },
          preUpdate: function preUpdate() {
            this.p2 && this.p2.preUpdate(), this.box2d && this.box2d.preUpdate(), this.matter && this.matter.preUpdate();
          },
          update: function update() {
            this.p2 && this.p2.update(), this.box2d && this.box2d.update(), this.matter && this.matter.update();
          },
          setBoundsToWorld: function setBoundsToWorld() {
            this.arcade && this.arcade.setBoundsToWorld(), this.ninja && this.ninja.setBoundsToWorld(), this.p2 && this.p2.setBoundsToWorld(), this.box2d && this.box2d.setBoundsToWorld(), this.matter && this.matter.setBoundsToWorld();
          },
          clear: function clear() {
            this.p2 && this.p2.clear(), this.box2d && this.box2d.clear(), this.matter && this.matter.clear();
          },
          reset: function reset() {
            this.p2 && this.p2.reset(), this.box2d && this.box2d.reset(), this.matter && this.matter.reset();
          },
          destroy: function destroy() {
            this.p2 && this.p2.destroy(), this.box2d && this.box2d.destroy(), this.matter && this.matter.destroy(), this.arcade = null, this.ninja = null, this.p2 = null, this.box2d = null, this.matter = null;
          }
        }, s.Physics.prototype.constructor = s.Physics,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.Arcade = function (t) {
          this.game = t, this.gravity = new s.Point(), this.bounds = new s.Rectangle(0, 0, t.world.width, t.world.height), this.checkCollision = {
            up: !0,
            down: !0,
            left: !0,
            right: !0
          }, this.maxObjects = 10, this.maxLevels = 4, this.OVERLAP_BIAS = 4, this.forceX = !1, this.sortDirection = s.Physics.Arcade.LEFT_RIGHT, this.skipQuadTree = !0, this.isPaused = !1, this.quadTree = new s.QuadTree(this.game.world.bounds.x, this.game.world.bounds.y, this.game.world.bounds.width, this.game.world.bounds.height, this.maxObjects, this.maxLevels), this._total = 0, this.setBoundsToWorld();
        }, s.Physics.Arcade.prototype.constructor = s.Physics.Arcade, s.Physics.Arcade.SORT_NONE = 0, s.Physics.Arcade.LEFT_RIGHT = 1, s.Physics.Arcade.RIGHT_LEFT = 2, s.Physics.Arcade.TOP_BOTTOM = 3, s.Physics.Arcade.BOTTOM_TOP = 4, s.Physics.Arcade.prototype = {
          setBounds: function setBounds(t, e, i, s) {
            this.bounds.setTo(t, e, i, s);
          },
          setBoundsToWorld: function setBoundsToWorld() {
            this.bounds.copyFrom(this.game.world.bounds);
          },
          enable: function enable(t, e) {
            void 0 === e && (e = !0);
            var i = 1;
            if (Array.isArray(t)) for (i = t.length; i--;) {
              t[i] instanceof s.Group ? this.enable(t[i].children, e) : (this.enableBody(t[i]), e && t[i].hasOwnProperty("children") && t[i].children.length > 0 && this.enable(t[i], !0));
            } else t instanceof s.Group ? this.enable(t.children, e) : (this.enableBody(t), e && t.hasOwnProperty("children") && t.children.length > 0 && this.enable(t.children, !0));
          },
          enableBody: function enableBody(t) {
            t.hasOwnProperty("body") && null === t.body && (t.body = new s.Physics.Arcade.Body(t), t.parent && t.parent instanceof s.Group && t.parent.addToHash(t));
          },
          updateMotion: function updateMotion(t) {
            if (t.allowRotation) {
              var e = this.computeVelocity(0, t, t.angularVelocity, t.angularAcceleration, t.angularDrag, t.maxAngular) - t.angularVelocity;
              t.angularVelocity += e, t.rotation += t.angularVelocity * this.game.time.physicsElapsed;
            }

            t.velocity.x = this.computeVelocity(1, t, t.velocity.x, t.acceleration.x, t.drag.x, t.maxVelocity.x), t.velocity.y = this.computeVelocity(2, t, t.velocity.y, t.acceleration.y, t.drag.y, t.maxVelocity.y);
          },
          computeVelocity: function computeVelocity(t, e, i, s, n, o) {
            return void 0 === o && (o = 1e4), 1 === t && e.allowGravity ? i += (this.gravity.x + e.gravity.x) * this.game.time.physicsElapsed : 2 === t && e.allowGravity && (i += (this.gravity.y + e.gravity.y) * this.game.time.physicsElapsed), s ? i += s * this.game.time.physicsElapsed : n && e.allowDrag && (i - (n *= this.game.time.physicsElapsed) > 0 ? i -= n : i + n < 0 ? i += n : i = 0), i > o ? i = o : i < -o && (i = -o), i;
          },
          overlap: function overlap(t, e, i, s, n) {
            return i = i || null, s = s || null, n = n || i, this._total = 0, this.collideObjects(t, e, i, s, n, !0), this._total > 0;
          },
          collide: function collide(t, e, i, s, n) {
            return i = i || null, s = s || null, n = n || i, this._total = 0, this.collideObjects(t, e, i, s, n, !1), this._total > 0;
          },
          sortLeftRight: function sortLeftRight(t, e) {
            return t.body && e.body ? t.body.x - e.body.x : 0;
          },
          sortRightLeft: function sortRightLeft(t, e) {
            return t.body && e.body ? e.body.x - t.body.x : 0;
          },
          sortTopBottom: function sortTopBottom(t, e) {
            return t.body && e.body ? t.body.y - e.body.y : 0;
          },
          sortBottomTop: function sortBottomTop(t, e) {
            return t.body && e.body ? e.body.y - t.body.y : 0;
          },
          sort: function sort(t, e) {
            null !== t.physicsSortDirection ? e = t.physicsSortDirection : void 0 === e && (e = this.sortDirection), e === s.Physics.Arcade.LEFT_RIGHT ? t.hash.sort(this.sortLeftRight) : e === s.Physics.Arcade.RIGHT_LEFT ? t.hash.sort(this.sortRightLeft) : e === s.Physics.Arcade.TOP_BOTTOM ? t.hash.sort(this.sortTopBottom) : e === s.Physics.Arcade.BOTTOM_TOP && t.hash.sort(this.sortBottomTop);
          },
          collideObjects: function collideObjects(t, e, i, s, n, o) {
            if (!Array.isArray(t) && Array.isArray(e)) for (var r = 0; r < e.length; r++) {
              e[r] && this.collideHandler(t, e[r], i, s, n, o);
            } else if (Array.isArray(t) && !Array.isArray(e)) for (r = 0; r < t.length; r++) {
              t[r] && this.collideHandler(t[r], e, i, s, n, o);
            } else if (Array.isArray(t) && Array.isArray(e)) {
              for (r = 0; r < t.length; r++) {
                if (t[r]) for (var a = 0; a < e.length; a++) {
                  e[a] && this.collideHandler(t[r], e[a], i, s, n, o);
                }
              }
            } else this.collideHandler(t, e, i, s, n, o);
          },
          collideHandler: function collideHandler(t, e, i, n, o, r) {
            if (void 0 === e && t.physicsType === s.GROUP) return this.sort(t), void this.collideGroupVsSelf(t, i, n, o, r);
            t && e && t.exists && e.exists && (this.sortDirection !== s.Physics.Arcade.SORT_NONE && (t.physicsType === s.GROUP && this.sort(t), e.physicsType === s.GROUP && this.sort(e)), t.physicsType === s.SPRITE ? e.physicsType === s.SPRITE ? this.collideSpriteVsSprite(t, e, i, n, o, r) : e.physicsType === s.GROUP ? this.collideSpriteVsGroup(t, e, i, n, o, r) : e.physicsType === s.TILEMAPLAYER && this.collideSpriteVsTilemapLayer(t, e, i, n, o, r) : t.physicsType === s.GROUP ? e.physicsType === s.SPRITE ? this.collideSpriteVsGroup(e, t, i, n, o, r) : e.physicsType === s.GROUP ? this.collideGroupVsGroup(t, e, i, n, o, r) : e.physicsType === s.TILEMAPLAYER && this.collideGroupVsTilemapLayer(t, e, i, n, o, r) : t.physicsType === s.TILEMAPLAYER && (e.physicsType === s.SPRITE ? this.collideSpriteVsTilemapLayer(e, t, i, n, o, r) : e.physicsType === s.GROUP && this.collideGroupVsTilemapLayer(e, t, i, n, o, r)));
          },
          collideSpriteVsSprite: function collideSpriteVsSprite(t, e, i, s, n, o) {
            return !(!t.body || !e.body) && (this.separate(t.body, e.body, s, n, o) && (i && i.call(n, t, e), this._total++), !0);
          },
          collideSpriteVsGroup: function collideSpriteVsGroup(t, e, i, n, o, r) {
            if (0 !== e.length && t.body) if (this.skipQuadTree || t.body.skipQuadTree) for (var a = {}, h = 0; h < e.hash.length; h++) {
              var l = e.hash[h];

              if (l && l.exists && l.body) {
                if (a = l.body.getBounds(a), this.sortDirection === s.Physics.Arcade.LEFT_RIGHT) {
                  if (t.body.right < a.x) break;
                  if (a.right < t.body.x) continue;
                } else if (this.sortDirection === s.Physics.Arcade.RIGHT_LEFT) {
                  if (t.body.x > a.right) break;
                  if (a.x > t.body.right) continue;
                } else if (this.sortDirection === s.Physics.Arcade.TOP_BOTTOM) {
                  if (t.body.bottom < a.y) break;
                  if (a.bottom < t.body.y) continue;
                } else if (this.sortDirection === s.Physics.Arcade.BOTTOM_TOP) {
                  if (t.body.y > a.bottom) break;
                  if (a.y > t.body.bottom) continue;
                }

                this.collideSpriteVsSprite(t, l, i, n, o, r);
              }
            } else {
              this.quadTree.clear(), this.quadTree.reset(this.game.world.bounds.x, this.game.world.bounds.y, this.game.world.bounds.width, this.game.world.bounds.height, this.maxObjects, this.maxLevels), this.quadTree.populate(e);
              var c = this.quadTree.retrieve(t);

              for (h = 0; h < c.length; h++) {
                this.separate(t.body, c[h], n, o, r) && (i && i.call(o, t, c[h].sprite), this._total++);
              }
            }
          },
          collideGroupVsSelf: function collideGroupVsSelf(t, e, i, n, o) {
            if (0 !== t.length) for (var r = 0; r < t.hash.length; r++) {
              var a = {},
                  h = t.hash[r];

              if (h && h.exists && h.body) {
                a = h.body.getBounds(a);

                for (var l = r + 1; l < t.hash.length; l++) {
                  var c = {},
                      u = t.hash[l];

                  if (u && u.exists && u.body) {
                    if (c = u.body.getBounds(c), this.sortDirection === s.Physics.Arcade.LEFT_RIGHT) {
                      if (a.right < c.x) break;
                      if (c.right < a.x) continue;
                    } else if (this.sortDirection === s.Physics.Arcade.RIGHT_LEFT) {
                      if (a.x > c.right) continue;
                      if (c.x > a.right) break;
                    } else if (this.sortDirection === s.Physics.Arcade.TOP_BOTTOM) {
                      if (a.bottom < c.y) continue;
                      if (c.bottom < a.y) break;
                    } else if (this.sortDirection === s.Physics.Arcade.BOTTOM_TOP) {
                      if (a.y > c.bottom) continue;
                      if (c.y > h.body.bottom) break;
                    }

                    this.collideSpriteVsSprite(h, u, e, i, n, o);
                  }
                }
              }
            }
          },
          collideGroupVsGroup: function collideGroupVsGroup(t, e, i, n, o, r) {
            if (0 !== t.length && 0 !== e.length) for (var a = 0; a < t.children.length; a++) {
              t.children[a].exists && (t.children[a].physicsType === s.GROUP ? this.collideGroupVsGroup(t.children[a], e, i, n, o, r) : this.collideSpriteVsGroup(t.children[a], e, i, n, o, r));
            }
          },
          separate: function separate(t, e, i, s, n) {
            if (!t.enable || !e.enable || t.checkCollision.none || e.checkCollision.none || !this.intersects(t, e)) return !1;
            if (i && !1 === i.call(s, t.sprite, e.sprite)) return !1;
            if (t.isCircle && e.isCircle) return this.separateCircle(t, e, n);

            if (t.isCircle !== e.isCircle) {
              var o = t.isCircle ? e : t,
                  r = t.isCircle ? t : e,
                  a = {
                x: o.x,
                y: o.y,
                right: o.right,
                bottom: o.bottom
              },
                  h = r.center;
              if ((h.y < a.y || h.y > a.bottom) && (h.x < a.x || h.x > a.right)) return this.separateCircle(t, e, n);
            }

            var l = !1,
                c = !1;
            this.forceX || Math.abs(this.gravity.y + t.gravity.y) < Math.abs(this.gravity.x + t.gravity.x) ? (l = this.separateX(t, e, n), this.intersects(t, e) && (c = this.separateY(t, e, n))) : (c = this.separateY(t, e, n), this.intersects(t, e) && (l = this.separateX(t, e, n)));
            var u = l || c;
            return u && (n ? (t.onOverlap && t.onOverlap.dispatch(t.sprite, e.sprite), e.onOverlap && e.onOverlap.dispatch(e.sprite, t.sprite)) : (t.onCollide && t.onCollide.dispatch(t.sprite, e.sprite), e.onCollide && e.onCollide.dispatch(e.sprite, t.sprite))), u;
          },
          intersects: function intersects(t, e) {
            return t !== e && (t.isCircle ? e.isCircle ? s.Math.distance(t.center.x, t.center.y, e.center.x, e.center.y) <= t.halfWidth + e.halfWidth : this.circleBodyIntersects(t, e) : e.isCircle ? this.circleBodyIntersects(e, t) : !(t.right <= e.position.x) && !(t.bottom <= e.position.y) && !(t.position.x >= e.right) && !(t.position.y >= e.bottom));
          },
          circleBodyIntersects: function circleBodyIntersects(t, e) {
            var i = s.Math.clamp(t.center.x, e.left, e.right),
                n = s.Math.clamp(t.center.y, e.top, e.bottom);
            return (t.center.x - i) * (t.center.x - i) + (t.center.y - n) * (t.center.y - n) <= t.halfWidth * t.halfWidth;
          },
          separateCircle: function separateCircle(t, e, i) {
            this.getOverlapX(t, e), this.getOverlapY(t, e);
            var n = e.center.x - t.center.x,
                o = e.center.y - t.center.y,
                r = Math.atan2(o, n),
                a = 0;

            if (t.isCircle !== e.isCircle) {
              var h = {
                x: e.isCircle ? t.position.x : e.position.x,
                y: e.isCircle ? t.position.y : e.position.y,
                right: e.isCircle ? t.right : e.right,
                bottom: e.isCircle ? t.bottom : e.bottom
              },
                  l = {
                x: t.isCircle ? t.center.x : e.center.x,
                y: t.isCircle ? t.center.y : e.center.y,
                radius: t.isCircle ? t.halfWidth : e.halfWidth
              };
              l.y < h.y ? l.x < h.x ? a = s.Math.distance(l.x, l.y, h.x, h.y) - l.radius : l.x > h.right && (a = s.Math.distance(l.x, l.y, h.right, h.y) - l.radius) : l.y > h.bottom && (l.x < h.x ? a = s.Math.distance(l.x, l.y, h.x, h.bottom) - l.radius : l.x > h.right && (a = s.Math.distance(l.x, l.y, h.right, h.bottom) - l.radius)), a *= -1;
            } else a = t.halfWidth + e.halfWidth - s.Math.distance(t.center.x, t.center.y, e.center.x, e.center.y);

            if (i || 0 === a || t.immovable && e.immovable || t.customSeparateX || e.customSeparateX) return 0 !== a && (t.onOverlap && t.onOverlap.dispatch(t.sprite, e.sprite), e.onOverlap && e.onOverlap.dispatch(e.sprite, t.sprite)), 0 !== a;
            var c = t.velocity.x * Math.cos(r) + t.velocity.y * Math.sin(r),
                u = -t.velocity.x * Math.sin(r) + t.velocity.y * Math.cos(r),
                d = e.velocity.x * Math.cos(r) + e.velocity.y * Math.sin(r),
                p = -e.velocity.x * Math.sin(r) + e.velocity.y * Math.cos(r),
                f = ((t.mass - e.mass) * c + 2 * e.mass * d) / (t.mass + e.mass),
                g = (2 * t.mass * c + (e.mass - t.mass) * d) / (t.mass + e.mass);
            return t.immovable || (t.velocity.x = (f * Math.cos(r) - u * Math.sin(r)) * t.bounce.x, t.velocity.y = (u * Math.cos(r) + f * Math.sin(r)) * t.bounce.y), e.immovable || (e.velocity.x = (g * Math.cos(r) - p * Math.sin(r)) * e.bounce.x, e.velocity.y = (p * Math.cos(r) + g * Math.sin(r)) * e.bounce.y), Math.abs(r) < Math.PI / 2 ? t.velocity.x > 0 && !t.immovable && e.velocity.x > t.velocity.x ? t.velocity.x *= -1 : e.velocity.x < 0 && !e.immovable && t.velocity.x < e.velocity.x ? e.velocity.x *= -1 : t.velocity.y > 0 && !t.immovable && e.velocity.y > t.velocity.y ? t.velocity.y *= -1 : e.velocity.y < 0 && !e.immovable && t.velocity.y < e.velocity.y && (e.velocity.y *= -1) : Math.abs(r) > Math.PI / 2 && (t.velocity.x < 0 && !t.immovable && e.velocity.x < t.velocity.x ? t.velocity.x *= -1 : e.velocity.x > 0 && !e.immovable && t.velocity.x > e.velocity.x ? e.velocity.x *= -1 : t.velocity.y < 0 && !t.immovable && e.velocity.y < t.velocity.y ? t.velocity.y *= -1 : e.velocity.y > 0 && !e.immovable && t.velocity.x > e.velocity.y && (e.velocity.y *= -1)), t.immovable || (t.x += t.velocity.x * this.game.time.physicsElapsed - a * Math.cos(r), t.y += t.velocity.y * this.game.time.physicsElapsed - a * Math.sin(r)), e.immovable || (e.x += e.velocity.x * this.game.time.physicsElapsed + a * Math.cos(r), e.y += e.velocity.y * this.game.time.physicsElapsed + a * Math.sin(r)), t.onCollide && t.onCollide.dispatch(t.sprite, e.sprite), e.onCollide && e.onCollide.dispatch(e.sprite, t.sprite), !0;
          },
          getOverlapX: function getOverlapX(t, e, i) {
            var s = 0,
                n = t.deltaAbsX() + e.deltaAbsX() + this.OVERLAP_BIAS;
            return 0 === t.deltaX() && 0 === e.deltaX() ? (t.embedded = !0, e.embedded = !0) : t.deltaX() > e.deltaX() ? (s = t.right - e.x) > n && !i || !1 === t.checkCollision.right || !1 === e.checkCollision.left ? s = 0 : (t.touching.none = !1, t.touching.right = !0, e.touching.none = !1, e.touching.left = !0) : t.deltaX() < e.deltaX() && (-(s = t.x - e.width - e.x) > n && !i || !1 === t.checkCollision.left || !1 === e.checkCollision.right ? s = 0 : (t.touching.none = !1, t.touching.left = !0, e.touching.none = !1, e.touching.right = !0)), t.overlapX = s, e.overlapX = s, s;
          },
          getOverlapY: function getOverlapY(t, e, i) {
            var s = 0,
                n = t.deltaAbsY() + e.deltaAbsY() + this.OVERLAP_BIAS;
            return 0 === t.deltaY() && 0 === e.deltaY() ? (t.embedded = !0, e.embedded = !0) : t.deltaY() > e.deltaY() ? (s = t.bottom - e.y) > n && !i || !1 === t.checkCollision.down || !1 === e.checkCollision.up ? s = 0 : (t.touching.none = !1, t.touching.down = !0, e.touching.none = !1, e.touching.up = !0) : t.deltaY() < e.deltaY() && (-(s = t.y - e.bottom) > n && !i || !1 === t.checkCollision.up || !1 === e.checkCollision.down ? s = 0 : (t.touching.none = !1, t.touching.up = !0, e.touching.none = !1, e.touching.down = !0)), t.overlapY = s, e.overlapY = s, s;
          },
          separateX: function separateX(t, e, i) {
            var s = this.getOverlapX(t, e, i);
            if (i || 0 === s || t.immovable && e.immovable || t.customSeparateX || e.customSeparateX) return 0 !== s || t.embedded && e.embedded;
            var n = t.velocity.x,
                o = e.velocity.x;
            if (t.immovable || e.immovable) t.immovable ? (e.x += s, e.velocity.x = n - o * e.bounce.x, t.moves && (e.y += (t.y - t.prev.y) * t.friction.y)) : (t.x -= s, t.velocity.x = o - n * t.bounce.x, e.moves && (t.y += (e.y - e.prev.y) * e.friction.y));else {
              s *= .5, t.x -= s, e.x += s;
              var r = Math.sqrt(o * o * e.mass / t.mass) * (o > 0 ? 1 : -1),
                  a = Math.sqrt(n * n * t.mass / e.mass) * (n > 0 ? 1 : -1),
                  h = .5 * (r + a);
              r -= h, a -= h, t.velocity.x = h + r * t.bounce.x, e.velocity.x = h + a * e.bounce.x;
            }
            return !0;
          },
          separateY: function separateY(t, e, i) {
            var s = this.getOverlapY(t, e, i);
            if (i || 0 === s || t.immovable && e.immovable || t.customSeparateY || e.customSeparateY) return 0 !== s || t.embedded && e.embedded;
            var n = t.velocity.y,
                o = e.velocity.y;
            if (t.immovable || e.immovable) t.immovable ? (e.y += s, e.velocity.y = n - o * e.bounce.y, t.moves && (e.x += (t.x - t.prev.x) * t.friction.x)) : (t.y -= s, t.velocity.y = o - n * t.bounce.y, e.moves && (t.x += (e.x - e.prev.x) * e.friction.x));else {
              s *= .5, t.y -= s, e.y += s;
              var r = Math.sqrt(o * o * e.mass / t.mass) * (o > 0 ? 1 : -1),
                  a = Math.sqrt(n * n * t.mass / e.mass) * (n > 0 ? 1 : -1),
                  h = .5 * (r + a);
              r -= h, a -= h, t.velocity.y = h + r * t.bounce.y, e.velocity.y = h + a * e.bounce.y;
            }
            return !0;
          },
          getObjectsUnderPointer: function getObjectsUnderPointer(t, e, i, s) {
            if (0 !== e.length && t.exists) return this.getObjectsAtLocation(t.x, t.y, e, i, s, t);
          },
          getObjectsAtLocation: function getObjectsAtLocation(t, e, i, n, o, r) {
            this.quadTree.clear(), this.quadTree.reset(this.game.world.bounds.x, this.game.world.bounds.y, this.game.world.bounds.width, this.game.world.bounds.height, this.maxObjects, this.maxLevels), this.quadTree.populate(i);

            for (var a = new s.Rectangle(t, e, 1, 1), h = [], l = this.quadTree.retrieve(a), c = 0; c < l.length; c++) {
              l[c].hitTest(t, e) && (n && n.call(o, r, l[c].sprite), h.push(l[c].sprite));
            }

            return h;
          },
          moveToObject: function moveToObject(t, e, i, n) {
            void 0 === i && (i = 60), void 0 === n && (n = 0);
            var o = s.Point.angle(e, t);
            return n > 0 && (i = this.distanceBetween(t, e) / (n / 1e3)), t.body.velocity.setToPolar(o, i), o;
          },
          moveToPointer: function moveToPointer(t, e, i, s) {
            void 0 === e && (e = 60), i = i || this.game.input.activePointer, void 0 === s && (s = 0);
            var n = this.angleToPointer(t, i);
            return s > 0 && (e = this.distanceToPointer(t, i) / (s / 1e3)), t.body.velocity.setToPolar(n, e), n;
          },
          moveToXY: function moveToXY(t, e, i, s, n) {
            void 0 === s && (s = 60), void 0 === n && (n = 0);
            var o = Math.atan2(i - t.y, e - t.x);
            return n > 0 && (s = this.distanceToXY(t, e, i) / (n / 1e3)), t.body.velocity.setToPolar(o, s), o;
          },
          velocityFromAngle: function velocityFromAngle(t, e, i) {
            return void 0 === e && (e = 60), (i = i || new s.Point()).setToPolar(t, e, !0);
          },
          velocityFromRotation: function velocityFromRotation(t, e, i) {
            return void 0 === e && (e = 60), (i = i || new s.Point()).setToPolar(t, e);
          },
          accelerationFromRotation: function accelerationFromRotation(t, e, i) {
            return void 0 === e && (e = 60), (i = i || new s.Point()).setToPolar(t, e);
          },
          accelerateToObject: function accelerateToObject(t, e, i, s, n) {
            void 0 === i && (i = 60), void 0 === s && (s = 1e3), void 0 === n && (n = 1e3);
            var o = this.angleBetween(t, e);
            return t.body.acceleration.setToPolar(o, i), t.body.maxVelocity.setTo(s, n), o;
          },
          accelerateToPointer: function accelerateToPointer(t, e, i, s, n) {
            void 0 === i && (i = 60), void 0 === e && (e = this.game.input.activePointer), void 0 === s && (s = 1e3), void 0 === n && (n = 1e3);
            var o = this.angleToPointer(t, e);
            return t.body.acceleration.setToPolar(o, i), t.body.maxVelocity.setTo(s, n), o;
          },
          accelerateToXY: function accelerateToXY(t, e, i, s, n, o) {
            void 0 === s && (s = 60), void 0 === n && (n = 1e3), void 0 === o && (o = 1e3);
            var r = this.angleToXY(t, e, i);
            return t.body.acceleration.setTo(r, s), t.body.maxVelocity.setTo(n, o), r;
          },
          distanceBetween: function distanceBetween(t, e, i, s) {
            var n, o;
            return void 0 === i && (i = !1), s ? (n = t.centerX - e.centerX, o = t.centerY - e.centerY) : i ? (n = t.world.x - e.world.x, o = t.world.y - e.world.y) : (n = t.x - e.x, o = t.y - e.y), Math.sqrt(n * n + o * o);
          },
          distanceToXY: function distanceToXY(t, e, i, s) {
            void 0 === s && (s = !1);
            var n = s ? t.world.x - e : t.x - e,
                o = s ? t.world.y - i : t.y - i;
            return Math.sqrt(n * n + o * o);
          },
          distanceToPointer: function distanceToPointer(t, e, i) {
            void 0 === e && (e = this.game.input.activePointer), void 0 === i && (i = !1);
            var s = i ? t.world.x - e.worldX : t.x - e.worldX,
                n = i ? t.world.y - e.worldY : t.y - e.worldY;
            return Math.sqrt(s * s + n * n);
          },
          closest: function closest(t, e, i, s) {
            for (var n = 1 / 0, o = null, r = 0, a = e.length; r < a; r++) {
              var h = e[r],
                  l = this.distanceBetween(t, h, i, s);
              l < n && (o = h, n = l);
            }

            return o;
          },
          farthest: function farthest(t, e, i, s) {
            for (var n = -1, o = null, r = 0, a = e.length; r < a; r++) {
              var h = e[r],
                  l = this.distanceBetween(t, h, i, s);
              l > n && (o = h, n = l);
            }

            return o;
          },
          angleBetween: function angleBetween(t, e, i) {
            return void 0 === i && (i = !1), i ? s.Point.angle(e.world, t.world) : s.Point.angle(e, t);
          },
          angleBetweenCenters: function angleBetweenCenters(t, e) {
            var i = e.centerX - t.centerX,
                s = e.centerY - t.centerY;
            return Math.atan2(s, i);
          },
          angleToXY: function angleToXY(t, e, i, s) {
            return void 0 === s && (s = !1), s ? Math.atan2(i - t.world.y, e - t.world.x) : Math.atan2(i - t.y, e - t.x);
          },
          angleToPointer: function angleToPointer(t, e, i) {
            return void 0 === e && (e = this.game.input.activePointer), void 0 === i && (i = !1), i ? Math.atan2(e.worldY - t.world.y, e.worldX - t.world.x) : Math.atan2(e.worldY - t.y, e.worldX - t.x);
          },
          worldAngleToPointer: function worldAngleToPointer(t, e) {
            return this.angleToPointer(t, e, !0);
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.Arcade.Body = function (t) {
          this.sprite = t, this.game = t.game, this.type = s.Physics.ARCADE, this.enable = !0, this.isCircle = !1, this.radius = 0, this.offset = new s.Point(), this.position = new s.Point(t.x, t.y), this.prev = new s.Point(this.position.x, this.position.y), this.allowRotation = !0, this.rotation = t.angle, this.preRotation = t.angle, this.width = t.width, this.height = t.height, this.sourceWidth = t.width, this.sourceHeight = t.height, t.texture && (this.sourceWidth = t.texture.frame.width, this.sourceHeight = t.texture.frame.height), this.halfWidth = Math.abs(t.width / 2), this.halfHeight = Math.abs(t.height / 2), this.center = new s.Point(t.x + this.halfWidth, t.y + this.halfHeight), this.velocity = new s.Point(), this.newVelocity = new s.Point(), this.deltaMax = new s.Point(), this.acceleration = new s.Point(), this.allowDrag = !0, this.drag = new s.Point(), this.allowGravity = !0, this.gravity = new s.Point(), this.bounce = new s.Point(), this.worldBounce = null, this.onWorldBounds = null, this.onCollide = null, this.onOverlap = null, this.maxVelocity = new s.Point(1e4, 1e4), this.friction = new s.Point(1, 0), this.angularVelocity = 0, this.angularAcceleration = 0, this.angularDrag = 0, this.maxAngular = 1e3, this.mass = 1, this.angle = 0, this.speed = 0, this.facing = s.NONE, this.immovable = !1, this.moves = !0, this.customSeparateX = !1, this.customSeparateY = !1, this.overlapX = 0, this.overlapY = 0, this.overlapR = 0, this.embedded = !1, this.collideWorldBounds = !1, this.checkCollision = {
            none: !1,
            up: !0,
            down: !0,
            left: !0,
            right: !0
          }, this.touching = {
            none: !0,
            up: !1,
            down: !1,
            left: !1,
            right: !1
          }, this.wasTouching = {
            none: !0,
            up: !1,
            down: !1,
            left: !1,
            right: !1
          }, this.blocked = {
            none: !0,
            up: !1,
            down: !1,
            left: !1,
            right: !1
          }, this.tilePadding = new s.Point(), this.dirty = !1, this.skipQuadTree = !1, this.syncBounds = !1, this.isMoving = !1, this.stopVelocityOnCollide = !0, this.moveTimer = 0, this.moveDistance = 0, this.moveDuration = 0, this.moveTarget = null, this.moveEnd = null, this.onMoveComplete = new s.Signal(), this.movementCallback = null, this.movementCallbackContext = null, this._reset = !0, this._sx = t.scale.x, this._sy = t.scale.y, this._dx = 0, this._dy = 0;
        }, s.Physics.Arcade.Body.prototype = {
          updateBounds: function updateBounds() {
            if (this.syncBounds) {
              var t = this.sprite.getBounds();
              t.ceilAll(), t.width === this.width && t.height === this.height || (this.width = t.width, this.height = t.height, this._reset = !0);
            } else {
              var e = Math.abs(this.sprite.scale.x),
                  i = Math.abs(this.sprite.scale.y);
              e === this._sx && i === this._sy || (this.width = this.sourceWidth * e, this.height = this.sourceHeight * i, this._sx = e, this._sy = i, this._reset = !0);
            }

            this._reset && (this.halfWidth = Math.floor(this.width / 2), this.halfHeight = Math.floor(this.height / 2), this.updateCenter());
          },
          updateCenter: function updateCenter() {
            this.center.setTo(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
          },
          preUpdate: function preUpdate() {
            this.enable && !this.game.physics.arcade.isPaused && (this.dirty = !0, this.wasTouching.none = this.touching.none, this.wasTouching.up = this.touching.up, this.wasTouching.down = this.touching.down, this.wasTouching.left = this.touching.left, this.wasTouching.right = this.touching.right, this.touching.none = !0, this.touching.up = !1, this.touching.down = !1, this.touching.left = !1, this.touching.right = !1, this.blocked.none = !0, this.blocked.up = !1, this.blocked.down = !1, this.blocked.left = !1, this.blocked.right = !1, this.overlapR = 0, this.overlapX = 0, this.overlapY = 0, this.embedded = !1, this.updateBounds(), this.position.x = this.sprite.world.x - this.sprite.anchor.x * this.sprite.width + this.sprite.scale.x * this.offset.x, this.position.x -= this.sprite.scale.x < 0 ? this.width : 0, this.position.y = this.sprite.world.y - this.sprite.anchor.y * this.sprite.height + this.sprite.scale.y * this.offset.y, this.position.y -= this.sprite.scale.y < 0 ? this.height : 0, this.updateCenter(), this.rotation = this.sprite.angle, this.preRotation = this.rotation, (this._reset || this.sprite.fresh) && (this.prev.x = this.position.x, this.prev.y = this.position.y), this.moves && (this.game.physics.arcade.updateMotion(this), this.newVelocity.set(this.velocity.x * this.game.time.physicsElapsed, this.velocity.y * this.game.time.physicsElapsed), this.position.x += this.newVelocity.x, this.position.y += this.newVelocity.y, this.updateCenter(), this.position.x === this.prev.x && this.position.y === this.prev.y || (this.angle = this.velocity.atan()), this.speed = Math.sqrt(this.velocity.x * this.velocity.x + this.velocity.y * this.velocity.y), this.collideWorldBounds && this.checkWorldBounds() && this.onWorldBounds && this.onWorldBounds.dispatch(this.sprite, this.blocked.up, this.blocked.down, this.blocked.left, this.blocked.right)), this._dx = this.deltaX(), this._dy = this.deltaY(), this._reset = !1);
          },
          updateMovement: function updateMovement() {
            var t = 0,
                e = 0 !== this.overlapX || 0 !== this.overlapY;
            if (this.moveDuration > 0 ? (this.moveTimer += this.game.time.elapsedMS, t = this.moveTimer / this.moveDuration) : (this.moveTarget.end.set(this.position.x, this.position.y), t = this.moveTarget.length / this.moveDistance), this.movementCallback) var i = this.movementCallback.call(this.movementCallbackContext, this, this.velocity, t);
            return !(e || t >= 1 || void 0 !== i && !0 !== i) || (this.stopMovement(t >= 1 || this.stopVelocityOnCollide && e), !1);
          },
          stopMovement: function stopMovement(t) {
            this.isMoving && (this.isMoving = !1, t && this.velocity.set(0), this.onMoveComplete.dispatch(this.sprite, 0 !== this.overlapX || 0 !== this.overlapY));
          },
          postUpdate: function postUpdate() {
            this.enable && this.dirty && (this.isMoving && this.updateMovement(), this.dirty = !1, this.deltaX() < 0 ? this.facing = s.LEFT : this.deltaX() > 0 && (this.facing = s.RIGHT), this.deltaY() < 0 ? this.facing = s.UP : this.deltaY() > 0 && (this.facing = s.DOWN), this.moves && (this._dx = this.deltaX(), this._dy = this.deltaY(), 0 !== this.deltaMax.x && 0 !== this._dx && (this._dx < 0 && this._dx < -this.deltaMax.x ? this._dx = -this.deltaMax.x : this._dx > 0 && this._dx > this.deltaMax.x && (this._dx = this.deltaMax.x)), 0 !== this.deltaMax.y && 0 !== this._dy && (this._dy < 0 && this._dy < -this.deltaMax.y ? this._dy = -this.deltaMax.y : this._dy > 0 && this._dy > this.deltaMax.y && (this._dy = this.deltaMax.y)), this.sprite.position.x += this._dx, this.sprite.position.y += this._dy, this._reset = !0), this.updateCenter(), this.allowRotation && (this.sprite.angle += this.deltaZ()), this.prev.x = this.position.x, this.prev.y = this.position.y);
          },
          checkWorldBounds: function checkWorldBounds() {
            var t = this.position,
                e = this.game.physics.arcade.bounds,
                i = this.game.physics.arcade.checkCollision,
                s = this.worldBounce ? -this.worldBounce.x : -this.bounce.x,
                n = this.worldBounce ? -this.worldBounce.y : -this.bounce.y;
            return t.x < e.x && i.left ? (t.x = e.x, this.velocity.x *= s, this.blocked.left = !0, this.blocked.none = !1) : this.right > e.right && i.right && (t.x = e.right - this.width, this.velocity.x *= s, this.blocked.right = !0, this.blocked.none = !1), t.y < e.y && i.up ? (t.y = e.y, this.velocity.y *= n, this.blocked.up = !0, this.blocked.none = !1) : this.bottom > e.bottom && i.down && (t.y = e.bottom - this.height, this.velocity.y *= n, this.blocked.down = !0, this.blocked.none = !1), !this.blocked.none;
          },
          moveFrom: function moveFrom(t, e, i) {
            return void 0 === e && (e = this.speed), 0 !== e && (void 0 === i ? (s = this.angle, i = this.game.math.radToDeg(s)) : s = this.game.math.degToRad(i), this.moveTimer = 0, this.moveDuration = t, 0 === i || 180 === i ? this.velocity.set(Math.cos(s) * e, 0) : 90 === i || 270 === i ? this.velocity.set(0, Math.sin(s) * e) : this.velocity.setToPolar(s, e), this.isMoving = !0, !0);
            var s;
          },
          moveTo: function moveTo(t, e, i) {
            var n,
                o = e / (t / 1e3);
            return 0 !== o && (void 0 === i ? (n = this.angle, i = this.game.math.radToDeg(n)) : n = this.game.math.degToRad(i), e = Math.abs(e), this.moveDuration = 0, this.moveDistance = e, null === this.moveTarget && (this.moveTarget = new s.Line(), this.moveEnd = new s.Point()), this.moveTarget.fromAngle(this.x, this.y, n, e), this.moveEnd.set(this.moveTarget.end.x, this.moveTarget.end.y), this.moveTarget.setTo(this.x, this.y, this.x, this.y), 0 === i || 180 === i ? this.velocity.set(Math.cos(n) * o, 0) : 90 === i || 270 === i ? this.velocity.set(0, Math.sin(n) * o) : this.velocity.setToPolar(n, o), this.isMoving = !0, !0);
          },
          setSize: function setSize(t, e, i, s) {
            void 0 === i && (i = this.offset.x), void 0 === s && (s = this.offset.y), this.sourceWidth = t, this.sourceHeight = e, this.width = this.sourceWidth * this._sx, this.height = this.sourceHeight * this._sy, this.halfWidth = Math.floor(this.width / 2), this.halfHeight = Math.floor(this.height / 2), this.offset.setTo(i, s), this.updateCenter(), this.isCircle = !1, this.radius = 0;
          },
          setCircle: function setCircle(t, e, i) {
            void 0 === e && (e = this.offset.x), void 0 === i && (i = this.offset.y), t > 0 ? (this.isCircle = !0, this.radius = t, this.sourceWidth = 2 * t, this.sourceHeight = 2 * t, this.width = this.sourceWidth * this._sx, this.height = this.sourceHeight * this._sy, this.halfWidth = Math.floor(this.width / 2), this.halfHeight = Math.floor(this.height / 2), this.offset.setTo(e, i), this.updateCenter()) : this.isCircle = !1;
          },
          reset: function reset(t, e) {
            this.stop(), this.position.x = t - this.sprite.anchor.x * this.sprite.width + this.sprite.scale.x * this.offset.x, this.position.x -= this.sprite.scale.x < 0 ? this.width : 0, this.position.y = e - this.sprite.anchor.y * this.sprite.height + this.sprite.scale.y * this.offset.y, this.position.y -= this.sprite.scale.y < 0 ? this.height : 0, this.prev.x = this.position.x, this.prev.y = this.position.y, this.rotation = this.sprite.angle, this.preRotation = this.rotation, this.updateBounds(), this.updateCenter();
          },
          stop: function stop() {
            this.velocity.set(0), this.acceleration.set(0), this.speed = 0, this.angularVelocity = 0, this.angularAcceleration = 0;
          },
          getBounds: function getBounds(t) {
            return t.x = this.x, t.y = this.y, t.right = this.right, t.bottom = this.bottom, t;
          },
          hitTest: function hitTest(t, e) {
            return this.isCircle ? s.Circle.contains(this, t, e) : s.Rectangle.contains(this, t, e);
          },
          onFloor: function onFloor() {
            return this.blocked.down;
          },
          onCeiling: function onCeiling() {
            return this.blocked.up;
          },
          onWall: function onWall() {
            return this.blocked.left || this.blocked.right;
          },
          deltaAbsX: function deltaAbsX() {
            return this.deltaX() > 0 ? this.deltaX() : -this.deltaX();
          },
          deltaAbsY: function deltaAbsY() {
            return this.deltaY() > 0 ? this.deltaY() : -this.deltaY();
          },
          deltaX: function deltaX() {
            return this.position.x - this.prev.x;
          },
          deltaY: function deltaY() {
            return this.position.y - this.prev.y;
          },
          deltaZ: function deltaZ() {
            return this.rotation - this.preRotation;
          },
          destroy: function destroy() {
            this.sprite.parent && this.sprite.parent instanceof s.Group && this.sprite.parent.removeFromHash(this.sprite), this.sprite.body = null, this.sprite = null;
          }
        }, Object.defineProperty(s.Physics.Arcade.Body.prototype, "left", {
          get: function get() {
            return this.position.x;
          }
        }), Object.defineProperty(s.Physics.Arcade.Body.prototype, "right", {
          get: function get() {
            return this.position.x + this.width;
          }
        }), Object.defineProperty(s.Physics.Arcade.Body.prototype, "top", {
          get: function get() {
            return this.position.y;
          }
        }), Object.defineProperty(s.Physics.Arcade.Body.prototype, "bottom", {
          get: function get() {
            return this.position.y + this.height;
          }
        }), Object.defineProperty(s.Physics.Arcade.Body.prototype, "x", {
          get: function get() {
            return this.position.x;
          },
          set: function set(t) {
            this.position.x = t;
          }
        }), Object.defineProperty(s.Physics.Arcade.Body.prototype, "y", {
          get: function get() {
            return this.position.y;
          },
          set: function set(t) {
            this.position.y = t;
          }
        }), s.Physics.Arcade.Body.render = function (t, e, i, s, n) {
          void 0 === s && (s = !0), i = i || "rgba(0,255,0,0.4)", t.fillStyle = i, t.strokeStyle = i, t.lineWidth = n || 1, e.isCircle ? (t.beginPath(), t.arc(e.center.x - e.game.camera.x, e.center.y - e.game.camera.y, e.halfWidth, 0, 2 * Math.PI), s ? t.fill() : t.stroke()) : s ? t.fillRect(e.position.x - e.game.camera.x, e.position.y - e.game.camera.y, e.width, e.height) : t.strokeRect(e.position.x - e.game.camera.x, e.position.y - e.game.camera.y, e.width, e.height);
        }, s.Physics.Arcade.Body.renderBodyInfo = function (t, e) {
          t.line("x: " + e.x.toFixed(2), "y: " + e.y.toFixed(2), "width: " + e.width, "height: " + e.height), t.line("velocity x: " + e.velocity.x.toFixed(2), "y: " + e.velocity.y.toFixed(2), "deltaX: " + e._dx.toFixed(2), "deltaY: " + e._dy.toFixed(2)), t.line("acceleration x: " + e.acceleration.x.toFixed(2), "y: " + e.acceleration.y.toFixed(2), "speed: " + e.speed.toFixed(2), "angle: " + e.angle.toFixed(2)), t.line("gravity x: " + e.gravity.x, "y: " + e.gravity.y, "bounce x: " + e.bounce.x.toFixed(2), "y: " + e.bounce.y.toFixed(2)), t.line("touching left: " + e.touching.left, "right: " + e.touching.right, "up: " + e.touching.up, "down: " + e.touching.down), t.line("blocked left: " + e.blocked.left, "right: " + e.blocked.right, "up: " + e.blocked.up, "down: " + e.blocked.down);
        }, s.Physics.Arcade.Body.prototype.constructor = s.Physics.Arcade.Body,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.Arcade.TilemapCollision = function () {}, s.Physics.Arcade.TilemapCollision.prototype = {
          TILE_BIAS: 16,
          collideSpriteVsTilemapLayer: function collideSpriteVsTilemapLayer(t, e, i, s, n, o) {
            if (t.body) {
              var r = e.getTiles(t.body.position.x - t.body.tilePadding.x - e.getTileOffsetX(), t.body.position.y - t.body.tilePadding.y - e.getTileOffsetY(), t.body.width + t.body.tilePadding.x, t.body.height + t.body.tilePadding.y, !1, !1);
              if (0 !== r.length) for (var a = 0; a < r.length; a++) {
                s ? s.call(n, t, r[a]) && this.separateTile(a, t.body, r[a], e, o) && (this._total++, i && i.call(n, t, r[a])) : this.separateTile(a, t.body, r[a], e, o) && (this._total++, i && i.call(n, t, r[a]));
              }
            }
          },
          collideGroupVsTilemapLayer: function collideGroupVsTilemapLayer(t, e, i, s, n, o) {
            if (0 !== t.length) for (var r = 0; r < t.children.length; r++) {
              t.children[r].exists && this.collideSpriteVsTilemapLayer(t.children[r], e, i, s, n, o);
            }
          },
          separateTile: function separateTile(t, e, i, s, n) {
            if (!e.enable) return !1;
            var o = s.getTileOffsetX(),
                r = s.getTileOffsetY();
            if (!i.intersects(e.position.x - o, e.position.y - r, e.right - o, e.bottom - r)) return !1;
            if (n) return !0;
            if (i.collisionCallback && !i.collisionCallback.call(i.collisionCallbackContext, e.sprite, i)) return !1;
            if (void 0 !== i.layer.callbacks && i.layer.callbacks[i.index] && !i.layer.callbacks[i.index].callback.call(i.layer.callbacks[i.index].callbackContext, e.sprite, i)) return !1;
            if (!(i.faceLeft || i.faceRight || i.faceTop || i.faceBottom)) return !1;
            var a = 0,
                h = 0,
                l = 0,
                c = 1;

            if (e.deltaAbsX() > e.deltaAbsY() ? l = -1 : e.deltaAbsX() < e.deltaAbsY() && (c = -1), 0 !== e.deltaX() && 0 !== e.deltaY() && (i.faceLeft || i.faceRight) && (i.faceTop || i.faceBottom) && (l = Math.min(Math.abs(e.position.x - o - i.right), Math.abs(e.right - o - i.left)), c = Math.min(Math.abs(e.position.y - r - i.bottom), Math.abs(e.bottom - r - i.top))), l < c) {
              if ((i.faceLeft || i.faceRight) && 0 !== (a = this.tileCheckX(e, i, s)) && !i.intersects(e.position.x - o, e.position.y - r, e.right - o, e.bottom - r)) return !0;
              (i.faceTop || i.faceBottom) && (h = this.tileCheckY(e, i, s));
            } else {
              if ((i.faceTop || i.faceBottom) && 0 !== (h = this.tileCheckY(e, i, s)) && !i.intersects(e.position.x - o, e.position.y - r, e.right - o, e.bottom - r)) return !0;
              (i.faceLeft || i.faceRight) && (a = this.tileCheckX(e, i, s));
            }

            return 0 !== a || 0 !== h;
          },
          tileCheckX: function tileCheckX(t, e, i) {
            var s = 0,
                n = i.getTileOffsetX();
            return t.deltaX() < 0 && !t.blocked.left && e.collideRight && t.checkCollision.left ? e.faceRight && t.x - n < e.right && (s = t.x - n - e.right) < -this.TILE_BIAS && (s = 0) : t.deltaX() > 0 && !t.blocked.right && e.collideLeft && t.checkCollision.right && e.faceLeft && t.right - n > e.left && (s = t.right - n - e.left) > this.TILE_BIAS && (s = 0), 0 !== s && (t.customSeparateX ? t.overlapX = s : this.processTileSeparationX(t, s)), s;
          },
          tileCheckY: function tileCheckY(t, e, i) {
            var s = 0,
                n = i.getTileOffsetY();
            return t.deltaY() < 0 && !t.blocked.up && e.collideDown && t.checkCollision.up ? e.faceBottom && t.y - n < e.bottom && (s = t.y - n - e.bottom) < -this.TILE_BIAS && (s = 0) : t.deltaY() > 0 && !t.blocked.down && e.collideUp && t.checkCollision.down && e.faceTop && t.bottom - n > e.top && (s = t.bottom - n - e.top) > this.TILE_BIAS && (s = 0), 0 !== s && (t.customSeparateY ? t.overlapY = s : this.processTileSeparationY(t, s)), s;
          },
          processTileSeparationX: function processTileSeparationX(t, e) {
            e < 0 ? (t.blocked.left = !0, t.blocked.none = !1) : e > 0 && (t.blocked.right = !0, t.blocked.none = !1), t.position.x -= e, 0 === t.bounce.x ? t.velocity.x = 0 : t.velocity.x = -t.velocity.x * t.bounce.x;
          },
          processTileSeparationY: function processTileSeparationY(t, e) {
            e < 0 ? (t.blocked.up = !0, t.blocked.none = !1) : e > 0 && (t.blocked.down = !0, t.blocked.none = !1), t.position.y -= e, 0 === t.bounce.y ? t.velocity.y = 0 : t.velocity.y = -t.velocity.y * t.bounce.y;
          }
        }, s.Utils.mixinPrototype(s.Physics.Arcade.prototype, s.Physics.Arcade.TilemapCollision.prototype),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        p2.Body.prototype.parent = null, p2.Spring.prototype.parent = null, s.Physics.P2 = function (t, e) {
          this.game = t, void 0 === e ? e = {
            gravity: [0, 0],
            broadphase: new p2.SAPBroadphase()
          } : (e.hasOwnProperty("gravity") || (e.gravity = [0, 0]), e.hasOwnProperty("broadphase") || (e.broadphase = new p2.SAPBroadphase())), this.config = e, this.world = new p2.World(this.config), this.frameRate = 1 / 60, this.useElapsedTime = !1, this.paused = !1, this.materials = [], this.gravity = new s.Physics.P2.InversePointProxy(this, this.world.gravity), this.walls = {
            left: null,
            right: null,
            top: null,
            bottom: null
          }, this.onBodyAdded = new s.Signal(), this.onBodyRemoved = new s.Signal(), this.onSpringAdded = new s.Signal(), this.onSpringRemoved = new s.Signal(), this.onConstraintAdded = new s.Signal(), this.onConstraintRemoved = new s.Signal(), this.onContactMaterialAdded = new s.Signal(), this.onContactMaterialRemoved = new s.Signal(), this.postBroadphaseCallback = null, this.callbackContext = null, this.onBeginContact = new s.Signal(), this.onEndContact = new s.Signal(), e.hasOwnProperty("mpx") && e.hasOwnProperty("pxm") && e.hasOwnProperty("mpxi") && e.hasOwnProperty("pxmi") && (this.mpx = e.mpx, this.mpxi = e.mpxi, this.pxm = e.pxm, this.pxmi = e.pxmi), this.world.on("beginContact", this.beginContactHandler, this), this.world.on("endContact", this.endContactHandler, this), this.collisionGroups = [], this.nothingCollisionGroup = new s.Physics.P2.CollisionGroup(1), this.boundsCollisionGroup = new s.Physics.P2.CollisionGroup(2), this.everythingCollisionGroup = new s.Physics.P2.CollisionGroup(2147483648), this.boundsCollidesWith = [], this._toRemove = [], this._collisionGroupID = 2, this._boundsLeft = !0, this._boundsRight = !0, this._boundsTop = !0, this._boundsBottom = !0, this._boundsOwnGroup = !1, this.setBoundsToWorld(!0, !0, !0, !0, !1);
        }, s.Physics.P2.prototype = {
          removeBodyNextStep: function removeBodyNextStep(t) {
            this._toRemove.push(t);
          },
          preUpdate: function preUpdate() {
            for (var t = this._toRemove.length; t--;) {
              this.removeBody(this._toRemove[t]);
            }

            this._toRemove.length = 0;
          },
          enable: function enable(t, e, i) {
            void 0 === e && (e = !1), void 0 === i && (i = !0);
            var n = 1;
            if (Array.isArray(t)) for (n = t.length; n--;) {
              t[n] instanceof s.Group ? this.enable(t[n].children, e, i) : (this.enableBody(t[n], e), i && t[n].hasOwnProperty("children") && t[n].children.length > 0 && this.enable(t[n], e, !0));
            } else t instanceof s.Group ? this.enable(t.children, e, i) : (this.enableBody(t, e), i && t.hasOwnProperty("children") && t.children.length > 0 && this.enable(t.children, e, !0));
          },
          enableBody: function enableBody(t, e) {
            t.hasOwnProperty("body") && null === t.body && (t.body = new s.Physics.P2.Body(this.game, t, t.x, t.y, 1), t.body.debug = e, void 0 !== t.anchor && t.anchor.set(.5));
          },
          setImpactEvents: function setImpactEvents(t) {
            t ? this.world.on("impact", this.impactHandler, this) : this.world.off("impact", this.impactHandler, this);
          },
          setPostBroadphaseCallback: function setPostBroadphaseCallback(t, e) {
            this.postBroadphaseCallback = t, this.callbackContext = e, null !== t ? this.world.on("postBroadphase", this.postBroadphaseHandler, this) : this.world.off("postBroadphase", this.postBroadphaseHandler, this);
          },
          postBroadphaseHandler: function postBroadphaseHandler(t) {
            if (this.postBroadphaseCallback && 0 !== t.pairs.length) for (var e = t.pairs.length - 2; e >= 0; e -= 2) {
              t.pairs[e].parent && t.pairs[e + 1].parent && !this.postBroadphaseCallback.call(this.callbackContext, t.pairs[e].parent, t.pairs[e + 1].parent) && t.pairs.splice(e, 2);
            }
          },
          impactHandler: function impactHandler(t) {
            if (t.bodyA.parent && t.bodyB.parent) {
              var e = t.bodyA.parent,
                  i = t.bodyB.parent;
              e._bodyCallbacks[t.bodyB.id] && e._bodyCallbacks[t.bodyB.id].call(e._bodyCallbackContext[t.bodyB.id], e, i, t.shapeA, t.shapeB), i._bodyCallbacks[t.bodyA.id] && i._bodyCallbacks[t.bodyA.id].call(i._bodyCallbackContext[t.bodyA.id], i, e, t.shapeB, t.shapeA), e._groupCallbacks[t.shapeB.collisionGroup] && e._groupCallbacks[t.shapeB.collisionGroup].call(e._groupCallbackContext[t.shapeB.collisionGroup], e, i, t.shapeA, t.shapeB), i._groupCallbacks[t.shapeA.collisionGroup] && i._groupCallbacks[t.shapeA.collisionGroup].call(i._groupCallbackContext[t.shapeA.collisionGroup], i, e, t.shapeB, t.shapeA);
            }
          },
          beginContactHandler: function beginContactHandler(t) {
            t.bodyA && t.bodyB && (this.onBeginContact.dispatch(t.bodyA, t.bodyB, t.shapeA, t.shapeB, t.contactEquations), t.bodyA.parent && t.bodyA.parent.onBeginContact.dispatch(t.bodyB.parent, t.bodyB, t.shapeA, t.shapeB, t.contactEquations), t.bodyB.parent && t.bodyB.parent.onBeginContact.dispatch(t.bodyA.parent, t.bodyA, t.shapeB, t.shapeA, t.contactEquations));
          },
          endContactHandler: function endContactHandler(t) {
            t.bodyA && t.bodyB && (this.onEndContact.dispatch(t.bodyA, t.bodyB, t.shapeA, t.shapeB), t.bodyA.parent && t.bodyA.parent.onEndContact.dispatch(t.bodyB.parent, t.bodyB, t.shapeA, t.shapeB), t.bodyB.parent && t.bodyB.parent.onEndContact.dispatch(t.bodyA.parent, t.bodyA, t.shapeB, t.shapeA));
          },
          setBoundsToWorld: function setBoundsToWorld(t, e, i, s, n) {
            this.setBounds(this.game.world.bounds.x, this.game.world.bounds.y, this.game.world.bounds.width, this.game.world.bounds.height, t, e, i, s, n);
          },
          setWorldMaterial: function setWorldMaterial(t, e, i, s, n) {
            void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === s && (s = !0), void 0 === n && (n = !0), e && this.walls.left && (this.walls.left.shapes[0].material = t), i && this.walls.right && (this.walls.right.shapes[0].material = t), s && this.walls.top && (this.walls.top.shapes[0].material = t), n && this.walls.bottom && (this.walls.bottom.shapes[0].material = t);
          },
          updateBoundsCollisionGroup: function updateBoundsCollisionGroup(t) {
            void 0 === t && (t = !0);
            var e = t ? this.boundsCollisionGroup.mask : this.everythingCollisionGroup.mask;
            this.walls.left && (this.walls.left.shapes[0].collisionGroup = e), this.walls.right && (this.walls.right.shapes[0].collisionGroup = e), this.walls.top && (this.walls.top.shapes[0].collisionGroup = e), this.walls.bottom && (this.walls.bottom.shapes[0].collisionGroup = e), this._boundsOwnGroup = t;
          },
          setBounds: function setBounds(t, e, i, s, n, o, r, a, h) {
            void 0 === n && (n = this._boundsLeft), void 0 === o && (o = this._boundsRight), void 0 === r && (r = this._boundsTop), void 0 === a && (a = this._boundsBottom), void 0 === h && (h = this._boundsOwnGroup), this.setupWall(n, "left", t, e, 1.5707963267948966, h), this.setupWall(o, "right", t + i, e, -1.5707963267948966, h), this.setupWall(r, "top", t, e, -3.141592653589793, h), this.setupWall(a, "bottom", t, e + s, 0, h), this._boundsLeft = n, this._boundsRight = o, this._boundsTop = r, this._boundsBottom = a, this._boundsOwnGroup = h;
          },
          setupWall: function setupWall(t, e, i, s, n, o) {
            t ? (this.walls[e] ? this.walls[e].position = [this.pxmi(i), this.pxmi(s)] : (this.walls[e] = new p2.Body({
              mass: 0,
              position: [this.pxmi(i), this.pxmi(s)],
              angle: n
            }), this.walls[e].addShape(new p2.Plane()), this.world.addBody(this.walls[e])), o && (this.walls[e].shapes[0].collisionGroup = this.boundsCollisionGroup.mask)) : this.walls[e] && (this.world.removeBody(this.walls[e]), this.walls[e] = null);
          },
          pause: function pause() {
            this.paused = !0;
          },
          resume: function resume() {
            this.paused = !1;
          },
          update: function update() {
            this.paused || (this.useElapsedTime ? this.world.step(this.game.time.physicsElapsed) : this.world.step(this.frameRate));
          },
          reset: function reset() {
            this.world.on("beginContact", this.beginContactHandler, this), this.world.on("endContact", this.endContactHandler, this), this.nothingCollisionGroup = new s.Physics.P2.CollisionGroup(1), this.boundsCollisionGroup = new s.Physics.P2.CollisionGroup(2), this.everythingCollisionGroup = new s.Physics.P2.CollisionGroup(2147483648), this._collisionGroupID = 2, this.setBoundsToWorld(!0, !0, !0, !0, !1);
          },
          clear: function clear() {
            this.world.time = 0, this.world.fixedStepTime = 0, this.world.solver && this.world.solver.equations.length && this.world.solver.removeAllEquations();

            for (var t = this.world.constraints, e = t.length - 1; e >= 0; e--) {
              this.world.removeConstraint(t[e]);
            }

            var i = this.world.bodies;

            for (e = i.length - 1; e >= 0; e--) {
              this.world.removeBody(i[e]);
            }

            var s = this.world.springs;

            for (e = s.length - 1; e >= 0; e--) {
              this.world.removeSpring(s[e]);
            }

            var n = this.world.contactMaterials;

            for (e = n.length - 1; e >= 0; e--) {
              this.world.removeContactMaterial(n[e]);
            }

            this.world.off("beginContact", this.beginContactHandler, this), this.world.off("endContact", this.endContactHandler, this), this.postBroadphaseCallback = null, this.callbackContext = null, this.impactCallback = null, this.collisionGroups = [], this._toRemove = [], this.boundsCollidesWith = [], this.walls = {
              left: null,
              right: null,
              top: null,
              bottom: null
            };
          },
          destroy: function destroy() {
            this.clear(), this.game = null;
          },
          addBody: function addBody(t) {
            return !t.data.world && (this.world.addBody(t.data), this.onBodyAdded.dispatch(t), !0);
          },
          removeBody: function removeBody(t) {
            return t.data.world === this.world && (this.world.removeBody(t.data), this.onBodyRemoved.dispatch(t)), t;
          },
          addSpring: function addSpring(t) {
            return t instanceof s.Physics.P2.Spring || t instanceof s.Physics.P2.RotationalSpring ? this.world.addSpring(t.data) : this.world.addSpring(t), this.onSpringAdded.dispatch(t), t;
          },
          removeSpring: function removeSpring(t) {
            return t instanceof s.Physics.P2.Spring || t instanceof s.Physics.P2.RotationalSpring ? this.world.removeSpring(t.data) : this.world.removeSpring(t), this.onSpringRemoved.dispatch(t), t;
          },
          createDistanceConstraint: function createDistanceConstraint(t, e, i, n, o, r) {
            if (t = this.getBody(t), e = this.getBody(e), t && e) return this.addConstraint(new s.Physics.P2.DistanceConstraint(this, t, e, i, n, o, r));
            console.warn("Cannot create Constraint, invalid body objects given");
          },
          createGearConstraint: function createGearConstraint(t, e, i, n) {
            if (t = this.getBody(t), e = this.getBody(e), t && e) return this.addConstraint(new s.Physics.P2.GearConstraint(this, t, e, i, n));
            console.warn("Cannot create Constraint, invalid body objects given");
          },
          createRevoluteConstraint: function createRevoluteConstraint(t, e, i, n, o, r) {
            if (t = this.getBody(t), i = this.getBody(i), t && i) return this.addConstraint(new s.Physics.P2.RevoluteConstraint(this, t, e, i, n, o, r));
            console.warn("Cannot create Constraint, invalid body objects given");
          },
          createLockConstraint: function createLockConstraint(t, e, i, n, o) {
            if (t = this.getBody(t), e = this.getBody(e), t && e) return this.addConstraint(new s.Physics.P2.LockConstraint(this, t, e, i, n, o));
            console.warn("Cannot create Constraint, invalid body objects given");
          },
          createPrismaticConstraint: function createPrismaticConstraint(t, e, i, n, o, r, a) {
            if (t = this.getBody(t), e = this.getBody(e), t && e) return this.addConstraint(new s.Physics.P2.PrismaticConstraint(this, t, e, i, n, o, r, a));
            console.warn("Cannot create Constraint, invalid body objects given");
          },
          addConstraint: function addConstraint(t) {
            return this.world.addConstraint(t), this.onConstraintAdded.dispatch(t), t;
          },
          removeConstraint: function removeConstraint(t) {
            return this.world.removeConstraint(t), this.onConstraintRemoved.dispatch(t), t;
          },
          addContactMaterial: function addContactMaterial(t) {
            return this.world.addContactMaterial(t), this.onContactMaterialAdded.dispatch(t), t;
          },
          removeContactMaterial: function removeContactMaterial(t) {
            return this.world.removeContactMaterial(t), this.onContactMaterialRemoved.dispatch(t), t;
          },
          getContactMaterial: function getContactMaterial(t, e) {
            return this.world.getContactMaterial(t, e);
          },
          setMaterial: function setMaterial(t, e) {
            for (var i = e.length; i--;) {
              e[i].setMaterial(t);
            }
          },
          createMaterial: function createMaterial(t, e) {
            t = t || "";
            var i = new s.Physics.P2.Material(t);
            return this.materials.push(i), void 0 !== e && e.setMaterial(i), i;
          },
          createContactMaterial: function createContactMaterial(t, e, i) {
            void 0 === t && (t = this.createMaterial()), void 0 === e && (e = this.createMaterial());
            var n = new s.Physics.P2.ContactMaterial(t, e, i);
            return this.addContactMaterial(n);
          },
          getBodies: function getBodies() {
            for (var t = [], e = this.world.bodies.length; e--;) {
              t.push(this.world.bodies[e].parent);
            }

            return t;
          },
          getBody: function getBody(t) {
            return t instanceof p2.Body ? t : t instanceof s.Physics.P2.Body ? t.data : t.body && t.body.type === s.Physics.P2JS ? t.body.data : null;
          },
          getSprings: function getSprings() {
            for (var t = [], e = this.world.springs.length; e--;) {
              t.push(this.world.springs[e].parent);
            }

            return t;
          },
          getConstraints: function getConstraints() {
            for (var t = [], e = this.world.constraints.length; e--;) {
              t.push(this.world.constraints[e]);
            }

            return t;
          },
          hitTest: function hitTest(t, e, i, n) {
            void 0 === e && (e = this.world.bodies), void 0 === i && (i = 5), void 0 === n && (n = !1);

            for (var o = [this.pxmi(t.x), this.pxmi(t.y)], r = [], a = e.length; a--;) {
              e[a] instanceof s.Physics.P2.Body && (!n || e[a].data.type !== p2.Body.STATIC) ? r.push(e[a].data) : e[a] instanceof p2.Body && e[a].parent && (!n || e[a].type !== p2.Body.STATIC) ? r.push(e[a]) : e[a] instanceof s.Sprite && e[a].hasOwnProperty("body") && (!n || e[a].body.data.type !== p2.Body.STATIC) && r.push(e[a].body.data);
            }

            return this.world.hitTest(o, r, i);
          },
          toJSON: function toJSON() {
            return this.world.toJSON();
          },
          createCollisionGroup: function createCollisionGroup(t) {
            var e = Math.pow(2, this._collisionGroupID);
            this.walls.left && (this.walls.left.shapes[0].collisionMask = this.walls.left.shapes[0].collisionMask | e), this.walls.right && (this.walls.right.shapes[0].collisionMask = this.walls.right.shapes[0].collisionMask | e), this.walls.top && (this.walls.top.shapes[0].collisionMask = this.walls.top.shapes[0].collisionMask | e), this.walls.bottom && (this.walls.bottom.shapes[0].collisionMask = this.walls.bottom.shapes[0].collisionMask | e), this._collisionGroupID++;
            var i = new s.Physics.P2.CollisionGroup(e);
            return this.collisionGroups.push(i), t && this.setCollisionGroup(t, i), i;
          },
          setCollisionGroup: function setCollisionGroup(t, e) {
            if (t instanceof s.Group) for (var i = 0; i < t.total; i++) {
              t.children[i].body && t.children[i].body.type === s.Physics.P2JS && t.children[i].body.setCollisionGroup(e);
            } else t.body.setCollisionGroup(e);
          },
          createSpring: function createSpring(t, e, i, n, o, r, a, h, l) {
            if (t = this.getBody(t), e = this.getBody(e), t && e) return this.addSpring(new s.Physics.P2.Spring(this, t, e, i, n, o, r, a, h, l));
            console.warn("Cannot create Spring, invalid body objects given");
          },
          createRotationalSpring: function createRotationalSpring(t, e, i, n, o) {
            if (t = this.getBody(t), e = this.getBody(e), t && e) return this.addSpring(new s.Physics.P2.RotationalSpring(this, t, e, i, n, o));
            console.warn("Cannot create Rotational Spring, invalid body objects given");
          },
          createBody: function createBody(t, e, i, n, o, r) {
            void 0 === n && (n = !1);
            var a = new s.Physics.P2.Body(this.game, null, t, e, i);
            if (r && !a.addPolygon(o, r)) return !1;
            return n && this.world.addBody(a.data), a;
          },
          createParticle: function createParticle(t, e, i, n, o, r) {
            void 0 === n && (n = !1);
            var a = new s.Physics.P2.Body(this.game, null, t, e, i);
            if (r && !a.addPolygon(o, r)) return !1;
            return n && this.world.addBody(a.data), a;
          },
          convertCollisionObjects: function convertCollisionObjects(t, e, i) {
            void 0 === i && (i = !0);

            for (var s = [], n = 0, o = t.collision[e].length; n < o; n++) {
              var r = t.collision[e][n],
                  a = r.polyline || r.polygon;
              if (a) var h = this.createBody(r.x, r.y, 0, i, {}, a);else if (r.rectangle) {
                (h = this.createBody(r.x, r.y, 0, i)).addRectangle(r.width, r.height, r.width / 2, r.height / 2);
              }
              h && s.push(h);
            }

            return s;
          },
          clearTilemapLayerBodies: function clearTilemapLayerBodies(t, e) {
            e = t.getLayer(e);

            for (var i = t.layers[e].bodies.length; i--;) {
              t.layers[e].bodies[i].destroy();
            }

            t.layers[e].bodies.length = 0;
          },
          convertTilemap: function convertTilemap(t, e, i, s) {
            e = t.getLayer(e), void 0 === i && (i = !0), void 0 === s && (s = !0), this.clearTilemapLayerBodies(t, e);

            for (var n = 0, o = 0, r = 0, a = 0, h = t.layers[e].height; a < h; a++) {
              n = 0;

              for (var l = 0, c = t.layers[e].width; l < c; l++) {
                var u = t.layers[e].data[a][l];
                if (u && u.index > -1 && u.collides) if (s) {
                  var d = t.getTileRight(e, l, a);
                  if (0 === n && (o = u.x * u.width, r = u.y * u.height, n = u.width), d && d.collides) n += u.width;else (p = this.createBody(o, r, 0, !1)).addRectangle(n, u.height, n / 2, u.height / 2, 0), i && this.addBody(p), t.layers[e].bodies.push(p), n = 0;
                } else {
                  var p;
                  (p = this.createBody(u.x * u.width, u.y * u.height, 0, !1)).addRectangle(u.width, u.height, u.width / 2, u.height / 2, 0), i && this.addBody(p), t.layers[e].bodies.push(p);
                }
              }
            }

            return t.layers[e].bodies;
          },
          mpx: function mpx(t) {
            return 20 * t;
          },
          pxm: function pxm(t) {
            return .05 * t;
          },
          mpxi: function mpxi(t) {
            return -20 * t;
          },
          pxmi: function pxmi(t) {
            return -.05 * t;
          }
        }, Object.defineProperty(s.Physics.P2.prototype, "friction", {
          get: function get() {
            return this.world.defaultContactMaterial.friction;
          },
          set: function set(t) {
            this.world.defaultContactMaterial.friction = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "restitution", {
          get: function get() {
            return this.world.defaultContactMaterial.restitution;
          },
          set: function set(t) {
            this.world.defaultContactMaterial.restitution = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "contactMaterial", {
          get: function get() {
            return this.world.defaultContactMaterial;
          },
          set: function set(t) {
            this.world.defaultContactMaterial = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "applySpringForces", {
          get: function get() {
            return this.world.applySpringForces;
          },
          set: function set(t) {
            this.world.applySpringForces = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "applyDamping", {
          get: function get() {
            return this.world.applyDamping;
          },
          set: function set(t) {
            this.world.applyDamping = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "applyGravity", {
          get: function get() {
            return this.world.applyGravity;
          },
          set: function set(t) {
            this.world.applyGravity = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "solveConstraints", {
          get: function get() {
            return this.world.solveConstraints;
          },
          set: function set(t) {
            this.world.solveConstraints = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "time", {
          get: function get() {
            return this.world.time;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "emitImpactEvent", {
          get: function get() {
            return this.world.emitImpactEvent;
          },
          set: function set(t) {
            this.world.emitImpactEvent = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "sleepMode", {
          get: function get() {
            return this.world.sleepMode;
          },
          set: function set(t) {
            this.world.sleepMode = t;
          }
        }), Object.defineProperty(s.Physics.P2.prototype, "total", {
          get: function get() {
            return this.world.bodies.length;
          }
        }),
        /**
        * @author       Georgios Kaleadis https://github.com/georgiee
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.FixtureList = function (t) {
          Array.isArray(t) || (t = [t]), this.rawList = t, this.init(), this.parse(this.rawList);
        }, s.Physics.P2.FixtureList.prototype = {
          init: function init() {
            this.namedFixtures = {}, this.groupedFixtures = [], this.allFixtures = [];
          },
          setCategory: function setCategory(t, e) {
            this.getFixtures(e).forEach(function (e) {
              e.collisionGroup = t;
            });
          },
          setMask: function setMask(t, e) {
            this.getFixtures(e).forEach(function (e) {
              e.collisionMask = t;
            });
          },
          setSensor: function setSensor(t, e) {
            this.getFixtures(e).forEach(function (e) {
              e.sensor = t;
            });
          },
          setMaterial: function setMaterial(t, e) {
            this.getFixtures(e).forEach(function (e) {
              e.material = t;
            });
          },
          getFixtures: function getFixtures(t) {
            var e = [];

            if (t) {
              t instanceof Array || (t = [t]);
              var i = this;
              return t.forEach(function (t) {
                i.namedFixtures[t] && e.push(i.namedFixtures[t]);
              }), this.flatten(e);
            }

            return this.allFixtures;
          },
          getFixtureByKey: function getFixtureByKey(t) {
            return this.namedFixtures[t];
          },
          getGroup: function getGroup(t) {
            return this.groupedFixtures[t];
          },
          parse: function parse() {
            var t, e, i, s;

            for (t in s = [], i = this.rawList) {
              e = i[t], isNaN(t - 0) ? this.namedFixtures[t] = this.flatten(e) : (this.groupedFixtures[t] = this.groupedFixtures[t] || [], this.groupedFixtures[t] = this.groupedFixtures[t].concat(e)), s.push(this.allFixtures = this.flatten(this.groupedFixtures));
            }
          },
          flatten: function flatten(t) {
            var e, i;
            return e = [], i = arguments.callee, t.forEach(function (t) {
              return Array.prototype.push.apply(e, Array.isArray(t) ? i(t) : [t]);
            }), e;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.PointProxy = function (t, e) {
          this.world = t, this.destination = e;
        }, s.Physics.P2.PointProxy.prototype.constructor = s.Physics.P2.PointProxy, Object.defineProperty(s.Physics.P2.PointProxy.prototype, "x", {
          get: function get() {
            return this.world.mpx(this.destination[0]);
          },
          set: function set(t) {
            this.destination[0] = this.world.pxm(t);
          }
        }), Object.defineProperty(s.Physics.P2.PointProxy.prototype, "y", {
          get: function get() {
            return this.world.mpx(this.destination[1]);
          },
          set: function set(t) {
            this.destination[1] = this.world.pxm(t);
          }
        }), Object.defineProperty(s.Physics.P2.PointProxy.prototype, "mx", {
          get: function get() {
            return this.destination[0];
          },
          set: function set(t) {
            this.destination[0] = t;
          }
        }), Object.defineProperty(s.Physics.P2.PointProxy.prototype, "my", {
          get: function get() {
            return this.destination[1];
          },
          set: function set(t) {
            this.destination[1] = t;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.InversePointProxy = function (t, e) {
          this.world = t, this.destination = e;
        }, s.Physics.P2.InversePointProxy.prototype.constructor = s.Physics.P2.InversePointProxy, Object.defineProperty(s.Physics.P2.InversePointProxy.prototype, "x", {
          get: function get() {
            return this.world.mpxi(this.destination[0]);
          },
          set: function set(t) {
            this.destination[0] = this.world.pxmi(t);
          }
        }), Object.defineProperty(s.Physics.P2.InversePointProxy.prototype, "y", {
          get: function get() {
            return this.world.mpxi(this.destination[1]);
          },
          set: function set(t) {
            this.destination[1] = this.world.pxmi(t);
          }
        }), Object.defineProperty(s.Physics.P2.InversePointProxy.prototype, "mx", {
          get: function get() {
            return this.destination[0];
          },
          set: function set(t) {
            this.destination[0] = -t;
          }
        }), Object.defineProperty(s.Physics.P2.InversePointProxy.prototype, "my", {
          get: function get() {
            return this.destination[1];
          },
          set: function set(t) {
            this.destination[1] = -t;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.Body = function (t, e, i, n, o) {
          e = e || null, i = i || 0, n = n || 0, void 0 === o && (o = 1), this.game = t, this.world = t.physics.p2, this.sprite = e, this.type = s.Physics.P2JS, this.offset = new s.Point(), this.data = new p2.Body({
            position: [this.world.pxmi(i), this.world.pxmi(n)],
            mass: o
          }), this.data.parent = this, this.velocity = new s.Physics.P2.InversePointProxy(this.world, this.data.velocity), this.force = new s.Physics.P2.InversePointProxy(this.world, this.data.force), this.gravity = new s.Point(), this.onBeginContact = new s.Signal(), this.onEndContact = new s.Signal(), this.collidesWith = [], this.removeNextStep = !1, this.debugBody = null, this.dirty = !1, this._collideWorldBounds = !0, this._bodyCallbacks = {}, this._bodyCallbackContext = {}, this._groupCallbacks = {}, this._groupCallbackContext = {}, this._reset = !1, e && (this.setRectangleFromSprite(e), e.exists && this.game.physics.p2.addBody(this));
        }, s.Physics.P2.Body.prototype = {
          createBodyCallback: function createBodyCallback(t, e, i) {
            var s = -1;
            t.id ? s = t.id : t.body && (s = t.body.id), s > -1 && (null === e ? (delete this._bodyCallbacks[s], delete this._bodyCallbackContext[s]) : (this._bodyCallbacks[s] = e, this._bodyCallbackContext[s] = i));
          },
          createGroupCallback: function createGroupCallback(t, e, i) {
            null === e ? (delete this._groupCallbacks[t.mask], delete this._groupCallbackContext[t.mask]) : (this._groupCallbacks[t.mask] = e, this._groupCallbackContext[t.mask] = i);
          },
          getCollisionMask: function getCollisionMask() {
            var t = 0;
            this._collideWorldBounds && (t = this.game.physics.p2.boundsCollisionGroup.mask);

            for (var e = 0; e < this.collidesWith.length; e++) {
              t |= this.collidesWith[e].mask;
            }

            return t;
          },
          updateCollisionMask: function updateCollisionMask(t) {
            var e = this.getCollisionMask();
            if (void 0 === t) for (var i = this.data.shapes.length - 1; i >= 0; i--) {
              this.data.shapes[i].collisionMask = e;
            } else t.collisionMask = e;
          },
          setCollisionGroup: function setCollisionGroup(t, e) {
            var i = this.getCollisionMask();
            if (void 0 === e) for (var s = this.data.shapes.length - 1; s >= 0; s--) {
              this.data.shapes[s].collisionGroup = t.mask, this.data.shapes[s].collisionMask = i;
            } else e.collisionGroup = t.mask, e.collisionMask = i;
          },
          clearCollision: function clearCollision(t, e, i) {
            if (void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === i) for (var s = this.data.shapes.length - 1; s >= 0; s--) {
              t && (this.data.shapes[s].collisionGroup = null), e && (this.data.shapes[s].collisionMask = null);
            } else t && (i.collisionGroup = null), e && (i.collisionMask = null);
            t && (this.collidesWith.length = 0);
          },
          removeCollisionGroup: function removeCollisionGroup(t, e, i) {
            var s;
            if (void 0 === e && (e = !0), Array.isArray(t)) for (var n = 0; n < t.length; n++) {
              (s = this.collidesWith.indexOf(t[n])) > -1 && (this.collidesWith.splice(s, 1), e && (delete this._groupCallbacks[t.mask], delete this._groupCallbackContext[t.mask]));
            } else (s = this.collidesWith.indexOf(t)) > -1 && (this.collidesWith.splice(s, 1), e && (delete this._groupCallbacks[t.mask], delete this._groupCallbackContext[t.mask]));
            var o = this.getCollisionMask();
            if (void 0 === i) for (n = this.data.shapes.length - 1; n >= 0; n--) {
              this.data.shapes[n].collisionMask = o;
            } else i.collisionMask = o;
          },
          collides: function collides(t, e, i, s) {
            if (Array.isArray(t)) for (var n = 0; n < t.length; n++) {
              -1 === this.collidesWith.indexOf(t[n]) && (this.collidesWith.push(t[n]), e && this.createGroupCallback(t[n], e, i));
            } else -1 === this.collidesWith.indexOf(t) && (this.collidesWith.push(t), e && this.createGroupCallback(t, e, i));
            var o = this.getCollisionMask();
            if (void 0 === s) for (n = this.data.shapes.length - 1; n >= 0; n--) {
              this.data.shapes[n].collisionMask = o;
            } else s.collisionMask = o;
          },
          adjustCenterOfMass: function adjustCenterOfMass() {
            this.data.adjustCenterOfMass(), this.shapeChanged();
          },
          getVelocityAtPoint: function getVelocityAtPoint(t, e) {
            return this.data.getVelocityAtPoint(t, e);
          },
          applyDamping: function applyDamping(t) {
            this.data.applyDamping(t);
          },
          applyImpulse: function applyImpulse(t, e, i) {
            this.data.applyImpulse(t, [this.world.pxmi(e), this.world.pxmi(i)]);
          },
          applyImpulseLocal: function applyImpulseLocal(t, e, i) {
            this.data.applyImpulseLocal(t, [this.world.pxmi(e), this.world.pxmi(i)]);
          },
          applyForce: function applyForce(t, e, i) {
            this.data.applyForce(t, [this.world.pxmi(e), this.world.pxmi(i)]);
          },
          setZeroForce: function setZeroForce() {
            this.data.setZeroForce();
          },
          setZeroRotation: function setZeroRotation() {
            this.data.angularVelocity = 0;
          },
          setZeroVelocity: function setZeroVelocity() {
            this.data.velocity[0] = 0, this.data.velocity[1] = 0;
          },
          setZeroDamping: function setZeroDamping() {
            this.data.damping = 0, this.data.angularDamping = 0;
          },
          toLocalFrame: function toLocalFrame(t, e) {
            return this.data.toLocalFrame(t, e);
          },
          toWorldFrame: function toWorldFrame(t, e) {
            return this.data.toWorldFrame(t, e);
          },
          rotateLeft: function rotateLeft(t) {
            this.data.angularVelocity = this.world.pxm(-t);
          },
          rotateRight: function rotateRight(t) {
            this.data.angularVelocity = this.world.pxm(t);
          },
          moveForward: function moveForward(t) {
            var e = this.world.pxmi(-t),
                i = this.data.angle + Math.PI / 2;
            this.data.velocity[0] = e * Math.cos(i), this.data.velocity[1] = e * Math.sin(i);
          },
          moveBackward: function moveBackward(t) {
            var e = this.world.pxmi(-t),
                i = this.data.angle + Math.PI / 2;
            this.data.velocity[0] = -e * Math.cos(i), this.data.velocity[1] = -e * Math.sin(i);
          },
          thrust: function thrust(t) {
            var e = this.world.pxmi(-t),
                i = this.data.angle + Math.PI / 2;
            this.data.force[0] += e * Math.cos(i), this.data.force[1] += e * Math.sin(i);
          },
          thrustLeft: function thrustLeft(t) {
            var e = this.world.pxmi(-t),
                i = this.data.angle;
            this.data.force[0] += e * Math.cos(i), this.data.force[1] += e * Math.sin(i);
          },
          thrustRight: function thrustRight(t) {
            var e = this.world.pxmi(-t),
                i = this.data.angle;
            this.data.force[0] -= e * Math.cos(i), this.data.force[1] -= e * Math.sin(i);
          },
          reverse: function reverse(t) {
            var e = this.world.pxmi(-t),
                i = this.data.angle + Math.PI / 2;
            this.data.force[0] -= e * Math.cos(i), this.data.force[1] -= e * Math.sin(i);
          },
          moveLeft: function moveLeft(t) {
            this.data.velocity[0] = this.world.pxmi(-t);
          },
          moveRight: function moveRight(t) {
            this.data.velocity[0] = this.world.pxmi(t);
          },
          moveUp: function moveUp(t) {
            this.data.velocity[1] = this.world.pxmi(-t);
          },
          moveDown: function moveDown(t) {
            this.data.velocity[1] = this.world.pxmi(t);
          },
          preUpdate: function preUpdate() {
            this.dirty = !0, this.removeNextStep && (this.removeFromWorld(), this.removeNextStep = !1);
          },
          postUpdate: function postUpdate() {
            this.sprite.x = this.world.mpxi(this.data.position[0]) + this.offset.x, this.sprite.y = this.world.mpxi(this.data.position[1]) + this.offset.y, this.fixedRotation || (this.sprite.rotation = this.data.angle), this.debugBody && this.debugBody.updateSpriteTransform(), this.dirty = !1;
          },
          reset: function reset(t, e, i, s) {
            void 0 === i && (i = !1), void 0 === s && (s = !1), this.setZeroForce(), this.setZeroVelocity(), this.setZeroRotation(), i && this.setZeroDamping(), s && (this.mass = 1), this.x = t, this.y = e;
          },
          addToWorld: function addToWorld() {
            if (this.game.physics.p2._toRemove) for (var t = 0; t < this.game.physics.p2._toRemove.length; t++) {
              this.game.physics.p2._toRemove[t] === this && this.game.physics.p2._toRemove.splice(t, 1);
            }
            this.data.world !== this.game.physics.p2.world && this.game.physics.p2.addBody(this);
          },
          removeFromWorld: function removeFromWorld() {
            this.data.world === this.game.physics.p2.world && this.game.physics.p2.removeBodyNextStep(this);
          },
          destroy: function destroy() {
            this.removeFromWorld(), this.clearShapes(), this._bodyCallbacks = {}, this._bodyCallbackContext = {}, this._groupCallbacks = {}, this._groupCallbackContext = {}, this.debugBody && this.debugBody.destroy(!0, !0), this.debugBody = null, this.sprite && (this.sprite.body = null, this.sprite = null);
          },
          clearShapes: function clearShapes() {
            for (var t = this.data.shapes.length; t--;) {
              this.data.removeShape(this.data.shapes[t]);
            }

            this.shapeChanged();
          },
          addShape: function addShape(t, e, i, s) {
            return void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === s && (s = 0), this.data.addShape(t, [this.world.pxmi(e), this.world.pxmi(i)], s), this.shapeChanged(), t;
          },
          addCircle: function addCircle(t, e, i, s) {
            var n = new p2.Circle({
              radius: this.world.pxm(t)
            });
            return this.addShape(n, e, i, s);
          },
          addRectangle: function addRectangle(t, e, i, s, n) {
            var o = new p2.Box({
              width: this.world.pxm(t),
              height: this.world.pxm(e)
            });
            return this.addShape(o, i, s, n);
          },
          addPlane: function addPlane(t, e, i) {
            var s = new p2.Plane();
            return this.addShape(s, t, e, i);
          },
          addParticle: function addParticle(t, e, i) {
            var s = new p2.Particle();
            return this.addShape(s, t, e, i);
          },
          addLine: function addLine(t, e, i, s) {
            var n = new p2.Line({
              length: this.world.pxm(t)
            });
            return this.addShape(n, e, i, s);
          },
          addCapsule: function addCapsule(t, e, i, s, n) {
            var o = new p2.Capsule({
              length: this.world.pxm(t),
              radius: this.world.pxm(e)
            });
            return this.addShape(o, i, s, n);
          },
          addPolygon: function addPolygon(t, e) {
            t = t || {}, Array.isArray(e) || (e = Array.prototype.slice.call(arguments, 1));
            var i = [];
            if (1 === e.length && Array.isArray(e[0])) i = e[0].slice(0);else if (Array.isArray(e[0])) i = e.slice();else if ("number" == typeof e[0]) for (var s = 0, n = e.length; s < n; s += 2) {
              i.push([e[s], e[s + 1]]);
            }
            var o = i.length - 1;
            i[o][0] === i[0][0] && i[o][1] === i[0][1] && i.pop();

            for (var r = 0; r < i.length; r++) {
              i[r][0] = this.world.pxmi(i[r][0]), i[r][1] = this.world.pxmi(i[r][1]);
            }

            var a = this.data.fromPolygon(i, t);
            return this.shapeChanged(), a;
          },
          removeShape: function removeShape(t) {
            var e = this.data.removeShape(t);
            return this.shapeChanged(), e;
          },
          setCircle: function setCircle(t, e, i, s) {
            return this.clearShapes(), this.addCircle(t, e, i, s);
          },
          setRectangle: function setRectangle(t, e, i, s, n) {
            return void 0 === t && (t = 16), void 0 === e && (e = 16), this.clearShapes(), this.addRectangle(t, e, i, s, n);
          },
          setRectangleFromSprite: function setRectangleFromSprite(t) {
            return void 0 === t && (t = this.sprite), this.clearShapes(), this.addRectangle(t.width, t.height, 0, 0, t.rotation);
          },
          setMaterial: function setMaterial(t, e) {
            if (void 0 === e) for (var i = this.data.shapes.length - 1; i >= 0; i--) {
              this.data.shapes[i].material = t;
            } else e.material = t;
          },
          shapeChanged: function shapeChanged() {
            this.debugBody && this.debugBody.draw();
          },
          addPhaserPolygon: function addPhaserPolygon(t, e) {
            for (var i = this.game.cache.getPhysicsData(t, e), s = [], n = 0; n < i.length; n++) {
              var o = i[n],
                  r = this.addFixture(o);
              s[o.filter.group] = s[o.filter.group] || [], s[o.filter.group] = s[o.filter.group].concat(r), o.fixtureKey && (s[o.fixtureKey] = r);
            }

            return this.data.aabbNeedsUpdate = !0, this.shapeChanged(), s;
          },
          addFixture: function addFixture(t) {
            var e = [];

            if (t.circle) {
              (l = new p2.Circle({
                radius: this.world.pxm(t.circle.radius)
              })).collisionGroup = t.filter.categoryBits, l.collisionMask = t.filter.maskBits, l.sensor = t.isSensor;
              var i = p2.vec2.create();
              i[0] = this.world.pxmi(t.circle.position[0] - this.sprite.width / 2), i[1] = this.world.pxmi(t.circle.position[1] - this.sprite.height / 2), this.data.addShape(l, i), e.push(l);
            } else for (var s = t.polygons, n = p2.vec2.create(), o = 0; o < s.length; o++) {
              for (var r = s[o], a = [], h = 0; h < r.length; h += 2) {
                a.push([this.world.pxmi(r[h]), this.world.pxmi(r[h + 1])]);
              }

              for (var l = new p2.Convex({
                vertices: a
              }), c = 0; c !== l.vertices.length; c++) {
                var u = l.vertices[c];
                p2.vec2.sub(u, u, l.centerOfMass);
              }

              p2.vec2.scale(n, l.centerOfMass, 1), n[0] -= this.world.pxmi(this.sprite.width / 2), n[1] -= this.world.pxmi(this.sprite.height / 2), l.updateTriangles(), l.updateCenterOfMass(), l.updateBoundingRadius(), l.collisionGroup = t.filter.categoryBits, l.collisionMask = t.filter.maskBits, l.sensor = t.isSensor, this.data.addShape(l, n), e.push(l);
            }

            return e;
          },
          loadPolygon: function loadPolygon(t, e, i) {
            if (null === t) var s = e;else s = this.game.cache.getPhysicsData(t, e);
            "number" != typeof i && (i = 1);

            for (var n = p2.vec2.create(), o = 0; o < s.length; o++) {
              for (var r = [], a = 0; a < s[o].shape.length; a += 2) {
                r.push([this.world.pxmi(s[o].shape[a] * i), this.world.pxmi(s[o].shape[a + 1] * i)]);
              }

              for (var h = new p2.Convex({
                vertices: r
              }), l = 0; l !== h.vertices.length; l++) {
                var c = h.vertices[l];
                p2.vec2.sub(c, c, h.centerOfMass);
              }

              p2.vec2.scale(n, h.centerOfMass, 1), n[0] -= this.world.pxmi(this.sprite.width / 2), n[1] -= this.world.pxmi(this.sprite.height / 2), h.updateTriangles(), h.updateCenterOfMass(), h.updateBoundingRadius(), this.data.addShape(h, n);
            }

            return this.data.aabbNeedsUpdate = !0, this.shapeChanged(), !0;
          }
        }, s.Physics.P2.Body.prototype.constructor = s.Physics.P2.Body, s.Physics.P2.Body.DYNAMIC = 1, s.Physics.P2.Body.STATIC = 2, s.Physics.P2.Body.KINEMATIC = 4, Object.defineProperty(s.Physics.P2.Body.prototype, "static", {
          get: function get() {
            return this.data.type === s.Physics.P2.Body.STATIC;
          },
          set: function set(t) {
            t && this.data.type !== s.Physics.P2.Body.STATIC ? (this.data.type = s.Physics.P2.Body.STATIC, this.mass = 0) : t || this.data.type !== s.Physics.P2.Body.STATIC || (this.data.type = s.Physics.P2.Body.DYNAMIC, this.mass = 1);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "dynamic", {
          get: function get() {
            return this.data.type === s.Physics.P2.Body.DYNAMIC;
          },
          set: function set(t) {
            t && this.data.type !== s.Physics.P2.Body.DYNAMIC ? (this.data.type = s.Physics.P2.Body.DYNAMIC, this.mass = 1) : t || this.data.type !== s.Physics.P2.Body.DYNAMIC || (this.data.type = s.Physics.P2.Body.STATIC, this.mass = 0);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "kinematic", {
          get: function get() {
            return this.data.type === s.Physics.P2.Body.KINEMATIC;
          },
          set: function set(t) {
            t && this.data.type !== s.Physics.P2.Body.KINEMATIC ? (this.data.type = s.Physics.P2.Body.KINEMATIC, this.mass = 4) : t || this.data.type !== s.Physics.P2.Body.KINEMATIC || (this.data.type = s.Physics.P2.Body.STATIC, this.mass = 0);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "allowSleep", {
          get: function get() {
            return this.data.allowSleep;
          },
          set: function set(t) {
            t !== this.data.allowSleep && (this.data.allowSleep = t);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "angle", {
          get: function get() {
            return s.Math.wrapAngle(s.Math.radToDeg(this.data.angle));
          },
          set: function set(t) {
            this.data.angle = s.Math.degToRad(s.Math.wrapAngle(t));
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "angularDamping", {
          get: function get() {
            return this.data.angularDamping;
          },
          set: function set(t) {
            this.data.angularDamping = t;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "angularForce", {
          get: function get() {
            return this.data.angularForce;
          },
          set: function set(t) {
            this.data.angularForce = t;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "angularVelocity", {
          get: function get() {
            return this.data.angularVelocity;
          },
          set: function set(t) {
            this.data.angularVelocity = t;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "damping", {
          get: function get() {
            return this.data.damping;
          },
          set: function set(t) {
            this.data.damping = t;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "fixedRotation", {
          get: function get() {
            return this.data.fixedRotation;
          },
          set: function set(t) {
            t !== this.data.fixedRotation && (this.data.fixedRotation = t);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "inertia", {
          get: function get() {
            return this.data.inertia;
          },
          set: function set(t) {
            this.data.inertia = t;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "mass", {
          get: function get() {
            return this.data.mass;
          },
          set: function set(t) {
            t !== this.data.mass && (this.data.mass = t, this.data.updateMassProperties());
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "motionState", {
          get: function get() {
            return this.data.type;
          },
          set: function set(t) {
            t !== this.data.type && (this.data.type = t);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "rotation", {
          get: function get() {
            return this.data.angle;
          },
          set: function set(t) {
            this.data.angle = t;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "sleepSpeedLimit", {
          get: function get() {
            return this.data.sleepSpeedLimit;
          },
          set: function set(t) {
            this.data.sleepSpeedLimit = t;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "x", {
          get: function get() {
            return this.world.mpxi(this.data.position[0]);
          },
          set: function set(t) {
            this.data.position[0] = this.world.pxmi(t);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "y", {
          get: function get() {
            return this.world.mpxi(this.data.position[1]);
          },
          set: function set(t) {
            this.data.position[1] = this.world.pxmi(t);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "id", {
          get: function get() {
            return this.data.id;
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "debug", {
          get: function get() {
            return null !== this.debugBody;
          },
          set: function set(t) {
            t && !this.debugBody ? this.debugBody = new s.Physics.P2.BodyDebug(this.game, this.data) : !t && this.debugBody && (this.debugBody.destroy(), this.debugBody = null);
          }
        }), Object.defineProperty(s.Physics.P2.Body.prototype, "collideWorldBounds", {
          get: function get() {
            return this._collideWorldBounds;
          },
          set: function set(t) {
            t && !this._collideWorldBounds ? (this._collideWorldBounds = !0, this.updateCollisionMask()) : !t && this._collideWorldBounds && (this._collideWorldBounds = !1, this.updateCollisionMask());
          }
        }),
        /**
        * @author       George https://github.com/georgiee
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.BodyDebug = function (t, e, i) {
          s.Group.call(this, t);
          var n = {
            pixelsPerLengthUnit: t.physics.p2.mpx(1),
            debugPolygons: !1,
            lineWidth: 1,
            alpha: .5
          };
          this.settings = Object.assign(n, i), this.ppu = this.settings.pixelsPerLengthUnit, this.ppu = -1 * this.ppu, this.body = e, this.canvas = new s.Graphics(t), this.canvas.alpha = this.settings.alpha, this.add(this.canvas), this.draw(), this.updateSpriteTransform();
        }, s.Physics.P2.BodyDebug.prototype = Object.create(s.Group.prototype), s.Physics.P2.BodyDebug.prototype.constructor = s.Physics.P2.BodyDebug, Object.assign(s.Physics.P2.BodyDebug.prototype, {
          updateSpriteTransform: function updateSpriteTransform() {
            this.position.x = this.body.position[0] * this.ppu, this.position.y = this.body.position[1] * this.ppu, this.rotation = this.body.angle;
          },
          draw: function draw() {
            var t, e, i, s, n, o, r, a, h, l, c, u, d, p;

            if (r = this.body, (h = this.canvas).clear(), i = parseInt(this.randomPastelHex(), 16), 16711680, o = this.lineWidth, r instanceof p2.Body && r.shapes.length) {
              var f = r.shapes.length;

              for (s = 0; s !== f;) {
                if (a = (e = r.shapes[s]).position || 0, t = e.angle || 0, e instanceof p2.Circle) this.drawCircle(h, a[0] * this.ppu, a[1] * this.ppu, t, e.radius * this.ppu, i, o);else if (e instanceof p2.Capsule) this.drawCapsule(h, a[0] * this.ppu, a[1] * this.ppu, t, e.length * this.ppu, e.radius * this.ppu, 16711680, i, o);else if (e instanceof p2.Plane) this.drawPlane(h, a[0] * this.ppu, -a[1] * this.ppu, i, 16711680, 5 * o, 10 * o, 10 * o, 100 * this.ppu, t);else if (e instanceof p2.Line) this.drawLine(h, e.length * this.ppu, 16711680, o);else if (e instanceof p2.Box) this.drawRectangle(h, a[0] * this.ppu, a[1] * this.ppu, t, e.width * this.ppu, e.height * this.ppu, 16711680, i, o);else if (e instanceof p2.Convex) {
                  for (c = [], u = p2.vec2.create(), n = d = 0, p = e.vertices.length; p >= 0 ? d < p : d > p; n = p >= 0 ? ++d : --d) {
                    l = e.vertices[n], p2.vec2.rotate(u, l, t), c.push([(u[0] + a[0]) * this.ppu, -(u[1] + a[1]) * this.ppu]);
                  }

                  this.drawConvex(h, c, e.triangles, 16711680, i, o, this.settings.debugPolygons, [a[0] * this.ppu, -a[1] * this.ppu]);
                }
                s++;
              }
            }
          },
          drawRectangle: function drawRectangle(t, e, i, s, n, o, r, a, h) {
            void 0 === h && (h = 1), void 0 === r && (r = 0), t.lineStyle(h, r, 1), t.beginFill(a), t.drawRect(e - n / 2, i - o / 2, n, o);
          },
          drawCircle: function drawCircle(t, e, i, s, n, o, r) {
            void 0 === r && (r = 1), void 0 === o && (o = 16777215), t.lineStyle(r, 0, 1), t.beginFill(o, 1), t.drawCircle(e, i, 2 * -n), t.endFill(), t.moveTo(e, i), t.lineTo(e + n * Math.cos(-s), i + n * Math.sin(-s));
          },
          drawLine: function drawLine(t, e, i, s) {
            void 0 === s && (s = 1), void 0 === i && (i = 0), t.lineStyle(5 * s, i, 1), t.moveTo(-e / 2, 0), t.lineTo(e / 2, 0);
          },
          drawConvex: function drawConvex(t, e, i, s, n, o, r, a) {
            var h, l, c, u, d, p, f, g, m, y, v;

            if (void 0 === o && (o = 1), void 0 === s && (s = 0), r) {
              for (h = [16711680, 65280, 255], l = 0; l !== e.length + 1;) {
                u = e[l % e.length], d = e[(l + 1) % e.length], f = u[0], y = u[1], g = d[0], v = d[1], t.lineStyle(o, h[l % h.length], 1), t.moveTo(f, -y), t.lineTo(g, -v), t.drawCircle(f, -y, 2 * o), l++;
              }

              return t.lineStyle(o, 0, 1), t.drawCircle(a[0], a[1], 2 * o);
            }

            for (t.lineStyle(o, s, 1), t.beginFill(n), l = 0; l !== e.length;) {
              p = (c = e[l])[0], m = c[1], 0 === l ? t.moveTo(p, -m) : t.lineTo(p, -m), l++;
            }

            if (t.endFill(), e.length > 2) return t.moveTo(e[e.length - 1][0], -e[e.length - 1][1]), t.lineTo(e[0][0], -e[0][1]);
          },
          drawPath: function drawPath(t, e, i, s, n) {
            var o, r, a, h, l, c, u, d, p, f, g;

            for (void 0 === n && (n = 1), void 0 === i && (i = 0), t.lineStyle(n, i, 1), "number" == typeof s && t.beginFill(s), r = null, a = null, o = 0; o < e.length;) {
              f = (p = e[o])[0], g = p[1], f === r && g === a || (0 === o ? t.moveTo(f, g) : (h = r, l = a, c = f, u = g, d = e[(o + 1) % e.length][0], 0 !== (c - h) * (e[(o + 1) % e.length][1] - l) - (d - h) * (u - l) && t.lineTo(f, g)), r = f, a = g), o++;
            }

            "number" == typeof s && t.endFill(), e.length > 2 && "number" == typeof s && (t.moveTo(e[e.length - 1][0], e[e.length - 1][1]), t.lineTo(e[0][0], e[0][1]));
          },
          drawPlane: function drawPlane(t, e, i, s, n, o, r, a, h, l) {
            var c, u;
            void 0 === o && (o = 1), void 0 === s && (s = 16777215), t.lineStyle(o, n, 11), t.beginFill(s), t.moveTo(e, -i), c = e + Math.cos(l) * this.game.width, u = i + Math.sin(l) * this.game.height, t.lineTo(c, -u), t.moveTo(e, -i), c = e + Math.cos(l) * -this.game.width, u = i + Math.sin(l) * -this.game.height, t.lineTo(c, -u);
          },
          drawCapsule: function drawCapsule(t, e, i, s, n, o, r, a, h) {
            void 0 === h && (h = 1), void 0 === r && (r = 0), t.lineStyle(h, r, 1);
            var l = Math.cos(s),
                c = Math.sin(s);
            t.beginFill(a, 1), t.drawCircle(-n / 2 * l + e, -n / 2 * c + i, 2 * -o), t.drawCircle(n / 2 * l + e, n / 2 * c + i, 2 * -o), t.endFill(), t.lineStyle(h, r, 0), t.beginFill(a, 1), t.moveTo(-n / 2 * l + o * c + e, -n / 2 * c + o * l + i), t.lineTo(n / 2 * l + o * c + e, n / 2 * c + o * l + i), t.lineTo(n / 2 * l - o * c + e, n / 2 * c - o * l + i), t.lineTo(-n / 2 * l - o * c + e, -n / 2 * c - o * l + i), t.endFill(), t.lineStyle(h, r, 1), t.moveTo(-n / 2 * l + o * c + e, -n / 2 * c + o * l + i), t.lineTo(n / 2 * l + o * c + e, n / 2 * c + o * l + i), t.moveTo(-n / 2 * l - o * c + e, -n / 2 * c - o * l + i), t.lineTo(n / 2 * l - o * c + e, n / 2 * c - o * l + i);
          },
          randomPastelHex: function randomPastelHex() {
            var t, e, i, s;
            return i = [255, 255, 255], s = Math.floor(256 * Math.random()), e = Math.floor(256 * Math.random()), t = Math.floor(256 * Math.random()), s = Math.floor((s + 3 * i[0]) / 4), e = Math.floor((e + 3 * i[1]) / 4), t = Math.floor((t + 3 * i[2]) / 4), this.rgbToHex(s, e, t);
          },
          rgbToHex: function rgbToHex(t, e, i) {
            return this.componentToHex(t) + this.componentToHex(e) + this.componentToHex(i);
          },
          componentToHex: function componentToHex(t) {
            var e;
            return 2 === (e = t.toString(16)).length ? e : e + "0";
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.Spring = function (t, e, i, s, n, o, r, a, h, l) {
          this.game = t.game, this.world = t, void 0 === s && (s = 1), void 0 === n && (n = 100), void 0 === o && (o = 1);
          var c = {
            restLength: s = t.pxm(s),
            stiffness: n,
            damping: o
          };
          void 0 !== r && null !== r && (c.worldAnchorA = [t.pxm(r[0]), t.pxm(r[1])]), void 0 !== a && null !== a && (c.worldAnchorB = [t.pxm(a[0]), t.pxm(a[1])]), void 0 !== h && null !== h && (c.localAnchorA = [t.pxm(h[0]), t.pxm(h[1])]), void 0 !== l && null !== l && (c.localAnchorB = [t.pxm(l[0]), t.pxm(l[1])]), this.data = new p2.LinearSpring(e, i, c), this.data.parent = this;
        }, s.Physics.P2.Spring.prototype.constructor = s.Physics.P2.Spring,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.RotationalSpring = function (t, e, i, s, n, o) {
          this.game = t.game, this.world = t, void 0 === s && (s = null), void 0 === n && (n = 100), void 0 === o && (o = 1), s && (s = t.pxm(s));
          var r = {
            restAngle: s,
            stiffness: n,
            damping: o
          };
          this.data = new p2.RotationalSpring(e, i, r), this.data.parent = this;
        }, s.Physics.P2.Spring.prototype.constructor = s.Physics.P2.Spring,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.Material = function (t) {
          this.name = t, p2.Material.call(this);
        }, s.Physics.P2.Material.prototype = Object.create(p2.Material.prototype), s.Physics.P2.Material.prototype.constructor = s.Physics.P2.Material,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.ContactMaterial = function (t, e, i) {
          p2.ContactMaterial.call(this, t, e, i);
        }, s.Physics.P2.ContactMaterial.prototype = Object.create(p2.ContactMaterial.prototype), s.Physics.P2.ContactMaterial.prototype.constructor = s.Physics.P2.ContactMaterial,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.CollisionGroup = function (t) {
          this.mask = t;
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.DistanceConstraint = function (t, e, i, s, n, o, r) {
          void 0 === s && (s = 100), void 0 === n && (n = [0, 0]), void 0 === o && (o = [0, 0]), void 0 === r && (r = Number.MAX_VALUE), this.game = t.game, this.world = t;
          var a = {
            distance: s = t.pxm(s),
            localAnchorA: n = [t.pxmi(n[0]), t.pxmi(n[1])],
            localAnchorB: o = [t.pxmi(o[0]), t.pxmi(o[1])],
            maxForce: r
          };
          p2.DistanceConstraint.call(this, e, i, a);
        }, s.Physics.P2.DistanceConstraint.prototype = Object.create(p2.DistanceConstraint.prototype), s.Physics.P2.DistanceConstraint.prototype.constructor = s.Physics.P2.DistanceConstraint,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.GearConstraint = function (t, e, i, s, n) {
          void 0 === s && (s = 0), void 0 === n && (n = 1), this.game = t.game, this.world = t;
          var o = {
            angle: s,
            ratio: n
          };
          p2.GearConstraint.call(this, e, i, o);
        }, s.Physics.P2.GearConstraint.prototype = Object.create(p2.GearConstraint.prototype), s.Physics.P2.GearConstraint.prototype.constructor = s.Physics.P2.GearConstraint,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.LockConstraint = function (t, e, i, s, n, o) {
          void 0 === s && (s = [0, 0]), void 0 === n && (n = 0), void 0 === o && (o = Number.MAX_VALUE), this.game = t.game, this.world = t;
          var r = {
            localOffsetB: s = [t.pxm(s[0]), t.pxm(s[1])],
            localAngleB: n,
            maxForce: o
          };
          p2.LockConstraint.call(this, e, i, r);
        }, s.Physics.P2.LockConstraint.prototype = Object.create(p2.LockConstraint.prototype), s.Physics.P2.LockConstraint.prototype.constructor = s.Physics.P2.LockConstraint,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.PrismaticConstraint = function (t, e, i, s, n, o, r, a) {
          void 0 === s && (s = !0), void 0 === n && (n = [0, 0]), void 0 === o && (o = [0, 0]), void 0 === r && (r = [0, 0]), void 0 === a && (a = Number.MAX_VALUE), this.game = t.game, this.world = t;
          var h = {
            localAnchorA: n = [t.pxmi(n[0]), t.pxmi(n[1])],
            localAnchorB: o = [t.pxmi(o[0]), t.pxmi(o[1])],
            localAxisA: r,
            maxForce: a,
            disableRotationalLock: !s
          };
          p2.PrismaticConstraint.call(this, e, i, h);
        }, s.Physics.P2.PrismaticConstraint.prototype = Object.create(p2.PrismaticConstraint.prototype), s.Physics.P2.PrismaticConstraint.prototype.constructor = s.Physics.P2.PrismaticConstraint,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Physics.P2.RevoluteConstraint = function (t, e, i, s, n, o, r) {
          void 0 === o && (o = Number.MAX_VALUE), void 0 === r && (r = null), this.game = t.game, this.world = t, i = [t.pxmi(i[0]), t.pxmi(i[1])], n = [t.pxmi(n[0]), t.pxmi(n[1])], r && (r = [t.pxmi(r[0]), t.pxmi(r[1])]);
          var a = {
            worldPivot: r,
            localPivotA: i,
            localPivotB: n,
            maxForce: o
          };
          p2.RevoluteConstraint.call(this, e, s, a);
        }, s.Physics.P2.RevoluteConstraint.prototype = Object.create(p2.RevoluteConstraint.prototype), s.Physics.P2.RevoluteConstraint.prototype.constructor = s.Physics.P2.RevoluteConstraint,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.ImageCollection = function (t, e, i, s, n, o, r) {
          (void 0 === i || i <= 0) && (i = 32), (void 0 === s || s <= 0) && (s = 32), void 0 === n && (n = 0), void 0 === o && (o = 0), this.name = t, this.firstgid = 0 | e, this.imageWidth = 0 | i, this.imageHeight = 0 | s, this.imageMargin = 0 | n, this.imageSpacing = 0 | o, this.properties = r || {}, this.images = [], this.total = 0;
        }, s.ImageCollection.prototype = {
          containsImageIndex: function containsImageIndex(t) {
            return t >= this.firstgid && t < this.firstgid + this.total;
          },
          addImage: function addImage(t, e) {
            this.images.push({
              gid: t,
              image: e
            }), this.total++;
          }
        }, s.ImageCollection.prototype.constructor = s.ImageCollection,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Tile = function (t, e, i, s, n, o) {
          this.layer = t, this.index = e, this.x = i, this.y = s, this.rotation = 0, this.flipped = !1, this.worldX = i * n, this.worldY = s * o, this.width = n, this.height = o, this.centerX = Math.abs(n / 2), this.centerY = Math.abs(o / 2), this.alpha = 1, this.properties = {}, this.scanned = !1, this.faceTop = !1, this.faceBottom = !1, this.faceLeft = !1, this.faceRight = !1, this.collideLeft = !1, this.collideRight = !1, this.collideUp = !1, this.collideDown = !1, this.collisionCallback = null, this.collisionCallbackContext = this, this.debug = !1;
        }, s.Tile.prototype = {
          containsPoint: function containsPoint(t, e) {
            return !(t < this.worldX || e < this.worldY || t > this.right || e > this.bottom);
          },
          intersects: function intersects(t, e, i, s) {
            return !(i <= this.worldX) && !(s <= this.worldY) && !(t >= this.worldX + this.width) && !(e >= this.worldY + this.height);
          },
          setCollisionCallback: function setCollisionCallback(t, e) {
            this.collisionCallback = t, this.collisionCallbackContext = e;
          },
          destroy: function destroy() {
            this.collisionCallback = null, this.collisionCallbackContext = null, this.properties = null;
          },
          setCollision: function setCollision(t, e, i, s) {
            this.collideLeft = t, this.collideRight = e, this.collideUp = i, this.collideDown = s, this.faceLeft = t, this.faceRight = e, this.faceTop = i, this.faceBottom = s;
          },
          resetCollision: function resetCollision() {
            this.collideLeft = !1, this.collideRight = !1, this.collideUp = !1, this.collideDown = !1, this.faceTop = !1, this.faceBottom = !1, this.faceLeft = !1, this.faceRight = !1;
          },
          isInteresting: function isInteresting(t, e) {
            return t && e ? this.collideLeft || this.collideRight || this.collideUp || this.collideDown || this.faceTop || this.faceBottom || this.faceLeft || this.faceRight || this.collisionCallback : t ? this.collideLeft || this.collideRight || this.collideUp || this.collideDown : !!e && (this.faceTop || this.faceBottom || this.faceLeft || this.faceRight);
          },
          copy: function copy(t) {
            this.index = t.index, this.alpha = t.alpha, this.properties = t.properties, this.collideUp = t.collideUp, this.collideDown = t.collideDown, this.collideLeft = t.collideLeft, this.collideRight = t.collideRight, this.collisionCallback = t.collisionCallback, this.collisionCallbackContext = t.collisionCallbackContext;
          }
        }, s.Tile.prototype.constructor = s.Tile, Object.defineProperty(s.Tile.prototype, "collides", {
          get: function get() {
            return this.collideLeft || this.collideRight || this.collideUp || this.collideDown;
          }
        }), Object.defineProperty(s.Tile.prototype, "canCollide", {
          get: function get() {
            return this.collideLeft || this.collideRight || this.collideUp || this.collideDown || this.collisionCallback;
          }
        }), Object.defineProperty(s.Tile.prototype, "left", {
          get: function get() {
            return this.worldX;
          }
        }), Object.defineProperty(s.Tile.prototype, "right", {
          get: function get() {
            return this.worldX + this.width;
          }
        }), Object.defineProperty(s.Tile.prototype, "top", {
          get: function get() {
            return this.worldY;
          }
        }), Object.defineProperty(s.Tile.prototype, "bottom", {
          get: function get() {
            return this.worldY + this.height;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Tilemap = function (t, e, i, n, o, r) {
          this.game = t, this.key = e;
          var a = s.TilemapParser.parse(this.game, e, i, n, o, r);
          null !== a && (this.width = a.width, this.height = a.height, this.tileWidth = a.tileWidth, this.tileHeight = a.tileHeight, this.orientation = a.orientation, this.format = a.format, this.version = a.version, this.properties = a.properties, this.widthInPixels = a.widthInPixels, this.heightInPixels = a.heightInPixels, this.layers = a.layers, this.tilesets = a.tilesets, this.imagecollections = a.imagecollections, this.tiles = a.tiles, this.objects = a.objects, this.collideIndexes = [], this.collision = a.collision, this.images = a.images, this.enableDebug = !1, this.currentLayer = 0, this.debugMap = [], this._results = [], this._tempA = 0, this._tempB = 0);
        }, s.Tilemap.CSV = 0, s.Tilemap.TILED_JSON = 1, s.Tilemap.NORTH = 0, s.Tilemap.EAST = 1, s.Tilemap.SOUTH = 2, s.Tilemap.WEST = 3, s.Tilemap.prototype = {
          create: function create(t, e, i, s, n, o) {
            return void 0 === o && (o = this.game.world), this.width = e, this.height = i, this.setTileSize(s, n), this.layers.length = 0, this.createBlankLayer(t, e, i, s, n, o);
          },
          setTileSize: function setTileSize(t, e) {
            this.tileWidth = t, this.tileHeight = e, this.widthInPixels = this.width * t, this.heightInPixels = this.height * e;
          },
          addTilesetImage: function addTilesetImage(t, e, i, n, o, r, a) {
            if (void 0 === t) return null;
            void 0 === i && (i = this.tileWidth), void 0 === n && (n = this.tileHeight), void 0 === o && (o = 0), void 0 === r && (r = 0), void 0 === a && (a = 0), 0 === i && (i = 32), 0 === n && (n = 32);
            var h = null;
            if (void 0 !== e && null !== e || (e = t), e instanceof s.BitmapData) h = e.canvas;else {
              if (!this.game.cache.checkImageKey(e)) return console.warn('Phaser.Tilemap.addTilesetImage: Invalid image key given: "' + e + '"'), null;
              h = this.game.cache.getImage(e);
            }
            var l = this.getTilesetIndex(t);
            if (null === l && this.format === s.Tilemap.TILED_JSON) return console.warn('Phaser.Tilemap.addTilesetImage: No data found in the JSON matching the tileset name: "' + t + '"'), console.log("Tilesets: ", this.tilesets), null;
            if (this.tilesets[l]) return this.tilesets[l].setImage(h), this.tilesets[l];
            var c = new s.Tileset(t, a, i, n, o, r, {});
            c.setImage(h), this.tilesets.push(c);

            for (var u = this.tilesets.length - 1, d = o, p = o, f = 0, g = 0, m = 0, y = a; y < a + c.total && (this.tiles[y] = [d, p, u], d += i + r, ++f !== c.total) && (++g !== c.columns || (d = o, p += n + r, g = 0, ++m !== c.rows)); y++) {
              ;
            }

            return c;
          },
          createFromObjects: function createFromObjects(t, e, i, n, o, r, a, h, l, c) {
            if (void 0 === o && (o = !0), void 0 === r && (r = !1), void 0 === a && (a = this.game.world), void 0 === h && (h = s.Sprite), void 0 === l && (l = !0), void 0 === c && (c = !0), !this.objects[t]) return console.warn("Tilemap.createFromObjects: Invalid objectgroup name given: " + t), void console.log("Objects: ", this.objects);

            for (var u = 0; u < this.objects[t].length; u++) {
              var d = !1,
                  p = this.objects[t][u];

              if (void 0 !== p.gid && "number" == typeof e && p.gid === e ? d = !0 : void 0 !== p.id && "number" == typeof e && p.id === e ? d = !0 : void 0 !== p.name && "string" == typeof e && p.name === e && (d = !0), d) {
                var f = new h(this.game, parseFloat(p.x, 10), parseFloat(p.y, 10), i, n);

                for (var g in f.name = p.name, f.autoCull = r, f.exists = o, f.visible = p.visible, c && (p.width && (f.width = p.width), p.height && (f.height = p.height)), p.rotation && (f.angle = p.rotation), l && (f.y -= f.height), a.add(f), p.properties) {
                  a.set(f, g, p.properties[g], !1, !1, 0, !0);
                }
              }
            }
          },
          createFromTiles: function createFromTiles(t, e, i, n, o, r) {
            "number" == typeof t && (t = [t]), void 0 === e || null === e ? e = [] : "number" == typeof e && (e = [e]), n = this.getLayer(n), void 0 === o && (o = this.game.world), void 0 === r && (r = {}), void 0 === r.customClass && (r.customClass = s.Sprite), void 0 === r.adjustY && (r.adjustY = !0);
            var a = this.layers[n].width,
                h = this.layers[n].height;
            if (this.copy(0, 0, a, h, n), this._results.length < 2) return 0;

            for (var l, c = 0, u = 1, d = this._results.length; u < d; u++) {
              if (-1 !== t.indexOf(this._results[u].index)) {
                for (var p in l = new r.customClass(this.game, this._results[u].worldX, this._results[u].worldY, i), r) {
                  l[p] = r[p];
                }

                o.add(l), c++;
              }
            }

            if (1 === e.length) for (u = 0; u < t.length; u++) {
              this.replace(t[u], e[0], 0, 0, a, h, n);
            } else if (e.length > 1) for (u = 0; u < t.length; u++) {
              this.replace(t[u], e[u], 0, 0, a, h, n);
            }
            return c;
          },
          createLayer: function createLayer(t, e, i, n) {
            void 0 === e && (e = this.game.width), void 0 === i && (i = this.game.height), void 0 === n && (n = this.game.world);
            var o = t;
            if ("string" == typeof t && (o = this.getLayerIndex(t)), null === o || o > this.layers.length) return console.warn('Tilemap.createLayer: Invalid layer ID given: "' + t + '"'), void console.log("Layers: ", this.layers);
            void 0 === e || e <= 0 ? e = Math.min(this.game.width, this.layers[o].widthInPixels) : e > this.game.width && (e = this.game.width), void 0 === i || i <= 0 ? i = Math.min(this.game.height, this.layers[o].heightInPixels) : i > this.game.height && (i = this.game.height), this.enableDebug && (console.group("Tilemap.createLayer"), console.log("Name:", this.layers[o].name), console.log("Size:", e, "x", i), console.log("Tileset:", this.tilesets[0].name, "index:", o));
            var r = n.add(new s.TilemapLayer(this.game, this, o, e, i));
            return this.enableDebug && console.groupEnd(), r;
          },
          createBlankLayer: function createBlankLayer(t, e, i, n, o, r) {
            if (void 0 === r && (r = this.game.world), null === this.getLayerIndex(t)) {
              for (var a, h = {
                name: t,
                x: 0,
                y: 0,
                width: e,
                height: i,
                widthInPixels: e * n,
                heightInPixels: i * o,
                alpha: 1,
                visible: !0,
                properties: {},
                indexes: [],
                callbacks: [],
                bodies: [],
                data: null
              }, l = [], c = 0; c < i; c++) {
                a = [];

                for (var u = 0; u < e; u++) {
                  a.push(new s.Tile(h, -1, u, c, n, o));
                }

                l.push(a);
              }

              h.data = l, this.layers.push(h), this.currentLayer = this.layers.length - 1;
              var d = h.widthInPixels,
                  p = h.heightInPixels;
              return d > this.game.width && (d = this.game.width), p > this.game.height && (p = this.game.height), (l = new s.TilemapLayer(this.game, this, this.layers.length - 1, d, p)).name = t, r.add(l);
            }

            console.warn("Tilemap.createBlankLayer: Layer with matching name already exists: " + t);
          },
          getIndex: function getIndex(t, e) {
            for (var i = 0; i < t.length; i++) {
              if (t[i].name === e) return i;
            }

            return null;
          },
          getLayerIndex: function getLayerIndex(t) {
            return this.getIndex(this.layers, t);
          },
          getTilesetIndex: function getTilesetIndex(t) {
            return this.getIndex(this.tilesets, t);
          },
          getImageIndex: function getImageIndex(t) {
            return this.getIndex(this.images, t);
          },
          setTileIndexCallback: function setTileIndexCallback(t, e, i, s) {
            if (s = this.getLayer(s), "number" == typeof t) null === e ? delete this.layers[s].callbacks[t] : this.layers[s].callbacks[t] = {
              callback: e,
              callbackContext: i
            };else for (var n = 0, o = t.length; n < o; n++) {
              null === e ? delete this.layers[s].callbacks[t[n]] : this.layers[s].callbacks[t[n]] = {
                callback: e,
                callbackContext: i
              };
            }
          },
          setTileLocationCallback: function setTileLocationCallback(t, e, i, s, n, o, r) {
            if (r = this.getLayer(r), this.copy(t, e, i, s, r), !(this._results.length < 2)) for (var a = 1; a < this._results.length; a++) {
              this._results[a].setCollisionCallback(n, o);
            }
          },
          setCollision: function setCollision(t, e, i, s) {
            if (void 0 === e && (e = !0), void 0 === s && (s = !0), i = this.getLayer(i), "number" == typeof t) return this.setCollisionByIndex(t, e, i, !0);

            if (Array.isArray(t)) {
              for (var n = 0; n < t.length; n++) {
                this.setCollisionByIndex(t[n], e, i, !1);
              }

              s && this.calculateFaces(i);
            }
          },
          setCollisionBetween: function setCollisionBetween(t, e, i, s, n) {
            if (void 0 === i && (i = !0), void 0 === n && (n = !0), s = this.getLayer(s), !(t > e)) {
              for (var o = t; o <= e; o++) {
                this.setCollisionByIndex(o, i, s, !1);
              }

              n && this.calculateFaces(s);
            }
          },
          setCollisionByExclusion: function setCollisionByExclusion(t, e, i, s) {
            void 0 === e && (e = !0), void 0 === s && (s = !0), i = this.getLayer(i);

            for (var n = 0, o = this.tiles.length; n < o; n++) {
              -1 === t.indexOf(n) && this.setCollisionByIndex(n, e, i, !1);
            }

            s && this.calculateFaces(i);
          },
          setCollisionByIndex: function setCollisionByIndex(t, e, i, s) {
            if (void 0 === e && (e = !0), void 0 === i && (i = this.currentLayer), void 0 === s && (s = !0), e) this.collideIndexes.push(t);else {
              var n = this.collideIndexes.indexOf(t);
              n > -1 && this.collideIndexes.splice(n, 1);
            }

            for (var o = 0; o < this.layers[i].height; o++) {
              for (var r = 0; r < this.layers[i].width; r++) {
                var a = this.layers[i].data[o][r];
                a && a.index === t && (e ? a.setCollision(!0, !0, !0, !0) : a.resetCollision(), a.faceTop = e, a.faceBottom = e, a.faceLeft = e, a.faceRight = e);
              }
            }

            return s && this.calculateFaces(i), i;
          },
          getLayer: function getLayer(t) {
            if (void 0 === t) t = this.currentLayer;else if ("string" == typeof t) {
              var e = t;
              null === (t = this.getLayerIndex(t)) && console.warn("No such layer name: " + e);
            } else t instanceof s.TilemapLayer && (t = t.index);
            return t;
          },
          setPreventRecalculate: function setPreventRecalculate(t) {
            if (!0 === t && !0 !== this.preventingRecalculate && (this.preventingRecalculate = !0, this.needToRecalculate = {}), !1 === t && !0 === this.preventingRecalculate) {
              for (var e in this.preventingRecalculate = !1, this.needToRecalculate) {
                this.calculateFaces(e);
              }

              this.needToRecalculate = !1;
            }
          },
          calculateFaces: function calculateFaces(t) {
            if (this.preventingRecalculate) this.needToRecalculate[t] = !0;else for (var e = null, i = null, s = null, n = null, o = 0, r = this.layers[t].height; o < r; o++) {
              for (var a = 0, h = this.layers[t].width; a < h; a++) {
                var l = this.layers[t].data[o][a];
                l && (e = this.getTileAbove(t, a, o), i = this.getTileBelow(t, a, o), s = this.getTileLeft(t, a, o), n = this.getTileRight(t, a, o), l.collides && (l.faceTop = !0, l.faceBottom = !0, l.faceLeft = !0, l.faceRight = !0), e && e.collides && (l.faceTop = !1), i && i.collides && (l.faceBottom = !1), s && s.collides && (l.faceLeft = !1), n && n.collides && (l.faceRight = !1));
              }
            }
          },
          getTileAbove: function getTileAbove(t, e, i) {
            return i > 0 ? this.layers[t].data[i - 1][e] : null;
          },
          getTileBelow: function getTileBelow(t, e, i) {
            return i < this.layers[t].height - 1 ? this.layers[t].data[i + 1][e] : null;
          },
          getTileLeft: function getTileLeft(t, e, i) {
            return e > 0 ? this.layers[t].data[i][e - 1] : null;
          },
          getTileRight: function getTileRight(t, e, i) {
            return e < this.layers[t].width - 1 ? this.layers[t].data[i][e + 1] : null;
          },
          setLayer: function setLayer(t) {
            t = this.getLayer(t), this.layers[t] && (this.currentLayer = t);
          },
          hasTile: function hasTile(t, e, i) {
            return i = this.getLayer(i), void 0 !== this.layers[i].data[e] && void 0 !== this.layers[i].data[e][t] && this.layers[i].data[e][t].index > -1;
          },
          removeTile: function removeTile(t, e, i) {
            if (i = this.getLayer(i), t >= 0 && t < this.layers[i].width && e >= 0 && e < this.layers[i].height && this.hasTile(t, e, i)) {
              var n = this.layers[i].data[e][t];
              return this.layers[i].data[e][t] = new s.Tile(this.layers[i], -1, t, e, this.tileWidth, this.tileHeight), this.layers[i].dirty = !0, this.calculateFaces(i), n;
            }
          },
          removeTileWorldXY: function removeTileWorldXY(t, e, i, s, n) {
            return n = this.getLayer(n), t = this.game.math.snapToFloor(t, i) / i, e = this.game.math.snapToFloor(e, s) / s, this.removeTile(t, e, n);
          },
          putTile: function putTile(t, e, i, n) {
            return null === t ? this.removeTile(e, i, n) : (n = this.getLayer(n), e >= 0 && e < this.layers[n].width && i >= 0 && i < this.layers[n].height ? (t instanceof s.Tile ? (o = t.index, this.hasTile(e, i, n) ? this.layers[n].data[i][e].copy(t) : this.layers[n].data[i][e] = new s.Tile(n, o, e, i, t.width, t.height)) : (o = t, this.hasTile(e, i, n) ? this.layers[n].data[i][e].index = o : this.layers[n].data[i][e] = new s.Tile(this.layers[n], o, e, i, this.tileWidth, this.tileHeight)), this.collideIndexes.indexOf(o) > -1 ? this.layers[n].data[i][e].setCollision(!0, !0, !0, !0) : this.layers[n].data[i][e].resetCollision(), this.layers[n].dirty = !0, this.calculateFaces(n), this.layers[n].data[i][e]) : null);
            var o;
          },
          putTileWorldXY: function putTileWorldXY(t, e, i, s, n, o) {
            return o = this.getLayer(o), e = this.game.math.snapToFloor(e, s) / s, i = this.game.math.snapToFloor(i, n) / n, this.putTile(t, e, i, o);
          },
          searchTileIndex: function searchTileIndex(t, e, i, s) {
            void 0 === e && (e = 0), void 0 === i && (i = !1), s = this.getLayer(s);
            var n = 0;

            if (i) {
              for (var o = this.layers[s].height - 1; o >= 0; o--) {
                for (var r = this.layers[s].width - 1; r >= 0; r--) {
                  if (this.layers[s].data[o][r].index === t) {
                    if (n === e) return this.layers[s].data[o][r];
                    n++;
                  }
                }
              }
            } else for (o = 0; o < this.layers[s].height; o++) {
              for (r = 0; r < this.layers[s].width; r++) {
                if (this.layers[s].data[o][r].index === t) {
                  if (n === e) return this.layers[s].data[o][r];
                  n++;
                }
              }
            }

            return null;
          },
          getTile: function getTile(t, e, i, s) {
            return void 0 === s && (s = !1), i = this.getLayer(i), t >= 0 && t < this.layers[i].width && e >= 0 && e < this.layers[i].height ? -1 === this.layers[i].data[e][t].index ? s ? this.layers[i].data[e][t] : null : this.layers[i].data[e][t] : null;
          },
          getTileWorldXY: function getTileWorldXY(t, e, i, s, n, o) {
            return void 0 === i && (i = this.tileWidth), void 0 === s && (s = this.tileHeight), n = this.getLayer(n), t = this.game.math.snapToFloor(t, i) / i, e = this.game.math.snapToFloor(e, s) / s, this.getTile(t, e, n, o);
          },
          copy: function copy(t, e, i, s, n) {
            if (n = this.getLayer(n), this.layers[n]) {
              void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = this.layers[n].width), void 0 === s && (s = this.layers[n].height), t < 0 && (t = 0), e < 0 && (e = 0), i > this.layers[n].width && (i = this.layers[n].width), s > this.layers[n].height && (s = this.layers[n].height), this._results.length = 0, this._results.push({
                x: t,
                y: e,
                width: i,
                height: s,
                layer: n
              });

              for (var o = e; o < e + s; o++) {
                for (var r = t; r < t + i; r++) {
                  this._results.push(this.layers[n].data[o][r]);
                }
              }

              return this._results;
            }

            this._results.length = 0;
          },
          paste: function paste(t, e, i, s) {
            if (void 0 === t && (t = 0), void 0 === e && (e = 0), s = this.getLayer(s), i && !(i.length < 2)) {
              for (var n = t - i[1].x, o = e - i[1].y, r = 1; r < i.length; r++) {
                this.layers[s].data[o + i[r].y][n + i[r].x].copy(i[r]);
              }

              this.layers[s].dirty = !0, this.calculateFaces(s);
            }
          },
          swap: function swap(t, e, i, s, n, o, r) {
            r = this.getLayer(r), this.copy(i, s, n, o, r), this._results.length < 2 || (this._tempA = t, this._tempB = e, this._results.forEach(this.swapHandler, this), this.paste(i, s, this._results, r));
          },
          swapHandler: function swapHandler(t) {
            t.index === this._tempA ? t.index = this._tempB : t.index === this._tempB && (t.index = this._tempA);
          },
          forEach: function forEach(t, e, i, s, n, o, r) {
            r = this.getLayer(r), this.copy(i, s, n, o, r), this._results.length < 2 || (this._results.forEach(t, e), this.paste(i, s, this._results, r));
          },
          replace: function replace(t, e, i, s, n, o, r) {
            if (r = this.getLayer(r), this.copy(i, s, n, o, r), !(this._results.length < 2)) {
              for (var a = 1; a < this._results.length; a++) {
                this._results[a].index === t && (this._results[a].index = e);
              }

              this.paste(i, s, this._results, r);
            }
          },
          random: function random(t, e, i, s, n) {
            if (n = this.getLayer(n), this.copy(t, e, i, s, n), !(this._results.length < 2)) {
              for (var o = [], r = 1; r < this._results.length; r++) {
                if (this._results[r].index) {
                  var a = this._results[r].index;
                  -1 === o.indexOf(a) && o.push(a);
                }
              }

              for (var h = 1; h < this._results.length; h++) {
                this._results[h].index = this.game.rnd.pick(o);
              }

              this.paste(t, e, this._results, n);
            }
          },
          shuffle: function shuffle(t, e, i, n, o) {
            if (o = this.getLayer(o), this.copy(t, e, i, n, o), !(this._results.length < 2)) {
              for (var r = [], a = 1; a < this._results.length; a++) {
                this._results[a].index && r.push(this._results[a].index);
              }

              s.ArrayUtils.shuffle(r);

              for (var h = 1; h < this._results.length; h++) {
                this._results[h].index = r[h - 1];
              }

              this.paste(t, e, this._results, o);
            }
          },
          fill: function fill(t, e, i, s, n, o) {
            if (o = this.getLayer(o), this.copy(e, i, s, n, o), !(this._results.length < 2)) {
              for (var r = 1; r < this._results.length; r++) {
                this._results[r].index = t;
              }

              this.paste(e, i, this._results, o);
            }
          },
          removeAllLayers: function removeAllLayers() {
            this.layers.length = 0, this.currentLayer = 0;
          },
          dump: function dump() {
            for (var t = "", e = [""], i = 0; i < this.layers[this.currentLayer].height; i++) {
              for (var s = 0; s < this.layers[this.currentLayer].width; s++) {
                t += "%c  ", this.layers[this.currentLayer].data[i][s] > 1 ? this.debugMap[this.layers[this.currentLayer].data[i][s]] ? e.push("background: " + this.debugMap[this.layers[this.currentLayer].data[i][s]]) : e.push("background: #ffffff") : e.push("background: rgb(0, 0, 0)");
              }

              t += "\n";
            }

            e[0] = t, console.log.apply(console, e);
          },
          destroy: function destroy() {
            this.removeAllLayers(), this.data = [], this.game = null;
          }
        }, s.Tilemap.prototype.constructor = s.Tilemap, Object.defineProperty(s.Tilemap.prototype, "layer", {
          get: function get() {
            return this.layers[this.currentLayer];
          },
          set: function set(t) {
            t !== this.currentLayer && this.setLayer(t);
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.TilemapLayer = function (t, e, i, n, o) {
          n |= 0, o |= 0, s.Sprite.call(this, t, 0, 0), this.map = e, this.index = i, this.layer = e.layers[i], this.canvas = s.CanvasPool.create(this, n, o), this.context = this.canvas.getContext("2d"), this.setTexture(new PIXI.Texture(new PIXI.BaseTexture(this.canvas, null, this.game.resolution))), this.type = s.TILEMAPLAYER, this.physicsType = s.TILEMAPLAYER, this.renderSettings = {
            enableScrollDelta: !0,
            overdrawRatio: .2,
            copyCanvas: null
          }, this.debug = !1, this.exists = !0, this.debugSettings = {
            missingImageFill: "rgb(255,255,255)",
            debuggedTileOverfill: "rgba(0,255,0,0.4)",
            forceFullRedraw: !0,
            debugAlpha: .5,
            facingEdgeStroke: "rgba(0,255,0,1)",
            collidingTileOverfill: "rgba(0,255,0,0.2)"
          }, this.scrollFactorX = 1, this.scrollFactorY = 1, this.dirty = !0, this.rayStepRate = 4, this._wrap = !1, this._mc = {
            scrollX: 0,
            scrollY: 0,
            renderWidth: 0,
            renderHeight: 0,
            tileWidth: e.tileWidth,
            tileHeight: e.tileHeight,
            cw: e.tileWidth,
            ch: e.tileHeight,
            tilesets: []
          }, this._scrollX = 0, this._scrollY = 0, this.tileOffset = new s.Point(this.layer.offsetX || 0, this.layer.offsetY || 0), this._results = [], t.device.canvasBitBltShift || (this.renderSettings.copyCanvas = s.TilemapLayer.ensureSharedCopyCanvas()), this.fixedToCamera = !0;
        }, s.TilemapLayer.prototype = Object.create(s.Sprite.prototype), s.TilemapLayer.prototype.constructor = s.TilemapLayer, s.TilemapLayer.prototype.preUpdateCore = s.Component.Core.preUpdate, s.TilemapLayer.sharedCopyCanvas = null, s.TilemapLayer.ensureSharedCopyCanvas = function () {
          return this.sharedCopyCanvas || (this.sharedCopyCanvas = s.CanvasPool.create(this, 2, 2)), this.sharedCopyCanvas;
        }, s.TilemapLayer.prototype.preUpdate = function () {
          return this.preUpdateCore();
        }, s.TilemapLayer.prototype.postUpdate = function () {
          this.fixedToCamera && (this.position.x = (this.game.camera.view.x + this.cameraOffset.x) / this.game.camera.scale.x, this.position.y = (this.game.camera.view.y + this.cameraOffset.y) / this.game.camera.scale.y), this._scrollX = (this.game.camera.view.x - this.tileOffset.x) * this.scrollFactorX / this.scale.x, this._scrollY = (this.game.camera.view.y - this.tileOffset.y) * this.scrollFactorY / this.scale.y;
        }, s.TilemapLayer.prototype._renderCanvas = function (t) {
          this.fixedToCamera && (this.position.x = (this.game.camera.view.x + this.cameraOffset.x) / this.game.camera.scale.x, this.position.y = (this.game.camera.view.y + this.cameraOffset.y) / this.game.camera.scale.y), this._scrollX = (this.game.camera.view.x - this.tileOffset.x) * this.scrollFactorX / this.scale.x, this._scrollY = (this.game.camera.view.y - this.tileOffset.y) * this.scrollFactorY / this.scale.y, this.render(), PIXI.Sprite.prototype._renderCanvas.call(this, t);
        }, s.TilemapLayer.prototype._renderWebGL = function (t) {
          this.fixedToCamera && (this.position.x = (this.game.camera.view.x + this.cameraOffset.x) / this.game.camera.scale.x, this.position.y = (this.game.camera.view.y + this.cameraOffset.y) / this.game.camera.scale.y), this._scrollX = (this.game.camera.view.x - this.tileOffset.x) * this.scrollFactorX / this.scale.x, this._scrollY = (this.game.camera.view.y - this.tileOffset.y) * this.scrollFactorY / this.scale.y, this.render(), PIXI.Sprite.prototype._renderWebGL.call(this, t);
        }, s.TilemapLayer.prototype.destroy = function () {
          s.CanvasPool.remove(this), s.Component.Destroy.prototype.destroy.call(this);
        }, s.TilemapLayer.prototype.resize = function (t, e) {
          this.canvas.width = t, this.canvas.height = e, this.texture.frame.resize(t, e), this.texture.width = t, this.texture.height = e, this.texture.crop.width = t, this.texture.crop.height = e, this.texture.baseTexture.width = t, this.texture.baseTexture.height = e, this.texture.baseTexture.dirty(), this.texture.requiresUpdate = !0, this.texture._updateUvs(), this.dirty = !0;
        }, s.TilemapLayer.prototype.resizeWorld = function () {
          this.game.world.setBounds(0, 0, this.layer.widthInPixels * this.scale.x, this.layer.heightInPixels * this.scale.y);
        }, s.TilemapLayer.prototype.getTileOffsetX = function () {
          return this.tileOffset.x || (this.fixedToCamera ? 0 : this.position.x);
        }, s.TilemapLayer.prototype.getTileOffsetY = function () {
          return this.tileOffset.y || (this.fixedToCamera ? 0 : this.position.y);
        }, s.TilemapLayer.prototype._fixX = function (t) {
          return 1 === this.scrollFactorX || 0 === this.scrollFactorX && 0 === this.position.x ? t : 0 === this.scrollFactorX && 0 !== this.position.x ? t - this.position.x : this._scrollX + (t - this._scrollX / this.scrollFactorX);
        }, s.TilemapLayer.prototype._unfixX = function (t) {
          return 1 === this.scrollFactorX ? t : this._scrollX / this.scrollFactorX + (t - this._scrollX);
        }, s.TilemapLayer.prototype._fixY = function (t) {
          return 1 === this.scrollFactorY || 0 === this.scrollFactorY && 0 === this.position.y ? t : 0 === this.scrollFactorY && 0 !== this.position.y ? t - this.position.y : this._scrollY + (t - this._scrollY / this.scrollFactorY);
        }, s.TilemapLayer.prototype._unfixY = function (t) {
          return 1 === this.scrollFactorY ? t : this._scrollY / this.scrollFactorY + (t - this._scrollY);
        }, s.TilemapLayer.prototype.getTileX = function (t) {
          return Math.floor(this._fixX(t) / this._mc.tileWidth);
        }, s.TilemapLayer.prototype.getTileY = function (t) {
          return Math.floor(this._fixY(t) / this._mc.tileHeight);
        }, s.TilemapLayer.prototype.getTileXY = function (t, e, i) {
          return i.x = this.getTileX(t), i.y = this.getTileY(e), i;
        }, s.TilemapLayer.prototype.getRayCastTiles = function (t, e, i, s) {
          e || (e = this.rayStepRate), void 0 === i && (i = !1), void 0 === s && (s = !1);
          var n = this.getTiles(t.x, t.y, t.width, t.height, i, s);
          if (0 === n.length) return [];

          for (var o = t.coordinatesOnLine(e), r = [], a = 0; a < n.length; a++) {
            for (var h = 0; h < o.length; h++) {
              var l = n[a],
                  c = o[h];

              if (l.containsPoint(c[0], c[1])) {
                r.push(l);
                break;
              }
            }
          }

          return r;
        }, s.TilemapLayer.prototype.getTiles = function (t, e, i, s, n, o) {
          void 0 === n && (n = !1), void 0 === o && (o = !1);
          var r = !(n || o);
          t = this._fixX(t), e = this._fixY(e);

          for (var a = Math.floor(t / (this._mc.cw * this.scale.x)), h = Math.floor(e / (this._mc.ch * this.scale.y)), l = Math.ceil((t + i) / (this._mc.cw * this.scale.x)) - a, c = Math.ceil((e + s) / (this._mc.ch * this.scale.y)) - h; this._results.length;) {
            this._results.pop();
          }

          for (var u = h; u < h + c; u++) {
            for (var d = a; d < a + l; d++) {
              var p = this.layer.data[u];
              p && p[d] && (r || p[d].isInteresting(n, o)) && this._results.push(p[d]);
            }
          }

          return this._results.slice();
        }, s.TilemapLayer.prototype.resolveTileset = function (t) {
          var e = this._mc.tilesets;
          if (t < 2e3) for (; e.length < t;) {
            e.push(void 0);
          }
          var i = this.map.tiles[t] && this.map.tiles[t][2];

          if (null !== i) {
            var s = this.map.tilesets[i];
            if (s && s.containsTileIndex(t)) return e[t] = s;
          }

          return e[t] = null;
        }, s.TilemapLayer.prototype.resetTilesetCache = function () {
          for (var t = this._mc.tilesets; t.length;) {
            t.pop();
          }
        }, s.TilemapLayer.prototype.setScale = function (t, e) {
          t = t || 1, e = e || t;

          for (var i = 0; i < this.layer.data.length; i++) {
            for (var s = this.layer.data[i], n = 0; n < s.length; n++) {
              var o = s[n];
              o.width = this.map.tileWidth * t, o.height = this.map.tileHeight * e, o.worldX = o.x * o.width, o.worldY = o.y * o.height;
            }
          }

          this.scale.setTo(t, e);
        }, s.TilemapLayer.prototype.shiftCanvas = function (t, e, i) {
          var s = t.canvas,
              n = s.width - Math.abs(e),
              o = s.height - Math.abs(i),
              r = 0,
              a = 0,
              h = e,
              l = i;
          e < 0 && (r = -e, h = 0), i < 0 && (a = -i, l = 0);
          var c = this.renderSettings.copyCanvas;

          if (c) {
            (c.width < n || c.height < o) && (c.width = n, c.height = o);
            var u = c.getContext("2d");
            u.clearRect(0, 0, n, o), u.drawImage(s, r, a, n, o, 0, 0, n, o), t.clearRect(h, l, n, o), t.drawImage(c, 0, 0, n, o, h, l, n, o);
          } else t.save(), t.globalCompositeOperation = "copy", t.drawImage(s, r, a, n, o, h, l, n, o), t.restore();
        }, s.TilemapLayer.prototype.renderRegion = function (t, e, i, s, n, o) {
          var r = this.context,
              a = this.layer.width,
              h = this.layer.height,
              l = this._mc.tileWidth,
              c = this._mc.tileHeight,
              u = this._mc.tilesets,
              d = NaN;
          this._wrap || (i <= n && (i = Math.max(0, i), n = Math.min(a - 1, n)), s <= o && (s = Math.max(0, s), o = Math.min(h - 1, o)));
          var p,
              f,
              g,
              m,
              y,
              v,
              b = i * l - t,
              x = (i + (1 << 20) * a) % a;

          for (m = (s + (1 << 20) * h) % h, v = o - s, f = s * c - e; v >= 0; m++, v--, f += c) {
            m >= h && (m -= h);
            var w = this.layer.data[m];

            for (g = x, y = n - i, p = b; y >= 0; g++, y--, p += l) {
              g >= a && (g -= a);
              var _ = w[g];

              if (_ && !(_.index < 0)) {
                var T = _.index,
                    P = u[T];
                void 0 === P && (P = this.resolveTileset(T)), _.alpha === d || this.debug || (r.globalAlpha = _.alpha, d = _.alpha), P ? _.rotation || _.flipped ? (r.save(), r.translate(p + _.centerX, f + _.centerY), r.rotate(_.rotation), _.flipped && r.scale(-1, 1), P.draw(r, -_.centerX, -_.centerY, T), r.restore()) : P.draw(r, p, f, T) : this.debugSettings.missingImageFill && (r.fillStyle = this.debugSettings.missingImageFill, r.fillRect(p, f, l, c)), _.debug && this.debugSettings.debuggedTileOverfill && (r.fillStyle = this.debugSettings.debuggedTileOverfill, r.fillRect(p, f, l, c));
              }
            }
          }
        }, s.TilemapLayer.prototype.renderDeltaScroll = function (t, e) {
          var i = this._mc.scrollX,
              s = this._mc.scrollY,
              n = this.canvas.width,
              o = this.canvas.height,
              r = this._mc.tileWidth,
              a = this._mc.tileHeight,
              h = 0,
              l = -r,
              c = 0,
              u = -a;

          if (t < 0 ? (h = n + t, l = n - 1) : t > 0 && (l = t), e < 0 ? (c = o + e, u = o - 1) : e > 0 && (u = e), this.shiftCanvas(this.context, t, e), h = Math.floor((h + i) / r), l = Math.floor((l + i) / r), c = Math.floor((c + s) / a), u = Math.floor((u + s) / a), h <= l) {
            this.context.clearRect(h * r - i, 0, (l - h + 1) * r, o);
            var d = Math.floor((0 + s) / a),
                p = Math.floor((o - 1 + s) / a);
            this.renderRegion(i, s, h, d, l, p);
          }

          if (c <= u) {
            this.context.clearRect(0, c * a - s, n, (u - c + 1) * a);
            var f = Math.floor((0 + i) / r),
                g = Math.floor((n - 1 + i) / r);
            this.renderRegion(i, s, f, c, g, u);
          }
        }, s.TilemapLayer.prototype.renderFull = function () {
          var t = this._mc.scrollX,
              e = this._mc.scrollY,
              i = this.canvas.width,
              s = this.canvas.height,
              n = this._mc.tileWidth,
              o = this._mc.tileHeight,
              r = Math.floor(t / n),
              a = Math.floor((i - 1 + t) / n),
              h = Math.floor(e / o),
              l = Math.floor((s - 1 + e) / o);
          this.context.clearRect(0, 0, i, s), this.renderRegion(t, e, r, h, a, l);
        }, s.TilemapLayer.prototype.render = function () {
          var t = !1;

          if (this.visible) {
            (this.dirty || this.layer.dirty) && (this.layer.dirty = !1, t = !0);
            var e = this.canvas.width,
                i = this.canvas.height,
                s = 0 | this._scrollX,
                n = 0 | this._scrollY,
                o = this._mc,
                r = o.scrollX - s,
                a = o.scrollY - n;
            if (t || 0 !== r || 0 !== a || o.renderWidth !== e || o.renderHeight !== i) return this.context.save(), o.scrollX = s, o.scrollY = n, o.renderWidth === e && o.renderHeight === i || (o.renderWidth = e, o.renderHeight = i), this.debug && (this.context.globalAlpha = this.debugSettings.debugAlpha, this.debugSettings.forceFullRedraw && (t = !0)), !t && this.renderSettings.enableScrollDelta && Math.abs(r) + Math.abs(a) < Math.min(e, i) ? this.renderDeltaScroll(r, a) : this.renderFull(), this.debug && (this.context.globalAlpha = 1, this.renderDebug()), this.texture.baseTexture.dirty(), this.dirty = !1, this.context.restore(), !0;
          }
        }, s.TilemapLayer.prototype.renderDebug = function () {
          var t,
              e,
              i,
              s,
              n,
              o,
              r = this._mc.scrollX,
              a = this._mc.scrollY,
              h = this.context,
              l = this.canvas.width,
              c = this.canvas.height,
              u = this.layer.width,
              d = this.layer.height,
              p = this._mc.tileWidth,
              f = this._mc.tileHeight,
              g = Math.floor(r / p),
              m = Math.floor((l - 1 + r) / p),
              y = Math.floor(a / f),
              v = Math.floor((c - 1 + a) / f),
              b = g * p - r,
              x = y * f - a,
              w = (g + (1 << 20) * u) % u,
              _ = (y + (1 << 20) * d) % d;

          for (h.strokeStyle = this.debugSettings.facingEdgeStroke, s = _, o = v - y, e = x; o >= 0; s++, o--, e += f) {
            s >= d && (s -= d);
            var T = this.layer.data[s];

            for (i = w, n = m - g, t = b; n >= 0; i++, n--, t += p) {
              i >= u && (i -= u);
              var P = T[i];
              !P || P.index < 0 || !P.collides || (this.debugSettings.collidingTileOverfill && (h.fillStyle = this.debugSettings.collidingTileOverfill, h.fillRect(t, e, this._mc.cw, this._mc.ch)), this.debugSettings.facingEdgeStroke && (h.beginPath(), P.faceTop && (h.moveTo(t, e), h.lineTo(t + this._mc.cw, e)), P.faceBottom && (h.moveTo(t, e + this._mc.ch), h.lineTo(t + this._mc.cw, e + this._mc.ch)), P.faceLeft && (h.moveTo(t, e), h.lineTo(t, e + this._mc.ch)), P.faceRight && (h.moveTo(t + this._mc.cw, e), h.lineTo(t + this._mc.cw, e + this._mc.ch)), h.closePath(), h.stroke()));
            }
          }
        }, Object.defineProperty(s.TilemapLayer.prototype, "wrap", {
          get: function get() {
            return this._wrap;
          },
          set: function set(t) {
            this._wrap = t, this.dirty = !0;
          }
        }), Object.defineProperty(s.TilemapLayer.prototype, "scrollX", {
          get: function get() {
            return this._scrollX;
          },
          set: function set(t) {
            this._scrollX = t;
          }
        }), Object.defineProperty(s.TilemapLayer.prototype, "scrollY", {
          get: function get() {
            return this._scrollY;
          },
          set: function set(t) {
            this._scrollY = t;
          }
        }), Object.defineProperty(s.TilemapLayer.prototype, "collisionWidth", {
          get: function get() {
            return this._mc.cw;
          },
          set: function set(t) {
            this._mc.cw = 0 | t, this.dirty = !0;
          }
        }), Object.defineProperty(s.TilemapLayer.prototype, "collisionHeight", {
          get: function get() {
            return this._mc.ch;
          },
          set: function set(t) {
            this._mc.ch = 0 | t, this.dirty = !0;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.TilemapParser = {
          INSERT_NULL: !1,
          parse: function parse(t, e, i, n, o, r) {
            if (void 0 === i && (i = 32), void 0 === n && (n = 32), void 0 === o && (o = 10), void 0 === r && (r = 10), void 0 === e) return this.getEmptyData();
            if (null === e) return this.getEmptyData(i, n, o, r);
            var a = t.cache.getTilemapData(e);

            if (a) {
              if (a.format === s.Tilemap.CSV) return this.parseCSV(e, a.data, i, n);
              if (!a.format || a.format === s.Tilemap.TILED_JSON) return this.parseTiledJSON(a.data);
            } else console.warn("Phaser.TilemapParser.parse - No map data found for key " + e);
          },
          parseCSV: function parseCSV(t, e, i, n) {
            for (var o = this.getEmptyData(), r = [], a = (e = e.trim()).split("\n"), h = a.length, l = 0, c = 0; c < a.length; c++) {
              r[c] = [];

              for (var u = a[c].split(","), d = 0; d < u.length; d++) {
                r[c][d] = new s.Tile(o.layers[0], parseInt(u[d], 10), d, c, i, n);
              }

              0 === l && (l = u.length);
            }

            return o.format = s.Tilemap.CSV, o.name = t, o.width = l, o.height = h, o.tileWidth = i, o.tileHeight = n, o.widthInPixels = l * i, o.heightInPixels = h * n, o.layers[0].width = l, o.layers[0].height = h, o.layers[0].widthInPixels = o.widthInPixels, o.layers[0].heightInPixels = o.heightInPixels, o.layers[0].data = r, o;
          },
          getEmptyData: function getEmptyData(t, e, i, s) {
            return {
              width: void 0 !== i && null !== i ? i : 0,
              height: void 0 !== s && null !== s ? s : 0,
              tileWidth: void 0 !== t && null !== t ? t : 0,
              tileHeight: void 0 !== e && null !== e ? e : 0,
              orientation: "orthogonal",
              version: "1",
              properties: {},
              widthInPixels: 0,
              heightInPixels: 0,
              layers: [{
                name: "layer",
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                widthInPixels: 0,
                heightInPixels: 0,
                alpha: 1,
                visible: !0,
                properties: {},
                indexes: [],
                callbacks: [],
                bodies: [],
                data: []
              }],
              images: [],
              objects: {},
              collision: {},
              tilesets: [],
              tiles: []
            };
          },
          _slice: function _slice(t, e) {
            var i = {};

            for (var s in e) {
              var n = e[s];
              void 0 !== t[n] && (i[n] = t[n]);
            }

            return i;
          },
          parseObjectGroup: function parseObjectGroup(t, e, i, s, n) {
            s = s || t.name, n = n || {
              x: 0,
              y: 0
            };
            var o = this._slice;
            s || console.warn("No name found for objectGroup", t), void 0 !== n.x && void 0 !== n.y || console.warn("Malformed xy properties in relativePosition", n), e[s] = e[s] || [], i[s] = i[s] || [];

            for (var r = 0, a = t.objects.length; r < a; r++) {
              var h = t.objects[r];

              if (h.gid) {
                var l = {
                  gid: h.gid,
                  name: h.name,
                  type: h.type || "",
                  x: h.x + n.x,
                  y: h.y + n.y,
                  width: h.width,
                  height: h.height,
                  visible: h.visible,
                  properties: h.properties
                };
                h.rotation && (l.rotation = h.rotation), e[s].push(l);
              } else if (h.polyline) {
                l = {
                  name: h.name,
                  type: h.type,
                  x: h.x + n.x,
                  y: h.y + n.y,
                  width: h.width,
                  height: h.height,
                  visible: h.visible,
                  properties: h.properties
                };
                h.rotation && (l.rotation = h.rotation), l.polyline = [];

                for (var c = 0; c < h.polyline.length; c++) {
                  l.polyline.push([h.polyline[c].x, h.polyline[c].y]);
                }

                i[s].push(l), e[s].push(l);
              } else if (h.polygon) {
                (l = o(h, ["name", "type", "x", "y", "visible", "rotation", "properties"])).x += n.x, l.y += n.y, l.polygon = [];

                for (c = 0; c < h.polygon.length; c++) {
                  l.polygon.push([h.polygon[c].x, h.polygon[c].y]);
                }

                i[s].push(l), e[s].push(l);
              } else if (h.ellipse) {
                (l = o(h, ["name", "type", "ellipse", "x", "y", "width", "height", "visible", "rotation", "properties"])).x += n.x, l.y += n.y, i[s].push(l), e[s].push(l);
              } else {
                (l = o(h, ["name", "type", "x", "y", "width", "height", "visible", "rotation", "properties"])).x += n.x, l.y += n.y, l.rectangle = !0, i[s].push(l), e[s].push(l);
              }
            }

            return {
              objectsCollection: e,
              collisionCollection: i
            };
          },
          parseTiledJSON: function parseTiledJSON(t) {
            if ("orthogonal" !== t.orientation) return console.warn("TilemapParser.parseTiledJSON - Only orthogonal map types are supported in this version of Phaser"), null;

            for (var e = {
              width: t.width,
              height: t.height,
              tileWidth: t.tilewidth,
              tileHeight: t.tileheight,
              orientation: t.orientation,
              format: s.Tilemap.TILED_JSON,
              version: t.version,
              properties: t.properties,
              widthInPixels: t.width * t.tilewidth,
              heightInPixels: t.height * t.tileheight
            }, i = [], n = 0; n < t.layers.length; n++) {
              if ("tilelayer" === t.layers[n].type) {
                var o = t.layers[n];

                if (!o.compression && o.encoding && "base64" === o.encoding) {
                  for (var r = window.atob(o.data), a = r.length, h = new Array(a), l = 0; l < a; l += 4) {
                    h[l / 4] = (r.charCodeAt(l) | r.charCodeAt(l + 1) << 8 | r.charCodeAt(l + 2) << 16 | r.charCodeAt(l + 3) << 24) >>> 0;
                  }

                  o.data = h, delete o.encoding;
                } else if (o.compression) {
                  console.warn("TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer '" + o.name + "'");
                  continue;
                }

                var c = {
                  name: o.name,
                  x: o.x,
                  y: o.y,
                  width: o.width,
                  height: o.height,
                  widthInPixels: o.width * t.tilewidth,
                  heightInPixels: o.height * t.tileheight,
                  alpha: o.opacity,
                  offsetX: o.offsetx,
                  offsetY: o.offsety,
                  visible: o.visible,
                  properties: {},
                  indexes: [],
                  callbacks: [],
                  bodies: []
                };
                o.properties && (c.properties = o.properties);
                var u,
                    d,
                    p,
                    f = 0,
                    g = [],
                    m = [],
                    y = 0;

                for (a = o.data.length; y < a; y++) {
                  if (u = 0, d = !1, p = 0, (E = o.data[y]) > 536870912) switch (E > 2147483648 && (E -= 2147483648, p += 4), E > 1073741824 && (E -= 1073741824, p += 2), E > 536870912 && (E -= 536870912, p += 1), p) {
                    case 5:
                      u = Math.PI / 2;
                      break;

                    case 6:
                      u = Math.PI;
                      break;

                    case 3:
                      u = 3 * Math.PI / 2;
                      break;

                    case 4:
                      u = 0, d = !0;
                      break;

                    case 7:
                      u = Math.PI / 2, d = !0;
                      break;

                    case 2:
                      u = Math.PI, d = !0;
                      break;

                    case 1:
                      u = 3 * Math.PI / 2, d = !0;
                  }
                  if (E > 0) (M = new s.Tile(c, E, f, m.length, t.tilewidth, t.tileheight)).rotation = u, M.flipped = d, 0 !== p && (M.flippedVal = p), g.push(M);else s.TilemapParser.INSERT_NULL ? g.push(null) : g.push(new s.Tile(c, -1, f, m.length, t.tilewidth, t.tileheight));
                  ++f === o.width && (m.push(g), f = 0, g = []);
                }

                c.data = m, i.push(c);
              }
            }

            e.layers = i;
            var v = [];

            for (n = 0; n < t.layers.length; n++) {
              if ("imagelayer" === t.layers[n].type) {
                var b = t.layers[n],
                    x = {
                  name: b.name,
                  image: b.image,
                  x: b.x,
                  y: b.y,
                  alpha: b.opacity,
                  visible: b.visible,
                  properties: {}
                };
                b.properties && (x.properties = b.properties), v.push(x);
              }
            }

            e.images = v;
            var w = [],
                _ = {},
                T = [],
                P = null;

            for (n = 0; n < t.tilesets.length; n++) {
              if ((O = t.tilesets[n]).source) console.warn("Phaser.TilemapParser - Phaser can't load external tilesets (%s). Use the Embed Tileset button and then export the map again.", O.source);else if (O.image) {
                var S = new s.Tileset(O.name, O.firstgid, O.tilewidth, O.tileheight, O.margin, O.spacing, O.properties);
                O.tileproperties && (S.tileProperties = O.tileproperties), S.updateTileData(O.imagewidth, O.imageheight), w.push(S);
              } else {
                if (!O.tiles) throw new Error("Tileset " + O.name + " has no `image` or `tiles` property.");
                var C = new s.ImageCollection(O.name, O.firstgid, O.tilewidth, O.tileheight, O.margin, O.spacing, O.properties);

                for (var A in O.tiles) {
                  x = O.tiles[A].image;
                  var E = O.firstgid + parseInt(A, 10);
                  C.addImage(E, x);
                }

                T.push(C);
              }

              for (var A in O.tiles) {
                (k = O.tiles[A].objectgroup) && (_[parseInt(A, 10) + O.firstgid] = k);
              }

              P && (P.lastgid = O.firstgid - 1), P = O;
            }

            if (0 === w.length && 0 === T.length) throw new Error("This tilemap has no tilesets.");
            e.tilesets = w, e.imagecollections = T;
            var M,
                R,
                L = {},
                I = {};

            for (n = 0; n < t.layers.length; n++) {
              if ("objectgroup" === t.layers[n].type) {
                var k = t.layers[n];
                this.parseObjectGroup(k, L, I);
              }
            }

            e.objects = L, e.collision = I, e.tiles = [];

            for (n = 0; n < e.tilesets.length; n++) {
              f = (O = e.tilesets[n]).tileMargin;
              var O,
                  B = O.tileMargin,
                  F = 0,
                  D = 0,
                  U = 0;

              for (y = O.firstgid; y < O.firstgid + O.total && (e.tiles[y] = [f, B, n], f += O.tileWidth + O.tileSpacing, ++F !== O.total) && (++D !== O.columns || (f = O.tileMargin, B += O.tileHeight + O.tileSpacing, D = 0, ++U !== O.rows)); y++) {
                ;
              }
            }

            for (n = 0; n < e.layers.length; n++) {
              I[(c = e.layers[n]).name] = [], O = null;

              for (l = 0; l < c.data.length; l++) {
                g = c.data[l];

                for (var G = 0; G < g.length; G++) {
                  if (!(null === (M = g[G]) || M.index < 0)) R = e.tiles[M.index][2], (O = e.tilesets[R]).tileProperties && O.tileProperties[M.index - O.firstgid] && (M.properties = s.Utils.mixin(O.tileProperties[M.index - O.firstgid], M.properties)), (k = _[M.index]) && this.parseObjectGroup(k, e.objects, e.collision, M.layer.name, {
                    x: M.worldX + k.x,
                    y: M.worldY + k.y
                  });
                }
              }
            }

            return e;
          }
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Tileset = function (t, e, i, s, n, o, r) {
          (void 0 === i || i <= 0) && (i = 32), (void 0 === s || s <= 0) && (s = 32), void 0 === n && (n = 0), void 0 === o && (o = 0), this.name = t, this.firstgid = 0 | e, this.tileWidth = 0 | i, this.tileHeight = 0 | s, this.tileMargin = 0 | n, this.tileSpacing = 0 | o, this.properties = r || {}, this.image = null, this.rows = 0, this.columns = 0, this.total = 0, this.drawCoords = [];
        }, s.Tileset.prototype = {
          draw: function draw(t, e, i, s) {
            var n = s - this.firstgid << 1;
            n >= 0 && n + 1 < this.drawCoords.length && t.drawImage(this.image, this.drawCoords[n], this.drawCoords[n + 1], this.tileWidth, this.tileHeight, e, i, this.tileWidth, this.tileHeight);
          },
          containsTileIndex: function containsTileIndex(t) {
            return t >= this.firstgid && t < this.firstgid + this.total;
          },
          setImage: function setImage(t) {
            this.image = t, this.updateTileData(t.width, t.height);
          },
          setSpacing: function setSpacing(t, e) {
            this.tileMargin = 0 | t, this.tileSpacing = 0 | e, this.image && this.updateTileData(this.image.width, this.image.height);
          },
          updateTileData: function updateTileData(t, e) {
            var i = (e - 2 * this.tileMargin + this.tileSpacing) / (this.tileHeight + this.tileSpacing),
                s = (t - 2 * this.tileMargin + this.tileSpacing) / (this.tileWidth + this.tileSpacing);
            i % 1 == 0 && s % 1 == 0 || console.warn("Phaser.Tileset - '%s' image tile area (%s x %s) is not a whole multiple of tile size (%s x %s + %s + %s)", this.name, t, e, this.tileWidth, this.tileHeight, this.tileMargin, this.tileSpacing), i = Math.floor(i), s = Math.floor(s), (this.rows && this.rows !== i || this.columns && this.columns !== s) && console.warn("Phaser.Tileset - Tile layout from image '%s' (%s rows by %s columns) differs from tileset '%s' (%s rows by %s columns)", this.image.name, s, i, this.name, this.columns, this.rows), this.rows = i, this.columns = s, this.total = i * s, this.drawCoords.length = 0;

            for (var n = this.tileMargin, o = this.tileMargin, r = 0; r < this.rows; r++) {
              for (var a = 0; a < this.columns; a++) {
                this.drawCoords.push(n), this.drawCoords.push(o), n += this.tileWidth + this.tileSpacing;
              }

              n = this.tileMargin, o += this.tileHeight + this.tileSpacing;
            }
          }
        }, s.Tileset.prototype.constructor = s.Tileset,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Particle = function (t, e, i, n, o) {
          s.Sprite.call(this, t, e, i, n, o), this.autoScale = !1, this.scaleData = null, this._s = 0, this.autoAlpha = !1, this.alphaData = null, this._a = 0;
        }, s.Particle.prototype = Object.create(s.Sprite.prototype), s.Particle.prototype.constructor = s.Particle, s.Particle.prototype.update = function () {
          this.autoScale && (this._s--, this._s ? this.scale.set(this.scaleData[this._s].x, this.scaleData[this._s].y) : this.autoScale = !1), this.autoAlpha && (this._a--, this._a ? this.alpha = this.alphaData[this._a].v : this.autoAlpha = !1);
        }, s.Particle.prototype.onEmit = function () {}, s.Particle.prototype.setAlphaData = function (t) {
          this.alphaData = t, this._a = t.length - 1, this.alpha = this.alphaData[this._a].v, this.autoAlpha = !0;
        }, s.Particle.prototype.setScaleData = function (t) {
          this.scaleData = t, this._s = t.length - 1, this.scale.set(this.scaleData[this._s].x, this.scaleData[this._s].y), this.autoScale = !0;
        }, s.Particle.prototype.reset = function (t, e, i) {
          return s.Component.Reset.prototype.reset.call(this, t, e, i), this.alpha = 1, this.scale.set(1), this.autoScale = !1, this.autoAlpha = !1, this;
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Particles = function (t) {
          this.game = t, this.emitters = {}, this.ID = 0;
        }, s.Particles.prototype = {
          add: function add(t) {
            return this.emitters[t.id] = t, t;
          },
          remove: function remove(t) {
            delete this.emitters[t.id];
          }
        }, s.Particles.prototype.constructor = s.Particles,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Particles.Arcade = {},
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Particles.Arcade.Emitter = function (t, e, i, n) {
          this.maxParticles = n || 50, s.Group.call(this, t), this._id = this.game.particles.ID++, this.name = "emitter" + this.id, this.type = s.EMITTER, this.physicsType = s.GROUP, this.area = new s.Rectangle(e, i, 1, 1), this.minAngle = null, this.maxAngle = null, this.minSpeed = 0, this.maxSpeed = 100, this.minParticleSpeed = new s.Point(-100, -100), this.maxParticleSpeed = new s.Point(100, 100), this.minParticleScale = 1, this.maxParticleScale = 1, this.scaleData = null, this.minRotation = -360, this.maxRotation = 360, this.minParticleAlpha = 1, this.maxParticleAlpha = 1, this.alphaData = null, this.particleClass = s.Particle, this.particleDrag = new s.Point(), this.angularDrag = 0, this.frequency = 100, this.lifespan = 2e3, this.bounce = new s.Point(), this.on = !1, this.particleAnchor = new s.Point(.5, .5), this.blendMode = s.blendModes.NORMAL, this.emitX = e, this.emitY = i, this.autoScale = !1, this.autoAlpha = !1, this.particleBringToTop = !1, this.particleSendToBack = !1, this.counts = {
            emitted: 0,
            failed: 0,
            totalEmitted: 0,
            totalFailed: 0
          }, this._gravity = new s.Point(0, 100), this._minParticleScale = new s.Point(1, 1), this._maxParticleScale = new s.Point(1, 1), this._total = 0, this._timer = 0, this._counter = 0, this._flowQuantity = 0, this._flowTotal = 0, this._explode = !0, this._frames = null;
        }, s.Particles.Arcade.Emitter.prototype = Object.create(s.Group.prototype), s.Particles.Arcade.Emitter.prototype.constructor = s.Particles.Arcade.Emitter, s.Particles.Arcade.Emitter.prototype.update = function () {
          if (this.counts.emitted = 0, this.counts.failed = 0, this.on && this.game.time.time >= this._timer) if (this._timer = this.game.time.time + this.frequency * this.game.time.slowMotion, 0 !== this._flowTotal) {
            if (this._flowQuantity > 0) {
              for (var t = 0; t < this._flowQuantity; t++) {
                if (this.emitParticle() && (this._counter++, -1 !== this._flowTotal && this._counter >= this._flowTotal)) {
                  this.on = !1;
                  break;
                }
              }
            } else this.emitParticle() && (this._counter++, -1 !== this._flowTotal && this._counter >= this._flowTotal && (this.on = !1));
          } else this.emitParticle() && (this._counter++, this._total > 0 && this._counter >= this._total && (this.on = !1));

          for (t = this.children.length; t--;) {
            this.children[t].exists && this.children[t].update();
          }
        }, s.Particles.Arcade.Emitter.prototype.makeParticles = function (t, e, i, s, n, o) {
          var r;
          void 0 === e && (e = 0), void 0 === i && (i = this.maxParticles), void 0 === s && (s = !1), void 0 === n && (n = !1), void 0 === o && (o = null);
          var a = 0,
              h = t,
              l = e;

          for (this._frames = e, i > this.maxParticles && (this.maxParticles = i); a < i;) {
            Array.isArray(t) && (h = this.game.rnd.pick(t)), Array.isArray(e) && (l = this.game.rnd.pick(e)), r = new this.particleClass(this.game, 0, 0, h, l, o), this.game.physics.arcade.enable(r, !1), r.body.checkCollision.none = !s, r.body.collideWorldBounds = n, r.body.skipQuadTree = !0, r.exists = !1, r.visible = !1, r.anchor.copyFrom(this.particleAnchor), this.add(r), a++;
          }

          return this;
        }, s.Particles.Arcade.Emitter.prototype.kill = function () {
          return this.on = !1, this.alive = !1, this.exists = !1, this;
        }, s.Particles.Arcade.Emitter.prototype.revive = function () {
          return this.alive = !0, this.exists = !0, this;
        }, s.Particles.Arcade.Emitter.prototype.explode = function (t, e) {
          return void 0 === e && (e = this.maxParticles), this._flowTotal = 0, this.start(!0, t, 0, e, !1), this;
        }, s.Particles.Arcade.Emitter.prototype.flow = function (t, e, i, s, n) {
          return void 0 !== e && null !== e || (e = 250), void 0 !== i && 0 !== i || (i = 1), void 0 === s && (s = -1), void 0 === n && (n = !0), i > this.maxParticles && (i = this.maxParticles), this._counter = 0, this._flowQuantity = i, this._flowTotal = s, n ? (this.start(!0, t, e, i), this._counter += i, this.on = !0, this._timer = this.game.time.time + e * this.game.time.slowMotion) : this.start(!1, t, e, i), this;
        }, s.Particles.Arcade.Emitter.prototype.start = function (t, e, i, s, n) {
          if (void 0 === t && (t = !0), void 0 === e && (e = 0), void 0 !== i && null !== i || (i = 250), void 0 === s && (s = 0), void 0 === n && (n = !1), s > this.maxParticles && (s = this.maxParticles), this.revive(), this.visible = !0, this.lifespan = e, this.frequency = i, t || n) for (var o = 0; o < s; o++) {
            this.emitParticle();
          } else this.on = !0, this._total = s, this._counter = 0, this._timer = this.game.time.time + i * this.game.time.slowMotion;
          return this;
        }, s.Particles.Arcade.Emitter.prototype.emitParticle = function (t, e, i, s) {
          void 0 === t && (t = null), void 0 === e && (e = null);
          var n = this.getNextParticle();
          if (null === n) return this.counts.failed++, this.counts.totalFailed++, !1;
          this.counts.emitted++, this.counts.totalEmitted++;
          var o = this.game.rnd;
          void 0 !== i && void 0 !== s ? n.loadTexture(i, s) : void 0 !== i && (n.loadTexture(i), n.frame = Array.isArray(this._frames) ? o.pick(this._frames) : this._frames);
          var r = this.emitX,
              a = this.emitY;
          return null !== t ? r = t : this.width > 1 && (r = o.between(this.left, this.right)), null !== e ? a = e : this.height > 1 && (a = o.between(this.top, this.bottom)), this.resetParticle(n, r, a), !0;
        }, s.Particles.Arcade.Emitter.prototype.getNextParticle = function () {
          for (var t = this.length; t--;) {
            var e = this.next();
            if (!e.exists) return e;
          }

          return null;
        }, s.Particles.Arcade.Emitter.prototype.resetParticle = function (t, e, i) {
          var s = this.game.rnd;
          t.reset(e, i), t.angle = 0, t.lifespan = this.lifespan, this.particleBringToTop ? this.bringToTop(t) : this.particleSendToBack && this.sendToBack(t), this.autoScale ? t.setScaleData(this.scaleData) : 1 !== this.minParticleScale || 1 !== this.maxParticleScale ? t.scale.set(s.realInRange(this.minParticleScale, this.maxParticleScale)) : this._minParticleScale.x !== this._maxParticleScale.x || this._minParticleScale.y !== this._maxParticleScale.y ? t.scale.set(s.realInRange(this._minParticleScale.x, this._maxParticleScale.x), s.realInRange(this._minParticleScale.y, this._maxParticleScale.y)) : t.scale.set(this._minParticleScale.x, this._minParticleScale.y), this.autoAlpha ? t.setAlphaData(this.alphaData) : t.alpha = s.realInRange(this.minParticleAlpha, this.maxParticleAlpha), t.blendMode = this.blendMode;
          var n = t.body;
          n.updateBounds(), n.bounce.copyFrom(this.bounce), n.drag.copyFrom(this.particleDrag), null != this.minAngle && null != this.maxAngle ? this.game.physics.arcade.velocityFromAngle(this.minAngle === this.maxAngle ? this.minAngle : s.between(this.minAngle, this.maxAngle), this.minSpeed === this.maxSpeed ? this.minSpeed : s.between(this.minSpeed, this.maxSpeed), n.velocity) : (n.velocity.x = s.between(this.minParticleSpeed.x, this.maxParticleSpeed.x), n.velocity.y = s.between(this.minParticleSpeed.y, this.maxParticleSpeed.y)), n.angularVelocity = s.between(this.minRotation, this.maxRotation), n.gravity.copyFrom(this.gravity), n.angularDrag = this.angularDrag, t.onEmit();
        }, s.Particles.Arcade.Emitter.prototype.destroy = function () {
          this.game.particles.remove(this), s.Group.prototype.destroy.call(this, !0, !1);
        }, s.Particles.Arcade.Emitter.prototype.setSize = function (t, e) {
          return this.area.width = t, this.area.height = e, this;
        }, s.Particles.Arcade.Emitter.prototype.setXSpeed = function (t, e) {
          return t = t || 0, e = e || 0, this.minParticleSpeed.x = t, this.maxParticleSpeed.x = e, this;
        }, s.Particles.Arcade.Emitter.prototype.setYSpeed = function (t, e) {
          return t = t || 0, e = e || 0, this.minParticleSpeed.y = t, this.maxParticleSpeed.y = e, this;
        }, s.Particles.Arcade.Emitter.prototype.setRotation = function (t, e) {
          return t = t || 0, e = e || 0, this.minRotation = t, this.maxRotation = e, this;
        }, s.Particles.Arcade.Emitter.prototype.setAlpha = function (t, e, i, n, o) {
          if (void 0 === t && (t = 1), void 0 === e && (e = 1), void 0 === i && (i = 0), void 0 === n && (n = s.Easing.Linear.None), void 0 === o && (o = !1), this.minParticleAlpha = t, this.maxParticleAlpha = e, this.autoAlpha = !1, i > 0 && t !== e) {
            var r = {
              v: t
            },
                a = this.game.make.tween(r).to({
              v: e
            }, i, n);
            a.yoyo(o), this.alphaData = a.generateData(60), this.alphaData.reverse(), this.autoAlpha = !0;
          }

          return this;
        }, s.Particles.Arcade.Emitter.prototype.setScale = function (t, e, i, n, o, r, a) {
          if (void 0 === t && (t = 1), void 0 === e && (e = 1), void 0 === i && (i = 1), void 0 === n && (n = 1), void 0 === o && (o = 0), void 0 === r && (r = s.Easing.Linear.None), void 0 === a && (a = !1), this.minParticleScale = 1, this.maxParticleScale = 1, this._minParticleScale.set(t, i), this._maxParticleScale.set(e, n), this.autoScale = !1, o > 0 && (t !== e || i !== n)) {
            var h = {
              x: t,
              y: i
            },
                l = this.game.make.tween(h).to({
              x: e,
              y: n
            }, o, r);
            l.yoyo(a), this.scaleData = l.generateData(60), this.scaleData.reverse(), this.autoScale = !0;
          }

          return this;
        }, s.Particles.Arcade.Emitter.prototype.setAngle = function (t, e, i, s) {
          return this.minAngle = t, this.maxAngle = e, null != i && (this.minSpeed = i), null != s && (this.maxSpeed = s), this;
        }, s.Particles.Arcade.Emitter.prototype.at = function (t) {
          return t.center ? (this.emitX = t.center.x, this.emitY = t.center.y) : (this.emitX = t.world.x + t.anchor.x * t.width, this.emitY = t.world.y + t.anchor.y * t.height), this;
        }, Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "gravity", {
          get: function get() {
            return this._gravity;
          },
          set: function set(t) {
            "number" == typeof t ? this._gravity.y = t : this._gravity = t;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "id", {
          get: function get() {
            return this._id;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "width", {
          get: function get() {
            return this.area.width;
          },
          set: function set(t) {
            this.area.width = t;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "height", {
          get: function get() {
            return this.area.height;
          },
          set: function set(t) {
            this.area.height = t;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "x", {
          get: function get() {
            return this.emitX;
          },
          set: function set(t) {
            this.emitX = t;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "y", {
          get: function get() {
            return this.emitY;
          },
          set: function set(t) {
            this.emitY = t;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "left", {
          get: function get() {
            return Math.floor(this.x - this.area.width / 2);
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "right", {
          get: function get() {
            return Math.floor(this.x + this.area.width / 2);
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "top", {
          get: function get() {
            return Math.floor(this.y - this.area.height / 2);
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "bottom", {
          get: function get() {
            return Math.floor(this.y + this.area.height / 2);
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "output", {
          get: function get() {
            return 1e3 * this._flowQuantity / this.frequency;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "lifespanOutput", {
          get: function get() {
            return (0 === this.lifespan ? 1 / 0 : this.lifespan) * this._flowQuantity / this.frequency;
          }
        }), Object.defineProperty(s.Particles.Arcade.Emitter.prototype, "remainder", {
          get: function get() {
            return this.maxParticles - this.lifespanOutput;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Weapon = function (t, e) {
          s.Plugin.call(this, t, e), this.bullets = null, this.autoExpandBulletsGroup = !1, this.autofire = !1, this.shots = 0, this.fireLimit = 0, this.fireRate = 100, this.fireRateVariance = 0, this.fireFrom = new s.Rectangle(0, 0, 1, 1), this.fireAngle = s.ANGLE_UP, this.bulletInheritSpriteSpeed = !1, this.bulletAnimation = "", this.bulletFrameRandom = !1, this.bulletFrameCycle = !1, this.bulletWorldWrap = !1, this.bulletWorldWrapPadding = 0, this.bulletAngleOffset = 0, this.bulletAngleVariance = 0, this.bulletSpeed = 200, this.bulletSpeedVariance = 0, this.bulletLifespan = 0, this.bulletKillDistance = 0, this.bulletGravity = new s.Point(0, 0), this.bulletRotateToVelocity = !1, this.bulletKey = "", this.bulletFrame = "", this._bulletClass = s.Bullet, this._bulletCollideWorldBounds = !1, this._bulletKillType = s.Weapon.KILL_WORLD_BOUNDS, this._data = {
            customBody: !1,
            width: 0,
            height: 0,
            offsetX: 0,
            offsetY: 0
          }, this.bounds = new s.Rectangle(), this.bulletBounds = t.world.bounds, this.bulletFrames = [], this.bulletFrameIndex = 0, this.anims = {}, this.onFire = new s.Signal(), this.onKill = new s.Signal(), this.onFireLimit = new s.Signal(), this.trackedSprite = null, this.trackedPointer = null, this.multiFire = !1, this._hasFired = !1, this.trackRotation = !1, this.trackOffset = new s.Point(), this._nextFire = 0, this._tempNextFire = 0, this._rotatedPoint = new s.Point();
        }, s.Weapon.prototype = Object.create(s.Plugin.prototype), s.Weapon.prototype.constructor = s.Weapon, s.Weapon.KILL_NEVER = 0, s.Weapon.KILL_LIFESPAN = 1, s.Weapon.KILL_DISTANCE = 2, s.Weapon.KILL_WEAPON_BOUNDS = 3, s.Weapon.KILL_CAMERA_BOUNDS = 4, s.Weapon.KILL_WORLD_BOUNDS = 5, s.Weapon.KILL_STATIC_BOUNDS = 6, s.Weapon.prototype.createBullets = function (t, e, i, n) {
          return void 0 === t && (t = 1), void 0 === n && (n = this.game.world), this.bullets && !this.bullets.game && (this.bullets = null), this.bullets || (this.bullets = this.game.add.physicsGroup(s.Physics.ARCADE, n), this.bullets.classType = this._bulletClass), 0 !== t && (-1 === t && (this.autoExpandBulletsGroup = !0, t = 1), this.bullets.createMultiple(t, e, i), this.bullets.setAll("data.bulletManager", this), this.bulletKey = e, this.bulletFrame = i), this;
        }, s.Weapon.prototype.forEach = function (t, e) {
          return this.bullets.forEachExists(t, e, arguments), this;
        }, s.Weapon.prototype.pauseAll = function () {
          return this.bullets.setAll("body.enable", !1), this;
        }, s.Weapon.prototype.resumeAll = function () {
          return this.bullets.setAll("body.enable", !0), this;
        }, s.Weapon.prototype.killAll = function () {
          return this.bullets.callAllExists("kill", !0), this.bullets.setAll("body.enable", !0), this;
        }, s.Weapon.prototype.resetShots = function (t) {
          return this.shots = 0, void 0 !== t && (this.fireLimit = t), this;
        }, s.Weapon.prototype.destroy = function () {
          this.parent.remove(this, !1), this.bullets.destroy(), this.game = null, this.parent = null, this.active = !1, this.visible = !1;
        }, s.Weapon.prototype.update = function () {
          this._bulletKillType === s.Weapon.KILL_WEAPON_BOUNDS && (this.trackedSprite ? (this.trackedSprite.updateTransform(), this.bounds.centerOn(this.trackedSprite.worldPosition.x, this.trackedSprite.worldPosition.y)) : this.trackedPointer && this.bounds.centerOn(this.trackedPointer.worldX, this.trackedPointer.worldY)), this.autofire && this.fire();
        }, s.Weapon.prototype.postRender = function () {
          this.multiFire && this._hasFired && (this._hasFired = !1, this._nextFire = this._tempNextFire);
        }, s.Weapon.prototype.trackSprite = function (t, e, i, s) {
          return void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === s && (s = !1), this.trackedPointer = null, this.trackedSprite = t, this.trackRotation = s, this.trackOffset.set(e, i), this;
        }, s.Weapon.prototype.trackPointer = function (t, e, i) {
          return void 0 === t && (t = this.game.input.activePointer), void 0 === e && (e = 0), void 0 === i && (i = 0), this.trackedPointer = t, this.trackedSprite = null, this.trackRotation = !1, this.trackOffset.set(e, i), this;
        }, s.Weapon.prototype.fireMany = function (t, e) {
          this.multiFire = !0;
          var i = [],
              s = this;
          return e || this.trackedSprite || this.trackedPointer ? t.forEach(function (t) {
            i.push(s.fire(e, null, null, t.x, t.y));
          }) : t.forEach(function (t) {
            i.push(s.fire(t));
          }), i;
        }, s.Weapon.prototype.fireOffset = function (t, e) {
          return void 0 === t && (t = 0), void 0 === e && (e = 0), this.fire(null, null, null, t, e);
        }, s.Weapon.prototype.fire = function (t, e, i, n, o) {
          if (void 0 === e && (e = null), void 0 === i && (i = null), this.game.time.now < this._nextFire || this.fireLimit > 0 && this.shots === this.fireLimit) return null;
          var r = this.bulletSpeed;
          0 !== this.bulletSpeedVariance && (r += s.Math.between(-this.bulletSpeedVariance, this.bulletSpeedVariance)), t ? this.fireFrom.width > 1 ? this.fireFrom.centerOn(t.x, t.y) : (this.fireFrom.x = t.x, this.fireFrom.y = t.y) : this.trackedSprite ? (this.trackRotation ? (this._rotatedPoint.set(this.trackedSprite.world.x + this.trackOffset.x, this.trackedSprite.world.y + this.trackOffset.y), this._rotatedPoint.rotate(this.trackedSprite.world.x, this.trackedSprite.world.y, this.trackedSprite.worldRotation), this.fireFrom.width > 1 ? this.fireFrom.centerOn(this._rotatedPoint.x, this._rotatedPoint.y) : (this.fireFrom.x = this._rotatedPoint.x, this.fireFrom.y = this._rotatedPoint.y)) : this.fireFrom.width > 1 ? this.fireFrom.centerOn(this.trackedSprite.world.x + this.trackOffset.x, this.trackedSprite.world.y + this.trackOffset.y) : (this.fireFrom.x = this.trackedSprite.world.x + this.trackOffset.x, this.fireFrom.y = this.trackedSprite.world.y + this.trackOffset.y), this.bulletInheritSpriteSpeed && (r += this.trackedSprite.body.speed)) : this.trackedPointer && (this.fireFrom.width > 1 ? this.fireFrom.centerOn(this.trackedPointer.world.x + this.trackOffset.x, this.trackedPointer.world.y + this.trackOffset.y) : (this.fireFrom.x = this.trackedPointer.world.x + this.trackOffset.x, this.fireFrom.y = this.trackedPointer.world.y + this.trackOffset.y)), void 0 !== n && (this.fireFrom.x += n), void 0 !== o && (this.fireFrom.y += o);
          var a = this.fireFrom.width > 1 ? this.fireFrom.randomX : this.fireFrom.x,
              h = this.fireFrom.height > 1 ? this.fireFrom.randomY : this.fireFrom.y,
              l = this.trackRotation ? this.trackedSprite.angle : this.fireAngle;
          null !== e && null !== i && (l = this.game.math.radToDeg(Math.atan2(i - h, e - a))), 0 !== this.bulletAngleVariance && (l += s.Math.between(-this.bulletAngleVariance, this.bulletAngleVariance));
          var c = 0,
              u = 0;
          0 === l || 180 === l ? c = Math.cos(this.game.math.degToRad(l)) * r : 90 === l || 270 === l ? u = Math.sin(this.game.math.degToRad(l)) * r : (c = Math.cos(this.game.math.degToRad(l)) * r, u = Math.sin(this.game.math.degToRad(l)) * r);
          var d = null;

          if (this.autoExpandBulletsGroup ? (d = this.bullets.getFirstExists(!1, !0, a, h, this.bulletKey, this.bulletFrame)).data.bulletManager = this : d = this.bullets.getFirstExists(!1), d) {
            if (d.reset(a, h), d.data.fromX = a, d.data.fromY = h, d.data.killType = this.bulletKillType, d.data.killDistance = this.bulletKillDistance, d.data.rotateToVelocity = this.bulletRotateToVelocity, this.bulletKillType === s.Weapon.KILL_LIFESPAN && (d.lifespan = this.bulletLifespan), d.angle = l + this.bulletAngleOffset, "" !== this.bulletAnimation) {
              if (null === d.animations.getAnimation(this.bulletAnimation)) {
                var p = this.anims[this.bulletAnimation];
                d.animations.add(p.name, p.frames, p.frameRate, p.loop, p.useNumericIndex);
              }

              d.animations.play(this.bulletAnimation);
            } else this.bulletFrameCycle ? (d.frame = this.bulletFrames[this.bulletFrameIndex], this.bulletFrameIndex++, this.bulletFrameIndex >= this.bulletFrames.length && (this.bulletFrameIndex = 0)) : this.bulletFrameRandom && (d.frame = this.bulletFrames[Math.floor(Math.random() * this.bulletFrames.length)]);

            d.data.bodyDirty && (this._data.customBody && d.body.setSize(this._data.width, this._data.height, this._data.offsetX, this._data.offsetY), d.body.collideWorldBounds = this.bulletCollideWorldBounds, d.data.bodyDirty = !1), d.body.velocity.set(c, u), d.body.gravity.set(this.bulletGravity.x, this.bulletGravity.y);
            var f = 0;

            if (0 !== this.bulletSpeedVariance) {
              var g = this.fireRate;
              (g += s.Math.between(-this.fireRateVariance, this.fireRateVariance)) < 0 && (g = 0), f = this.game.time.now + g;
            } else f = this.game.time.now + this.fireRate;

            this.multiFire ? this._hasFired || (this._hasFired = !0, this._tempNextFire = f, this.shots++) : (this._nextFire = f, this.shots++), this.onFire.dispatch(d, this, r), this.fireLimit > 0 && this.shots === this.fireLimit && this.onFireLimit.dispatch(this, this.fireLimit);
          }

          return d;
        }, s.Weapon.prototype.fireAtPointer = function (t) {
          return void 0 === t && (t = this.game.input.activePointer), this.fire(null, t.worldX, t.worldY);
        }, s.Weapon.prototype.fireAtSprite = function (t) {
          return this.fire(null, t.world.x, t.world.y);
        }, s.Weapon.prototype.fireAtXY = function (t, e) {
          return this.fire(null, t, e);
        }, s.Weapon.prototype.setBulletBodyOffset = function (t, e, i, s) {
          return void 0 === i && (i = 0), void 0 === s && (s = 0), this._data.customBody = !0, this._data.width = t, this._data.height = e, this._data.offsetX = i, this._data.offsetY = s, this.bullets.callAll("body.setSize", "body", t, e, i, s), this.bullets.setAll("data.bodyDirty", !1), this;
        }, s.Weapon.prototype.setBulletFrames = function (t, e, i, n) {
          return void 0 === i && (i = !0), void 0 === n && (n = !1), this.bulletFrames = s.ArrayUtils.numberArray(t, e), this.bulletFrameIndex = 0, this.bulletFrameCycle = i, this.bulletFrameRandom = n, this;
        }, s.Weapon.prototype.addBulletAnimation = function (t, e, i, s, n) {
          return this.anims[t] = {
            name: t,
            frames: e,
            frameRate: i,
            loop: s,
            useNumericIndex: n
          }, this.bullets.callAll("animations.add", "animations", t, e, i, s, n), this.bulletAnimation = t, this;
        }, s.Weapon.prototype.debug = function (t, e, i) {
          void 0 === t && (t = 16), void 0 === e && (e = 32), void 0 === i && (i = !1), this.game.debug.text("Weapon Plugin", t, e), this.game.debug.text("Bullets Alive: " + this.bullets.total + " - Total: " + this.bullets.length, t, e + 24), i && this.bullets.forEachExists(this.game.debug.body, this.game.debug, "rgba(255, 0, 255, 0.8)");
        }, Object.defineProperty(s.Weapon.prototype, "bulletClass", {
          get: function get() {
            return this._bulletClass;
          },
          set: function set(t) {
            this._bulletClass = t, this.bullets && (this.bullets.classType = this._bulletClass);
          }
        }), Object.defineProperty(s.Weapon.prototype, "bulletKillType", {
          get: function get() {
            return this._bulletKillType;
          },
          set: function set(t) {
            switch (t) {
              case s.Weapon.KILL_STATIC_BOUNDS:
              case s.Weapon.KILL_WEAPON_BOUNDS:
                this.bulletBounds = this.bounds;
                break;

              case s.Weapon.KILL_CAMERA_BOUNDS:
                this.bulletBounds = this.game.camera.view;
                break;

              case s.Weapon.KILL_WORLD_BOUNDS:
                this.bulletBounds = this.game.world.bounds;
            }

            this._bulletKillType = t;
          }
        }), Object.defineProperty(s.Weapon.prototype, "bulletCollideWorldBounds", {
          get: function get() {
            return this._bulletCollideWorldBounds;
          },
          set: function set(t) {
            this._bulletCollideWorldBounds = t, this.bullets.setAll("body.collideWorldBounds", t), this.bullets.setAll("data.bodyDirty", !1);
          }
        }), Object.defineProperty(s.Weapon.prototype, "x", {
          get: function get() {
            return this.fireFrom.x;
          },
          set: function set(t) {
            this.fireFrom.x = t;
          }
        }), Object.defineProperty(s.Weapon.prototype, "y", {
          get: function get() {
            return this.fireFrom.y;
          },
          set: function set(t) {
            this.fireFrom.y = t;
          }
        }),
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Bullet = function (t, e, i, n, o) {
          s.Sprite.call(this, t, e, i, n, o), this.anchor.set(.5), this.data = {
            bulletManager: null,
            fromX: 0,
            fromY: 0,
            bodyDirty: !0,
            rotateToVelocity: !1,
            killType: 0,
            killDistance: 0
          };
        }, s.Bullet.prototype = Object.create(s.Sprite.prototype), s.Bullet.prototype.constructor = s.Bullet, s.Bullet.prototype.kill = function () {
          return this.alive = !1, this.exists = !1, this.visible = !1, this.data.bulletManager.onKill.dispatch(this), this;
        }, s.Bullet.prototype.update = function () {
          this.exists && (this.data.killType > s.Weapon.KILL_LIFESPAN && (this.data.killType === s.Weapon.KILL_DISTANCE ? this.game.physics.arcade.distanceToXY(this, this.data.fromX, this.data.fromY, !0) > this.data.killDistance && this.kill() : this.data.bulletManager.bulletBounds.intersects(this) || this.kill()), this.data.rotateToVelocity && (this.rotation = this.body.velocity.atan()), this.data.bulletManager.bulletWorldWrap && this.game.world.wrap(this, this.data.bulletManager.bulletWorldWrapPadding));
        },
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        s.Video = function (t, e, i) {
          if (void 0 === e && (e = null), void 0 === i && (i = null), this.game = t, this.key = e, this.width = 0, this.height = 0, this.type = s.VIDEO, this.disableTextureUpload = !1, this.touchLocked = !1, this.onPlay = new s.Signal(), this.onChangeSource = new s.Signal(), this.onComplete = new s.Signal(), this.onAccess = new s.Signal(), this.onError = new s.Signal(), this.onTimeout = new s.Signal(), this.onTouchUnlock = new s.Signal(), this.playWhenUnlocked = !0, this.timeout = 15e3, this._timeOutID = null, this.video = null, this.videoStream = null, this.isStreaming = !1, this.retryLimit = 20, this.retry = 0, this.retryInterval = 500, this._retryID = null, this._codeMuted = !1, this._muted = !1, this._codePaused = !1, this._paused = !1, this._pending = !1, this._pendingChangeSource = !1, this._autoplay = !1, this._endCallback = null, this._playCallback = null, e && this.game.cache.checkVideoKey(e)) {
            var n = this.game.cache.getVideo(e);
            n.isBlob ? this.createVideoFromBlob(n.data) : this.video = n.data, this.width = this.video.videoWidth, this.height = this.video.videoHeight;
          } else i && this.createVideoFromURL(i, !1);

          this.video && !i ? (this.baseTexture = new PIXI.BaseTexture(this.video, null, this.game.resolution), this.baseTexture.forceLoaded(this.width, this.height)) : (this.baseTexture = new PIXI.BaseTexture(s.Cache.DEFAULT.baseTexture.source, null, this.game.resolution), this.baseTexture.forceLoaded(this.width, this.height)), this.texture = new PIXI.Texture(this.baseTexture), this.textureFrame = new s.Frame(0, 0, 0, this.width, this.height, "video"), this.texture.setFrame(this.textureFrame), this.texture.valid = !1, null !== e && this.video && (this.texture.valid = this.video.canplay), this.snapshot = null, s.BitmapData && (this.snapshot = new s.BitmapData(this.game, "", this.width, this.height)), this.game.device.needsTouchUnlock() ? this.setTouchLock() : n && (n.locked = !1);
        }, s.Video.prototype = {
          connectToMediaStream: function connectToMediaStream(t, e) {
            return t && e && (this.video = t, this.videoStream = e, this.isStreaming = !0, this.baseTexture.source = this.video, this.updateTexture(null, this.video.videoWidth, this.video.videoHeight), this.onAccess.dispatch(this)), this;
          },
          startMediaStream: function startMediaStream(t, e, i) {
            if (void 0 === t && (t = !1), void 0 === e && (e = null), void 0 === i && (i = null), !this.game.device.getUserMedia) return this.onError.dispatch(this, "No getUserMedia"), !1;
            null !== this.videoStream && (this.videoStream.active ? this.videoStream.active = !1 : this.videoStream.stop()), this.removeVideoElement(), this.video = document.createElement("video"), this.video.setAttribute("autoplay", "autoplay"), null !== e && (this.video.width = e), null !== i && (this.video.height = i), this._timeOutID = window.setTimeout(this.getUserMediaTimeout.bind(this), this.timeout);

            try {
              navigator.getUserMedia({
                audio: t,
                video: !0
              }, this.getUserMediaSuccess.bind(this), this.getUserMediaError.bind(this));
            } catch (t) {
              this.getUserMediaError(t);
            }

            return this;
          },
          getUserMediaTimeout: function getUserMediaTimeout() {
            clearTimeout(this._timeOutID), this.onTimeout.dispatch(this);
          },
          getUserMediaError: function getUserMediaError(t) {
            clearTimeout(this._timeOutID), this.onError.dispatch(this, t);
          },
          getUserMediaSuccess: function getUserMediaSuccess(t) {
            clearTimeout(this._timeOutID), this.videoStream = t, void 0 !== this.video.mozSrcObject ? this.video.mozSrcObject = t : this.video.src = window.URL && window.URL.createObjectURL(t) || t;
            var e = this;

            this.video.onloadeddata = function () {
              var t = 10;
              !function i() {
                if (t > 0) {
                  if (e.video.videoWidth > 0) {
                    var s = e.video.videoWidth,
                        n = e.video.videoHeight;
                    isNaN(e.video.videoHeight) && (n = s / (4 / 3)), e.video.play(), e.isStreaming = !0, e.baseTexture.source = e.video, e.updateTexture(null, s, n), e.onAccess.dispatch(e);
                  } else window.setTimeout(i, 500);
                } else console.warn("Unable to connect to video stream. Webcam error?");
                t--;
              }();
            };
          },
          createVideoFromBlob: function createVideoFromBlob(t) {
            var e = this;
            return this.video = document.createElement("video"), this.video.controls = !1, this.video.setAttribute("autoplay", "autoplay"), this.video.addEventListener("loadeddata", function (t) {
              e.updateTexture(t);
            }, !0), this.video.src = window.URL.createObjectURL(t), this.video.canplay = !0, this;
          },
          createVideoFromURL: function createVideoFromURL(t, e) {
            return void 0 === e && (e = !1), this.texture && (this.texture.valid = !1), this.video = document.createElement("video"), this.video.controls = !1, e && this.video.setAttribute("autoplay", "autoplay"), this.video.src = t, this.video.canplay = !0, this.video.load(), this.retry = this.retryLimit, this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval), this.key = t, this;
          },
          updateTexture: function updateTexture(t, e, i) {
            var s = !1;
            void 0 !== e && null !== e || (e = this.video.videoWidth, s = !0), void 0 !== i && null !== i || (i = this.video.videoHeight), this.width = e, this.height = i, this.baseTexture.source !== this.video && (this.baseTexture.source = this.video), this.baseTexture.forceLoaded(e, i), this.texture.frame.resize(e, i), this.texture.width = e, this.texture.height = i, this.texture.valid = !0, this.snapshot && this.snapshot.resize(e, i), s && null !== this.key && (this.onChangeSource.dispatch(this, e, i), this._autoplay && (this.video.play(), this.onPlay.dispatch(this, this.loop, this.playbackRate)));
          },
          complete: function complete() {
            this.onComplete.dispatch(this);
          },
          play: function play(t, e) {
            return this._pendingChangeSource ? this : (void 0 === t && (t = !1), void 0 === e && (e = 1), this.game.sound.onMute && (this.game.sound.onMute.add(this.setMute, this), this.game.sound.onUnMute.add(this.unsetMute, this), this.game.sound.mute && this.setMute()), this.game.onPause.add(this.setPause, this), this.game.onResume.add(this.setResume, this), this._endCallback = this.complete.bind(this), this.video.addEventListener("ended", this._endCallback, !0), this.video.addEventListener("webkitendfullscreen", this._endCallback, !0), this.video.loop = t ? "loop" : "", this.video.playbackRate = e, this.touchLocked ? this._pending = !0 : (this._pending = !1, null !== this.key && (4 !== this.video.readyState ? (this.retry = this.retryLimit, this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval)) : (this._playCallback = this.playHandler.bind(this), this.video.addEventListener("playing", this._playCallback, !0))), this.video.play(), this.onPlay.dispatch(this, t, e)), this);
          },
          playHandler: function playHandler() {
            this.video.removeEventListener("playing", this._playCallback, !0), this.updateTexture();
          },
          stop: function stop() {
            return this.game.sound.onMute && (this.game.sound.onMute.remove(this.setMute, this), this.game.sound.onUnMute.remove(this.unsetMute, this)), this.game.onPause.remove(this.setPause, this), this.game.onResume.remove(this.setResume, this), this.isStreaming ? (this.video.mozSrcObject ? (this.video.mozSrcObject.stop(), this.video.src = null) : (this.video.src = "", this.videoStream.active ? this.videoStream.active = !1 : this.videoStream.getTracks ? this.videoStream.getTracks().forEach(function (t) {
              t.stop();
            }) : this.videoStream.stop()), this.videoStream = null, this.isStreaming = !1) : (this.video.removeEventListener("ended", this._endCallback, !0), this.video.removeEventListener("webkitendfullscreen", this._endCallback, !0), this.video.removeEventListener("playing", this._playCallback, !0), this.touchLocked ? this._pending = !1 : this.video.pause()), this;
          },
          add: function add(t) {
            if (Array.isArray(t)) for (var e = 0; e < t.length; e++) {
              t[e].loadTexture && t[e].loadTexture(this);
            } else t.loadTexture(this);
            return this;
          },
          addToWorld: function addToWorld(t, e, i, s, n, o) {
            n = n || 1, o = o || 1;
            var r = this.game.add.image(t, e, this);
            return r.anchor.set(i, s), r.scale.set(n, o), r;
          },
          render: function render() {
            !this.disableTextureUpload && this.playing && this.baseTexture.dirty();
          },
          setMute: function setMute() {
            this._muted || (this._muted = !0, this.video.muted = !0);
          },
          unsetMute: function unsetMute() {
            this._muted && !this._codeMuted && (this._muted = !1, this.video.muted = !1);
          },
          setPause: function setPause() {
            this._paused || this.touchLocked || (this._paused = !0, this.video.pause());
          },
          setResume: function setResume() {
            !this._paused || this._codePaused || this.touchLocked || (this._paused = !1, this.video.ended || this.video.play());
          },
          changeSource: function changeSource(t, e) {
            return void 0 === e && (e = !0), this.texture.valid = !1, this.video.pause(), this._pendingChangeSource = !0, this.retry = this.retryLimit, this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval), this.video.src = t, this.video.load(), this._autoplay = e, e || (this.paused = !0), this;
          },
          checkVideoProgress: function checkVideoProgress() {
            4 === this.video.readyState ? (this._pendingChangeSource = !1, this.updateTexture()) : (this.retry--, this.retry > 0 ? this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval) : console.warn("Phaser.Video: Unable to start downloading video in time", this.isStreaming));
          },
          setTouchLock: function setTouchLock() {
            this.game.input.addTouchLockCallback(this.unlock, this, !0), this.touchLocked = !0;
          },
          unlock: function unlock() {
            if (this.touchLocked = !1, this.playWhenUnlocked && (this.video.play(), this.onPlay.dispatch(this, this.loop, this.playbackRate)), this.key) {
              var t = this.game.cache.getVideo(this.key);
              t && !t.isBlob && (t.locked = !1);
            }

            return this.onTouchUnlock.dispatch(this), !0;
          },
          grab: function grab(t, e, i) {
            if (void 0 === t && (t = !1), void 0 === e && (e = 1), void 0 === i && (i = null), null !== this.snapshot) return t && this.snapshot.cls(), this.snapshot.copy(this.video, 0, 0, this.width, this.height, 0, 0, this.width, this.height, 0, 0, 0, 1, 1, e, i), this.snapshot;
            console.warn("Video.grab cannot run because Phaser.BitmapData is unavailable");
          },
          removeVideoElement: function removeVideoElement() {
            if (this.video) {
              for (this.video.parentNode && this.video.parentNode.removeChild(this.video); this.video.hasChildNodes();) {
                this.video.removeChild(this.video.firstChild);
              }

              this.video.removeAttribute("autoplay"), this.video.removeAttribute("src"), this.video = null;
            }
          },
          destroy: function destroy() {
            this.stop(), this.removeVideoElement(), this.touchLocked && this.game.input.touch.removeTouchLockCallback(this.unlock, this), this._retryID && window.clearTimeout(this._retryID);
          }
        }, Object.defineProperty(s.Video.prototype, "currentTime", {
          get: function get() {
            return this.video ? this.video.currentTime : 0;
          },
          set: function set(t) {
            this.video.currentTime = t;
          }
        }), Object.defineProperty(s.Video.prototype, "duration", {
          get: function get() {
            return this.video ? this.video.duration : 0;
          }
        }), Object.defineProperty(s.Video.prototype, "progress", {
          get: function get() {
            return this.video ? this.video.currentTime / this.video.duration : 0;
          }
        }), Object.defineProperty(s.Video.prototype, "mute", {
          get: function get() {
            return this._muted;
          },
          set: function set(t) {
            if (t = t || null) {
              if (this._muted) return;
              this._codeMuted = !0, this.setMute();
            } else {
              if (!this._muted) return;
              this._codeMuted = !1, this.unsetMute();
            }
          }
        }), Object.defineProperty(s.Video.prototype, "paused", {
          get: function get() {
            return this._paused;
          },
          set: function set(t) {
            if (t = t || null, !this.touchLocked) if (t) {
              if (this._paused) return;
              this._codePaused = !0, this.setPause();
            } else {
              if (!this._paused) return;
              this._codePaused = !1, this.setResume();
            }
          }
        }), Object.defineProperty(s.Video.prototype, "volume", {
          get: function get() {
            return this.video ? this.video.volume : 1;
          },
          set: function set(t) {
            t < 0 ? t = 0 : t > 1 && (t = 1), this.video && (this.video.volume = t);
          }
        }), Object.defineProperty(s.Video.prototype, "playbackRate", {
          get: function get() {
            return this.video ? this.video.playbackRate : 1;
          },
          set: function set(t) {
            this.video && (this.video.playbackRate = t);
          }
        }), Object.defineProperty(s.Video.prototype, "loop", {
          get: function get() {
            return !!this.video && this.video.loop;
          },
          set: function set(t) {
            t && this.video ? this.video.loop = "loop" : this.video && (this.video.loop = "");
          }
        }), Object.defineProperty(s.Video.prototype, "playing", {
          get: function get() {
            return !!this.video && !(this.video.paused && this.video.ended);
          }
        }), s.Video.prototype.constructor = s.Video,
        /**
        * @author       Richard Davey <rich@photonstorm.com>
        * @copyright    2016 Photon Storm Ltd.
        * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
        */
        void 0 === PIXI.blendModes && (PIXI.blendModes = s.blendModes), void 0 === PIXI.scaleModes && (PIXI.scaleModes = s.scaleModes), void 0 === PIXI.Texture.emptyTexture && (PIXI.Texture.emptyTexture = new PIXI.Texture(new PIXI.BaseTexture())), void 0 === PIXI.DisplayObject._tempMatrix && (PIXI.DisplayObject._tempMatrix = new s.Matrix()), PIXI.TextureSilentFail = !0, PIXI.canUseNewCanvasBlendModes = function () {
          return s.Device.canUseMultiply;
        }, void 0 !== t && t.exports && (e = t.exports = s), e.Phaser = s, s;
      }).call(this);
    }).call(this, i(8));
  }, function (t, e) {
    var i,
        s,
        n = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function r() {
      throw new Error("clearTimeout has not been defined");
    }

    function a(t) {
      if (i === setTimeout) return setTimeout(t, 0);
      if ((i === o || !i) && setTimeout) return i = setTimeout, setTimeout(t, 0);

      try {
        return i(t, 0);
      } catch (e) {
        try {
          return i.call(null, t, 0);
        } catch (e) {
          return i.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        i = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        i = o;
      }

      try {
        s = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (t) {
        s = r;
      }
    }();
    var h,
        l = [],
        c = !1,
        u = -1;

    function d() {
      c && h && (c = !1, h.length ? l = h.concat(l) : u = -1, l.length && p());
    }

    function p() {
      if (!c) {
        var t = a(d);
        c = !0;

        for (var e = l.length; e;) {
          for (h = l, l = []; ++u < e;) {
            h && h[u].run();
          }

          u = -1, e = l.length;
        }

        h = null, c = !1, function (t) {
          if (s === clearTimeout) return clearTimeout(t);
          if ((s === r || !s) && clearTimeout) return s = clearTimeout, clearTimeout(t);

          try {
            s(t);
          } catch (e) {
            try {
              return s.call(null, t);
            } catch (e) {
              return s.call(this, t);
            }
          }
        }(t);
      }
    }

    function f(t, e) {
      this.fun = t, this.array = e;
    }

    function g() {}

    n.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var i = 1; i < arguments.length; i++) {
        e[i - 1] = arguments[i];
      }
      l.push(new f(t, e)), 1 !== l.length || c || a(p);
    }, f.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = g, n.addListener = g, n.once = g, n.off = g, n.removeListener = g, n.removeAllListeners = g, n.emit = g, n.prependListener = g, n.prependOnceListener = g, n.listeners = function (t) {
      return [];
    }, n.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, n.cwd = function () {
      return "/";
    }, n.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, n.umask = function () {
      return 0;
    };
  }, function (t, e) {
    /*!
     * phaser-input - version 2.0.5 
     * Adds input boxes to Phaser like CanvasInput, but also works for WebGL and Mobile, made for Phaser only.
     *
     * OrangeGames
     * Build at 02-06-2017
     * Released under MIT License 
     */
    var i,
        s = this && this.__extends || function () {
      var t = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var i in e) {
          e.hasOwnProperty(i) && (t[i] = e[i]);
        }
      };

      return function (e, i) {
        function s() {
          this.constructor = e;
        }

        t(e, i), e.prototype = null === i ? Object.create(i) : (s.prototype = i.prototype, new s());
      };
    }();

    !function (t) {
      var e;
      !function (t) {
        t[t.text = 0] = "text", t[t.password = 1] = "password", t[t.number = 2] = "number";
      }(e = t.InputType || (t.InputType = {}));

      var i = function () {
        function t(t, i, s, n, o, r) {
          void 0 === s && (s = e.text), void 0 === n && (n = "");
          var a = this;
          this.id = i, this.type = s, this.game = t, this.focusIn = o, this.focusOut = r;
          var h = this.game.canvas.getBoundingClientRect().top + document.body.scrollTop;
          this.element = document.createElement("input"), this.element.id = i, this.element.style.position = "absolute", this.element.style.top = h + "px", this.element.style.left = (-40).toString() + "px", this.element.style.width = 10..toString() + "px", this.element.style.height = 10..toString() + "px", this.element.style.border = "0px", this.element.value = this.value, this.element.type = e[s], this.element.addEventListener("focusin", function () {
            a.focusIn instanceof Phaser.Signal && a.focusIn.dispatch();
          }), this.element.addEventListener("focusout", function () {
            a.focusOut instanceof Phaser.Signal && a.focusOut.dispatch();
          }), document.body.appendChild(this.element);
        }

        return t.prototype.addKeyUpListener = function (t) {
          this.keyUpCallback = t, document.addEventListener("keyup", this.keyUpCallback), this.element.addEventListener("input", this.keyUpCallback);
        }, t.prototype.blockKeyDownEvents = function () {
          document.addEventListener("keydown", this.preventKeyPropagation);
        }, t.prototype.preventKeyPropagation = function (t) {
          t.stopPropagation ? t.stopPropagation() : event.cancelBubble = !0;
        }, t.prototype.unblockKeyDownEvents = function () {
          document.removeEventListener("keydown", this.preventKeyPropagation);
        }, t.prototype.removeEventListener = function () {
          document.removeEventListener("keyup", this.keyUpCallback), this.element.removeEventListener("input", this.keyUpCallback);
        }, t.prototype.destroy = function () {
          document.body.removeChild(this.element);
        }, t.prototype.setMax = function (t, i) {
          if (void 0 !== t) if (this.type === e.text || this.type === e.password) this.element.maxLength = parseInt(t, 10);else if (this.type === e.number) {
            if (this.element.max = t, void 0 === i) return;
            this.element.min = i;
          }
        }, Object.defineProperty(t.prototype, "value", {
          get: function get() {
            return this.element.value;
          },
          set: function set(t) {
            this.element.value = t;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.focus = function () {
          var t = this;
          if (this.element.focus(), !this.game.device.desktop && this.game.device.chrome) var e = window.innerWidth,
              i = window.innerHeight,
              s = !1,
              n = setInterval(function () {
            (e > window.innerWidth || i > window.innerHeight) && (s = !0), s && e === window.innerWidth && i === window.innerHeight && (t.focusOut instanceof Phaser.Signal && t.focusOut.dispatch(), clearInterval(n));
          }, 50);
        }, t.prototype.blur = function () {
          this.element.blur();
        }, Object.defineProperty(t.prototype, "hasSelection", {
          get: function get() {
            return this.type !== e.number && this.element.selectionStart !== this.element.selectionEnd;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "caretStart", {
          get: function get() {
            return this.element.selectionEnd;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "caretEnd", {
          get: function get() {
            return this.element.selectionStart;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.getCaretPosition = function () {
          return this.type === e.number ? -1 : this.element.selectionStart;
        }, t.prototype.setCaretPosition = function (t) {
          this.type !== e.number && this.element.setSelectionRange(t, t);
        }, t;
      }();

      t.InputElement = i;
    }(i || (i = {})), function (t) {
      var e;
      !function (t) {
        t[t.none = 0] = "none", t[t.lower = 1] = "lower", t[t.upper = 2] = "upper";
      }(e = t.ForceCase || (t.ForceCase = {}));

      var i = function (i) {
        function n(s, n, o, r) {
          void 0 === r && (r = {});
          var a = i.call(this, s, n, o) || this;
          return a.focusOutOnEnter = !0, a.placeHolder = null, a.box = null, a.focus = !1, a.value = "", a.windowScale = 1, a.blockInput = !0, a.focusIn = new Phaser.Signal(), a.focusOut = new Phaser.Signal(), a.blink = !0, a.cnt = 0, a.inputOptions = r, a.inputOptions.width = "number" == typeof r.width ? r.width : 150, a.inputOptions.padding = "number" == typeof r.padding ? r.padding : 0, a.inputOptions.textAlign = r.textAlign || "left", a.inputOptions.type = r.type || t.InputType.text, a.inputOptions.forceCase = r.forceCase ? r.forceCase : e.none, a.inputOptions.borderRadius = "number" == typeof r.borderRadius ? r.borderRadius : 0, a.inputOptions.height = "number" == typeof r.height ? r.height : 14, a.inputOptions.fillAlpha = void 0 === r.fillAlpha ? 1 : r.fillAlpha, a.inputOptions.selectionColor = r.selectionColor || "rgba(179, 212, 253, 0.8)", a.inputOptions.zoom = !s.device.desktop && (r.zoom || !1), a.box = new t.InputBox(a.game, r), a.setTexture(a.box.generateTexture()), a.textMask = new t.TextMask(a.game, r), a.addChild(a.textMask), a.domElement = new t.InputElement(a.game, "phaser-input-" + (1e4 * Math.random() | 0).toString(), a.inputOptions.type, a.value, a.focusIn, a.focusOut), a.domElement.setMax(a.inputOptions.max, a.inputOptions.min), a.selection = new t.SelectionHighlight(a.game, a.inputOptions), a.selection.mask = a.textMask, a.addChild(a.selection), r.placeHolder && r.placeHolder.length > 0 && (a.placeHolder = new Phaser.Text(s, a.inputOptions.padding, a.inputOptions.padding, r.placeHolder, {
            font: r.font || "14px Arial",
            fontWeight: r.fontWeight || "normal",
            fill: r.placeHolderColor || "#bfbebd"
          }), a.placeHolder.mask = a.textMask, a.addChild(a.placeHolder)), a.cursor = new Phaser.Text(s, a.inputOptions.padding, a.inputOptions.padding - 2, "|", {
            font: r.font || "14px Arial",
            fontWeight: r.fontWeight || "normal",
            fill: r.cursorColor || "#000000"
          }), a.cursor.visible = !1, a.addChild(a.cursor), a.text = new Phaser.Text(s, a.inputOptions.padding, a.inputOptions.padding, "", {
            font: r.font || "14px Arial",
            fontWeight: r.fontWeight || "normal",
            fill: r.fill || "#000000"
          }), a.text.mask = a.textMask, a.addChild(a.text), a.offscreenText = new Phaser.Text(s, a.inputOptions.padding, a.inputOptions.padding, "", {
            font: r.font || "14px Arial",
            fontWeight: r.fontWeight || "normal",
            fill: r.fill || "#000000"
          }), a.updateTextAlignment(), a.inputEnabled = !0, a.input.useHandCursor = !0, a.game.input.onDown.add(a.checkDown, a), a.focusOut.add(function () {
            t.KeyboardOpen && (a.endFocus(), a.inputOptions.zoom && a.zoomOut());
          }), a;
        }

        return s(n, i), Object.defineProperty(n.prototype, "width", {
          get: function get() {
            return this.inputOptions.width;
          },
          set: function set(t) {
            this.inputOptions.width = t, this.box.resize(t), this.textMask.resize(t), this.updateTextAlignment();
          },
          enumerable: !0,
          configurable: !0
        }), n.prototype.updateTextAlignment = function () {
          switch (this.inputOptions.textAlign) {
            case "left":
              this.text.anchor.set(0, 0), this.text.x = this.inputOptions.padding, null !== this.placeHolder && this.placeHolder.anchor.set(0, 0), this.cursor.x = this.inputOptions.padding + this.getCaretPosition();
              break;

            case "center":
              this.text.anchor.set(.5, 0), this.text.x = this.inputOptions.padding + this.inputOptions.width / 2, null !== this.placeHolder && (this.placeHolder.anchor.set(.5, 0), this.placeHolder.x = this.inputOptions.padding + this.inputOptions.width / 2), this.cursor.x = this.inputOptions.padding + this.inputOptions.width / 2 - this.text.width / 2 + this.getCaretPosition();
              break;

            case "right":
              this.text.anchor.set(1, 0), this.text.x = this.inputOptions.padding + this.inputOptions.width, null !== this.placeHolder && (this.placeHolder.anchor.set(1, 0), this.placeHolder.x = this.inputOptions.padding + this.inputOptions.width), this.cursor.x = this.inputOptions.padding + this.inputOptions.width;
          }
        }, n.prototype.checkDown = function (e) {
          if (this.value || this.resetText(), this.input.checkPointerOver(e)) {
            if (this.focus) return void this.setCaretOnclick(e);
            this.inputOptions.zoom && !t.Zoomed && this.zoomIn(), this.startFocus();
          } else !0 === this.focus && (this.endFocus(), this.inputOptions.zoom && this.zoomOut());
        }, n.prototype.update = function () {
          if (this.text.update(), this.placeHolder && this.placeHolder.update(), this.focus) {
            if (30 !== this.cnt) return this.cnt++;
            this.cursor.visible = this.blink, this.blink = !this.blink, this.cnt = 0;
          }
        }, n.prototype.endFocus = function () {
          var e = this;
          this.focus && (this.domElement.removeEventListener(), !0 === this.blockInput && this.domElement.unblockKeyDownEvents(), this.focus = !1, 0 === this.value.length && null !== this.placeHolder && (this.placeHolder.visible = !0), this.cursor.visible = !1, this.game.device.desktop ? setTimeout(function () {
            e.domElement.blur();
          }, 0) : this.domElement.blur(), this.game.device.desktop || (t.KeyboardOpen = !1, t.onKeyboardClose.dispatch()));
        }, n.prototype.startFocus = function () {
          var e = this;
          this.focus = !0, null !== this.placeHolder && (this.placeHolder.visible = !1), this.game.device.desktop ? setTimeout(function () {
            e.keyUpProcessor();
          }, 0) : this.keyUpProcessor(), this.game.device.desktop || (t.KeyboardOpen = !0, t.onKeyboardOpen.dispatch());
        }, n.prototype.keyUpProcessor = function () {
          this.domElement.addKeyUpListener(this.keyListener.bind(this)), this.domElement.focus(), !0 === this.blockInput && this.domElement.blockKeyDownEvents();
        }, n.prototype.updateText = function () {
          var e = "";
          if (this.inputOptions.type === t.InputType.password) for (var i = 0; i < this.value.length; i++) {
            e += "*";
          } else if (this.inputOptions.type === t.InputType.number) {
            var s = parseInt(this.value);
            e = s < parseInt(this.inputOptions.min) ? this.value = this.domElement.value = this.inputOptions.min : s > parseInt(this.inputOptions.max) ? this.value = this.domElement.value = this.inputOptions.max : this.value;
          } else e = this.value;
          if (this.text.setText(e), this.text.width > this.inputOptions.width) this.text.anchor.x = 1, this.text.x = this.inputOptions.padding + this.inputOptions.width;else switch (this.inputOptions.textAlign) {
            case "left":
              this.text.anchor.set(0, 0), this.text.x = this.inputOptions.padding;
              break;

            case "center":
              this.text.anchor.set(.5, 0), this.text.x = this.inputOptions.padding + this.inputOptions.width / 2;
              break;

            case "right":
              this.text.anchor.set(1, 0), this.text.x = this.inputOptions.padding + this.inputOptions.width;
          }
        }, n.prototype.updateCursor = function () {
          if (this.text.width > this.inputOptions.width || "right" === this.inputOptions.textAlign) this.cursor.x = this.inputOptions.padding + this.inputOptions.width;else switch (this.inputOptions.textAlign) {
            case "left":
              this.cursor.x = this.inputOptions.padding + this.getCaretPosition();
              break;

            case "center":
              this.cursor.x = this.inputOptions.padding + this.inputOptions.width / 2 - this.text.width / 2 + this.getCaretPosition();
          }
        }, n.prototype.getCaretPosition = function () {
          var e = this.domElement.getCaretPosition();
          if (-1 === e) return this.text.width;
          var i = this.value;

          if (this.inputOptions.type === t.InputType.password) {
            i = "";

            for (var s = 0; s < this.value.length; s++) {
              i += "*";
            }
          }

          return this.offscreenText.setText(i.slice(0, e)), this.offscreenText.width;
        }, n.prototype.setCaretOnclick = function (t) {
          var e = this.text.toLocal(new PIXI.Point(t.x, t.y), this.game.world).x;
          this.inputOptions.textAlign && "center" === this.inputOptions.textAlign && (e += this.text.width / 2);

          for (var i = this.text.width / this.value.length, s = 0, n = 0; n < this.value.length; n++) {
            if (e >= n * i && e <= (n + 1) * i) {
              s = n;
              break;
            }
          }

          e > (this.value.length - 1) * i && (s = this.value.length), this.startFocus(), this.domElement.setCaretPosition(s), this.updateCursor();
        }, n.prototype.updateSelection = function () {
          if (this.domElement.hasSelection) {
            var e = this.value;

            if (this.inputOptions.type === t.InputType.password) {
              e = "";

              for (var i = 0; i < this.value.length; i++) {
                e += "*";
              }
            }

            switch (e = e.substring(this.domElement.caretStart, this.domElement.caretEnd), this.offscreenText.setText(e), this.selection.updateSelection(this.offscreenText.getBounds()), this.inputOptions.textAlign) {
              case "left":
                this.selection.x = this.inputOptions.padding;
                break;

              case "center":
                this.selection.x = this.inputOptions.padding + this.inputOptions.width / 2 - this.text.width / 2;
            }
          } else this.selection.clear();
        }, n.prototype.zoomIn = function () {
          if (!t.Zoomed) {
            var e = this.getBounds();
            window.innerHeight > window.innerWidth ? this.windowScale = this.game.width / (1.5 * e.width) : this.windowScale = this.game.width / 2 / (1.5 * e.width);
            var i = (this.game.width - 1.5 * e.width) / 2 / this.windowScale;
            this.game.world.scale.set(this.game.world.scale.x * this.windowScale, this.game.world.scale.y * this.windowScale), this.game.world.pivot.set(e.x - i, e.y - 2 * this.inputOptions.padding), t.Zoomed = !0;
          }
        }, n.prototype.zoomOut = function () {
          t.Zoomed && (this.game.world.scale.set(this.game.world.scale.x / this.windowScale, this.game.world.scale.y / this.windowScale), this.game.world.pivot.set(0, 0), t.Zoomed = !1);
        }, n.prototype.keyListener = function (t) {
          this.value = this.getFormattedText(this.domElement.value), 13 !== t.keyCode ? (this.updateText(), this.updateCursor(), this.updateSelection(), t.preventDefault()) : this.focusOutOnEnter && this.endFocus();
        }, n.prototype.destroy = function (t) {
          this.game.input.onDown.remove(this.checkDown, this), this.focusIn.removeAll(), this.focusOut.removeAll(), this.domElement.destroy(), i.prototype.destroy.call(this, t);
        }, n.prototype.resetText = function () {
          this.setText();
        }, n.prototype.setText = function (t) {
          void 0 === t && (t = ""), null !== this.placeHolder && (t.length > 0 ? this.placeHolder.visible = !1 : this.placeHolder.visible = !0), this.value = this.getFormattedText(t), this.domElement.value = this.value, this.updateText(), this.updateCursor(), this.endFocus();
        }, n.prototype.getFormattedText = function (t) {
          switch (this.inputOptions.forceCase) {
            default:
            case e.none:
              return t;

            case e.lower:
              return t.toLowerCase();

            case e.upper:
              return t.toUpperCase();
          }
        }, n;
      }(Phaser.Sprite);

      t.InputField = i;
    }(i || (i = {})), function (t) {
      var e = function (t) {
        function e(e, i) {
          var s = t.call(this, e, 0, 0) || this;
          s.bgColor = i.backgroundColor ? parseInt(i.backgroundColor.slice(1), 16) : 16777215, s.borderRadius = i.borderRadius || 0, s.borderWidth = i.borderWidth || 1, s.borderColor = i.borderColor ? parseInt(i.borderColor.slice(1), 16) : 9803157, s.boxAlpha = i.fillAlpha, s.padding = i.padding;
          var n = i.height,
              o = i.width;
          i.font && (n = Math.max(parseInt(i.font.substr(0, i.font.indexOf("px")), 10), n)), s.boxHeight = 2 * s.padding + n;
          o = i.width;
          return s.boxWidth = 2 * s.padding + o, s.drawBox(), s;
        }

        return s(e, t), e.prototype.resize = function (t) {
          this.boxWidth = 2 * this.padding + t, this.drawBox();
        }, e.prototype.drawBox = function () {
          this.clear().beginFill(this.bgColor, this.boxAlpha).lineStyle(this.borderWidth, this.borderColor, this.boxAlpha), this.borderRadius > 0 ? this.drawRoundedRect(0, 0, this.boxWidth, this.boxHeight, this.borderRadius) : this.drawRect(0, 0, this.boxWidth, this.boxHeight);
        }, e;
      }(Phaser.Graphics);

      t.InputBox = e;
    }(i || (i = {})), function (t) {
      var e = function (t) {
        function e(e, i) {
          var s = t.call(this, e, i.padding, i.padding) || this;
          return s.inputOptions = i, s;
        }

        return s(e, t), e.prototype.updateSelection = function (t) {
          var i = Phaser.Color.webToColor(this.inputOptions.selectionColor);
          this.clear(), this.beginFill(e.rgb2hex(i), i.a), this.drawRect(t.x, t.y, t.width, t.height - this.inputOptions.padding);
        }, e.rgb2hex = function (t) {
          return parseInt(("0" + t.r.toString(16)).slice(-2) + ("0" + t.g.toString(16)).slice(-2) + ("0" + t.b.toString(16)).slice(-2), 16);
        }, e;
      }(Phaser.Graphics);

      t.SelectionHighlight = e;
    }(i || (i = {})), function (t) {
      var e = function (t) {
        function e(e, i) {
          var s = t.call(this, e, i.padding, i.padding) || this,
              n = i.height;
          return i.font && (n = Math.max(parseInt(i.font.substr(0, i.font.indexOf("px")), 10), n)), s.maskWidth = i.width, s.maskHeight = 1.3 * n, s.drawMask(), s;
        }

        return s(e, t), e.prototype.resize = function (t) {
          this.maskWidth = t, this.drawMask();
        }, e.prototype.drawMask = function () {
          this.clear().beginFill(0).drawRect(0, 0, this.maskWidth, this.maskHeight).endFill();
        }, e;
      }(Phaser.Graphics);

      t.TextMask = e;
    }(i || (i = {})), function (t) {
      t.Zoomed = !1, t.KeyboardOpen = !1, t.onKeyboardOpen = new Phaser.Signal(), t.onKeyboardClose = new Phaser.Signal();

      var e = function (e) {
        function i(t, i) {
          var s = e.call(this, t, i) || this;
          return s.addInputFieldFactory(), s;
        }

        return s(i, e), i.prototype.addInputFieldFactory = function () {
          Phaser.GameObjectFactory.prototype.inputField = function (e, i, s, n) {
            void 0 === n && (n = this.world);
            var o = new t.InputField(this.game, e, i, s);
            return n.add(o);
          }, Phaser.GameObjectCreator.prototype.inputField = function (e, i, s) {
            return new t.InputField(this.game, e, i, s);
          };
        }, i;
      }(Phaser.Plugin);

      e.Zoomed = !1, e.KeyboardOpen = !1, e.onKeyboardOpen = new Phaser.Signal(), e.onKeyboardClose = new Phaser.Signal(), t.Plugin = e;
    }(i || (i = {})), t.exports = i;
  }, function (t, e) {
    t.exports = {
      create: function create() {
        this.game.global.score = 0, this.usedCapitals = [], this.ansPost = [{
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }], this.countriesAF = this.game.global.fullArray[this.game.global.continentIndex].slice(0), console.log(this.game.global.continentIndex), console.log(this.game.global.fullArray[this.game.global.continentIndex]), this.streak = 0, this.getInfo, this.answer, this.options = [], this.correctSound = this.game.add.audio("correct"), this.correctSound2 = this.game.add.audio("correct2"), this.wrongSound = this.game.add.audio("wrong"), this.clickSound = this.game.add.audio("click"), this.overSound = this.game.add.audio("over"), this.wonSound = this.game.add.audio("won"), this.streakSound = this.game.add.audio("streak"), getInfo = JSON.parse(this.game.cache.getText("infoAF")), this.questionLine1 = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(350), "myfont", "The capital of", this.game.getScaledHeight(80)), this.questionLine2 = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(450), "myfont", "Democratic Republic of the Congo is ?", this.game.getScaledHeight(80)), this.questionLine1.anchor.set(.5), this.questionLine2.anchor.set(.5), this.stats = {
          textS: "",
          lives: 4
        }, this.txtScore = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(45), "myguifont", "SCORE: " + this.game.global.score, this.game.getScaledHeight(60)), this.txtScore.anchor.setTo(.5, .5), this.backBt = this.game.add.sprite(0, this.game.getScaledHeight(10), "btBack"), this.backBt.height = this.game.getScaledHeight(this.backBt.height), this.backBt.width = this.game.getScaledWidth(this.backBt.width), this.backBt.inputEnabled = !0, this.backBt.events.onInputDown.add(this.home, this), this.livesImage = this.game.add.sprite(this.game.getScaledWidth(1276), 0, "lives"), this.livesImage.frame = 4, this.livesImage.height = this.game.getScaledHeight(this.livesImage.height), this.livesImage.width = this.game.getScaledWidth(this.livesImage.width);
        var t = 0,
            e = this.game.getScaledHeight(700),
            i = this.game.getScaledWidth(580);
        this.ansPost[0] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(700), "option"), this.ansPost[0].height = this.game.getScaledHeight(this.ansPost[0].height), this.ansPost[0].width = this.game.getScaledWidth(this.ansPost[0].width), this.ansPost[0].anchor.setTo(.5), this.ansPost[1] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(700), "option"), this.ansPost[1].height = this.game.getScaledHeight(this.ansPost[1].height), this.ansPost[1].width = this.game.getScaledWidth(this.ansPost[1].width), this.ansPost[1].anchor.setTo(.5), this.ansPost[1].scale.x *= -1, this.ansPost[2] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(1020), "option"), this.ansPost[2].height = this.game.getScaledHeight(this.ansPost[2].height), this.ansPost[2].width = this.game.getScaledWidth(this.ansPost[2].width), this.ansPost[2].anchor.setTo(.5), this.ansPost[2].scale.y *= -1, this.ansPost[3] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(1020), "option"), this.ansPost[3].height = this.game.getScaledHeight(this.ansPost[3].height), this.ansPost[3].width = this.game.getScaledWidth(this.ansPost[3].width), this.ansPost[3].anchor.setTo(.5), this.ansPost[3].scale.x *= -1, this.ansPost[3].scale.y *= -1;

        for (var s = 0; s < 2; s++) {
          for (var n = 0; n < 2; n++) {
            this.ansPost[t].text = this.game.add.bitmapText(i, e, "myfont", "", this.game.getScaledHeight(45)), this.ansPost[t].text.maxWidth = 300, this.ansPost[t].text.anchor.setTo(.5), this.ansPost[t].text.align = "center", this.ansPost[t].inputEnabled = !0, this.ansPost[t].events.onInputDown.add(this.checkChoice, this), i += this.game.getScaledWidth(420), t += 1;
          }

          e += this.game.getScaledHeight(320), i = this.game.getScaledWidth(580);
        }

        this.nextQuestion();
      },
      update: function update() {},
      home: function home() {
        this.clickSound.play(), this.game.state.start("menuState");
      },
      checkChoice: function checkChoice(t) {
        this.answer == t.choice ? (this.correctSound.play(), t.frame = 1, this.game.time.events.add(.2 * Phaser.Timer.SECOND, this.correct, this)) : (t.frame = 2, this.wrong());
      },
      wrong: function wrong() {
        if (this.stats.lives <= 0) {
          this.overSound.play(), this.livesImage.alpha = 0;

          for (var t = 0; t < 4; t++) {
            this.ansPost[t].inputEnabled = !1, this.ansPost[t].choice == this.answer && (this.ansPost[t].frame = 1);
          }

          this.game.time.events.add(3 * Phaser.Timer.SECOND, this.gameover, this);
        } else this.wrongSound.play(), this.stats.lives -= 1, this.streak = 0, this.livesImage.frame = this.stats.lives;
      },
      gameover: function gameover() {
        this.game.state.start("gameOver");
      },
      correct: function correct() {
        console.log("remaining: " + this.countriesAF.length), this.countriesAF.length <= 1 ? this.game.state.start("winState") : (this.game.global.score += 1, this.txtScore.setText("SCORE: " + this.game.global.score), this.streak += 1, this.streak >= 3 && this.bonus(), this.countriesAF.pop(), this.nextQuestion()), console.log(this.streak);
      },
      bonus: function bonus() {
        this.streak = 0, this.stats.lives < 4 && (this.streakSound.play(), this.stats.lives += 1, this.livesImage.frame = this.stats.lives);
      },
      reset: function reset() {
        for (var t = 0; t < 4; t++) {
          this.ansPost[t].frame = 0, this.ansPost[t].inputEnabled = !0;
        }

        this.options = [];
      },
      nextQuestion: function nextQuestion() {
        this.reset(), Phaser.ArrayUtils.shuffle(this.countriesAF);
        var t = getInfo[this.countriesAF[this.countriesAF.length - 1]];

        if (this.questionLine2.setText(t.name + " is?"), this.answer = t.capital, this.usedCapitals.push(this.answer), this.options.push(this.answer), this.countriesAF.length <= 3) {
          Phaser.ArrayUtils.shuffle(this.usedCapitals);

          for (var e = 2; e < 5; e++) {
            this.options.push(this.usedCapitals[e]);
          }
        } else for (e = 2; e < 5; e++) {
          this.options.push(getInfo[this.countriesAF[this.countriesAF.length - e]].capital);
        }

        Phaser.ArrayUtils.shuffle(this.options);

        for (e = 0; e < 4; e++) {
          this.ansPost[e].text.setText(this.options[e]), this.ansPost[e].choice = this.options[e];
        }
      }
    };
  }, function (t, e) {
    t.exports = {
      create: function create() {
        console.log("inside"), this.game.global.score = 0, this.usedPopulation = [], this.ansPost = [{
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }], this.countriesAF = this.game.global.fullArray[this.game.global.continentIndex].slice(0), console.log(this.game.global.continentIndex), console.log(this.game.global.fullArray[this.game.global.continentIndex]), this.streak = 0, this.getInfo, this.answer, this.options = [], this.correctSound = this.game.add.audio("correct"), this.correctSound2 = this.game.add.audio("correct2"), this.wrongSound = this.game.add.audio("wrong"), this.clickSound = this.game.add.audio("click"), this.overSound = this.game.add.audio("over"), this.streakSound = this.game.add.audio("streak"), getInfo = JSON.parse(this.game.cache.getText("infoAF")), this.questionLine1 = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(350), "myfont", "The population of", this.game.getScaledHeight(80)), this.questionLine2 = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(450), "myfont", "Democratic Republic of the Congo is ?", this.game.getScaledHeight(80)), this.questionLine1.anchor.set(.5), this.questionLine2.anchor.set(.5), this.stats = {
          textS: "",
          lives: 4
        }, this.txtScore = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(45), "myguifont", "SCORE: " + this.game.global.score, this.game.getScaledHeight(60)), this.txtScore.anchor.setTo(.5, .5), this.backBt = this.game.add.sprite(0, this.game.getScaledHeight(10), "btBack"), this.backBt.height = this.game.getScaledHeight(this.backBt.height), this.backBt.width = this.game.getScaledWidth(this.backBt.width), this.backBt.inputEnabled = !0, this.backBt.events.onInputDown.add(this.home, this), this.livesImage = this.game.add.sprite(this.game.getScaledWidth(1276), 0, "lives"), this.livesImage.frame = 4, this.livesImage.height = this.game.getScaledHeight(this.livesImage.height), this.livesImage.width = this.game.getScaledWidth(this.livesImage.width);
        var t = 0,
            e = this.game.getScaledHeight(700),
            i = this.game.getScaledWidth(580);
        this.ansPost[0] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(700), "option"), this.ansPost[0].height = this.game.getScaledHeight(this.ansPost[0].height), this.ansPost[0].width = this.game.getScaledWidth(this.ansPost[0].width), this.ansPost[0].anchor.setTo(.5), this.ansPost[1] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(700), "option"), this.ansPost[1].height = this.game.getScaledHeight(this.ansPost[1].height), this.ansPost[1].width = this.game.getScaledWidth(this.ansPost[1].width), this.ansPost[1].anchor.setTo(.5), this.ansPost[1].scale.x *= -1, this.ansPost[2] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(1020), "option"), this.ansPost[2].height = this.game.getScaledHeight(this.ansPost[2].height), this.ansPost[2].width = this.game.getScaledWidth(this.ansPost[2].width), this.ansPost[2].anchor.setTo(.5), this.ansPost[2].scale.y *= -1, this.ansPost[3] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(1020), "option"), this.ansPost[3].height = this.game.getScaledHeight(this.ansPost[3].height), this.ansPost[3].width = this.game.getScaledWidth(this.ansPost[3].width), this.ansPost[3].anchor.setTo(.5), this.ansPost[3].scale.x *= -1, this.ansPost[3].scale.y *= -1;

        for (var s = 0; s < 2; s++) {
          for (var n = 0; n < 2; n++) {
            this.ansPost[t].text = this.game.add.bitmapText(i, e, "myfont", "", this.game.getScaledHeight(45)), this.ansPost[t].text.maxWidth = 300, this.ansPost[t].text.anchor.setTo(.5), this.ansPost[t].text.align = "center", this.ansPost[t].inputEnabled = !0, this.ansPost[t].events.onInputDown.add(this.checkChoice, this), i += this.game.getScaledWidth(420), t += 1;
          }

          e += this.game.getScaledHeight(320), i = this.game.getScaledWidth(580);
        }

        this.nextQuestion();
      },
      update: function update() {},
      home: function home() {
        this.clickSound.play(), this.game.state.start("menuState");
      },
      checkChoice: function checkChoice(t) {
        this.answer == t.choice ? (this.correctSound.play(), t.frame = 1, this.game.time.events.add(.2 * Phaser.Timer.SECOND, this.correct, this)) : (this.wrong(), t.frame = 2);
      },
      wrong: function wrong() {
        if (this.stats.lives <= 0) {
          this.livesImage.alpha = 0, this.overSound.play();

          for (var t = 0; t < 4; t++) {
            this.ansPost[t].inputEnabled = !1, this.ansPost[t].choice == this.answer && (this.ansPost[t].frame = 1);
          }

          this.game.time.events.add(3 * Phaser.Timer.SECOND, this.gameover, this);
        } else this.wrongSound.play(), this.stats.lives -= 1, this.streak = 0, this.livesImage.frame = this.stats.lives;
      },
      gameover: function gameover() {
        this.game.state.start("gameOver");
      },
      correct: function correct() {
        console.log("remaining: " + this.countriesAF.length), this.countriesAF.length <= 1 ? this.game.state.start("winState") : (this.game.global.score += 1, this.txtScore.setText("SCORE: " + this.game.global.score), this.streak += 1, this.streak >= 3 && this.bonus(), this.countriesAF.pop(), this.nextQuestion()), console.log(this.streak);
      },
      bonus: function bonus() {
        this.streak = 0, this.stats.lives < 4 && (this.streakSound.play(), this.stats.lives += 1, this.livesImage.frame = this.stats.lives);
      },
      reset: function reset() {
        for (var t = 0; t < 4; t++) {
          this.ansPost[t].frame = 0, this.ansPost[t].inputEnabled = !0;
        }

        this.options = [];
      },
      nextQuestion: function nextQuestion() {
        this.reset(), Phaser.ArrayUtils.shuffle(this.countriesAF);
        var t = getInfo[this.countriesAF[this.countriesAF.length - 1]];

        if (this.questionLine2.setText(t.name + " is?"), this.answer = t.population, this.usedPopulation.push(this.answer), this.options.push(this.answer), this.countriesAF.length <= 3) {
          Phaser.ArrayUtils.shuffle(this.usedPopulation);

          for (var e = 2; e < 5; e++) {
            this.options.push(this.usedPopulation[e]);
          }
        } else for (e = 2; e < 5; e++) {
          this.options.push(getInfo[this.countriesAF[this.countriesAF.length - e]].population);
        }

        Phaser.ArrayUtils.shuffle(this.options);

        for (e = 0; e < 4; e++) {
          this.ansPost[e].text.setText(this.options[e]), this.ansPost[e].choice = this.options[e];
        }
      }
    };
  }, function (t, e) {
    t.exports = {
      create: function create() {
        this.game.global.score = 0, this.usedCapitals = [], this.ansPost = [{
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }, {
          text: "",
          choice: ""
        }], this.countriesAF = this.game.global.fullArray[this.game.global.continentIndex].slice(0), this.currencyOptions = this.game.global.fullArray[this.game.global.continentIndex].slice(0), console.log(this.game.global.continentIndex), console.log(this.game.global.fullArray[this.game.global.continentIndex]), this.streak = 0, this.getInfo, this.answer, this.options = [], this.correctSound = this.game.add.audio("correct"), this.correctSound2 = this.game.add.audio("correct2"), this.wrongSound = this.game.add.audio("wrong"), this.clickSound = this.game.add.audio("click"), this.overSound = this.game.add.audio("over"), this.wonSound = this.game.add.audio("won"), this.streakSound = this.game.add.audio("streak"), getInfo = JSON.parse(this.game.cache.getText("infoAF")), this.questionLine1 = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(450), "myfont", "What is Democratic Republic of the Congo's", this.game.getScaledHeight(80)), this.questionLine1.anchor.set(.5), this.stats = {
          textS: "",
          lives: 4
        }, this.txtScore = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(45), "myguifont", "SCORE: " + this.game.global.score, this.game.getScaledHeight(60)), this.txtScore.anchor.setTo(.5, .5), this.backBt = this.game.add.sprite(0, this.game.getScaledHeight(10), "btBack"), this.backBt.height = this.game.getScaledHeight(this.backBt.height), this.backBt.width = this.game.getScaledWidth(this.backBt.width), this.backBt.inputEnabled = !0, this.backBt.events.onInputDown.add(this.home, this), this.livesImage = this.game.add.sprite(this.game.getScaledWidth(1276), 0, "lives"), this.livesImage.frame = 4, this.livesImage.height = this.game.getScaledHeight(this.livesImage.height), this.livesImage.width = this.game.getScaledWidth(this.livesImage.width);
        var t = 0,
            e = this.game.getScaledHeight(700),
            i = this.game.getScaledWidth(580);
        this.ansPost[0] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(700), "option"), this.ansPost[0].height = this.game.getScaledHeight(this.ansPost[0].height), this.ansPost[0].width = this.game.getScaledWidth(this.ansPost[0].width), this.ansPost[0].anchor.setTo(.5), this.ansPost[1] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(700), "option"), this.ansPost[1].height = this.game.getScaledHeight(this.ansPost[1].height), this.ansPost[1].width = this.game.getScaledWidth(this.ansPost[1].width), this.ansPost[1].anchor.setTo(.5), this.ansPost[1].scale.x *= -1, this.ansPost[2] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(1020), "option"), this.ansPost[2].height = this.game.getScaledHeight(this.ansPost[2].height), this.ansPost[2].width = this.game.getScaledWidth(this.ansPost[2].width), this.ansPost[2].anchor.setTo(.5), this.ansPost[2].scale.y *= -1, this.ansPost[3] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(1020), "option"), this.ansPost[3].height = this.game.getScaledHeight(this.ansPost[3].height), this.ansPost[3].width = this.game.getScaledWidth(this.ansPost[3].width), this.ansPost[3].anchor.setTo(.5), this.ansPost[3].scale.x *= -1, this.ansPost[3].scale.y *= -1;

        for (var s = 0; s < 2; s++) {
          for (var n = 0; n < 2; n++) {
            this.ansPost[t].text = this.game.add.bitmapText(i, e, "myfont", "", this.game.getScaledHeight(45)), this.ansPost[t].text.maxWidth = 300, this.ansPost[t].text.anchor.setTo(.5), this.ansPost[t].text.align = "center", this.ansPost[t].inputEnabled = !0, this.ansPost[t].events.onInputDown.add(this.checkChoice, this), i += this.game.getScaledWidth(420), t += 1;
          }

          e += this.game.getScaledHeight(320), i = this.game.getScaledWidth(580);
        }

        this.nextQuestion();
      },
      update: function update() {},
      home: function home() {
        this.clickSound.play(), this.game.state.start("menuState");
      },
      checkChoice: function checkChoice(t) {
        this.answer == t.choice ? (this.correctSound.play(), t.frame = 1, this.game.time.events.add(.2 * Phaser.Timer.SECOND, this.correct, this)) : (this.wrong(), t.frame = 2);
      },
      wrong: function wrong() {
        if (this.stats.lives <= 0) {
          this.overSound.play(), this.livesImage.alpha = 0;

          for (var t = 0; t < 4; t++) {
            this.ansPost[t].inputEnabled = !1, this.ansPost[t].choice == this.answer && (this.ansPost[t].frame = 1);
          }

          this.game.time.events.add(3 * Phaser.Timer.SECOND, this.gameover, this);
        } else this.wrongSound.play(), this.stats.lives -= 1, this.streak = 0, this.livesImage.frame = this.stats.lives;
      },
      gameover: function gameover() {
        this.game.state.start("gameOver");
      },
      correct: function correct() {
        console.log("remaining: " + this.countriesAF.length), this.countriesAF.length <= 1 ? this.game.state.start("winState") : (this.game.global.score += 1, this.txtScore.setText("SCORE: " + this.game.global.score), this.streak += 1, this.streak >= 3 && this.bonus(), this.countriesAF.pop(), this.nextQuestion()), console.log(this.streak);
      },
      bonus: function bonus() {
        this.streak = 0, this.stats.lives < 4 && (this.streakSound.play(), this.stats.lives += 1, this.livesImage.frame = this.stats.lives);
      },
      reset: function reset() {
        for (var t = 0; t < 4; t++) {
          this.ansPost[t].frame = 0, this.ansPost[t].inputEnabled = !0;
        }

        this.options = [];
      },
      nextQuestion: function nextQuestion() {
        this.reset(), Phaser.ArrayUtils.shuffle(this.countriesAF);
        var t = getInfo[this.countriesAF[this.countriesAF.length - 1]];
        this.questionLine1.setText("What is " + t.name + "'s main currency?"), this.questionLine1.maxWidth = 1500, this.questionLine1.align = "center", this.answer = t.currency, this.usedCapitals.push(this.answer), this.options.push(this.answer), Phaser.ArrayUtils.shuffle(this.currencyOptions), this.count = 0;

        for (var e = 1; e < this.currencyOptions.length && (this.checkoption = getInfo[this.currencyOptions[e]].currency, this.checkoption == this.answer || (this.options.push(this.checkoption), this.count += 1), !(this.count >= 3)); e++) {
          ;
        }

        Phaser.ArrayUtils.shuffle(this.options);

        for (e = 0; e < 4; e++) {
          this.ansPost[e].text.setText(this.options[e]), this.ansPost[e].choice = this.options[e];
        }
      }
    };
  }, function (t, e) {
    t.exports = {
      create: function create() {
        this.game.global.score = 0, this.correctSound = this.game.add.audio("correct"), this.correctSound2 = this.game.add.audio("correct2"), this.wrongSound = this.game.add.audio("wrong"), this.clickSound = this.game.add.audio("click"), this.overSound = this.game.add.audio("over"), this.wonSound = this.game.add.audio("won"), this.streakSound = this.game.add.audio("streak"), this.streak = 0, this.txtScore = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(45), "myguifont", "SCORE: " + this.game.global.score, this.game.getScaledHeight(60)), this.txtScore.anchor.setTo(.5, .5), this.backBt = this.game.add.sprite(0, this.game.getScaledHeight(10), "btBack"), this.backBt.height = this.game.getScaledHeight(this.backBt.height), this.backBt.width = this.game.getScaledWidth(this.backBt.width), this.backBt.inputEnabled = !0, this.backBt.events.onInputDown.add(this.home, this), this.stats = {
          textS: "",
          textL: "",
          lives: 4
        }, this.livesImage = this.game.add.sprite(this.game.getScaledWidth(1150), 0, "lives"), this.livesImage.frame = 4, this.livesImage.height = this.game.getScaledHeight(this.livesImage.height), this.livesImage.width = this.game.getScaledWidth(this.livesImage.width), this.ansPost = [{
          flag: "",
          choice: ""
        }, {
          flag: "",
          choice: ""
        }, {
          flag: "",
          choice: ""
        }, {
          flag: "",
          choice: ""
        }], this.countriesAF = this.game.global.fullArray[this.game.global.continentIndex].slice(0), this.fullOptions = [], this.getInfo, this.answer, this.options = [], this.usedFlags = [], getInfo = JSON.parse(this.game.cache.getText("infoAF")), this.questionLine1 = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(350), "myfont", "The flag of", this.game.getScaledHeight(80)), this.questionLine2 = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(450), "myfont", "Democratic Republic of the Congo is ?", this.game.getScaledHeight(80)), this.questionLine1.anchor.set(.5), this.questionLine2.anchor.set(.5);
        this.ansPost[0] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(700), "option"), this.ansPost[0].height = this.game.getScaledHeight(this.ansPost[0].height), this.ansPost[0].width = this.game.getScaledWidth(this.ansPost[0].width), this.ansPost[0].anchor.setTo(.5), this.ansPost[0].inputEnabled = !0, this.ansPost[0].events.onInputDown.add(this.checkChoice, this), this.ansPost[1] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(700), "option"), this.ansPost[1].height = this.game.getScaledHeight(this.ansPost[1].height), this.ansPost[1].width = this.game.getScaledWidth(this.ansPost[1].width), this.ansPost[1].anchor.setTo(.5), this.ansPost[1].scale.x *= -1, this.ansPost[1].inputEnabled = !0, this.ansPost[1].events.onInputDown.add(this.checkChoice, this), this.ansPost[2] = this.game.add.sprite(this.game.getScaledWidth(580), this.game.getScaledHeight(1020), "option"), this.ansPost[2].height = this.game.getScaledHeight(this.ansPost[2].height), this.ansPost[2].width = this.game.getScaledWidth(this.ansPost[2].width), this.ansPost[2].anchor.setTo(.5), this.ansPost[2].scale.y *= -1, this.ansPost[2].inputEnabled = !0, this.ansPost[2].events.onInputDown.add(this.checkChoice, this), this.ansPost[3] = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(1020), "option"), this.ansPost[3].height = this.game.getScaledHeight(this.ansPost[3].height), this.ansPost[3].width = this.game.getScaledWidth(this.ansPost[3].width), this.ansPost[3].anchor.setTo(.5), this.ansPost[3].scale.x *= -1, this.ansPost[3].scale.y *= -1, this.ansPost[3].inputEnabled = !0, this.ansPost[3].events.onInputDown.add(this.checkChoice, this), this.nextQuestion();
      },
      setFlags: function setFlags(t) {
        console.log("create options");

        for (var e = 0, i = this.game.getScaledWidth(580), s = this.game.getScaledHeight(700), n = 0; n < 2; n++) {
          for (var o = 0; o < 2; o++) {
            this.ansPost[e].flag = this.game.add.sprite(i, s, t[e]), this.ansPost[e].flag.height = this.game.getScaledHeight(this.ansPost[e].flag.height), this.ansPost[e].flag.width = this.game.getScaledWidth(this.ansPost[e].flag.width), this.ansPost[e].flag.anchor.setTo(.5), this.ansPost[e].choice = t[e], i += this.game.getScaledWidth(420), e += 1;
          }

          i = this.game.getScaledWidth(580), s += this.game.getScaledHeight(320);
        }
      },
      home: function home() {
        this.clickSound.play(), this.game.state.start("menuState");
      },
      checkChoice: function checkChoice(t) {
        this.answer == t.choice ? (t.frame = 1, this.correctSound.play(), this.game.time.events.add(.2 * Phaser.Timer.SECOND, this.correct, this)) : (t.frame = 2, this.wrong());
      },
      wrong: function wrong() {
        if (this.stats.lives <= 0) {
          this.overSound.play(), this.livesImage.alpha = 0;

          for (var t = 0; t < 4; t++) {
            this.ansPost[t].inputEnabled = !1, this.ansPost[t].choice == this.answer && (this.ansPost[t].frame = 1);
          }

          this.game.time.events.add(3 * Phaser.Timer.SECOND, this.gameover, this);
        } else this.wrongSound.play(), this.stats.lives -= 1, this.streak = 0, this.livesImage.frame = this.stats.lives;
      },
      gameover: function gameover() {
        this.game.state.start("gameOver");
      },
      correct: function correct() {
        this.game.global.score += 1, this.txtScore.setText("SCORE: " + this.game.global.score), this.streak += 1, this.streak >= 3 && this.bonus(), this.countriesAF.pop(), this.reset(), this.nextQuestion();
      },
      bonus: function bonus() {
        this.streak = 0, this.stats.lives < 4 && (this.streakSound.play(), this.stats.lives += 1, this.livesImage.frame = this.stats.lives);
      },
      reset: function reset() {
        for (var t = 0; t < 4; t++) {
          this.ansPost[t].flag.destroy(), this.ansPost[t].frame = 0;
        }

        this.options = [];
      },
      nextQuestion: function nextQuestion() {
        Phaser.ArrayUtils.shuffle(this.countriesAF);
        var t = this.countriesAF[this.countriesAF.length - 1];
        console.log("question: " + t);
        var e = getInfo[t];

        if (this.questionLine2.setText(e.name + " is?"), this.answer = t, this.usedFlags.push(this.answer), this.options.push(this.answer), this.countriesAF.length <= 3) {
          Phaser.ArrayUtils.shuffle(this.usedFlags);

          for (var i = 2; i < 5; i++) {
            this.options.push(this.usedFlags[i]);
          }
        } else for (i = 2; i < 5; i++) {
          this.options.push(this.countriesAF[this.countriesAF.length - i]);
        }

        Phaser.ArrayUtils.shuffle(this.options), console.log(this.options), this.setFlags(this.options);
      }
    };
  }, function (t, e) {
    t.exports = {
      preload: function preload() {},
      create: function create() {
        this.continents = ["Africa", "America", "Asia", "Australia", "Europe"], this.modes = ["Capitals", "Flags", "Population", "Currency"], this.states = ["capitalState", "flagState", "populationState", "currencyState"], this.clickSound = this.game.add.audio("click"), this.game.global.score > localStorage.getItem("" + this.game.global.continentIndex + this.game.global.modeIndex) && (localStorage.setItem("" + this.game.global.continentIndex + this.game.global.modeIndex, this.game.global.score), this.game.global.highscore[this.game.global.continentIndex][this.game.global.modeIndex] = this.game.global.score), this.gameOverText1 = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(300), "myguifont", "Game Over", this.game.getScaledHeight(120)), this.gameOverText1.anchor.set(.5), this.gameOverText2 = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(420), "myfont", "Continent: " + this.continents[this.game.global.continentIndex], this.game.getScaledHeight(70)), this.gameOverText2.anchor.set(.5), this.gameOverText3 = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(500), "myfont", "Mode: " + this.modes[this.game.global.modeIndex], this.game.getScaledHeight(70)), this.gameOverText3.anchor.set(.5), this.gameOverText4 = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(580), "myfont", "Highscore: " + this.game.global.highscore[this.game.global.continentIndex][this.game.global.modeIndex], this.game.getScaledHeight(70)), this.gameOverText4.anchor.set(.5), this.gameOverText4 = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(660), "myfont", "Score: " + this.game.global.score, this.game.getScaledHeight(70)), this.gameOverText4.anchor.set(.5), this.btRestart = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(800), "btFlag"), this.btRestart.height = this.game.getScaledHeight(this.btRestart.height), this.btRestart.width = this.game.getScaledWidth(this.btRestart.width), this.btRestart.anchor.set(.5), this.btRestart.inputEnabled = !0, this.btRestart.events.onInputDown.add(this.restart, this), this.txtRestart = this.game.add.bitmapText(this.game.getScaledWidth(1e3), this.game.getScaledHeight(800), "myfont", "Restart", this.game.getScaledHeight(50)), this.txtRestart.anchor.set(.5), this.btHome = this.game.add.sprite(this.game.getScaledWidth(600), this.game.getScaledHeight(800), "btFlag"), this.btHome.height = this.game.getScaledHeight(this.btHome.height), this.btHome.width = this.game.getScaledWidth(this.btHome.width), this.btHome.anchor.set(.5), this.btHome.inputEnabled = !0, this.btHome.events.onInputDown.add(this.home, this), this.txtHome = this.game.add.bitmapText(this.game.getScaledWidth(600), this.game.getScaledHeight(800), "myfont", "Main Menu", this.game.getScaledHeight(50)), this.txtHome.anchor.set(.5), this.btFeedback = this.game.add.sprite(this.game.world.centerX, this.game.getScaledHeight(1e3), "btFlag"), this.btFeedback.height = this.game.getScaledHeight(this.btFeedback.height), this.btFeedback.width = this.game.getScaledWidth(this.btFeedback.width), this.btFeedback.anchor.set(.5), this.btFeedback.inputEnabled = !0, this.btFeedback.events.onInputDown.add(this.feedback, this), this.btFeedback = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(1e3), "myfont", "Feedback", this.game.getScaledHeight(50)), this.btFeedback.maxWidth = 300, this.btFeedback.align = "center", this.btFeedback.anchor.set(.5);
      },
      restart: function restart() {
        this.clickSound.play(), this.state.start(this.states[this.game.global.modeIndex]);
      },
      feedback: function feedback() {
        window.open("https://www.surveymonkey.co.uk/r/VJ7K3PX", "_blank");
      },
      home: function home() {
        this.clickSound.play(), this.game.state.start("menuState");
      }
    };
  }, function (t, e) {
    t.exports = {
      create: function create() {
        this.wonSound = this.game.add.audio("won"), this.wonSound.play(), this.continents = ["Africa", "America", "Asia", "Australia", "Europe"], this.modes = ["Capitals", "Flags", "Population", "Currency"], this.states = ["capitalState", "flagState", "populationState", "currencyState"], this.clickSound = this.game.add.audio("click"), this.gameOverText1 = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(300), "myguifont", "You did it!", this.game.getScaledHeight(120)), this.gameOverText1.anchor.set(.5), this.gameOverText2 = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(500), "myfont", "You've mastered the " + this.modes[this.game.global.modeIndex] + " of \n " + this.continents[this.game.global.continentIndex], this.game.getScaledHeight(70)), this.gameOverText2.anchor.set(.5), this.gameOverText2.align = "center", this.game.global.score > localStorage.getItem("" + this.game.global.continentIndex + this.game.global.modeIndex) && (localStorage.setItem("" + this.game.global.continentIndex + this.game.global.modeIndex, this.game.global.score), this.game.global.highscore[this.game.global.continentIndex][this.game.global.modeIndex] = this.game.global.score), this.btRestart = this.game.add.sprite(this.game.getScaledWidth(1e3), this.game.getScaledHeight(800), this.game.global.modeButton[this.game.global.modeIndex]), this.btRestart.height = this.game.getScaledHeight(this.btRestart.height), this.btRestart.width = this.game.getScaledWidth(this.btRestart.width), this.btRestart.anchor.set(.5), this.btRestart.inputEnabled = !0, this.btRestart.events.onInputDown.add(this.restart, this), this.txtRestart = this.game.add.bitmapText(this.game.getScaledWidth(1e3), this.game.getScaledHeight(800), "myfont", "Restart", this.game.getScaledHeight(50)), this.txtRestart.anchor.set(.5), this.btHome = this.game.add.sprite(this.game.getScaledWidth(600), this.game.getScaledHeight(800), "btFlag"), this.btHome.height = this.game.getScaledHeight(this.btHome.height), this.btHome.width = this.game.getScaledWidth(this.btHome.width), this.btHome.anchor.set(.5), this.btHome.inputEnabled = !0, this.btHome.events.onInputDown.add(this.home, this), this.txtHome = this.game.add.bitmapText(this.game.getScaledWidth(600), this.game.getScaledHeight(800), "myfont", "Main Menu", this.game.getScaledHeight(50)), this.txtHome.anchor.set(.5);
      },
      restart: function restart() {
        this.clickSound.play(), this.state.start(this.states[this.game.global.modeIndex]);
      },
      home: function home() {
        this.clickSound.play(), this.game.state.start("menuState");
      }
    };
  }, function (t, e) {
    t.exports = {
      preload: function preload() {},
      create: function create() {
        this.nextSound = this.game.add.audio("next"), this.backSound = this.game.add.audio("back"), this.clickSound = this.game.add.audio("click"), this.left = this.game.add.sprite(this.game.getScaledWidth(200), this.game.getScaledHeight(300), "leftArrow"), this.left.height = this.game.getScaledHeight(this.left.height), this.left.width = this.game.getScaledWidth(this.left.width), this.left.anchor.set(.5), this.left.inputEnabled = !0, this.left.events.onInputDown.add(this.onLArrowClick, this), this.right = this.game.add.sprite(this.game.getScaledWidth(1400), this.game.getScaledHeight(300), "rightArrow"), this.right.height = this.game.getScaledHeight(this.right.height), this.right.width = this.game.getScaledWidth(this.right.width), this.right.anchor.set(.5), this.right.inputEnabled = !0, this.right.events.onInputDown.add(this.onRArrowClick, this);
        var t = this.game.add.sprite(this.game.getScaledWidth(500), this.game.getScaledHeight(500), "btFlag");
        t.height = this.game.getScaledHeight(t.height), t.width = this.game.getScaledWidth(t.width), t.anchor.set(.5), t.inputEnabled = !0, t.events.onInputDown.add(this.startCapitalMode, this);
        var e = this.game.add.sprite(this.game.getScaledWidth(1100), this.game.getScaledHeight(500), "btFlag");
        e.height = this.game.getScaledHeight(e.height), e.width = this.game.getScaledWidth(e.width), e.anchor.set(.5), e.inputEnabled = !0, e.events.onInputDown.add(this.startFlagMode, this);
        var i = this.game.add.sprite(this.game.getScaledWidth(500), this.game.getScaledHeight(900), "btFlag", this.game.getScaledHeight(50));
        i.height = this.game.getScaledHeight(i.height), i.width = this.game.getScaledWidth(i.width), i.anchor.set(.5), i.inputEnabled = !0, i.events.onInputDown.add(this.startPopulationMode, this);
        var s = this.game.add.sprite(this.game.getScaledWidth(1100), this.game.getScaledHeight(900), "btFlag", this.game.getScaledHeight(50));
        s.height = this.game.getScaledHeight(s.height), s.width = this.game.getScaledWidth(s.width), s.anchor.set(.5), s.inputEnabled = !0, s.events.onInputDown.add(this.startCurrencyMode, this);
        var n = this.game.add.sprite(this.world.centerX, this.game.getScaledHeight(700), "btFlag", this.game.getScaledHeight(50));
        n.height = this.game.getScaledHeight(n.height), n.width = this.game.getScaledWidth(n.width), n.anchor.set(.5), n.inputEnabled = !0, n.events.onInputDown.add(this.startLearnMode, this), this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(700), "myfont", "Learn", this.game.getScaledHeight(50)).anchor.set(.5), this.game.add.bitmapText(this.game.getScaledWidth(500), this.game.getScaledHeight(500), "myfont", "Capitals", this.game.getScaledHeight(50)).anchor.set(.5), this.game.add.bitmapText(this.game.getScaledWidth(1100), this.game.getScaledHeight(500), "myfont", "Flags", this.game.getScaledHeight(50)).anchor.set(.5), this.game.add.bitmapText(this.game.getScaledWidth(500), this.game.getScaledHeight(900), "myfont", "Population", this.game.getScaledHeight(50)).anchor.set(.5), this.game.add.bitmapText(this.game.getScaledWidth(1100), this.game.getScaledHeight(900), "myfont", "Currency", this.game.getScaledHeight(50)).anchor.set(.5), this.Continents = ["Africa", "Americas", "Asia", "Australia", "Europe"], this.txtContinent = this.game.add.bitmapText(this.game.world.centerX, this.game.getScaledHeight(300), "myfont", this.Continents[this.game.global.continentIndex], this.game.getScaledHeight(100)), this.txtContinent.anchor.set(.5);
      },
      onLArrowClick: function onLArrowClick() {
        this.backSound.play(), this.game.global.continentIndex <= 0 && (this.game.global.continentIndex = 5), this.game.global.continentIndex -= 1, this.txtContinent.setText("" + this.Continents[this.game.global.continentIndex]);
      },
      onRArrowClick: function onRArrowClick() {
        this.nextSound.play(), this.game.global.continentIndex >= 4 && (this.game.global.continentIndex = -1), this.game.global.continentIndex += 1, this.txtContinent.setText("" + this.Continents[this.game.global.continentIndex]);
      },
      startCapitalMode: function startCapitalMode() {
        this.clickSound.play(), this.alpha = .5, this.state.start("capitalState"), this.game.global.modeIndex = 0;
      },
      startFlagMode: function startFlagMode() {
        this.clickSound.play(), this.state.start("flagState"), this.game.global.modeIndex = 1;
      },
      startPopulationMode: function startPopulationMode() {
        console.log("outside"), this.clickSound.play(), this.state.start("populationState"), this.game.global.modeIndex = 2;
      },
      startCurrencyMode: function startCurrencyMode() {
        console.log("outside"), this.clickSound.play(), this.state.start("currencyState"), this.game.global.modeIndex = 3;
      },
      startLearnMode: function startLearnMode() {
        console.log("outside"), this.clickSound.play(), this.state.start("learnState");
      },
      updateModeArrays: function updateModeArrays() {
        this.game.global.modeArray = this.game.global.fullArray[this.game.global.modeIndex];
      }
    };
  }, function (t, e, i) {
    t.exports = {
      preload: function preload() {
        var _this = this;

        this.bg = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(400), "myfont", "Round the World", this.game.getScaledHeight(150)), this.bg.anchor.setTo(.5), this.globe = this.game.add.sprite(this.world.centerX, this.game.getScaledHeight(700), "globe"), this.globe.height = this.game.getScaledHeight(this.globe.height), this.globe.width = this.game.getScaledWidth(this.globe.width), this.globe.anchor.setTo(.5), this.loadBar = this.game.add.sprite(this.world.centerX, this.game.getScaledHeight(950), "loadingBar"), this.loadBar.anchor.setTo(.5), this.load.setPreloadSprite(this.loadBar), this.loadBar.height = this.game.getScaledHeight(this.loadBar.height), this.loadBar.width = this.game.getScaledWidth(this.loadBar.width), i(18).keys().forEach(function (t) {
          var e = t.split("/")[1].replace(".png", "").toLowerCase();

          _this.game.load.image(e, "assets/round-the-world/flags/" + e + ".png");
        }), this.game.load.image("leftArrow", "assets/round-the-world/images/leftArrow.png"), this.game.load.image("rightArrow", "assets/round-the-world/images/rightArrow.png"), this.game.load.spritesheet("option", "assets/round-the-world/images/options.png", 404, 304, 3), this.game.load.image("btFlag", "assets/round-the-world/images/bt2.png"), this.game.load.image("btBack", "assets/round-the-world/images/back.png"), this.game.load.image("btHome", "assets/round-the-world/images/options.png"), this.game.load.bitmapFont("myguifont", "assets/round-the-world/fonts/guifont.png", "assets/round-the-world/fonts/guifont.fnt"), this.game.load.spritesheet("lives", "assets/round-the-world/images/lives.png", 324, 68, 5), this.game.load.text("infoAF", "assets/round-the-world/data/countries.json "), i(274).keys().forEach(function (t) {
          var e = t.replace("./", "").replace(".ogg", "");

          _this.game.load.audio(e, "assets/round-the-world/audio/" + e + ".ogg");
        });
      },
      create: function create() {
        for (var t = 0; t < 5; t++) {
          for (var e = 0; e < 5; e++) {
            console.log("" + t + e), console.log(localStorage.getItem("" + t + e)), null == localStorage.getItem("" + t + e) || (this.game.global.highscore[t][e] = localStorage.getItem("" + t + e));
          }

          this.state.start("menuState");
        }
      }
    };
  }, function (t, e, i) {
    var s = {
      "./ad.png": 19,
      "./ae.png": 20,
      "./af.png": 21,
      "./ag.png": 22,
      "./ai.png": 23,
      "./al.png": 24,
      "./am.png": 25,
      "./ao.png": 26,
      "./aq.png": 27,
      "./ar.png": 28,
      "./as.png": 29,
      "./at.png": 30,
      "./au.png": 31,
      "./aw.png": 32,
      "./ax.png": 33,
      "./az.png": 34,
      "./ba.png": 35,
      "./bb.png": 36,
      "./bd.png": 37,
      "./be.png": 38,
      "./bf.png": 39,
      "./bg.png": 40,
      "./bh.png": 41,
      "./bi.png": 42,
      "./bj.png": 43,
      "./bl.png": 44,
      "./bm.png": 45,
      "./bn.png": 46,
      "./bo.png": 47,
      "./bq.png": 48,
      "./br.png": 49,
      "./bs.png": 50,
      "./bt.png": 51,
      "./bv.png": 52,
      "./bw.png": 53,
      "./by.png": 54,
      "./bz.png": 55,
      "./ca.png": 56,
      "./cc.png": 57,
      "./cd.png": 58,
      "./cf.png": 59,
      "./cg.png": 60,
      "./ch.png": 61,
      "./ci.png": 62,
      "./ck.png": 63,
      "./cl.png": 64,
      "./cm.png": 65,
      "./cn.png": 66,
      "./co.png": 67,
      "./cr.png": 68,
      "./cu.png": 69,
      "./cv.png": 70,
      "./cw.png": 71,
      "./cx.png": 72,
      "./cy.png": 73,
      "./cz.png": 74,
      "./de.png": 75,
      "./dj.png": 76,
      "./dk.png": 77,
      "./dm.png": 78,
      "./do.png": 79,
      "./dz.png": 80,
      "./ec.png": 81,
      "./ee.png": 82,
      "./eg.png": 83,
      "./eh.png": 84,
      "./er.png": 85,
      "./es.png": 86,
      "./et.png": 87,
      "./fi.png": 88,
      "./fj.png": 89,
      "./fk.png": 90,
      "./fm.png": 91,
      "./fo.png": 92,
      "./fr.png": 93,
      "./ga.png": 94,
      "./gb-eng.png": 95,
      "./gb-nir.png": 96,
      "./gb-sct.png": 97,
      "./gb-wls.png": 98,
      "./gb.png": 99,
      "./gd.png": 100,
      "./ge.png": 101,
      "./gf.png": 102,
      "./gg.png": 103,
      "./gh.png": 104,
      "./gi.png": 105,
      "./gl.png": 106,
      "./gm.png": 107,
      "./gn.png": 108,
      "./gp.png": 109,
      "./gq.png": 110,
      "./gr.png": 111,
      "./gs.png": 112,
      "./gt.png": 113,
      "./gu.png": 114,
      "./gw.png": 115,
      "./gy.png": 116,
      "./hk.png": 117,
      "./hm.png": 118,
      "./hn.png": 119,
      "./hr.png": 120,
      "./ht.png": 121,
      "./hu.png": 122,
      "./id.png": 123,
      "./ie.png": 124,
      "./il.png": 125,
      "./im.png": 126,
      "./in.png": 127,
      "./io.png": 128,
      "./iq.png": 129,
      "./ir.png": 130,
      "./is.png": 131,
      "./it.png": 132,
      "./je.png": 133,
      "./jm.png": 134,
      "./jo.png": 135,
      "./jp.png": 136,
      "./ke.png": 137,
      "./kg.png": 138,
      "./kh.png": 139,
      "./ki.png": 140,
      "./km.png": 141,
      "./kn.png": 142,
      "./kp.png": 143,
      "./kr.png": 144,
      "./ks.png": 145,
      "./kw.png": 146,
      "./ky.png": 147,
      "./kz.png": 148,
      "./la.png": 149,
      "./lb.png": 150,
      "./lc.png": 151,
      "./li.png": 152,
      "./lk.png": 153,
      "./lr.png": 154,
      "./ls.png": 155,
      "./lt.png": 156,
      "./lu.png": 157,
      "./lv.png": 158,
      "./ly.png": 159,
      "./ma.png": 160,
      "./mc.png": 161,
      "./md.png": 162,
      "./me.png": 163,
      "./mf.png": 164,
      "./mg.png": 165,
      "./mh.png": 166,
      "./mk.png": 167,
      "./ml.png": 168,
      "./mm.png": 169,
      "./mn.png": 170,
      "./mo.png": 171,
      "./mp.png": 172,
      "./mq.png": 173,
      "./mr.png": 174,
      "./ms.png": 175,
      "./mt.png": 176,
      "./mu.png": 177,
      "./mv.png": 178,
      "./mw.png": 179,
      "./mx.png": 180,
      "./my.png": 181,
      "./mz.png": 182,
      "./na.png": 183,
      "./nc.png": 184,
      "./ne.png": 185,
      "./nf.png": 186,
      "./ng.png": 187,
      "./ni.png": 188,
      "./nl.png": 189,
      "./no.png": 190,
      "./np.png": 191,
      "./nr.png": 192,
      "./nu.png": 193,
      "./nz.png": 194,
      "./om.png": 195,
      "./pa.png": 196,
      "./pe.png": 197,
      "./pf.png": 198,
      "./pg.png": 199,
      "./ph.png": 200,
      "./pk.png": 201,
      "./pl.png": 202,
      "./pm.png": 203,
      "./pn.png": 204,
      "./pr.png": 205,
      "./ps.png": 206,
      "./pt.png": 207,
      "./pw.png": 208,
      "./py.png": 209,
      "./qa.png": 210,
      "./re.png": 211,
      "./ro.png": 212,
      "./rs.png": 213,
      "./ru.png": 214,
      "./rw.png": 215,
      "./sa.png": 216,
      "./sb.png": 217,
      "./sc.png": 218,
      "./sd.png": 219,
      "./se.png": 220,
      "./sg.png": 221,
      "./sh.png": 222,
      "./si.png": 223,
      "./sj.png": 224,
      "./sk.png": 225,
      "./sl.png": 226,
      "./sm.png": 227,
      "./sn.png": 228,
      "./so.png": 229,
      "./sr.png": 230,
      "./ss.png": 231,
      "./st.png": 232,
      "./sv.png": 233,
      "./sx.png": 234,
      "./sy.png": 235,
      "./sz.png": 236,
      "./tc.png": 237,
      "./td.png": 238,
      "./tf.png": 239,
      "./tg.png": 240,
      "./th.png": 241,
      "./tj.png": 242,
      "./tk.png": 243,
      "./tl.png": 244,
      "./tm.png": 245,
      "./tn.png": 246,
      "./to.png": 247,
      "./tr.png": 248,
      "./tt.png": 249,
      "./tv.png": 250,
      "./tw.png": 251,
      "./tz.png": 252,
      "./ua.png": 253,
      "./ug.png": 254,
      "./um.png": 255,
      "./us.png": 256,
      "./uy.png": 257,
      "./uz.png": 258,
      "./va.png": 259,
      "./vc.png": 260,
      "./ve.png": 261,
      "./vg.png": 262,
      "./vi.png": 263,
      "./vn.png": 264,
      "./vu.png": 265,
      "./wf.png": 266,
      "./ws.png": 267,
      "./xk.png": 268,
      "./ye.png": 269,
      "./yt.png": 270,
      "./za.png": 271,
      "./zm.png": 272,
      "./zw.png": 273
    };

    function n(t) {
      var e = o(t);
      return i(e);
    }

    function o(t) {
      var e = s[t];

      if (!(e + 1)) {
        var i = new Error("Cannot find module '" + t + "'");
        throw i.code = "MODULE_NOT_FOUND", i;
      }

      return e;
    }

    n.keys = function () {
      return Object.keys(s);
    }, n.resolve = o, t.exports = n, n.id = 18;
  }, function (t, e, i) {
    t.exports = i.p + "91d180a82bc91694122772818201ac75.png";
  }, function (t, e, i) {
    t.exports = i.p + "a03838c8dc243189b4cc0157e21d85bd.png";
  }, function (t, e, i) {
    t.exports = i.p + "b1e832c5de560f86fd3a21bb38f1769e.png";
  }, function (t, e, i) {
    t.exports = i.p + "dae7b63881423b1ec352475398b859e6.png";
  }, function (t, e, i) {
    t.exports = i.p + "0dcdaf87f11d1c7cc50fafcd39f62bc8.png";
  }, function (t, e, i) {
    t.exports = i.p + "ba32a352f2be74d113a186783739ce47.png";
  }, function (t, e, i) {
    t.exports = i.p + "b1725cbad02cd2a4b5b687ad28a9fb6e.png";
  }, function (t, e, i) {
    t.exports = i.p + "a3ec6407134eb93988adb9a351680b40.png";
  }, function (t, e, i) {
    t.exports = i.p + "9bc97555d93cd77972a9c1e98df15458.png";
  }, function (t, e, i) {
    t.exports = i.p + "219529187e0c474d0d532299c253c918.png";
  }, function (t, e, i) {
    t.exports = i.p + "281505d728f47827eadaed943faeddb3.png";
  }, function (t, e, i) {
    t.exports = i.p + "23d05f0a445d22314aa7de49deb503eb.png";
  }, function (t, e, i) {
    t.exports = i.p + "3aeecae5c705017de394e0e2371322f4.png";
  }, function (t, e, i) {
    t.exports = i.p + "9ac2ebfe540dc1defdc58a017aad1ae9.png";
  }, function (t, e, i) {
    t.exports = i.p + "343fa61a0868af0c0dee0f65380e1907.png";
  }, function (t, e, i) {
    t.exports = i.p + "047ed3f44870f137dc4be3817ba0dc85.png";
  }, function (t, e, i) {
    t.exports = i.p + "da09d0e8a7b145b23948e65601403a8f.png";
  }, function (t, e, i) {
    t.exports = i.p + "9c178ae9e1ec7f8ed8269750b31bebe5.png";
  }, function (t, e, i) {
    t.exports = i.p + "d4fff4a247109023abeb0b5360a0233d.png";
  }, function (t, e, i) {
    t.exports = i.p + "3ad1ae0b28aa6a1ee7084557e5d627e4.png";
  }, function (t, e, i) {
    t.exports = i.p + "ea556193aba349ec3ef3955a581698bb.png";
  }, function (t, e, i) {
    t.exports = i.p + "bb9fe661546b06c2fc69e31c7d0b2e89.png";
  }, function (t, e, i) {
    t.exports = i.p + "be4bf5bf6e1cffaab8b6e76f6fec4202.png";
  }, function (t, e, i) {
    t.exports = i.p + "949704db24185c499c30103fbb7236b6.png";
  }, function (t, e, i) {
    t.exports = i.p + "e144707cff7cc0991bfe432640ca31a5.png";
  }, function (t, e, i) {
    t.exports = i.p + "16a4af00f5e10923c02cdd06244c25b2.png";
  }, function (t, e, i) {
    t.exports = i.p + "732865c0ebf98bc0566869ad7d48785c.png";
  }, function (t, e, i) {
    t.exports = i.p + "1f1488c8b3666f3cf70ee5db293cf132.png";
  }, function (t, e, i) {
    t.exports = i.p + "fa44390cea1e027b272c14e54469b49d.png";
  }, function (t, e, i) {
    t.exports = i.p + "dd23d2a74b3451150a89da87846f18ac.png";
  }, function (t, e, i) {
    t.exports = i.p + "3352ac1a1bb836bb33ddcc1879151fc8.png";
  }, function (t, e, i) {
    t.exports = i.p + "a03c8c740f3ca2579f27f7602a69e06f.png";
  }, function (t, e, i) {
    t.exports = i.p + "20f79a0313bdfe01b13f7cd20b7e1165.png";
  }, function (t, e, i) {
    t.exports = i.p + "4cf7bf2bea7d8bd9b90ad055570878e5.png";
  }, function (t, e, i) {
    t.exports = i.p + "efe94219a2ed3e2d61eb318343c854d1.png";
  }, function (t, e, i) {
    t.exports = i.p + "a8d4dac59afcad81468406e1ed7656c2.png";
  }, function (t, e, i) {
    t.exports = i.p + "c2a091f226125cc3f7bf6b467c57e5e2.png";
  }, function (t, e, i) {
    t.exports = i.p + "1f71ba7fac399aff019973d1f65306a0.png";
  }, function (t, e, i) {
    t.exports = i.p + "3e9d2a0417edae4a9b29bf9401356e44.png";
  }, function (t, e, i) {
    t.exports = i.p + "2ce06d90e183506bdfeed649d539015c.png";
  }, function (t, e, i) {
    t.exports = i.p + "c922019fc529b1fadde08f9d4967aa92.png";
  }, function (t, e, i) {
    t.exports = i.p + "8327b0db6e08ac4541abbbcfd0c08448.png";
  }, function (t, e, i) {
    t.exports = i.p + "0c35931be61d82ac033b3ff3dcee9b69.png";
  }, function (t, e, i) {
    t.exports = i.p + "8f85ce6184748e9987c9d4e60f4513e8.png";
  }, function (t, e, i) {
    t.exports = i.p + "28a61e5175e11cf7e9aad4af1c30bd76.png";
  }, function (t, e, i) {
    t.exports = i.p + "22a6124b1529d3f396b0aae11646163e.png";
  }, function (t, e, i) {
    t.exports = i.p + "f4c836e4f60710a1cf418d060b4f31e9.png";
  }, function (t, e, i) {
    t.exports = i.p + "ba513891ba11977ac6c3d0167d429d0a.png";
  }, function (t, e, i) {
    t.exports = i.p + "7f3536f23b6285625b4f53f5b9575b7d.png";
  }, function (t, e, i) {
    t.exports = i.p + "b36cdf18f427b6d80ed44f9ad920bdfb.png";
  }, function (t, e, i) {
    t.exports = i.p + "b0f032d69c111d494d2f3623f7ac724e.png";
  }, function (t, e, i) {
    t.exports = i.p + "11d6381a1b70a49837e930384e435e57.png";
  }, function (t, e, i) {
    t.exports = i.p + "8ae5c3ac2dcdeff6287cc119c7036e65.png";
  }, function (t, e, i) {
    t.exports = i.p + "e2b416a1fcc8185bb57e7d9e6dad515c.png";
  }, function (t, e, i) {
    t.exports = i.p + "2657bcbc45e3b1ecdefd99b25c8697f0.png";
  }, function (t, e, i) {
    t.exports = i.p + "e7168748ad38852fb5e320740923aafd.png";
  }, function (t, e, i) {
    t.exports = i.p + "f080bafd4a71b4ce95f575b4a15d1138.png";
  }, function (t, e, i) {
    t.exports = i.p + "47fe2ad102b004dbcc4eeb7bd1793789.png";
  }, function (t, e, i) {
    t.exports = i.p + "4fd5adde6b26d7618d119fcecbaa2562.png";
  }, function (t, e, i) {
    t.exports = i.p + "7d5191b9b11176765ba0387d6f3ad8f1.png";
  }, function (t, e, i) {
    t.exports = i.p + "8d9dd55dfd13a11db89737774dc4be01.png";
  }, function (t, e, i) {
    t.exports = i.p + "aa52497bbdeab9f6495cc5174cb0ac74.png";
  }, function (t, e, i) {
    t.exports = i.p + "4a99ab2c9ad58ad7d6de5dbdc96708cc.png";
  }, function (t, e, i) {
    t.exports = i.p + "a6430a1eb5787944011d666c560f56a6.png";
  }, function (t, e, i) {
    t.exports = i.p + "c1b2968ff5c2696c75fb3554c429d98d.png";
  }, function (t, e, i) {
    t.exports = i.p + "d6215b095f6b5fce420ea6499666a47f.png";
  }, function (t, e, i) {
    t.exports = i.p + "bc6db831f0e488b77d9aea14aa444714.png";
  }, function (t, e, i) {
    t.exports = i.p + "65dcc98a52c0740c7b705a03630c991e.png";
  }, function (t, e, i) {
    t.exports = i.p + "18b50c87bc0274c512b90e276d6f5099.png";
  }, function (t, e, i) {
    t.exports = i.p + "13fc6d597670bacd45822a6ae83feb6d.png";
  }, function (t, e, i) {
    t.exports = i.p + "4c1ea329ec359ead7e2d49d4bef63c9a.png";
  }, function (t, e, i) {
    t.exports = i.p + "404a741d420da6e0588a4e4de47c7c10.png";
  }, function (t, e, i) {
    t.exports = i.p + "7254b9e9e7c9d313090dddbe74760815.png";
  }, function (t, e, i) {
    t.exports = i.p + "8312102867e071c53191297d35e609e4.png";
  }, function (t, e, i) {
    t.exports = i.p + "fc63e8e15b58725e5955590a6ef93bb0.png";
  }, function (t, e, i) {
    t.exports = i.p + "7e9e0a8656928435c63544810f837ccc.png";
  }, function (t, e, i) {
    t.exports = i.p + "efa028a8a47b6c06618a58995f79ae41.png";
  }, function (t, e, i) {
    t.exports = i.p + "f9d92da7bee019cad446d79239b93de9.png";
  }, function (t, e, i) {
    t.exports = i.p + "a16607c0be5326585d8deabb675e681a.png";
  }, function (t, e, i) {
    t.exports = i.p + "8a232d0b35d7fd9d174e7225c544aba5.png";
  }, function (t, e, i) {
    t.exports = i.p + "4fbe0a5d5afa1bb193be78ee41b47e83.png";
  }, function (t, e, i) {
    t.exports = i.p + "a729e7038249fc8c0e408616f4e14b00.png";
  }, function (t, e, i) {
    t.exports = i.p + "249cfb4f38fd04810d0e29014ec3b0ac.png";
  }, function (t, e, i) {
    t.exports = i.p + "c48ea067e46369d8206f36407943cddb.png";
  }, function (t, e, i) {
    t.exports = i.p + "94ca652abba3800ec0e50e300aae80d4.png";
  }, function (t, e, i) {
    t.exports = i.p + "82de1f0fa498bee9da4bc629965b8f0f.png";
  }, function (t, e, i) {
    t.exports = i.p + "cbd4c1d22869fef756998f44f406fefe.png";
  }, function (t, e, i) {
    t.exports = i.p + "ba025129cab09e0425bb3efd1117cd21.png";
  }, function (t, e, i) {
    t.exports = i.p + "41b9574c10e7a9e25a7aa36c94be4ccf.png";
  }, function (t, e, i) {
    t.exports = i.p + "0615b72ea55a1939d8c2c29e5b467f57.png";
  }, function (t, e, i) {
    t.exports = i.p + "7efb3db3ba3f3f472069639f9ea96fa8.png";
  }, function (t, e, i) {
    t.exports = i.p + "a828d8e3662608bc879ee5d189567686.png";
  }, function (t, e, i) {
    t.exports = i.p + "1a2a38ca9e3816360128618d3f4308b9.png";
  }, function (t, e, i) {
    t.exports = i.p + "cb2620076919362a62fdfdfc0156100f.png";
  }, function (t, e, i) {
    t.exports = i.p + "4338a4ad070f14b04b01e38e272eecce.png";
  }, function (t, e, i) {
    t.exports = i.p + "52254bbffb309bf6f368c4bbd5a4c889.png";
  }, function (t, e, i) {
    t.exports = i.p + "5d8e92d2e33de4bb19f6f918bd176575.png";
  }, function (t, e, i) {
    t.exports = i.p + "1119efec65ed8b2d2642b2386ed8f4b3.png";
  }, function (t, e, i) {
    t.exports = i.p + "cbe81679802df95818c87c77b5e7ecaa.png";
  }, function (t, e, i) {
    t.exports = i.p + "f43c793295a48bf4ec166f27291486c3.png";
  }, function (t, e, i) {
    t.exports = i.p + "440254b5ace8d2dd3f7551f879b33829.png";
  }, function (t, e, i) {
    t.exports = i.p + "ac8b64d34297afe87e1f44976815a7b4.png";
  }, function (t, e, i) {
    t.exports = i.p + "c4e22318d02d33cb633de451264a6374.png";
  }, function (t, e, i) {
    t.exports = i.p + "7b6332cf4886a10c130cae1c54e8cac9.png";
  }, function (t, e, i) {
    t.exports = i.p + "f93d8001e29b544d3fa7849a9db4e48c.png";
  }, function (t, e, i) {
    t.exports = i.p + "21d230c29afbb7d04c5620c0f124ac15.png";
  }, function (t, e, i) {
    t.exports = i.p + "fc35e3928aa596e062b6d62f1eb061ed.png";
  }, function (t, e, i) {
    t.exports = i.p + "f9df2bb6600cc4fbd2166da7b6fd1955.png";
  }, function (t, e, i) {
    t.exports = i.p + "0d68b3bf95cfc06016bdae0dba0eb4f9.png";
  }, function (t, e, i) {
    t.exports = i.p + "52651427e55363f6e708a01e3ec80385.png";
  }, function (t, e, i) {
    t.exports = i.p + "e8886b7f6eef08fde35c80e3daded9dc.png";
  }, function (t, e, i) {
    t.exports = i.p + "9a0dc861f47d5f14cb2e60b4b2af7100.png";
  }, function (t, e, i) {
    t.exports = i.p + "996e4db6468b8a10c0f3711c922cdb29.png";
  }, function (t, e, i) {
    t.exports = i.p + "61eecb40a5bf78b89e93318a0d67341b.png";
  }, function (t, e, i) {
    t.exports = i.p + "7258ddace4b5fe757dc07bb70596dea5.png";
  }, function (t, e, i) {
    t.exports = i.p + "51ef96d3fccf69aeb05652801dc340be.png";
  }, function (t, e, i) {
    t.exports = i.p + "392f528d6a8b92297dd31fabc1b6cd0d.png";
  }, function (t, e, i) {
    t.exports = i.p + "415a319a98c3cde7d1819cf38b382e47.png";
  }, function (t, e, i) {
    t.exports = i.p + "95433e855178c7f39a500c2cf9c55ca5.png";
  }, function (t, e, i) {
    t.exports = i.p + "c3dd1a2b7d69c57b3b55b274d03c2347.png";
  }, function (t, e, i) {
    t.exports = i.p + "128c8567444f488776a2cb25d55b0bf1.png";
  }, function (t, e, i) {
    t.exports = i.p + "d304e3c75d512da84b4a827408821721.png";
  }, function (t, e, i) {
    t.exports = i.p + "a6c0f3cc416b7133751e9695c0ba9eac.png";
  }, function (t, e, i) {
    t.exports = i.p + "a2cdf49813a003879c85a9c2cd2b4486.png";
  }, function (t, e, i) {
    t.exports = i.p + "f333041648f00fdd6645969c109937d4.png";
  }, function (t, e, i) {
    t.exports = i.p + "5920a82449128810bc155ef8713b047b.png";
  }, function (t, e, i) {
    t.exports = i.p + "7376f53748cd5b72550626696d82aa52.png";
  }, function (t, e, i) {
    t.exports = i.p + "cf2ebfed2ebe5aadc9e0bb5f47d27e80.png";
  }, function (t, e, i) {
    t.exports = i.p + "3056e5f5becfafb4e1ead73ccdc3cd6a.png";
  }, function (t, e, i) {
    t.exports = i.p + "ebd8dc1844d6d4dad56452c87d3e8b01.png";
  }, function (t, e, i) {
    t.exports = i.p + "0fbde0d97a7c67f355455d96a69d9c4a.png";
  }, function (t, e, i) {
    t.exports = i.p + "326b8169b2a6e8ddef4d754cbb324116.png";
  }, function (t, e, i) {
    t.exports = i.p + "b02f6cc0890823883640ead0afed1abe.png";
  }, function (t, e, i) {
    t.exports = i.p + "b0f2852bfec1e8ad5d8c8840322d83ef.png";
  }, function (t, e, i) {
    t.exports = i.p + "cf15fa032a186aee813dfc85e36a37ad.png";
  }, function (t, e, i) {
    t.exports = i.p + "7571aab66871f24f49d33a8813ae293e.png";
  }, function (t, e, i) {
    t.exports = i.p + "325ca8b6b50ff6646ca6954e2971e378.png";
  }, function (t, e, i) {
    t.exports = i.p + "eae6fd86b29ca365e5571e91c7ad921b.png";
  }, function (t, e, i) {
    t.exports = i.p + "ba6c78d3d1c4fc6ca3d492a6bd180398.png";
  }, function (t, e, i) {
    t.exports = i.p + "3ce84ea97b6dd889d53457624a5e736b.png";
  }, function (t, e, i) {
    t.exports = i.p + "0a7facc2aa9364107c9887481285eb90.png";
  }, function (t, e, i) {
    t.exports = i.p + "f743d5a879daa76ad82e9063de1ac9c8.png";
  }, function (t, e, i) {
    t.exports = i.p + "6772522fe590a6ecc6ca08992e0718bb.png";
  }, function (t, e, i) {
    t.exports = i.p + "7339dfa66fd152d90e6696ed72b26d67.png";
  }, function (t, e, i) {
    t.exports = i.p + "c5776d014ebd1056515559b792cdbfa8.png";
  }, function (t, e, i) {
    t.exports = i.p + "7efb3db3ba3f3f472069639f9ea96fa8.png";
  }, function (t, e, i) {
    t.exports = i.p + "660028bb53e69be237b827aea1a62cc7.png";
  }, function (t, e, i) {
    t.exports = i.p + "7d0fe38a64ab64153e181a0b60afbf11.png";
  }, function (t, e, i) {
    t.exports = i.p + "926e5e1cf35b9c9b29211e99ff42ec0b.png";
  }, function (t, e, i) {
    t.exports = i.p + "f2ffc03e1b693b69a51791329cab253a.png";
  }, function (t, e, i) {
    t.exports = i.p + "807887bdd5407f3b454a3125f389f29b.png";
  }, function (t, e, i) {
    t.exports = i.p + "8b76998172df4a865b32fcb77e34e0c0.png";
  }, function (t, e, i) {
    t.exports = i.p + "aa8591ca22336498d2d3fe888b36a9e4.png";
  }, function (t, e, i) {
    t.exports = i.p + "8342ed1aa63b21939445ea47b47a41e4.png";
  }, function (t, e, i) {
    t.exports = i.p + "805e44ac584ba9d8ae4ecbb7ff421a33.png";
  }, function (t, e, i) {
    t.exports = i.p + "67a39658fcc884258e003b480a779ce8.png";
  }, function (t, e, i) {
    t.exports = i.p + "0e4e1bbf71108e94b67240a83b439bc5.png";
  }, function (t, e, i) {
    t.exports = i.p + "89adb4905db5353ef5e8c6b3e0b4018b.png";
  }, function (t, e, i) {
    t.exports = i.p + "44c7633cb01235e234cf6e5c7a1f3f63.png";
  }, function (t, e, i) {
    t.exports = i.p + "c8de3fa81ae80a8f533617b62fff99a4.png";
  }, function (t, e, i) {
    t.exports = i.p + "9938ff08d1d11cb91d325a747ecfbae8.png";
  }, function (t, e, i) {
    t.exports = i.p + "2294466803976aee47caf15a6ab6e0c3.png";
  }, function (t, e, i) {
    t.exports = i.p + "3a15b3ed33dfffa5a9d2af0784f8c25e.png";
  }, function (t, e, i) {
    t.exports = i.p + "3a343b534fb9ab8fef45ec74d7d9cd55.png";
  }, function (t, e, i) {
    t.exports = i.p + "b6cac35c8af93e59960346b730eccaf4.png";
  }, function (t, e, i) {
    t.exports = i.p + "d84894e9dc214e03a5604615ba5aaa80.png";
  }, function (t, e, i) {
    t.exports = i.p + "4d3433a7a756bbff1d36294fc6053ae7.png";
  }, function (t, e, i) {
    t.exports = i.p + "589472160506e9fe086a2ab993604bc0.png";
  }, function (t, e, i) {
    t.exports = i.p + "00da83fcee20fc77b2c3b207367aa388.png";
  }, function (t, e, i) {
    t.exports = i.p + "989946d310b5b5ca85295bb47e5271b5.png";
  }, function (t, e, i) {
    t.exports = i.p + "22e9a6a871b41157603320b5cd72ce89.png";
  }, function (t, e, i) {
    t.exports = i.p + "58e3f176f8bb52f7ce12dc58fed8ab71.png";
  }, function (t, e, i) {
    t.exports = i.p + "bab6799c43015a8177d91955870ae50d.png";
  }, function (t, e, i) {
    t.exports = i.p + "afe465ec51cac55f70bb73b075a6716d.png";
  }, function (t, e, i) {
    t.exports = i.p + "01f49f3944985b36aeaf0b87b9f66863.png";
  }, function (t, e, i) {
    t.exports = i.p + "a00639abdb69a1040a30548cfd0b996b.png";
  }, function (t, e, i) {
    t.exports = i.p + "6e95e928370f140345281173fc06df5f.png";
  }, function (t, e, i) {
    t.exports = i.p + "d3535c279874c06ac375d701c14800ff.png";
  }, function (t, e, i) {
    t.exports = i.p + "2c35cd1e556a2f798955d40ca678067d.png";
  }, function (t, e, i) {
    t.exports = i.p + "582c10e40e687a4789e935b0f1662d85.png";
  }, function (t, e, i) {
    t.exports = i.p + "a0b9c28a588fb0ff46bb96c88c112ef6.png";
  }, function (t, e, i) {
    t.exports = i.p + "f010bb639b2d098b16d82f0c66c6432e.png";
  }, function (t, e, i) {
    t.exports = i.p + "10dca3a2b2a959e1a3ac6732e5c37d28.png";
  }, function (t, e, i) {
    t.exports = i.p + "f73a6cf91d0f6d7a871b9e771f6a707d.png";
  }, function (t, e, i) {
    t.exports = i.p + "7efb3db3ba3f3f472069639f9ea96fa8.png";
  }, function (t, e, i) {
    t.exports = i.p + "60b40d79c0d9f7d32ce08fd9bc8cf0d4.png";
  }, function (t, e, i) {
    t.exports = i.p + "86277510d1b093d85dbdb56f9a364c4b.png";
  }, function (t, e, i) {
    t.exports = i.p + "e4feb24ed9320ac241f25bd583b9d6d5.png";
  }, function (t, e, i) {
    t.exports = i.p + "ccc57b3559bfe2035bd597f59ddd8a2f.png";
  }, function (t, e, i) {
    t.exports = i.p + "02726783572371b9b37055aee6bf7578.png";
  }, function (t, e, i) {
    t.exports = i.p + "cf33524020bb18f39d800914e9dd4fad.png";
  }, function (t, e, i) {
    t.exports = i.p + "9a9c3fc01eabb63ae39efa36241cc755.png";
  }, function (t, e, i) {
    t.exports = i.p + "7efb3db3ba3f3f472069639f9ea96fa8.png";
  }, function (t, e, i) {
    t.exports = i.p + "78b9d9083cb07551a43d5ba4417de236.png";
  }, function (t, e, i) {
    t.exports = i.p + "fc27c74c2f01f4a1e13104783bbf6d65.png";
  }, function (t, e, i) {
    t.exports = i.p + "f72587ce7a5916b4ac3b48aa885c6cd0.png";
  }, function (t, e, i) {
    t.exports = i.p + "3fd37ccfbbe13c99744f8503389a8680.png";
  }, function (t, e, i) {
    t.exports = i.p + "6b1e758be446c32ab6473e6b5872523d.png";
  }, function (t, e, i) {
    t.exports = i.p + "acabfd061e228eb76cb516af70bf1c56.png";
  }, function (t, e, i) {
    t.exports = i.p + "d4921fe1f5b4925b8f3d878be5992a37.png";
  }, function (t, e, i) {
    t.exports = i.p + "ac59277ee9d4ebd770be1e630ba59e39.png";
  }, function (t, e, i) {
    t.exports = i.p + "c844f2da17ab47eeff4f878941e6585e.png";
  }, function (t, e, i) {
    t.exports = i.p + "03a43feb278ea98656231c77bacc9475.png";
  }, function (t, e, i) {
    t.exports = i.p + "f9d92da7bee019cad446d79239b93de9.png";
  }, function (t, e, i) {
    t.exports = i.p + "145603de31c70dd5f85828d170ce9275.png";
  }, function (t, e, i) {
    t.exports = i.p + "4cf7bf2bea7d8bd9b90ad055570878e5.png";
  }, function (t, e, i) {
    t.exports = i.p + "0cac0c9b875d2a69e80aa6bc3460bca3.png";
  }, function (t, e, i) {
    t.exports = i.p + "b062e4a867c3a9132bbe27af0819bb6c.png";
  }, function (t, e, i) {
    t.exports = i.p + "f207c03f4777d2455f2e8ea9cf33d81b.png";
  }, function (t, e, i) {
    t.exports = i.p + "5c7fbf72b9c6171f26b5d3d90f694aad.png";
  }, function (t, e, i) {
    t.exports = i.p + "6bb630ab8e50f471117ee3844d1a14d9.png";
  }, function (t, e, i) {
    t.exports = i.p + "7e48770f06648f3e19a031f74d258396.png";
  }, function (t, e, i) {
    t.exports = i.p + "28e77933b65e35bc74fec89fccc5a172.png";
  }, function (t, e, i) {
    t.exports = i.p + "2d268dd9b540c09c2e2509ad3d913868.png";
  }, function (t, e, i) {
    t.exports = i.p + "c8a3b29382f323908e0980e1eed06712.png";
  }, function (t, e, i) {
    t.exports = i.p + "cc3dfc85e42409bde5f0babbf7061640.png";
  }, function (t, e, i) {
    t.exports = i.p + "881ca9524919fdfdf1afe52615738795.png";
  }, function (t, e, i) {
    t.exports = i.p + "c7d1ca6e9655a5edb0c830d7370952c6.png";
  }, function (t, e, i) {
    t.exports = i.p + "8d76b3e12733db2546b3c0ba66843a4c.png";
  }, function (t, e, i) {
    t.exports = i.p + "9f43ca596286addc895ee2a8eff6c7f9.png";
  }, function (t, e, i) {
    t.exports = i.p + "17cc11b8931ba8d3fc42ce804de9c0ab.png";
  }, function (t, e, i) {
    t.exports = i.p + "0f79ee2f1739aa01f922b4670fccbe3e.png";
  }, function (t, e, i) {
    t.exports = i.p + "3a72fafc06b34011e980e70720ab48f4.png";
  }, function (t, e, i) {
    t.exports = i.p + "477d915e59d2c2758aa4fad8a4b074b9.png";
  }, function (t, e, i) {
    t.exports = i.p + "06c209070a120740010fd27c8728c9e8.png";
  }, function (t, e, i) {
    t.exports = i.p + "4c7b2301fe3c8c82f045c71572575454.png";
  }, function (t, e, i) {
    t.exports = i.p + "41abbac57ad0642dc6c81309afb30704.png";
  }, function (t, e, i) {
    t.exports = i.p + "75c56b19664f62e7d61ef633737b1e54.png";
  }, function (t, e, i) {
    t.exports = i.p + "69bb864bf924d740ffa53834b61c876e.png";
  }, function (t, e, i) {
    t.exports = i.p + "f85416a57a0d0e938405a44be8052eed.png";
  }, function (t, e, i) {
    t.exports = i.p + "66ba0860b6c4893e9220dcf991e60e76.png";
  }, function (t, e, i) {
    t.exports = i.p + "7df7b889836bfc53dc7ab661d73ae12c.png";
  }, function (t, e, i) {
    t.exports = i.p + "e556464ec7553693dd24aae8b735700d.png";
  }, function (t, e, i) {
    t.exports = i.p + "417f5bafb0c78cb32ec10998f1a4b5a5.png";
  }, function (t, e, i) {
    t.exports = i.p + "0d3a374ce2ba0e192ed9823c86dcf73e.png";
  }, function (t, e, i) {
    t.exports = i.p + "efb6980dcdef0981ee7df3aa29dfe489.png";
  }, function (t, e, i) {
    t.exports = i.p + "92bf0c8bc29fb16318f17351d3dcfa82.png";
  }, function (t, e, i) {
    t.exports = i.p + "c468cbc20b1e3fafc54e688452fb7551.png";
  }, function (t, e, i) {
    t.exports = i.p + "3df42d016d7a3380f20b69ddbdefe5d6.png";
  }, function (t, e, i) {
    t.exports = i.p + "739e8a8b0cf571c0537ef7d188190f27.png";
  }, function (t, e, i) {
    t.exports = i.p + "08a337c8edc6d42b37ecb13226f02c6a.png";
  }, function (t, e, i) {
    t.exports = i.p + "697f1f24e16af270f43357cd6a1b6e53.png";
  }, function (t, e, i) {
    t.exports = i.p + "3dfa22b1e3882493b5b6376610c6d3c2.png";
  }, function (t, e, i) {
    t.exports = i.p + "d8f06422f64c46fe0798424017a7602b.png";
  }, function (t, e, i) {
    t.exports = i.p + "6f937b40fa6942f9c391982d1fb4210d.png";
  }, function (t, e, i) {
    t.exports = i.p + "1e0d8a1ba987be304dcf7c3d49802f30.png";
  }, function (t, e, i) {
    t.exports = i.p + "5079db5c1c647b970308997eb013b9b3.png";
  }, function (t, e, i) {
    t.exports = i.p + "3e799b99df74d6144e73679dc7311ea9.png";
  }, function (t, e, i) {
    t.exports = i.p + "d5b436e1280ebd4ca88081944afcbc09.png";
  }, function (t, e, i) {
    t.exports = i.p + "f75f42f946985657164c9e2c6252fc69.png";
  }, function (t, e, i) {
    t.exports = i.p + "a732a3cb2275e15a57faa6245060617d.png";
  }, function (t, e, i) {
    t.exports = i.p + "7efb3db3ba3f3f472069639f9ea96fa8.png";
  }, function (t, e, i) {
    t.exports = i.p + "7b7cd9d09a338ac4bb29253cb3f09cda.png";
  }, function (t, e, i) {
    t.exports = i.p + "15a75edfae6de407f41b8d46fd2835b7.png";
  }, function (t, e, i) {
    t.exports = i.p + "6ec810e870d578b6ce9e21b2830a6f8f.png";
  }, function (t, e, i) {
    var s = {
      "./back.ogg": 275,
      "./click.ogg": 276,
      "./correct.ogg": 277,
      "./correct2.ogg": 278,
      "./next.ogg": 279,
      "./over.ogg": 280,
      "./streak.ogg": 281,
      "./won.ogg": 282,
      "./wrong.ogg": 283
    };

    function n(t) {
      var e = o(t);
      return i(e);
    }

    function o(t) {
      var e = s[t];

      if (!(e + 1)) {
        var i = new Error("Cannot find module '" + t + "'");
        throw i.code = "MODULE_NOT_FOUND", i;
      }

      return e;
    }

    n.keys = function () {
      return Object.keys(s);
    }, n.resolve = o, t.exports = n, n.id = 274;
  }, function (t, e, i) {
    t.exports = i.p + "cb269eda0d059af206b1e08023d94152.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "fdb637f49a0b93026e2fa45266809473.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "bdc97ffc7dce82a7fa3d4b456af913d4.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "73ba17a2c05606bd07c2d0514df54f9e.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "82af68fab5b8f04c0abb2141dbffe2de.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "c50841375d8b304fc30c819c47c1806f.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "ac288a3e5be768308c21d1e31de8a9de.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "d80f5027458f6c5703610a31c33917b6.ogg";
  }, function (t, e, i) {
    t.exports = i.p + "ecb54e6db8c47c2239163b01dd6dc608.ogg";
  }, function (t, e) {
    t.exports = {
      create: function create() {
        this.nextSound = this.game.add.audio("next"), this.backSound = this.game.add.audio("back"), this.clickSound = this.game.add.audio("click"), this.index = 0, this.continents = ["Africa", "America", "Asia", "Australia", "Europe"], this.backBt = this.game.add.sprite(0, this.game.getScaledHeight(10), "btBack"), this.backBt.height = this.game.getScaledHeight(this.backBt.height), this.backBt.width = this.game.getScaledWidth(this.backBt.width), this.backBt.inputEnabled = !0, this.backBt.events.onInputDown.add(this.home, this), this.countries = this.game.global.fullArray[this.game.global.continentIndex].slice(0), console.log(this.game.global.continentIndex), console.log(this.game.global.fullArray[this.game.global.continentIndex]), this.right = this.game.add.sprite(this.game.getScaledWidth(1565), this.world.centerY, "rightArrow"), this.right.height = this.game.getScaledHeight(this.right.height), this.right.width = this.game.getScaledWidth(this.right.width), this.right.scale.setTo(.5), this.right.anchor.set(.5), this.right.inputEnabled = !0, this.right.events.onInputDown.add(this.next, this), this.left = this.game.add.sprite(this.game.getScaledWidth(35), this.world.centerY, "leftArrow"), this.left.height = this.game.getScaledHeight(this.left.height), this.left.width = this.game.getScaledWidth(this.left.width), this.left.scale.setTo(.5), this.left.anchor.set(.5), this.left.inputEnabled = !0, this.left.events.onInputDown.add(this.back, this), this.getInfo = JSON.parse(this.game.cache.getText("infoAF")), this.correctSound = this.game.add.audio("correct"), this.correctSound2 = this.game.add.audio("correct2"), this.continentName = this.game.add.bitmapText(this.world.centerX, this.game.getScaledHeight(50), "myguifont", "Countries in " + this.continents[this.game.global.continentIndex], this.game.getScaledHeight(80)), this.continentName.anchor.set(.5);
        var t = this.getInfo[this.countries[this.index]];
        this.cName = this.game.add.bitmapText(this.game.getScaledWidth(500), this.game.getScaledHeight(250), "myfont", t.name, this.game.getScaledHeight(100)), this.cName.maxWidth = 1100, this.cName.align = "left", this.flag = this.game.add.sprite(this.game.getScaledWidth(250), this.game.getScaledHeight(325), this.countries[this.index]), this.flag.height = this.game.getScaledHeight(this.flag.height), this.flag.width = this.game.getScaledWidth(this.flag.width), this.flag.anchor.set(.5), this.cCapital = this.game.add.bitmapText(this.game.getScaledWidth(100), this.game.getScaledHeight(550), "myfont", "Capital: " + t.capital, this.game.getScaledHeight(80)), this.cCurrency = this.game.add.bitmapText(this.game.getScaledWidth(100), this.game.getScaledHeight(700), "myfont", "Currency: " + t.currency, this.game.getScaledHeight(80)), this.cPopulation = this.game.add.bitmapText(this.game.getScaledWidth(100), this.game.getScaledHeight(850), "myfont", "Population: " + t.population, this.game.getScaledHeight(80));
      },
      home: function home() {
        this.clickSound.play(), this.game.state.start("menuState");
      },
      next: function next() {
        if (this.index < this.countries.length - 1) {
          this.nextSound.play(), this.flag.destroy(), this.index += 1, this.flag = this.game.add.sprite(this.game.getScaledWidth(250), this.game.getScaledHeight(325), this.countries[this.index]), this.flag.height = this.game.getScaledHeight(this.flag.height), this.flag.width = this.game.getScaledWidth(this.flag.width), this.flag.anchor.set(.5);
          var t = this.getInfo[this.countries[this.index]];
          this.cName.setText(t.name), this.cCapital.setText("Capital: " + t.capital), this.cCurrency.setText("Currency: " + t.currency), this.cPopulation.setText("Population: " + t.population);
        }
      },
      back: function back() {
        if (this.index > 0) {
          this.backSound.play(), this.flag.destroy(), this.index -= 1, this.flag = this.game.add.sprite(this.game.getScaledWidth(250), this.game.getScaledHeight(325), this.countries[this.index]), this.flag.height = this.game.getScaledHeight(this.flag.height), this.flag.width = this.game.getScaledWidth(this.flag.width), this.flag.anchor.set(.5);
          var t = this.getInfo[this.countries[this.index]];
          this.cName.setText(t.name), this.cCapital.setText("Capital: " + t.capital), this.cCurrency.setText("Currency: " + t.currency), this.cPopulation.setText("Population: " + t.population);
        }
      }
    };
  }, function (t, e) {
    t.exports = {
      init: function init() {
        this.game.stage.backgroundColor = "#CDEDFD", this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL, this.scale.pageAlignHorizontally = !0, this.scale.pageAlignVertically = !0;
      },
      preload: function preload() {
        this.game.load.bitmapFont("myfont", "assets/round-the-world/fonts/fontshadow.png", "assets/round-the-world/fonts/fontshadow.fnt"), this.load.image("loadingBar", "assets/round-the-world/images/loading.png"), this.load.image("globe", "assets/round-the-world/images/globe.png");
      },
      create: function create() {
        this.state.start("preloadState");
      }
    };
  }]);
});